var pluginJson$1 = {
  'macOS.minVersion': '10.13.0',
  'noteplan.minAppVersion': '3.9.10',
  'plugin.id': 'np.Templating',
  'plugin.name': '📒 Templating',
  'plugin.version': '1.10.4',
  'plugin.lastUpdateInfo':
    '1.10.4: Allow for simple templates with no frontmatter',
  'plugin.description': 'Templating Plugin for NotePlan',
  'plugin.author': 'Mike Erickson (@codedungeon)',
  'plugin.dependencies': [],
  'plugin.script': 'script.js',
  'plugin.url.old':
    'https://github.com/NotePlan/plugins/blob/main/np.Templating/README.md',
  'plugin.url': 'https://nptemplating-docs.netlify.app/docs/intro',
  'plugin.commands': [
    {
      name: 'Append template to end of current note',
      alias: ['append', 'at', 'template', 'npa', 'np:append'],
      description: 'Append template to end of current note',
      jsFunction: 'templateAppend',
      arguments: ['template title to run'],
    },
    {
      name: 'Insert template at cursor position',
      alias: ['insert', 'it', 'template', 'npi', 'np:insert'],
      description: 'Insert template in current note at cursor position',
      jsFunction: 'templateInsert',
      arguments: ['template title to run'],
    },
    {
      name: 'Invoke/Place template at <location> in template',
      alias: ['invoke', 'npv', 'np:invoke', 'place'],
      description:
        'Place template using <location> attribute in template frontmatter',
      jsFunction: 'templateInvoke',
      arguments: ['Template name to execute (optional)'],
    },
    {
      name: 'Create new note using template',
      alias: ['new', 'nn', 'template', 'npn', 'np:new'],
      description:
        'Create new note with title, optionally using folder and newNoteTitle attribute',
      jsFunction: 'templateNew',
      arguments: [
        'template title to run (or if you know the folder but want to be prompted at run-time for the template, enter a single space for this argument)',
        'folder to create note in (optional-leave empty to be prompted for it)',
      ],
    },
    {
      name: 'New note using Quick Note Template',
      alias: [
        'Quick template note',
        'quick',
        'template',
        'qnt',
        'qtn',
        'qqq',
        'npq',
        'np:qtn',
      ],
      description: 'Create new note based on Quick Note Template',
      jsFunction: 'templateQuickNote',
      arguments: ['template title to run'],
    },
    {
      name: 'Create Meeting Note using Meeting Note Template',
      alias: [
        'Meeting template note',
        'quick',
        'template',
        'mnt',
        'mtn',
        'mmm',
        'npm',
        'np:mtn',
      ],
      description: 'Create new note based on Meeting Note Template',
      hidden: true,
      jsFunction: 'templateMeetingNote',
      arguments: ['template title to use'],
    },
    {
      name: 'np:update',
      alias: ['npu'],
      description: 'Run np.Templating Setting',
      jsFunction: 'onUpdateOrInstall',
      hidden: true,
    },
    {
      name: 'np:convert',
      alias: ['npc'],
      description: 'Convert Project Note to Frontmatter format',
      jsFunction: 'templateConvertNote',
      hidden: true,
    },
    {
      name: 'np:about',
      alias: [],
      description: 'np.Templating About...',
      jsFunction: 'templateAbout',
    },
    {
      name: 'Execute template script (type: template-fragment)',
      alias: ['npe', 'np:execute'],
      description:
        'Execute Template Script (type: template-fragment) which may or may not output text to current note',
      jsFunction: 'templateExecute',
      arguments: ['Template name to execute (optional)'],
    },
    {
      name: 'np:test',
      alias: [],
      description: 'np.Templating Testbed',
      jsFunction: 'templateTest',
      hidden: true,
    },
    {
      name: 'getTemplate',
      description: 'NPTemplating.getTemplate export',
      jsFunction: 'getTemplate',
      hidden: true,
    },
    {
      name: 'preRender',
      description: 'NPTemplating.preRender export',
      jsFunction: 'preRender',
      hidden: true,
    },
    {
      name: 'render',
      description: 'NPTemplating.render export',
      jsFunction: 'render',
      hidden: true,
    },
    {
      name: 'renderTemplate',
      description: 'NPTemplating.renderTemplate export',
      jsFunction: 'renderTemplate',
      hidden: true,
    },
    {
      name: 'np:tft',
      alias: ['Template file by title', 'np:run', 'npr'],
      description: 'Run a template file by title/preset',
      jsFunction: 'templateFileByTitle',
      hidden: true,
    },
    {
      name: 'templateRunner',
      alias: [],
      description:
        'Load and run self-contained template instructions with arguments',
      jsFunction: 'templateRunner',
      hidden: true,
      arguments: [
        'template title to run',
        'open file in editor after running',
        'template arguments',
      ],
    },
  ],
  'plugin.settings': [
    {
      type: 'heading',
      title: 'np.Templating Settings',
    },
    {
      key: 'version',
      type: 'hidden',
      title: 'np.Templating Settings Version',
    },
    {
      key: 'templateLocale',
      title: 'Template Locale',
      description:
        'Locale used by np.Templating Modules (leave blank for system locale)\n\nDefault: <system>',
      type: 'string',
      default: '<system>',
      required: false,
    },
    {
      key: 'templateGroupTemplatesByFolder',
      title: 'Group Templates by Folder',
      description: 'Group Templates by Folder in Template Chooser',
      type: 'bool',
      default: false,
      required: false,
    },
    {
      type: 'separator',
    },
    {
      key: 'userFirstName',
      title: 'First Name',
      description: 'Used when referencing <%= user.first %>',
      type: 'string',
      default: 'John',
      required: false,
    },
    {
      key: 'userLastName',
      title: 'Last Name',
      description: 'Used when referencing <%= user.last %>',
      type: 'string',
      default: 'Doe',
      required: false,
    },
    {
      key: 'userEmail',
      title: 'Email',
      description: 'Used when referencing <%= email %>',
      type: 'string',
      default: 'name@domain.com',
      required: false,
    },
    {
      key: 'userPhone',
      title: 'Phone',
      description: 'Used when referencing <%= phone %>',
      type: 'string',
      default: '(714) 555-1212',
      required: false,
    },
    {
      type: 'separator',
    },
    {
      key: 'dateFormat',
      title: 'Date Format',
      description:
        'Default date format (may be overridden in desired DateModule method)\n\nDefault: short',
      type: 'string',
      default: 'short',
      required: false,
    },
    {
      key: 'timeFormat',
      title: 'Time Format',
      description:
        'Default time format (may be overridden in desired TimeModule method)\n\nDefault: short',
      type: 'string',
      default: 'short',
      required: false,
    },
    {
      key: 'timestampFormat',
      title: 'Timestamp Format',
      description:
        'Default format when using date.timestamp()\n\nDefault: YYYY-MM-DD h:mm A',
      type: 'string',
      default: 'YYYY-MM-DD h:mm A',
      required: false,
    },
    {
      type: 'separator',
    },
    {
      key: 'weatherFormat',
      title: 'Weather Format',
      description:
        'Note: Leave blank for default weather response\n\nYou can customize the weather output by providing a custom format string which may include placeholders for different pieces from weather response\n\nRefer to np.Templating documention for list of available placeholders.',
      type: 'string',
      default: '',
      required: false,
    },
    {
      type: 'separator',
    },
    {
      key: 'services',
      title: 'Web Services',
      description:
        'Configuration for Services which can be referenced using\n<% web.service() %> method\n\nTip: Use https://jsonformatter.org/json5-validator to validate',
      type: 'json',
      default: '',
      required: false,
    },
    {
      type: 'separator',
    },
    {
      type: 'heading',
      title: 'Debugging',
    },
    {
      key: '_logLevel',
      type: 'string',
      title: 'Log Level',
      choices: ['DEBUG', 'INFO', 'WARN', 'ERROR', 'none'],
      description:
        'Set how much loggin output will be displayed when executing np.Templating commands in NotePlan Plugin Console Logs (NotePlan -> Help -> Plugin Console)\n\n - DEBUG Show All Logs\n - INFO Only Show Info, Warnings, and Errors\n - WARN Only Show Errors or Warnings\n - ERROR Only Show Errors\n - none Silence Logs',
      default: 'INFO',
      required: true,
    },
  ],
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object)
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object)
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable
      })),
      keys.push.apply(keys, symbols)
  }
  return keys
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {}
    i % 2
      ? ownKeys(Object(source), !0).forEach(function (key) {
          _defineProperty(target, key, source[key])
        })
      : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(
            target,
            Object.getOwnPropertyDescriptors(source)
          )
        : ownKeys(Object(source)).forEach(function (key) {
            Object.defineProperty(
              target,
              key,
              Object.getOwnPropertyDescriptor(source, key)
            )
          })
  }
  return target
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key)
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    })
  } else {
    obj[key] = value
  }
  return obj
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {}
  var target = {}
  var sourceKeys = Object.keys(source)
  var key, i
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i]
    if (excluded.indexOf(key) >= 0) continue
    target[key] = source[key]
  }
  return target
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {}
  var target = _objectWithoutPropertiesLoose(source, excluded)
  var key, i
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source)
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i]
      if (excluded.indexOf(key) >= 0) continue
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue
      target[key] = source[key]
    }
  }
  return target
}
function _toPrimitive(input, hint) {
  if (typeof input !== 'object' || input === null) return input
  var prim = input[Symbol.toPrimitive]
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default')
    if (typeof res !== 'object') return res
    throw new TypeError('@@toPrimitive must return a primitive value.')
  }
  return (hint === 'string' ? String : Number)(input)
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, 'string')
  return typeof key === 'symbol' ? key : String(key)
}
const PARAM_BLACKLIST = [
  'note',
  'referencedBlocks',
  'availableThemes',
  'currentTheme',
  'linkedNoteTitles',
  'linkedItems',
]
const dt = () => {
  const d = new Date()
  const pad = (value) => (value < 10 ? '0'.concat(value) : value.toString())
  return ''
    .concat(d.getFullYear(), '-')
    .concat(pad(d.getMonth() + 1), '-')
    .concat(pad(d.getDate()), ' ')
    .concat(d.toLocaleTimeString('en-GB'))
}
function JSP(obj) {
  let space =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2
  if (typeof obj !== 'object' || obj instanceof Date) {
    return String(obj)
  } else {
    if (Array.isArray(obj)) {
      const arrInfo = []
      let isValues = false
      obj.forEach((item, i) => {
        if (typeof item === 'object') {
          arrInfo.push('['.concat(i, '] = ').concat(JSP(item, space)))
        } else {
          isValues = true
          arrInfo.push(''.concat(item))
        }
      })
      return ''
        .concat(isValues ? '[' : '')
        .concat(arrInfo.join(isValues ? ', ' : ',\n'))
        .concat(isValues ? ']' : '')
    }
    const propNames = getFilteredProps(obj)
    const fullObj = propNames.reduce((acc, propName) => {
      if (!/^__/.test(propName)) {
        if (Array.isArray(obj[propName])) {
          try {
            if (PARAM_BLACKLIST.indexOf(propName) === -1) {
              acc[propName] = obj[propName].map((x) => {
                if (typeof x === 'object' && !(x instanceof Date)) {
                  return JSP(x, '')
                } else {
                  return x
                }
              })
            } else {
              acc[propName] = obj[propName]
            }
          } catch (error) {
            var _obj$propName
            logDebug(
              'helpers/dev',
              'Caught error in JSP for propname='
                .concat(propName, ' : ')
                .concat(error, ' typeof obj[propName]=')
                .concat(typeof obj[propName], ' isArray=')
                .concat(String(Array.isArray(obj[propName])), ' len=')
                .concat(
                  (_obj$propName = obj[propName]) === null ||
                    _obj$propName === void 0
                    ? void 0
                    : _obj$propName.length,
                  ' \n VALUE: '
                )
                .concat(JSON.stringify(obj[propName]))
            )
          }
        } else {
          acc[propName] = obj[propName]
        }
      }
      return acc
    }, {})
    return typeof fullObj === 'object' && !(fullObj instanceof Date)
      ? JSON.stringify(
          fullObj,
          null,
          space !== null && space !== void 0 ? space : null
        )
      : 'date'
  }
}
function clo(obj) {
  let preamble =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ''
  let space =
    arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2
  if (!obj) {
    logDebug(preamble, 'null')
    return
  }
  if (typeof obj !== 'object') {
    logDebug(preamble, ''.concat(obj))
  } else {
    logDebug(preamble, JSP(obj, space))
  }
}
function getAllPropertyNames(inObj) {
  let obj = inObj
  const props = []
  do {
    Object.getOwnPropertyNames(obj).forEach(function (prop) {
      if (props.indexOf(prop) === -1) {
        props.push(prop)
      }
    })
  } while ((obj = Object.getPrototypeOf(obj)))
  return props
}
const getFilteredProps = (object) => {
  const ignore = [
    'toString',
    'toLocaleString',
    'valueOf',
    'hasOwnProperty',
    'propertyIsEnumerable',
    'isPrototypeOf',
  ]
  if (typeof object !== 'object' || Array.isArray(object)) {
    return []
  }
  return getAllPropertyNames(object).filter(
    (prop) => !/(^__)|(constructor)/.test(prop) && !ignore.includes(prop)
  )
}
const _message = (message) => {
  let logMessage = ''
  switch (typeof message) {
    case 'string':
      logMessage = message
      break

    case 'object':
      if (Array.isArray(message)) {
        logMessage = message.toString()
      } else {
        logMessage =
          message instanceof Date ? message.toString() : JSON.stringify(message)
      }
      break

    default:
      logMessage = message.toString()
      break
  }
  return logMessage
}
const LOG_LEVELS = ['DEBUG', 'INFO', 'WARN', 'ERROR', 'none']
const LOG_LEVEL_STRINGS = [
  '| DEBUG |',
  '| INFO  |',
  '🥺 WARN🥺',
  '❗️ERROR❗️',
  'none',
]
function log(pluginInfo) {
  let message =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ''
  let type =
    arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'INFO'
  const thisMessageLevel = LOG_LEVELS.indexOf(type)
  const thisIndicator = LOG_LEVEL_STRINGS[thisMessageLevel]
  let msg = ''
  let pluginId = ''
  let pluginVersion = ''
  const isPluginJson =
    typeof pluginInfo === 'object' && pluginInfo.hasOwnProperty('plugin.id')
  if (isPluginJson) {
    pluginId = pluginInfo.hasOwnProperty('plugin.id')
      ? pluginInfo['plugin.id']
      : 'INVALID_PLUGIN_ID'
    pluginVersion = pluginInfo.hasOwnProperty('plugin.version')
      ? pluginInfo['plugin.version']
      : 'INVALID_PLUGIN_VERSION'
    msg = ''
      .concat(dt().padEnd(19), ' ')
      .concat(thisIndicator, ' ')
      .concat(pluginId, ' v')
      .concat(pluginVersion, ' :: ')
      .concat(_message(message))
  } else {
    if (message.length > 0) {
      msg = ''
        .concat(dt().padEnd(19), ' ')
        .concat(thisIndicator, ' ')
        .concat(pluginInfo, ' :: ')
        .concat(_message(message))
    } else {
      msg = ''
        .concat(dt().padEnd(19), ' ')
        .concat(thisIndicator, ' ')
        .concat(_message(pluginInfo))
    }
  }
  let userLogLevel = 1
  const pluginSettings =
    typeof DataStore !== 'undefined' ? DataStore.settings : null
  if (pluginSettings && pluginSettings.hasOwnProperty('_logLevel')) {
    userLogLevel = pluginSettings['_logLevel']
  }
  const userLogLevelIndex = LOG_LEVELS.indexOf(userLogLevel)
  if (thisMessageLevel >= userLogLevelIndex) {
    console.log(msg)
  }
  return msg
}
function logError(pluginInfo, error) {
  if (typeof error === 'object' && error != null) {
    var _error$filename, _error$lineNumber
    const msg = ''
      .concat(
        (_error$filename = error.filename) !== null &&
          _error$filename !== void 0
          ? _error$filename
          : '<unknown file>',
        ' '
      )
      .concat(
        (_error$lineNumber = error.lineNumber) !== null &&
          _error$lineNumber !== void 0
          ? _error$lineNumber
          : '<unkonwn line>',
        ': '
      )
      .concat(error.message)
    return log(pluginInfo, msg, 'ERROR')
  }
  return log(pluginInfo, error, 'ERROR')
}
function logWarn(pluginInfo) {
  let message =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ''
  return log(pluginInfo, message, 'WARN')
}
function logDebug(pluginInfo) {
  let message =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ''
  return log(pluginInfo, message, 'DEBUG')
}
function overrideSettingsWithStringArgs(config, argsAsString) {
  try {
    if (argsAsString) {
      const argObj = {}
      argsAsString
        .split(';')
        .forEach((arg) =>
          arg.split('=').length === 2
            ? (argObj[arg.split('=')[0]] = arg.split('=')[1])
            : null
        )
      const configOut = Object.assign(config)
      for (const key in argObj) {
        let value = argObj[key]
        logDebug(
          'dev.js',
          'overrideSettingsWithStringArgs key:'
            .concat(key, ' value:')
            .concat(argObj[key], ' typeof:')
            .concat(typeof argObj[key], ' !isNaN(')
            .concat(value, '):')
            .concat(String(!isNaN(argObj[key])))
        )
        if (!isNaN(value) && value !== '') {
          value = Number(value)
        } else if (value === 'false') {
          value = false
        } else if (value === 'true') {
          value = true
        } else if (value.includes(',')) {
          value = value.split(',')
        }
        configOut[key] = value
        if (configOut[key] !== argObj[key]) {
          logDebug(
            'overrideSettingsWithStringArgs',
            "- updated setting '"
              .concat(key, "' -> value '")
              .concat(String(value), "'")
          )
        }
      }
      return configOut
    } else {
      return config
    }
  } catch (error) {
    logError('overrideSettingsWithStringArgs', JSP(error))
    console.log(JSP(error))
  }
}
var commonjsGlobal =
  typeof globalThis !== 'undefined'
    ? globalThis
    : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
        ? global
        : typeof self !== 'undefined'
          ? self
          : {}
function commonjsRequire(path) {
  throw new Error(
    'Could not dynamically require "' +
      path +
      '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.'
  )
}
var dist = {
  exports: {},
}
;(function (module, exports) {
  ;(function (global, factory) {
    module.exports = factory()
  })(commonjsGlobal, function () {
    function createCommonjsModule(fn, module) {
      return (
        (module = {
          exports: {},
        }),
        fn(module, module.exports),
        module.exports
      )
    }
    var _global = createCommonjsModule(function (module) {
      var global = (module.exports =
        typeof window != 'undefined' && window.Math == Math
          ? window
          : typeof self != 'undefined' && self.Math == Math
            ? self
            : Function('return this')())
      if (typeof __g == 'number') {
        __g = global
      }
    })
    var _core = createCommonjsModule(function (module) {
      var core = (module.exports = {
        version: '2.6.5',
      })
      if (typeof __e == 'number') {
        __e = core
      }
    })
    _core.version
    var _isObject = function (it) {
      return typeof it === 'object' ? it !== null : typeof it === 'function'
    }
    var _anObject = function (it) {
      if (!_isObject(it)) {
        throw TypeError(it + ' is not an object!')
      }
      return it
    }
    var _fails = function (exec) {
      try {
        return !!exec()
      } catch (e) {
        return true
      }
    }
    var _descriptors = !_fails(function () {
      return (
        Object.defineProperty({}, 'a', {
          get: function () {
            return 7
          },
        }).a != 7
      )
    })
    var document = _global.document
    var is = _isObject(document) && _isObject(document.createElement)
    var _domCreate = function (it) {
      return is ? document.createElement(it) : {}
    }
    var _ie8DomDefine =
      !_descriptors &&
      !_fails(function () {
        return (
          Object.defineProperty(_domCreate('div'), 'a', {
            get: function () {
              return 7
            },
          }).a != 7
        )
      })
    var _toPrimitive = function (it, S) {
      if (!_isObject(it)) {
        return it
      }
      var fn, val
      if (
        S &&
        typeof (fn = it.toString) == 'function' &&
        !_isObject((val = fn.call(it)))
      ) {
        return val
      }
      if (
        typeof (fn = it.valueOf) == 'function' &&
        !_isObject((val = fn.call(it)))
      ) {
        return val
      }
      if (
        !S &&
        typeof (fn = it.toString) == 'function' &&
        !_isObject((val = fn.call(it)))
      ) {
        return val
      }
      throw TypeError("Can't convert object to primitive value")
    }
    var dP = Object.defineProperty
    var f = _descriptors
      ? Object.defineProperty
      : function defineProperty(O, P, Attributes) {
          _anObject(O)
          P = _toPrimitive(P, true)
          _anObject(Attributes)
          if (_ie8DomDefine) {
            try {
              return dP(O, P, Attributes)
            } catch (e) {}
          }
          if ('get' in Attributes || 'set' in Attributes) {
            throw TypeError('Accessors not supported!')
          }
          if ('value' in Attributes) {
            O[P] = Attributes.value
          }
          return O
        }
    var _objectDp = {
      f: f,
    }
    var _propertyDesc = function (bitmap, value) {
      return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value,
      }
    }
    var _hide = _descriptors
      ? function (object, key, value) {
          return _objectDp.f(object, key, _propertyDesc(1, value))
        }
      : function (object, key, value) {
          object[key] = value
          return object
        }
    var hasOwnProperty = {}.hasOwnProperty
    var _has = function (it, key) {
      return hasOwnProperty.call(it, key)
    }
    var id = 0
    var px = Math.random()
    var _uid = function (key) {
      return 'Symbol('.concat(
        key === undefined ? '' : key,
        ')_',
        (++id + px).toString(36)
      )
    }
    var _shared = createCommonjsModule(function (module) {
      var SHARED = '__core-js_shared__'
      var store = _global[SHARED] || (_global[SHARED] = {})
      ;(module.exports = function (key, value) {
        return store[key] || (store[key] = value !== undefined ? value : {})
      })('versions', []).push({
        version: _core.version,
        mode: 'global',
        copyright: '© 2019 Denis Pushkarev (zloirock.ru)',
      })
    })
    var _functionToString = _shared(
      'native-function-to-string',
      Function.toString
    )
    var _redefine = createCommonjsModule(function (module) {
      var SRC = _uid('src')
      var TO_STRING = 'toString'
      var TPL = ('' + _functionToString).split(TO_STRING)
      _core.inspectSource = function (it) {
        return _functionToString.call(it)
      }
      ;(module.exports = function (O, key, val, safe) {
        var isFunction = typeof val == 'function'
        if (isFunction) {
          _has(val, 'name') || _hide(val, 'name', key)
        }
        if (O[key] === val) {
          return
        }
        if (isFunction) {
          _has(val, SRC) ||
            _hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)))
        }
        if (O === _global) {
          O[key] = val
        } else if (!safe) {
          delete O[key]
          _hide(O, key, val)
        } else if (O[key]) {
          O[key] = val
        } else {
          _hide(O, key, val)
        }
      })(Function.prototype, TO_STRING, function toString() {
        return (
          (typeof this == 'function' && this[SRC]) ||
          _functionToString.call(this)
        )
      })
    })
    var _aFunction = function (it) {
      if (typeof it != 'function') {
        throw TypeError(it + ' is not a function!')
      }
      return it
    }
    var _ctx = function (fn, that, length) {
      _aFunction(fn)
      if (that === undefined) {
        return fn
      }
      switch (length) {
        case 1:
          return function (a) {
            return fn.call(that, a)
          }

        case 2:
          return function (a, b) {
            return fn.call(that, a, b)
          }

        case 3:
          return function (a, b, c) {
            return fn.call(that, a, b, c)
          }
      }
      return function () {
        return fn.apply(that, arguments)
      }
    }
    var PROTOTYPE = 'prototype'
    var $export = function (type, name, source) {
      var IS_FORCED = type & $export.F
      var IS_GLOBAL = type & $export.G
      var IS_STATIC = type & $export.S
      var IS_PROTO = type & $export.P
      var IS_BIND = type & $export.B
      var target = IS_GLOBAL
        ? _global
        : IS_STATIC
          ? _global[name] || (_global[name] = {})
          : (_global[name] || {})[PROTOTYPE]
      var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {})
      var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
      var key, own, out, exp
      if (IS_GLOBAL) {
        source = name
      }
      for (key in source) {
        own = !IS_FORCED && target && target[key] !== undefined
        out = (own ? target : source)[key]
        exp =
          IS_BIND && own
            ? _ctx(out, _global)
            : IS_PROTO && typeof out == 'function'
              ? _ctx(Function.call, out)
              : out
        if (target) {
          _redefine(target, key, out, type & $export.U)
        }
        if (exports[key] != out) {
          _hide(exports, key, exp)
        }
        if (IS_PROTO && expProto[key] != out) {
          expProto[key] = out
        }
      }
    }
    _global.core = _core
    $export.F = 1
    $export.G = 2
    $export.S = 4
    $export.P = 8
    $export.B = 16
    $export.W = 32
    $export.U = 64
    $export.R = 128
    var _export = $export
    var ceil = Math.ceil
    var floor = Math.floor
    var _toInteger = function (it) {
      return isNaN((it = +it)) ? 0 : (it > 0 ? floor : ceil)(it)
    }
    var _defined = function (it) {
      if (it == undefined) {
        throw TypeError("Can't call method on  " + it)
      }
      return it
    }
    var _stringAt = function (TO_STRING) {
      return function (that, pos) {
        var s = String(_defined(that))
        var i = _toInteger(pos)
        var l = s.length
        var a, b
        if (i < 0 || i >= l) {
          return TO_STRING ? '' : undefined
        }
        a = s.charCodeAt(i)
        return a < 55296 ||
          a > 56319 ||
          i + 1 === l ||
          (b = s.charCodeAt(i + 1)) < 56320 ||
          b > 57343
          ? TO_STRING
            ? s.charAt(i)
            : a
          : TO_STRING
            ? s.slice(i, i + 2)
            : ((a - 55296) << 10) + (b - 56320) + 65536
      }
    }
    var $at = _stringAt(false)
    _export(_export.P, 'String', {
      codePointAt: function codePointAt(pos) {
        return $at(this, pos)
      },
    })
    _core.String.codePointAt
    var max = Math.max
    var min = Math.min
    var _toAbsoluteIndex = function (index, length) {
      index = _toInteger(index)
      return index < 0 ? max(index + length, 0) : min(index, length)
    }
    var fromCharCode = String.fromCharCode
    var $fromCodePoint = String.fromCodePoint
    _export(
      _export.S + _export.F * (!!$fromCodePoint && $fromCodePoint.length != 1),
      'String',
      {
        fromCodePoint: function fromCodePoint(x) {
          var arguments$1 = arguments
          var res = []
          var aLen = arguments.length
          var i = 0
          var code
          while (aLen > i) {
            code = +arguments$1[i++]
            if (_toAbsoluteIndex(code, 1114111) !== code) {
              throw RangeError(code + ' is not a valid code point')
            }
            res.push(
              code < 65536
                ? fromCharCode(code)
                : fromCharCode(
                    ((code -= 65536) >> 10) + 55296,
                    (code % 1024) + 56320
                  )
            )
          }
          return res.join('')
        },
      }
    )
    _core.String.fromCodePoint
    var Space_Separator = /[\u1680\u2000-\u200A\u202F\u205F\u3000]/
    var ID_Start =
      /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312E\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEA\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE83\uDE86-\uDE89\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0\uDFE1]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00-\uDD1E\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]/
    var ID_Continue =
      /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u09FC\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9-\u0AFF\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D00-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF9\u1D00-\u1DF9\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312E\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEA\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF2D-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDCA-\uDDCC\uDDD0-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC00-\uDC4A\uDC50-\uDC59\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF39]|\uD806[\uDCA0-\uDCE9\uDCFF\uDE00-\uDE3E\uDE47\uDE50-\uDE83\uDE86-\uDE99\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC40\uDC50-\uDC59\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD47\uDD50-\uDD59]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F\uDFE0\uDFE1]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00-\uDD1E\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6\uDD00-\uDD4A\uDD50-\uDD59]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/
    var unicode = {
      Space_Separator: Space_Separator,
      ID_Start: ID_Start,
      ID_Continue: ID_Continue,
    }
    var util = {
      isSpaceSeparator: function isSpaceSeparator(c) {
        return typeof c === 'string' && unicode.Space_Separator.test(c)
      },
      isIdStartChar: function isIdStartChar(c) {
        return (
          typeof c === 'string' &&
          ((c >= 'a' && c <= 'z') ||
            (c >= 'A' && c <= 'Z') ||
            c === '$' ||
            c === '_' ||
            unicode.ID_Start.test(c))
        )
      },
      isIdContinueChar: function isIdContinueChar(c) {
        return (
          typeof c === 'string' &&
          ((c >= 'a' && c <= 'z') ||
            (c >= 'A' && c <= 'Z') ||
            (c >= '0' && c <= '9') ||
            c === '$' ||
            c === '_' ||
            c === '‌' ||
            c === '‍' ||
            unicode.ID_Continue.test(c))
        )
      },
      isDigit: function isDigit(c) {
        return typeof c === 'string' && /[0-9]/.test(c)
      },
      isHexDigit: function isHexDigit(c) {
        return typeof c === 'string' && /[0-9A-Fa-f]/.test(c)
      },
    }
    var source
    var parseState
    var stack
    var pos
    var line
    var column
    var token
    var key
    var root
    var parse = function parse(text, reviver) {
      source = String(text)
      parseState = 'start'
      stack = []
      pos = 0
      line = 1
      column = 0
      token = undefined
      key = undefined
      root = undefined
      do {
        token = lex()
        parseStates[parseState]()
      } while (token.type !== 'eof')
      if (typeof reviver === 'function') {
        return internalize(
          {
            '': root,
          },
          '',
          reviver
        )
      }
      return root
    }
    function internalize(holder, name, reviver) {
      var value = holder[name]
      if (value != null && typeof value === 'object') {
        if (Array.isArray(value)) {
          for (var i = 0; i < value.length; i++) {
            var key = String(i)
            var replacement = internalize(value, key, reviver)
            if (replacement === undefined) {
              delete value[key]
            } else {
              Object.defineProperty(value, key, {
                value: replacement,
                writable: true,
                enumerable: true,
                configurable: true,
              })
            }
          }
        } else {
          for (var key$1 in value) {
            var replacement$1 = internalize(value, key$1, reviver)
            if (replacement$1 === undefined) {
              delete value[key$1]
            } else {
              Object.defineProperty(value, key$1, {
                value: replacement$1,
                writable: true,
                enumerable: true,
                configurable: true,
              })
            }
          }
        }
      }
      return reviver.call(holder, name, value)
    }
    var lexState
    var buffer
    var doubleQuote
    var sign
    var c
    function lex() {
      lexState = 'default'
      buffer = ''
      doubleQuote = false
      sign = 1
      for (;;) {
        c = peek()
        var token = lexStates[lexState]()
        if (token) {
          return token
        }
      }
    }
    function peek() {
      if (source[pos]) {
        return String.fromCodePoint(source.codePointAt(pos))
      }
    }
    function read() {
      var c = peek()
      if (c === '\n') {
        line++
        column = 0
      } else if (c) {
        column += c.length
      } else {
        column++
      }
      if (c) {
        pos += c.length
      }
      return c
    }
    var lexStates = {
      default: function default$1() {
        switch (c) {
          case '\t':
          case '\v':
          case '\f':
          case ' ':
          case ' ':
          case '\ufeff':
          case '\n':
          case '\r':
          case '\u2028':
          case '\u2029':
            read()
            return

          case '/':
            read()
            lexState = 'comment'
            return

          case undefined:
            read()
            return newToken('eof')
        }
        if (util.isSpaceSeparator(c)) {
          read()
          return
        }
        return lexStates[parseState]()
      },
      comment: function comment() {
        switch (c) {
          case '*':
            read()
            lexState = 'multiLineComment'
            return

          case '/':
            read()
            lexState = 'singleLineComment'
            return
        }
        throw invalidChar(read())
      },
      multiLineComment: function multiLineComment() {
        switch (c) {
          case '*':
            read()
            lexState = 'multiLineCommentAsterisk'
            return

          case undefined:
            throw invalidChar(read())
        }
        read()
      },
      multiLineCommentAsterisk: function multiLineCommentAsterisk() {
        switch (c) {
          case '*':
            read()
            return

          case '/':
            read()
            lexState = 'default'
            return

          case undefined:
            throw invalidChar(read())
        }
        read()
        lexState = 'multiLineComment'
      },
      singleLineComment: function singleLineComment() {
        switch (c) {
          case '\n':
          case '\r':
          case '\u2028':
          case '\u2029':
            read()
            lexState = 'default'
            return

          case undefined:
            read()
            return newToken('eof')
        }
        read()
      },
      value: function value() {
        switch (c) {
          case '{':
          case '[':
            return newToken('punctuator', read())

          case 'n':
            read()
            literal('ull')
            return newToken('null', null)

          case 't':
            read()
            literal('rue')
            return newToken('boolean', true)

          case 'f':
            read()
            literal('alse')
            return newToken('boolean', false)

          case '-':
          case '+':
            if (read() === '-') {
              sign = -1
            }
            lexState = 'sign'
            return

          case '.':
            buffer = read()
            lexState = 'decimalPointLeading'
            return

          case '0':
            buffer = read()
            lexState = 'zero'
            return

          case '1':
          case '2':
          case '3':
          case '4':
          case '5':
          case '6':
          case '7':
          case '8':
          case '9':
            buffer = read()
            lexState = 'decimalInteger'
            return

          case 'I':
            read()
            literal('nfinity')
            return newToken('numeric', Infinity)

          case 'N':
            read()
            literal('aN')
            return newToken('numeric', NaN)

          case '"':
          case "'":
            doubleQuote = read() === '"'
            buffer = ''
            lexState = 'string'
            return
        }
        throw invalidChar(read())
      },
      identifierNameStartEscape: function identifierNameStartEscape() {
        if (c !== 'u') {
          throw invalidChar(read())
        }
        read()
        var u = unicodeEscape()
        switch (u) {
          case '$':
          case '_':
            break

          default:
            if (!util.isIdStartChar(u)) {
              throw invalidIdentifier()
            }
            break
        }
        buffer += u
        lexState = 'identifierName'
      },
      identifierName: function identifierName() {
        switch (c) {
          case '$':
          case '_':
          case '‌':
          case '‍':
            buffer += read()
            return

          case '\\':
            read()
            lexState = 'identifierNameEscape'
            return
        }
        if (util.isIdContinueChar(c)) {
          buffer += read()
          return
        }
        return newToken('identifier', buffer)
      },
      identifierNameEscape: function identifierNameEscape() {
        if (c !== 'u') {
          throw invalidChar(read())
        }
        read()
        var u = unicodeEscape()
        switch (u) {
          case '$':
          case '_':
          case '‌':
          case '‍':
            break

          default:
            if (!util.isIdContinueChar(u)) {
              throw invalidIdentifier()
            }
            break
        }
        buffer += u
        lexState = 'identifierName'
      },
      sign: function sign$1() {
        switch (c) {
          case '.':
            buffer = read()
            lexState = 'decimalPointLeading'
            return

          case '0':
            buffer = read()
            lexState = 'zero'
            return

          case '1':
          case '2':
          case '3':
          case '4':
          case '5':
          case '6':
          case '7':
          case '8':
          case '9':
            buffer = read()
            lexState = 'decimalInteger'
            return

          case 'I':
            read()
            literal('nfinity')
            return newToken('numeric', sign * Infinity)

          case 'N':
            read()
            literal('aN')
            return newToken('numeric', NaN)
        }
        throw invalidChar(read())
      },
      zero: function zero() {
        switch (c) {
          case '.':
            buffer += read()
            lexState = 'decimalPoint'
            return

          case 'e':
          case 'E':
            buffer += read()
            lexState = 'decimalExponent'
            return

          case 'x':
          case 'X':
            buffer += read()
            lexState = 'hexadecimal'
            return
        }
        return newToken('numeric', sign * 0)
      },
      decimalInteger: function decimalInteger() {
        switch (c) {
          case '.':
            buffer += read()
            lexState = 'decimalPoint'
            return

          case 'e':
          case 'E':
            buffer += read()
            lexState = 'decimalExponent'
            return
        }
        if (util.isDigit(c)) {
          buffer += read()
          return
        }
        return newToken('numeric', sign * Number(buffer))
      },
      decimalPointLeading: function decimalPointLeading() {
        if (util.isDigit(c)) {
          buffer += read()
          lexState = 'decimalFraction'
          return
        }
        throw invalidChar(read())
      },
      decimalPoint: function decimalPoint() {
        switch (c) {
          case 'e':
          case 'E':
            buffer += read()
            lexState = 'decimalExponent'
            return
        }
        if (util.isDigit(c)) {
          buffer += read()
          lexState = 'decimalFraction'
          return
        }
        return newToken('numeric', sign * Number(buffer))
      },
      decimalFraction: function decimalFraction() {
        switch (c) {
          case 'e':
          case 'E':
            buffer += read()
            lexState = 'decimalExponent'
            return
        }
        if (util.isDigit(c)) {
          buffer += read()
          return
        }
        return newToken('numeric', sign * Number(buffer))
      },
      decimalExponent: function decimalExponent() {
        switch (c) {
          case '+':
          case '-':
            buffer += read()
            lexState = 'decimalExponentSign'
            return
        }
        if (util.isDigit(c)) {
          buffer += read()
          lexState = 'decimalExponentInteger'
          return
        }
        throw invalidChar(read())
      },
      decimalExponentSign: function decimalExponentSign() {
        if (util.isDigit(c)) {
          buffer += read()
          lexState = 'decimalExponentInteger'
          return
        }
        throw invalidChar(read())
      },
      decimalExponentInteger: function decimalExponentInteger() {
        if (util.isDigit(c)) {
          buffer += read()
          return
        }
        return newToken('numeric', sign * Number(buffer))
      },
      hexadecimal: function hexadecimal() {
        if (util.isHexDigit(c)) {
          buffer += read()
          lexState = 'hexadecimalInteger'
          return
        }
        throw invalidChar(read())
      },
      hexadecimalInteger: function hexadecimalInteger() {
        if (util.isHexDigit(c)) {
          buffer += read()
          return
        }
        return newToken('numeric', sign * Number(buffer))
      },
      string: function string() {
        switch (c) {
          case '\\':
            read()
            buffer += escape()
            return

          case '"':
            if (doubleQuote) {
              read()
              return newToken('string', buffer)
            }
            buffer += read()
            return

          case "'":
            if (!doubleQuote) {
              read()
              return newToken('string', buffer)
            }
            buffer += read()
            return

          case '\n':
          case '\r':
            throw invalidChar(read())

          case '\u2028':
          case '\u2029':
            separatorChar(c)
            break

          case undefined:
            throw invalidChar(read())
        }
        buffer += read()
      },
      start: function start() {
        switch (c) {
          case '{':
          case '[':
            return newToken('punctuator', read())
        }
        lexState = 'value'
      },
      beforePropertyName: function beforePropertyName() {
        switch (c) {
          case '$':
          case '_':
            buffer = read()
            lexState = 'identifierName'
            return

          case '\\':
            read()
            lexState = 'identifierNameStartEscape'
            return

          case '}':
            return newToken('punctuator', read())

          case '"':
          case "'":
            doubleQuote = read() === '"'
            lexState = 'string'
            return
        }
        if (util.isIdStartChar(c)) {
          buffer += read()
          lexState = 'identifierName'
          return
        }
        throw invalidChar(read())
      },
      afterPropertyName: function afterPropertyName() {
        if (c === ':') {
          return newToken('punctuator', read())
        }
        throw invalidChar(read())
      },
      beforePropertyValue: function beforePropertyValue() {
        lexState = 'value'
      },
      afterPropertyValue: function afterPropertyValue() {
        switch (c) {
          case ',':
          case '}':
            return newToken('punctuator', read())
        }
        throw invalidChar(read())
      },
      beforeArrayValue: function beforeArrayValue() {
        if (c === ']') {
          return newToken('punctuator', read())
        }
        lexState = 'value'
      },
      afterArrayValue: function afterArrayValue() {
        switch (c) {
          case ',':
          case ']':
            return newToken('punctuator', read())
        }
        throw invalidChar(read())
      },
      end: function end() {
        throw invalidChar(read())
      },
    }
    function newToken(type, value) {
      return {
        type: type,
        value: value,
        line: line,
        column: column,
      }
    }
    function literal(s) {
      for (var i = 0, list = s; i < list.length; i += 1) {
        var c = list[i]
        var p = peek()
        if (p !== c) {
          throw invalidChar(read())
        }
        read()
      }
    }
    function escape() {
      var c = peek()
      switch (c) {
        case 'b':
          read()
          return '\b'

        case 'f':
          read()
          return '\f'

        case 'n':
          read()
          return '\n'

        case 'r':
          read()
          return '\r'

        case 't':
          read()
          return '\t'

        case 'v':
          read()
          return '\v'

        case '0':
          read()
          if (util.isDigit(peek())) {
            throw invalidChar(read())
          }
          return '\0'

        case 'x':
          read()
          return hexEscape()

        case 'u':
          read()
          return unicodeEscape()

        case '\n':
        case '\u2028':
        case '\u2029':
          read()
          return ''

        case '\r':
          read()
          if (peek() === '\n') {
            read()
          }
          return ''

        case '1':
        case '2':
        case '3':
        case '4':
        case '5':
        case '6':
        case '7':
        case '8':
        case '9':
          throw invalidChar(read())

        case undefined:
          throw invalidChar(read())
      }
      return read()
    }
    function hexEscape() {
      var buffer = ''
      var c = peek()
      if (!util.isHexDigit(c)) {
        throw invalidChar(read())
      }
      buffer += read()
      c = peek()
      if (!util.isHexDigit(c)) {
        throw invalidChar(read())
      }
      buffer += read()
      return String.fromCodePoint(parseInt(buffer, 16))
    }
    function unicodeEscape() {
      var buffer = ''
      var count = 4
      while (count-- > 0) {
        var c = peek()
        if (!util.isHexDigit(c)) {
          throw invalidChar(read())
        }
        buffer += read()
      }
      return String.fromCodePoint(parseInt(buffer, 16))
    }
    var parseStates = {
      start: function start() {
        if (token.type === 'eof') {
          throw invalidEOF()
        }
        push()
      },
      beforePropertyName: function beforePropertyName() {
        switch (token.type) {
          case 'identifier':
          case 'string':
            key = token.value
            parseState = 'afterPropertyName'
            return

          case 'punctuator':
            pop()
            return

          case 'eof':
            throw invalidEOF()
        }
      },
      afterPropertyName: function afterPropertyName() {
        if (token.type === 'eof') {
          throw invalidEOF()
        }
        parseState = 'beforePropertyValue'
      },
      beforePropertyValue: function beforePropertyValue() {
        if (token.type === 'eof') {
          throw invalidEOF()
        }
        push()
      },
      beforeArrayValue: function beforeArrayValue() {
        if (token.type === 'eof') {
          throw invalidEOF()
        }
        if (token.type === 'punctuator' && token.value === ']') {
          pop()
          return
        }
        push()
      },
      afterPropertyValue: function afterPropertyValue() {
        if (token.type === 'eof') {
          throw invalidEOF()
        }
        switch (token.value) {
          case ',':
            parseState = 'beforePropertyName'
            return

          case '}':
            pop()
        }
      },
      afterArrayValue: function afterArrayValue() {
        if (token.type === 'eof') {
          throw invalidEOF()
        }
        switch (token.value) {
          case ',':
            parseState = 'beforeArrayValue'
            return

          case ']':
            pop()
        }
      },
      end: function end() {},
    }
    function push() {
      var value
      switch (token.type) {
        case 'punctuator':
          switch (token.value) {
            case '{':
              value = {}
              break

            case '[':
              value = []
              break
          }
          break

        case 'null':
        case 'boolean':
        case 'numeric':
        case 'string':
          value = token.value
          break
      }
      if (root === undefined) {
        root = value
      } else {
        var parent = stack[stack.length - 1]
        if (Array.isArray(parent)) {
          parent.push(value)
        } else {
          Object.defineProperty(parent, key, {
            value: value,
            writable: true,
            enumerable: true,
            configurable: true,
          })
        }
      }
      if (value !== null && typeof value === 'object') {
        stack.push(value)
        if (Array.isArray(value)) {
          parseState = 'beforeArrayValue'
        } else {
          parseState = 'beforePropertyName'
        }
      } else {
        var current = stack[stack.length - 1]
        if (current == null) {
          parseState = 'end'
        } else if (Array.isArray(current)) {
          parseState = 'afterArrayValue'
        } else {
          parseState = 'afterPropertyValue'
        }
      }
    }
    function pop() {
      stack.pop()
      var current = stack[stack.length - 1]
      if (current == null) {
        parseState = 'end'
      } else if (Array.isArray(current)) {
        parseState = 'afterArrayValue'
      } else {
        parseState = 'afterPropertyValue'
      }
    }
    function invalidChar(c) {
      if (c === undefined) {
        return syntaxError(
          'JSON5: invalid end of input at ' + line + ':' + column
        )
      }
      return syntaxError(
        "JSON5: invalid character '" +
          formatChar(c) +
          "' at " +
          line +
          ':' +
          column
      )
    }
    function invalidEOF() {
      return syntaxError(
        'JSON5: invalid end of input at ' + line + ':' + column
      )
    }
    function invalidIdentifier() {
      column -= 5
      return syntaxError(
        'JSON5: invalid identifier character at ' + line + ':' + column
      )
    }
    function separatorChar(c) {
      console.warn(
        "JSON5: '" +
          formatChar(c) +
          "' in strings is not valid ECMAScript; consider escaping"
      )
    }
    function formatChar(c) {
      var replacements = {
        "'": "\\'",
        '"': '\\"',
        '\\': '\\\\',
        '\b': '\\b',
        '\f': '\\f',
        '\n': '\\n',
        '\r': '\\r',
        '\t': '\\t',
        '\v': '\\v',
        '\0': '\\0',
        '\u2028': '\\u2028',
        '\u2029': '\\u2029',
      }
      if (replacements[c]) {
        return replacements[c]
      }
      if (c < ' ') {
        var hexString = c.charCodeAt(0).toString(16)
        return '\\x' + ('00' + hexString).substring(hexString.length)
      }
      return c
    }
    function syntaxError(message) {
      var err = new SyntaxError(message)
      err.lineNumber = line
      err.columnNumber = column
      return err
    }
    var stringify = function stringify(value, replacer, space) {
      var stack = []
      var indent = ''
      var propertyList
      var replacerFunc
      var gap = ''
      var quote
      if (
        replacer != null &&
        typeof replacer === 'object' &&
        !Array.isArray(replacer)
      ) {
        space = replacer.space
        quote = replacer.quote
        replacer = replacer.replacer
      }
      if (typeof replacer === 'function') {
        replacerFunc = replacer
      } else if (Array.isArray(replacer)) {
        propertyList = []
        for (var i = 0, list = replacer; i < list.length; i += 1) {
          var v = list[i]
          var item = void 0
          if (typeof v === 'string') {
            item = v
          } else if (
            typeof v === 'number' ||
            v instanceof String ||
            v instanceof Number
          ) {
            item = String(v)
          }
          if (item !== undefined && propertyList.indexOf(item) < 0) {
            propertyList.push(item)
          }
        }
      }
      if (space instanceof Number) {
        space = Number(space)
      } else if (space instanceof String) {
        space = String(space)
      }
      if (typeof space === 'number') {
        if (space > 0) {
          space = Math.min(10, Math.floor(space))
          gap = '          '.substr(0, space)
        }
      } else if (typeof space === 'string') {
        gap = space.substr(0, 10)
      }
      return serializeProperty('', {
        '': value,
      })
      function serializeProperty(key, holder) {
        var value = holder[key]
        if (value != null) {
          if (typeof value.toJSON5 === 'function') {
            value = value.toJSON5(key)
          } else if (typeof value.toJSON === 'function') {
            value = value.toJSON(key)
          }
        }
        if (replacerFunc) {
          value = replacerFunc.call(holder, key, value)
        }
        if (value instanceof Number) {
          value = Number(value)
        } else if (value instanceof String) {
          value = String(value)
        } else if (value instanceof Boolean) {
          value = value.valueOf()
        }
        switch (value) {
          case null:
            return 'null'

          case true:
            return 'true'

          case false:
            return 'false'
        }
        if (typeof value === 'string') {
          return quoteString(value)
        }
        if (typeof value === 'number') {
          return String(value)
        }
        if (typeof value === 'object') {
          return Array.isArray(value)
            ? serializeArray(value)
            : serializeObject(value)
        }
        return undefined
      }
      function quoteString(value) {
        var quotes = {
          "'": 0.1,
          '"': 0.2,
        }
        var replacements = {
          "'": "\\'",
          '"': '\\"',
          '\\': '\\\\',
          '\b': '\\b',
          '\f': '\\f',
          '\n': '\\n',
          '\r': '\\r',
          '\t': '\\t',
          '\v': '\\v',
          '\0': '\\0',
          '\u2028': '\\u2028',
          '\u2029': '\\u2029',
        }
        var product = ''
        for (var i = 0; i < value.length; i++) {
          var c = value[i]
          switch (c) {
            case "'":
            case '"':
              quotes[c]++
              product += c
              continue

            case '\0':
              if (util.isDigit(value[i + 1])) {
                product += '\\x00'
                continue
              }
          }
          if (replacements[c]) {
            product += replacements[c]
            continue
          }
          if (c < ' ') {
            var hexString = c.charCodeAt(0).toString(16)
            product += '\\x' + ('00' + hexString).substring(hexString.length)
            continue
          }
          product += c
        }
        var quoteChar =
          quote ||
          Object.keys(quotes).reduce(function (a, b) {
            return quotes[a] < quotes[b] ? a : b
          })
        product = product.replace(
          new RegExp(quoteChar, 'g'),
          replacements[quoteChar]
        )
        return quoteChar + product + quoteChar
      }
      function serializeObject(value) {
        if (stack.indexOf(value) >= 0) {
          throw TypeError('Converting circular structure to JSON5')
        }
        stack.push(value)
        var stepback = indent
        indent = indent + gap
        var keys = propertyList || Object.keys(value)
        var partial = []
        for (var i = 0, list = keys; i < list.length; i += 1) {
          var key = list[i]
          var propertyString = serializeProperty(key, value)
          if (propertyString !== undefined) {
            var member = serializeKey(key) + ':'
            if (gap !== '') {
              member += ' '
            }
            member += propertyString
            partial.push(member)
          }
        }
        var final
        if (partial.length === 0) {
          final = '{}'
        } else {
          var properties
          if (gap === '') {
            properties = partial.join(',')
            final = '{' + properties + '}'
          } else {
            var separator = ',\n' + indent
            properties = partial.join(separator)
            final = '{\n' + indent + properties + ',\n' + stepback + '}'
          }
        }
        stack.pop()
        indent = stepback
        return final
      }
      function serializeKey(key) {
        if (key.length === 0) {
          return quoteString(key)
        }
        var firstChar = String.fromCodePoint(key.codePointAt(0))
        if (!util.isIdStartChar(firstChar)) {
          return quoteString(key)
        }
        for (var i = firstChar.length; i < key.length; i++) {
          if (
            !util.isIdContinueChar(String.fromCodePoint(key.codePointAt(i)))
          ) {
            return quoteString(key)
          }
        }
        return key
      }
      function serializeArray(value) {
        if (stack.indexOf(value) >= 0) {
          throw TypeError('Converting circular structure to JSON5')
        }
        stack.push(value)
        var stepback = indent
        indent = indent + gap
        var partial = []
        for (var i = 0; i < value.length; i++) {
          var propertyString = serializeProperty(String(i), value)
          partial.push(propertyString !== undefined ? propertyString : 'null')
        }
        var final
        if (partial.length === 0) {
          final = '[]'
        } else {
          if (gap === '') {
            var properties = partial.join(',')
            final = '[' + properties + ']'
          } else {
            var separator = ',\n' + indent
            var properties$1 = partial.join(separator)
            final = '[\n' + indent + properties$1 + ',\n' + stepback + ']'
          }
        }
        stack.pop()
        indent = stepback
        return final
      }
    }
    var JSON5 = {
      parse: parse,
      stringify: stringify,
    }
    var lib = JSON5
    var es5 = lib
    return es5
  })
})(dist)
var json5 = dist.exports
var strftime$1 = {
  exports: {},
}
;(function (module) {
  ;(function () {
    var Locales = {
      de_DE: {
        days: [
          'Sonntag',
          'Montag',
          'Dienstag',
          'Mittwoch',
          'Donnerstag',
          'Freitag',
          'Samstag',
        ],
        shortDays: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
        months: [
          'Januar',
          'Februar',
          'März',
          'April',
          'Mai',
          'Juni',
          'Juli',
          'August',
          'September',
          'Oktober',
          'November',
          'Dezember',
        ],
        shortMonths: [
          'Jan',
          'Feb',
          'Mär',
          'Apr',
          'Mai',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Okt',
          'Nov',
          'Dez',
        ],
        AM: 'AM',
        PM: 'PM',
        am: 'am',
        pm: 'pm',
        formats: {
          c: '%a %d %b %Y %X %Z',
          D: '%d.%m.%Y',
          F: '%Y-%m-%d',
          R: '%H:%M',
          r: '%I:%M:%S %p',
          T: '%H:%M:%S',
          v: '%e-%b-%Y',
          X: '%T',
          x: '%D',
        },
      },
      en_CA: {
        days: [
          'Sunday',
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
        ],
        shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        months: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ],
        shortMonths: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ],
        ordinalSuffixes: [
          'st',
          'nd',
          'rd',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'st',
          'nd',
          'rd',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'st',
        ],
        AM: 'AM',
        PM: 'PM',
        am: 'am',
        pm: 'pm',
        formats: {
          c: '%a %d %b %Y %X %Z',
          D: '%d/%m/%y',
          F: '%Y-%m-%d',
          R: '%H:%M',
          r: '%I:%M:%S %p',
          T: '%H:%M:%S',
          v: '%e-%b-%Y',
          X: '%r',
          x: '%D',
        },
      },
      en_US: {
        days: [
          'Sunday',
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
        ],
        shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        months: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ],
        shortMonths: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ],
        ordinalSuffixes: [
          'st',
          'nd',
          'rd',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'st',
          'nd',
          'rd',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'st',
        ],
        AM: 'AM',
        PM: 'PM',
        am: 'am',
        pm: 'pm',
        formats: {
          c: '%a %d %b %Y %X %Z',
          D: '%m/%d/%y',
          F: '%Y-%m-%d',
          R: '%H:%M',
          r: '%I:%M:%S %p',
          T: '%H:%M:%S',
          v: '%e-%b-%Y',
          X: '%r',
          x: '%D',
        },
      },
      es_MX: {
        days: [
          'domingo',
          'lunes',
          'martes',
          'miércoles',
          'jueves',
          'viernes',
          'sábado',
        ],
        shortDays: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        months: [
          'enero',
          'febrero',
          'marzo',
          'abril',
          'mayo',
          'junio',
          'julio',
          'agosto',
          'septiembre',
          'octubre',
          'noviembre',
          ' diciembre',
        ],
        shortMonths: [
          'ene',
          'feb',
          'mar',
          'abr',
          'may',
          'jun',
          'jul',
          'ago',
          'sep',
          'oct',
          'nov',
          'dic',
        ],
        AM: 'AM',
        PM: 'PM',
        am: 'am',
        pm: 'pm',
        formats: {
          c: '%a %d %b %Y %X %Z',
          D: '%d/%m/%Y',
          F: '%Y-%m-%d',
          R: '%H:%M',
          r: '%I:%M:%S %p',
          T: '%H:%M:%S',
          v: '%e-%b-%Y',
          X: '%T',
          x: '%D',
        },
      },
      fr_FR: {
        days: [
          'dimanche',
          'lundi',
          'mardi',
          'mercredi',
          'jeudi',
          'vendredi',
          'samedi',
        ],
        shortDays: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
        months: [
          'janvier',
          'février',
          'mars',
          'avril',
          'mai',
          'juin',
          'juillet',
          'août',
          'septembre',
          'octobre',
          'novembre',
          'décembre',
        ],
        shortMonths: [
          'janv.',
          'févr.',
          'mars',
          'avril',
          'mai',
          'juin',
          'juil.',
          'août',
          'sept.',
          'oct.',
          'nov.',
          'déc.',
        ],
        AM: 'AM',
        PM: 'PM',
        am: 'am',
        pm: 'pm',
        formats: {
          c: '%a %d %b %Y %X %Z',
          D: '%d/%m/%Y',
          F: '%Y-%m-%d',
          R: '%H:%M',
          r: '%I:%M:%S %p',
          T: '%H:%M:%S',
          v: '%e-%b-%Y',
          X: '%T',
          x: '%D',
        },
      },
      it_IT: {
        days: [
          'domenica',
          'lunedì',
          'martedì',
          'mercoledì',
          'giovedì',
          'venerdì',
          'sabato',
        ],
        shortDays: ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'],
        months: [
          'gennaio',
          'febbraio',
          'marzo',
          'aprile',
          'maggio',
          'giugno',
          'luglio',
          'agosto',
          'settembre',
          'ottobre',
          'novembre',
          'dicembre',
        ],
        shortMonths: [
          'pr',
          'mag',
          'giu',
          'lug',
          'ago',
          'set',
          'ott',
          'nov',
          'dic',
        ],
        AM: 'AM',
        PM: 'PM',
        am: 'am',
        pm: 'pm',
        formats: {
          c: '%a %d %b %Y %X %Z',
          D: '%d/%m/%Y',
          F: '%Y-%m-%d',
          R: '%H:%M',
          r: '%I:%M:%S %p',
          T: '%H:%M:%S',
          v: '%e-%b-%Y',
          X: '%T',
          x: '%D',
        },
      },
      nl_NL: {
        days: [
          'zondag',
          'maandag',
          'dinsdag',
          'woensdag',
          'donderdag',
          'vrijdag',
          'zaterdag',
        ],
        shortDays: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
        months: [
          'januari',
          'februari',
          'maart',
          'april',
          'mei',
          'juni',
          'juli',
          'augustus',
          'september',
          'oktober',
          'november',
          'december',
        ],
        shortMonths: [
          'jan',
          'feb',
          'mrt',
          'apr',
          'mei',
          'jun',
          'jul',
          'aug',
          'sep',
          'okt',
          'nov',
          'dec',
        ],
        AM: 'AM',
        PM: 'PM',
        am: 'am',
        pm: 'pm',
        formats: {
          c: '%a %d %b %Y %X %Z',
          D: '%d-%m-%y',
          F: '%Y-%m-%d',
          R: '%H:%M',
          r: '%I:%M:%S %p',
          T: '%H:%M:%S',
          v: '%e-%b-%Y',
          X: '%T',
          x: '%D',
        },
      },
      pt_BR: {
        days: [
          'domingo',
          'segunda',
          'terça',
          'quarta',
          'quinta',
          'sexta',
          'sábado',
        ],
        shortDays: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        months: [
          'janeiro',
          'fevereiro',
          'março',
          'abril',
          'maio',
          'junho',
          'julho',
          'agosto',
          'setembro',
          'outubro',
          'novembro',
          'dezembro',
        ],
        shortMonths: [
          'Jan',
          'Fev',
          'Mar',
          'Abr',
          'Mai',
          'Jun',
          'Jul',
          'Ago',
          'Set',
          'Out',
          'Nov',
          'Dez',
        ],
        AM: 'AM',
        PM: 'PM',
        am: 'am',
        pm: 'pm',
        formats: {
          c: '%a %d %b %Y %X %Z',
          D: '%d-%m-%Y',
          F: '%Y-%m-%d',
          R: '%H:%M',
          r: '%I:%M:%S %p',
          T: '%H:%M:%S',
          v: '%e-%b-%Y',
          X: '%T',
          x: '%D',
        },
      },
      ru_RU: {
        days: [
          'Воскресенье',
          'Понедельник',
          'Вторник',
          'Среда',
          'Четверг',
          'Пятница',
          'Суббота',
        ],
        shortDays: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
        months: [
          'Январь',
          'Февраль',
          'Март',
          'Апрель',
          'Май',
          'Июнь',
          'Июль',
          'Август',
          'Сентябрь',
          'Октябрь',
          'Ноябрь',
          'Декабрь',
        ],
        shortMonths: [
          'янв',
          'фев',
          'мар',
          'апр',
          'май',
          'июн',
          'июл',
          'авг',
          'сен',
          'окт',
          'ноя',
          'дек',
        ],
        AM: 'AM',
        PM: 'PM',
        am: 'am',
        pm: 'pm',
        formats: {
          c: '%a %d %b %Y %X',
          D: '%d.%m.%y',
          F: '%Y-%m-%d',
          R: '%H:%M',
          r: '%I:%M:%S %p',
          T: '%H:%M:%S',
          v: '%e-%b-%Y',
          X: '%T',
          x: '%D',
        },
      },
      tr_TR: {
        days: [
          'Pazar',
          'Pazartesi',
          'Salı',
          'Çarşamba',
          'Perşembe',
          'Cuma',
          'Cumartesi',
        ],
        shortDays: ['Paz', 'Pzt', 'Sal', 'Çrş', 'Prş', 'Cum', 'Cts'],
        months: [
          'Ocak',
          'Şubat',
          'Mart',
          'Nisan',
          'Mayıs',
          'Haziran',
          'Temmuz',
          'Ağustos',
          'Eylül',
          'Ekim',
          'Kasım',
          'Aralık',
        ],
        shortMonths: [
          'Oca',
          'Şub',
          'Mar',
          'Nis',
          'May',
          'Haz',
          'Tem',
          'Ağu',
          'Eyl',
          'Eki',
          'Kas',
          'Ara',
        ],
        AM: 'ÖÖ',
        PM: 'ÖS',
        am: 'ÖÖ',
        pm: 'ÖS',
        formats: {
          c: '%a %d %b %Y %X %Z',
          D: '%d-%m-%Y',
          F: '%Y-%m-%d',
          R: '%H:%M',
          r: '%I:%M:%S %p',
          T: '%H:%M:%S',
          v: '%e-%b-%Y',
          X: '%T',
          x: '%D',
        },
      },
      zh_CN: {
        days: [
          '星期日',
          '星期一',
          '星期二',
          '星期三',
          '星期四',
          '星期五',
          '星期六',
        ],
        shortDays: ['日', '一', '二', '三', '四', '五', '六'],
        months: [
          '一月份',
          '二月份',
          '三月份',
          '四月份',
          '五月份',
          '六月份',
          '七月份',
          '八月份',
          '九月份',
          '十月份',
          '十一月份',
          '十二月份',
        ],
        shortMonths: [
          '一月',
          '二月',
          '三月',
          '四月',
          '五月',
          '六月',
          '七月',
          '八月',
          '九月',
          '十月',
          '十一月',
          '十二月',
        ],
        AM: '上午',
        PM: '下午',
        am: '上午',
        pm: '下午',
        formats: {
          c: '%a %d %b %Y %X %Z',
          D: '%d/%m/%y',
          F: '%Y-%m-%d',
          R: '%H:%M',
          r: '%I:%M:%S %p',
          T: '%H:%M:%S',
          v: '%e-%b-%Y',
          X: '%r',
          x: '%D',
        },
      },
    }
    var DefaultLocale = Locales['en_US'],
      defaultStrftime = new Strftime(DefaultLocale, 0, false)
    {
      module.exports = defaultStrftime
    }
    if (typeof Date.now !== 'function') {
      Date.now = function () {
        return +new Date()
      }
    }
    function Strftime(locale, customTimezoneOffset, useUtcTimezone) {
      var _locale = locale || DefaultLocale,
        _customTimezoneOffset = customTimezoneOffset || 0,
        _useUtcBasedDate = useUtcTimezone || false,
        _cachedDateTimestamp = 0,
        _cachedDate
      function _strftime(format, date) {
        var timestamp
        if (!date) {
          var currentTimestamp = Date.now()
          if (currentTimestamp > _cachedDateTimestamp) {
            _cachedDateTimestamp = currentTimestamp
            _cachedDate = new Date(_cachedDateTimestamp)
            timestamp = _cachedDateTimestamp
            if (_useUtcBasedDate) {
              _cachedDate = new Date(
                _cachedDateTimestamp +
                  getTimestampToUtcOffsetFor(_cachedDate) +
                  _customTimezoneOffset
              )
            }
          } else {
            timestamp = _cachedDateTimestamp
          }
          date = _cachedDate
        } else {
          timestamp = date.getTime()
          if (_useUtcBasedDate) {
            var utcOffset = getTimestampToUtcOffsetFor(date)
            date = new Date(timestamp + utcOffset + _customTimezoneOffset)
            if (getTimestampToUtcOffsetFor(date) !== utcOffset) {
              var newUTCOffset = getTimestampToUtcOffsetFor(date)
              date = new Date(timestamp + newUTCOffset + _customTimezoneOffset)
            }
          }
        }
        return _processFormat(format, date, _locale, timestamp)
      }
      function _processFormat(format, date, locale, timestamp) {
        var resultString = '',
          padding = null,
          isInScope = false,
          length = format.length,
          extendedTZ = false
        for (var i = 0; i < length; i++) {
          var currentCharCode = format.charCodeAt(i)
          if (isInScope === true) {
            if (currentCharCode === 45) {
              padding = ''
              continue
            } else if (currentCharCode === 95) {
              padding = ' '
              continue
            } else if (currentCharCode === 48) {
              padding = '0'
              continue
            } else if (currentCharCode === 58) {
              if (extendedTZ) {
                warn(
                  '[WARNING] detected use of unsupported %:: or %::: modifiers to strftime'
                )
              }
              extendedTZ = true
              continue
            }
            switch (currentCharCode) {
              case 37:
                resultString += '%'
                break

              case 65:
                resultString += locale.days[date.getDay()]
                break

              case 66:
                resultString += locale.months[date.getMonth()]
                break

              case 67:
                resultString += padTill2(
                  Math.floor(date.getFullYear() / 100),
                  padding
                )
                break

              case 68:
                resultString += _processFormat(
                  locale.formats.D,
                  date,
                  locale,
                  timestamp
                )
                break

              case 70:
                resultString += _processFormat(
                  locale.formats.F,
                  date,
                  locale,
                  timestamp
                )
                break

              case 72:
                resultString += padTill2(date.getHours(), padding)
                break

              case 73:
                resultString += padTill2(hours12(date.getHours()), padding)
                break

              case 76:
                resultString += padTill3(Math.floor(timestamp % 1e3))
                break

              case 77:
                resultString += padTill2(date.getMinutes(), padding)
                break

              case 80:
                resultString += date.getHours() < 12 ? locale.am : locale.pm
                break

              case 82:
                resultString += _processFormat(
                  locale.formats.R,
                  date,
                  locale,
                  timestamp
                )
                break

              case 83:
                resultString += padTill2(date.getSeconds(), padding)
                break

              case 84:
                resultString += _processFormat(
                  locale.formats.T,
                  date,
                  locale,
                  timestamp
                )
                break

              case 85:
                resultString += padTill2(weekNumber(date, 'sunday'), padding)
                break

              case 87:
                resultString += padTill2(weekNumber(date, 'monday'), padding)
                break

              case 88:
                resultString += _processFormat(
                  locale.formats.X,
                  date,
                  locale,
                  timestamp
                )
                break

              case 89:
                resultString += date.getFullYear()
                break

              case 90:
                if (_useUtcBasedDate && _customTimezoneOffset === 0) {
                  resultString += 'GMT'
                } else {
                  var tzString = date.toString().match(/\(([\w\s]+)\)/)
                  resultString += (tzString && tzString[1]) || ''
                }
                break

              case 97:
                resultString += locale.shortDays[date.getDay()]
                break

              case 98:
                resultString += locale.shortMonths[date.getMonth()]
                break

              case 99:
                resultString += _processFormat(
                  locale.formats.c,
                  date,
                  locale,
                  timestamp
                )
                break

              case 100:
                resultString += padTill2(date.getDate(), padding)
                break

              case 101:
                resultString += padTill2(
                  date.getDate(),
                  padding == null ? ' ' : padding
                )
                break

              case 104:
                resultString += locale.shortMonths[date.getMonth()]
                break

              case 106:
                var y = new Date(date.getFullYear(), 0, 1)
                var day = Math.ceil(
                  (date.getTime() - y.getTime()) / (1e3 * 60 * 60 * 24)
                )
                resultString += padTill3(day)
                break

              case 107:
                resultString += padTill2(
                  date.getHours(),
                  padding == null ? ' ' : padding
                )
                break

              case 108:
                resultString += padTill2(
                  hours12(date.getHours()),
                  padding == null ? ' ' : padding
                )
                break

              case 109:
                resultString += padTill2(date.getMonth() + 1, padding)
                break

              case 110:
                resultString += '\n'
                break

              case 111:
                var day = date.getDate()
                if (locale.ordinalSuffixes) {
                  resultString +=
                    String(day) +
                    (locale.ordinalSuffixes[day - 1] || ordinal(day))
                } else {
                  resultString += String(day) + ordinal(day)
                }
                break

              case 112:
                resultString += date.getHours() < 12 ? locale.AM : locale.PM
                break

              case 114:
                resultString += _processFormat(
                  locale.formats.r,
                  date,
                  locale,
                  timestamp
                )
                break

              case 115:
                resultString += Math.floor(timestamp / 1e3)
                break

              case 116:
                resultString += '\t'
                break

              case 117:
                var day = date.getDay()
                resultString += day === 0 ? 7 : day
                break

              case 118:
                resultString += _processFormat(
                  locale.formats.v,
                  date,
                  locale,
                  timestamp
                )
                break

              case 119:
                resultString += date.getDay()
                break

              case 120:
                resultString += _processFormat(
                  locale.formats.x,
                  date,
                  locale,
                  timestamp
                )
                break

              case 121:
                resultString += ('' + date.getFullYear()).slice(2)
                break

              case 122:
                if (_useUtcBasedDate && _customTimezoneOffset === 0) {
                  resultString += extendedTZ ? '+00:00' : '+0000'
                } else {
                  var off
                  if (_customTimezoneOffset !== 0) {
                    off = _customTimezoneOffset / (60 * 1e3)
                  } else {
                    off = -date.getTimezoneOffset()
                  }
                  var sign = off < 0 ? '-' : '+'
                  var sep = extendedTZ ? ':' : ''
                  var hours = Math.floor(Math.abs(off / 60))
                  var mins = Math.abs(off % 60)
                  resultString += sign + padTill2(hours) + sep + padTill2(mins)
                }
                break

              default:
                if (isInScope) {
                  resultString += '%'
                }
                resultString += format[i]
                break
            }
            padding = null
            isInScope = false
            continue
          }
          if (currentCharCode === 37) {
            isInScope = true
            continue
          }
          resultString += format[i]
        }
        return resultString
      }
      var strftime = _strftime
      strftime.localize = function (locale) {
        return new Strftime(
          locale || _locale,
          _customTimezoneOffset,
          _useUtcBasedDate
        )
      }
      strftime.localizeByIdentifier = function (localeIdentifier) {
        var locale = Locales[localeIdentifier]
        if (!locale) {
          warn(
            '[WARNING] No locale found with identifier "' +
              localeIdentifier +
              '".'
          )
          return strftime
        }
        return strftime.localize(locale)
      }
      strftime.timezone = function (timezone) {
        var customTimezoneOffset = _customTimezoneOffset
        var useUtcBasedDate = _useUtcBasedDate
        var timezoneType = typeof timezone
        if (timezoneType === 'number' || timezoneType === 'string') {
          useUtcBasedDate = true
          if (timezoneType === 'string') {
            var sign = timezone[0] === '-' ? -1 : 1,
              hours = parseInt(timezone.slice(1, 3), 10),
              minutes = parseInt(timezone.slice(3, 5), 10)
            customTimezoneOffset = sign * (60 * hours + minutes) * 60 * 1e3
          } else if (timezoneType === 'number') {
            customTimezoneOffset = timezone * 60 * 1e3
          }
        }
        return new Strftime(_locale, customTimezoneOffset, useUtcBasedDate)
      }
      strftime.utc = function () {
        return new Strftime(_locale, _customTimezoneOffset, true)
      }
      return strftime
    }
    function padTill2(numberToPad, paddingChar) {
      if (paddingChar === '' || numberToPad > 9) {
        return numberToPad
      }
      if (paddingChar == null) {
        paddingChar = '0'
      }
      return paddingChar + numberToPad
    }
    function padTill3(numberToPad) {
      if (numberToPad > 99) {
        return numberToPad
      }
      if (numberToPad > 9) {
        return '0' + numberToPad
      }
      return '00' + numberToPad
    }
    function hours12(hour) {
      if (hour === 0) {
        return 12
      } else if (hour > 12) {
        return hour - 12
      }
      return hour
    }
    function weekNumber(date, firstWeekday) {
      firstWeekday = firstWeekday || 'sunday'
      var weekday = date.getDay()
      if (firstWeekday === 'monday') {
        if (weekday === 0) weekday = 6
        else weekday--
      }
      var firstDayOfYearUtc = Date.UTC(date.getFullYear(), 0, 1),
        dateUtc = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()),
        yday = Math.floor((dateUtc - firstDayOfYearUtc) / 864e5),
        weekNum = (yday + 7 - weekday) / 7
      return Math.floor(weekNum)
    }
    function ordinal(number) {
      var i = number % 10
      var ii = number % 100
      if ((ii >= 11 && ii <= 13) || i === 0 || i >= 4) {
        return 'th'
      }
      switch (i) {
        case 1:
          return 'st'

        case 2:
          return 'nd'

        case 3:
          return 'rd'
      }
    }
    function getTimestampToUtcOffsetFor(date) {
      return (date.getTimezoneOffset() || 0) * 6e4
    }
    function warn(message) {
      if (typeof console !== 'undefined' && typeof console.warn == 'function') {
        console.warn(message)
      }
    }
  })()
})(strftime$1)
var strftime = strftime$1.exports
var momentWithLocales = {
  exports: {},
}
;(function (module, exports) {
  ;(function (global, factory) {
    module.exports = factory()
  })(commonjsGlobal, function () {
    var hookCallback
    function hooks() {
      return hookCallback.apply(null, arguments)
    }
    function setHookCallback(callback) {
      hookCallback = callback
    }
    function isArray(input) {
      return (
        input instanceof Array ||
        Object.prototype.toString.call(input) === '[object Array]'
      )
    }
    function isObject(input) {
      return (
        input != null &&
        Object.prototype.toString.call(input) === '[object Object]'
      )
    }
    function hasOwnProp(a, b) {
      return Object.prototype.hasOwnProperty.call(a, b)
    }
    function isObjectEmpty(obj) {
      if (Object.getOwnPropertyNames) {
        return Object.getOwnPropertyNames(obj).length === 0
      } else {
        var k
        for (k in obj) {
          if (hasOwnProp(obj, k)) {
            return false
          }
        }
        return true
      }
    }
    function isUndefined(input) {
      return input === void 0
    }
    function isNumber(input) {
      return (
        typeof input === 'number' ||
        Object.prototype.toString.call(input) === '[object Number]'
      )
    }
    function isDate(input) {
      return (
        input instanceof Date ||
        Object.prototype.toString.call(input) === '[object Date]'
      )
    }
    function map(arr, fn) {
      var res = [],
        i
      for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i))
      }
      return res
    }
    function extend(a, b) {
      for (var i in b) {
        if (hasOwnProp(b, i)) {
          a[i] = b[i]
        }
      }
      if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString
      }
      if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf
      }
      return a
    }
    function createUTC(input, format, locale, strict) {
      return createLocalOrUTC(input, format, locale, strict, true).utc()
    }
    function defaultParsingFlags() {
      return {
        empty: false,
        unusedTokens: [],
        unusedInput: [],
        overflow: -2,
        charsLeftOver: 0,
        nullInput: false,
        invalidEra: null,
        invalidMonth: null,
        invalidFormat: false,
        userInvalidated: false,
        iso: false,
        parsedDateParts: [],
        era: null,
        meridiem: null,
        rfc2822: false,
        weekdayMismatch: false,
      }
    }
    function getParsingFlags(m) {
      if (m._pf == null) {
        m._pf = defaultParsingFlags()
      }
      return m._pf
    }
    var some
    if (Array.prototype.some) {
      some = Array.prototype.some
    } else {
      some = function (fun) {
        var t = Object(this),
          len = t.length >>> 0,
          i
        for (i = 0; i < len; i++) {
          if (i in t && fun.call(this, t[i], i, t)) {
            return true
          }
        }
        return false
      }
    }
    function isValid(m) {
      if (m._isValid == null) {
        var flags = getParsingFlags(m),
          parsedParts = some.call(flags.parsedDateParts, function (i) {
            return i != null
          }),
          isNowValid =
            !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidEra &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.weekdayMismatch &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts))
        if (m._strict) {
          isNowValid =
            isNowValid &&
            flags.charsLeftOver === 0 &&
            flags.unusedTokens.length === 0 &&
            flags.bigHour === undefined
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
          m._isValid = isNowValid
        } else {
          return isNowValid
        }
      }
      return m._isValid
    }
    function createInvalid(flags) {
      var m = createUTC(NaN)
      if (flags != null) {
        extend(getParsingFlags(m), flags)
      } else {
        getParsingFlags(m).userInvalidated = true
      }
      return m
    }
    var momentProperties = (hooks.momentProperties = []),
      updateInProgress = false
    function copyConfig(to, from) {
      var i, prop, val
      if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject
      }
      if (!isUndefined(from._i)) {
        to._i = from._i
      }
      if (!isUndefined(from._f)) {
        to._f = from._f
      }
      if (!isUndefined(from._l)) {
        to._l = from._l
      }
      if (!isUndefined(from._strict)) {
        to._strict = from._strict
      }
      if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm
      }
      if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC
      }
      if (!isUndefined(from._offset)) {
        to._offset = from._offset
      }
      if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from)
      }
      if (!isUndefined(from._locale)) {
        to._locale = from._locale
      }
      if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
          prop = momentProperties[i]
          val = from[prop]
          if (!isUndefined(val)) {
            to[prop] = val
          }
        }
      }
      return to
    }
    function Moment(config) {
      copyConfig(this, config)
      this._d = new Date(config._d != null ? config._d.getTime() : NaN)
      if (!this.isValid()) {
        this._d = new Date(NaN)
      }
      if (updateInProgress === false) {
        updateInProgress = true
        hooks.updateOffset(this)
        updateInProgress = false
      }
    }
    function isMoment(obj) {
      return (
        obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
      )
    }
    function warn(msg) {
      if (
        hooks.suppressDeprecationWarnings === false &&
        typeof console !== 'undefined' &&
        console.warn
      ) {
        console.warn('Deprecation warning: ' + msg)
      }
    }
    function deprecate(msg, fn) {
      var firstTime = true
      return extend(function () {
        if (hooks.deprecationHandler != null) {
          hooks.deprecationHandler(null, msg)
        }
        if (firstTime) {
          var args = [],
            arg,
            i,
            key
          for (i = 0; i < arguments.length; i++) {
            arg = ''
            if (typeof arguments[i] === 'object') {
              arg += '\n[' + i + '] '
              for (key in arguments[0]) {
                if (hasOwnProp(arguments[0], key)) {
                  arg += key + ': ' + arguments[0][key] + ', '
                }
              }
              arg = arg.slice(0, -2)
            } else {
              arg = arguments[i]
            }
            args.push(arg)
          }
          warn(
            msg +
              '\nArguments: ' +
              Array.prototype.slice.call(args).join('') +
              '\n' +
              new Error().stack
          )
          firstTime = false
        }
        return fn.apply(this, arguments)
      }, fn)
    }
    var deprecations = {}
    function deprecateSimple(name, msg) {
      if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg)
      }
      if (!deprecations[name]) {
        warn(msg)
        deprecations[name] = true
      }
    }
    hooks.suppressDeprecationWarnings = false
    hooks.deprecationHandler = null
    function isFunction(input) {
      return (
        (typeof Function !== 'undefined' && input instanceof Function) ||
        Object.prototype.toString.call(input) === '[object Function]'
      )
    }
    function set(config) {
      var prop, i
      for (i in config) {
        if (hasOwnProp(config, i)) {
          prop = config[i]
          if (isFunction(prop)) {
            this[i] = prop
          } else {
            this['_' + i] = prop
          }
        }
      }
      this._config = config
      this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
          '|' +
          /\d{1,2}/.source
      )
    }
    function mergeConfigs(parentConfig, childConfig) {
      var res = extend({}, parentConfig),
        prop
      for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
          if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
            res[prop] = {}
            extend(res[prop], parentConfig[prop])
            extend(res[prop], childConfig[prop])
          } else if (childConfig[prop] != null) {
            res[prop] = childConfig[prop]
          } else {
            delete res[prop]
          }
        }
      }
      for (prop in parentConfig) {
        if (
          hasOwnProp(parentConfig, prop) &&
          !hasOwnProp(childConfig, prop) &&
          isObject(parentConfig[prop])
        ) {
          res[prop] = extend({}, res[prop])
        }
      }
      return res
    }
    function Locale(config) {
      if (config != null) {
        this.set(config)
      }
    }
    var keys
    if (Object.keys) {
      keys = Object.keys
    } else {
      keys = function (obj) {
        var i,
          res = []
        for (i in obj) {
          if (hasOwnProp(obj, i)) {
            res.push(i)
          }
        }
        return res
      }
    }
    var defaultCalendar = {
      sameDay: '[Today at] LT',
      nextDay: '[Tomorrow at] LT',
      nextWeek: 'dddd [at] LT',
      lastDay: '[Yesterday at] LT',
      lastWeek: '[Last] dddd [at] LT',
      sameElse: 'L',
    }
    function calendar(key, mom, now) {
      var output = this._calendar[key] || this._calendar['sameElse']
      return isFunction(output) ? output.call(mom, now) : output
    }
    function zeroFill(number, targetLength, forceSign) {
      var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0
      return (
        (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
        absNumber
      )
    }
    var formattingTokens =
        /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
      localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
      formatFunctions = {},
      formatTokenFunctions = {}
    function addFormatToken(token, padded, ordinal, callback) {
      var func = callback
      if (typeof callback === 'string') {
        func = function () {
          return this[callback]()
        }
      }
      if (token) {
        formatTokenFunctions[token] = func
      }
      if (padded) {
        formatTokenFunctions[padded[0]] = function () {
          return zeroFill(func.apply(this, arguments), padded[1], padded[2])
        }
      }
      if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
          return this.localeData().ordinal(func.apply(this, arguments), token)
        }
      }
    }
    function removeFormattingTokens(input) {
      if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '')
      }
      return input.replace(/\\/g, '')
    }
    function makeFormatFunction(format) {
      var array = format.match(formattingTokens),
        i,
        length
      for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
          array[i] = formatTokenFunctions[array[i]]
        } else {
          array[i] = removeFormattingTokens(array[i])
        }
      }
      return function (mom) {
        var output = '',
          i
        for (i = 0; i < length; i++) {
          output += isFunction(array[i]) ? array[i].call(mom, format) : array[i]
        }
        return output
      }
    }
    function formatMoment(m, format) {
      if (!m.isValid()) {
        return m.localeData().invalidDate()
      }
      format = expandFormat(format, m.localeData())
      formatFunctions[format] =
        formatFunctions[format] || makeFormatFunction(format)
      return formatFunctions[format](m)
    }
    function expandFormat(format, locale) {
      var i = 5
      function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input
      }
      localFormattingTokens.lastIndex = 0
      while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(
          localFormattingTokens,
          replaceLongDateFormatTokens
        )
        localFormattingTokens.lastIndex = 0
        i -= 1
      }
      return format
    }
    var defaultLongDateFormat = {
      LTS: 'h:mm:ss A',
      LT: 'h:mm A',
      L: 'MM/DD/YYYY',
      LL: 'MMMM D, YYYY',
      LLL: 'MMMM D, YYYY h:mm A',
      LLLL: 'dddd, MMMM D, YYYY h:mm A',
    }
    function longDateFormat(key) {
      var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()]
      if (format || !formatUpper) {
        return format
      }
      this._longDateFormat[key] = formatUpper
        .match(formattingTokens)
        .map(function (tok) {
          if (
            tok === 'MMMM' ||
            tok === 'MM' ||
            tok === 'DD' ||
            tok === 'dddd'
          ) {
            return tok.slice(1)
          }
          return tok
        })
        .join('')
      return this._longDateFormat[key]
    }
    var defaultInvalidDate = 'Invalid date'
    function invalidDate() {
      return this._invalidDate
    }
    var defaultOrdinal = '%d',
      defaultDayOfMonthOrdinalParse = /\d{1,2}/
    function ordinal(number) {
      return this._ordinal.replace('%d', number)
    }
    var defaultRelativeTime = {
      future: 'in %s',
      past: '%s ago',
      s: 'a few seconds',
      ss: '%d seconds',
      m: 'a minute',
      mm: '%d minutes',
      h: 'an hour',
      hh: '%d hours',
      d: 'a day',
      dd: '%d days',
      w: 'a week',
      ww: '%d weeks',
      M: 'a month',
      MM: '%d months',
      y: 'a year',
      yy: '%d years',
    }
    function relativeTime(number, withoutSuffix, string, isFuture) {
      var output = this._relativeTime[string]
      return isFunction(output)
        ? output(number, withoutSuffix, string, isFuture)
        : output.replace(/%d/i, number)
    }
    function pastFuture(diff, output) {
      var format = this._relativeTime[diff > 0 ? 'future' : 'past']
      return isFunction(format) ? format(output) : format.replace(/%s/i, output)
    }
    var aliases = {}
    function addUnitAlias(unit, shorthand) {
      var lowerCase = unit.toLowerCase()
      aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit
    }
    function normalizeUnits(units) {
      return typeof units === 'string'
        ? aliases[units] || aliases[units.toLowerCase()]
        : undefined
    }
    function normalizeObjectUnits(inputObject) {
      var normalizedInput = {},
        normalizedProp,
        prop
      for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
          normalizedProp = normalizeUnits(prop)
          if (normalizedProp) {
            normalizedInput[normalizedProp] = inputObject[prop]
          }
        }
      }
      return normalizedInput
    }
    var priorities = {}
    function addUnitPriority(unit, priority) {
      priorities[unit] = priority
    }
    function getPrioritizedUnits(unitsObj) {
      var units = [],
        u
      for (u in unitsObj) {
        if (hasOwnProp(unitsObj, u)) {
          units.push({
            unit: u,
            priority: priorities[u],
          })
        }
      }
      units.sort(function (a, b) {
        return a.priority - b.priority
      })
      return units
    }
    function isLeapYear(year) {
      return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0
    }
    function absFloor(number) {
      if (number < 0) {
        return Math.ceil(number) || 0
      } else {
        return Math.floor(number)
      }
    }
    function toInt(argumentForCoercion) {
      var coercedNumber = +argumentForCoercion,
        value = 0
      if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber)
      }
      return value
    }
    function makeGetSet(unit, keepTime) {
      return function (value) {
        if (value != null) {
          set$1(this, unit, value)
          hooks.updateOffset(this, keepTime)
          return this
        } else {
          return get(this, unit)
        }
      }
    }
    function get(mom, unit) {
      return mom.isValid()
        ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
        : NaN
    }
    function set$1(mom, unit, value) {
      if (mom.isValid() && !isNaN(value)) {
        if (
          unit === 'FullYear' &&
          isLeapYear(mom.year()) &&
          mom.month() === 1 &&
          mom.date() === 29
        ) {
          value = toInt(value)
          mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
            value,
            mom.month(),
            daysInMonth(value, mom.month())
          )
        } else {
          mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value)
        }
      }
    }
    function stringGet(units) {
      units = normalizeUnits(units)
      if (isFunction(this[units])) {
        return this[units]()
      }
      return this
    }
    function stringSet(units, value) {
      if (typeof units === 'object') {
        units = normalizeObjectUnits(units)
        var prioritized = getPrioritizedUnits(units),
          i
        for (i = 0; i < prioritized.length; i++) {
          this[prioritized[i].unit](units[prioritized[i].unit])
        }
      } else {
        units = normalizeUnits(units)
        if (isFunction(this[units])) {
          return this[units](value)
        }
      }
      return this
    }
    var match1 = /\d/,
      match2 = /\d\d/,
      match3 = /\d{3}/,
      match4 = /\d{4}/,
      match6 = /[+-]?\d{6}/,
      match1to2 = /\d\d?/,
      match3to4 = /\d\d\d\d?/,
      match5to6 = /\d\d\d\d\d\d?/,
      match1to3 = /\d{1,3}/,
      match1to4 = /\d{1,4}/,
      match1to6 = /[+-]?\d{1,6}/,
      matchUnsigned = /\d+/,
      matchSigned = /[+-]?\d+/,
      matchOffset = /Z|[+-]\d\d:?\d\d/gi,
      matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi,
      matchTimestamp = /[+-]?\d+(\.\d{1,3})?/,
      matchWord =
        /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
      regexes
    regexes = {}
    function addRegexToken(token, regex, strictRegex) {
      regexes[token] = isFunction(regex)
        ? regex
        : function (isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex
          }
    }
    function getParseRegexForToken(token, config) {
      if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token))
      }
      return regexes[token](config._strict, config._locale)
    }
    function unescapeFormat(s) {
      return regexEscape(
        s
          .replace('\\', '')
          .replace(
            /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
            function (matched, p1, p2, p3, p4) {
              return p1 || p2 || p3 || p4
            }
          )
      )
    }
    function regexEscape(s) {
      return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
    }
    var tokens = {}
    function addParseToken(token, callback) {
      var i,
        func = callback
      if (typeof token === 'string') {
        token = [token]
      }
      if (isNumber(callback)) {
        func = function (input, array) {
          array[callback] = toInt(input)
        }
      }
      for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func
      }
    }
    function addWeekParseToken(token, callback) {
      addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {}
        callback(input, config._w, config, token)
      })
    }
    function addTimeToArrayFromToken(token, input, config) {
      if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token)
      }
    }
    var YEAR = 0,
      MONTH = 1,
      DATE = 2,
      HOUR = 3,
      MINUTE = 4,
      SECOND = 5,
      MILLISECOND = 6,
      WEEK = 7,
      WEEKDAY = 8
    function mod(n, x) {
      return ((n % x) + x) % x
    }
    var indexOf
    if (Array.prototype.indexOf) {
      indexOf = Array.prototype.indexOf
    } else {
      indexOf = function (o) {
        var i
        for (i = 0; i < this.length; ++i) {
          if (this[i] === o) {
            return i
          }
        }
        return -1
      }
    }
    function daysInMonth(year, month) {
      if (isNaN(year) || isNaN(month)) {
        return NaN
      }
      var modMonth = mod(month, 12)
      year += (month - modMonth) / 12
      return modMonth === 1
        ? isLeapYear(year)
          ? 29
          : 28
        : 31 - ((modMonth % 7) % 2)
    }
    addFormatToken('M', ['MM', 2], 'Mo', function () {
      return this.month() + 1
    })
    addFormatToken('MMM', 0, 0, function (format) {
      return this.localeData().monthsShort(this, format)
    })
    addFormatToken('MMMM', 0, 0, function (format) {
      return this.localeData().months(this, format)
    })
    addUnitAlias('month', 'M')
    addUnitPriority('month', 8)
    addRegexToken('M', match1to2)
    addRegexToken('MM', match1to2, match2)
    addRegexToken('MMM', function (isStrict, locale) {
      return locale.monthsShortRegex(isStrict)
    })
    addRegexToken('MMMM', function (isStrict, locale) {
      return locale.monthsRegex(isStrict)
    })
    addParseToken(['M', 'MM'], function (input, array) {
      array[MONTH] = toInt(input) - 1
    })
    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
      var month = config._locale.monthsParse(input, token, config._strict)
      if (month != null) {
        array[MONTH] = month
      } else {
        getParsingFlags(config).invalidMonth = input
      }
    })
    var defaultLocaleMonths =
        'January_February_March_April_May_June_July_August_September_October_November_December'.split(
          '_'
        ),
      defaultLocaleMonthsShort =
        'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
      MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
      defaultMonthsShortRegex = matchWord,
      defaultMonthsRegex = matchWord
    function localeMonths(m, format) {
      if (!m) {
        return isArray(this._months) ? this._months : this._months['standalone']
      }
      return isArray(this._months)
        ? this._months[m.month()]
        : this._months[
            (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
              ? 'format'
              : 'standalone'
          ][m.month()]
    }
    function localeMonthsShort(m, format) {
      if (!m) {
        return isArray(this._monthsShort)
          ? this._monthsShort
          : this._monthsShort['standalone']
      }
      return isArray(this._monthsShort)
        ? this._monthsShort[m.month()]
        : this._monthsShort[
            MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
          ][m.month()]
    }
    function handleStrictParse(monthName, format, strict) {
      var i,
        ii,
        mom,
        llc = monthName.toLocaleLowerCase()
      if (!this._monthsParse) {
        this._monthsParse = []
        this._longMonthsParse = []
        this._shortMonthsParse = []
        for (i = 0; i < 12; ++i) {
          mom = createUTC([2e3, i])
          this._shortMonthsParse[i] = this.monthsShort(
            mom,
            ''
          ).toLocaleLowerCase()
          this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase()
        }
      }
      if (strict) {
        if (format === 'MMM') {
          ii = indexOf.call(this._shortMonthsParse, llc)
          return ii !== -1 ? ii : null
        } else {
          ii = indexOf.call(this._longMonthsParse, llc)
          return ii !== -1 ? ii : null
        }
      } else {
        if (format === 'MMM') {
          ii = indexOf.call(this._shortMonthsParse, llc)
          if (ii !== -1) {
            return ii
          }
          ii = indexOf.call(this._longMonthsParse, llc)
          return ii !== -1 ? ii : null
        } else {
          ii = indexOf.call(this._longMonthsParse, llc)
          if (ii !== -1) {
            return ii
          }
          ii = indexOf.call(this._shortMonthsParse, llc)
          return ii !== -1 ? ii : null
        }
      }
    }
    function localeMonthsParse(monthName, format, strict) {
      var i, mom, regex
      if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict)
      }
      if (!this._monthsParse) {
        this._monthsParse = []
        this._longMonthsParse = []
        this._shortMonthsParse = []
      }
      for (i = 0; i < 12; i++) {
        mom = createUTC([2e3, i])
        if (strict && !this._longMonthsParse[i]) {
          this._longMonthsParse[i] = new RegExp(
            '^' + this.months(mom, '').replace('.', '') + '$',
            'i'
          )
          this._shortMonthsParse[i] = new RegExp(
            '^' + this.monthsShort(mom, '').replace('.', '') + '$',
            'i'
          )
        }
        if (!strict && !this._monthsParse[i]) {
          regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '')
          this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i')
        }
        if (
          strict &&
          format === 'MMMM' &&
          this._longMonthsParse[i].test(monthName)
        ) {
          return i
        } else if (
          strict &&
          format === 'MMM' &&
          this._shortMonthsParse[i].test(monthName)
        ) {
          return i
        } else if (!strict && this._monthsParse[i].test(monthName)) {
          return i
        }
      }
    }
    function setMonth(mom, value) {
      var dayOfMonth
      if (!mom.isValid()) {
        return mom
      }
      if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
          value = toInt(value)
        } else {
          value = mom.localeData().monthsParse(value)
          if (!isNumber(value)) {
            return mom
          }
        }
      }
      dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value))
      mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth)
      return mom
    }
    function getSetMonth(value) {
      if (value != null) {
        setMonth(this, value)
        hooks.updateOffset(this, true)
        return this
      } else {
        return get(this, 'Month')
      }
    }
    function getDaysInMonth() {
      return daysInMonth(this.year(), this.month())
    }
    function monthsShortRegex(isStrict) {
      if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
          computeMonthsParse.call(this)
        }
        if (isStrict) {
          return this._monthsShortStrictRegex
        } else {
          return this._monthsShortRegex
        }
      } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
          this._monthsShortRegex = defaultMonthsShortRegex
        }
        return this._monthsShortStrictRegex && isStrict
          ? this._monthsShortStrictRegex
          : this._monthsShortRegex
      }
    }
    function monthsRegex(isStrict) {
      if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
          computeMonthsParse.call(this)
        }
        if (isStrict) {
          return this._monthsStrictRegex
        } else {
          return this._monthsRegex
        }
      } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
          this._monthsRegex = defaultMonthsRegex
        }
        return this._monthsStrictRegex && isStrict
          ? this._monthsStrictRegex
          : this._monthsRegex
      }
    }
    function computeMonthsParse() {
      function cmpLenRev(a, b) {
        return b.length - a.length
      }
      var shortPieces = [],
        longPieces = [],
        mixedPieces = [],
        i,
        mom
      for (i = 0; i < 12; i++) {
        mom = createUTC([2e3, i])
        shortPieces.push(this.monthsShort(mom, ''))
        longPieces.push(this.months(mom, ''))
        mixedPieces.push(this.months(mom, ''))
        mixedPieces.push(this.monthsShort(mom, ''))
      }
      shortPieces.sort(cmpLenRev)
      longPieces.sort(cmpLenRev)
      mixedPieces.sort(cmpLenRev)
      for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i])
        longPieces[i] = regexEscape(longPieces[i])
      }
      for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i])
      }
      this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i')
      this._monthsShortRegex = this._monthsRegex
      this._monthsStrictRegex = new RegExp(
        '^(' + longPieces.join('|') + ')',
        'i'
      )
      this._monthsShortStrictRegex = new RegExp(
        '^(' + shortPieces.join('|') + ')',
        'i'
      )
    }
    addFormatToken('Y', 0, 0, function () {
      var y = this.year()
      return y <= 9999 ? zeroFill(y, 4) : '+' + y
    })
    addFormatToken(0, ['YY', 2], 0, function () {
      return this.year() % 100
    })
    addFormatToken(0, ['YYYY', 4], 0, 'year')
    addFormatToken(0, ['YYYYY', 5], 0, 'year')
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year')
    addUnitAlias('year', 'y')
    addUnitPriority('year', 1)
    addRegexToken('Y', matchSigned)
    addRegexToken('YY', match1to2, match2)
    addRegexToken('YYYY', match1to4, match4)
    addRegexToken('YYYYY', match1to6, match6)
    addRegexToken('YYYYYY', match1to6, match6)
    addParseToken(['YYYYY', 'YYYYYY'], YEAR)
    addParseToken('YYYY', function (input, array) {
      array[YEAR] =
        input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input)
    })
    addParseToken('YY', function (input, array) {
      array[YEAR] = hooks.parseTwoDigitYear(input)
    })
    addParseToken('Y', function (input, array) {
      array[YEAR] = parseInt(input, 10)
    })
    function daysInYear(year) {
      return isLeapYear(year) ? 366 : 365
    }
    hooks.parseTwoDigitYear = function (input) {
      return toInt(input) + (toInt(input) > 68 ? 1900 : 2e3)
    }
    var getSetYear = makeGetSet('FullYear', true)
    function getIsLeapYear() {
      return isLeapYear(this.year())
    }
    function createDate(y, m, d, h, M, s, ms) {
      var date
      if (y < 100 && y >= 0) {
        date = new Date(y + 400, m, d, h, M, s, ms)
        if (isFinite(date.getFullYear())) {
          date.setFullYear(y)
        }
      } else {
        date = new Date(y, m, d, h, M, s, ms)
      }
      return date
    }
    function createUTCDate(y) {
      var date, args
      if (y < 100 && y >= 0) {
        args = Array.prototype.slice.call(arguments)
        args[0] = y + 400
        date = new Date(Date.UTC.apply(null, args))
        if (isFinite(date.getUTCFullYear())) {
          date.setUTCFullYear(y)
        }
      } else {
        date = new Date(Date.UTC.apply(null, arguments))
      }
      return date
    }
    function firstWeekOffset(year, dow, doy) {
      var fwd = 7 + dow - doy,
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7
      return -fwdlw + fwd - 1
    }
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
      var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear,
        resDayOfYear
      if (dayOfYear <= 0) {
        resYear = year - 1
        resDayOfYear = daysInYear(resYear) + dayOfYear
      } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1
        resDayOfYear = dayOfYear - daysInYear(year)
      } else {
        resYear = year
        resDayOfYear = dayOfYear
      }
      return {
        year: resYear,
        dayOfYear: resDayOfYear,
      }
    }
    function weekOfYear(mom, dow, doy) {
      var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek,
        resYear
      if (week < 1) {
        resYear = mom.year() - 1
        resWeek = week + weeksInYear(resYear, dow, doy)
      } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy)
        resYear = mom.year() + 1
      } else {
        resYear = mom.year()
        resWeek = week
      }
      return {
        week: resWeek,
        year: resYear,
      }
    }
    function weeksInYear(year, dow, doy) {
      var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy)
      return (daysInYear(year) - weekOffset + weekOffsetNext) / 7
    }
    addFormatToken('w', ['ww', 2], 'wo', 'week')
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek')
    addUnitAlias('week', 'w')
    addUnitAlias('isoWeek', 'W')
    addUnitPriority('week', 5)
    addUnitPriority('isoWeek', 5)
    addRegexToken('w', match1to2)
    addRegexToken('ww', match1to2, match2)
    addRegexToken('W', match1to2)
    addRegexToken('WW', match1to2, match2)
    addWeekParseToken(
      ['w', 'ww', 'W', 'WW'],
      function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input)
      }
    )
    function localeWeek(mom) {
      return weekOfYear(mom, this._week.dow, this._week.doy).week
    }
    var defaultLocaleWeek = {
      dow: 0,
      doy: 6,
    }
    function localeFirstDayOfWeek() {
      return this._week.dow
    }
    function localeFirstDayOfYear() {
      return this._week.doy
    }
    function getSetWeek(input) {
      var week = this.localeData().week(this)
      return input == null ? week : this.add((input - week) * 7, 'd')
    }
    function getSetISOWeek(input) {
      var week = weekOfYear(this, 1, 4).week
      return input == null ? week : this.add((input - week) * 7, 'd')
    }
    addFormatToken('d', 0, 'do', 'day')
    addFormatToken('dd', 0, 0, function (format) {
      return this.localeData().weekdaysMin(this, format)
    })
    addFormatToken('ddd', 0, 0, function (format) {
      return this.localeData().weekdaysShort(this, format)
    })
    addFormatToken('dddd', 0, 0, function (format) {
      return this.localeData().weekdays(this, format)
    })
    addFormatToken('e', 0, 0, 'weekday')
    addFormatToken('E', 0, 0, 'isoWeekday')
    addUnitAlias('day', 'd')
    addUnitAlias('weekday', 'e')
    addUnitAlias('isoWeekday', 'E')
    addUnitPriority('day', 11)
    addUnitPriority('weekday', 11)
    addUnitPriority('isoWeekday', 11)
    addRegexToken('d', match1to2)
    addRegexToken('e', match1to2)
    addRegexToken('E', match1to2)
    addRegexToken('dd', function (isStrict, locale) {
      return locale.weekdaysMinRegex(isStrict)
    })
    addRegexToken('ddd', function (isStrict, locale) {
      return locale.weekdaysShortRegex(isStrict)
    })
    addRegexToken('dddd', function (isStrict, locale) {
      return locale.weekdaysRegex(isStrict)
    })
    addWeekParseToken(
      ['dd', 'ddd', 'dddd'],
      function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict)
        if (weekday != null) {
          week.d = weekday
        } else {
          getParsingFlags(config).invalidWeekday = input
        }
      }
    )
    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
      week[token] = toInt(input)
    })
    function parseWeekday(input, locale) {
      if (typeof input !== 'string') {
        return input
      }
      if (!isNaN(input)) {
        return parseInt(input, 10)
      }
      input = locale.weekdaysParse(input)
      if (typeof input === 'number') {
        return input
      }
      return null
    }
    function parseIsoWeekday(input, locale) {
      if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7
      }
      return isNaN(input) ? null : input
    }
    function shiftWeekdays(ws, n) {
      return ws.slice(n, 7).concat(ws.slice(0, n))
    }
    var defaultLocaleWeekdays =
        'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
      defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
      defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
      defaultWeekdaysRegex = matchWord,
      defaultWeekdaysShortRegex = matchWord,
      defaultWeekdaysMinRegex = matchWord
    function localeWeekdays(m, format) {
      var weekdays = isArray(this._weekdays)
        ? this._weekdays
        : this._weekdays[
            m && m !== true && this._weekdays.isFormat.test(format)
              ? 'format'
              : 'standalone'
          ]
      return m === true
        ? shiftWeekdays(weekdays, this._week.dow)
        : m
          ? weekdays[m.day()]
          : weekdays
    }
    function localeWeekdaysShort(m) {
      return m === true
        ? shiftWeekdays(this._weekdaysShort, this._week.dow)
        : m
          ? this._weekdaysShort[m.day()]
          : this._weekdaysShort
    }
    function localeWeekdaysMin(m) {
      return m === true
        ? shiftWeekdays(this._weekdaysMin, this._week.dow)
        : m
          ? this._weekdaysMin[m.day()]
          : this._weekdaysMin
    }
    function handleStrictParse$1(weekdayName, format, strict) {
      var i,
        ii,
        mom,
        llc = weekdayName.toLocaleLowerCase()
      if (!this._weekdaysParse) {
        this._weekdaysParse = []
        this._shortWeekdaysParse = []
        this._minWeekdaysParse = []
        for (i = 0; i < 7; ++i) {
          mom = createUTC([2e3, 1]).day(i)
          this._minWeekdaysParse[i] = this.weekdaysMin(
            mom,
            ''
          ).toLocaleLowerCase()
          this._shortWeekdaysParse[i] = this.weekdaysShort(
            mom,
            ''
          ).toLocaleLowerCase()
          this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase()
        }
      }
      if (strict) {
        if (format === 'dddd') {
          ii = indexOf.call(this._weekdaysParse, llc)
          return ii !== -1 ? ii : null
        } else if (format === 'ddd') {
          ii = indexOf.call(this._shortWeekdaysParse, llc)
          return ii !== -1 ? ii : null
        } else {
          ii = indexOf.call(this._minWeekdaysParse, llc)
          return ii !== -1 ? ii : null
        }
      } else {
        if (format === 'dddd') {
          ii = indexOf.call(this._weekdaysParse, llc)
          if (ii !== -1) {
            return ii
          }
          ii = indexOf.call(this._shortWeekdaysParse, llc)
          if (ii !== -1) {
            return ii
          }
          ii = indexOf.call(this._minWeekdaysParse, llc)
          return ii !== -1 ? ii : null
        } else if (format === 'ddd') {
          ii = indexOf.call(this._shortWeekdaysParse, llc)
          if (ii !== -1) {
            return ii
          }
          ii = indexOf.call(this._weekdaysParse, llc)
          if (ii !== -1) {
            return ii
          }
          ii = indexOf.call(this._minWeekdaysParse, llc)
          return ii !== -1 ? ii : null
        } else {
          ii = indexOf.call(this._minWeekdaysParse, llc)
          if (ii !== -1) {
            return ii
          }
          ii = indexOf.call(this._weekdaysParse, llc)
          if (ii !== -1) {
            return ii
          }
          ii = indexOf.call(this._shortWeekdaysParse, llc)
          return ii !== -1 ? ii : null
        }
      }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
      var i, mom, regex
      if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict)
      }
      if (!this._weekdaysParse) {
        this._weekdaysParse = []
        this._minWeekdaysParse = []
        this._shortWeekdaysParse = []
        this._fullWeekdaysParse = []
      }
      for (i = 0; i < 7; i++) {
        mom = createUTC([2e3, 1]).day(i)
        if (strict && !this._fullWeekdaysParse[i]) {
          this._fullWeekdaysParse[i] = new RegExp(
            '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
            'i'
          )
          this._shortWeekdaysParse[i] = new RegExp(
            '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
            'i'
          )
          this._minWeekdaysParse[i] = new RegExp(
            '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
            'i'
          )
        }
        if (!this._weekdaysParse[i]) {
          regex =
            '^' +
            this.weekdays(mom, '') +
            '|^' +
            this.weekdaysShort(mom, '') +
            '|^' +
            this.weekdaysMin(mom, '')
          this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i')
        }
        if (
          strict &&
          format === 'dddd' &&
          this._fullWeekdaysParse[i].test(weekdayName)
        ) {
          return i
        } else if (
          strict &&
          format === 'ddd' &&
          this._shortWeekdaysParse[i].test(weekdayName)
        ) {
          return i
        } else if (
          strict &&
          format === 'dd' &&
          this._minWeekdaysParse[i].test(weekdayName)
        ) {
          return i
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
          return i
        }
      }
    }
    function getSetDayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN
      }
      var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay()
      if (input != null) {
        input = parseWeekday(input, this.localeData())
        return this.add(input - day, 'd')
      } else {
        return day
      }
    }
    function getSetLocaleDayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN
      }
      var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7
      return input == null ? weekday : this.add(input - weekday, 'd')
    }
    function getSetISODayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN
      }
      if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData())
        return this.day(this.day() % 7 ? weekday : weekday - 7)
      } else {
        return this.day() || 7
      }
    }
    function weekdaysRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this)
        }
        if (isStrict) {
          return this._weekdaysStrictRegex
        } else {
          return this._weekdaysRegex
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          this._weekdaysRegex = defaultWeekdaysRegex
        }
        return this._weekdaysStrictRegex && isStrict
          ? this._weekdaysStrictRegex
          : this._weekdaysRegex
      }
    }
    function weekdaysShortRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this)
        }
        if (isStrict) {
          return this._weekdaysShortStrictRegex
        } else {
          return this._weekdaysShortRegex
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
          this._weekdaysShortRegex = defaultWeekdaysShortRegex
        }
        return this._weekdaysShortStrictRegex && isStrict
          ? this._weekdaysShortStrictRegex
          : this._weekdaysShortRegex
      }
    }
    function weekdaysMinRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this)
        }
        if (isStrict) {
          return this._weekdaysMinStrictRegex
        } else {
          return this._weekdaysMinRegex
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
          this._weekdaysMinRegex = defaultWeekdaysMinRegex
        }
        return this._weekdaysMinStrictRegex && isStrict
          ? this._weekdaysMinStrictRegex
          : this._weekdaysMinRegex
      }
    }
    function computeWeekdaysParse() {
      function cmpLenRev(a, b) {
        return b.length - a.length
      }
      var minPieces = [],
        shortPieces = [],
        longPieces = [],
        mixedPieces = [],
        i,
        mom,
        minp,
        shortp,
        longp
      for (i = 0; i < 7; i++) {
        mom = createUTC([2e3, 1]).day(i)
        minp = regexEscape(this.weekdaysMin(mom, ''))
        shortp = regexEscape(this.weekdaysShort(mom, ''))
        longp = regexEscape(this.weekdays(mom, ''))
        minPieces.push(minp)
        shortPieces.push(shortp)
        longPieces.push(longp)
        mixedPieces.push(minp)
        mixedPieces.push(shortp)
        mixedPieces.push(longp)
      }
      minPieces.sort(cmpLenRev)
      shortPieces.sort(cmpLenRev)
      longPieces.sort(cmpLenRev)
      mixedPieces.sort(cmpLenRev)
      this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i')
      this._weekdaysShortRegex = this._weekdaysRegex
      this._weekdaysMinRegex = this._weekdaysRegex
      this._weekdaysStrictRegex = new RegExp(
        '^(' + longPieces.join('|') + ')',
        'i'
      )
      this._weekdaysShortStrictRegex = new RegExp(
        '^(' + shortPieces.join('|') + ')',
        'i'
      )
      this._weekdaysMinStrictRegex = new RegExp(
        '^(' + minPieces.join('|') + ')',
        'i'
      )
    }
    function hFormat() {
      return this.hours() % 12 || 12
    }
    function kFormat() {
      return this.hours() || 24
    }
    addFormatToken('H', ['HH', 2], 0, 'hour')
    addFormatToken('h', ['hh', 2], 0, hFormat)
    addFormatToken('k', ['kk', 2], 0, kFormat)
    addFormatToken('hmm', 0, 0, function () {
      return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2)
    })
    addFormatToken('hmmss', 0, 0, function () {
      return (
        '' +
        hFormat.apply(this) +
        zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2)
      )
    })
    addFormatToken('Hmm', 0, 0, function () {
      return '' + this.hours() + zeroFill(this.minutes(), 2)
    })
    addFormatToken('Hmmss', 0, 0, function () {
      return (
        '' +
        this.hours() +
        zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2)
      )
    })
    function meridiem(token, lowercase) {
      addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(
          this.hours(),
          this.minutes(),
          lowercase
        )
      })
    }
    meridiem('a', true)
    meridiem('A', false)
    addUnitAlias('hour', 'h')
    addUnitPriority('hour', 13)
    function matchMeridiem(isStrict, locale) {
      return locale._meridiemParse
    }
    addRegexToken('a', matchMeridiem)
    addRegexToken('A', matchMeridiem)
    addRegexToken('H', match1to2)
    addRegexToken('h', match1to2)
    addRegexToken('k', match1to2)
    addRegexToken('HH', match1to2, match2)
    addRegexToken('hh', match1to2, match2)
    addRegexToken('kk', match1to2, match2)
    addRegexToken('hmm', match3to4)
    addRegexToken('hmmss', match5to6)
    addRegexToken('Hmm', match3to4)
    addRegexToken('Hmmss', match5to6)
    addParseToken(['H', 'HH'], HOUR)
    addParseToken(['k', 'kk'], function (input, array, config) {
      var kInput = toInt(input)
      array[HOUR] = kInput === 24 ? 0 : kInput
    })
    addParseToken(['a', 'A'], function (input, array, config) {
      config._isPm = config._locale.isPM(input)
      config._meridiem = input
    })
    addParseToken(['h', 'hh'], function (input, array, config) {
      array[HOUR] = toInt(input)
      getParsingFlags(config).bigHour = true
    })
    addParseToken('hmm', function (input, array, config) {
      var pos = input.length - 2
      array[HOUR] = toInt(input.substr(0, pos))
      array[MINUTE] = toInt(input.substr(pos))
      getParsingFlags(config).bigHour = true
    })
    addParseToken('hmmss', function (input, array, config) {
      var pos1 = input.length - 4,
        pos2 = input.length - 2
      array[HOUR] = toInt(input.substr(0, pos1))
      array[MINUTE] = toInt(input.substr(pos1, 2))
      array[SECOND] = toInt(input.substr(pos2))
      getParsingFlags(config).bigHour = true
    })
    addParseToken('Hmm', function (input, array, config) {
      var pos = input.length - 2
      array[HOUR] = toInt(input.substr(0, pos))
      array[MINUTE] = toInt(input.substr(pos))
    })
    addParseToken('Hmmss', function (input, array, config) {
      var pos1 = input.length - 4,
        pos2 = input.length - 2
      array[HOUR] = toInt(input.substr(0, pos1))
      array[MINUTE] = toInt(input.substr(pos1, 2))
      array[SECOND] = toInt(input.substr(pos2))
    })
    function localeIsPM(input) {
      return (input + '').toLowerCase().charAt(0) === 'p'
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
      getSetHour = makeGetSet('Hours', true)
    function localeMeridiem(hours, minutes, isLower) {
      if (hours > 11) {
        return isLower ? 'pm' : 'PM'
      } else {
        return isLower ? 'am' : 'AM'
      }
    }
    var baseConfig = {
      calendar: defaultCalendar,
      longDateFormat: defaultLongDateFormat,
      invalidDate: defaultInvalidDate,
      ordinal: defaultOrdinal,
      dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
      relativeTime: defaultRelativeTime,
      months: defaultLocaleMonths,
      monthsShort: defaultLocaleMonthsShort,
      week: defaultLocaleWeek,
      weekdays: defaultLocaleWeekdays,
      weekdaysMin: defaultLocaleWeekdaysMin,
      weekdaysShort: defaultLocaleWeekdaysShort,
      meridiemParse: defaultLocaleMeridiemParse,
    }
    var locales = {},
      localeFamilies = {},
      globalLocale
    function commonPrefix(arr1, arr2) {
      var i,
        minl = Math.min(arr1.length, arr2.length)
      for (i = 0; i < minl; i += 1) {
        if (arr1[i] !== arr2[i]) {
          return i
        }
      }
      return minl
    }
    function normalizeLocale(key) {
      return key ? key.toLowerCase().replace('_', '-') : key
    }
    function chooseLocale(names) {
      var i = 0,
        j,
        next,
        locale,
        split
      while (i < names.length) {
        split = normalizeLocale(names[i]).split('-')
        j = split.length
        next = normalizeLocale(names[i + 1])
        next = next ? next.split('-') : null
        while (j > 0) {
          locale = loadLocale(split.slice(0, j).join('-'))
          if (locale) {
            return locale
          }
          if (next && next.length >= j && commonPrefix(split, next) >= j - 1) {
            break
          }
          j--
        }
        i++
      }
      return globalLocale
    }
    function loadLocale(name) {
      var oldLocale = null,
        aliasedRequire
      if (
        locales[name] === undefined &&
        'object' !== 'undefined' &&
        module &&
        module.exports
      ) {
        try {
          oldLocale = globalLocale._abbr
          aliasedRequire = commonjsRequire
          aliasedRequire('./locale/' + name)
          getSetGlobalLocale(oldLocale)
        } catch (e) {
          locales[name] = null
        }
      }
      return locales[name]
    }
    function getSetGlobalLocale(key, values) {
      var data
      if (key) {
        if (isUndefined(values)) {
          data = getLocale(key)
        } else {
          data = defineLocale(key, values)
        }
        if (data) {
          globalLocale = data
        } else {
          if (typeof console !== 'undefined' && console.warn) {
            console.warn(
              'Locale ' + key + ' not found. Did you forget to load it?'
            )
          }
        }
      }
      return globalLocale._abbr
    }
    function defineLocale(name, config) {
      if (config !== null) {
        var locale,
          parentConfig = baseConfig
        config.abbr = name
        if (locales[name] != null) {
          deprecateSimple(
            'defineLocaleOverride',
            'use moment.updateLocale(localeName, config) to change ' +
              'an existing locale. moment.defineLocale(localeName, ' +
              'config) should only be used for creating a new locale ' +
              'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
          )
          parentConfig = locales[name]._config
        } else if (config.parentLocale != null) {
          if (locales[config.parentLocale] != null) {
            parentConfig = locales[config.parentLocale]._config
          } else {
            locale = loadLocale(config.parentLocale)
            if (locale != null) {
              parentConfig = locale._config
            } else {
              if (!localeFamilies[config.parentLocale]) {
                localeFamilies[config.parentLocale] = []
              }
              localeFamilies[config.parentLocale].push({
                name: name,
                config: config,
              })
              return null
            }
          }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config))
        if (localeFamilies[name]) {
          localeFamilies[name].forEach(function (x) {
            defineLocale(x.name, x.config)
          })
        }
        getSetGlobalLocale(name)
        return locales[name]
      } else {
        delete locales[name]
        return null
      }
    }
    function updateLocale(name, config) {
      if (config != null) {
        var locale,
          tmpLocale,
          parentConfig = baseConfig
        if (locales[name] != null && locales[name].parentLocale != null) {
          locales[name].set(mergeConfigs(locales[name]._config, config))
        } else {
          tmpLocale = loadLocale(name)
          if (tmpLocale != null) {
            parentConfig = tmpLocale._config
          }
          config = mergeConfigs(parentConfig, config)
          if (tmpLocale == null) {
            config.abbr = name
          }
          locale = new Locale(config)
          locale.parentLocale = locales[name]
          locales[name] = locale
        }
        getSetGlobalLocale(name)
      } else {
        if (locales[name] != null) {
          if (locales[name].parentLocale != null) {
            locales[name] = locales[name].parentLocale
            if (name === getSetGlobalLocale()) {
              getSetGlobalLocale(name)
            }
          } else if (locales[name] != null) {
            delete locales[name]
          }
        }
      }
      return locales[name]
    }
    function getLocale(key) {
      var locale
      if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr
      }
      if (!key) {
        return globalLocale
      }
      if (!isArray(key)) {
        locale = loadLocale(key)
        if (locale) {
          return locale
        }
        key = [key]
      }
      return chooseLocale(key)
    }
    function listLocales() {
      return keys(locales)
    }
    function checkOverflow(m) {
      var overflow,
        a = m._a
      if (a && getParsingFlags(m).overflow === -2) {
        overflow =
          a[MONTH] < 0 || a[MONTH] > 11
            ? MONTH
            : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
              ? DATE
              : a[HOUR] < 0 ||
                  a[HOUR] > 24 ||
                  (a[HOUR] === 24 &&
                    (a[MINUTE] !== 0 ||
                      a[SECOND] !== 0 ||
                      a[MILLISECOND] !== 0))
                ? HOUR
                : a[MINUTE] < 0 || a[MINUTE] > 59
                  ? MINUTE
                  : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                      ? MILLISECOND
                      : -1
        if (
          getParsingFlags(m)._overflowDayOfYear &&
          (overflow < YEAR || overflow > DATE)
        ) {
          overflow = DATE
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
          overflow = WEEK
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
          overflow = WEEKDAY
        }
        getParsingFlags(m).overflow = overflow
      }
      return m
    }
    var extendedIsoRegex =
        /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
      basicIsoRegex =
        /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
      tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
      isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/],
        ['YYYYMM', /\d{6}/, false],
        ['YYYY', /\d{4}/, false],
      ],
      isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/],
      ],
      aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
      rfc2822 =
        /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
      obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60,
      }
    function configFromISO(config) {
      var i,
        l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime,
        dateFormat,
        timeFormat,
        tzFormat
      if (match) {
        getParsingFlags(config).iso = true
        for (i = 0, l = isoDates.length; i < l; i++) {
          if (isoDates[i][1].exec(match[1])) {
            dateFormat = isoDates[i][0]
            allowTime = isoDates[i][2] !== false
            break
          }
        }
        if (dateFormat == null) {
          config._isValid = false
          return
        }
        if (match[3]) {
          for (i = 0, l = isoTimes.length; i < l; i++) {
            if (isoTimes[i][1].exec(match[3])) {
              timeFormat = (match[2] || ' ') + isoTimes[i][0]
              break
            }
          }
          if (timeFormat == null) {
            config._isValid = false
            return
          }
        }
        if (!allowTime && timeFormat != null) {
          config._isValid = false
          return
        }
        if (match[4]) {
          if (tzRegex.exec(match[4])) {
            tzFormat = 'Z'
          } else {
            config._isValid = false
            return
          }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '')
        configFromStringAndFormat(config)
      } else {
        config._isValid = false
      }
    }
    function extractFromRFC2822Strings(
      yearStr,
      monthStr,
      dayStr,
      hourStr,
      minuteStr,
      secondStr
    ) {
      var result = [
        untruncateYear(yearStr),
        defaultLocaleMonthsShort.indexOf(monthStr),
        parseInt(dayStr, 10),
        parseInt(hourStr, 10),
        parseInt(minuteStr, 10),
      ]
      if (secondStr) {
        result.push(parseInt(secondStr, 10))
      }
      return result
    }
    function untruncateYear(yearStr) {
      var year = parseInt(yearStr, 10)
      if (year <= 49) {
        return 2e3 + year
      } else if (year <= 999) {
        return 1900 + year
      }
      return year
    }
    function preprocessRFC2822(s) {
      return s
        .replace(/\([^)]*\)|[\n\t]/g, ' ')
        .replace(/(\s\s+)/g, ' ')
        .replace(/^\s\s*/, '')
        .replace(/\s\s*$/, '')
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
      if (weekdayStr) {
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
          weekdayActual = new Date(
            parsedInput[0],
            parsedInput[1],
            parsedInput[2]
          ).getDay()
        if (weekdayProvided !== weekdayActual) {
          getParsingFlags(config).weekdayMismatch = true
          config._isValid = false
          return false
        }
      }
      return true
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
      if (obsOffset) {
        return obsOffsets[obsOffset]
      } else if (militaryOffset) {
        return 0
      } else {
        var hm = parseInt(numOffset, 10),
          m = hm % 100,
          h = (hm - m) / 100
        return h * 60 + m
      }
    }
    function configFromRFC2822(config) {
      var match = rfc2822.exec(preprocessRFC2822(config._i)),
        parsedArray
      if (match) {
        parsedArray = extractFromRFC2822Strings(
          match[4],
          match[3],
          match[2],
          match[5],
          match[6],
          match[7]
        )
        if (!checkWeekday(match[1], parsedArray, config)) {
          return
        }
        config._a = parsedArray
        config._tzm = calculateOffset(match[8], match[9], match[10])
        config._d = createUTCDate.apply(null, config._a)
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm)
        getParsingFlags(config).rfc2822 = true
      } else {
        config._isValid = false
      }
    }
    function configFromString(config) {
      var matched = aspNetJsonRegex.exec(config._i)
      if (matched !== null) {
        config._d = new Date(+matched[1])
        return
      }
      configFromISO(config)
      if (config._isValid === false) {
        delete config._isValid
      } else {
        return
      }
      configFromRFC2822(config)
      if (config._isValid === false) {
        delete config._isValid
      } else {
        return
      }
      if (config._strict) {
        config._isValid = false
      } else {
        hooks.createFromInputFallback(config)
      }
    }
    hooks.createFromInputFallback = deprecate(
      'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
      function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''))
      }
    )
    function defaults(a, b, c) {
      if (a != null) {
        return a
      }
      if (b != null) {
        return b
      }
      return c
    }
    function currentDateArray(config) {
      var nowValue = new Date(hooks.now())
      if (config._useUTC) {
        return [
          nowValue.getUTCFullYear(),
          nowValue.getUTCMonth(),
          nowValue.getUTCDate(),
        ]
      }
      return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()]
    }
    function configFromArray(config) {
      var i,
        date,
        input = [],
        currentDate,
        expectedWeekday,
        yearToUse
      if (config._d) {
        return
      }
      currentDate = currentDateArray(config)
      if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config)
      }
      if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR])
        if (
          config._dayOfYear > daysInYear(yearToUse) ||
          config._dayOfYear === 0
        ) {
          getParsingFlags(config)._overflowDayOfYear = true
        }
        date = createUTCDate(yearToUse, 0, config._dayOfYear)
        config._a[MONTH] = date.getUTCMonth()
        config._a[DATE] = date.getUTCDate()
      }
      for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i]
      }
      for (; i < 7; i++) {
        config._a[i] = input[i] =
          config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i]
      }
      if (
        config._a[HOUR] === 24 &&
        config._a[MINUTE] === 0 &&
        config._a[SECOND] === 0 &&
        config._a[MILLISECOND] === 0
      ) {
        config._nextDay = true
        config._a[HOUR] = 0
      }
      config._d = (config._useUTC ? createUTCDate : createDate).apply(
        null,
        input
      )
      expectedWeekday = config._useUTC
        ? config._d.getUTCDay()
        : config._d.getDay()
      if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm)
      }
      if (config._nextDay) {
        config._a[HOUR] = 24
      }
      if (
        config._w &&
        typeof config._w.d !== 'undefined' &&
        config._w.d !== expectedWeekday
      ) {
        getParsingFlags(config).weekdayMismatch = true
      }
    }
    function dayOfYearFromWeekInfo(config) {
      var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek
      w = config._w
      if (w.GG != null || w.W != null || w.E != null) {
        dow = 1
        doy = 4
        weekYear = defaults(
          w.GG,
          config._a[YEAR],
          weekOfYear(createLocal(), 1, 4).year
        )
        week = defaults(w.W, 1)
        weekday = defaults(w.E, 1)
        if (weekday < 1 || weekday > 7) {
          weekdayOverflow = true
        }
      } else {
        dow = config._locale._week.dow
        doy = config._locale._week.doy
        curWeek = weekOfYear(createLocal(), dow, doy)
        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year)
        week = defaults(w.w, curWeek.week)
        if (w.d != null) {
          weekday = w.d
          if (weekday < 0 || weekday > 6) {
            weekdayOverflow = true
          }
        } else if (w.e != null) {
          weekday = w.e + dow
          if (w.e < 0 || w.e > 6) {
            weekdayOverflow = true
          }
        } else {
          weekday = dow
        }
      }
      if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true
      } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true
      } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy)
        config._a[YEAR] = temp.year
        config._dayOfYear = temp.dayOfYear
      }
    }
    hooks.ISO_8601 = function () {}
    hooks.RFC_2822 = function () {}
    function configFromStringAndFormat(config) {
      if (config._f === hooks.ISO_8601) {
        configFromISO(config)
        return
      }
      if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config)
        return
      }
      config._a = []
      getParsingFlags(config).empty = true
      var string = '' + config._i,
        i,
        parsedInput,
        tokens,
        token,
        skipped,
        stringLength = string.length,
        totalParsedInputLength = 0,
        era
      tokens =
        expandFormat(config._f, config._locale).match(formattingTokens) || []
      for (i = 0; i < tokens.length; i++) {
        token = tokens[i]
        parsedInput = (string.match(getParseRegexForToken(token, config)) ||
          [])[0]
        if (parsedInput) {
          skipped = string.substr(0, string.indexOf(parsedInput))
          if (skipped.length > 0) {
            getParsingFlags(config).unusedInput.push(skipped)
          }
          string = string.slice(
            string.indexOf(parsedInput) + parsedInput.length
          )
          totalParsedInputLength += parsedInput.length
        }
        if (formatTokenFunctions[token]) {
          if (parsedInput) {
            getParsingFlags(config).empty = false
          } else {
            getParsingFlags(config).unusedTokens.push(token)
          }
          addTimeToArrayFromToken(token, parsedInput, config)
        } else if (config._strict && !parsedInput) {
          getParsingFlags(config).unusedTokens.push(token)
        }
      }
      getParsingFlags(config).charsLeftOver =
        stringLength - totalParsedInputLength
      if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string)
      }
      if (
        config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0
      ) {
        getParsingFlags(config).bigHour = undefined
      }
      getParsingFlags(config).parsedDateParts = config._a.slice(0)
      getParsingFlags(config).meridiem = config._meridiem
      config._a[HOUR] = meridiemFixWrap(
        config._locale,
        config._a[HOUR],
        config._meridiem
      )
      era = getParsingFlags(config).era
      if (era !== null) {
        config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR])
      }
      configFromArray(config)
      checkOverflow(config)
    }
    function meridiemFixWrap(locale, hour, meridiem) {
      var isPm
      if (meridiem == null) {
        return hour
      }
      if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem)
      } else if (locale.isPM != null) {
        isPm = locale.isPM(meridiem)
        if (isPm && hour < 12) {
          hour += 12
        }
        if (!isPm && hour === 12) {
          hour = 0
        }
        return hour
      } else {
        return hour
      }
    }
    function configFromStringAndArray(config) {
      var tempConfig,
        bestMoment,
        scoreToBeat,
        i,
        currentScore,
        validFormatFound,
        bestFormatIsValid = false
      if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true
        config._d = new Date(NaN)
        return
      }
      for (i = 0; i < config._f.length; i++) {
        currentScore = 0
        validFormatFound = false
        tempConfig = copyConfig({}, config)
        if (config._useUTC != null) {
          tempConfig._useUTC = config._useUTC
        }
        tempConfig._f = config._f[i]
        configFromStringAndFormat(tempConfig)
        if (isValid(tempConfig)) {
          validFormatFound = true
        }
        currentScore += getParsingFlags(tempConfig).charsLeftOver
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10
        getParsingFlags(tempConfig).score = currentScore
        if (!bestFormatIsValid) {
          if (
            scoreToBeat == null ||
            currentScore < scoreToBeat ||
            validFormatFound
          ) {
            scoreToBeat = currentScore
            bestMoment = tempConfig
            if (validFormatFound) {
              bestFormatIsValid = true
            }
          }
        } else {
          if (currentScore < scoreToBeat) {
            scoreToBeat = currentScore
            bestMoment = tempConfig
          }
        }
      }
      extend(config, bestMoment || tempConfig)
    }
    function configFromObject(config) {
      if (config._d) {
        return
      }
      var i = normalizeObjectUnits(config._i),
        dayOrDate = i.day === undefined ? i.date : i.day
      config._a = map(
        [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
        function (obj) {
          return obj && parseInt(obj, 10)
        }
      )
      configFromArray(config)
    }
    function createFromConfig(config) {
      var res = new Moment(checkOverflow(prepareConfig(config)))
      if (res._nextDay) {
        res.add(1, 'd')
        res._nextDay = undefined
      }
      return res
    }
    function prepareConfig(config) {
      var input = config._i,
        format = config._f
      config._locale = config._locale || getLocale(config._l)
      if (input === null || (format === undefined && input === '')) {
        return createInvalid({
          nullInput: true,
        })
      }
      if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input)
      }
      if (isMoment(input)) {
        return new Moment(checkOverflow(input))
      } else if (isDate(input)) {
        config._d = input
      } else if (isArray(format)) {
        configFromStringAndArray(config)
      } else if (format) {
        configFromStringAndFormat(config)
      } else {
        configFromInput(config)
      }
      if (!isValid(config)) {
        config._d = null
      }
      return config
    }
    function configFromInput(config) {
      var input = config._i
      if (isUndefined(input)) {
        config._d = new Date(hooks.now())
      } else if (isDate(input)) {
        config._d = new Date(input.valueOf())
      } else if (typeof input === 'string') {
        configFromString(config)
      } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
          return parseInt(obj, 10)
        })
        configFromArray(config)
      } else if (isObject(input)) {
        configFromObject(config)
      } else if (isNumber(input)) {
        config._d = new Date(input)
      } else {
        hooks.createFromInputFallback(config)
      }
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
      var c = {}
      if (format === true || format === false) {
        strict = format
        format = undefined
      }
      if (locale === true || locale === false) {
        strict = locale
        locale = undefined
      }
      if (
        (isObject(input) && isObjectEmpty(input)) ||
        (isArray(input) && input.length === 0)
      ) {
        input = undefined
      }
      c._isAMomentObject = true
      c._useUTC = c._isUTC = isUTC
      c._l = locale
      c._i = input
      c._f = format
      c._strict = strict
      return createFromConfig(c)
    }
    function createLocal(input, format, locale, strict) {
      return createLocalOrUTC(input, format, locale, strict, false)
    }
    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
          var other = createLocal.apply(null, arguments)
          if (this.isValid() && other.isValid()) {
            return other < this ? this : other
          } else {
            return createInvalid()
          }
        }
      ),
      prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
          var other = createLocal.apply(null, arguments)
          if (this.isValid() && other.isValid()) {
            return other > this ? this : other
          } else {
            return createInvalid()
          }
        }
      )
    function pickBy(fn, moments) {
      var res, i
      if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0]
      }
      if (!moments.length) {
        return createLocal()
      }
      res = moments[0]
      for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
          res = moments[i]
        }
      }
      return res
    }
    function min() {
      var args = [].slice.call(arguments, 0)
      return pickBy('isBefore', args)
    }
    function max() {
      var args = [].slice.call(arguments, 0)
      return pickBy('isAfter', args)
    }
    var now = function () {
      return Date.now ? Date.now() : +new Date()
    }
    var ordering = [
      'year',
      'quarter',
      'month',
      'week',
      'day',
      'hour',
      'minute',
      'second',
      'millisecond',
    ]
    function isDurationValid(m) {
      var key,
        unitHasDecimal = false,
        i
      for (key in m) {
        if (
          hasOwnProp(m, key) &&
          !(
            indexOf.call(ordering, key) !== -1 &&
            (m[key] == null || !isNaN(m[key]))
          )
        ) {
          return false
        }
      }
      for (i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
          if (unitHasDecimal) {
            return false
          }
          if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
            unitHasDecimal = true
          }
        }
      }
      return true
    }
    function isValid$1() {
      return this._isValid
    }
    function createInvalid$1() {
      return createDuration(NaN)
    }
    function Duration(duration) {
      var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0
      this._isValid = isDurationValid(normalizedInput)
      this._milliseconds =
        +milliseconds + seconds * 1e3 + minutes * 6e4 + hours * 1e3 * 60 * 60
      this._days = +days + weeks * 7
      this._months = +months + quarters * 3 + years * 12
      this._data = {}
      this._locale = getLocale()
      this._bubble()
    }
    function isDuration(obj) {
      return obj instanceof Duration
    }
    function absRound(number) {
      if (number < 0) {
        return Math.round(-1 * number) * -1
      } else {
        return Math.round(number)
      }
    }
    function compareArrays(array1, array2, dontConvert) {
      var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i
      for (i = 0; i < len; i++) {
        if (
          (dontConvert && array1[i] !== array2[i]) ||
          (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
        ) {
          diffs++
        }
      }
      return diffs + lengthDiff
    }
    function offset(token, separator) {
      addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset(),
          sign = '+'
        if (offset < 0) {
          offset = -offset
          sign = '-'
        }
        return (
          sign +
          zeroFill(~~(offset / 60), 2) +
          separator +
          zeroFill(~~offset % 60, 2)
        )
      })
    }
    offset('Z', ':')
    offset('ZZ', '')
    addRegexToken('Z', matchShortOffset)
    addRegexToken('ZZ', matchShortOffset)
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
      config._useUTC = true
      config._tzm = offsetFromString(matchShortOffset, input)
    })
    var chunkOffset = /([\+\-]|\d\d)/gi
    function offsetFromString(matcher, string) {
      var matches = (string || '').match(matcher),
        chunk,
        parts,
        minutes
      if (matches === null) {
        return null
      }
      chunk = matches[matches.length - 1] || []
      parts = (chunk + '').match(chunkOffset) || ['-', 0, 0]
      minutes = +(parts[1] * 60) + toInt(parts[2])
      return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes
    }
    function cloneWithOffset(input, model) {
      var res, diff
      if (model._isUTC) {
        res = model.clone()
        diff =
          (isMoment(input) || isDate(input)
            ? input.valueOf()
            : createLocal(input).valueOf()) - res.valueOf()
        res._d.setTime(res._d.valueOf() + diff)
        hooks.updateOffset(res, false)
        return res
      } else {
        return createLocal(input).local()
      }
    }
    function getDateOffset(m) {
      return -Math.round(m._d.getTimezoneOffset())
    }
    hooks.updateOffset = function () {}
    function getSetOffset(input, keepLocalTime, keepMinutes) {
      var offset = this._offset || 0,
        localAdjust
      if (!this.isValid()) {
        return input != null ? this : NaN
      }
      if (input != null) {
        if (typeof input === 'string') {
          input = offsetFromString(matchShortOffset, input)
          if (input === null) {
            return this
          }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
          input = input * 60
        }
        if (!this._isUTC && keepLocalTime) {
          localAdjust = getDateOffset(this)
        }
        this._offset = input
        this._isUTC = true
        if (localAdjust != null) {
          this.add(localAdjust, 'm')
        }
        if (offset !== input) {
          if (!keepLocalTime || this._changeInProgress) {
            addSubtract(this, createDuration(input - offset, 'm'), 1, false)
          } else if (!this._changeInProgress) {
            this._changeInProgress = true
            hooks.updateOffset(this, true)
            this._changeInProgress = null
          }
        }
        return this
      } else {
        return this._isUTC ? offset : getDateOffset(this)
      }
    }
    function getSetZone(input, keepLocalTime) {
      if (input != null) {
        if (typeof input !== 'string') {
          input = -input
        }
        this.utcOffset(input, keepLocalTime)
        return this
      } else {
        return -this.utcOffset()
      }
    }
    function setOffsetToUTC(keepLocalTime) {
      return this.utcOffset(0, keepLocalTime)
    }
    function setOffsetToLocal(keepLocalTime) {
      if (this._isUTC) {
        this.utcOffset(0, keepLocalTime)
        this._isUTC = false
        if (keepLocalTime) {
          this.subtract(getDateOffset(this), 'm')
        }
      }
      return this
    }
    function setOffsetToParsedOffset() {
      if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true)
      } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i)
        if (tZone != null) {
          this.utcOffset(tZone)
        } else {
          this.utcOffset(0, true)
        }
      }
      return this
    }
    function hasAlignedHourOffset(input) {
      if (!this.isValid()) {
        return false
      }
      input = input ? createLocal(input).utcOffset() : 0
      return (this.utcOffset() - input) % 60 === 0
    }
    function isDaylightSavingTime() {
      return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
      )
    }
    function isDaylightSavingTimeShifted() {
      if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted
      }
      var c = {},
        other
      copyConfig(c, this)
      c = prepareConfig(c)
      if (c._a) {
        other = c._isUTC ? createUTC(c._a) : createLocal(c._a)
        this._isDSTShifted =
          this.isValid() && compareArrays(c._a, other.toArray()) > 0
      } else {
        this._isDSTShifted = false
      }
      return this._isDSTShifted
    }
    function isLocal() {
      return this.isValid() ? !this._isUTC : false
    }
    function isUtcOffset() {
      return this.isValid() ? this._isUTC : false
    }
    function isUtc() {
      return this.isValid() ? this._isUTC && this._offset === 0 : false
    }
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
      isoRegex =
        /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/
    function createDuration(input, key) {
      var duration = input,
        match = null,
        sign,
        ret,
        diffRes
      if (isDuration(input)) {
        duration = {
          ms: input._milliseconds,
          d: input._days,
          M: input._months,
        }
      } else if (isNumber(input) || !isNaN(+input)) {
        duration = {}
        if (key) {
          duration[key] = +input
        } else {
          duration.milliseconds = +input
        }
      } else if ((match = aspNetRegex.exec(input))) {
        sign = match[1] === '-' ? -1 : 1
        duration = {
          y: 0,
          d: toInt(match[DATE]) * sign,
          h: toInt(match[HOUR]) * sign,
          m: toInt(match[MINUTE]) * sign,
          s: toInt(match[SECOND]) * sign,
          ms: toInt(absRound(match[MILLISECOND] * 1e3)) * sign,
        }
      } else if ((match = isoRegex.exec(input))) {
        sign = match[1] === '-' ? -1 : 1
        duration = {
          y: parseIso(match[2], sign),
          M: parseIso(match[3], sign),
          w: parseIso(match[4], sign),
          d: parseIso(match[5], sign),
          h: parseIso(match[6], sign),
          m: parseIso(match[7], sign),
          s: parseIso(match[8], sign),
        }
      } else if (duration == null) {
        duration = {}
      } else if (
        typeof duration === 'object' &&
        ('from' in duration || 'to' in duration)
      ) {
        diffRes = momentsDifference(
          createLocal(duration.from),
          createLocal(duration.to)
        )
        duration = {}
        duration.ms = diffRes.milliseconds
        duration.M = diffRes.months
      }
      ret = new Duration(duration)
      if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale
      }
      if (isDuration(input) && hasOwnProp(input, '_isValid')) {
        ret._isValid = input._isValid
      }
      return ret
    }
    createDuration.fn = Duration.prototype
    createDuration.invalid = createInvalid$1
    function parseIso(inp, sign) {
      var res = inp && parseFloat(inp.replace(',', '.'))
      return (isNaN(res) ? 0 : res) * sign
    }
    function positiveMomentsDifference(base, other) {
      var res = {}
      res.months =
        other.month() - base.month() + (other.year() - base.year()) * 12
      if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months
      }
      res.milliseconds = +other - +base.clone().add(res.months, 'M')
      return res
    }
    function momentsDifference(base, other) {
      var res
      if (!(base.isValid() && other.isValid())) {
        return {
          milliseconds: 0,
          months: 0,
        }
      }
      other = cloneWithOffset(other, base)
      if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other)
      } else {
        res = positiveMomentsDifference(other, base)
        res.milliseconds = -res.milliseconds
        res.months = -res.months
      }
      return res
    }
    function createAdder(direction, name) {
      return function (val, period) {
        var dur, tmp
        if (period !== null && !isNaN(+period)) {
          deprecateSimple(
            name,
            'moment().' +
              name +
              '(period, number) is deprecated. Please use moment().' +
              name +
              '(number, period). ' +
              'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
          )
          tmp = val
          val = period
          period = tmp
        }
        dur = createDuration(val, period)
        addSubtract(this, dur, direction)
        return this
      }
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
      var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months)
      if (!mom.isValid()) {
        return
      }
      updateOffset = updateOffset == null ? true : updateOffset
      if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding)
      }
      if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding)
      }
      if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding)
      }
      if (updateOffset) {
        hooks.updateOffset(mom, days || months)
      }
    }
    var add = createAdder(1, 'add'),
      subtract = createAdder(-1, 'subtract')
    function isString(input) {
      return typeof input === 'string' || input instanceof String
    }
    function isMomentInput(input) {
      return (
        isMoment(input) ||
        isDate(input) ||
        isString(input) ||
        isNumber(input) ||
        isNumberOrStringArray(input) ||
        isMomentInputObject(input) ||
        input === null ||
        input === undefined
      )
    }
    function isMomentInputObject(input) {
      var objectTest = isObject(input) && !isObjectEmpty(input),
        propertyTest = false,
        properties = [
          'years',
          'year',
          'y',
          'months',
          'month',
          'M',
          'days',
          'day',
          'd',
          'dates',
          'date',
          'D',
          'hours',
          'hour',
          'h',
          'minutes',
          'minute',
          'm',
          'seconds',
          'second',
          's',
          'milliseconds',
          'millisecond',
          'ms',
        ],
        i,
        property
      for (i = 0; i < properties.length; i += 1) {
        property = properties[i]
        propertyTest = propertyTest || hasOwnProp(input, property)
      }
      return objectTest && propertyTest
    }
    function isNumberOrStringArray(input) {
      var arrayTest = isArray(input),
        dataTypeTest = false
      if (arrayTest) {
        dataTypeTest =
          input.filter(function (item) {
            return !isNumber(item) && isString(input)
          }).length === 0
      }
      return arrayTest && dataTypeTest
    }
    function isCalendarSpec(input) {
      var objectTest = isObject(input) && !isObjectEmpty(input),
        propertyTest = false,
        properties = [
          'sameDay',
          'nextDay',
          'lastDay',
          'nextWeek',
          'lastWeek',
          'sameElse',
        ],
        i,
        property
      for (i = 0; i < properties.length; i += 1) {
        property = properties[i]
        propertyTest = propertyTest || hasOwnProp(input, property)
      }
      return objectTest && propertyTest
    }
    function getCalendarFormat(myMoment, now) {
      var diff = myMoment.diff(now, 'days', true)
      return diff < -6
        ? 'sameElse'
        : diff < -1
          ? 'lastWeek'
          : diff < 0
            ? 'lastDay'
            : diff < 1
              ? 'sameDay'
              : diff < 2
                ? 'nextDay'
                : diff < 7
                  ? 'nextWeek'
                  : 'sameElse'
    }
    function calendar$1(time, formats) {
      if (arguments.length === 1) {
        if (!arguments[0]) {
          time = undefined
          formats = undefined
        } else if (isMomentInput(arguments[0])) {
          time = arguments[0]
          formats = undefined
        } else if (isCalendarSpec(arguments[0])) {
          formats = arguments[0]
          time = undefined
        }
      }
      var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse',
        output =
          formats &&
          (isFunction(formats[format])
            ? formats[format].call(this, now)
            : formats[format])
      return this.format(
        output || this.localeData().calendar(format, this, createLocal(now))
      )
    }
    function clone() {
      return new Moment(this)
    }
    function isAfter(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input)
      if (!(this.isValid() && localInput.isValid())) {
        return false
      }
      units = normalizeUnits(units) || 'millisecond'
      if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf()
      } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf()
      }
    }
    function isBefore(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input)
      if (!(this.isValid() && localInput.isValid())) {
        return false
      }
      units = normalizeUnits(units) || 'millisecond'
      if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf()
      } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf()
      }
    }
    function isBetween(from, to, units, inclusivity) {
      var localFrom = isMoment(from) ? from : createLocal(from),
        localTo = isMoment(to) ? to : createLocal(to)
      if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
        return false
      }
      inclusivity = inclusivity || '()'
      return (
        (inclusivity[0] === '('
          ? this.isAfter(localFrom, units)
          : !this.isBefore(localFrom, units)) &&
        (inclusivity[1] === ')'
          ? this.isBefore(localTo, units)
          : !this.isAfter(localTo, units))
      )
    }
    function isSame(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input),
        inputMs
      if (!(this.isValid() && localInput.isValid())) {
        return false
      }
      units = normalizeUnits(units) || 'millisecond'
      if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf()
      } else {
        inputMs = localInput.valueOf()
        return (
          this.clone().startOf(units).valueOf() <= inputMs &&
          inputMs <= this.clone().endOf(units).valueOf()
        )
      }
    }
    function isSameOrAfter(input, units) {
      return this.isSame(input, units) || this.isAfter(input, units)
    }
    function isSameOrBefore(input, units) {
      return this.isSame(input, units) || this.isBefore(input, units)
    }
    function diff(input, units, asFloat) {
      var that, zoneDelta, output
      if (!this.isValid()) {
        return NaN
      }
      that = cloneWithOffset(input, this)
      if (!that.isValid()) {
        return NaN
      }
      zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4
      units = normalizeUnits(units)
      switch (units) {
        case 'year':
          output = monthDiff(this, that) / 12
          break

        case 'month':
          output = monthDiff(this, that)
          break

        case 'quarter':
          output = monthDiff(this, that) / 3
          break

        case 'second':
          output = (this - that) / 1e3
          break

        case 'minute':
          output = (this - that) / 6e4
          break

        case 'hour':
          output = (this - that) / 36e5
          break

        case 'day':
          output = (this - that - zoneDelta) / 864e5
          break

        case 'week':
          output = (this - that - zoneDelta) / 6048e5
          break

        default:
          output = this - that
      }
      return asFloat ? output : absFloor(output)
    }
    function monthDiff(a, b) {
      if (a.date() < b.date()) {
        return -monthDiff(b, a)
      }
      var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2,
        adjust
      if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months')
        adjust = (b - anchor) / (anchor - anchor2)
      } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months')
        adjust = (b - anchor) / (anchor2 - anchor)
      }
      return -(wholeMonthDiff + adjust) || 0
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ'
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]'
    function toString() {
      return this.clone()
        .locale('en')
        .format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ')
    }
    function toISOString(keepOffset) {
      if (!this.isValid()) {
        return null
      }
      var utc = keepOffset !== true,
        m = utc ? this.clone().utc() : this
      if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(
          m,
          utc
            ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
            : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
        )
      }
      if (isFunction(Date.prototype.toISOString)) {
        if (utc) {
          return this.toDate().toISOString()
        } else {
          return new Date(this.valueOf() + this.utcOffset() * 60 * 1e3)
            .toISOString()
            .replace('Z', formatMoment(m, 'Z'))
        }
      }
      return formatMoment(
        m,
        utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
      )
    }
    function inspect() {
      if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)'
      }
      var func = 'moment',
        zone = '',
        prefix,
        year,
        datetime,
        suffix
      if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone'
        zone = 'Z'
      }
      prefix = '[' + func + '("]'
      year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY'
      datetime = '-MM-DD[T]HH:mm:ss.SSS'
      suffix = zone + '[")]'
      return this.format(prefix + year + datetime + suffix)
    }
    function format(inputString) {
      if (!inputString) {
        inputString = this.isUtc()
          ? hooks.defaultFormatUtc
          : hooks.defaultFormat
      }
      var output = formatMoment(this, inputString)
      return this.localeData().postformat(output)
    }
    function from(time, withoutSuffix) {
      if (
        this.isValid() &&
        ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
      ) {
        return createDuration({
          to: this,
          from: time,
        })
          .locale(this.locale())
          .humanize(!withoutSuffix)
      } else {
        return this.localeData().invalidDate()
      }
    }
    function fromNow(withoutSuffix) {
      return this.from(createLocal(), withoutSuffix)
    }
    function to(time, withoutSuffix) {
      if (
        this.isValid() &&
        ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
      ) {
        return createDuration({
          from: this,
          to: time,
        })
          .locale(this.locale())
          .humanize(!withoutSuffix)
      } else {
        return this.localeData().invalidDate()
      }
    }
    function toNow(withoutSuffix) {
      return this.to(createLocal(), withoutSuffix)
    }
    function locale(key) {
      var newLocaleData
      if (key === undefined) {
        return this._locale._abbr
      } else {
        newLocaleData = getLocale(key)
        if (newLocaleData != null) {
          this._locale = newLocaleData
        }
        return this
      }
    }
    var lang = deprecate(
      'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
      function (key) {
        if (key === undefined) {
          return this.localeData()
        } else {
          return this.locale(key)
        }
      }
    )
    function localeData() {
      return this._locale
    }
    var MS_PER_SECOND = 1e3,
      MS_PER_MINUTE = 60 * MS_PER_SECOND,
      MS_PER_HOUR = 60 * MS_PER_MINUTE,
      MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR
    function mod$1(dividend, divisor) {
      return ((dividend % divisor) + divisor) % divisor
    }
    function localStartOfDate(y, m, d) {
      if (y < 100 && y >= 0) {
        return new Date(y + 400, m, d) - MS_PER_400_YEARS
      } else {
        return new Date(y, m, d).valueOf()
      }
    }
    function utcStartOfDate(y, m, d) {
      if (y < 100 && y >= 0) {
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS
      } else {
        return Date.UTC(y, m, d)
      }
    }
    function startOf(units) {
      var time, startOfDate
      units = normalizeUnits(units)
      if (units === undefined || units === 'millisecond' || !this.isValid()) {
        return this
      }
      startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate
      switch (units) {
        case 'year':
          time = startOfDate(this.year(), 0, 1)
          break

        case 'quarter':
          time = startOfDate(this.year(), this.month() - (this.month() % 3), 1)
          break

        case 'month':
          time = startOfDate(this.year(), this.month(), 1)
          break

        case 'week':
          time = startOfDate(
            this.year(),
            this.month(),
            this.date() - this.weekday()
          )
          break

        case 'isoWeek':
          time = startOfDate(
            this.year(),
            this.month(),
            this.date() - (this.isoWeekday() - 1)
          )
          break

        case 'day':
        case 'date':
          time = startOfDate(this.year(), this.month(), this.date())
          break

        case 'hour':
          time = this._d.valueOf()
          time -= mod$1(
            time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
            MS_PER_HOUR
          )
          break

        case 'minute':
          time = this._d.valueOf()
          time -= mod$1(time, MS_PER_MINUTE)
          break

        case 'second':
          time = this._d.valueOf()
          time -= mod$1(time, MS_PER_SECOND)
          break
      }
      this._d.setTime(time)
      hooks.updateOffset(this, true)
      return this
    }
    function endOf(units) {
      var time, startOfDate
      units = normalizeUnits(units)
      if (units === undefined || units === 'millisecond' || !this.isValid()) {
        return this
      }
      startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate
      switch (units) {
        case 'year':
          time = startOfDate(this.year() + 1, 0, 1) - 1
          break

        case 'quarter':
          time =
            startOfDate(this.year(), this.month() - (this.month() % 3) + 3, 1) -
            1
          break

        case 'month':
          time = startOfDate(this.year(), this.month() + 1, 1) - 1
          break

        case 'week':
          time =
            startOfDate(
              this.year(),
              this.month(),
              this.date() - this.weekday() + 7
            ) - 1
          break

        case 'isoWeek':
          time =
            startOfDate(
              this.year(),
              this.month(),
              this.date() - (this.isoWeekday() - 1) + 7
            ) - 1
          break

        case 'day':
        case 'date':
          time = startOfDate(this.year(), this.month(), this.date() + 1) - 1
          break

        case 'hour':
          time = this._d.valueOf()
          time +=
            MS_PER_HOUR -
            mod$1(
              time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
              MS_PER_HOUR
            ) -
            1
          break

        case 'minute':
          time = this._d.valueOf()
          time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1
          break

        case 'second':
          time = this._d.valueOf()
          time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1
          break
      }
      this._d.setTime(time)
      hooks.updateOffset(this, true)
      return this
    }
    function valueOf() {
      return this._d.valueOf() - (this._offset || 0) * 6e4
    }
    function unix() {
      return Math.floor(this.valueOf() / 1e3)
    }
    function toDate() {
      return new Date(this.valueOf())
    }
    function toArray() {
      var m = this
      return [
        m.year(),
        m.month(),
        m.date(),
        m.hour(),
        m.minute(),
        m.second(),
        m.millisecond(),
      ]
    }
    function toObject() {
      var m = this
      return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds(),
      }
    }
    function toJSON() {
      return this.isValid() ? this.toISOString() : null
    }
    function isValid$2() {
      return isValid(this)
    }
    function parsingFlags() {
      return extend({}, getParsingFlags(this))
    }
    function invalidAt() {
      return getParsingFlags(this).overflow
    }
    function creationData() {
      return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict,
      }
    }
    addFormatToken('N', 0, 0, 'eraAbbr')
    addFormatToken('NN', 0, 0, 'eraAbbr')
    addFormatToken('NNN', 0, 0, 'eraAbbr')
    addFormatToken('NNNN', 0, 0, 'eraName')
    addFormatToken('NNNNN', 0, 0, 'eraNarrow')
    addFormatToken('y', ['y', 1], 'yo', 'eraYear')
    addFormatToken('y', ['yy', 2], 0, 'eraYear')
    addFormatToken('y', ['yyy', 3], 0, 'eraYear')
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear')
    addRegexToken('N', matchEraAbbr)
    addRegexToken('NN', matchEraAbbr)
    addRegexToken('NNN', matchEraAbbr)
    addRegexToken('NNNN', matchEraName)
    addRegexToken('NNNNN', matchEraNarrow)
    addParseToken(
      ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
      function (input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict)
        if (era) {
          getParsingFlags(config).era = era
        } else {
          getParsingFlags(config).invalidEra = input
        }
      }
    )
    addRegexToken('y', matchUnsigned)
    addRegexToken('yy', matchUnsigned)
    addRegexToken('yyy', matchUnsigned)
    addRegexToken('yyyy', matchUnsigned)
    addRegexToken('yo', matchEraYearOrdinal)
    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR)
    addParseToken(['yo'], function (input, array, config, token) {
      var match
      if (config._locale._eraYearOrdinalRegex) {
        match = input.match(config._locale._eraYearOrdinalRegex)
      }
      if (config._locale.eraYearOrdinalParse) {
        array[YEAR] = config._locale.eraYearOrdinalParse(input, match)
      } else {
        array[YEAR] = parseInt(input, 10)
      }
    })
    function localeEras(m, format) {
      var i,
        l,
        date,
        eras = this._eras || getLocale('en')._eras
      for (i = 0, l = eras.length; i < l; ++i) {
        switch (typeof eras[i].since) {
          case 'string':
            date = hooks(eras[i].since).startOf('day')
            eras[i].since = date.valueOf()
            break
        }
        switch (typeof eras[i].until) {
          case 'undefined':
            eras[i].until = +Infinity
            break

          case 'string':
            date = hooks(eras[i].until).startOf('day').valueOf()
            eras[i].until = date.valueOf()
            break
        }
      }
      return eras
    }
    function localeErasParse(eraName, format, strict) {
      var i,
        l,
        eras = this.eras(),
        name,
        abbr,
        narrow
      eraName = eraName.toUpperCase()
      for (i = 0, l = eras.length; i < l; ++i) {
        name = eras[i].name.toUpperCase()
        abbr = eras[i].abbr.toUpperCase()
        narrow = eras[i].narrow.toUpperCase()
        if (strict) {
          switch (format) {
            case 'N':
            case 'NN':
            case 'NNN':
              if (abbr === eraName) {
                return eras[i]
              }
              break

            case 'NNNN':
              if (name === eraName) {
                return eras[i]
              }
              break

            case 'NNNNN':
              if (narrow === eraName) {
                return eras[i]
              }
              break
          }
        } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
          return eras[i]
        }
      }
    }
    function localeErasConvertYear(era, year) {
      var dir = era.since <= era.until ? +1 : -1
      if (year === undefined) {
        return hooks(era.since).year()
      } else {
        return hooks(era.since).year() + (year - era.offset) * dir
      }
    }
    function getEraName() {
      var i,
        l,
        val,
        eras = this.localeData().eras()
      for (i = 0, l = eras.length; i < l; ++i) {
        val = this.clone().startOf('day').valueOf()
        if (eras[i].since <= val && val <= eras[i].until) {
          return eras[i].name
        }
        if (eras[i].until <= val && val <= eras[i].since) {
          return eras[i].name
        }
      }
      return ''
    }
    function getEraNarrow() {
      var i,
        l,
        val,
        eras = this.localeData().eras()
      for (i = 0, l = eras.length; i < l; ++i) {
        val = this.clone().startOf('day').valueOf()
        if (eras[i].since <= val && val <= eras[i].until) {
          return eras[i].narrow
        }
        if (eras[i].until <= val && val <= eras[i].since) {
          return eras[i].narrow
        }
      }
      return ''
    }
    function getEraAbbr() {
      var i,
        l,
        val,
        eras = this.localeData().eras()
      for (i = 0, l = eras.length; i < l; ++i) {
        val = this.clone().startOf('day').valueOf()
        if (eras[i].since <= val && val <= eras[i].until) {
          return eras[i].abbr
        }
        if (eras[i].until <= val && val <= eras[i].since) {
          return eras[i].abbr
        }
      }
      return ''
    }
    function getEraYear() {
      var i,
        l,
        dir,
        val,
        eras = this.localeData().eras()
      for (i = 0, l = eras.length; i < l; ++i) {
        dir = eras[i].since <= eras[i].until ? +1 : -1
        val = this.clone().startOf('day').valueOf()
        if (
          (eras[i].since <= val && val <= eras[i].until) ||
          (eras[i].until <= val && val <= eras[i].since)
        ) {
          return (
            (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset
          )
        }
      }
      return this.year()
    }
    function erasNameRegex(isStrict) {
      if (!hasOwnProp(this, '_erasNameRegex')) {
        computeErasParse.call(this)
      }
      return isStrict ? this._erasNameRegex : this._erasRegex
    }
    function erasAbbrRegex(isStrict) {
      if (!hasOwnProp(this, '_erasAbbrRegex')) {
        computeErasParse.call(this)
      }
      return isStrict ? this._erasAbbrRegex : this._erasRegex
    }
    function erasNarrowRegex(isStrict) {
      if (!hasOwnProp(this, '_erasNarrowRegex')) {
        computeErasParse.call(this)
      }
      return isStrict ? this._erasNarrowRegex : this._erasRegex
    }
    function matchEraAbbr(isStrict, locale) {
      return locale.erasAbbrRegex(isStrict)
    }
    function matchEraName(isStrict, locale) {
      return locale.erasNameRegex(isStrict)
    }
    function matchEraNarrow(isStrict, locale) {
      return locale.erasNarrowRegex(isStrict)
    }
    function matchEraYearOrdinal(isStrict, locale) {
      return locale._eraYearOrdinalRegex || matchUnsigned
    }
    function computeErasParse() {
      var abbrPieces = [],
        namePieces = [],
        narrowPieces = [],
        mixedPieces = [],
        i,
        l,
        eras = this.eras()
      for (i = 0, l = eras.length; i < l; ++i) {
        namePieces.push(regexEscape(eras[i].name))
        abbrPieces.push(regexEscape(eras[i].abbr))
        narrowPieces.push(regexEscape(eras[i].narrow))
        mixedPieces.push(regexEscape(eras[i].name))
        mixedPieces.push(regexEscape(eras[i].abbr))
        mixedPieces.push(regexEscape(eras[i].narrow))
      }
      this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i')
      this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i')
      this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i')
      this._erasNarrowRegex = new RegExp(
        '^(' + narrowPieces.join('|') + ')',
        'i'
      )
    }
    addFormatToken(0, ['gg', 2], 0, function () {
      return this.weekYear() % 100
    })
    addFormatToken(0, ['GG', 2], 0, function () {
      return this.isoWeekYear() % 100
    })
    function addWeekYearFormatToken(token, getter) {
      addFormatToken(0, [token, token.length], 0, getter)
    }
    addWeekYearFormatToken('gggg', 'weekYear')
    addWeekYearFormatToken('ggggg', 'weekYear')
    addWeekYearFormatToken('GGGG', 'isoWeekYear')
    addWeekYearFormatToken('GGGGG', 'isoWeekYear')
    addUnitAlias('weekYear', 'gg')
    addUnitAlias('isoWeekYear', 'GG')
    addUnitPriority('weekYear', 1)
    addUnitPriority('isoWeekYear', 1)
    addRegexToken('G', matchSigned)
    addRegexToken('g', matchSigned)
    addRegexToken('GG', match1to2, match2)
    addRegexToken('gg', match1to2, match2)
    addRegexToken('GGGG', match1to4, match4)
    addRegexToken('gggg', match1to4, match4)
    addRegexToken('GGGGG', match1to6, match6)
    addRegexToken('ggggg', match1to6, match6)
    addWeekParseToken(
      ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
      function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input)
      }
    )
    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
      week[token] = hooks.parseTwoDigitYear(input)
    })
    function getSetWeekYear(input) {
      return getSetWeekYearHelper.call(
        this,
        input,
        this.week(),
        this.weekday(),
        this.localeData()._week.dow,
        this.localeData()._week.doy
      )
    }
    function getSetISOWeekYear(input) {
      return getSetWeekYearHelper.call(
        this,
        input,
        this.isoWeek(),
        this.isoWeekday(),
        1,
        4
      )
    }
    function getISOWeeksInYear() {
      return weeksInYear(this.year(), 1, 4)
    }
    function getISOWeeksInISOWeekYear() {
      return weeksInYear(this.isoWeekYear(), 1, 4)
    }
    function getWeeksInYear() {
      var weekInfo = this.localeData()._week
      return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy)
    }
    function getWeeksInWeekYear() {
      var weekInfo = this.localeData()._week
      return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy)
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
      var weeksTarget
      if (input == null) {
        return weekOfYear(this, dow, doy).year
      } else {
        weeksTarget = weeksInYear(input, dow, doy)
        if (week > weeksTarget) {
          week = weeksTarget
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy)
      }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
      var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear)
      this.year(date.getUTCFullYear())
      this.month(date.getUTCMonth())
      this.date(date.getUTCDate())
      return this
    }
    addFormatToken('Q', 0, 'Qo', 'quarter')
    addUnitAlias('quarter', 'Q')
    addUnitPriority('quarter', 7)
    addRegexToken('Q', match1)
    addParseToken('Q', function (input, array) {
      array[MONTH] = (toInt(input) - 1) * 3
    })
    function getSetQuarter(input) {
      return input == null
        ? Math.ceil((this.month() + 1) / 3)
        : this.month((input - 1) * 3 + (this.month() % 3))
    }
    addFormatToken('D', ['DD', 2], 'Do', 'date')
    addUnitAlias('date', 'D')
    addUnitPriority('date', 9)
    addRegexToken('D', match1to2)
    addRegexToken('DD', match1to2, match2)
    addRegexToken('Do', function (isStrict, locale) {
      return isStrict
        ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
        : locale._dayOfMonthOrdinalParseLenient
    })
    addParseToken(['D', 'DD'], DATE)
    addParseToken('Do', function (input, array) {
      array[DATE] = toInt(input.match(match1to2)[0])
    })
    var getSetDayOfMonth = makeGetSet('Date', true)
    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear')
    addUnitAlias('dayOfYear', 'DDD')
    addUnitPriority('dayOfYear', 4)
    addRegexToken('DDD', match1to3)
    addRegexToken('DDDD', match3)
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
      config._dayOfYear = toInt(input)
    })
    function getSetDayOfYear(input) {
      var dayOfYear =
        Math.round(
          (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
        ) + 1
      return input == null ? dayOfYear : this.add(input - dayOfYear, 'd')
    }
    addFormatToken('m', ['mm', 2], 0, 'minute')
    addUnitAlias('minute', 'm')
    addUnitPriority('minute', 14)
    addRegexToken('m', match1to2)
    addRegexToken('mm', match1to2, match2)
    addParseToken(['m', 'mm'], MINUTE)
    var getSetMinute = makeGetSet('Minutes', false)
    addFormatToken('s', ['ss', 2], 0, 'second')
    addUnitAlias('second', 's')
    addUnitPriority('second', 15)
    addRegexToken('s', match1to2)
    addRegexToken('ss', match1to2, match2)
    addParseToken(['s', 'ss'], SECOND)
    var getSetSecond = makeGetSet('Seconds', false)
    addFormatToken('S', 0, 0, function () {
      return ~~(this.millisecond() / 100)
    })
    addFormatToken(0, ['SS', 2], 0, function () {
      return ~~(this.millisecond() / 10)
    })
    addFormatToken(0, ['SSS', 3], 0, 'millisecond')
    addFormatToken(0, ['SSSS', 4], 0, function () {
      return this.millisecond() * 10
    })
    addFormatToken(0, ['SSSSS', 5], 0, function () {
      return this.millisecond() * 100
    })
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
      return this.millisecond() * 1e3
    })
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
      return this.millisecond() * 1e4
    })
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
      return this.millisecond() * 1e5
    })
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
      return this.millisecond() * 1e6
    })
    addUnitAlias('millisecond', 'ms')
    addUnitPriority('millisecond', 16)
    addRegexToken('S', match1to3, match1)
    addRegexToken('SS', match1to3, match2)
    addRegexToken('SSS', match1to3, match3)
    var token, getSetMillisecond
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
      addRegexToken(token, matchUnsigned)
    }
    function parseMs(input, array) {
      array[MILLISECOND] = toInt(('0.' + input) * 1e3)
    }
    for (token = 'S'; token.length <= 9; token += 'S') {
      addParseToken(token, parseMs)
    }
    getSetMillisecond = makeGetSet('Milliseconds', false)
    addFormatToken('z', 0, 0, 'zoneAbbr')
    addFormatToken('zz', 0, 0, 'zoneName')
    function getZoneAbbr() {
      return this._isUTC ? 'UTC' : ''
    }
    function getZoneName() {
      return this._isUTC ? 'Coordinated Universal Time' : ''
    }
    var proto = Moment.prototype
    proto.add = add
    proto.calendar = calendar$1
    proto.clone = clone
    proto.diff = diff
    proto.endOf = endOf
    proto.format = format
    proto.from = from
    proto.fromNow = fromNow
    proto.to = to
    proto.toNow = toNow
    proto.get = stringGet
    proto.invalidAt = invalidAt
    proto.isAfter = isAfter
    proto.isBefore = isBefore
    proto.isBetween = isBetween
    proto.isSame = isSame
    proto.isSameOrAfter = isSameOrAfter
    proto.isSameOrBefore = isSameOrBefore
    proto.isValid = isValid$2
    proto.lang = lang
    proto.locale = locale
    proto.localeData = localeData
    proto.max = prototypeMax
    proto.min = prototypeMin
    proto.parsingFlags = parsingFlags
    proto.set = stringSet
    proto.startOf = startOf
    proto.subtract = subtract
    proto.toArray = toArray
    proto.toObject = toObject
    proto.toDate = toDate
    proto.toISOString = toISOString
    proto.inspect = inspect
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
      proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
        return 'Moment<' + this.format() + '>'
      }
    }
    proto.toJSON = toJSON
    proto.toString = toString
    proto.unix = unix
    proto.valueOf = valueOf
    proto.creationData = creationData
    proto.eraName = getEraName
    proto.eraNarrow = getEraNarrow
    proto.eraAbbr = getEraAbbr
    proto.eraYear = getEraYear
    proto.year = getSetYear
    proto.isLeapYear = getIsLeapYear
    proto.weekYear = getSetWeekYear
    proto.isoWeekYear = getSetISOWeekYear
    proto.quarter = proto.quarters = getSetQuarter
    proto.month = getSetMonth
    proto.daysInMonth = getDaysInMonth
    proto.week = proto.weeks = getSetWeek
    proto.isoWeek = proto.isoWeeks = getSetISOWeek
    proto.weeksInYear = getWeeksInYear
    proto.weeksInWeekYear = getWeeksInWeekYear
    proto.isoWeeksInYear = getISOWeeksInYear
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear
    proto.date = getSetDayOfMonth
    proto.day = proto.days = getSetDayOfWeek
    proto.weekday = getSetLocaleDayOfWeek
    proto.isoWeekday = getSetISODayOfWeek
    proto.dayOfYear = getSetDayOfYear
    proto.hour = proto.hours = getSetHour
    proto.minute = proto.minutes = getSetMinute
    proto.second = proto.seconds = getSetSecond
    proto.millisecond = proto.milliseconds = getSetMillisecond
    proto.utcOffset = getSetOffset
    proto.utc = setOffsetToUTC
    proto.local = setOffsetToLocal
    proto.parseZone = setOffsetToParsedOffset
    proto.hasAlignedHourOffset = hasAlignedHourOffset
    proto.isDST = isDaylightSavingTime
    proto.isLocal = isLocal
    proto.isUtcOffset = isUtcOffset
    proto.isUtc = isUtc
    proto.isUTC = isUtc
    proto.zoneAbbr = getZoneAbbr
    proto.zoneName = getZoneName
    proto.dates = deprecate(
      'dates accessor is deprecated. Use date instead.',
      getSetDayOfMonth
    )
    proto.months = deprecate(
      'months accessor is deprecated. Use month instead',
      getSetMonth
    )
    proto.years = deprecate(
      'years accessor is deprecated. Use year instead',
      getSetYear
    )
    proto.zone = deprecate(
      'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
      getSetZone
    )
    proto.isDSTShifted = deprecate(
      'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
      isDaylightSavingTimeShifted
    )
    function createUnix(input) {
      return createLocal(input * 1e3)
    }
    function createInZone() {
      return createLocal.apply(null, arguments).parseZone()
    }
    function preParsePostFormat(string) {
      return string
    }
    var proto$1 = Locale.prototype
    proto$1.calendar = calendar
    proto$1.longDateFormat = longDateFormat
    proto$1.invalidDate = invalidDate
    proto$1.ordinal = ordinal
    proto$1.preparse = preParsePostFormat
    proto$1.postformat = preParsePostFormat
    proto$1.relativeTime = relativeTime
    proto$1.pastFuture = pastFuture
    proto$1.set = set
    proto$1.eras = localeEras
    proto$1.erasParse = localeErasParse
    proto$1.erasConvertYear = localeErasConvertYear
    proto$1.erasAbbrRegex = erasAbbrRegex
    proto$1.erasNameRegex = erasNameRegex
    proto$1.erasNarrowRegex = erasNarrowRegex
    proto$1.months = localeMonths
    proto$1.monthsShort = localeMonthsShort
    proto$1.monthsParse = localeMonthsParse
    proto$1.monthsRegex = monthsRegex
    proto$1.monthsShortRegex = monthsShortRegex
    proto$1.week = localeWeek
    proto$1.firstDayOfYear = localeFirstDayOfYear
    proto$1.firstDayOfWeek = localeFirstDayOfWeek
    proto$1.weekdays = localeWeekdays
    proto$1.weekdaysMin = localeWeekdaysMin
    proto$1.weekdaysShort = localeWeekdaysShort
    proto$1.weekdaysParse = localeWeekdaysParse
    proto$1.weekdaysRegex = weekdaysRegex
    proto$1.weekdaysShortRegex = weekdaysShortRegex
    proto$1.weekdaysMinRegex = weekdaysMinRegex
    proto$1.isPM = localeIsPM
    proto$1.meridiem = localeMeridiem
    function get$1(format, index, field, setter) {
      var locale = getLocale(),
        utc = createUTC().set(setter, index)
      return locale[field](utc, format)
    }
    function listMonthsImpl(format, index, field) {
      if (isNumber(format)) {
        index = format
        format = undefined
      }
      format = format || ''
      if (index != null) {
        return get$1(format, index, field, 'month')
      }
      var i,
        out = []
      for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month')
      }
      return out
    }
    function listWeekdaysImpl(localeSorted, format, index, field) {
      if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
          index = format
          format = undefined
        }
        format = format || ''
      } else {
        format = localeSorted
        index = format
        localeSorted = false
        if (isNumber(format)) {
          index = format
          format = undefined
        }
        format = format || ''
      }
      var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0,
        i,
        out = []
      if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day')
      }
      for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day')
      }
      return out
    }
    function listMonths(format, index) {
      return listMonthsImpl(format, index, 'months')
    }
    function listMonthsShort(format, index) {
      return listMonthsImpl(format, index, 'monthsShort')
    }
    function listWeekdays(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdays')
    }
    function listWeekdaysShort(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort')
    }
    function listWeekdaysMin(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin')
    }
    getSetGlobalLocale('en', {
      eras: [
        {
          since: '0001-01-01',
          until: +Infinity,
          offset: 1,
          name: 'Anno Domini',
          narrow: 'AD',
          abbr: 'AD',
        },
        {
          since: '0000-12-31',
          until: -Infinity,
          offset: 1,
          name: 'Before Christ',
          narrow: 'BC',
          abbr: 'BC',
        },
      ],
      dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
      ordinal: function (number) {
        var b = number % 10,
          output =
            toInt((number % 100) / 10) === 1
              ? 'th'
              : b === 1
                ? 'st'
                : b === 2
                  ? 'nd'
                  : b === 3
                    ? 'rd'
                    : 'th'
        return number + output
      },
    })
    hooks.lang = deprecate(
      'moment.lang is deprecated. Use moment.locale instead.',
      getSetGlobalLocale
    )
    hooks.langData = deprecate(
      'moment.langData is deprecated. Use moment.localeData instead.',
      getLocale
    )
    var mathAbs = Math.abs
    function abs() {
      var data = this._data
      this._milliseconds = mathAbs(this._milliseconds)
      this._days = mathAbs(this._days)
      this._months = mathAbs(this._months)
      data.milliseconds = mathAbs(data.milliseconds)
      data.seconds = mathAbs(data.seconds)
      data.minutes = mathAbs(data.minutes)
      data.hours = mathAbs(data.hours)
      data.months = mathAbs(data.months)
      data.years = mathAbs(data.years)
      return this
    }
    function addSubtract$1(duration, input, value, direction) {
      var other = createDuration(input, value)
      duration._milliseconds += direction * other._milliseconds
      duration._days += direction * other._days
      duration._months += direction * other._months
      return duration._bubble()
    }
    function add$1(input, value) {
      return addSubtract$1(this, input, value, 1)
    }
    function subtract$1(input, value) {
      return addSubtract$1(this, input, value, -1)
    }
    function absCeil(number) {
      if (number < 0) {
        return Math.floor(number)
      } else {
        return Math.ceil(number)
      }
    }
    function bubble() {
      var milliseconds = this._milliseconds,
        days = this._days,
        months = this._months,
        data = this._data,
        seconds,
        minutes,
        hours,
        years,
        monthsFromDays
      if (
        !(
          (milliseconds >= 0 && days >= 0 && months >= 0) ||
          (milliseconds <= 0 && days <= 0 && months <= 0)
        )
      ) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5
        days = 0
        months = 0
      }
      data.milliseconds = milliseconds % 1e3
      seconds = absFloor(milliseconds / 1e3)
      data.seconds = seconds % 60
      minutes = absFloor(seconds / 60)
      data.minutes = minutes % 60
      hours = absFloor(minutes / 60)
      data.hours = hours % 24
      days += absFloor(hours / 24)
      monthsFromDays = absFloor(daysToMonths(days))
      months += monthsFromDays
      days -= absCeil(monthsToDays(monthsFromDays))
      years = absFloor(months / 12)
      months %= 12
      data.days = days
      data.months = months
      data.years = years
      return this
    }
    function daysToMonths(days) {
      return (days * 4800) / 146097
    }
    function monthsToDays(months) {
      return (months * 146097) / 4800
    }
    function as(units) {
      if (!this.isValid()) {
        return NaN
      }
      var days,
        months,
        milliseconds = this._milliseconds
      units = normalizeUnits(units)
      if (units === 'month' || units === 'quarter' || units === 'year') {
        days = this._days + milliseconds / 864e5
        months = this._months + daysToMonths(days)
        switch (units) {
          case 'month':
            return months

          case 'quarter':
            return months / 3

          case 'year':
            return months / 12
        }
      } else {
        days = this._days + Math.round(monthsToDays(this._months))
        switch (units) {
          case 'week':
            return days / 7 + milliseconds / 6048e5

          case 'day':
            return days + milliseconds / 864e5

          case 'hour':
            return days * 24 + milliseconds / 36e5

          case 'minute':
            return days * 1440 + milliseconds / 6e4

          case 'second':
            return days * 86400 + milliseconds / 1e3

          case 'millisecond':
            return Math.floor(days * 864e5) + milliseconds

          default:
            throw new Error('Unknown unit ' + units)
        }
      }
    }
    function valueOf$1() {
      if (!this.isValid()) {
        return NaN
      }
      return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
      )
    }
    function makeAs(alias) {
      return function () {
        return this.as(alias)
      }
    }
    var asMilliseconds = makeAs('ms'),
      asSeconds = makeAs('s'),
      asMinutes = makeAs('m'),
      asHours = makeAs('h'),
      asDays = makeAs('d'),
      asWeeks = makeAs('w'),
      asMonths = makeAs('M'),
      asQuarters = makeAs('Q'),
      asYears = makeAs('y')
    function clone$1() {
      return createDuration(this)
    }
    function get$2(units) {
      units = normalizeUnits(units)
      return this.isValid() ? this[units + 's']() : NaN
    }
    function makeGetter(name) {
      return function () {
        return this.isValid() ? this._data[name] : NaN
      }
    }
    var milliseconds = makeGetter('milliseconds'),
      seconds = makeGetter('seconds'),
      minutes = makeGetter('minutes'),
      hours = makeGetter('hours'),
      days = makeGetter('days'),
      months = makeGetter('months'),
      years = makeGetter('years')
    function weeks() {
      return absFloor(this.days() / 7)
    }
    var round = Math.round,
      thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11,
      }
    function substituteTimeAgo(
      string,
      number,
      withoutSuffix,
      isFuture,
      locale
    ) {
      return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture)
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
      var duration = createDuration(posNegDuration).abs(),
        seconds = round(duration.as('s')),
        minutes = round(duration.as('m')),
        hours = round(duration.as('h')),
        days = round(duration.as('d')),
        months = round(duration.as('M')),
        weeks = round(duration.as('w')),
        years = round(duration.as('y')),
        a =
          (seconds <= thresholds.ss && ['s', seconds]) ||
          (seconds < thresholds.s && ['ss', seconds]) ||
          (minutes <= 1 && ['m']) ||
          (minutes < thresholds.m && ['mm', minutes]) ||
          (hours <= 1 && ['h']) ||
          (hours < thresholds.h && ['hh', hours]) ||
          (days <= 1 && ['d']) ||
          (days < thresholds.d && ['dd', days])
      if (thresholds.w != null) {
        a =
          a || (weeks <= 1 && ['w']) || (weeks < thresholds.w && ['ww', weeks])
      }
      a = a ||
        (months <= 1 && ['M']) ||
        (months < thresholds.M && ['MM', months]) ||
        (years <= 1 && ['y']) || ['yy', years]
      a[2] = withoutSuffix
      a[3] = +posNegDuration > 0
      a[4] = locale
      return substituteTimeAgo.apply(null, a)
    }
    function getSetRelativeTimeRounding(roundingFunction) {
      if (roundingFunction === undefined) {
        return round
      }
      if (typeof roundingFunction === 'function') {
        round = roundingFunction
        return true
      }
      return false
    }
    function getSetRelativeTimeThreshold(threshold, limit) {
      if (thresholds[threshold] === undefined) {
        return false
      }
      if (limit === undefined) {
        return thresholds[threshold]
      }
      thresholds[threshold] = limit
      if (threshold === 's') {
        thresholds.ss = limit - 1
      }
      return true
    }
    function humanize(argWithSuffix, argThresholds) {
      if (!this.isValid()) {
        return this.localeData().invalidDate()
      }
      var withSuffix = false,
        th = thresholds,
        locale,
        output
      if (typeof argWithSuffix === 'object') {
        argThresholds = argWithSuffix
        argWithSuffix = false
      }
      if (typeof argWithSuffix === 'boolean') {
        withSuffix = argWithSuffix
      }
      if (typeof argThresholds === 'object') {
        th = Object.assign({}, thresholds, argThresholds)
        if (argThresholds.s != null && argThresholds.ss == null) {
          th.ss = argThresholds.s - 1
        }
      }
      locale = this.localeData()
      output = relativeTime$1(this, !withSuffix, th, locale)
      if (withSuffix) {
        output = locale.pastFuture(+this, output)
      }
      return locale.postformat(output)
    }
    var abs$1 = Math.abs
    function sign(x) {
      return (x > 0) - (x < 0) || +x
    }
    function toISOString$1() {
      if (!this.isValid()) {
        return this.localeData().invalidDate()
      }
      var seconds = abs$1(this._milliseconds) / 1e3,
        days = abs$1(this._days),
        months = abs$1(this._months),
        minutes,
        hours,
        years,
        s,
        total = this.asSeconds(),
        totalSign,
        ymSign,
        daysSign,
        hmsSign
      if (!total) {
        return 'P0D'
      }
      minutes = absFloor(seconds / 60)
      hours = absFloor(minutes / 60)
      seconds %= 60
      minutes %= 60
      years = absFloor(months / 12)
      months %= 12
      s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : ''
      totalSign = total < 0 ? '-' : ''
      ymSign = sign(this._months) !== sign(total) ? '-' : ''
      daysSign = sign(this._days) !== sign(total) ? '-' : ''
      hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : ''
      return (
        totalSign +
        'P' +
        (years ? ymSign + years + 'Y' : '') +
        (months ? ymSign + months + 'M' : '') +
        (days ? daysSign + days + 'D' : '') +
        (hours || minutes || seconds ? 'T' : '') +
        (hours ? hmsSign + hours + 'H' : '') +
        (minutes ? hmsSign + minutes + 'M' : '') +
        (seconds ? hmsSign + s + 'S' : '')
      )
    }
    var proto$2 = Duration.prototype
    proto$2.isValid = isValid$1
    proto$2.abs = abs
    proto$2.add = add$1
    proto$2.subtract = subtract$1
    proto$2.as = as
    proto$2.asMilliseconds = asMilliseconds
    proto$2.asSeconds = asSeconds
    proto$2.asMinutes = asMinutes
    proto$2.asHours = asHours
    proto$2.asDays = asDays
    proto$2.asWeeks = asWeeks
    proto$2.asMonths = asMonths
    proto$2.asQuarters = asQuarters
    proto$2.asYears = asYears
    proto$2.valueOf = valueOf$1
    proto$2._bubble = bubble
    proto$2.clone = clone$1
    proto$2.get = get$2
    proto$2.milliseconds = milliseconds
    proto$2.seconds = seconds
    proto$2.minutes = minutes
    proto$2.hours = hours
    proto$2.days = days
    proto$2.weeks = weeks
    proto$2.months = months
    proto$2.years = years
    proto$2.humanize = humanize
    proto$2.toISOString = toISOString$1
    proto$2.toString = toISOString$1
    proto$2.toJSON = toISOString$1
    proto$2.locale = locale
    proto$2.localeData = localeData
    proto$2.toIsoString = deprecate(
      'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
      toISOString$1
    )
    proto$2.lang = lang
    addFormatToken('X', 0, 0, 'unix')
    addFormatToken('x', 0, 0, 'valueOf')
    addRegexToken('x', matchSigned)
    addRegexToken('X', matchTimestamp)
    addParseToken('X', function (input, array, config) {
      config._d = new Date(parseFloat(input) * 1e3)
    })
    addParseToken('x', function (input, array, config) {
      config._d = new Date(toInt(input))
    })
    hooks.version = '2.29.1'
    setHookCallback(createLocal)
    hooks.fn = proto
    hooks.min = min
    hooks.max = max
    hooks.now = now
    hooks.utc = createUTC
    hooks.unix = createUnix
    hooks.months = listMonths
    hooks.isDate = isDate
    hooks.locale = getSetGlobalLocale
    hooks.invalid = createInvalid
    hooks.duration = createDuration
    hooks.isMoment = isMoment
    hooks.weekdays = listWeekdays
    hooks.parseZone = createInZone
    hooks.localeData = getLocale
    hooks.isDuration = isDuration
    hooks.monthsShort = listMonthsShort
    hooks.weekdaysMin = listWeekdaysMin
    hooks.defineLocale = defineLocale
    hooks.updateLocale = updateLocale
    hooks.locales = listLocales
    hooks.weekdaysShort = listWeekdaysShort
    hooks.normalizeUnits = normalizeUnits
    hooks.relativeTimeRounding = getSetRelativeTimeRounding
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold
    hooks.calendarFormat = getCalendarFormat
    hooks.prototype = proto
    hooks.HTML5_FMT = {
      DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
      DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
      DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
      DATE: 'YYYY-MM-DD',
      TIME: 'HH:mm',
      TIME_SECONDS: 'HH:mm:ss',
      TIME_MS: 'HH:mm:ss.SSS',
      WEEK: 'GGGG-[W]WW',
      MONTH: 'YYYY-MM',
    }
    hooks.defineLocale('af', {
      months:
        'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
          '_'
        ),
      monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
      weekdays:
        'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
      weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
      weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
      meridiemParse: /vm|nm/i,
      isPM: function (input) {
        return /^nm$/i.test(input)
      },
      meridiem: function (hours, minutes, isLower) {
        if (hours < 12) {
          return isLower ? 'vm' : 'VM'
        } else {
          return isLower ? 'nm' : 'NM'
        }
      },
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[Vandag om] LT',
        nextDay: '[Môre om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[Gister om] LT',
        lastWeek: '[Laas] dddd [om] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'oor %s',
        past: '%s gelede',
        s: "'n paar sekondes",
        ss: '%d sekondes',
        m: "'n minuut",
        mm: '%d minute',
        h: "'n uur",
        hh: '%d ure',
        d: "'n dag",
        dd: '%d dae',
        M: "'n maand",
        MM: '%d maande',
        y: "'n jaar",
        yy: '%d jaar',
      },
      dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
      ordinal: function (number) {
        return (
          number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
        )
      },
      week: {
        dow: 1,
        doy: 4,
      },
    })
    var pluralForm = function (n) {
        return n === 0
          ? 0
          : n === 1
            ? 1
            : n === 2
              ? 2
              : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                  ? 4
                  : 5
      },
      plurals = {
        s: [
          'أقل من ثانية',
          'ثانية واحدة',
          ['ثانيتان', 'ثانيتين'],
          '%d ثوان',
          '%d ثانية',
          '%d ثانية',
        ],
        m: [
          'أقل من دقيقة',
          'دقيقة واحدة',
          ['دقيقتان', 'دقيقتين'],
          '%d دقائق',
          '%d دقيقة',
          '%d دقيقة',
        ],
        h: [
          'أقل من ساعة',
          'ساعة واحدة',
          ['ساعتان', 'ساعتين'],
          '%d ساعات',
          '%d ساعة',
          '%d ساعة',
        ],
        d: [
          'أقل من يوم',
          'يوم واحد',
          ['يومان', 'يومين'],
          '%d أيام',
          '%d يومًا',
          '%d يوم',
        ],
        M: [
          'أقل من شهر',
          'شهر واحد',
          ['شهران', 'شهرين'],
          '%d أشهر',
          '%d شهرا',
          '%d شهر',
        ],
        y: [
          'أقل من عام',
          'عام واحد',
          ['عامان', 'عامين'],
          '%d أعوام',
          '%d عامًا',
          '%d عام',
        ],
      },
      pluralize = function (u) {
        return function (number, withoutSuffix, string, isFuture) {
          var f = pluralForm(number),
            str = plurals[u][pluralForm(number)]
          if (f === 2) {
            str = str[withoutSuffix ? 0 : 1]
          }
          return str.replace(/%d/i, number)
        }
      },
      months$1 = [
        'جانفي',
        'فيفري',
        'مارس',
        'أفريل',
        'ماي',
        'جوان',
        'جويلية',
        'أوت',
        'سبتمبر',
        'أكتوبر',
        'نوفمبر',
        'ديسمبر',
      ]
    hooks.defineLocale('ar-dz', {
      months: months$1,
      monthsShort: months$1,
      weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split(
        '_'
      ),
      weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
      weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'D/‏M/‏YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm',
      },
      meridiemParse: /ص|م/,
      isPM: function (input) {
        return 'م' === input
      },
      meridiem: function (hour, minute, isLower) {
        if (hour < 12) {
          return 'ص'
        } else {
          return 'م'
        }
      },
      calendar: {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'بعد %s',
        past: 'منذ %s',
        s: pluralize('s'),
        ss: pluralize('s'),
        m: pluralize('m'),
        mm: pluralize('m'),
        h: pluralize('h'),
        hh: pluralize('h'),
        d: pluralize('d'),
        dd: pluralize('d'),
        M: pluralize('M'),
        MM: pluralize('M'),
        y: pluralize('y'),
        yy: pluralize('y'),
      },
      postformat: function (string) {
        return string.replace(/,/g, '،')
      },
      week: {
        dow: 0,
        doy: 4,
      },
    })
    hooks.defineLocale('ar-kw', {
      months:
        'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
          '_'
        ),
      monthsShort:
        'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
          '_'
        ),
      weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split(
        '_'
      ),
      weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
      weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'في %s',
        past: 'منذ %s',
        s: 'ثوان',
        ss: '%d ثانية',
        m: 'دقيقة',
        mm: '%d دقائق',
        h: 'ساعة',
        hh: '%d ساعات',
        d: 'يوم',
        dd: '%d أيام',
        M: 'شهر',
        MM: '%d أشهر',
        y: 'سنة',
        yy: '%d سنوات',
      },
      week: {
        dow: 0,
        doy: 12,
      },
    })
    var symbolMap = {
        1: '1',
        2: '2',
        3: '3',
        4: '4',
        5: '5',
        6: '6',
        7: '7',
        8: '8',
        9: '9',
        0: '0',
      },
      pluralForm$1 = function (n) {
        return n === 0
          ? 0
          : n === 1
            ? 1
            : n === 2
              ? 2
              : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                  ? 4
                  : 5
      },
      plurals$1 = {
        s: [
          'أقل من ثانية',
          'ثانية واحدة',
          ['ثانيتان', 'ثانيتين'],
          '%d ثوان',
          '%d ثانية',
          '%d ثانية',
        ],
        m: [
          'أقل من دقيقة',
          'دقيقة واحدة',
          ['دقيقتان', 'دقيقتين'],
          '%d دقائق',
          '%d دقيقة',
          '%d دقيقة',
        ],
        h: [
          'أقل من ساعة',
          'ساعة واحدة',
          ['ساعتان', 'ساعتين'],
          '%d ساعات',
          '%d ساعة',
          '%d ساعة',
        ],
        d: [
          'أقل من يوم',
          'يوم واحد',
          ['يومان', 'يومين'],
          '%d أيام',
          '%d يومًا',
          '%d يوم',
        ],
        M: [
          'أقل من شهر',
          'شهر واحد',
          ['شهران', 'شهرين'],
          '%d أشهر',
          '%d شهرا',
          '%d شهر',
        ],
        y: [
          'أقل من عام',
          'عام واحد',
          ['عامان', 'عامين'],
          '%d أعوام',
          '%d عامًا',
          '%d عام',
        ],
      },
      pluralize$1 = function (u) {
        return function (number, withoutSuffix, string, isFuture) {
          var f = pluralForm$1(number),
            str = plurals$1[u][pluralForm$1(number)]
          if (f === 2) {
            str = str[withoutSuffix ? 0 : 1]
          }
          return str.replace(/%d/i, number)
        }
      },
      months$2 = [
        'يناير',
        'فبراير',
        'مارس',
        'أبريل',
        'مايو',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمبر',
        'أكتوبر',
        'نوفمبر',
        'ديسمبر',
      ]
    hooks.defineLocale('ar-ly', {
      months: months$2,
      monthsShort: months$2,
      weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split(
        '_'
      ),
      weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
      weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'D/‏M/‏YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm',
      },
      meridiemParse: /ص|م/,
      isPM: function (input) {
        return 'م' === input
      },
      meridiem: function (hour, minute, isLower) {
        if (hour < 12) {
          return 'ص'
        } else {
          return 'م'
        }
      },
      calendar: {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'بعد %s',
        past: 'منذ %s',
        s: pluralize$1('s'),
        ss: pluralize$1('s'),
        m: pluralize$1('m'),
        mm: pluralize$1('m'),
        h: pluralize$1('h'),
        hh: pluralize$1('h'),
        d: pluralize$1('d'),
        dd: pluralize$1('d'),
        M: pluralize$1('M'),
        MM: pluralize$1('M'),
        y: pluralize$1('y'),
        yy: pluralize$1('y'),
      },
      preparse: function (string) {
        return string.replace(/،/g, ',')
      },
      postformat: function (string) {
        return string
          .replace(/\d/g, function (match) {
            return symbolMap[match]
          })
          .replace(/,/g, '،')
      },
      week: {
        dow: 6,
        doy: 12,
      },
    })
    hooks.defineLocale('ar-ma', {
      months:
        'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
          '_'
        ),
      monthsShort:
        'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
          '_'
        ),
      weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split(
        '_'
      ),
      weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
      weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'في %s',
        past: 'منذ %s',
        s: 'ثوان',
        ss: '%d ثانية',
        m: 'دقيقة',
        mm: '%d دقائق',
        h: 'ساعة',
        hh: '%d ساعات',
        d: 'يوم',
        dd: '%d أيام',
        M: 'شهر',
        MM: '%d أشهر',
        y: 'سنة',
        yy: '%d سنوات',
      },
      week: {
        dow: 1,
        doy: 4,
      },
    })
    var symbolMap$1 = {
        1: '١',
        2: '٢',
        3: '٣',
        4: '٤',
        5: '٥',
        6: '٦',
        7: '٧',
        8: '٨',
        9: '٩',
        0: '٠',
      },
      numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0',
      }
    hooks.defineLocale('ar-sa', {
      months:
        'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
          '_'
        ),
      monthsShort:
        'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
          '_'
        ),
      weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split(
        '_'
      ),
      weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
      weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm',
      },
      meridiemParse: /ص|م/,
      isPM: function (input) {
        return 'م' === input
      },
      meridiem: function (hour, minute, isLower) {
        if (hour < 12) {
          return 'ص'
        } else {
          return 'م'
        }
      },
      calendar: {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'في %s',
        past: 'منذ %s',
        s: 'ثوان',
        ss: '%d ثانية',
        m: 'دقيقة',
        mm: '%d دقائق',
        h: 'ساعة',
        hh: '%d ساعات',
        d: 'يوم',
        dd: '%d أيام',
        M: 'شهر',
        MM: '%d أشهر',
        y: 'سنة',
        yy: '%d سنوات',
      },
      preparse: function (string) {
        return string
          .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap[match]
          })
          .replace(/،/g, ',')
      },
      postformat: function (string) {
        return string
          .replace(/\d/g, function (match) {
            return symbolMap$1[match]
          })
          .replace(/,/g, '،')
      },
      week: {
        dow: 0,
        doy: 6,
      },
    })
    hooks.defineLocale('ar-tn', {
      months:
        'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
          '_'
        ),
      monthsShort:
        'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
          '_'
        ),
      weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split(
        '_'
      ),
      weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
      weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'في %s',
        past: 'منذ %s',
        s: 'ثوان',
        ss: '%d ثانية',
        m: 'دقيقة',
        mm: '%d دقائق',
        h: 'ساعة',
        hh: '%d ساعات',
        d: 'يوم',
        dd: '%d أيام',
        M: 'شهر',
        MM: '%d أشهر',
        y: 'سنة',
        yy: '%d سنوات',
      },
      week: {
        dow: 1,
        doy: 4,
      },
    })
    var symbolMap$2 = {
        1: '١',
        2: '٢',
        3: '٣',
        4: '٤',
        5: '٥',
        6: '٦',
        7: '٧',
        8: '٨',
        9: '٩',
        0: '٠',
      },
      numberMap$1 = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0',
      },
      pluralForm$2 = function (n) {
        return n === 0
          ? 0
          : n === 1
            ? 1
            : n === 2
              ? 2
              : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                  ? 4
                  : 5
      },
      plurals$2 = {
        s: [
          'أقل من ثانية',
          'ثانية واحدة',
          ['ثانيتان', 'ثانيتين'],
          '%d ثوان',
          '%d ثانية',
          '%d ثانية',
        ],
        m: [
          'أقل من دقيقة',
          'دقيقة واحدة',
          ['دقيقتان', 'دقيقتين'],
          '%d دقائق',
          '%d دقيقة',
          '%d دقيقة',
        ],
        h: [
          'أقل من ساعة',
          'ساعة واحدة',
          ['ساعتان', 'ساعتين'],
          '%d ساعات',
          '%d ساعة',
          '%d ساعة',
        ],
        d: [
          'أقل من يوم',
          'يوم واحد',
          ['يومان', 'يومين'],
          '%d أيام',
          '%d يومًا',
          '%d يوم',
        ],
        M: [
          'أقل من شهر',
          'شهر واحد',
          ['شهران', 'شهرين'],
          '%d أشهر',
          '%d شهرا',
          '%d شهر',
        ],
        y: [
          'أقل من عام',
          'عام واحد',
          ['عامان', 'عامين'],
          '%d أعوام',
          '%d عامًا',
          '%d عام',
        ],
      },
      pluralize$2 = function (u) {
        return function (number, withoutSuffix, string, isFuture) {
          var f = pluralForm$2(number),
            str = plurals$2[u][pluralForm$2(number)]
          if (f === 2) {
            str = str[withoutSuffix ? 0 : 1]
          }
          return str.replace(/%d/i, number)
        }
      },
      months$3 = [
        'يناير',
        'فبراير',
        'مارس',
        'أبريل',
        'مايو',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمبر',
        'أكتوبر',
        'نوفمبر',
        'ديسمبر',
      ]
    hooks.defineLocale('ar', {
      months: months$3,
      monthsShort: months$3,
      weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split(
        '_'
      ),
      weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
      weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'D/‏M/‏YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm',
      },
      meridiemParse: /ص|م/,
      isPM: function (input) {
        return 'م' === input
      },
      meridiem: function (hour, minute, isLower) {
        if (hour < 12) {
          return 'ص'
        } else {
          return 'م'
        }
      },
      calendar: {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'بعد %s',
        past: 'منذ %s',
        s: pluralize$2('s'),
        ss: pluralize$2('s'),
        m: pluralize$2('m'),
        mm: pluralize$2('m'),
        h: pluralize$2('h'),
        hh: pluralize$2('h'),
        d: pluralize$2('d'),
        dd: pluralize$2('d'),
        M: pluralize$2('M'),
        MM: pluralize$2('M'),
        y: pluralize$2('y'),
        yy: pluralize$2('y'),
      },
      preparse: function (string) {
        return string
          .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap$1[match]
          })
          .replace(/،/g, ',')
      },
      postformat: function (string) {
        return string
          .replace(/\d/g, function (match) {
            return symbolMap$2[match]
          })
          .replace(/,/g, '،')
      },
      week: {
        dow: 6,
        doy: 12,
      },
    })
    var suffixes = {
      1: '-inci',
      5: '-inci',
      8: '-inci',
      70: '-inci',
      80: '-inci',
      2: '-nci',
      7: '-nci',
      20: '-nci',
      50: '-nci',
      3: '-üncü',
      4: '-üncü',
      100: '-üncü',
      6: '-ncı',
      9: '-uncu',
      10: '-uncu',
      30: '-uncu',
      60: '-ıncı',
      90: '-ıncı',
    }
    hooks.defineLocale('az', {
      months:
        'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
          '_'
        ),
      monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
      weekdays:
        'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
          '_'
        ),
      weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
      weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[bugün saat] LT',
        nextDay: '[sabah saat] LT',
        nextWeek: '[gələn həftə] dddd [saat] LT',
        lastDay: '[dünən] LT',
        lastWeek: '[keçən həftə] dddd [saat] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: '%s sonra',
        past: '%s əvvəl',
        s: 'bir neçə saniyə',
        ss: '%d saniyə',
        m: 'bir dəqiqə',
        mm: '%d dəqiqə',
        h: 'bir saat',
        hh: '%d saat',
        d: 'bir gün',
        dd: '%d gün',
        M: 'bir ay',
        MM: '%d ay',
        y: 'bir il',
        yy: '%d il',
      },
      meridiemParse: /gecə|səhər|gündüz|axşam/,
      isPM: function (input) {
        return /^(gündüz|axşam)$/.test(input)
      },
      meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
          return 'gecə'
        } else if (hour < 12) {
          return 'səhər'
        } else if (hour < 17) {
          return 'gündüz'
        } else {
          return 'axşam'
        }
      },
      dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
      ordinal: function (number) {
        if (number === 0) {
          return number + '-ıncı'
        }
        var a = number % 10,
          b = (number % 100) - a,
          c = number >= 100 ? 100 : null
        return number + (suffixes[a] || suffixes[b] || suffixes[c])
      },
      week: {
        dow: 1,
        doy: 7,
      },
    })
    function plural(word, num) {
      var forms = word.split('_')
      return num % 10 === 1 && num % 100 !== 11
        ? forms[0]
        : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
          ? forms[1]
          : forms[2]
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
      var format = {
        ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
        mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
        hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
        dd: 'дзень_дні_дзён',
        MM: 'месяц_месяцы_месяцаў',
        yy: 'год_гады_гадоў',
      }
      if (key === 'm') {
        return withoutSuffix ? 'хвіліна' : 'хвіліну'
      } else if (key === 'h') {
        return withoutSuffix ? 'гадзіна' : 'гадзіну'
      } else {
        return number + ' ' + plural(format[key], +number)
      }
    }
    hooks.defineLocale('be', {
      months: {
        format:
          'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
            '_'
          ),
        standalone:
          'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
            '_'
          ),
      },
      monthsShort:
        'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
      weekdays: {
        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
          '_'
        ),
        standalone:
          'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
        isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
      },
      weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
      weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D MMMM YYYY г.',
        LLL: 'D MMMM YYYY г., HH:mm',
        LLLL: 'dddd, D MMMM YYYY г., HH:mm',
      },
      calendar: {
        sameDay: '[Сёння ў] LT',
        nextDay: '[Заўтра ў] LT',
        lastDay: '[Учора ў] LT',
        nextWeek: function () {
          return '[У] dddd [ў] LT'
        },
        lastWeek: function () {
          switch (this.day()) {
            case 0:
            case 3:
            case 5:
            case 6:
              return '[У мінулую] dddd [ў] LT'

            case 1:
            case 2:
            case 4:
              return '[У мінулы] dddd [ў] LT'
          }
        },
        sameElse: 'L',
      },
      relativeTime: {
        future: 'праз %s',
        past: '%s таму',
        s: 'некалькі секунд',
        m: relativeTimeWithPlural,
        mm: relativeTimeWithPlural,
        h: relativeTimeWithPlural,
        hh: relativeTimeWithPlural,
        d: 'дзень',
        dd: relativeTimeWithPlural,
        M: 'месяц',
        MM: relativeTimeWithPlural,
        y: 'год',
        yy: relativeTimeWithPlural,
      },
      meridiemParse: /ночы|раніцы|дня|вечара/,
      isPM: function (input) {
        return /^(дня|вечара)$/.test(input)
      },
      meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
          return 'ночы'
        } else if (hour < 12) {
          return 'раніцы'
        } else if (hour < 17) {
          return 'дня'
        } else {
          return 'вечара'
        }
      },
      dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
      ordinal: function (number, period) {
        switch (period) {
          case 'M':
          case 'd':
          case 'DDD':
          case 'w':
          case 'W':
            return (number % 10 === 2 || number % 10 === 3) &&
              number % 100 !== 12 &&
              number % 100 !== 13
              ? number + '-і'
              : number + '-ы'

          case 'D':
            return number + '-га'

          default:
            return number
        }
      },
      week: {
        dow: 1,
        doy: 7,
      },
    })
    hooks.defineLocale('bg', {
      months:
        'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
          '_'
        ),
      monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
      weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
        '_'
      ),
      weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
      weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
      longDateFormat: {
        LT: 'H:mm',
        LTS: 'H:mm:ss',
        L: 'D.MM.YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY H:mm',
        LLLL: 'dddd, D MMMM YYYY H:mm',
      },
      calendar: {
        sameDay: '[Днес в] LT',
        nextDay: '[Утре в] LT',
        nextWeek: 'dddd [в] LT',
        lastDay: '[Вчера в] LT',
        lastWeek: function () {
          switch (this.day()) {
            case 0:
            case 3:
            case 6:
              return '[Миналата] dddd [в] LT'

            case 1:
            case 2:
            case 4:
            case 5:
              return '[Миналия] dddd [в] LT'
          }
        },
        sameElse: 'L',
      },
      relativeTime: {
        future: 'след %s',
        past: 'преди %s',
        s: 'няколко секунди',
        ss: '%d секунди',
        m: 'минута',
        mm: '%d минути',
        h: 'час',
        hh: '%d часа',
        d: 'ден',
        dd: '%d дена',
        w: 'седмица',
        ww: '%d седмици',
        M: 'месец',
        MM: '%d месеца',
        y: 'година',
        yy: '%d години',
      },
      dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
      ordinal: function (number) {
        var lastDigit = number % 10,
          last2Digits = number % 100
        if (number === 0) {
          return number + '-ев'
        } else if (last2Digits === 0) {
          return number + '-ен'
        } else if (last2Digits > 10 && last2Digits < 20) {
          return number + '-ти'
        } else if (lastDigit === 1) {
          return number + '-ви'
        } else if (lastDigit === 2) {
          return number + '-ри'
        } else if (lastDigit === 7 || lastDigit === 8) {
          return number + '-ми'
        } else {
          return number + '-ти'
        }
      },
      week: {
        dow: 1,
        doy: 7,
      },
    })
    hooks.defineLocale('bm', {
      months:
        'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
          '_'
        ),
      monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
      weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
      weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
      weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'MMMM [tile] D [san] YYYY',
        LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
        LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
      },
      calendar: {
        sameDay: '[Bi lɛrɛ] LT',
        nextDay: '[Sini lɛrɛ] LT',
        nextWeek: 'dddd [don lɛrɛ] LT',
        lastDay: '[Kunu lɛrɛ] LT',
        lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: '%s kɔnɔ',
        past: 'a bɛ %s bɔ',
        s: 'sanga dama dama',
        ss: 'sekondi %d',
        m: 'miniti kelen',
        mm: 'miniti %d',
        h: 'lɛrɛ kelen',
        hh: 'lɛrɛ %d',
        d: 'tile kelen',
        dd: 'tile %d',
        M: 'kalo kelen',
        MM: 'kalo %d',
        y: 'san kelen',
        yy: 'san %d',
      },
      week: {
        dow: 1,
        doy: 4,
      },
    })
    var symbolMap$3 = {
        1: '১',
        2: '২',
        3: '৩',
        4: '৪',
        5: '৫',
        6: '৬',
        7: '৭',
        8: '৮',
        9: '৯',
        0: '০',
      },
      numberMap$2 = {
        '১': '1',
        '২': '2',
        '৩': '3',
        '৪': '4',
        '৫': '5',
        '৬': '6',
        '৭': '7',
        '৮': '8',
        '৯': '9',
        '০': '0',
      }
    hooks.defineLocale('bn-bd', {
      months:
        'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
          '_'
        ),
      monthsShort:
        'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
          '_'
        ),
      weekdays:
        'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
      weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
      weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
      longDateFormat: {
        LT: 'A h:mm সময়',
        LTS: 'A h:mm:ss সময়',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY, A h:mm সময়',
        LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
      },
      calendar: {
        sameDay: '[আজ] LT',
        nextDay: '[আগামীকাল] LT',
        nextWeek: 'dddd, LT',
        lastDay: '[গতকাল] LT',
        lastWeek: '[গত] dddd, LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: '%s পরে',
        past: '%s আগে',
        s: 'কয়েক সেকেন্ড',
        ss: '%d সেকেন্ড',
        m: 'এক মিনিট',
        mm: '%d মিনিট',
        h: 'এক ঘন্টা',
        hh: '%d ঘন্টা',
        d: 'এক দিন',
        dd: '%d দিন',
        M: 'এক মাস',
        MM: '%d মাস',
        y: 'এক বছর',
        yy: '%d বছর',
      },
      preparse: function (string) {
        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
          return numberMap$2[match]
        })
      },
      postformat: function (string) {
        return string.replace(/\d/g, function (match) {
          return symbolMap$3[match]
        })
      },
      meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
      meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
          hour = 0
        }
        if (meridiem === 'রাত') {
          return hour < 4 ? hour : hour + 12
        } else if (meridiem === 'ভোর') {
          return hour
        } else if (meridiem === 'সকাল') {
          return hour
        } else if (meridiem === 'দুপুর') {
          return hour >= 3 ? hour : hour + 12
        } else if (meridiem === 'বিকাল') {
          return hour + 12
        } else if (meridiem === 'সন্ধ্যা') {
          return hour + 12
        }
      },
      meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
          return 'রাত'
        } else if (hour < 6) {
          return 'ভোর'
        } else if (hour < 12) {
          return 'সকাল'
        } else if (hour < 15) {
          return 'দুপুর'
        } else if (hour < 18) {
          return 'বিকাল'
        } else if (hour < 20) {
          return 'সন্ধ্যা'
        } else {
          return 'রাত'
        }
      },
      week: {
        dow: 0,
        doy: 6,
      },
    })
    var symbolMap$4 = {
        1: '১',
        2: '২',
        3: '৩',
        4: '৪',
        5: '৫',
        6: '৬',
        7: '৭',
        8: '৮',
        9: '৯',
        0: '০',
      },
      numberMap$3 = {
        '১': '1',
        '২': '2',
        '৩': '3',
        '৪': '4',
        '৫': '5',
        '৬': '6',
        '৭': '7',
        '৮': '8',
        '৯': '9',
        '০': '0',
      }
    hooks.defineLocale('bn', {
      months:
        'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
          '_'
        ),
      monthsShort:
        'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
          '_'
        ),
      weekdays:
        'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
      weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
      weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
      longDateFormat: {
        LT: 'A h:mm সময়',
        LTS: 'A h:mm:ss সময়',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY, A h:mm সময়',
        LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
      },
      calendar: {
        sameDay: '[আজ] LT',
        nextDay: '[আগামীকাল] LT',
        nextWeek: 'dddd, LT',
        lastDay: '[গতকাল] LT',
        lastWeek: '[গত] dddd, LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: '%s পরে',
        past: '%s আগে',
        s: 'কয়েক সেকেন্ড',
        ss: '%d সেকেন্ড',
        m: 'এক মিনিট',
        mm: '%d মিনিট',
        h: 'এক ঘন্টা',
        hh: '%d ঘন্টা',
        d: 'এক দিন',
        dd: '%d দিন',
        M: 'এক মাস',
        MM: '%d মাস',
        y: 'এক বছর',
        yy: '%d বছর',
      },
      preparse: function (string) {
        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
          return numberMap$3[match]
        })
      },
      postformat: function (string) {
        return string.replace(/\d/g, function (match) {
          return symbolMap$4[match]
        })
      },
      meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
      meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
          hour = 0
        }
        if (
          (meridiem === 'রাত' && hour >= 4) ||
          (meridiem === 'দুপুর' && hour < 5) ||
          meridiem === 'বিকাল'
        ) {
          return hour + 12
        } else {
          return hour
        }
      },
      meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
          return 'রাত'
        } else if (hour < 10) {
          return 'সকাল'
        } else if (hour < 17) {
          return 'দুপুর'
        } else if (hour < 20) {
          return 'বিকাল'
        } else {
          return 'রাত'
        }
      },
      week: {
        dow: 0,
        doy: 6,
      },
    })
    var symbolMap$5 = {
        1: '༡',
        2: '༢',
        3: '༣',
        4: '༤',
        5: '༥',
        6: '༦',
        7: '༧',
        8: '༨',
        9: '༩',
        0: '༠',
      },
      numberMap$4 = {
        '༡': '1',
        '༢': '2',
        '༣': '3',
        '༤': '4',
        '༥': '5',
        '༦': '6',
        '༧': '7',
        '༨': '8',
        '༩': '9',
        '༠': '0',
      }
    hooks.defineLocale('bo', {
      months:
        'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
          '_'
        ),
      monthsShort:
        'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
          '_'
        ),
      monthsShortRegex: /^(ཟླ་\d{1,2})/,
      monthsParseExact: true,
      weekdays:
        'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
          '_'
        ),
      weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
        '_'
      ),
      weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
      longDateFormat: {
        LT: 'A h:mm',
        LTS: 'A h:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY, A h:mm',
        LLLL: 'dddd, D MMMM YYYY, A h:mm',
      },
      calendar: {
        sameDay: '[དི་རིང] LT',
        nextDay: '[སང་ཉིན] LT',
        nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
        lastDay: '[ཁ་སང] LT',
        lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: '%s ལ་',
        past: '%s སྔན་ལ',
        s: 'ལམ་སང',
        ss: '%d སྐར་ཆ།',
        m: 'སྐར་མ་གཅིག',
        mm: '%d སྐར་མ',
        h: 'ཆུ་ཚོད་གཅིག',
        hh: '%d ཆུ་ཚོད',
        d: 'ཉིན་གཅིག',
        dd: '%d ཉིན་',
        M: 'ཟླ་བ་གཅིག',
        MM: '%d ཟླ་བ',
        y: 'ལོ་གཅིག',
        yy: '%d ལོ',
      },
      preparse: function (string) {
        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
          return numberMap$4[match]
        })
      },
      postformat: function (string) {
        return string.replace(/\d/g, function (match) {
          return symbolMap$5[match]
        })
      },
      meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
      meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
          hour = 0
        }
        if (
          (meridiem === 'མཚན་མོ' && hour >= 4) ||
          (meridiem === 'ཉིན་གུང' && hour < 5) ||
          meridiem === 'དགོང་དག'
        ) {
          return hour + 12
        } else {
          return hour
        }
      },
      meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
          return 'མཚན་མོ'
        } else if (hour < 10) {
          return 'ཞོགས་ཀས'
        } else if (hour < 17) {
          return 'ཉིན་གུང'
        } else if (hour < 20) {
          return 'དགོང་དག'
        } else {
          return 'མཚན་མོ'
        }
      },
      week: {
        dow: 0,
        doy: 6,
      },
    })
    function relativeTimeWithMutation(number, withoutSuffix, key) {
      var format = {
        mm: 'munutenn',
        MM: 'miz',
        dd: 'devezh',
      }
      return number + ' ' + mutation(format[key], number)
    }
    function specialMutationForYears(number) {
      switch (lastNumber(number)) {
        case 1:
        case 3:
        case 4:
        case 5:
        case 9:
          return number + ' bloaz'

        default:
          return number + ' vloaz'
      }
    }
    function lastNumber(number) {
      if (number > 9) {
        return lastNumber(number % 10)
      }
      return number
    }
    function mutation(text, number) {
      if (number === 2) {
        return softMutation(text)
      }
      return text
    }
    function softMutation(text) {
      var mutationTable = {
        m: 'v',
        b: 'v',
        d: 'z',
      }
      if (mutationTable[text.charAt(0)] === undefined) {
        return text
      }
      return mutationTable[text.charAt(0)] + text.substring(1)
    }
    var monthsParse = [
        /^gen/i,
        /^c[ʼ\']hwe/i,
        /^meu/i,
        /^ebr/i,
        /^mae/i,
        /^(mez|eve)/i,
        /^gou/i,
        /^eos/i,
        /^gwe/i,
        /^her/i,
        /^du/i,
        /^ker/i,
      ],
      monthsRegex$1 =
        /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
      monthsStrictRegex =
        /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
      monthsShortStrictRegex =
        /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
      fullWeekdaysParse = [
        /^sul/i,
        /^lun/i,
        /^meurzh/i,
        /^merc[ʼ\']her/i,
        /^yaou/i,
        /^gwener/i,
        /^sadorn/i,
      ],
      shortWeekdaysParse = [
        /^Sul/i,
        /^Lun/i,
        /^Meu/i,
        /^Mer/i,
        /^Yao/i,
        /^Gwe/i,
        /^Sad/i,
      ],
      minWeekdaysParse = [
        /^Su/i,
        /^Lu/i,
        /^Me([^r]|$)/i,
        /^Mer/i,
        /^Ya/i,
        /^Gw/i,
        /^Sa/i,
      ]
    hooks.defineLocale('br', {
      months:
        'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
          '_'
        ),
      monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split(
        '_'
      ),
      weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
      weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
      weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
      weekdaysParse: minWeekdaysParse,
      fullWeekdaysParse: fullWeekdaysParse,
      shortWeekdaysParse: shortWeekdaysParse,
      minWeekdaysParse: minWeekdaysParse,
      monthsRegex: monthsRegex$1,
      monthsShortRegex: monthsRegex$1,
      monthsStrictRegex: monthsStrictRegex,
      monthsShortStrictRegex: monthsShortStrictRegex,
      monthsParse: monthsParse,
      longMonthsParse: monthsParse,
      shortMonthsParse: monthsParse,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D [a viz] MMMM YYYY',
        LLL: 'D [a viz] MMMM YYYY HH:mm',
        LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[Hiziv da] LT',
        nextDay: '[Warcʼhoazh da] LT',
        nextWeek: 'dddd [da] LT',
        lastDay: '[Decʼh da] LT',
        lastWeek: 'dddd [paset da] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'a-benn %s',
        past: '%s ʼzo',
        s: 'un nebeud segondennoù',
        ss: '%d eilenn',
        m: 'ur vunutenn',
        mm: relativeTimeWithMutation,
        h: 'un eur',
        hh: '%d eur',
        d: 'un devezh',
        dd: relativeTimeWithMutation,
        M: 'ur miz',
        MM: relativeTimeWithMutation,
        y: 'ur bloaz',
        yy: specialMutationForYears,
      },
      dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
      ordinal: function (number) {
        var output = number === 1 ? 'añ' : 'vet'
        return number + output
      },
      week: {
        dow: 1,
        doy: 4,
      },
      meridiemParse: /a.m.|g.m./,
      isPM: function (token) {
        return token === 'g.m.'
      },
      meridiem: function (hour, minute, isLower) {
        return hour < 12 ? 'a.m.' : 'g.m.'
      },
    })
    function translate(number, withoutSuffix, key) {
      var result = number + ' '
      switch (key) {
        case 'ss':
          if (number === 1) {
            result += 'sekunda'
          } else if (number === 2 || number === 3 || number === 4) {
            result += 'sekunde'
          } else {
            result += 'sekundi'
          }
          return result

        case 'm':
          return withoutSuffix ? 'jedna minuta' : 'jedne minute'

        case 'mm':
          if (number === 1) {
            result += 'minuta'
          } else if (number === 2 || number === 3 || number === 4) {
            result += 'minute'
          } else {
            result += 'minuta'
          }
          return result

        case 'h':
          return withoutSuffix ? 'jedan sat' : 'jednog sata'

        case 'hh':
          if (number === 1) {
            result += 'sat'
          } else if (number === 2 || number === 3 || number === 4) {
            result += 'sata'
          } else {
            result += 'sati'
          }
          return result

        case 'dd':
          if (number === 1) {
            result += 'dan'
          } else {
            result += 'dana'
          }
          return result

        case 'MM':
          if (number === 1) {
            result += 'mjesec'
          } else if (number === 2 || number === 3 || number === 4) {
            result += 'mjeseca'
          } else {
            result += 'mjeseci'
          }
          return result

        case 'yy':
          if (number === 1) {
            result += 'godina'
          } else if (number === 2 || number === 3 || number === 4) {
            result += 'godine'
          } else {
            result += 'godina'
          }
          return result
      }
    }
    hooks.defineLocale('bs', {
      months:
        'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
          '_'
        ),
      monthsShort:
        'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
          '_'
        ),
      monthsParseExact: true,
      weekdays:
        'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
      weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
      weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'H:mm',
        LTS: 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm',
      },
      calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sutra u] LT',
        nextWeek: function () {
          switch (this.day()) {
            case 0:
              return '[u] [nedjelju] [u] LT'

            case 3:
              return '[u] [srijedu] [u] LT'

            case 6:
              return '[u] [subotu] [u] LT'

            case 1:
            case 2:
            case 4:
            case 5:
              return '[u] dddd [u] LT'
          }
        },
        lastDay: '[jučer u] LT',
        lastWeek: function () {
          switch (this.day()) {
            case 0:
            case 3:
              return '[prošlu] dddd [u] LT'

            case 6:
              return '[prošle] [subote] [u] LT'

            case 1:
            case 2:
            case 4:
            case 5:
              return '[prošli] dddd [u] LT'
          }
        },
        sameElse: 'L',
      },
      relativeTime: {
        future: 'za %s',
        past: 'prije %s',
        s: 'par sekundi',
        ss: translate,
        m: translate,
        mm: translate,
        h: translate,
        hh: translate,
        d: 'dan',
        dd: translate,
        M: 'mjesec',
        MM: translate,
        y: 'godinu',
        yy: translate,
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: '%d.',
      week: {
        dow: 1,
        doy: 7,
      },
    })
    hooks.defineLocale('ca', {
      months: {
        standalone:
          'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
            '_'
          ),
        format:
          "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
            '_'
          ),
        isFormat: /D[oD]?(\s)+MMMM/,
      },
      monthsShort:
        'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
          '_'
        ),
      monthsParseExact: true,
      weekdays:
        'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
          '_'
        ),
      weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
      weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'H:mm',
        LTS: 'H:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM [de] YYYY',
        ll: 'D MMM YYYY',
        LLL: 'D MMMM [de] YYYY [a les] H:mm',
        lll: 'D MMM YYYY, H:mm',
        LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
        llll: 'ddd D MMM YYYY, H:mm',
      },
      calendar: {
        sameDay: function () {
          return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT'
        },
        nextDay: function () {
          return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT'
        },
        nextWeek: function () {
          return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT'
        },
        lastDay: function () {
          return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT'
        },
        lastWeek: function () {
          return (
            '[el] dddd [passat a ' +
            (this.hours() !== 1 ? 'les' : 'la') +
            '] LT'
          )
        },
        sameElse: 'L',
      },
      relativeTime: {
        future: "d'aquí %s",
        past: 'fa %s',
        s: 'uns segons',
        ss: '%d segons',
        m: 'un minut',
        mm: '%d minuts',
        h: 'una hora',
        hh: '%d hores',
        d: 'un dia',
        dd: '%d dies',
        M: 'un mes',
        MM: '%d mesos',
        y: 'un any',
        yy: '%d anys',
      },
      dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
      ordinal: function (number, period) {
        var output =
          number === 1
            ? 'r'
            : number === 2
              ? 'n'
              : number === 3
                ? 'r'
                : number === 4
                  ? 't'
                  : 'è'
        if (period === 'w' || period === 'W') {
          output = 'a'
        }
        return number + output
      },
      week: {
        dow: 1,
        doy: 4,
      },
    })
    var months$4 =
        'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
          '_'
        ),
      monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split(
        '_'
      ),
      monthsParse$1 = [
        /^led/i,
        /^úno/i,
        /^bře/i,
        /^dub/i,
        /^kvě/i,
        /^(čvn|červen$|června)/i,
        /^(čvc|červenec|července)/i,
        /^srp/i,
        /^zář/i,
        /^říj/i,
        /^lis/i,
        /^pro/i,
      ],
      monthsRegex$2 =
        /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i
    function plural$1(n) {
      return n > 1 && n < 5 && ~~(n / 10) !== 1
    }
    function translate$1(number, withoutSuffix, key, isFuture) {
      var result = number + ' '
      switch (key) {
        case 's':
          return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami'

        case 'ss':
          if (withoutSuffix || isFuture) {
            return result + (plural$1(number) ? 'sekundy' : 'sekund')
          } else {
            return result + 'sekundami'
          }

        case 'm':
          return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou'

        case 'mm':
          if (withoutSuffix || isFuture) {
            return result + (plural$1(number) ? 'minuty' : 'minut')
          } else {
            return result + 'minutami'
          }

        case 'h':
          return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou'

        case 'hh':
          if (withoutSuffix || isFuture) {
            return result + (plural$1(number) ? 'hodiny' : 'hodin')
          } else {
            return result + 'hodinami'
          }

        case 'd':
          return withoutSuffix || isFuture ? 'den' : 'dnem'

        case 'dd':
          if (withoutSuffix || isFuture) {
            return result + (plural$1(number) ? 'dny' : 'dní')
          } else {
            return result + 'dny'
          }

        case 'M':
          return withoutSuffix || isFuture ? 'měsíc' : 'měsícem'

        case 'MM':
          if (withoutSuffix || isFuture) {
            return result + (plural$1(number) ? 'měsíce' : 'měsíců')
          } else {
            return result + 'měsíci'
          }

        case 'y':
          return withoutSuffix || isFuture ? 'rok' : 'rokem'

        case 'yy':
          if (withoutSuffix || isFuture) {
            return result + (plural$1(number) ? 'roky' : 'let')
          } else {
            return result + 'lety'
          }
      }
    }
    hooks.defineLocale('cs', {
      months: months$4,
      monthsShort: monthsShort,
      monthsRegex: monthsRegex$2,
      monthsShortRegex: monthsRegex$2,
      monthsStrictRegex:
        /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
      monthsShortStrictRegex:
        /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
      monthsParse: monthsParse$1,
      longMonthsParse: monthsParse$1,
      shortMonthsParse: monthsParse$1,
      weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
      weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
      weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
      longDateFormat: {
        LT: 'H:mm',
        LTS: 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd D. MMMM YYYY H:mm',
        l: 'D. M. YYYY',
      },
      calendar: {
        sameDay: '[dnes v] LT',
        nextDay: '[zítra v] LT',
        nextWeek: function () {
          switch (this.day()) {
            case 0:
              return '[v neděli v] LT'

            case 1:
            case 2:
              return '[v] dddd [v] LT'

            case 3:
              return '[ve středu v] LT'

            case 4:
              return '[ve čtvrtek v] LT'

            case 5:
              return '[v pátek v] LT'

            case 6:
              return '[v sobotu v] LT'
          }
        },
        lastDay: '[včera v] LT',
        lastWeek: function () {
          switch (this.day()) {
            case 0:
              return '[minulou neděli v] LT'

            case 1:
            case 2:
              return '[minulé] dddd [v] LT'

            case 3:
              return '[minulou středu v] LT'

            case 4:
            case 5:
              return '[minulý] dddd [v] LT'

            case 6:
              return '[minulou sobotu v] LT'
          }
        },
        sameElse: 'L',
      },
      relativeTime: {
        future: 'za %s',
        past: 'před %s',
        s: translate$1,
        ss: translate$1,
        m: translate$1,
        mm: translate$1,
        h: translate$1,
        hh: translate$1,
        d: translate$1,
        dd: translate$1,
        M: translate$1,
        MM: translate$1,
        y: translate$1,
        yy: translate$1,
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: '%d.',
      week: {
        dow: 1,
        doy: 4,
      },
    })
    hooks.defineLocale('cv', {
      months:
        'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
          '_'
        ),
      monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
      weekdays:
        'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
          '_'
        ),
      weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
      weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD-MM-YYYY',
        LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
        LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
      },
      calendar: {
        sameDay: '[Паян] LT [сехетре]',
        nextDay: '[Ыран] LT [сехетре]',
        lastDay: '[Ӗнер] LT [сехетре]',
        nextWeek: '[Ҫитес] dddd LT [сехетре]',
        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
        sameElse: 'L',
      },
      relativeTime: {
        future: function (output) {
          var affix = /сехет$/i.exec(output)
            ? 'рен'
            : /ҫул$/i.exec(output)
              ? 'тан'
              : 'ран'
          return output + affix
        },
        past: '%s каялла',
        s: 'пӗр-ик ҫеккунт',
        ss: '%d ҫеккунт',
        m: 'пӗр минут',
        mm: '%d минут',
        h: 'пӗр сехет',
        hh: '%d сехет',
        d: 'пӗр кун',
        dd: '%d кун',
        M: 'пӗр уйӑх',
        MM: '%d уйӑх',
        y: 'пӗр ҫул',
        yy: '%d ҫул',
      },
      dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
      ordinal: '%d-мӗш',
      week: {
        dow: 1,
        doy: 7,
      },
    })
    hooks.defineLocale('cy', {
      months:
        'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
          '_'
        ),
      monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
        '_'
      ),
      weekdays:
        'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
          '_'
        ),
      weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
      weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[Heddiw am] LT',
        nextDay: '[Yfory am] LT',
        nextWeek: 'dddd [am] LT',
        lastDay: '[Ddoe am] LT',
        lastWeek: 'dddd [diwethaf am] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'mewn %s',
        past: '%s yn ôl',
        s: 'ychydig eiliadau',
        ss: '%d eiliad',
        m: 'munud',
        mm: '%d munud',
        h: 'awr',
        hh: '%d awr',
        d: 'diwrnod',
        dd: '%d diwrnod',
        M: 'mis',
        MM: '%d mis',
        y: 'blwyddyn',
        yy: '%d flynedd',
      },
      dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
      ordinal: function (number) {
        var b = number,
          output = '',
          lookup = [
            '',
            'af',
            'il',
            'ydd',
            'ydd',
            'ed',
            'ed',
            'ed',
            'fed',
            'fed',
            'fed',
            'eg',
            'fed',
            'eg',
            'eg',
            'fed',
            'eg',
            'eg',
            'fed',
            'eg',
            'fed',
          ]
        if (b > 20) {
          if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
            output = 'fed'
          } else {
            output = 'ain'
          }
        } else if (b > 0) {
          output = lookup[b]
        }
        return number + output
      },
      week: {
        dow: 1,
        doy: 4,
      },
    })
    hooks.defineLocale('da', {
      months:
        'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
          '_'
        ),
      monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
      weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
      weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
      weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY HH:mm',
        LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
      },
      calendar: {
        sameDay: '[i dag kl.] LT',
        nextDay: '[i morgen kl.] LT',
        nextWeek: 'på dddd [kl.] LT',
        lastDay: '[i går kl.] LT',
        lastWeek: '[i] dddd[s kl.] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'om %s',
        past: '%s siden',
        s: 'få sekunder',
        ss: '%d sekunder',
        m: 'et minut',
        mm: '%d minutter',
        h: 'en time',
        hh: '%d timer',
        d: 'en dag',
        dd: '%d dage',
        M: 'en måned',
        MM: '%d måneder',
        y: 'et år',
        yy: '%d år',
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: '%d.',
      week: {
        dow: 1,
        doy: 4,
      },
    })
    function processRelativeTime(number, withoutSuffix, key, isFuture) {
      var format = {
        m: ['eine Minute', 'einer Minute'],
        h: ['eine Stunde', 'einer Stunde'],
        d: ['ein Tag', 'einem Tag'],
        dd: [number + ' Tage', number + ' Tagen'],
        w: ['eine Woche', 'einer Woche'],
        M: ['ein Monat', 'einem Monat'],
        MM: [number + ' Monate', number + ' Monaten'],
        y: ['ein Jahr', 'einem Jahr'],
        yy: [number + ' Jahre', number + ' Jahren'],
      }
      return withoutSuffix ? format[key][0] : format[key][1]
    }
    hooks.defineLocale('de-at', {
      months:
        'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
          '_'
        ),
      monthsShort:
        'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
      monthsParseExact: true,
      weekdays:
        'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
          '_'
        ),
      weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
      weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY HH:mm',
        LLLL: 'dddd, D. MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]',
      },
      relativeTime: {
        future: 'in %s',
        past: 'vor %s',
        s: 'ein paar Sekunden',
        ss: '%d Sekunden',
        m: processRelativeTime,
        mm: '%d Minuten',
        h: processRelativeTime,
        hh: '%d Stunden',
        d: processRelativeTime,
        dd: processRelativeTime,
        w: processRelativeTime,
        ww: '%d Wochen',
        M: processRelativeTime,
        MM: processRelativeTime,
        y: processRelativeTime,
        yy: processRelativeTime,
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: '%d.',
      week: {
        dow: 1,
        doy: 4,
      },
    })
    function processRelativeTime$1(number, withoutSuffix, key, isFuture) {
      var format = {
        m: ['eine Minute', 'einer Minute'],
        h: ['eine Stunde', 'einer Stunde'],
        d: ['ein Tag', 'einem Tag'],
        dd: [number + ' Tage', number + ' Tagen'],
        w: ['eine Woche', 'einer Woche'],
        M: ['ein Monat', 'einem Monat'],
        MM: [number + ' Monate', number + ' Monaten'],
        y: ['ein Jahr', 'einem Jahr'],
        yy: [number + ' Jahre', number + ' Jahren'],
      }
      return withoutSuffix ? format[key][0] : format[key][1]
    }
    hooks.defineLocale('de-ch', {
      months:
        'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
          '_'
        ),
      monthsShort:
        'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
      monthsParseExact: true,
      weekdays:
        'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
          '_'
        ),
      weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
      weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY HH:mm',
        LLLL: 'dddd, D. MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]',
      },
      relativeTime: {
        future: 'in %s',
        past: 'vor %s',
        s: 'ein paar Sekunden',
        ss: '%d Sekunden',
        m: processRelativeTime$1,
        mm: '%d Minuten',
        h: processRelativeTime$1,
        hh: '%d Stunden',
        d: processRelativeTime$1,
        dd: processRelativeTime$1,
        w: processRelativeTime$1,
        ww: '%d Wochen',
        M: processRelativeTime$1,
        MM: processRelativeTime$1,
        y: processRelativeTime$1,
        yy: processRelativeTime$1,
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: '%d.',
      week: {
        dow: 1,
        doy: 4,
      },
    })
    function processRelativeTime$2(number, withoutSuffix, key, isFuture) {
      var format = {
        m: ['eine Minute', 'einer Minute'],
        h: ['eine Stunde', 'einer Stunde'],
        d: ['ein Tag', 'einem Tag'],
        dd: [number + ' Tage', number + ' Tagen'],
        w: ['eine Woche', 'einer Woche'],
        M: ['ein Monat', 'einem Monat'],
        MM: [number + ' Monate', number + ' Monaten'],
        y: ['ein Jahr', 'einem Jahr'],
        yy: [number + ' Jahre', number + ' Jahren'],
      }
      return withoutSuffix ? format[key][0] : format[key][1]
    }
    hooks.defineLocale('de', {
      months:
        'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
          '_'
        ),
      monthsShort:
        'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
      monthsParseExact: true,
      weekdays:
        'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
          '_'
        ),
      weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
      weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY HH:mm',
        LLLL: 'dddd, D. MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]',
      },
      relativeTime: {
        future: 'in %s',
        past: 'vor %s',
        s: 'ein paar Sekunden',
        ss: '%d Sekunden',
        m: processRelativeTime$2,
        mm: '%d Minuten',
        h: processRelativeTime$2,
        hh: '%d Stunden',
        d: processRelativeTime$2,
        dd: processRelativeTime$2,
        w: processRelativeTime$2,
        ww: '%d Wochen',
        M: processRelativeTime$2,
        MM: processRelativeTime$2,
        y: processRelativeTime$2,
        yy: processRelativeTime$2,
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: '%d.',
      week: {
        dow: 1,
        doy: 4,
      },
    })
    var months$5 = [
        'ޖެނުއަރީ',
        'ފެބްރުއަރީ',
        'މާރިޗު',
        'އޭޕްރީލު',
        'މޭ',
        'ޖޫން',
        'ޖުލައި',
        'އޯގަސްޓު',
        'ސެޕްޓެމްބަރު',
        'އޮކްޓޯބަރު',
        'ނޮވެމްބަރު',
        'ޑިސެމްބަރު',
      ],
      weekdays = [
        'އާދިއްތަ',
        'ހޯމަ',
        'އަންގާރަ',
        'ބުދަ',
        'ބުރާސްފަތި',
        'ހުކުރު',
        'ހޮނިހިރު',
      ]
    hooks.defineLocale('dv', {
      months: months$5,
      monthsShort: months$5,
      weekdays: weekdays,
      weekdaysShort: weekdays,
      weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'D/M/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm',
      },
      meridiemParse: /މކ|މފ/,
      isPM: function (input) {
        return 'މފ' === input
      },
      meridiem: function (hour, minute, isLower) {
        if (hour < 12) {
          return 'މކ'
        } else {
          return 'މފ'
        }
      },
      calendar: {
        sameDay: '[މިއަދު] LT',
        nextDay: '[މާދަމާ] LT',
        nextWeek: 'dddd LT',
        lastDay: '[އިއްޔެ] LT',
        lastWeek: '[ފާއިތުވި] dddd LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'ތެރޭގައި %s',
        past: 'ކުރިން %s',
        s: 'ސިކުންތުކޮޅެއް',
        ss: 'd% ސިކުންތު',
        m: 'މިނިޓެއް',
        mm: 'މިނިޓު %d',
        h: 'ގަޑިއިރެއް',
        hh: 'ގަޑިއިރު %d',
        d: 'ދުވަހެއް',
        dd: 'ދުވަސް %d',
        M: 'މަހެއް',
        MM: 'މަސް %d',
        y: 'އަހަރެއް',
        yy: 'އަހަރު %d',
      },
      preparse: function (string) {
        return string.replace(/،/g, ',')
      },
      postformat: function (string) {
        return string.replace(/,/g, '،')
      },
      week: {
        dow: 7,
        doy: 12,
      },
    })
    function isFunction$1(input) {
      return (
        (typeof Function !== 'undefined' && input instanceof Function) ||
        Object.prototype.toString.call(input) === '[object Function]'
      )
    }
    hooks.defineLocale('el', {
      monthsNominativeEl:
        'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
          '_'
        ),
      monthsGenitiveEl:
        'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
          '_'
        ),
      months: function (momentToFormat, format) {
        if (!momentToFormat) {
          return this._monthsNominativeEl
        } else if (
          typeof format === 'string' &&
          /D/.test(format.substring(0, format.indexOf('MMMM')))
        ) {
          return this._monthsGenitiveEl[momentToFormat.month()]
        } else {
          return this._monthsNominativeEl[momentToFormat.month()]
        }
      },
      monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split(
        '_'
      ),
      weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
        '_'
      ),
      weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
      weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
      meridiem: function (hours, minutes, isLower) {
        if (hours > 11) {
          return isLower ? 'μμ' : 'ΜΜ'
        } else {
          return isLower ? 'πμ' : 'ΠΜ'
        }
      },
      isPM: function (input) {
        return (input + '').toLowerCase()[0] === 'μ'
      },
      meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
      longDateFormat: {
        LT: 'h:mm A',
        LTS: 'h:mm:ss A',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY h:mm A',
        LLLL: 'dddd, D MMMM YYYY h:mm A',
      },
      calendarEl: {
        sameDay: '[Σήμερα {}] LT',
        nextDay: '[Αύριο {}] LT',
        nextWeek: 'dddd [{}] LT',
        lastDay: '[Χθες {}] LT',
        lastWeek: function () {
          switch (this.day()) {
            case 6:
              return '[το προηγούμενο] dddd [{}] LT'

            default:
              return '[την προηγούμενη] dddd [{}] LT'
          }
        },
        sameElse: 'L',
      },
      calendar: function (key, mom) {
        var output = this._calendarEl[key],
          hours = mom && mom.hours()
        if (isFunction$1(output)) {
          output = output.apply(mom)
        }
        return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις')
      },
      relativeTime: {
        future: 'σε %s',
        past: '%s πριν',
        s: 'λίγα δευτερόλεπτα',
        ss: '%d δευτερόλεπτα',
        m: 'ένα λεπτό',
        mm: '%d λεπτά',
        h: 'μία ώρα',
        hh: '%d ώρες',
        d: 'μία μέρα',
        dd: '%d μέρες',
        M: 'ένας μήνας',
        MM: '%d μήνες',
        y: 'ένας χρόνος',
        yy: '%d χρόνια',
      },
      dayOfMonthOrdinalParse: /\d{1,2}η/,
      ordinal: '%dη',
      week: {
        dow: 1,
        doy: 4,
      },
    })
    hooks.defineLocale('en-au', {
      months:
        'January_February_March_April_May_June_July_August_September_October_November_December'.split(
          '_'
        ),
      monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
      weekdays:
        'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
      weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
      weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
      longDateFormat: {
        LT: 'h:mm A',
        LTS: 'h:mm:ss A',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY h:mm A',
        LLLL: 'dddd, D MMMM YYYY h:mm A',
      },
      calendar: {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
      },
      dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
      ordinal: function (number) {
        var b = number % 10,
          output =
            ~~((number % 100) / 10) === 1
              ? 'th'
              : b === 1
                ? 'st'
                : b === 2
                  ? 'nd'
                  : b === 3
                    ? 'rd'
                    : 'th'
        return number + output
      },
      week: {
        dow: 0,
        doy: 4,
      },
    })
    hooks.defineLocale('en-ca', {
      months:
        'January_February_March_April_May_June_July_August_September_October_November_December'.split(
          '_'
        ),
      monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
      weekdays:
        'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
      weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
      weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
      longDateFormat: {
        LT: 'h:mm A',
        LTS: 'h:mm:ss A',
        L: 'YYYY-MM-DD',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
      },
      calendar: {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
      },
      dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
      ordinal: function (number) {
        var b = number % 10,
          output =
            ~~((number % 100) / 10) === 1
              ? 'th'
              : b === 1
                ? 'st'
                : b === 2
                  ? 'nd'
                  : b === 3
                    ? 'rd'
                    : 'th'
        return number + output
      },
    })
    hooks.defineLocale('en-gb', {
      months:
        'January_February_March_April_May_June_July_August_September_October_November_December'.split(
          '_'
        ),
      monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
      weekdays:
        'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
      weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
      weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
      },
      dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
      ordinal: function (number) {
        var b = number % 10,
          output =
            ~~((number % 100) / 10) === 1
              ? 'th'
              : b === 1
                ? 'st'
                : b === 2
                  ? 'nd'
                  : b === 3
                    ? 'rd'
                    : 'th'
        return number + output
      },
      week: {
        dow: 1,
        doy: 4,
      },
    })
    hooks.defineLocale('en-ie', {
      months:
        'January_February_March_April_May_June_July_August_September_October_November_December'.split(
          '_'
        ),
      monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
      weekdays:
        'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
      weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
      weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
      },
      dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
      ordinal: function (number) {
        var b = number % 10,
          output =
            ~~((number % 100) / 10) === 1
              ? 'th'
              : b === 1
                ? 'st'
                : b === 2
                  ? 'nd'
                  : b === 3
                    ? 'rd'
                    : 'th'
        return number + output
      },
      week: {
        dow: 1,
        doy: 4,
      },
    })
    hooks.defineLocale('en-il', {
      months:
        'January_February_March_April_May_June_July_August_September_October_November_December'.split(
          '_'
        ),
      monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
      weekdays:
        'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
      weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
      weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
      },
      dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
      ordinal: function (number) {
        var b = number % 10,
          output =
            ~~((number % 100) / 10) === 1
              ? 'th'
              : b === 1
                ? 'st'
                : b === 2
                  ? 'nd'
                  : b === 3
                    ? 'rd'
                    : 'th'
        return number + output
      },
    })
    hooks.defineLocale('en-in', {
      months:
        'January_February_March_April_May_June_July_August_September_October_November_December'.split(
          '_'
        ),
      monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
      weekdays:
        'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
      weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
      weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
      longDateFormat: {
        LT: 'h:mm A',
        LTS: 'h:mm:ss A',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY h:mm A',
        LLLL: 'dddd, D MMMM YYYY h:mm A',
      },
      calendar: {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
      },
      dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
      ordinal: function (number) {
        var b = number % 10,
          output =
            ~~((number % 100) / 10) === 1
              ? 'th'
              : b === 1
                ? 'st'
                : b === 2
                  ? 'nd'
                  : b === 3
                    ? 'rd'
                    : 'th'
        return number + output
      },
      week: {
        dow: 0,
        doy: 6,
      },
    })
    hooks.defineLocale('en-nz', {
      months:
        'January_February_March_April_May_June_July_August_September_October_November_December'.split(
          '_'
        ),
      monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
      weekdays:
        'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
      weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
      weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
      longDateFormat: {
        LT: 'h:mm A',
        LTS: 'h:mm:ss A',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY h:mm A',
        LLLL: 'dddd, D MMMM YYYY h:mm A',
      },
      calendar: {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
      },
      dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
      ordinal: function (number) {
        var b = number % 10,
          output =
            ~~((number % 100) / 10) === 1
              ? 'th'
              : b === 1
                ? 'st'
                : b === 2
                  ? 'nd'
                  : b === 3
                    ? 'rd'
                    : 'th'
        return number + output
      },
      week: {
        dow: 1,
        doy: 4,
      },
    })
    hooks.defineLocale('en-sg', {
      months:
        'January_February_March_April_May_June_July_August_September_October_November_December'.split(
          '_'
        ),
      monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
      weekdays:
        'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
      weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
      weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
      },
      dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
      ordinal: function (number) {
        var b = number % 10,
          output =
            ~~((number % 100) / 10) === 1
              ? 'th'
              : b === 1
                ? 'st'
                : b === 2
                  ? 'nd'
                  : b === 3
                    ? 'rd'
                    : 'th'
        return number + output
      },
      week: {
        dow: 1,
        doy: 4,
      },
    })
    hooks.defineLocale('eo', {
      months:
        'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
          '_'
        ),
      monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split(
        '_'
      ),
      weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
      weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
      weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'YYYY-MM-DD',
        LL: '[la] D[-an de] MMMM, YYYY',
        LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
        LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
        llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
      },
      meridiemParse: /[ap]\.t\.m/i,
      isPM: function (input) {
        return input.charAt(0).toLowerCase() === 'p'
      },
      meridiem: function (hours, minutes, isLower) {
        if (hours > 11) {
          return isLower ? 'p.t.m.' : 'P.T.M.'
        } else {
          return isLower ? 'a.t.m.' : 'A.T.M.'
        }
      },
      calendar: {
        sameDay: '[Hodiaŭ je] LT',
        nextDay: '[Morgaŭ je] LT',
        nextWeek: 'dddd[n je] LT',
        lastDay: '[Hieraŭ je] LT',
        lastWeek: '[pasintan] dddd[n je] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'post %s',
        past: 'antaŭ %s',
        s: 'kelkaj sekundoj',
        ss: '%d sekundoj',
        m: 'unu minuto',
        mm: '%d minutoj',
        h: 'unu horo',
        hh: '%d horoj',
        d: 'unu tago',
        dd: '%d tagoj',
        M: 'unu monato',
        MM: '%d monatoj',
        y: 'unu jaro',
        yy: '%d jaroj',
      },
      dayOfMonthOrdinalParse: /\d{1,2}a/,
      ordinal: '%da',
      week: {
        dow: 1,
        doy: 7,
      },
    })
    var monthsShortDot =
        'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
          '_'
        ),
      monthsShort$1 = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split(
        '_'
      ),
      monthsParse$2 = [
        /^ene/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i,
      ],
      monthsRegex$3 =
        /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i
    hooks.defineLocale('es-do', {
      months:
        'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
          '_'
        ),
      monthsShort: function (m, format) {
        if (!m) {
          return monthsShortDot
        } else if (/-MMM-/.test(format)) {
          return monthsShort$1[m.month()]
        } else {
          return monthsShortDot[m.month()]
        }
      },
      monthsRegex: monthsRegex$3,
      monthsShortRegex: monthsRegex$3,
      monthsStrictRegex:
        /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
      monthsShortStrictRegex:
        /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
      monthsParse: monthsParse$2,
      longMonthsParse: monthsParse$2,
      shortMonthsParse: monthsParse$2,
      weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split(
        '_'
      ),
      weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
      weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'h:mm A',
        LTS: 'h:mm:ss A',
        L: 'DD/MM/YYYY',
        LL: 'D [de] MMMM [de] YYYY',
        LLL: 'D [de] MMMM [de] YYYY h:mm A',
        LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
      },
      calendar: {
        sameDay: function () {
          return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT'
        },
        nextDay: function () {
          return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT'
        },
        nextWeek: function () {
          return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT'
        },
        lastDay: function () {
          return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT'
        },
        lastWeek: function () {
          return (
            '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT'
          )
        },
        sameElse: 'L',
      },
      relativeTime: {
        future: 'en %s',
        past: 'hace %s',
        s: 'unos segundos',
        ss: '%d segundos',
        m: 'un minuto',
        mm: '%d minutos',
        h: 'una hora',
        hh: '%d horas',
        d: 'un día',
        dd: '%d días',
        w: 'una semana',
        ww: '%d semanas',
        M: 'un mes',
        MM: '%d meses',
        y: 'un año',
        yy: '%d años',
      },
      dayOfMonthOrdinalParse: /\d{1,2}º/,
      ordinal: '%dº',
      week: {
        dow: 1,
        doy: 4,
      },
    })
    var monthsShortDot$1 =
        'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
          '_'
        ),
      monthsShort$2 = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split(
        '_'
      ),
      monthsParse$3 = [
        /^ene/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i,
      ],
      monthsRegex$4 =
        /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i
    hooks.defineLocale('es-mx', {
      months:
        'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
          '_'
        ),
      monthsShort: function (m, format) {
        if (!m) {
          return monthsShortDot$1
        } else if (/-MMM-/.test(format)) {
          return monthsShort$2[m.month()]
        } else {
          return monthsShortDot$1[m.month()]
        }
      },
      monthsRegex: monthsRegex$4,
      monthsShortRegex: monthsRegex$4,
      monthsStrictRegex:
        /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
      monthsShortStrictRegex:
        /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
      monthsParse: monthsParse$3,
      longMonthsParse: monthsParse$3,
      shortMonthsParse: monthsParse$3,
      weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split(
        '_'
      ),
      weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
      weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'H:mm',
        LTS: 'H:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D [de] MMMM [de] YYYY',
        LLL: 'D [de] MMMM [de] YYYY H:mm',
        LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
      },
      calendar: {
        sameDay: function () {
          return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT'
        },
        nextDay: function () {
          return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT'
        },
        nextWeek: function () {
          return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT'
        },
        lastDay: function () {
          return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT'
        },
        lastWeek: function () {
          return (
            '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT'
          )
        },
        sameElse: 'L',
      },
      relativeTime: {
        future: 'en %s',
        past: 'hace %s',
        s: 'unos segundos',
        ss: '%d segundos',
        m: 'un minuto',
        mm: '%d minutos',
        h: 'una hora',
        hh: '%d horas',
        d: 'un día',
        dd: '%d días',
        w: 'una semana',
        ww: '%d semanas',
        M: 'un mes',
        MM: '%d meses',
        y: 'un año',
        yy: '%d años',
      },
      dayOfMonthOrdinalParse: /\d{1,2}º/,
      ordinal: '%dº',
      week: {
        dow: 0,
        doy: 4,
      },
      invalidDate: 'Fecha inválida',
    })
    var monthsShortDot$2 =
        'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
          '_'
        ),
      monthsShort$3 = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split(
        '_'
      ),
      monthsParse$4 = [
        /^ene/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i,
      ],
      monthsRegex$5 =
        /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i
    hooks.defineLocale('es-us', {
      months:
        'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
          '_'
        ),
      monthsShort: function (m, format) {
        if (!m) {
          return monthsShortDot$2
        } else if (/-MMM-/.test(format)) {
          return monthsShort$3[m.month()]
        } else {
          return monthsShortDot$2[m.month()]
        }
      },
      monthsRegex: monthsRegex$5,
      monthsShortRegex: monthsRegex$5,
      monthsStrictRegex:
        /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
      monthsShortStrictRegex:
        /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
      monthsParse: monthsParse$4,
      longMonthsParse: monthsParse$4,
      shortMonthsParse: monthsParse$4,
      weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split(
        '_'
      ),
      weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
      weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'h:mm A',
        LTS: 'h:mm:ss A',
        L: 'MM/DD/YYYY',
        LL: 'D [de] MMMM [de] YYYY',
        LLL: 'D [de] MMMM [de] YYYY h:mm A',
        LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
      },
      calendar: {
        sameDay: function () {
          return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT'
        },
        nextDay: function () {
          return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT'
        },
        nextWeek: function () {
          return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT'
        },
        lastDay: function () {
          return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT'
        },
        lastWeek: function () {
          return (
            '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT'
          )
        },
        sameElse: 'L',
      },
      relativeTime: {
        future: 'en %s',
        past: 'hace %s',
        s: 'unos segundos',
        ss: '%d segundos',
        m: 'un minuto',
        mm: '%d minutos',
        h: 'una hora',
        hh: '%d horas',
        d: 'un día',
        dd: '%d días',
        w: 'una semana',
        ww: '%d semanas',
        M: 'un mes',
        MM: '%d meses',
        y: 'un año',
        yy: '%d años',
      },
      dayOfMonthOrdinalParse: /\d{1,2}º/,
      ordinal: '%dº',
      week: {
        dow: 0,
        doy: 6,
      },
    })
    var monthsShortDot$3 =
        'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
          '_'
        ),
      monthsShort$4 = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split(
        '_'
      ),
      monthsParse$5 = [
        /^ene/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i,
      ],
      monthsRegex$6 =
        /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i
    hooks.defineLocale('es', {
      months:
        'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
          '_'
        ),
      monthsShort: function (m, format) {
        if (!m) {
          return monthsShortDot$3
        } else if (/-MMM-/.test(format)) {
          return monthsShort$4[m.month()]
        } else {
          return monthsShortDot$3[m.month()]
        }
      },
      monthsRegex: monthsRegex$6,
      monthsShortRegex: monthsRegex$6,
      monthsStrictRegex:
        /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
      monthsShortStrictRegex:
        /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
      monthsParse: monthsParse$5,
      longMonthsParse: monthsParse$5,
      shortMonthsParse: monthsParse$5,
      weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split(
        '_'
      ),
      weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
      weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'H:mm',
        LTS: 'H:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D [de] MMMM [de] YYYY',
        LLL: 'D [de] MMMM [de] YYYY H:mm',
        LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
      },
      calendar: {
        sameDay: function () {
          return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT'
        },
        nextDay: function () {
          return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT'
        },
        nextWeek: function () {
          return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT'
        },
        lastDay: function () {
          return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT'
        },
        lastWeek: function () {
          return (
            '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT'
          )
        },
        sameElse: 'L',
      },
      relativeTime: {
        future: 'en %s',
        past: 'hace %s',
        s: 'unos segundos',
        ss: '%d segundos',
        m: 'un minuto',
        mm: '%d minutos',
        h: 'una hora',
        hh: '%d horas',
        d: 'un día',
        dd: '%d días',
        w: 'una semana',
        ww: '%d semanas',
        M: 'un mes',
        MM: '%d meses',
        y: 'un año',
        yy: '%d años',
      },
      dayOfMonthOrdinalParse: /\d{1,2}º/,
      ordinal: '%dº',
      week: {
        dow: 1,
        doy: 4,
      },
      invalidDate: 'Fecha inválida',
    })
    function processRelativeTime$3(number, withoutSuffix, key, isFuture) {
      var format = {
        s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
        ss: [number + 'sekundi', number + 'sekundit'],
        m: ['ühe minuti', 'üks minut'],
        mm: [number + ' minuti', number + ' minutit'],
        h: ['ühe tunni', 'tund aega', 'üks tund'],
        hh: [number + ' tunni', number + ' tundi'],
        d: ['ühe päeva', 'üks päev'],
        M: ['kuu aja', 'kuu aega', 'üks kuu'],
        MM: [number + ' kuu', number + ' kuud'],
        y: ['ühe aasta', 'aasta', 'üks aasta'],
        yy: [number + ' aasta', number + ' aastat'],
      }
      if (withoutSuffix) {
        return format[key][2] ? format[key][2] : format[key][1]
      }
      return isFuture ? format[key][0] : format[key][1]
    }
    hooks.defineLocale('et', {
      months:
        'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
          '_'
        ),
      monthsShort:
        'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
      weekdays:
        'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
          '_'
        ),
      weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
      weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
      longDateFormat: {
        LT: 'H:mm',
        LTS: 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm',
      },
      calendar: {
        sameDay: '[Täna,] LT',
        nextDay: '[Homme,] LT',
        nextWeek: '[Järgmine] dddd LT',
        lastDay: '[Eile,] LT',
        lastWeek: '[Eelmine] dddd LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: '%s pärast',
        past: '%s tagasi',
        s: processRelativeTime$3,
        ss: processRelativeTime$3,
        m: processRelativeTime$3,
        mm: processRelativeTime$3,
        h: processRelativeTime$3,
        hh: processRelativeTime$3,
        d: processRelativeTime$3,
        dd: '%d päeva',
        M: processRelativeTime$3,
        MM: processRelativeTime$3,
        y: processRelativeTime$3,
        yy: processRelativeTime$3,
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: '%d.',
      week: {
        dow: 1,
        doy: 4,
      },
    })
    hooks.defineLocale('eu', {
      months:
        'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
          '_'
        ),
      monthsShort:
        'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
          '_'
        ),
      monthsParseExact: true,
      weekdays:
        'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
          '_'
        ),
      weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
      weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'YYYY-MM-DD',
        LL: 'YYYY[ko] MMMM[ren] D[a]',
        LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
        LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
        l: 'YYYY-M-D',
        ll: 'YYYY[ko] MMM D[a]',
        lll: 'YYYY[ko] MMM D[a] HH:mm',
        llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
      },
      calendar: {
        sameDay: '[gaur] LT[etan]',
        nextDay: '[bihar] LT[etan]',
        nextWeek: 'dddd LT[etan]',
        lastDay: '[atzo] LT[etan]',
        lastWeek: '[aurreko] dddd LT[etan]',
        sameElse: 'L',
      },
      relativeTime: {
        future: '%s barru',
        past: 'duela %s',
        s: 'segundo batzuk',
        ss: '%d segundo',
        m: 'minutu bat',
        mm: '%d minutu',
        h: 'ordu bat',
        hh: '%d ordu',
        d: 'egun bat',
        dd: '%d egun',
        M: 'hilabete bat',
        MM: '%d hilabete',
        y: 'urte bat',
        yy: '%d urte',
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: '%d.',
      week: {
        dow: 1,
        doy: 7,
      },
    })
    var symbolMap$6 = {
        1: '۱',
        2: '۲',
        3: '۳',
        4: '۴',
        5: '۵',
        6: '۶',
        7: '۷',
        8: '۸',
        9: '۹',
        0: '۰',
      },
      numberMap$5 = {
        '۱': '1',
        '۲': '2',
        '۳': '3',
        '۴': '4',
        '۵': '5',
        '۶': '6',
        '۷': '7',
        '۸': '8',
        '۹': '9',
        '۰': '0',
      }
    hooks.defineLocale('fa', {
      months:
        'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
          '_'
        ),
      monthsShort:
        'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
          '_'
        ),
      weekdays: 'یک‌شنبه_دوشنبه_سه‌شنبه_چهارشنبه_پنج‌شنبه_جمعه_شنبه'.split('_'),
      weekdaysShort: 'یک‌شنبه_دوشنبه_سه‌شنبه_چهارشنبه_پنج‌شنبه_جمعه_شنبه'.split(
        '_'
      ),
      weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm',
      },
      meridiemParse: /قبل از ظهر|بعد از ظهر/,
      isPM: function (input) {
        return /بعد از ظهر/.test(input)
      },
      meridiem: function (hour, minute, isLower) {
        if (hour < 12) {
          return 'قبل از ظهر'
        } else {
          return 'بعد از ظهر'
        }
      },
      calendar: {
        sameDay: '[امروز ساعت] LT',
        nextDay: '[فردا ساعت] LT',
        nextWeek: 'dddd [ساعت] LT',
        lastDay: '[دیروز ساعت] LT',
        lastWeek: 'dddd [پیش] [ساعت] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'در %s',
        past: '%s پیش',
        s: 'چند ثانیه',
        ss: '%d ثانیه',
        m: 'یک دقیقه',
        mm: '%d دقیقه',
        h: 'یک ساعت',
        hh: '%d ساعت',
        d: 'یک روز',
        dd: '%d روز',
        M: 'یک ماه',
        MM: '%d ماه',
        y: 'یک سال',
        yy: '%d سال',
      },
      preparse: function (string) {
        return string
          .replace(/[۰-۹]/g, function (match) {
            return numberMap$5[match]
          })
          .replace(/،/g, ',')
      },
      postformat: function (string) {
        return string
          .replace(/\d/g, function (match) {
            return symbolMap$6[match]
          })
          .replace(/,/g, '،')
      },
      dayOfMonthOrdinalParse: /\d{1,2}م/,
      ordinal: '%dم',
      week: {
        dow: 6,
        doy: 12,
      },
    })
    var numbersPast =
        'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
          ' '
        ),
      numbersFuture = [
        'nolla',
        'yhden',
        'kahden',
        'kolmen',
        'neljän',
        'viiden',
        'kuuden',
        numbersPast[7],
        numbersPast[8],
        numbersPast[9],
      ]
    function translate$2(number, withoutSuffix, key, isFuture) {
      var result = ''
      switch (key) {
        case 's':
          return isFuture ? 'muutaman sekunnin' : 'muutama sekunti'

        case 'ss':
          result = isFuture ? 'sekunnin' : 'sekuntia'
          break

        case 'm':
          return isFuture ? 'minuutin' : 'minuutti'

        case 'mm':
          result = isFuture ? 'minuutin' : 'minuuttia'
          break

        case 'h':
          return isFuture ? 'tunnin' : 'tunti'

        case 'hh':
          result = isFuture ? 'tunnin' : 'tuntia'
          break

        case 'd':
          return isFuture ? 'päivän' : 'päivä'

        case 'dd':
          result = isFuture ? 'päivän' : 'päivää'
          break

        case 'M':
          return isFuture ? 'kuukauden' : 'kuukausi'

        case 'MM':
          result = isFuture ? 'kuukauden' : 'kuukautta'
          break

        case 'y':
          return isFuture ? 'vuoden' : 'vuosi'

        case 'yy':
          result = isFuture ? 'vuoden' : 'vuotta'
          break
      }
      result = verbalNumber(number, isFuture) + ' ' + result
      return result
    }
    function verbalNumber(number, isFuture) {
      return number < 10
        ? isFuture
          ? numbersFuture[number]
          : numbersPast[number]
        : number
    }
    hooks.defineLocale('fi', {
      months:
        'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
          '_'
        ),
      monthsShort:
        'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
          '_'
        ),
      weekdays:
        'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
          '_'
        ),
      weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
      weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
      longDateFormat: {
        LT: 'HH.mm',
        LTS: 'HH.mm.ss',
        L: 'DD.MM.YYYY',
        LL: 'Do MMMM[ta] YYYY',
        LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
        LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
        l: 'D.M.YYYY',
        ll: 'Do MMM YYYY',
        lll: 'Do MMM YYYY, [klo] HH.mm',
        llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
      },
      calendar: {
        sameDay: '[tänään] [klo] LT',
        nextDay: '[huomenna] [klo] LT',
        nextWeek: 'dddd [klo] LT',
        lastDay: '[eilen] [klo] LT',
        lastWeek: '[viime] dddd[na] [klo] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: '%s päästä',
        past: '%s sitten',
        s: translate$2,
        ss: translate$2,
        m: translate$2,
        mm: translate$2,
        h: translate$2,
        hh: translate$2,
        d: translate$2,
        dd: translate$2,
        M: translate$2,
        MM: translate$2,
        y: translate$2,
        yy: translate$2,
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: '%d.',
      week: {
        dow: 1,
        doy: 4,
      },
    })
    hooks.defineLocale('fil', {
      months:
        'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
          '_'
        ),
      monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
      weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
        '_'
      ),
      weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
      weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'MM/D/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY HH:mm',
        LLLL: 'dddd, MMMM DD, YYYY HH:mm',
      },
      calendar: {
        sameDay: 'LT [ngayong araw]',
        nextDay: '[Bukas ng] LT',
        nextWeek: 'LT [sa susunod na] dddd',
        lastDay: 'LT [kahapon]',
        lastWeek: 'LT [noong nakaraang] dddd',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'sa loob ng %s',
        past: '%s ang nakalipas',
        s: 'ilang segundo',
        ss: '%d segundo',
        m: 'isang minuto',
        mm: '%d minuto',
        h: 'isang oras',
        hh: '%d oras',
        d: 'isang araw',
        dd: '%d araw',
        M: 'isang buwan',
        MM: '%d buwan',
        y: 'isang taon',
        yy: '%d taon',
      },
      dayOfMonthOrdinalParse: /\d{1,2}/,
      ordinal: function (number) {
        return number
      },
      week: {
        dow: 1,
        doy: 4,
      },
    })
    hooks.defineLocale('fo', {
      months:
        'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
          '_'
        ),
      monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
      weekdays:
        'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
          '_'
        ),
      weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
      weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D. MMMM, YYYY HH:mm',
      },
      calendar: {
        sameDay: '[Í dag kl.] LT',
        nextDay: '[Í morgin kl.] LT',
        nextWeek: 'dddd [kl.] LT',
        lastDay: '[Í gjár kl.] LT',
        lastWeek: '[síðstu] dddd [kl] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'um %s',
        past: '%s síðani',
        s: 'fá sekund',
        ss: '%d sekundir',
        m: 'ein minuttur',
        mm: '%d minuttir',
        h: 'ein tími',
        hh: '%d tímar',
        d: 'ein dagur',
        dd: '%d dagar',
        M: 'ein mánaður',
        MM: '%d mánaðir',
        y: 'eitt ár',
        yy: '%d ár',
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: '%d.',
      week: {
        dow: 1,
        doy: 4,
      },
    })
    hooks.defineLocale('fr-ca', {
      months:
        'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
          '_'
        ),
      monthsShort:
        'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
          '_'
        ),
      monthsParseExact: true,
      weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split(
        '_'
      ),
      weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
      weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'YYYY-MM-DD',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[Aujourd’hui à] LT',
        nextDay: '[Demain à] LT',
        nextWeek: 'dddd [à] LT',
        lastDay: '[Hier à] LT',
        lastWeek: 'dddd [dernier à] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'dans %s',
        past: 'il y a %s',
        s: 'quelques secondes',
        ss: '%d secondes',
        m: 'une minute',
        mm: '%d minutes',
        h: 'une heure',
        hh: '%d heures',
        d: 'un jour',
        dd: '%d jours',
        M: 'un mois',
        MM: '%d mois',
        y: 'un an',
        yy: '%d ans',
      },
      dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
      ordinal: function (number, period) {
        switch (period) {
          default:
          case 'M':
          case 'Q':
          case 'D':
          case 'DDD':
          case 'd':
            return number + (number === 1 ? 'er' : 'e')

          case 'w':
          case 'W':
            return number + (number === 1 ? 're' : 'e')
        }
      },
    })
    hooks.defineLocale('fr-ch', {
      months:
        'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
          '_'
        ),
      monthsShort:
        'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
          '_'
        ),
      monthsParseExact: true,
      weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split(
        '_'
      ),
      weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
      weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[Aujourd’hui à] LT',
        nextDay: '[Demain à] LT',
        nextWeek: 'dddd [à] LT',
        lastDay: '[Hier à] LT',
        lastWeek: 'dddd [dernier à] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'dans %s',
        past: 'il y a %s',
        s: 'quelques secondes',
        ss: '%d secondes',
        m: 'une minute',
        mm: '%d minutes',
        h: 'une heure',
        hh: '%d heures',
        d: 'un jour',
        dd: '%d jours',
        M: 'un mois',
        MM: '%d mois',
        y: 'un an',
        yy: '%d ans',
      },
      dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
      ordinal: function (number, period) {
        switch (period) {
          default:
          case 'M':
          case 'Q':
          case 'D':
          case 'DDD':
          case 'd':
            return number + (number === 1 ? 'er' : 'e')

          case 'w':
          case 'W':
            return number + (number === 1 ? 're' : 'e')
        }
      },
      week: {
        dow: 1,
        doy: 4,
      },
    })
    var monthsStrictRegex$1 =
        /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
      monthsShortStrictRegex$1 =
        /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
      monthsRegex$7 =
        /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
      monthsParse$6 = [
        /^janv/i,
        /^févr/i,
        /^mars/i,
        /^avr/i,
        /^mai/i,
        /^juin/i,
        /^juil/i,
        /^août/i,
        /^sept/i,
        /^oct/i,
        /^nov/i,
        /^déc/i,
      ]
    hooks.defineLocale('fr', {
      months:
        'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
          '_'
        ),
      monthsShort:
        'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
          '_'
        ),
      monthsRegex: monthsRegex$7,
      monthsShortRegex: monthsRegex$7,
      monthsStrictRegex: monthsStrictRegex$1,
      monthsShortStrictRegex: monthsShortStrictRegex$1,
      monthsParse: monthsParse$6,
      longMonthsParse: monthsParse$6,
      shortMonthsParse: monthsParse$6,
      weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split(
        '_'
      ),
      weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
      weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[Aujourd’hui à] LT',
        nextDay: '[Demain à] LT',
        nextWeek: 'dddd [à] LT',
        lastDay: '[Hier à] LT',
        lastWeek: 'dddd [dernier à] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'dans %s',
        past: 'il y a %s',
        s: 'quelques secondes',
        ss: '%d secondes',
        m: 'une minute',
        mm: '%d minutes',
        h: 'une heure',
        hh: '%d heures',
        d: 'un jour',
        dd: '%d jours',
        w: 'une semaine',
        ww: '%d semaines',
        M: 'un mois',
        MM: '%d mois',
        y: 'un an',
        yy: '%d ans',
      },
      dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
      ordinal: function (number, period) {
        switch (period) {
          case 'D':
            return number + (number === 1 ? 'er' : '')

          default:
          case 'M':
          case 'Q':
          case 'DDD':
          case 'd':
            return number + (number === 1 ? 'er' : 'e')

          case 'w':
          case 'W':
            return number + (number === 1 ? 're' : 'e')
        }
      },
      week: {
        dow: 1,
        doy: 4,
      },
    })
    var monthsShortWithDots =
        'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
      monthsShortWithoutDots =
        'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_')
    hooks.defineLocale('fy', {
      months:
        'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
          '_'
        ),
      monthsShort: function (m, format) {
        if (!m) {
          return monthsShortWithDots
        } else if (/-MMM-/.test(format)) {
          return monthsShortWithoutDots[m.month()]
        } else {
          return monthsShortWithDots[m.month()]
        }
      },
      monthsParseExact: true,
      weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
        '_'
      ),
      weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
      weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD-MM-YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[hjoed om] LT',
        nextDay: '[moarn om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[juster om] LT',
        lastWeek: '[ôfrûne] dddd [om] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'oer %s',
        past: '%s lyn',
        s: 'in pear sekonden',
        ss: '%d sekonden',
        m: 'ien minút',
        mm: '%d minuten',
        h: 'ien oere',
        hh: '%d oeren',
        d: 'ien dei',
        dd: '%d dagen',
        M: 'ien moanne',
        MM: '%d moannen',
        y: 'ien jier',
        yy: '%d jierren',
      },
      dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
      ordinal: function (number) {
        return (
          number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
        )
      },
      week: {
        dow: 1,
        doy: 4,
      },
    })
    var months$6 = [
        'Eanáir',
        'Feabhra',
        'Márta',
        'Aibreán',
        'Bealtaine',
        'Meitheamh',
        'Iúil',
        'Lúnasa',
        'Meán Fómhair',
        'Deireadh Fómhair',
        'Samhain',
        'Nollaig',
      ],
      monthsShort$5 = [
        'Ean',
        'Feabh',
        'Márt',
        'Aib',
        'Beal',
        'Meith',
        'Iúil',
        'Lún',
        'M.F.',
        'D.F.',
        'Samh',
        'Noll',
      ],
      weekdays$1 = [
        'Dé Domhnaigh',
        'Dé Luain',
        'Dé Máirt',
        'Dé Céadaoin',
        'Déardaoin',
        'Dé hAoine',
        'Dé Sathairn',
      ],
      weekdaysShort = [
        'Domh',
        'Luan',
        'Máirt',
        'Céad',
        'Déar',
        'Aoine',
        'Sath',
      ],
      weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa']
    hooks.defineLocale('ga', {
      months: months$6,
      monthsShort: monthsShort$5,
      monthsParseExact: true,
      weekdays: weekdays$1,
      weekdaysShort: weekdaysShort,
      weekdaysMin: weekdaysMin,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[Inniu ag] LT',
        nextDay: '[Amárach ag] LT',
        nextWeek: 'dddd [ag] LT',
        lastDay: '[Inné ag] LT',
        lastWeek: 'dddd [seo caite] [ag] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'i %s',
        past: '%s ó shin',
        s: 'cúpla soicind',
        ss: '%d soicind',
        m: 'nóiméad',
        mm: '%d nóiméad',
        h: 'uair an chloig',
        hh: '%d uair an chloig',
        d: 'lá',
        dd: '%d lá',
        M: 'mí',
        MM: '%d míonna',
        y: 'bliain',
        yy: '%d bliain',
      },
      dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
      ordinal: function (number) {
        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh'
        return number + output
      },
      week: {
        dow: 1,
        doy: 4,
      },
    })
    var months$7 = [
        'Am Faoilleach',
        'An Gearran',
        'Am Màrt',
        'An Giblean',
        'An Cèitean',
        'An t-Ògmhios',
        'An t-Iuchar',
        'An Lùnastal',
        'An t-Sultain',
        'An Dàmhair',
        'An t-Samhain',
        'An Dùbhlachd',
      ],
      monthsShort$6 = [
        'Faoi',
        'Gear',
        'Màrt',
        'Gibl',
        'Cèit',
        'Ògmh',
        'Iuch',
        'Lùn',
        'Sult',
        'Dàmh',
        'Samh',
        'Dùbh',
      ],
      weekdays$2 = [
        'Didòmhnaich',
        'Diluain',
        'Dimàirt',
        'Diciadain',
        'Diardaoin',
        'Dihaoine',
        'Disathairne',
      ],
      weekdaysShort$1 = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
      weekdaysMin$1 = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa']
    hooks.defineLocale('gd', {
      months: months$7,
      monthsShort: monthsShort$6,
      monthsParseExact: true,
      weekdays: weekdays$2,
      weekdaysShort: weekdaysShort$1,
      weekdaysMin: weekdaysMin$1,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[An-diugh aig] LT',
        nextDay: '[A-màireach aig] LT',
        nextWeek: 'dddd [aig] LT',
        lastDay: '[An-dè aig] LT',
        lastWeek: 'dddd [seo chaidh] [aig] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'ann an %s',
        past: 'bho chionn %s',
        s: 'beagan diogan',
        ss: '%d diogan',
        m: 'mionaid',
        mm: '%d mionaidean',
        h: 'uair',
        hh: '%d uairean',
        d: 'latha',
        dd: '%d latha',
        M: 'mìos',
        MM: '%d mìosan',
        y: 'bliadhna',
        yy: '%d bliadhna',
      },
      dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
      ordinal: function (number) {
        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh'
        return number + output
      },
      week: {
        dow: 1,
        doy: 4,
      },
    })
    hooks.defineLocale('gl', {
      months:
        'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
          '_'
        ),
      monthsShort:
        'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
          '_'
        ),
      monthsParseExact: true,
      weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
      weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
      weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'H:mm',
        LTS: 'H:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D [de] MMMM [de] YYYY',
        LLL: 'D [de] MMMM [de] YYYY H:mm',
        LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
      },
      calendar: {
        sameDay: function () {
          return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT'
        },
        nextDay: function () {
          return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT'
        },
        nextWeek: function () {
          return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
        },
        lastDay: function () {
          return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT'
        },
        lastWeek: function () {
          return (
            '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
          )
        },
        sameElse: 'L',
      },
      relativeTime: {
        future: function (str) {
          if (str.indexOf('un') === 0) {
            return 'n' + str
          }
          return 'en ' + str
        },
        past: 'hai %s',
        s: 'uns segundos',
        ss: '%d segundos',
        m: 'un minuto',
        mm: '%d minutos',
        h: 'unha hora',
        hh: '%d horas',
        d: 'un día',
        dd: '%d días',
        M: 'un mes',
        MM: '%d meses',
        y: 'un ano',
        yy: '%d anos',
      },
      dayOfMonthOrdinalParse: /\d{1,2}º/,
      ordinal: '%dº',
      week: {
        dow: 1,
        doy: 4,
      },
    })
    function processRelativeTime$4(number, withoutSuffix, key, isFuture) {
      var format = {
        s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
        ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
        m: ['एका मिणटान', 'एक मिनूट'],
        mm: [number + ' मिणटांनी', number + ' मिणटां'],
        h: ['एका वरान', 'एक वर'],
        hh: [number + ' वरांनी', number + ' वरां'],
        d: ['एका दिसान', 'एक दीस'],
        dd: [number + ' दिसांनी', number + ' दीस'],
        M: ['एका म्हयन्यान', 'एक म्हयनो'],
        MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
        y: ['एका वर्सान', 'एक वर्स'],
        yy: [number + ' वर्सांनी', number + ' वर्सां'],
      }
      return isFuture ? format[key][0] : format[key][1]
    }
    hooks.defineLocale('gom-deva', {
      months: {
        standalone:
          'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
            '_'
          ),
        format:
          'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
            '_'
          ),
        isFormat: /MMMM(\s)+D[oD]?/,
      },
      monthsShort:
        'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
          '_'
        ),
      monthsParseExact: true,
      weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
      weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
      weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'A h:mm [वाजतां]',
        LTS: 'A h:mm:ss [वाजतां]',
        L: 'DD-MM-YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY A h:mm [वाजतां]',
        LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
        llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
      },
      calendar: {
        sameDay: '[आयज] LT',
        nextDay: '[फाल्यां] LT',
        nextWeek: '[फुडलो] dddd[,] LT',
        lastDay: '[काल] LT',
        lastWeek: '[फाटलो] dddd[,] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: '%s',
        past: '%s आदीं',
        s: processRelativeTime$4,
        ss: processRelativeTime$4,
        m: processRelativeTime$4,
        mm: processRelativeTime$4,
        h: processRelativeTime$4,
        hh: processRelativeTime$4,
        d: processRelativeTime$4,
        dd: processRelativeTime$4,
        M: processRelativeTime$4,
        MM: processRelativeTime$4,
        y: processRelativeTime$4,
        yy: processRelativeTime$4,
      },
      dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
      ordinal: function (number, period) {
        switch (period) {
          case 'D':
            return number + 'वेर'

          default:
          case 'M':
          case 'Q':
          case 'DDD':
          case 'd':
          case 'w':
          case 'W':
            return number
        }
      },
      week: {
        dow: 0,
        doy: 3,
      },
      meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
      meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
          hour = 0
        }
        if (meridiem === 'राती') {
          return hour < 4 ? hour : hour + 12
        } else if (meridiem === 'सकाळीं') {
          return hour
        } else if (meridiem === 'दनपारां') {
          return hour > 12 ? hour : hour + 12
        } else if (meridiem === 'सांजे') {
          return hour + 12
        }
      },
      meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
          return 'राती'
        } else if (hour < 12) {
          return 'सकाळीं'
        } else if (hour < 16) {
          return 'दनपारां'
        } else if (hour < 20) {
          return 'सांजे'
        } else {
          return 'राती'
        }
      },
    })
    function processRelativeTime$5(number, withoutSuffix, key, isFuture) {
      var format = {
        s: ['thoddea sekondamni', 'thodde sekond'],
        ss: [number + ' sekondamni', number + ' sekond'],
        m: ['eka mintan', 'ek minut'],
        mm: [number + ' mintamni', number + ' mintam'],
        h: ['eka voran', 'ek vor'],
        hh: [number + ' voramni', number + ' voram'],
        d: ['eka disan', 'ek dis'],
        dd: [number + ' disamni', number + ' dis'],
        M: ['eka mhoinean', 'ek mhoino'],
        MM: [number + ' mhoineamni', number + ' mhoine'],
        y: ['eka vorsan', 'ek voros'],
        yy: [number + ' vorsamni', number + ' vorsam'],
      }
      return isFuture ? format[key][0] : format[key][1]
    }
    hooks.defineLocale('gom-latn', {
      months: {
        standalone:
          'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
            '_'
          ),
        format:
          'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
            '_'
          ),
        isFormat: /MMMM(\s)+D[oD]?/,
      },
      monthsShort:
        'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
      monthsParseExact: true,
      weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split(
        '_'
      ),
      weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
      weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'A h:mm [vazta]',
        LTS: 'A h:mm:ss [vazta]',
        L: 'DD-MM-YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY A h:mm [vazta]',
        LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
        llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
      },
      calendar: {
        sameDay: '[Aiz] LT',
        nextDay: '[Faleam] LT',
        nextWeek: '[Fuddlo] dddd[,] LT',
        lastDay: '[Kal] LT',
        lastWeek: '[Fattlo] dddd[,] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: '%s',
        past: '%s adim',
        s: processRelativeTime$5,
        ss: processRelativeTime$5,
        m: processRelativeTime$5,
        mm: processRelativeTime$5,
        h: processRelativeTime$5,
        hh: processRelativeTime$5,
        d: processRelativeTime$5,
        dd: processRelativeTime$5,
        M: processRelativeTime$5,
        MM: processRelativeTime$5,
        y: processRelativeTime$5,
        yy: processRelativeTime$5,
      },
      dayOfMonthOrdinalParse: /\d{1,2}(er)/,
      ordinal: function (number, period) {
        switch (period) {
          case 'D':
            return number + 'er'

          default:
          case 'M':
          case 'Q':
          case 'DDD':
          case 'd':
          case 'w':
          case 'W':
            return number
        }
      },
      week: {
        dow: 0,
        doy: 3,
      },
      meridiemParse: /rati|sokallim|donparam|sanje/,
      meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
          hour = 0
        }
        if (meridiem === 'rati') {
          return hour < 4 ? hour : hour + 12
        } else if (meridiem === 'sokallim') {
          return hour
        } else if (meridiem === 'donparam') {
          return hour > 12 ? hour : hour + 12
        } else if (meridiem === 'sanje') {
          return hour + 12
        }
      },
      meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
          return 'rati'
        } else if (hour < 12) {
          return 'sokallim'
        } else if (hour < 16) {
          return 'donparam'
        } else if (hour < 20) {
          return 'sanje'
        } else {
          return 'rati'
        }
      },
    })
    var symbolMap$7 = {
        1: '૧',
        2: '૨',
        3: '૩',
        4: '૪',
        5: '૫',
        6: '૬',
        7: '૭',
        8: '૮',
        9: '૯',
        0: '૦',
      },
      numberMap$6 = {
        '૧': '1',
        '૨': '2',
        '૩': '3',
        '૪': '4',
        '૫': '5',
        '૬': '6',
        '૭': '7',
        '૮': '8',
        '૯': '9',
        '૦': '0',
      }
    hooks.defineLocale('gu', {
      months:
        'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
          '_'
        ),
      monthsShort:
        'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
          '_'
        ),
      monthsParseExact: true,
      weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
        '_'
      ),
      weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
      weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
      longDateFormat: {
        LT: 'A h:mm વાગ્યે',
        LTS: 'A h:mm:ss વાગ્યે',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
        LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
      },
      calendar: {
        sameDay: '[આજ] LT',
        nextDay: '[કાલે] LT',
        nextWeek: 'dddd, LT',
        lastDay: '[ગઇકાલે] LT',
        lastWeek: '[પાછલા] dddd, LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: '%s મા',
        past: '%s પહેલા',
        s: 'અમુક પળો',
        ss: '%d સેકંડ',
        m: 'એક મિનિટ',
        mm: '%d મિનિટ',
        h: 'એક કલાક',
        hh: '%d કલાક',
        d: 'એક દિવસ',
        dd: '%d દિવસ',
        M: 'એક મહિનો',
        MM: '%d મહિનો',
        y: 'એક વર્ષ',
        yy: '%d વર્ષ',
      },
      preparse: function (string) {
        return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
          return numberMap$6[match]
        })
      },
      postformat: function (string) {
        return string.replace(/\d/g, function (match) {
          return symbolMap$7[match]
        })
      },
      meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
      meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
          hour = 0
        }
        if (meridiem === 'રાત') {
          return hour < 4 ? hour : hour + 12
        } else if (meridiem === 'સવાર') {
          return hour
        } else if (meridiem === 'બપોર') {
          return hour >= 10 ? hour : hour + 12
        } else if (meridiem === 'સાંજ') {
          return hour + 12
        }
      },
      meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
          return 'રાત'
        } else if (hour < 10) {
          return 'સવાર'
        } else if (hour < 17) {
          return 'બપોર'
        } else if (hour < 20) {
          return 'સાંજ'
        } else {
          return 'રાત'
        }
      },
      week: {
        dow: 0,
        doy: 6,
      },
    })
    hooks.defineLocale('he', {
      months:
        'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
          '_'
        ),
      monthsShort:
        'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
      weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
      weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
      weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D [ב]MMMM YYYY',
        LLL: 'D [ב]MMMM YYYY HH:mm',
        LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
        l: 'D/M/YYYY',
        ll: 'D MMM YYYY',
        lll: 'D MMM YYYY HH:mm',
        llll: 'ddd, D MMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[היום ב־]LT',
        nextDay: '[מחר ב־]LT',
        nextWeek: 'dddd [בשעה] LT',
        lastDay: '[אתמול ב־]LT',
        lastWeek: '[ביום] dddd [האחרון בשעה] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'בעוד %s',
        past: 'לפני %s',
        s: 'מספר שניות',
        ss: '%d שניות',
        m: 'דקה',
        mm: '%d דקות',
        h: 'שעה',
        hh: function (number) {
          if (number === 2) {
            return 'שעתיים'
          }
          return number + ' שעות'
        },
        d: 'יום',
        dd: function (number) {
          if (number === 2) {
            return 'יומיים'
          }
          return number + ' ימים'
        },
        M: 'חודש',
        MM: function (number) {
          if (number === 2) {
            return 'חודשיים'
          }
          return number + ' חודשים'
        },
        y: 'שנה',
        yy: function (number) {
          if (number === 2) {
            return 'שנתיים'
          } else if (number % 10 === 0 && number !== 10) {
            return number + ' שנה'
          }
          return number + ' שנים'
        },
      },
      meridiemParse:
        /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
      isPM: function (input) {
        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input)
      },
      meridiem: function (hour, minute, isLower) {
        if (hour < 5) {
          return 'לפנות בוקר'
        } else if (hour < 10) {
          return 'בבוקר'
        } else if (hour < 12) {
          return isLower ? 'לפנה"צ' : 'לפני הצהריים'
        } else if (hour < 18) {
          return isLower ? 'אחה"צ' : 'אחרי הצהריים'
        } else {
          return 'בערב'
        }
      },
    })
    var symbolMap$8 = {
        1: '१',
        2: '२',
        3: '३',
        4: '४',
        5: '५',
        6: '६',
        7: '७',
        8: '८',
        9: '९',
        0: '०',
      },
      numberMap$7 = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0',
      },
      monthsParse$7 = [
        /^जन/i,
        /^फ़र|फर/i,
        /^मार्च/i,
        /^अप्रै/i,
        /^मई/i,
        /^जून/i,
        /^जुल/i,
        /^अग/i,
        /^सितं|सित/i,
        /^अक्टू/i,
        /^नव|नवं/i,
        /^दिसं|दिस/i,
      ],
      shortMonthsParse = [
        /^जन/i,
        /^फ़र/i,
        /^मार्च/i,
        /^अप्रै/i,
        /^मई/i,
        /^जून/i,
        /^जुल/i,
        /^अग/i,
        /^सित/i,
        /^अक्टू/i,
        /^नव/i,
        /^दिस/i,
      ]
    hooks.defineLocale('hi', {
      months: {
        format:
          'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
            '_'
          ),
        standalone:
          'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
            '_'
          ),
      },
      monthsShort:
        'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
      weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split(
        '_'
      ),
      weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
      weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
      longDateFormat: {
        LT: 'A h:mm बजे',
        LTS: 'A h:mm:ss बजे',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY, A h:mm बजे',
        LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
      },
      monthsParse: monthsParse$7,
      longMonthsParse: monthsParse$7,
      shortMonthsParse: shortMonthsParse,
      monthsRegex:
        /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
      monthsShortRegex:
        /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
      monthsStrictRegex:
        /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,
      monthsShortStrictRegex:
        /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,
      calendar: {
        sameDay: '[आज] LT',
        nextDay: '[कल] LT',
        nextWeek: 'dddd, LT',
        lastDay: '[कल] LT',
        lastWeek: '[पिछले] dddd, LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: '%s में',
        past: '%s पहले',
        s: 'कुछ ही क्षण',
        ss: '%d सेकंड',
        m: 'एक मिनट',
        mm: '%d मिनट',
        h: 'एक घंटा',
        hh: '%d घंटे',
        d: 'एक दिन',
        dd: '%d दिन',
        M: 'एक महीने',
        MM: '%d महीने',
        y: 'एक वर्ष',
        yy: '%d वर्ष',
      },
      preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
          return numberMap$7[match]
        })
      },
      postformat: function (string) {
        return string.replace(/\d/g, function (match) {
          return symbolMap$8[match]
        })
      },
      meridiemParse: /रात|सुबह|दोपहर|शाम/,
      meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
          hour = 0
        }
        if (meridiem === 'रात') {
          return hour < 4 ? hour : hour + 12
        } else if (meridiem === 'सुबह') {
          return hour
        } else if (meridiem === 'दोपहर') {
          return hour >= 10 ? hour : hour + 12
        } else if (meridiem === 'शाम') {
          return hour + 12
        }
      },
      meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
          return 'रात'
        } else if (hour < 10) {
          return 'सुबह'
        } else if (hour < 17) {
          return 'दोपहर'
        } else if (hour < 20) {
          return 'शाम'
        } else {
          return 'रात'
        }
      },
      week: {
        dow: 0,
        doy: 6,
      },
    })
    function translate$3(number, withoutSuffix, key) {
      var result = number + ' '
      switch (key) {
        case 'ss':
          if (number === 1) {
            result += 'sekunda'
          } else if (number === 2 || number === 3 || number === 4) {
            result += 'sekunde'
          } else {
            result += 'sekundi'
          }
          return result

        case 'm':
          return withoutSuffix ? 'jedna minuta' : 'jedne minute'

        case 'mm':
          if (number === 1) {
            result += 'minuta'
          } else if (number === 2 || number === 3 || number === 4) {
            result += 'minute'
          } else {
            result += 'minuta'
          }
          return result

        case 'h':
          return withoutSuffix ? 'jedan sat' : 'jednog sata'

        case 'hh':
          if (number === 1) {
            result += 'sat'
          } else if (number === 2 || number === 3 || number === 4) {
            result += 'sata'
          } else {
            result += 'sati'
          }
          return result

        case 'dd':
          if (number === 1) {
            result += 'dan'
          } else {
            result += 'dana'
          }
          return result

        case 'MM':
          if (number === 1) {
            result += 'mjesec'
          } else if (number === 2 || number === 3 || number === 4) {
            result += 'mjeseca'
          } else {
            result += 'mjeseci'
          }
          return result

        case 'yy':
          if (number === 1) {
            result += 'godina'
          } else if (number === 2 || number === 3 || number === 4) {
            result += 'godine'
          } else {
            result += 'godina'
          }
          return result
      }
    }
    hooks.defineLocale('hr', {
      months: {
        format:
          'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
            '_'
          ),
        standalone:
          'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
            '_'
          ),
      },
      monthsShort:
        'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
          '_'
        ),
      monthsParseExact: true,
      weekdays:
        'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
      weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
      weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'H:mm',
        LTS: 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'Do MMMM YYYY',
        LLL: 'Do MMMM YYYY H:mm',
        LLLL: 'dddd, Do MMMM YYYY H:mm',
      },
      calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sutra u] LT',
        nextWeek: function () {
          switch (this.day()) {
            case 0:
              return '[u] [nedjelju] [u] LT'

            case 3:
              return '[u] [srijedu] [u] LT'

            case 6:
              return '[u] [subotu] [u] LT'

            case 1:
            case 2:
            case 4:
            case 5:
              return '[u] dddd [u] LT'
          }
        },
        lastDay: '[jučer u] LT',
        lastWeek: function () {
          switch (this.day()) {
            case 0:
              return '[prošlu] [nedjelju] [u] LT'

            case 3:
              return '[prošlu] [srijedu] [u] LT'

            case 6:
              return '[prošle] [subote] [u] LT'

            case 1:
            case 2:
            case 4:
            case 5:
              return '[prošli] dddd [u] LT'
          }
        },
        sameElse: 'L',
      },
      relativeTime: {
        future: 'za %s',
        past: 'prije %s',
        s: 'par sekundi',
        ss: translate$3,
        m: translate$3,
        mm: translate$3,
        h: translate$3,
        hh: translate$3,
        d: 'dan',
        dd: translate$3,
        M: 'mjesec',
        MM: translate$3,
        y: 'godinu',
        yy: translate$3,
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: '%d.',
      week: {
        dow: 1,
        doy: 7,
      },
    })
    var weekEndings =
      'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ')
    function translate$4(number, withoutSuffix, key, isFuture) {
      var num = number
      switch (key) {
        case 's':
          return isFuture || withoutSuffix
            ? 'néhány másodperc'
            : 'néhány másodperce'

        case 'ss':
          return num + (isFuture || withoutSuffix)
            ? ' másodperc'
            : ' másodperce'

        case 'm':
          return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce')

        case 'mm':
          return num + (isFuture || withoutSuffix ? ' perc' : ' perce')

        case 'h':
          return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája')

        case 'hh':
          return num + (isFuture || withoutSuffix ? ' óra' : ' órája')

        case 'd':
          return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja')

        case 'dd':
          return num + (isFuture || withoutSuffix ? ' nap' : ' napja')

        case 'M':
          return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja')

        case 'MM':
          return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja')

        case 'y':
          return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve')

        case 'yy':
          return num + (isFuture || withoutSuffix ? ' év' : ' éve')
      }
      return ''
    }
    function week(isFuture) {
      return (
        (isFuture ? '' : '[múlt] ') +
        '[' +
        weekEndings[this.day()] +
        '] LT[-kor]'
      )
    }
    hooks.defineLocale('hu', {
      months:
        'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
          '_'
        ),
      monthsShort:
        'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
          '_'
        ),
      monthsParseExact: true,
      weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split(
        '_'
      ),
      weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
      weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
      longDateFormat: {
        LT: 'H:mm',
        LTS: 'H:mm:ss',
        L: 'YYYY.MM.DD.',
        LL: 'YYYY. MMMM D.',
        LLL: 'YYYY. MMMM D. H:mm',
        LLLL: 'YYYY. MMMM D., dddd H:mm',
      },
      meridiemParse: /de|du/i,
      isPM: function (input) {
        return input.charAt(1).toLowerCase() === 'u'
      },
      meridiem: function (hours, minutes, isLower) {
        if (hours < 12) {
          return isLower === true ? 'de' : 'DE'
        } else {
          return isLower === true ? 'du' : 'DU'
        }
      },
      calendar: {
        sameDay: '[ma] LT[-kor]',
        nextDay: '[holnap] LT[-kor]',
        nextWeek: function () {
          return week.call(this, true)
        },
        lastDay: '[tegnap] LT[-kor]',
        lastWeek: function () {
          return week.call(this, false)
        },
        sameElse: 'L',
      },
      relativeTime: {
        future: '%s múlva',
        past: '%s',
        s: translate$4,
        ss: translate$4,
        m: translate$4,
        mm: translate$4,
        h: translate$4,
        hh: translate$4,
        d: translate$4,
        dd: translate$4,
        M: translate$4,
        MM: translate$4,
        y: translate$4,
        yy: translate$4,
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: '%d.',
      week: {
        dow: 1,
        doy: 4,
      },
    })
    hooks.defineLocale('hy-am', {
      months: {
        format:
          'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
            '_'
          ),
        standalone:
          'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
            '_'
          ),
      },
      monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
      weekdays:
        'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
          '_'
        ),
      weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
      weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D MMMM YYYY թ.',
        LLL: 'D MMMM YYYY թ., HH:mm',
        LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
      },
      calendar: {
        sameDay: '[այսօր] LT',
        nextDay: '[վաղը] LT',
        lastDay: '[երեկ] LT',
        nextWeek: function () {
          return 'dddd [օրը ժամը] LT'
        },
        lastWeek: function () {
          return '[անցած] dddd [օրը ժամը] LT'
        },
        sameElse: 'L',
      },
      relativeTime: {
        future: '%s հետո',
        past: '%s առաջ',
        s: 'մի քանի վայրկյան',
        ss: '%d վայրկյան',
        m: 'րոպե',
        mm: '%d րոպե',
        h: 'ժամ',
        hh: '%d ժամ',
        d: 'օր',
        dd: '%d օր',
        M: 'ամիս',
        MM: '%d ամիս',
        y: 'տարի',
        yy: '%d տարի',
      },
      meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
      isPM: function (input) {
        return /^(ցերեկվա|երեկոյան)$/.test(input)
      },
      meridiem: function (hour) {
        if (hour < 4) {
          return 'գիշերվա'
        } else if (hour < 12) {
          return 'առավոտվա'
        } else if (hour < 17) {
          return 'ցերեկվա'
        } else {
          return 'երեկոյան'
        }
      },
      dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
      ordinal: function (number, period) {
        switch (period) {
          case 'DDD':
          case 'w':
          case 'W':
          case 'DDDo':
            if (number === 1) {
              return number + '-ին'
            }
            return number + '-րդ'

          default:
            return number
        }
      },
      week: {
        dow: 1,
        doy: 7,
      },
    })
    hooks.defineLocale('id', {
      months:
        'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
          '_'
        ),
      monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
      weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
      weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
      weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
      longDateFormat: {
        LT: 'HH.mm',
        LTS: 'HH.mm.ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY [pukul] HH.mm',
        LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
      },
      meridiemParse: /pagi|siang|sore|malam/,
      meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
          hour = 0
        }
        if (meridiem === 'pagi') {
          return hour
        } else if (meridiem === 'siang') {
          return hour >= 11 ? hour : hour + 12
        } else if (meridiem === 'sore' || meridiem === 'malam') {
          return hour + 12
        }
      },
      meridiem: function (hours, minutes, isLower) {
        if (hours < 11) {
          return 'pagi'
        } else if (hours < 15) {
          return 'siang'
        } else if (hours < 19) {
          return 'sore'
        } else {
          return 'malam'
        }
      },
      calendar: {
        sameDay: '[Hari ini pukul] LT',
        nextDay: '[Besok pukul] LT',
        nextWeek: 'dddd [pukul] LT',
        lastDay: '[Kemarin pukul] LT',
        lastWeek: 'dddd [lalu pukul] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'dalam %s',
        past: '%s yang lalu',
        s: 'beberapa detik',
        ss: '%d detik',
        m: 'semenit',
        mm: '%d menit',
        h: 'sejam',
        hh: '%d jam',
        d: 'sehari',
        dd: '%d hari',
        M: 'sebulan',
        MM: '%d bulan',
        y: 'setahun',
        yy: '%d tahun',
      },
      week: {
        dow: 0,
        doy: 6,
      },
    })
    function plural$2(n) {
      if (n % 100 === 11) {
        return true
      } else if (n % 10 === 1) {
        return false
      }
      return true
    }
    function translate$5(number, withoutSuffix, key, isFuture) {
      var result = number + ' '
      switch (key) {
        case 's':
          return withoutSuffix || isFuture
            ? 'nokkrar sekúndur'
            : 'nokkrum sekúndum'

        case 'ss':
          if (plural$2(number)) {
            return (
              result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
            )
          }
          return result + 'sekúnda'

        case 'm':
          return withoutSuffix ? 'mínúta' : 'mínútu'

        case 'mm':
          if (plural$2(number)) {
            return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
          } else if (withoutSuffix) {
            return result + 'mínúta'
          }
          return result + 'mínútu'

        case 'hh':
          if (plural$2(number)) {
            return (
              result +
              (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum')
            )
          }
          return result + 'klukkustund'

        case 'd':
          if (withoutSuffix) {
            return 'dagur'
          }
          return isFuture ? 'dag' : 'degi'

        case 'dd':
          if (plural$2(number)) {
            if (withoutSuffix) {
              return result + 'dagar'
            }
            return result + (isFuture ? 'daga' : 'dögum')
          } else if (withoutSuffix) {
            return result + 'dagur'
          }
          return result + (isFuture ? 'dag' : 'degi')

        case 'M':
          if (withoutSuffix) {
            return 'mánuður'
          }
          return isFuture ? 'mánuð' : 'mánuði'

        case 'MM':
          if (plural$2(number)) {
            if (withoutSuffix) {
              return result + 'mánuðir'
            }
            return result + (isFuture ? 'mánuði' : 'mánuðum')
          } else if (withoutSuffix) {
            return result + 'mánuður'
          }
          return result + (isFuture ? 'mánuð' : 'mánuði')

        case 'y':
          return withoutSuffix || isFuture ? 'ár' : 'ári'

        case 'yy':
          if (plural$2(number)) {
            return result + (withoutSuffix || isFuture ? 'ár' : 'árum')
          }
          return result + (withoutSuffix || isFuture ? 'ár' : 'ári')
      }
    }
    hooks.defineLocale('is', {
      months:
        'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
          '_'
        ),
      monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
      weekdays:
        'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
          '_'
        ),
      weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
      weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
      longDateFormat: {
        LT: 'H:mm',
        LTS: 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY [kl.] H:mm',
        LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
      },
      calendar: {
        sameDay: '[í dag kl.] LT',
        nextDay: '[á morgun kl.] LT',
        nextWeek: 'dddd [kl.] LT',
        lastDay: '[í gær kl.] LT',
        lastWeek: '[síðasta] dddd [kl.] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'eftir %s',
        past: 'fyrir %s síðan',
        s: translate$5,
        ss: translate$5,
        m: translate$5,
        mm: translate$5,
        h: 'klukkustund',
        hh: translate$5,
        d: translate$5,
        dd: translate$5,
        M: translate$5,
        MM: translate$5,
        y: translate$5,
        yy: translate$5,
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: '%d.',
      week: {
        dow: 1,
        doy: 4,
      },
    })
    hooks.defineLocale('it-ch', {
      months:
        'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
          '_'
        ),
      monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
      weekdays:
        'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
      weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
      weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[Oggi alle] LT',
        nextDay: '[Domani alle] LT',
        nextWeek: 'dddd [alle] LT',
        lastDay: '[Ieri alle] LT',
        lastWeek: function () {
          switch (this.day()) {
            case 0:
              return '[la scorsa] dddd [alle] LT'

            default:
              return '[lo scorso] dddd [alle] LT'
          }
        },
        sameElse: 'L',
      },
      relativeTime: {
        future: function (s) {
          return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s
        },
        past: '%s fa',
        s: 'alcuni secondi',
        ss: '%d secondi',
        m: 'un minuto',
        mm: '%d minuti',
        h: "un'ora",
        hh: '%d ore',
        d: 'un giorno',
        dd: '%d giorni',
        M: 'un mese',
        MM: '%d mesi',
        y: 'un anno',
        yy: '%d anni',
      },
      dayOfMonthOrdinalParse: /\d{1,2}º/,
      ordinal: '%dº',
      week: {
        dow: 1,
        doy: 4,
      },
    })
    hooks.defineLocale('it', {
      months:
        'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
          '_'
        ),
      monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
      weekdays:
        'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
      weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
      weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: function () {
          return (
            '[Oggi a' +
            (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
            ']LT'
          )
        },
        nextDay: function () {
          return (
            '[Domani a' +
            (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
            ']LT'
          )
        },
        nextWeek: function () {
          return (
            'dddd [a' +
            (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
            ']LT'
          )
        },
        lastDay: function () {
          return (
            '[Ieri a' +
            (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
            ']LT'
          )
        },
        lastWeek: function () {
          switch (this.day()) {
            case 0:
              return (
                '[La scorsa] dddd [a' +
                (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                ']LT'
              )

            default:
              return (
                '[Lo scorso] dddd [a' +
                (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                ']LT'
              )
          }
        },
        sameElse: 'L',
      },
      relativeTime: {
        future: 'tra %s',
        past: '%s fa',
        s: 'alcuni secondi',
        ss: '%d secondi',
        m: 'un minuto',
        mm: '%d minuti',
        h: "un'ora",
        hh: '%d ore',
        d: 'un giorno',
        dd: '%d giorni',
        w: 'una settimana',
        ww: '%d settimane',
        M: 'un mese',
        MM: '%d mesi',
        y: 'un anno',
        yy: '%d anni',
      },
      dayOfMonthOrdinalParse: /\d{1,2}º/,
      ordinal: '%dº',
      week: {
        dow: 1,
        doy: 4,
      },
    })
    hooks.defineLocale('ja', {
      eras: [
        {
          since: '2019-05-01',
          offset: 1,
          name: '令和',
          narrow: '㋿',
          abbr: 'R',
        },
        {
          since: '1989-01-08',
          until: '2019-04-30',
          offset: 1,
          name: '平成',
          narrow: '㍻',
          abbr: 'H',
        },
        {
          since: '1926-12-25',
          until: '1989-01-07',
          offset: 1,
          name: '昭和',
          narrow: '㍼',
          abbr: 'S',
        },
        {
          since: '1912-07-30',
          until: '1926-12-24',
          offset: 1,
          name: '大正',
          narrow: '㍽',
          abbr: 'T',
        },
        {
          since: '1873-01-01',
          until: '1912-07-29',
          offset: 6,
          name: '明治',
          narrow: '㍾',
          abbr: 'M',
        },
        {
          since: '0001-01-01',
          until: '1873-12-31',
          offset: 1,
          name: '西暦',
          narrow: 'AD',
          abbr: 'AD',
        },
        {
          since: '0000-12-31',
          until: -Infinity,
          offset: 1,
          name: '紀元前',
          narrow: 'BC',
          abbr: 'BC',
        },
      ],
      eraYearOrdinalRegex: /(元|\d+)年/,
      eraYearOrdinalParse: function (input, match) {
        return match[1] === '元' ? 1 : parseInt(match[1] || input, 10)
      },
      months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
      monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
        '_'
      ),
      weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
      weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
      weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'YYYY/MM/DD',
        LL: 'YYYY年M月D日',
        LLL: 'YYYY年M月D日 HH:mm',
        LLLL: 'YYYY年M月D日 dddd HH:mm',
        l: 'YYYY/MM/DD',
        ll: 'YYYY年M月D日',
        lll: 'YYYY年M月D日 HH:mm',
        llll: 'YYYY年M月D日(ddd) HH:mm',
      },
      meridiemParse: /午前|午後/i,
      isPM: function (input) {
        return input === '午後'
      },
      meridiem: function (hour, minute, isLower) {
        if (hour < 12) {
          return '午前'
        } else {
          return '午後'
        }
      },
      calendar: {
        sameDay: '[今日] LT',
        nextDay: '[明日] LT',
        nextWeek: function (now) {
          if (now.week() !== this.week()) {
            return '[来週]dddd LT'
          } else {
            return 'dddd LT'
          }
        },
        lastDay: '[昨日] LT',
        lastWeek: function (now) {
          if (this.week() !== now.week()) {
            return '[先週]dddd LT'
          } else {
            return 'dddd LT'
          }
        },
        sameElse: 'L',
      },
      dayOfMonthOrdinalParse: /\d{1,2}日/,
      ordinal: function (number, period) {
        switch (period) {
          case 'y':
            return number === 1 ? '元年' : number + '年'

          case 'd':
          case 'D':
          case 'DDD':
            return number + '日'

          default:
            return number
        }
      },
      relativeTime: {
        future: '%s後',
        past: '%s前',
        s: '数秒',
        ss: '%d秒',
        m: '1分',
        mm: '%d分',
        h: '1時間',
        hh: '%d時間',
        d: '1日',
        dd: '%d日',
        M: '1ヶ月',
        MM: '%dヶ月',
        y: '1年',
        yy: '%d年',
      },
    })
    hooks.defineLocale('jv', {
      months:
        'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
          '_'
        ),
      monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
      weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
      weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
      weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
      longDateFormat: {
        LT: 'HH.mm',
        LTS: 'HH.mm.ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY [pukul] HH.mm',
        LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
      },
      meridiemParse: /enjing|siyang|sonten|ndalu/,
      meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
          hour = 0
        }
        if (meridiem === 'enjing') {
          return hour
        } else if (meridiem === 'siyang') {
          return hour >= 11 ? hour : hour + 12
        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
          return hour + 12
        }
      },
      meridiem: function (hours, minutes, isLower) {
        if (hours < 11) {
          return 'enjing'
        } else if (hours < 15) {
          return 'siyang'
        } else if (hours < 19) {
          return 'sonten'
        } else {
          return 'ndalu'
        }
      },
      calendar: {
        sameDay: '[Dinten puniko pukul] LT',
        nextDay: '[Mbenjang pukul] LT',
        nextWeek: 'dddd [pukul] LT',
        lastDay: '[Kala wingi pukul] LT',
        lastWeek: 'dddd [kepengker pukul] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'wonten ing %s',
        past: '%s ingkang kepengker',
        s: 'sawetawis detik',
        ss: '%d detik',
        m: 'setunggal menit',
        mm: '%d menit',
        h: 'setunggal jam',
        hh: '%d jam',
        d: 'sedinten',
        dd: '%d dinten',
        M: 'sewulan',
        MM: '%d wulan',
        y: 'setaun',
        yy: '%d taun',
      },
      week: {
        dow: 1,
        doy: 7,
      },
    })
    hooks.defineLocale('ka', {
      months:
        'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
          '_'
        ),
      monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
      weekdays: {
        standalone:
          'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
            '_'
          ),
        format:
          'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
            '_'
          ),
        isFormat: /(წინა|შემდეგ)/,
      },
      weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
      weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[დღეს] LT[-ზე]',
        nextDay: '[ხვალ] LT[-ზე]',
        lastDay: '[გუშინ] LT[-ზე]',
        nextWeek: '[შემდეგ] dddd LT[-ზე]',
        lastWeek: '[წინა] dddd LT-ზე',
        sameElse: 'L',
      },
      relativeTime: {
        future: function (s) {
          return s.replace(
            /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
            function ($0, $1, $2) {
              return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში'
            }
          )
        },
        past: function (s) {
          if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
            return s.replace(/(ი|ე)$/, 'ის წინ')
          }
          if (/წელი/.test(s)) {
            return s.replace(/წელი$/, 'წლის წინ')
          }
          return s
        },
        s: 'რამდენიმე წამი',
        ss: '%d წამი',
        m: 'წუთი',
        mm: '%d წუთი',
        h: 'საათი',
        hh: '%d საათი',
        d: 'დღე',
        dd: '%d დღე',
        M: 'თვე',
        MM: '%d თვე',
        y: 'წელი',
        yy: '%d წელი',
      },
      dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
      ordinal: function (number) {
        if (number === 0) {
          return number
        }
        if (number === 1) {
          return number + '-ლი'
        }
        if (
          number < 20 ||
          (number <= 100 && number % 20 === 0) ||
          number % 100 === 0
        ) {
          return 'მე-' + number
        }
        return number + '-ე'
      },
      week: {
        dow: 1,
        doy: 7,
      },
    })
    var suffixes$1 = {
      0: '-ші',
      1: '-ші',
      2: '-ші',
      3: '-ші',
      4: '-ші',
      5: '-ші',
      6: '-шы',
      7: '-ші',
      8: '-ші',
      9: '-шы',
      10: '-шы',
      20: '-шы',
      30: '-шы',
      40: '-шы',
      50: '-ші',
      60: '-шы',
      70: '-ші',
      80: '-ші',
      90: '-шы',
      100: '-ші',
    }
    hooks.defineLocale('kk', {
      months:
        'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
          '_'
        ),
      monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
      weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
        '_'
      ),
      weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
      weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[Бүгін сағат] LT',
        nextDay: '[Ертең сағат] LT',
        nextWeek: 'dddd [сағат] LT',
        lastDay: '[Кеше сағат] LT',
        lastWeek: '[Өткен аптаның] dddd [сағат] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: '%s ішінде',
        past: '%s бұрын',
        s: 'бірнеше секунд',
        ss: '%d секунд',
        m: 'бір минут',
        mm: '%d минут',
        h: 'бір сағат',
        hh: '%d сағат',
        d: 'бір күн',
        dd: '%d күн',
        M: 'бір ай',
        MM: '%d ай',
        y: 'бір жыл',
        yy: '%d жыл',
      },
      dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
      ordinal: function (number) {
        var a = number % 10,
          b = number >= 100 ? 100 : null
        return number + (suffixes$1[number] || suffixes$1[a] || suffixes$1[b])
      },
      week: {
        dow: 1,
        doy: 7,
      },
    })
    var symbolMap$9 = {
        1: '១',
        2: '២',
        3: '៣',
        4: '៤',
        5: '៥',
        6: '៦',
        7: '៧',
        8: '៨',
        9: '៩',
        0: '០',
      },
      numberMap$8 = {
        '១': '1',
        '២': '2',
        '៣': '3',
        '៤': '4',
        '៥': '5',
        '៦': '6',
        '៧': '7',
        '៨': '8',
        '៩': '9',
        '០': '0',
      }
    hooks.defineLocale('km', {
      months:
        'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
          '_'
        ),
      monthsShort:
        'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
          '_'
        ),
      weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
      weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
      weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm',
      },
      meridiemParse: /ព្រឹក|ល្ងាច/,
      isPM: function (input) {
        return input === 'ល្ងាច'
      },
      meridiem: function (hour, minute, isLower) {
        if (hour < 12) {
          return 'ព្រឹក'
        } else {
          return 'ល្ងាច'
        }
      },
      calendar: {
        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
        nextDay: '[ស្អែក ម៉ោង] LT',
        nextWeek: 'dddd [ម៉ោង] LT',
        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: '%sទៀត',
        past: '%sមុន',
        s: 'ប៉ុន្មានវិនាទី',
        ss: '%d វិនាទី',
        m: 'មួយនាទី',
        mm: '%d នាទី',
        h: 'មួយម៉ោង',
        hh: '%d ម៉ោង',
        d: 'មួយថ្ងៃ',
        dd: '%d ថ្ងៃ',
        M: 'មួយខែ',
        MM: '%d ខែ',
        y: 'មួយឆ្នាំ',
        yy: '%d ឆ្នាំ',
      },
      dayOfMonthOrdinalParse: /ទី\d{1,2}/,
      ordinal: 'ទី%d',
      preparse: function (string) {
        return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
          return numberMap$8[match]
        })
      },
      postformat: function (string) {
        return string.replace(/\d/g, function (match) {
          return symbolMap$9[match]
        })
      },
      week: {
        dow: 1,
        doy: 4,
      },
    })
    var symbolMap$a = {
        1: '೧',
        2: '೨',
        3: '೩',
        4: '೪',
        5: '೫',
        6: '೬',
        7: '೭',
        8: '೮',
        9: '೯',
        0: '೦',
      },
      numberMap$9 = {
        '೧': '1',
        '೨': '2',
        '೩': '3',
        '೪': '4',
        '೫': '5',
        '೬': '6',
        '೭': '7',
        '೮': '8',
        '೯': '9',
        '೦': '0',
      }
    hooks.defineLocale('kn', {
      months:
        'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
          '_'
        ),
      monthsShort:
        'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
          '_'
        ),
      monthsParseExact: true,
      weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
        '_'
      ),
      weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
      weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
      longDateFormat: {
        LT: 'A h:mm',
        LTS: 'A h:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY, A h:mm',
        LLLL: 'dddd, D MMMM YYYY, A h:mm',
      },
      calendar: {
        sameDay: '[ಇಂದು] LT',
        nextDay: '[ನಾಳೆ] LT',
        nextWeek: 'dddd, LT',
        lastDay: '[ನಿನ್ನೆ] LT',
        lastWeek: '[ಕೊನೆಯ] dddd, LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: '%s ನಂತರ',
        past: '%s ಹಿಂದೆ',
        s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
        ss: '%d ಸೆಕೆಂಡುಗಳು',
        m: 'ಒಂದು ನಿಮಿಷ',
        mm: '%d ನಿಮಿಷ',
        h: 'ಒಂದು ಗಂಟೆ',
        hh: '%d ಗಂಟೆ',
        d: 'ಒಂದು ದಿನ',
        dd: '%d ದಿನ',
        M: 'ಒಂದು ತಿಂಗಳು',
        MM: '%d ತಿಂಗಳು',
        y: 'ಒಂದು ವರ್ಷ',
        yy: '%d ವರ್ಷ',
      },
      preparse: function (string) {
        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
          return numberMap$9[match]
        })
      },
      postformat: function (string) {
        return string.replace(/\d/g, function (match) {
          return symbolMap$a[match]
        })
      },
      meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
      meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
          hour = 0
        }
        if (meridiem === 'ರಾತ್ರಿ') {
          return hour < 4 ? hour : hour + 12
        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
          return hour
        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
          return hour >= 10 ? hour : hour + 12
        } else if (meridiem === 'ಸಂಜೆ') {
          return hour + 12
        }
      },
      meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
          return 'ರಾತ್ರಿ'
        } else if (hour < 10) {
          return 'ಬೆಳಿಗ್ಗೆ'
        } else if (hour < 17) {
          return 'ಮಧ್ಯಾಹ್ನ'
        } else if (hour < 20) {
          return 'ಸಂಜೆ'
        } else {
          return 'ರಾತ್ರಿ'
        }
      },
      dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
      ordinal: function (number) {
        return number + 'ನೇ'
      },
      week: {
        dow: 0,
        doy: 6,
      },
    })
    hooks.defineLocale('ko', {
      months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
      monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
        '_'
      ),
      weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
      weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
      weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
      longDateFormat: {
        LT: 'A h:mm',
        LTS: 'A h:mm:ss',
        L: 'YYYY.MM.DD.',
        LL: 'YYYY년 MMMM D일',
        LLL: 'YYYY년 MMMM D일 A h:mm',
        LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
        l: 'YYYY.MM.DD.',
        ll: 'YYYY년 MMMM D일',
        lll: 'YYYY년 MMMM D일 A h:mm',
        llll: 'YYYY년 MMMM D일 dddd A h:mm',
      },
      calendar: {
        sameDay: '오늘 LT',
        nextDay: '내일 LT',
        nextWeek: 'dddd LT',
        lastDay: '어제 LT',
        lastWeek: '지난주 dddd LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: '%s 후',
        past: '%s 전',
        s: '몇 초',
        ss: '%d초',
        m: '1분',
        mm: '%d분',
        h: '한 시간',
        hh: '%d시간',
        d: '하루',
        dd: '%d일',
        M: '한 달',
        MM: '%d달',
        y: '일 년',
        yy: '%d년',
      },
      dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
      ordinal: function (number, period) {
        switch (period) {
          case 'd':
          case 'D':
          case 'DDD':
            return number + '일'

          case 'M':
            return number + '월'

          case 'w':
          case 'W':
            return number + '주'

          default:
            return number
        }
      },
      meridiemParse: /오전|오후/,
      isPM: function (token) {
        return token === '오후'
      },
      meridiem: function (hour, minute, isUpper) {
        return hour < 12 ? '오전' : '오후'
      },
    })
    var symbolMap$b = {
        1: '١',
        2: '٢',
        3: '٣',
        4: '٤',
        5: '٥',
        6: '٦',
        7: '٧',
        8: '٨',
        9: '٩',
        0: '٠',
      },
      numberMap$a = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0',
      },
      months$8 = [
        'کانونی دووەم',
        'شوبات',
        'ئازار',
        'نیسان',
        'ئایار',
        'حوزەیران',
        'تەمموز',
        'ئاب',
        'ئەیلوول',
        'تشرینی یەكەم',
        'تشرینی دووەم',
        'كانونی یەکەم',
      ]
    hooks.defineLocale('ku', {
      months: months$8,
      monthsShort: months$8,
      weekdays:
        'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
          '_'
        ),
      weekdaysShort:
        'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
      weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm',
      },
      meridiemParse: /ئێواره‌|به‌یانی/,
      isPM: function (input) {
        return /ئێواره‌/.test(input)
      },
      meridiem: function (hour, minute, isLower) {
        if (hour < 12) {
          return 'به‌یانی'
        } else {
          return 'ئێواره‌'
        }
      },
      calendar: {
        sameDay: '[ئه‌مرۆ كاتژمێر] LT',
        nextDay: '[به‌یانی كاتژمێر] LT',
        nextWeek: 'dddd [كاتژمێر] LT',
        lastDay: '[دوێنێ كاتژمێر] LT',
        lastWeek: 'dddd [كاتژمێر] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'له‌ %s',
        past: '%s',
        s: 'چه‌ند چركه‌یه‌ك',
        ss: 'چركه‌ %d',
        m: 'یه‌ك خوله‌ك',
        mm: '%d خوله‌ك',
        h: 'یه‌ك كاتژمێر',
        hh: '%d كاتژمێر',
        d: 'یه‌ك ڕۆژ',
        dd: '%d ڕۆژ',
        M: 'یه‌ك مانگ',
        MM: '%d مانگ',
        y: 'یه‌ك ساڵ',
        yy: '%d ساڵ',
      },
      preparse: function (string) {
        return string
          .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap$a[match]
          })
          .replace(/،/g, ',')
      },
      postformat: function (string) {
        return string
          .replace(/\d/g, function (match) {
            return symbolMap$b[match]
          })
          .replace(/,/g, '،')
      },
      week: {
        dow: 6,
        doy: 12,
      },
    })
    var suffixes$2 = {
      0: '-чү',
      1: '-чи',
      2: '-чи',
      3: '-чү',
      4: '-чү',
      5: '-чи',
      6: '-чы',
      7: '-чи',
      8: '-чи',
      9: '-чу',
      10: '-чу',
      20: '-чы',
      30: '-чу',
      40: '-чы',
      50: '-чү',
      60: '-чы',
      70: '-чи',
      80: '-чи',
      90: '-чу',
      100: '-чү',
    }
    hooks.defineLocale('ky', {
      months:
        'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
          '_'
        ),
      monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
        '_'
      ),
      weekdays:
        'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
      weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
      weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[Бүгүн саат] LT',
        nextDay: '[Эртең саат] LT',
        nextWeek: 'dddd [саат] LT',
        lastDay: '[Кечээ саат] LT',
        lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: '%s ичинде',
        past: '%s мурун',
        s: 'бирнече секунд',
        ss: '%d секунд',
        m: 'бир мүнөт',
        mm: '%d мүнөт',
        h: 'бир саат',
        hh: '%d саат',
        d: 'бир күн',
        dd: '%d күн',
        M: 'бир ай',
        MM: '%d ай',
        y: 'бир жыл',
        yy: '%d жыл',
      },
      dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
      ordinal: function (number) {
        var a = number % 10,
          b = number >= 100 ? 100 : null
        return number + (suffixes$2[number] || suffixes$2[a] || suffixes$2[b])
      },
      week: {
        dow: 1,
        doy: 7,
      },
    })
    function processRelativeTime$6(number, withoutSuffix, key, isFuture) {
      var format = {
        m: ['eng Minutt', 'enger Minutt'],
        h: ['eng Stonn', 'enger Stonn'],
        d: ['een Dag', 'engem Dag'],
        M: ['ee Mount', 'engem Mount'],
        y: ['ee Joer', 'engem Joer'],
      }
      return withoutSuffix ? format[key][0] : format[key][1]
    }
    function processFutureTime(string) {
      var number = string.substr(0, string.indexOf(' '))
      if (eifelerRegelAppliesToNumber(number)) {
        return 'a ' + string
      }
      return 'an ' + string
    }
    function processPastTime(string) {
      var number = string.substr(0, string.indexOf(' '))
      if (eifelerRegelAppliesToNumber(number)) {
        return 'viru ' + string
      }
      return 'virun ' + string
    }
    function eifelerRegelAppliesToNumber(number) {
      number = parseInt(number, 10)
      if (isNaN(number)) {
        return false
      }
      if (number < 0) {
        return true
      } else if (number < 10) {
        if (4 <= number && number <= 7) {
          return true
        }
        return false
      } else if (number < 100) {
        var lastDigit = number % 10,
          firstDigit = number / 10
        if (lastDigit === 0) {
          return eifelerRegelAppliesToNumber(firstDigit)
        }
        return eifelerRegelAppliesToNumber(lastDigit)
      } else if (number < 1e4) {
        while (number >= 10) {
          number = number / 10
        }
        return eifelerRegelAppliesToNumber(number)
      } else {
        number = number / 1e3
        return eifelerRegelAppliesToNumber(number)
      }
    }
    hooks.defineLocale('lb', {
      months:
        'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
          '_'
        ),
      monthsShort:
        'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
          '_'
        ),
      monthsParseExact: true,
      weekdays:
        'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
          '_'
        ),
      weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
      weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'H:mm [Auer]',
        LTS: 'H:mm:ss [Auer]',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm [Auer]',
        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
      },
      calendar: {
        sameDay: '[Haut um] LT',
        sameElse: 'L',
        nextDay: '[Muer um] LT',
        nextWeek: 'dddd [um] LT',
        lastDay: '[Gëschter um] LT',
        lastWeek: function () {
          switch (this.day()) {
            case 2:
            case 4:
              return '[Leschten] dddd [um] LT'

            default:
              return '[Leschte] dddd [um] LT'
          }
        },
      },
      relativeTime: {
        future: processFutureTime,
        past: processPastTime,
        s: 'e puer Sekonnen',
        ss: '%d Sekonnen',
        m: processRelativeTime$6,
        mm: '%d Minutten',
        h: processRelativeTime$6,
        hh: '%d Stonnen',
        d: processRelativeTime$6,
        dd: '%d Deeg',
        M: processRelativeTime$6,
        MM: '%d Méint',
        y: processRelativeTime$6,
        yy: '%d Joer',
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: '%d.',
      week: {
        dow: 1,
        doy: 4,
      },
    })
    hooks.defineLocale('lo', {
      months:
        'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
          '_'
        ),
      monthsShort:
        'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
          '_'
        ),
      weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
      weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
      weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
      },
      meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
      isPM: function (input) {
        return input === 'ຕອນແລງ'
      },
      meridiem: function (hour, minute, isLower) {
        if (hour < 12) {
          return 'ຕອນເຊົ້າ'
        } else {
          return 'ຕອນແລງ'
        }
      },
      calendar: {
        sameDay: '[ມື້ນີ້ເວລາ] LT',
        nextDay: '[ມື້ອື່ນເວລາ] LT',
        nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
        lastDay: '[ມື້ວານນີ້ເວລາ] LT',
        lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'ອີກ %s',
        past: '%sຜ່ານມາ',
        s: 'ບໍ່ເທົ່າໃດວິນາທີ',
        ss: '%d ວິນາທີ',
        m: '1 ນາທີ',
        mm: '%d ນາທີ',
        h: '1 ຊົ່ວໂມງ',
        hh: '%d ຊົ່ວໂມງ',
        d: '1 ມື້',
        dd: '%d ມື້',
        M: '1 ເດືອນ',
        MM: '%d ເດືອນ',
        y: '1 ປີ',
        yy: '%d ປີ',
      },
      dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
      ordinal: function (number) {
        return 'ທີ່' + number
      },
    })
    var units = {
      ss: 'sekundė_sekundžių_sekundes',
      m: 'minutė_minutės_minutę',
      mm: 'minutės_minučių_minutes',
      h: 'valanda_valandos_valandą',
      hh: 'valandos_valandų_valandas',
      d: 'diena_dienos_dieną',
      dd: 'dienos_dienų_dienas',
      M: 'mėnuo_mėnesio_mėnesį',
      MM: 'mėnesiai_mėnesių_mėnesius',
      y: 'metai_metų_metus',
      yy: 'metai_metų_metus',
    }
    function translateSeconds(number, withoutSuffix, key, isFuture) {
      if (withoutSuffix) {
        return 'kelios sekundės'
      } else {
        return isFuture ? 'kelių sekundžių' : 'kelias sekundes'
      }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
      return withoutSuffix
        ? forms(key)[0]
        : isFuture
          ? forms(key)[1]
          : forms(key)[2]
    }
    function special(number) {
      return number % 10 === 0 || (number > 10 && number < 20)
    }
    function forms(key) {
      return units[key].split('_')
    }
    function translate$6(number, withoutSuffix, key, isFuture) {
      var result = number + ' '
      if (number === 1) {
        return (
          result + translateSingular(number, withoutSuffix, key[0], isFuture)
        )
      } else if (withoutSuffix) {
        return result + (special(number) ? forms(key)[1] : forms(key)[0])
      } else {
        if (isFuture) {
          return result + forms(key)[1]
        } else {
          return result + (special(number) ? forms(key)[1] : forms(key)[2])
        }
      }
    }
    hooks.defineLocale('lt', {
      months: {
        format:
          'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
            '_'
          ),
        standalone:
          'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
            '_'
          ),
        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
      },
      monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
      weekdays: {
        format:
          'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
            '_'
          ),
        standalone:
          'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
            '_'
          ),
        isFormat: /dddd HH:mm/,
      },
      weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
      weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'YYYY-MM-DD',
        LL: 'YYYY [m.] MMMM D [d.]',
        LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
        LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
        l: 'YYYY-MM-DD',
        ll: 'YYYY [m.] MMMM D [d.]',
        lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
        llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
      },
      calendar: {
        sameDay: '[Šiandien] LT',
        nextDay: '[Rytoj] LT',
        nextWeek: 'dddd LT',
        lastDay: '[Vakar] LT',
        lastWeek: '[Praėjusį] dddd LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'po %s',
        past: 'prieš %s',
        s: translateSeconds,
        ss: translate$6,
        m: translateSingular,
        mm: translate$6,
        h: translateSingular,
        hh: translate$6,
        d: translateSingular,
        dd: translate$6,
        M: translateSingular,
        MM: translate$6,
        y: translateSingular,
        yy: translate$6,
      },
      dayOfMonthOrdinalParse: /\d{1,2}-oji/,
      ordinal: function (number) {
        return number + '-oji'
      },
      week: {
        dow: 1,
        doy: 4,
      },
    })
    var units$1 = {
      ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
      m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
      mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
      h: 'stundas_stundām_stunda_stundas'.split('_'),
      hh: 'stundas_stundām_stunda_stundas'.split('_'),
      d: 'dienas_dienām_diena_dienas'.split('_'),
      dd: 'dienas_dienām_diena_dienas'.split('_'),
      M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
      MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
      y: 'gada_gadiem_gads_gadi'.split('_'),
      yy: 'gada_gadiem_gads_gadi'.split('_'),
    }
    function format$1(forms, number, withoutSuffix) {
      if (withoutSuffix) {
        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3]
      } else {
        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1]
      }
    }
    function relativeTimeWithPlural$1(number, withoutSuffix, key) {
      return number + ' ' + format$1(units$1[key], number, withoutSuffix)
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
      return format$1(units$1[key], number, withoutSuffix)
    }
    function relativeSeconds(number, withoutSuffix) {
      return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm'
    }
    hooks.defineLocale('lv', {
      months:
        'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
          '_'
        ),
      monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
      weekdays:
        'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
          '_'
        ),
      weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
      weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD.MM.YYYY.',
        LL: 'YYYY. [gada] D. MMMM',
        LLL: 'YYYY. [gada] D. MMMM, HH:mm',
        LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
      },
      calendar: {
        sameDay: '[Šodien pulksten] LT',
        nextDay: '[Rīt pulksten] LT',
        nextWeek: 'dddd [pulksten] LT',
        lastDay: '[Vakar pulksten] LT',
        lastWeek: '[Pagājušā] dddd [pulksten] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'pēc %s',
        past: 'pirms %s',
        s: relativeSeconds,
        ss: relativeTimeWithPlural$1,
        m: relativeTimeWithSingular,
        mm: relativeTimeWithPlural$1,
        h: relativeTimeWithSingular,
        hh: relativeTimeWithPlural$1,
        d: relativeTimeWithSingular,
        dd: relativeTimeWithPlural$1,
        M: relativeTimeWithSingular,
        MM: relativeTimeWithPlural$1,
        y: relativeTimeWithSingular,
        yy: relativeTimeWithPlural$1,
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: '%d.',
      week: {
        dow: 1,
        doy: 4,
      },
    })
    var translator = {
      words: {
        ss: ['sekund', 'sekunda', 'sekundi'],
        m: ['jedan minut', 'jednog minuta'],
        mm: ['minut', 'minuta', 'minuta'],
        h: ['jedan sat', 'jednog sata'],
        hh: ['sat', 'sata', 'sati'],
        dd: ['dan', 'dana', 'dana'],
        MM: ['mjesec', 'mjeseca', 'mjeseci'],
        yy: ['godina', 'godine', 'godina'],
      },
      correctGrammaticalCase: function (number, wordKey) {
        return number === 1
          ? wordKey[0]
          : number >= 2 && number <= 4
            ? wordKey[1]
            : wordKey[2]
      },
      translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key]
        if (key.length === 1) {
          return withoutSuffix ? wordKey[0] : wordKey[1]
        } else {
          return (
            number + ' ' + translator.correctGrammaticalCase(number, wordKey)
          )
        }
      },
    }
    hooks.defineLocale('me', {
      months:
        'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
          '_'
        ),
      monthsShort:
        'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
      monthsParseExact: true,
      weekdays:
        'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
      weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
      weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'H:mm',
        LTS: 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm',
      },
      calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sjutra u] LT',
        nextWeek: function () {
          switch (this.day()) {
            case 0:
              return '[u] [nedjelju] [u] LT'

            case 3:
              return '[u] [srijedu] [u] LT'

            case 6:
              return '[u] [subotu] [u] LT'

            case 1:
            case 2:
            case 4:
            case 5:
              return '[u] dddd [u] LT'
          }
        },
        lastDay: '[juče u] LT',
        lastWeek: function () {
          var lastWeekDays = [
            '[prošle] [nedjelje] [u] LT',
            '[prošlog] [ponedjeljka] [u] LT',
            '[prošlog] [utorka] [u] LT',
            '[prošle] [srijede] [u] LT',
            '[prošlog] [četvrtka] [u] LT',
            '[prošlog] [petka] [u] LT',
            '[prošle] [subote] [u] LT',
          ]
          return lastWeekDays[this.day()]
        },
        sameElse: 'L',
      },
      relativeTime: {
        future: 'za %s',
        past: 'prije %s',
        s: 'nekoliko sekundi',
        ss: translator.translate,
        m: translator.translate,
        mm: translator.translate,
        h: translator.translate,
        hh: translator.translate,
        d: 'dan',
        dd: translator.translate,
        M: 'mjesec',
        MM: translator.translate,
        y: 'godinu',
        yy: translator.translate,
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: '%d.',
      week: {
        dow: 1,
        doy: 7,
      },
    })
    hooks.defineLocale('mi', {
      months:
        'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
          '_'
        ),
      monthsShort:
        'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
          '_'
        ),
      monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
      monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
      monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
      monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
      weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
      weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
      weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY [i] HH:mm',
        LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
      },
      calendar: {
        sameDay: '[i teie mahana, i] LT',
        nextDay: '[apopo i] LT',
        nextWeek: 'dddd [i] LT',
        lastDay: '[inanahi i] LT',
        lastWeek: 'dddd [whakamutunga i] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'i roto i %s',
        past: '%s i mua',
        s: 'te hēkona ruarua',
        ss: '%d hēkona',
        m: 'he meneti',
        mm: '%d meneti',
        h: 'te haora',
        hh: '%d haora',
        d: 'he ra',
        dd: '%d ra',
        M: 'he marama',
        MM: '%d marama',
        y: 'he tau',
        yy: '%d tau',
      },
      dayOfMonthOrdinalParse: /\d{1,2}º/,
      ordinal: '%dº',
      week: {
        dow: 1,
        doy: 4,
      },
    })
    hooks.defineLocale('mk', {
      months:
        'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
          '_'
        ),
      monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
      weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
        '_'
      ),
      weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
      weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
      longDateFormat: {
        LT: 'H:mm',
        LTS: 'H:mm:ss',
        L: 'D.MM.YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY H:mm',
        LLLL: 'dddd, D MMMM YYYY H:mm',
      },
      calendar: {
        sameDay: '[Денес во] LT',
        nextDay: '[Утре во] LT',
        nextWeek: '[Во] dddd [во] LT',
        lastDay: '[Вчера во] LT',
        lastWeek: function () {
          switch (this.day()) {
            case 0:
            case 3:
            case 6:
              return '[Изминатата] dddd [во] LT'

            case 1:
            case 2:
            case 4:
            case 5:
              return '[Изминатиот] dddd [во] LT'
          }
        },
        sameElse: 'L',
      },
      relativeTime: {
        future: 'за %s',
        past: 'пред %s',
        s: 'неколку секунди',
        ss: '%d секунди',
        m: 'една минута',
        mm: '%d минути',
        h: 'еден час',
        hh: '%d часа',
        d: 'еден ден',
        dd: '%d дена',
        M: 'еден месец',
        MM: '%d месеци',
        y: 'една година',
        yy: '%d години',
      },
      dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
      ordinal: function (number) {
        var lastDigit = number % 10,
          last2Digits = number % 100
        if (number === 0) {
          return number + '-ев'
        } else if (last2Digits === 0) {
          return number + '-ен'
        } else if (last2Digits > 10 && last2Digits < 20) {
          return number + '-ти'
        } else if (lastDigit === 1) {
          return number + '-ви'
        } else if (lastDigit === 2) {
          return number + '-ри'
        } else if (lastDigit === 7 || lastDigit === 8) {
          return number + '-ми'
        } else {
          return number + '-ти'
        }
      },
      week: {
        dow: 1,
        doy: 7,
      },
    })
    hooks.defineLocale('ml', {
      months:
        'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
          '_'
        ),
      monthsShort:
        'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
          '_'
        ),
      monthsParseExact: true,
      weekdays:
        'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
          '_'
        ),
      weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
      weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
      longDateFormat: {
        LT: 'A h:mm -നു',
        LTS: 'A h:mm:ss -നു',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY, A h:mm -നു',
        LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
      },
      calendar: {
        sameDay: '[ഇന്ന്] LT',
        nextDay: '[നാളെ] LT',
        nextWeek: 'dddd, LT',
        lastDay: '[ഇന്നലെ] LT',
        lastWeek: '[കഴിഞ്ഞ] dddd, LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: '%s കഴിഞ്ഞ്',
        past: '%s മുൻപ്',
        s: 'അൽപ നിമിഷങ്ങൾ',
        ss: '%d സെക്കൻഡ്',
        m: 'ഒരു മിനിറ്റ്',
        mm: '%d മിനിറ്റ്',
        h: 'ഒരു മണിക്കൂർ',
        hh: '%d മണിക്കൂർ',
        d: 'ഒരു ദിവസം',
        dd: '%d ദിവസം',
        M: 'ഒരു മാസം',
        MM: '%d മാസം',
        y: 'ഒരു വർഷം',
        yy: '%d വർഷം',
      },
      meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
      meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
          hour = 0
        }
        if (
          (meridiem === 'രാത്രി' && hour >= 4) ||
          meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
          meridiem === 'വൈകുന്നേരം'
        ) {
          return hour + 12
        } else {
          return hour
        }
      },
      meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
          return 'രാത്രി'
        } else if (hour < 12) {
          return 'രാവിലെ'
        } else if (hour < 17) {
          return 'ഉച്ച കഴിഞ്ഞ്'
        } else if (hour < 20) {
          return 'വൈകുന്നേരം'
        } else {
          return 'രാത്രി'
        }
      },
    })
    function translate$7(number, withoutSuffix, key, isFuture) {
      switch (key) {
        case 's':
          return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын'

        case 'ss':
          return number + (withoutSuffix ? ' секунд' : ' секундын')

        case 'm':
        case 'mm':
          return number + (withoutSuffix ? ' минут' : ' минутын')

        case 'h':
        case 'hh':
          return number + (withoutSuffix ? ' цаг' : ' цагийн')

        case 'd':
        case 'dd':
          return number + (withoutSuffix ? ' өдөр' : ' өдрийн')

        case 'M':
        case 'MM':
          return number + (withoutSuffix ? ' сар' : ' сарын')

        case 'y':
        case 'yy':
          return number + (withoutSuffix ? ' жил' : ' жилийн')

        default:
          return number
      }
    }
    hooks.defineLocale('mn', {
      months:
        'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
          '_'
        ),
      monthsShort:
        '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
          '_'
        ),
      monthsParseExact: true,
      weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
      weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
      weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'YYYY-MM-DD',
        LL: 'YYYY оны MMMMын D',
        LLL: 'YYYY оны MMMMын D HH:mm',
        LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
      },
      meridiemParse: /ҮӨ|ҮХ/i,
      isPM: function (input) {
        return input === 'ҮХ'
      },
      meridiem: function (hour, minute, isLower) {
        if (hour < 12) {
          return 'ҮӨ'
        } else {
          return 'ҮХ'
        }
      },
      calendar: {
        sameDay: '[Өнөөдөр] LT',
        nextDay: '[Маргааш] LT',
        nextWeek: '[Ирэх] dddd LT',
        lastDay: '[Өчигдөр] LT',
        lastWeek: '[Өнгөрсөн] dddd LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: '%s дараа',
        past: '%s өмнө',
        s: translate$7,
        ss: translate$7,
        m: translate$7,
        mm: translate$7,
        h: translate$7,
        hh: translate$7,
        d: translate$7,
        dd: translate$7,
        M: translate$7,
        MM: translate$7,
        y: translate$7,
        yy: translate$7,
      },
      dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
      ordinal: function (number, period) {
        switch (period) {
          case 'd':
          case 'D':
          case 'DDD':
            return number + ' өдөр'

          default:
            return number
        }
      },
    })
    var symbolMap$c = {
        1: '१',
        2: '२',
        3: '३',
        4: '४',
        5: '५',
        6: '६',
        7: '७',
        8: '८',
        9: '९',
        0: '०',
      },
      numberMap$b = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0',
      }
    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
      var output = ''
      if (withoutSuffix) {
        switch (string) {
          case 's':
            output = 'काही सेकंद'
            break

          case 'ss':
            output = '%d सेकंद'
            break

          case 'm':
            output = 'एक मिनिट'
            break

          case 'mm':
            output = '%d मिनिटे'
            break

          case 'h':
            output = 'एक तास'
            break

          case 'hh':
            output = '%d तास'
            break

          case 'd':
            output = 'एक दिवस'
            break

          case 'dd':
            output = '%d दिवस'
            break

          case 'M':
            output = 'एक महिना'
            break

          case 'MM':
            output = '%d महिने'
            break

          case 'y':
            output = 'एक वर्ष'
            break

          case 'yy':
            output = '%d वर्षे'
            break
        }
      } else {
        switch (string) {
          case 's':
            output = 'काही सेकंदां'
            break

          case 'ss':
            output = '%d सेकंदां'
            break

          case 'm':
            output = 'एका मिनिटा'
            break

          case 'mm':
            output = '%d मिनिटां'
            break

          case 'h':
            output = 'एका तासा'
            break

          case 'hh':
            output = '%d तासां'
            break

          case 'd':
            output = 'एका दिवसा'
            break

          case 'dd':
            output = '%d दिवसां'
            break

          case 'M':
            output = 'एका महिन्या'
            break

          case 'MM':
            output = '%d महिन्यां'
            break

          case 'y':
            output = 'एका वर्षा'
            break

          case 'yy':
            output = '%d वर्षां'
            break
        }
      }
      return output.replace(/%d/i, number)
    }
    hooks.defineLocale('mr', {
      months:
        'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
          '_'
        ),
      monthsShort:
        'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
          '_'
        ),
      monthsParseExact: true,
      weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split(
        '_'
      ),
      weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
      weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
      longDateFormat: {
        LT: 'A h:mm वाजता',
        LTS: 'A h:mm:ss वाजता',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY, A h:mm वाजता',
        LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
      },
      calendar: {
        sameDay: '[आज] LT',
        nextDay: '[उद्या] LT',
        nextWeek: 'dddd, LT',
        lastDay: '[काल] LT',
        lastWeek: '[मागील] dddd, LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: '%sमध्ये',
        past: '%sपूर्वी',
        s: relativeTimeMr,
        ss: relativeTimeMr,
        m: relativeTimeMr,
        mm: relativeTimeMr,
        h: relativeTimeMr,
        hh: relativeTimeMr,
        d: relativeTimeMr,
        dd: relativeTimeMr,
        M: relativeTimeMr,
        MM: relativeTimeMr,
        y: relativeTimeMr,
        yy: relativeTimeMr,
      },
      preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
          return numberMap$b[match]
        })
      },
      postformat: function (string) {
        return string.replace(/\d/g, function (match) {
          return symbolMap$c[match]
        })
      },
      meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
      meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
          hour = 0
        }
        if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
          return hour
        } else if (
          meridiem === 'दुपारी' ||
          meridiem === 'सायंकाळी' ||
          meridiem === 'रात्री'
        ) {
          return hour >= 12 ? hour : hour + 12
        }
      },
      meridiem: function (hour, minute, isLower) {
        if (hour >= 0 && hour < 6) {
          return 'पहाटे'
        } else if (hour < 12) {
          return 'सकाळी'
        } else if (hour < 17) {
          return 'दुपारी'
        } else if (hour < 20) {
          return 'सायंकाळी'
        } else {
          return 'रात्री'
        }
      },
      week: {
        dow: 0,
        doy: 6,
      },
    })
    hooks.defineLocale('ms-my', {
      months:
        'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
          '_'
        ),
      monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
      weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
      weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
      weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
      longDateFormat: {
        LT: 'HH.mm',
        LTS: 'HH.mm.ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY [pukul] HH.mm',
        LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
      },
      meridiemParse: /pagi|tengahari|petang|malam/,
      meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
          hour = 0
        }
        if (meridiem === 'pagi') {
          return hour
        } else if (meridiem === 'tengahari') {
          return hour >= 11 ? hour : hour + 12
        } else if (meridiem === 'petang' || meridiem === 'malam') {
          return hour + 12
        }
      },
      meridiem: function (hours, minutes, isLower) {
        if (hours < 11) {
          return 'pagi'
        } else if (hours < 15) {
          return 'tengahari'
        } else if (hours < 19) {
          return 'petang'
        } else {
          return 'malam'
        }
      },
      calendar: {
        sameDay: '[Hari ini pukul] LT',
        nextDay: '[Esok pukul] LT',
        nextWeek: 'dddd [pukul] LT',
        lastDay: '[Kelmarin pukul] LT',
        lastWeek: 'dddd [lepas pukul] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'dalam %s',
        past: '%s yang lepas',
        s: 'beberapa saat',
        ss: '%d saat',
        m: 'seminit',
        mm: '%d minit',
        h: 'sejam',
        hh: '%d jam',
        d: 'sehari',
        dd: '%d hari',
        M: 'sebulan',
        MM: '%d bulan',
        y: 'setahun',
        yy: '%d tahun',
      },
      week: {
        dow: 1,
        doy: 7,
      },
    })
    hooks.defineLocale('ms', {
      months:
        'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
          '_'
        ),
      monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
      weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
      weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
      weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
      longDateFormat: {
        LT: 'HH.mm',
        LTS: 'HH.mm.ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY [pukul] HH.mm',
        LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
      },
      meridiemParse: /pagi|tengahari|petang|malam/,
      meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
          hour = 0
        }
        if (meridiem === 'pagi') {
          return hour
        } else if (meridiem === 'tengahari') {
          return hour >= 11 ? hour : hour + 12
        } else if (meridiem === 'petang' || meridiem === 'malam') {
          return hour + 12
        }
      },
      meridiem: function (hours, minutes, isLower) {
        if (hours < 11) {
          return 'pagi'
        } else if (hours < 15) {
          return 'tengahari'
        } else if (hours < 19) {
          return 'petang'
        } else {
          return 'malam'
        }
      },
      calendar: {
        sameDay: '[Hari ini pukul] LT',
        nextDay: '[Esok pukul] LT',
        nextWeek: 'dddd [pukul] LT',
        lastDay: '[Kelmarin pukul] LT',
        lastWeek: 'dddd [lepas pukul] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'dalam %s',
        past: '%s yang lepas',
        s: 'beberapa saat',
        ss: '%d saat',
        m: 'seminit',
        mm: '%d minit',
        h: 'sejam',
        hh: '%d jam',
        d: 'sehari',
        dd: '%d hari',
        M: 'sebulan',
        MM: '%d bulan',
        y: 'setahun',
        yy: '%d tahun',
      },
      week: {
        dow: 1,
        doy: 7,
      },
    })
    hooks.defineLocale('mt', {
      months:
        'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
          '_'
        ),
      monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
      weekdays:
        'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
          '_'
        ),
      weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
      weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[Illum fil-]LT',
        nextDay: '[Għada fil-]LT',
        nextWeek: 'dddd [fil-]LT',
        lastDay: '[Il-bieraħ fil-]LT',
        lastWeek: 'dddd [li għadda] [fil-]LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'f’ %s',
        past: '%s ilu',
        s: 'ftit sekondi',
        ss: '%d sekondi',
        m: 'minuta',
        mm: '%d minuti',
        h: 'siegħa',
        hh: '%d siegħat',
        d: 'ġurnata',
        dd: '%d ġranet',
        M: 'xahar',
        MM: '%d xhur',
        y: 'sena',
        yy: '%d sni',
      },
      dayOfMonthOrdinalParse: /\d{1,2}º/,
      ordinal: '%dº',
      week: {
        dow: 1,
        doy: 4,
      },
    })
    var symbolMap$d = {
        1: '၁',
        2: '၂',
        3: '၃',
        4: '၄',
        5: '၅',
        6: '၆',
        7: '၇',
        8: '၈',
        9: '၉',
        0: '၀',
      },
      numberMap$c = {
        '၁': '1',
        '၂': '2',
        '၃': '3',
        '၄': '4',
        '၅': '5',
        '၆': '6',
        '၇': '7',
        '၈': '8',
        '၉': '9',
        '၀': '0',
      }
    hooks.defineLocale('my', {
      months:
        'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
          '_'
        ),
      monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split(
        '_'
      ),
      weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
        '_'
      ),
      weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
      weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[ယနေ.] LT [မှာ]',
        nextDay: '[မနက်ဖြန်] LT [မှာ]',
        nextWeek: 'dddd LT [မှာ]',
        lastDay: '[မနေ.က] LT [မှာ]',
        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'လာမည့် %s မှာ',
        past: 'လွန်ခဲ့သော %s က',
        s: 'စက္ကန်.အနည်းငယ်',
        ss: '%d စက္ကန့်',
        m: 'တစ်မိနစ်',
        mm: '%d မိနစ်',
        h: 'တစ်နာရီ',
        hh: '%d နာရီ',
        d: 'တစ်ရက်',
        dd: '%d ရက်',
        M: 'တစ်လ',
        MM: '%d လ',
        y: 'တစ်နှစ်',
        yy: '%d နှစ်',
      },
      preparse: function (string) {
        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
          return numberMap$c[match]
        })
      },
      postformat: function (string) {
        return string.replace(/\d/g, function (match) {
          return symbolMap$d[match]
        })
      },
      week: {
        dow: 1,
        doy: 4,
      },
    })
    hooks.defineLocale('nb', {
      months:
        'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
          '_'
        ),
      monthsShort:
        'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
      monthsParseExact: true,
      weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
      weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
      weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY [kl.] HH:mm',
        LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
      },
      calendar: {
        sameDay: '[i dag kl.] LT',
        nextDay: '[i morgen kl.] LT',
        nextWeek: 'dddd [kl.] LT',
        lastDay: '[i går kl.] LT',
        lastWeek: '[forrige] dddd [kl.] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'om %s',
        past: '%s siden',
        s: 'noen sekunder',
        ss: '%d sekunder',
        m: 'ett minutt',
        mm: '%d minutter',
        h: 'en time',
        hh: '%d timer',
        d: 'en dag',
        dd: '%d dager',
        w: 'en uke',
        ww: '%d uker',
        M: 'en måned',
        MM: '%d måneder',
        y: 'ett år',
        yy: '%d år',
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: '%d.',
      week: {
        dow: 1,
        doy: 4,
      },
    })
    var symbolMap$e = {
        1: '१',
        2: '२',
        3: '३',
        4: '४',
        5: '५',
        6: '६',
        7: '७',
        8: '८',
        9: '९',
        0: '०',
      },
      numberMap$d = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0',
      }
    hooks.defineLocale('ne', {
      months:
        'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
          '_'
        ),
      monthsShort:
        'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
          '_'
        ),
      monthsParseExact: true,
      weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
        '_'
      ),
      weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
      weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'Aको h:mm बजे',
        LTS: 'Aको h:mm:ss बजे',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY, Aको h:mm बजे',
        LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
      },
      preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
          return numberMap$d[match]
        })
      },
      postformat: function (string) {
        return string.replace(/\d/g, function (match) {
          return symbolMap$e[match]
        })
      },
      meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
      meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
          hour = 0
        }
        if (meridiem === 'राति') {
          return hour < 4 ? hour : hour + 12
        } else if (meridiem === 'बिहान') {
          return hour
        } else if (meridiem === 'दिउँसो') {
          return hour >= 10 ? hour : hour + 12
        } else if (meridiem === 'साँझ') {
          return hour + 12
        }
      },
      meridiem: function (hour, minute, isLower) {
        if (hour < 3) {
          return 'राति'
        } else if (hour < 12) {
          return 'बिहान'
        } else if (hour < 16) {
          return 'दिउँसो'
        } else if (hour < 20) {
          return 'साँझ'
        } else {
          return 'राति'
        }
      },
      calendar: {
        sameDay: '[आज] LT',
        nextDay: '[भोलि] LT',
        nextWeek: '[आउँदो] dddd[,] LT',
        lastDay: '[हिजो] LT',
        lastWeek: '[गएको] dddd[,] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: '%sमा',
        past: '%s अगाडि',
        s: 'केही क्षण',
        ss: '%d सेकेण्ड',
        m: 'एक मिनेट',
        mm: '%d मिनेट',
        h: 'एक घण्टा',
        hh: '%d घण्टा',
        d: 'एक दिन',
        dd: '%d दिन',
        M: 'एक महिना',
        MM: '%d महिना',
        y: 'एक बर्ष',
        yy: '%d बर्ष',
      },
      week: {
        dow: 0,
        doy: 6,
      },
    })
    var monthsShortWithDots$1 =
        'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
      monthsShortWithoutDots$1 =
        'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
      monthsParse$8 = [
        /^jan/i,
        /^feb/i,
        /^maart|mrt.?$/i,
        /^apr/i,
        /^mei$/i,
        /^jun[i.]?$/i,
        /^jul[i.]?$/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i,
      ],
      monthsRegex$8 =
        /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i
    hooks.defineLocale('nl-be', {
      months:
        'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
          '_'
        ),
      monthsShort: function (m, format) {
        if (!m) {
          return monthsShortWithDots$1
        } else if (/-MMM-/.test(format)) {
          return monthsShortWithoutDots$1[m.month()]
        } else {
          return monthsShortWithDots$1[m.month()]
        }
      },
      monthsRegex: monthsRegex$8,
      monthsShortRegex: monthsRegex$8,
      monthsStrictRegex:
        /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
      monthsShortStrictRegex:
        /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
      monthsParse: monthsParse$8,
      longMonthsParse: monthsParse$8,
      shortMonthsParse: monthsParse$8,
      weekdays:
        'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
      weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
      weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[vandaag om] LT',
        nextDay: '[morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[gisteren om] LT',
        lastWeek: '[afgelopen] dddd [om] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'over %s',
        past: '%s geleden',
        s: 'een paar seconden',
        ss: '%d seconden',
        m: 'één minuut',
        mm: '%d minuten',
        h: 'één uur',
        hh: '%d uur',
        d: 'één dag',
        dd: '%d dagen',
        M: 'één maand',
        MM: '%d maanden',
        y: 'één jaar',
        yy: '%d jaar',
      },
      dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
      ordinal: function (number) {
        return (
          number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
        )
      },
      week: {
        dow: 1,
        doy: 4,
      },
    })
    var monthsShortWithDots$2 =
        'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
      monthsShortWithoutDots$2 =
        'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
      monthsParse$9 = [
        /^jan/i,
        /^feb/i,
        /^maart|mrt.?$/i,
        /^apr/i,
        /^mei$/i,
        /^jun[i.]?$/i,
        /^jul[i.]?$/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i,
      ],
      monthsRegex$9 =
        /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i
    hooks.defineLocale('nl', {
      months:
        'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
          '_'
        ),
      monthsShort: function (m, format) {
        if (!m) {
          return monthsShortWithDots$2
        } else if (/-MMM-/.test(format)) {
          return monthsShortWithoutDots$2[m.month()]
        } else {
          return monthsShortWithDots$2[m.month()]
        }
      },
      monthsRegex: monthsRegex$9,
      monthsShortRegex: monthsRegex$9,
      monthsStrictRegex:
        /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
      monthsShortStrictRegex:
        /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
      monthsParse: monthsParse$9,
      longMonthsParse: monthsParse$9,
      shortMonthsParse: monthsParse$9,
      weekdays:
        'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
      weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
      weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD-MM-YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[vandaag om] LT',
        nextDay: '[morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[gisteren om] LT',
        lastWeek: '[afgelopen] dddd [om] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'over %s',
        past: '%s geleden',
        s: 'een paar seconden',
        ss: '%d seconden',
        m: 'één minuut',
        mm: '%d minuten',
        h: 'één uur',
        hh: '%d uur',
        d: 'één dag',
        dd: '%d dagen',
        w: 'één week',
        ww: '%d weken',
        M: 'één maand',
        MM: '%d maanden',
        y: 'één jaar',
        yy: '%d jaar',
      },
      dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
      ordinal: function (number) {
        return (
          number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
        )
      },
      week: {
        dow: 1,
        doy: 4,
      },
    })
    hooks.defineLocale('nn', {
      months:
        'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
          '_'
        ),
      monthsShort:
        'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
      monthsParseExact: true,
      weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
      weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
      weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY [kl.] H:mm',
        LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
      },
      calendar: {
        sameDay: '[I dag klokka] LT',
        nextDay: '[I morgon klokka] LT',
        nextWeek: 'dddd [klokka] LT',
        lastDay: '[I går klokka] LT',
        lastWeek: '[Føregåande] dddd [klokka] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'om %s',
        past: '%s sidan',
        s: 'nokre sekund',
        ss: '%d sekund',
        m: 'eit minutt',
        mm: '%d minutt',
        h: 'ein time',
        hh: '%d timar',
        d: 'ein dag',
        dd: '%d dagar',
        w: 'ei veke',
        ww: '%d veker',
        M: 'ein månad',
        MM: '%d månader',
        y: 'eit år',
        yy: '%d år',
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: '%d.',
      week: {
        dow: 1,
        doy: 4,
      },
    })
    hooks.defineLocale('oc-lnc', {
      months: {
        standalone:
          'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
            '_'
          ),
        format:
          "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
            '_'
          ),
        isFormat: /D[oD]?(\s)+MMMM/,
      },
      monthsShort:
        'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
          '_'
        ),
      monthsParseExact: true,
      weekdays:
        'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split('_'),
      weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
      weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'H:mm',
        LTS: 'H:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM [de] YYYY',
        ll: 'D MMM YYYY',
        LLL: 'D MMMM [de] YYYY [a] H:mm',
        lll: 'D MMM YYYY, H:mm',
        LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
        llll: 'ddd D MMM YYYY, H:mm',
      },
      calendar: {
        sameDay: '[uèi a] LT',
        nextDay: '[deman a] LT',
        nextWeek: 'dddd [a] LT',
        lastDay: '[ièr a] LT',
        lastWeek: 'dddd [passat a] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: "d'aquí %s",
        past: 'fa %s',
        s: 'unas segondas',
        ss: '%d segondas',
        m: 'una minuta',
        mm: '%d minutas',
        h: 'una ora',
        hh: '%d oras',
        d: 'un jorn',
        dd: '%d jorns',
        M: 'un mes',
        MM: '%d meses',
        y: 'un an',
        yy: '%d ans',
      },
      dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
      ordinal: function (number, period) {
        var output =
          number === 1
            ? 'r'
            : number === 2
              ? 'n'
              : number === 3
                ? 'r'
                : number === 4
                  ? 't'
                  : 'è'
        if (period === 'w' || period === 'W') {
          output = 'a'
        }
        return number + output
      },
      week: {
        dow: 1,
        doy: 4,
      },
    })
    var symbolMap$f = {
        1: '੧',
        2: '੨',
        3: '੩',
        4: '੪',
        5: '੫',
        6: '੬',
        7: '੭',
        8: '੮',
        9: '੯',
        0: '੦',
      },
      numberMap$e = {
        '੧': '1',
        '੨': '2',
        '੩': '3',
        '੪': '4',
        '੫': '5',
        '੬': '6',
        '੭': '7',
        '੮': '8',
        '੯': '9',
        '੦': '0',
      }
    hooks.defineLocale('pa-in', {
      months:
        'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
          '_'
        ),
      monthsShort:
        'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
          '_'
        ),
      weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
        '_'
      ),
      weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
      weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
      longDateFormat: {
        LT: 'A h:mm ਵਜੇ',
        LTS: 'A h:mm:ss ਵਜੇ',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
        LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
      },
      calendar: {
        sameDay: '[ਅਜ] LT',
        nextDay: '[ਕਲ] LT',
        nextWeek: '[ਅਗਲਾ] dddd, LT',
        lastDay: '[ਕਲ] LT',
        lastWeek: '[ਪਿਛਲੇ] dddd, LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: '%s ਵਿੱਚ',
        past: '%s ਪਿਛਲੇ',
        s: 'ਕੁਝ ਸਕਿੰਟ',
        ss: '%d ਸਕਿੰਟ',
        m: 'ਇਕ ਮਿੰਟ',
        mm: '%d ਮਿੰਟ',
        h: 'ਇੱਕ ਘੰਟਾ',
        hh: '%d ਘੰਟੇ',
        d: 'ਇੱਕ ਦਿਨ',
        dd: '%d ਦਿਨ',
        M: 'ਇੱਕ ਮਹੀਨਾ',
        MM: '%d ਮਹੀਨੇ',
        y: 'ਇੱਕ ਸਾਲ',
        yy: '%d ਸਾਲ',
      },
      preparse: function (string) {
        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
          return numberMap$e[match]
        })
      },
      postformat: function (string) {
        return string.replace(/\d/g, function (match) {
          return symbolMap$f[match]
        })
      },
      meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
      meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
          hour = 0
        }
        if (meridiem === 'ਰਾਤ') {
          return hour < 4 ? hour : hour + 12
        } else if (meridiem === 'ਸਵੇਰ') {
          return hour
        } else if (meridiem === 'ਦੁਪਹਿਰ') {
          return hour >= 10 ? hour : hour + 12
        } else if (meridiem === 'ਸ਼ਾਮ') {
          return hour + 12
        }
      },
      meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
          return 'ਰਾਤ'
        } else if (hour < 10) {
          return 'ਸਵੇਰ'
        } else if (hour < 17) {
          return 'ਦੁਪਹਿਰ'
        } else if (hour < 20) {
          return 'ਸ਼ਾਮ'
        } else {
          return 'ਰਾਤ'
        }
      },
      week: {
        dow: 0,
        doy: 6,
      },
    })
    var monthsNominative =
        'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
          '_'
        ),
      monthsSubjective =
        'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
          '_'
        ),
      monthsParse$a = [
        /^sty/i,
        /^lut/i,
        /^mar/i,
        /^kwi/i,
        /^maj/i,
        /^cze/i,
        /^lip/i,
        /^sie/i,
        /^wrz/i,
        /^paź/i,
        /^lis/i,
        /^gru/i,
      ]
    function plural$3(n) {
      return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1
    }
    function translate$8(number, withoutSuffix, key) {
      var result = number + ' '
      switch (key) {
        case 'ss':
          return result + (plural$3(number) ? 'sekundy' : 'sekund')

        case 'm':
          return withoutSuffix ? 'minuta' : 'minutę'

        case 'mm':
          return result + (plural$3(number) ? 'minuty' : 'minut')

        case 'h':
          return withoutSuffix ? 'godzina' : 'godzinę'

        case 'hh':
          return result + (plural$3(number) ? 'godziny' : 'godzin')

        case 'ww':
          return result + (plural$3(number) ? 'tygodnie' : 'tygodni')

        case 'MM':
          return result + (plural$3(number) ? 'miesiące' : 'miesięcy')

        case 'yy':
          return result + (plural$3(number) ? 'lata' : 'lat')
      }
    }
    hooks.defineLocale('pl', {
      months: function (momentToFormat, format) {
        if (!momentToFormat) {
          return monthsNominative
        } else if (/D MMMM/.test(format)) {
          return monthsSubjective[momentToFormat.month()]
        } else {
          return monthsNominative[momentToFormat.month()]
        }
      },
      monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
      monthsParse: monthsParse$a,
      longMonthsParse: monthsParse$a,
      shortMonthsParse: monthsParse$a,
      weekdays:
        'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
      weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
      weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[Dziś o] LT',
        nextDay: '[Jutro o] LT',
        nextWeek: function () {
          switch (this.day()) {
            case 0:
              return '[W niedzielę o] LT'

            case 2:
              return '[We wtorek o] LT'

            case 3:
              return '[W środę o] LT'

            case 6:
              return '[W sobotę o] LT'

            default:
              return '[W] dddd [o] LT'
          }
        },
        lastDay: '[Wczoraj o] LT',
        lastWeek: function () {
          switch (this.day()) {
            case 0:
              return '[W zeszłą niedzielę o] LT'

            case 3:
              return '[W zeszłą środę o] LT'

            case 6:
              return '[W zeszłą sobotę o] LT'

            default:
              return '[W zeszły] dddd [o] LT'
          }
        },
        sameElse: 'L',
      },
      relativeTime: {
        future: 'za %s',
        past: '%s temu',
        s: 'kilka sekund',
        ss: translate$8,
        m: translate$8,
        mm: translate$8,
        h: translate$8,
        hh: translate$8,
        d: '1 dzień',
        dd: '%d dni',
        w: 'tydzień',
        ww: translate$8,
        M: 'miesiąc',
        MM: translate$8,
        y: 'rok',
        yy: translate$8,
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: '%d.',
      week: {
        dow: 1,
        doy: 4,
      },
    })
    hooks.defineLocale('pt-br', {
      months:
        'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
          '_'
        ),
      monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
      weekdays:
        'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
          '_'
        ),
      weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
      weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D [de] MMMM [de] YYYY',
        LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
        LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
      },
      calendar: {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
          return this.day() === 0 || this.day() === 6
            ? '[Último] dddd [às] LT'
            : '[Última] dddd [às] LT'
        },
        sameElse: 'L',
      },
      relativeTime: {
        future: 'em %s',
        past: 'há %s',
        s: 'poucos segundos',
        ss: '%d segundos',
        m: 'um minuto',
        mm: '%d minutos',
        h: 'uma hora',
        hh: '%d horas',
        d: 'um dia',
        dd: '%d dias',
        M: 'um mês',
        MM: '%d meses',
        y: 'um ano',
        yy: '%d anos',
      },
      dayOfMonthOrdinalParse: /\d{1,2}º/,
      ordinal: '%dº',
      invalidDate: 'Data inválida',
    })
    hooks.defineLocale('pt', {
      months:
        'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
          '_'
        ),
      monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
      weekdays:
        'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
          '_'
        ),
      weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
      weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D [de] MMMM [de] YYYY',
        LLL: 'D [de] MMMM [de] YYYY HH:mm',
        LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
      },
      calendar: {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
          return this.day() === 0 || this.day() === 6
            ? '[Último] dddd [às] LT'
            : '[Última] dddd [às] LT'
        },
        sameElse: 'L',
      },
      relativeTime: {
        future: 'em %s',
        past: 'há %s',
        s: 'segundos',
        ss: '%d segundos',
        m: 'um minuto',
        mm: '%d minutos',
        h: 'uma hora',
        hh: '%d horas',
        d: 'um dia',
        dd: '%d dias',
        w: 'uma semana',
        ww: '%d semanas',
        M: 'um mês',
        MM: '%d meses',
        y: 'um ano',
        yy: '%d anos',
      },
      dayOfMonthOrdinalParse: /\d{1,2}º/,
      ordinal: '%dº',
      week: {
        dow: 1,
        doy: 4,
      },
    })
    function relativeTimeWithPlural$2(number, withoutSuffix, key) {
      var format = {
          ss: 'secunde',
          mm: 'minute',
          hh: 'ore',
          dd: 'zile',
          ww: 'săptămâni',
          MM: 'luni',
          yy: 'ani',
        },
        separator = ' '
      if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
        separator = ' de '
      }
      return number + separator + format[key]
    }
    hooks.defineLocale('ro', {
      months:
        'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
          '_'
        ),
      monthsShort:
        'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
          '_'
        ),
      monthsParseExact: true,
      weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
      weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
      weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
      longDateFormat: {
        LT: 'H:mm',
        LTS: 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY H:mm',
        LLLL: 'dddd, D MMMM YYYY H:mm',
      },
      calendar: {
        sameDay: '[azi la] LT',
        nextDay: '[mâine la] LT',
        nextWeek: 'dddd [la] LT',
        lastDay: '[ieri la] LT',
        lastWeek: '[fosta] dddd [la] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'peste %s',
        past: '%s în urmă',
        s: 'câteva secunde',
        ss: relativeTimeWithPlural$2,
        m: 'un minut',
        mm: relativeTimeWithPlural$2,
        h: 'o oră',
        hh: relativeTimeWithPlural$2,
        d: 'o zi',
        dd: relativeTimeWithPlural$2,
        w: 'o săptămână',
        ww: relativeTimeWithPlural$2,
        M: 'o lună',
        MM: relativeTimeWithPlural$2,
        y: 'un an',
        yy: relativeTimeWithPlural$2,
      },
      week: {
        dow: 1,
        doy: 7,
      },
    })
    function plural$4(word, num) {
      var forms = word.split('_')
      return num % 10 === 1 && num % 100 !== 11
        ? forms[0]
        : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
          ? forms[1]
          : forms[2]
    }
    function relativeTimeWithPlural$3(number, withoutSuffix, key) {
      var format = {
        ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
        mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
        hh: 'час_часа_часов',
        dd: 'день_дня_дней',
        ww: 'неделя_недели_недель',
        MM: 'месяц_месяца_месяцев',
        yy: 'год_года_лет',
      }
      if (key === 'm') {
        return withoutSuffix ? 'минута' : 'минуту'
      } else {
        return number + ' ' + plural$4(format[key], +number)
      }
    }
    var monthsParse$b = [
      /^янв/i,
      /^фев/i,
      /^мар/i,
      /^апр/i,
      /^ма[йя]/i,
      /^июн/i,
      /^июл/i,
      /^авг/i,
      /^сен/i,
      /^окт/i,
      /^ноя/i,
      /^дек/i,
    ]
    hooks.defineLocale('ru', {
      months: {
        format:
          'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
            '_'
          ),
        standalone:
          'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
            '_'
          ),
      },
      monthsShort: {
        format:
          'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
            '_'
          ),
        standalone:
          'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
            '_'
          ),
      },
      weekdays: {
        standalone:
          'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
            '_'
          ),
        format:
          'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
            '_'
          ),
        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
      },
      weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
      weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
      monthsParse: monthsParse$b,
      longMonthsParse: monthsParse$b,
      shortMonthsParse: monthsParse$b,
      monthsRegex:
        /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
      monthsShortRegex:
        /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
      monthsStrictRegex:
        /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
      monthsShortStrictRegex:
        /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
      longDateFormat: {
        LT: 'H:mm',
        LTS: 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D MMMM YYYY г.',
        LLL: 'D MMMM YYYY г., H:mm',
        LLLL: 'dddd, D MMMM YYYY г., H:mm',
      },
      calendar: {
        sameDay: '[Сегодня, в] LT',
        nextDay: '[Завтра, в] LT',
        lastDay: '[Вчера, в] LT',
        nextWeek: function (now) {
          if (now.week() !== this.week()) {
            switch (this.day()) {
              case 0:
                return '[В следующее] dddd, [в] LT'

              case 1:
              case 2:
              case 4:
                return '[В следующий] dddd, [в] LT'

              case 3:
              case 5:
              case 6:
                return '[В следующую] dddd, [в] LT'
            }
          } else {
            if (this.day() === 2) {
              return '[Во] dddd, [в] LT'
            } else {
              return '[В] dddd, [в] LT'
            }
          }
        },
        lastWeek: function (now) {
          if (now.week() !== this.week()) {
            switch (this.day()) {
              case 0:
                return '[В прошлое] dddd, [в] LT'

              case 1:
              case 2:
              case 4:
                return '[В прошлый] dddd, [в] LT'

              case 3:
              case 5:
              case 6:
                return '[В прошлую] dddd, [в] LT'
            }
          } else {
            if (this.day() === 2) {
              return '[Во] dddd, [в] LT'
            } else {
              return '[В] dddd, [в] LT'
            }
          }
        },
        sameElse: 'L',
      },
      relativeTime: {
        future: 'через %s',
        past: '%s назад',
        s: 'несколько секунд',
        ss: relativeTimeWithPlural$3,
        m: relativeTimeWithPlural$3,
        mm: relativeTimeWithPlural$3,
        h: 'час',
        hh: relativeTimeWithPlural$3,
        d: 'день',
        dd: relativeTimeWithPlural$3,
        w: 'неделя',
        ww: relativeTimeWithPlural$3,
        M: 'месяц',
        MM: relativeTimeWithPlural$3,
        y: 'год',
        yy: relativeTimeWithPlural$3,
      },
      meridiemParse: /ночи|утра|дня|вечера/i,
      isPM: function (input) {
        return /^(дня|вечера)$/.test(input)
      },
      meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
          return 'ночи'
        } else if (hour < 12) {
          return 'утра'
        } else if (hour < 17) {
          return 'дня'
        } else {
          return 'вечера'
        }
      },
      dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
      ordinal: function (number, period) {
        switch (period) {
          case 'M':
          case 'd':
          case 'DDD':
            return number + '-й'

          case 'D':
            return number + '-го'

          case 'w':
          case 'W':
            return number + '-я'

          default:
            return number
        }
      },
      week: {
        dow: 1,
        doy: 4,
      },
    })
    var months$9 = [
        'جنوري',
        'فيبروري',
        'مارچ',
        'اپريل',
        'مئي',
        'جون',
        'جولاءِ',
        'آگسٽ',
        'سيپٽمبر',
        'آڪٽوبر',
        'نومبر',
        'ڊسمبر',
      ],
      days$1 = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر']
    hooks.defineLocale('sd', {
      months: months$9,
      monthsShort: months$9,
      weekdays: days$1,
      weekdaysShort: days$1,
      weekdaysMin: days$1,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd، D MMMM YYYY HH:mm',
      },
      meridiemParse: /صبح|شام/,
      isPM: function (input) {
        return 'شام' === input
      },
      meridiem: function (hour, minute, isLower) {
        if (hour < 12) {
          return 'صبح'
        }
        return 'شام'
      },
      calendar: {
        sameDay: '[اڄ] LT',
        nextDay: '[سڀاڻي] LT',
        nextWeek: 'dddd [اڳين هفتي تي] LT',
        lastDay: '[ڪالهه] LT',
        lastWeek: '[گزريل هفتي] dddd [تي] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: '%s پوء',
        past: '%s اڳ',
        s: 'چند سيڪنڊ',
        ss: '%d سيڪنڊ',
        m: 'هڪ منٽ',
        mm: '%d منٽ',
        h: 'هڪ ڪلاڪ',
        hh: '%d ڪلاڪ',
        d: 'هڪ ڏينهن',
        dd: '%d ڏينهن',
        M: 'هڪ مهينو',
        MM: '%d مهينا',
        y: 'هڪ سال',
        yy: '%d سال',
      },
      preparse: function (string) {
        return string.replace(/،/g, ',')
      },
      postformat: function (string) {
        return string.replace(/,/g, '،')
      },
      week: {
        dow: 1,
        doy: 4,
      },
    })
    hooks.defineLocale('se', {
      months:
        'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
          '_'
        ),
      monthsShort:
        'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
      weekdays:
        'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
          '_'
        ),
      weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
      weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'MMMM D. [b.] YYYY',
        LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
        LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
      },
      calendar: {
        sameDay: '[otne ti] LT',
        nextDay: '[ihttin ti] LT',
        nextWeek: 'dddd [ti] LT',
        lastDay: '[ikte ti] LT',
        lastWeek: '[ovddit] dddd [ti] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: '%s geažes',
        past: 'maŋit %s',
        s: 'moadde sekunddat',
        ss: '%d sekunddat',
        m: 'okta minuhta',
        mm: '%d minuhtat',
        h: 'okta diimmu',
        hh: '%d diimmut',
        d: 'okta beaivi',
        dd: '%d beaivvit',
        M: 'okta mánnu',
        MM: '%d mánut',
        y: 'okta jahki',
        yy: '%d jagit',
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: '%d.',
      week: {
        dow: 1,
        doy: 4,
      },
    })
    hooks.defineLocale('si', {
      months:
        'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
          '_'
        ),
      monthsShort:
        'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
      weekdays:
        'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
          '_'
        ),
      weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
      weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'a h:mm',
        LTS: 'a h:mm:ss',
        L: 'YYYY/MM/DD',
        LL: 'YYYY MMMM D',
        LLL: 'YYYY MMMM D, a h:mm',
        LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
      },
      calendar: {
        sameDay: '[අද] LT[ට]',
        nextDay: '[හෙට] LT[ට]',
        nextWeek: 'dddd LT[ට]',
        lastDay: '[ඊයේ] LT[ට]',
        lastWeek: '[පසුගිය] dddd LT[ට]',
        sameElse: 'L',
      },
      relativeTime: {
        future: '%sකින්',
        past: '%sකට පෙර',
        s: 'තත්පර කිහිපය',
        ss: 'තත්පර %d',
        m: 'මිනිත්තුව',
        mm: 'මිනිත්තු %d',
        h: 'පැය',
        hh: 'පැය %d',
        d: 'දිනය',
        dd: 'දින %d',
        M: 'මාසය',
        MM: 'මාස %d',
        y: 'වසර',
        yy: 'වසර %d',
      },
      dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
      ordinal: function (number) {
        return number + ' වැනි'
      },
      meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
      isPM: function (input) {
        return input === 'ප.ව.' || input === 'පස් වරු'
      },
      meridiem: function (hours, minutes, isLower) {
        if (hours > 11) {
          return isLower ? 'ප.ව.' : 'පස් වරු'
        } else {
          return isLower ? 'පෙ.ව.' : 'පෙර වරු'
        }
      },
    })
    var months$a =
        'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
          '_'
        ),
      monthsShort$7 = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split(
        '_'
      )
    function plural$5(n) {
      return n > 1 && n < 5
    }
    function translate$9(number, withoutSuffix, key, isFuture) {
      var result = number + ' '
      switch (key) {
        case 's':
          return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami'

        case 'ss':
          if (withoutSuffix || isFuture) {
            return result + (plural$5(number) ? 'sekundy' : 'sekúnd')
          } else {
            return result + 'sekundami'
          }

        case 'm':
          return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou'

        case 'mm':
          if (withoutSuffix || isFuture) {
            return result + (plural$5(number) ? 'minúty' : 'minút')
          } else {
            return result + 'minútami'
          }

        case 'h':
          return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou'

        case 'hh':
          if (withoutSuffix || isFuture) {
            return result + (plural$5(number) ? 'hodiny' : 'hodín')
          } else {
            return result + 'hodinami'
          }

        case 'd':
          return withoutSuffix || isFuture ? 'deň' : 'dňom'

        case 'dd':
          if (withoutSuffix || isFuture) {
            return result + (plural$5(number) ? 'dni' : 'dní')
          } else {
            return result + 'dňami'
          }

        case 'M':
          return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom'

        case 'MM':
          if (withoutSuffix || isFuture) {
            return result + (plural$5(number) ? 'mesiace' : 'mesiacov')
          } else {
            return result + 'mesiacmi'
          }

        case 'y':
          return withoutSuffix || isFuture ? 'rok' : 'rokom'

        case 'yy':
          if (withoutSuffix || isFuture) {
            return result + (plural$5(number) ? 'roky' : 'rokov')
          } else {
            return result + 'rokmi'
          }
      }
    }
    hooks.defineLocale('sk', {
      months: months$a,
      monthsShort: monthsShort$7,
      weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split(
        '_'
      ),
      weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
      weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
      longDateFormat: {
        LT: 'H:mm',
        LTS: 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd D. MMMM YYYY H:mm',
      },
      calendar: {
        sameDay: '[dnes o] LT',
        nextDay: '[zajtra o] LT',
        nextWeek: function () {
          switch (this.day()) {
            case 0:
              return '[v nedeľu o] LT'

            case 1:
            case 2:
              return '[v] dddd [o] LT'

            case 3:
              return '[v stredu o] LT'

            case 4:
              return '[vo štvrtok o] LT'

            case 5:
              return '[v piatok o] LT'

            case 6:
              return '[v sobotu o] LT'
          }
        },
        lastDay: '[včera o] LT',
        lastWeek: function () {
          switch (this.day()) {
            case 0:
              return '[minulú nedeľu o] LT'

            case 1:
            case 2:
              return '[minulý] dddd [o] LT'

            case 3:
              return '[minulú stredu o] LT'

            case 4:
            case 5:
              return '[minulý] dddd [o] LT'

            case 6:
              return '[minulú sobotu o] LT'
          }
        },
        sameElse: 'L',
      },
      relativeTime: {
        future: 'za %s',
        past: 'pred %s',
        s: translate$9,
        ss: translate$9,
        m: translate$9,
        mm: translate$9,
        h: translate$9,
        hh: translate$9,
        d: translate$9,
        dd: translate$9,
        M: translate$9,
        MM: translate$9,
        y: translate$9,
        yy: translate$9,
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: '%d.',
      week: {
        dow: 1,
        doy: 4,
      },
    })
    function processRelativeTime$7(number, withoutSuffix, key, isFuture) {
      var result = number + ' '
      switch (key) {
        case 's':
          return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami'

        case 'ss':
          if (number === 1) {
            result += withoutSuffix ? 'sekundo' : 'sekundi'
          } else if (number === 2) {
            result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah'
          } else if (number < 5) {
            result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah'
          } else {
            result += 'sekund'
          }
          return result

        case 'm':
          return withoutSuffix ? 'ena minuta' : 'eno minuto'

        case 'mm':
          if (number === 1) {
            result += withoutSuffix ? 'minuta' : 'minuto'
          } else if (number === 2) {
            result += withoutSuffix || isFuture ? 'minuti' : 'minutama'
          } else if (number < 5) {
            result += withoutSuffix || isFuture ? 'minute' : 'minutami'
          } else {
            result += withoutSuffix || isFuture ? 'minut' : 'minutami'
          }
          return result

        case 'h':
          return withoutSuffix ? 'ena ura' : 'eno uro'

        case 'hh':
          if (number === 1) {
            result += withoutSuffix ? 'ura' : 'uro'
          } else if (number === 2) {
            result += withoutSuffix || isFuture ? 'uri' : 'urama'
          } else if (number < 5) {
            result += withoutSuffix || isFuture ? 'ure' : 'urami'
          } else {
            result += withoutSuffix || isFuture ? 'ur' : 'urami'
          }
          return result

        case 'd':
          return withoutSuffix || isFuture ? 'en dan' : 'enim dnem'

        case 'dd':
          if (number === 1) {
            result += withoutSuffix || isFuture ? 'dan' : 'dnem'
          } else if (number === 2) {
            result += withoutSuffix || isFuture ? 'dni' : 'dnevoma'
          } else {
            result += withoutSuffix || isFuture ? 'dni' : 'dnevi'
          }
          return result

        case 'M':
          return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem'

        case 'MM':
          if (number === 1) {
            result += withoutSuffix || isFuture ? 'mesec' : 'mesecem'
          } else if (number === 2) {
            result += withoutSuffix || isFuture ? 'meseca' : 'mesecema'
          } else if (number < 5) {
            result += withoutSuffix || isFuture ? 'mesece' : 'meseci'
          } else {
            result += withoutSuffix || isFuture ? 'mesecev' : 'meseci'
          }
          return result

        case 'y':
          return withoutSuffix || isFuture ? 'eno leto' : 'enim letom'

        case 'yy':
          if (number === 1) {
            result += withoutSuffix || isFuture ? 'leto' : 'letom'
          } else if (number === 2) {
            result += withoutSuffix || isFuture ? 'leti' : 'letoma'
          } else if (number < 5) {
            result += withoutSuffix || isFuture ? 'leta' : 'leti'
          } else {
            result += withoutSuffix || isFuture ? 'let' : 'leti'
          }
          return result
      }
    }
    hooks.defineLocale('sl', {
      months:
        'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
          '_'
        ),
      monthsShort:
        'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
          '_'
        ),
      monthsParseExact: true,
      weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split(
        '_'
      ),
      weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
      weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'H:mm',
        LTS: 'H:mm:ss',
        L: 'DD. MM. YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm',
      },
      calendar: {
        sameDay: '[danes ob] LT',
        nextDay: '[jutri ob] LT',
        nextWeek: function () {
          switch (this.day()) {
            case 0:
              return '[v] [nedeljo] [ob] LT'

            case 3:
              return '[v] [sredo] [ob] LT'

            case 6:
              return '[v] [soboto] [ob] LT'

            case 1:
            case 2:
            case 4:
            case 5:
              return '[v] dddd [ob] LT'
          }
        },
        lastDay: '[včeraj ob] LT',
        lastWeek: function () {
          switch (this.day()) {
            case 0:
              return '[prejšnjo] [nedeljo] [ob] LT'

            case 3:
              return '[prejšnjo] [sredo] [ob] LT'

            case 6:
              return '[prejšnjo] [soboto] [ob] LT'

            case 1:
            case 2:
            case 4:
            case 5:
              return '[prejšnji] dddd [ob] LT'
          }
        },
        sameElse: 'L',
      },
      relativeTime: {
        future: 'čez %s',
        past: 'pred %s',
        s: processRelativeTime$7,
        ss: processRelativeTime$7,
        m: processRelativeTime$7,
        mm: processRelativeTime$7,
        h: processRelativeTime$7,
        hh: processRelativeTime$7,
        d: processRelativeTime$7,
        dd: processRelativeTime$7,
        M: processRelativeTime$7,
        MM: processRelativeTime$7,
        y: processRelativeTime$7,
        yy: processRelativeTime$7,
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: '%d.',
      week: {
        dow: 1,
        doy: 7,
      },
    })
    hooks.defineLocale('sq', {
      months:
        'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
          '_'
        ),
      monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
      weekdays:
        'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
      weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
      weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
      weekdaysParseExact: true,
      meridiemParse: /PD|MD/,
      isPM: function (input) {
        return input.charAt(0) === 'M'
      },
      meridiem: function (hours, minutes, isLower) {
        return hours < 12 ? 'PD' : 'MD'
      },
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[Sot në] LT',
        nextDay: '[Nesër në] LT',
        nextWeek: 'dddd [në] LT',
        lastDay: '[Dje në] LT',
        lastWeek: 'dddd [e kaluar në] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'në %s',
        past: '%s më parë',
        s: 'disa sekonda',
        ss: '%d sekonda',
        m: 'një minutë',
        mm: '%d minuta',
        h: 'një orë',
        hh: '%d orë',
        d: 'një ditë',
        dd: '%d ditë',
        M: 'një muaj',
        MM: '%d muaj',
        y: 'një vit',
        yy: '%d vite',
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: '%d.',
      week: {
        dow: 1,
        doy: 4,
      },
    })
    var translator$1 = {
      words: {
        ss: ['секунда', 'секунде', 'секунди'],
        m: ['један минут', 'једне минуте'],
        mm: ['минут', 'минуте', 'минута'],
        h: ['један сат', 'једног сата'],
        hh: ['сат', 'сата', 'сати'],
        dd: ['дан', 'дана', 'дана'],
        MM: ['месец', 'месеца', 'месеци'],
        yy: ['година', 'године', 'година'],
      },
      correctGrammaticalCase: function (number, wordKey) {
        return number === 1
          ? wordKey[0]
          : number >= 2 && number <= 4
            ? wordKey[1]
            : wordKey[2]
      },
      translate: function (number, withoutSuffix, key) {
        var wordKey = translator$1.words[key]
        if (key.length === 1) {
          return withoutSuffix ? wordKey[0] : wordKey[1]
        } else {
          return (
            number + ' ' + translator$1.correctGrammaticalCase(number, wordKey)
          )
        }
      },
    }
    hooks.defineLocale('sr-cyrl', {
      months:
        'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
          '_'
        ),
      monthsShort:
        'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
      monthsParseExact: true,
      weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split(
        '_'
      ),
      weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
      weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'H:mm',
        LTS: 'H:mm:ss',
        L: 'D. M. YYYY.',
        LL: 'D. MMMM YYYY.',
        LLL: 'D. MMMM YYYY. H:mm',
        LLLL: 'dddd, D. MMMM YYYY. H:mm',
      },
      calendar: {
        sameDay: '[данас у] LT',
        nextDay: '[сутра у] LT',
        nextWeek: function () {
          switch (this.day()) {
            case 0:
              return '[у] [недељу] [у] LT'

            case 3:
              return '[у] [среду] [у] LT'

            case 6:
              return '[у] [суботу] [у] LT'

            case 1:
            case 2:
            case 4:
            case 5:
              return '[у] dddd [у] LT'
          }
        },
        lastDay: '[јуче у] LT',
        lastWeek: function () {
          var lastWeekDays = [
            '[прошле] [недеље] [у] LT',
            '[прошлог] [понедељка] [у] LT',
            '[прошлог] [уторка] [у] LT',
            '[прошле] [среде] [у] LT',
            '[прошлог] [четвртка] [у] LT',
            '[прошлог] [петка] [у] LT',
            '[прошле] [суботе] [у] LT',
          ]
          return lastWeekDays[this.day()]
        },
        sameElse: 'L',
      },
      relativeTime: {
        future: 'за %s',
        past: 'пре %s',
        s: 'неколико секунди',
        ss: translator$1.translate,
        m: translator$1.translate,
        mm: translator$1.translate,
        h: translator$1.translate,
        hh: translator$1.translate,
        d: 'дан',
        dd: translator$1.translate,
        M: 'месец',
        MM: translator$1.translate,
        y: 'годину',
        yy: translator$1.translate,
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: '%d.',
      week: {
        dow: 1,
        doy: 7,
      },
    })
    var translator$2 = {
      words: {
        ss: ['sekunda', 'sekunde', 'sekundi'],
        m: ['jedan minut', 'jedne minute'],
        mm: ['minut', 'minute', 'minuta'],
        h: ['jedan sat', 'jednog sata'],
        hh: ['sat', 'sata', 'sati'],
        dd: ['dan', 'dana', 'dana'],
        MM: ['mesec', 'meseca', 'meseci'],
        yy: ['godina', 'godine', 'godina'],
      },
      correctGrammaticalCase: function (number, wordKey) {
        return number === 1
          ? wordKey[0]
          : number >= 2 && number <= 4
            ? wordKey[1]
            : wordKey[2]
      },
      translate: function (number, withoutSuffix, key) {
        var wordKey = translator$2.words[key]
        if (key.length === 1) {
          return withoutSuffix ? wordKey[0] : wordKey[1]
        } else {
          return (
            number + ' ' + translator$2.correctGrammaticalCase(number, wordKey)
          )
        }
      },
    }
    hooks.defineLocale('sr', {
      months:
        'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
          '_'
        ),
      monthsShort:
        'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
      monthsParseExact: true,
      weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
        '_'
      ),
      weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
      weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'H:mm',
        LTS: 'H:mm:ss',
        L: 'D. M. YYYY.',
        LL: 'D. MMMM YYYY.',
        LLL: 'D. MMMM YYYY. H:mm',
        LLLL: 'dddd, D. MMMM YYYY. H:mm',
      },
      calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sutra u] LT',
        nextWeek: function () {
          switch (this.day()) {
            case 0:
              return '[u] [nedelju] [u] LT'

            case 3:
              return '[u] [sredu] [u] LT'

            case 6:
              return '[u] [subotu] [u] LT'

            case 1:
            case 2:
            case 4:
            case 5:
              return '[u] dddd [u] LT'
          }
        },
        lastDay: '[juče u] LT',
        lastWeek: function () {
          var lastWeekDays = [
            '[prošle] [nedelje] [u] LT',
            '[prošlog] [ponedeljka] [u] LT',
            '[prošlog] [utorka] [u] LT',
            '[prošle] [srede] [u] LT',
            '[prošlog] [četvrtka] [u] LT',
            '[prošlog] [petka] [u] LT',
            '[prošle] [subote] [u] LT',
          ]
          return lastWeekDays[this.day()]
        },
        sameElse: 'L',
      },
      relativeTime: {
        future: 'za %s',
        past: 'pre %s',
        s: 'nekoliko sekundi',
        ss: translator$2.translate,
        m: translator$2.translate,
        mm: translator$2.translate,
        h: translator$2.translate,
        hh: translator$2.translate,
        d: 'dan',
        dd: translator$2.translate,
        M: 'mesec',
        MM: translator$2.translate,
        y: 'godinu',
        yy: translator$2.translate,
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: '%d.',
      week: {
        dow: 1,
        doy: 7,
      },
    })
    hooks.defineLocale('ss', {
      months:
        "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
          '_'
        ),
      monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
      weekdays:
        'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
          '_'
        ),
      weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
      weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'h:mm A',
        LTS: 'h:mm:ss A',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY h:mm A',
        LLLL: 'dddd, D MMMM YYYY h:mm A',
      },
      calendar: {
        sameDay: '[Namuhla nga] LT',
        nextDay: '[Kusasa nga] LT',
        nextWeek: 'dddd [nga] LT',
        lastDay: '[Itolo nga] LT',
        lastWeek: 'dddd [leliphelile] [nga] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'nga %s',
        past: 'wenteka nga %s',
        s: 'emizuzwana lomcane',
        ss: '%d mzuzwana',
        m: 'umzuzu',
        mm: '%d emizuzu',
        h: 'lihora',
        hh: '%d emahora',
        d: 'lilanga',
        dd: '%d emalanga',
        M: 'inyanga',
        MM: '%d tinyanga',
        y: 'umnyaka',
        yy: '%d iminyaka',
      },
      meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
      meridiem: function (hours, minutes, isLower) {
        if (hours < 11) {
          return 'ekuseni'
        } else if (hours < 15) {
          return 'emini'
        } else if (hours < 19) {
          return 'entsambama'
        } else {
          return 'ebusuku'
        }
      },
      meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
          hour = 0
        }
        if (meridiem === 'ekuseni') {
          return hour
        } else if (meridiem === 'emini') {
          return hour >= 11 ? hour : hour + 12
        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
          if (hour === 0) {
            return 0
          }
          return hour + 12
        }
      },
      dayOfMonthOrdinalParse: /\d{1,2}/,
      ordinal: '%d',
      week: {
        dow: 1,
        doy: 4,
      },
    })
    hooks.defineLocale('sv', {
      months:
        'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
          '_'
        ),
      monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
      weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
      weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
      weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'YYYY-MM-DD',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY [kl.] HH:mm',
        LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
        lll: 'D MMM YYYY HH:mm',
        llll: 'ddd D MMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[Idag] LT',
        nextDay: '[Imorgon] LT',
        lastDay: '[Igår] LT',
        nextWeek: '[På] dddd LT',
        lastWeek: '[I] dddd[s] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'om %s',
        past: 'för %s sedan',
        s: 'några sekunder',
        ss: '%d sekunder',
        m: 'en minut',
        mm: '%d minuter',
        h: 'en timme',
        hh: '%d timmar',
        d: 'en dag',
        dd: '%d dagar',
        M: 'en månad',
        MM: '%d månader',
        y: 'ett år',
        yy: '%d år',
      },
      dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
      ordinal: function (number) {
        var b = number % 10,
          output =
            ~~((number % 100) / 10) === 1
              ? ':e'
              : b === 1
                ? ':a'
                : b === 2
                  ? ':a'
                  : b === 3
                    ? ':e'
                    : ':e'
        return number + output
      },
      week: {
        dow: 1,
        doy: 4,
      },
    })
    hooks.defineLocale('sw', {
      months:
        'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
          '_'
        ),
      monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
      weekdays:
        'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
          '_'
        ),
      weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
      weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'hh:mm A',
        LTS: 'HH:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[leo saa] LT',
        nextDay: '[kesho saa] LT',
        nextWeek: '[wiki ijayo] dddd [saat] LT',
        lastDay: '[jana] LT',
        lastWeek: '[wiki iliyopita] dddd [saat] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: '%s baadaye',
        past: 'tokea %s',
        s: 'hivi punde',
        ss: 'sekunde %d',
        m: 'dakika moja',
        mm: 'dakika %d',
        h: 'saa limoja',
        hh: 'masaa %d',
        d: 'siku moja',
        dd: 'siku %d',
        M: 'mwezi mmoja',
        MM: 'miezi %d',
        y: 'mwaka mmoja',
        yy: 'miaka %d',
      },
      week: {
        dow: 1,
        doy: 7,
      },
    })
    var symbolMap$g = {
        1: '௧',
        2: '௨',
        3: '௩',
        4: '௪',
        5: '௫',
        6: '௬',
        7: '௭',
        8: '௮',
        9: '௯',
        0: '௦',
      },
      numberMap$f = {
        '௧': '1',
        '௨': '2',
        '௩': '3',
        '௪': '4',
        '௫': '5',
        '௬': '6',
        '௭': '7',
        '௮': '8',
        '௯': '9',
        '௦': '0',
      }
    hooks.defineLocale('ta', {
      months:
        'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
          '_'
        ),
      monthsShort:
        'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
          '_'
        ),
      weekdays:
        'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
          '_'
        ),
      weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
        '_'
      ),
      weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY, HH:mm',
        LLLL: 'dddd, D MMMM YYYY, HH:mm',
      },
      calendar: {
        sameDay: '[இன்று] LT',
        nextDay: '[நாளை] LT',
        nextWeek: 'dddd, LT',
        lastDay: '[நேற்று] LT',
        lastWeek: '[கடந்த வாரம்] dddd, LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: '%s இல்',
        past: '%s முன்',
        s: 'ஒரு சில விநாடிகள்',
        ss: '%d விநாடிகள்',
        m: 'ஒரு நிமிடம்',
        mm: '%d நிமிடங்கள்',
        h: 'ஒரு மணி நேரம்',
        hh: '%d மணி நேரம்',
        d: 'ஒரு நாள்',
        dd: '%d நாட்கள்',
        M: 'ஒரு மாதம்',
        MM: '%d மாதங்கள்',
        y: 'ஒரு வருடம்',
        yy: '%d ஆண்டுகள்',
      },
      dayOfMonthOrdinalParse: /\d{1,2}வது/,
      ordinal: function (number) {
        return number + 'வது'
      },
      preparse: function (string) {
        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
          return numberMap$f[match]
        })
      },
      postformat: function (string) {
        return string.replace(/\d/g, function (match) {
          return symbolMap$g[match]
        })
      },
      meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
      meridiem: function (hour, minute, isLower) {
        if (hour < 2) {
          return ' யாமம்'
        } else if (hour < 6) {
          return ' வைகறை'
        } else if (hour < 10) {
          return ' காலை'
        } else if (hour < 14) {
          return ' நண்பகல்'
        } else if (hour < 18) {
          return ' எற்பாடு'
        } else if (hour < 22) {
          return ' மாலை'
        } else {
          return ' யாமம்'
        }
      },
      meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
          hour = 0
        }
        if (meridiem === 'யாமம்') {
          return hour < 2 ? hour : hour + 12
        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
          return hour
        } else if (meridiem === 'நண்பகல்') {
          return hour >= 10 ? hour : hour + 12
        } else {
          return hour + 12
        }
      },
      week: {
        dow: 0,
        doy: 6,
      },
    })
    hooks.defineLocale('te', {
      months:
        'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
          '_'
        ),
      monthsShort:
        'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
          '_'
        ),
      monthsParseExact: true,
      weekdays:
        'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
          '_'
        ),
      weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
      weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
      longDateFormat: {
        LT: 'A h:mm',
        LTS: 'A h:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY, A h:mm',
        LLLL: 'dddd, D MMMM YYYY, A h:mm',
      },
      calendar: {
        sameDay: '[నేడు] LT',
        nextDay: '[రేపు] LT',
        nextWeek: 'dddd, LT',
        lastDay: '[నిన్న] LT',
        lastWeek: '[గత] dddd, LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: '%s లో',
        past: '%s క్రితం',
        s: 'కొన్ని క్షణాలు',
        ss: '%d సెకన్లు',
        m: 'ఒక నిమిషం',
        mm: '%d నిమిషాలు',
        h: 'ఒక గంట',
        hh: '%d గంటలు',
        d: 'ఒక రోజు',
        dd: '%d రోజులు',
        M: 'ఒక నెల',
        MM: '%d నెలలు',
        y: 'ఒక సంవత్సరం',
        yy: '%d సంవత్సరాలు',
      },
      dayOfMonthOrdinalParse: /\d{1,2}వ/,
      ordinal: '%dవ',
      meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
      meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
          hour = 0
        }
        if (meridiem === 'రాత్రి') {
          return hour < 4 ? hour : hour + 12
        } else if (meridiem === 'ఉదయం') {
          return hour
        } else if (meridiem === 'మధ్యాహ్నం') {
          return hour >= 10 ? hour : hour + 12
        } else if (meridiem === 'సాయంత్రం') {
          return hour + 12
        }
      },
      meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
          return 'రాత్రి'
        } else if (hour < 10) {
          return 'ఉదయం'
        } else if (hour < 17) {
          return 'మధ్యాహ్నం'
        } else if (hour < 20) {
          return 'సాయంత్రం'
        } else {
          return 'రాత్రి'
        }
      },
      week: {
        dow: 0,
        doy: 6,
      },
    })
    hooks.defineLocale('tet', {
      months:
        'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
          '_'
        ),
      monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
      weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
      weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
      weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[Ohin iha] LT',
        nextDay: '[Aban iha] LT',
        nextWeek: 'dddd [iha] LT',
        lastDay: '[Horiseik iha] LT',
        lastWeek: 'dddd [semana kotuk] [iha] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'iha %s',
        past: '%s liuba',
        s: 'segundu balun',
        ss: 'segundu %d',
        m: 'minutu ida',
        mm: 'minutu %d',
        h: 'oras ida',
        hh: 'oras %d',
        d: 'loron ida',
        dd: 'loron %d',
        M: 'fulan ida',
        MM: 'fulan %d',
        y: 'tinan ida',
        yy: 'tinan %d',
      },
      dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
      ordinal: function (number) {
        var b = number % 10,
          output =
            ~~((number % 100) / 10) === 1
              ? 'th'
              : b === 1
                ? 'st'
                : b === 2
                  ? 'nd'
                  : b === 3
                    ? 'rd'
                    : 'th'
        return number + output
      },
      week: {
        dow: 1,
        doy: 4,
      },
    })
    var suffixes$3 = {
      0: '-ум',
      1: '-ум',
      2: '-юм',
      3: '-юм',
      4: '-ум',
      5: '-ум',
      6: '-ум',
      7: '-ум',
      8: '-ум',
      9: '-ум',
      10: '-ум',
      12: '-ум',
      13: '-ум',
      20: '-ум',
      30: '-юм',
      40: '-ум',
      50: '-ум',
      60: '-ум',
      70: '-ум',
      80: '-ум',
      90: '-ум',
      100: '-ум',
    }
    hooks.defineLocale('tg', {
      months: {
        format:
          'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
            '_'
          ),
        standalone:
          'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
            '_'
          ),
      },
      monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
      weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
        '_'
      ),
      weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
      weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[Имрӯз соати] LT',
        nextDay: '[Фардо соати] LT',
        lastDay: '[Дирӯз соати] LT',
        nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
        lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'баъди %s',
        past: '%s пеш',
        s: 'якчанд сония',
        m: 'як дақиқа',
        mm: '%d дақиқа',
        h: 'як соат',
        hh: '%d соат',
        d: 'як рӯз',
        dd: '%d рӯз',
        M: 'як моҳ',
        MM: '%d моҳ',
        y: 'як сол',
        yy: '%d сол',
      },
      meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
      meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
          hour = 0
        }
        if (meridiem === 'шаб') {
          return hour < 4 ? hour : hour + 12
        } else if (meridiem === 'субҳ') {
          return hour
        } else if (meridiem === 'рӯз') {
          return hour >= 11 ? hour : hour + 12
        } else if (meridiem === 'бегоҳ') {
          return hour + 12
        }
      },
      meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
          return 'шаб'
        } else if (hour < 11) {
          return 'субҳ'
        } else if (hour < 16) {
          return 'рӯз'
        } else if (hour < 19) {
          return 'бегоҳ'
        } else {
          return 'шаб'
        }
      },
      dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
      ordinal: function (number) {
        var a = number % 10,
          b = number >= 100 ? 100 : null
        return number + (suffixes$3[number] || suffixes$3[a] || suffixes$3[b])
      },
      week: {
        dow: 1,
        doy: 7,
      },
    })
    hooks.defineLocale('th', {
      months:
        'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
          '_'
        ),
      monthsShort:
        'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
          '_'
        ),
      monthsParseExact: true,
      weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
      weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'),
      weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'H:mm',
        LTS: 'H:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY เวลา H:mm',
        LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
      },
      meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
      isPM: function (input) {
        return input === 'หลังเที่ยง'
      },
      meridiem: function (hour, minute, isLower) {
        if (hour < 12) {
          return 'ก่อนเที่ยง'
        } else {
          return 'หลังเที่ยง'
        }
      },
      calendar: {
        sameDay: '[วันนี้ เวลา] LT',
        nextDay: '[พรุ่งนี้ เวลา] LT',
        nextWeek: 'dddd[หน้า เวลา] LT',
        lastDay: '[เมื่อวานนี้ เวลา] LT',
        lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'อีก %s',
        past: '%sที่แล้ว',
        s: 'ไม่กี่วินาที',
        ss: '%d วินาที',
        m: '1 นาที',
        mm: '%d นาที',
        h: '1 ชั่วโมง',
        hh: '%d ชั่วโมง',
        d: '1 วัน',
        dd: '%d วัน',
        w: '1 สัปดาห์',
        ww: '%d สัปดาห์',
        M: '1 เดือน',
        MM: '%d เดือน',
        y: '1 ปี',
        yy: '%d ปี',
      },
    })
    var suffixes$4 = {
      1: "'inji",
      5: "'inji",
      8: "'inji",
      70: "'inji",
      80: "'inji",
      2: "'nji",
      7: "'nji",
      20: "'nji",
      50: "'nji",
      3: "'ünji",
      4: "'ünji",
      100: "'ünji",
      6: "'njy",
      9: "'unjy",
      10: "'unjy",
      30: "'unjy",
      60: "'ynjy",
      90: "'ynjy",
    }
    hooks.defineLocale('tk', {
      months:
        'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
          '_'
        ),
      monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
      weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
        '_'
      ),
      weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
      weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[bugün sagat] LT',
        nextDay: '[ertir sagat] LT',
        nextWeek: '[indiki] dddd [sagat] LT',
        lastDay: '[düýn] LT',
        lastWeek: '[geçen] dddd [sagat] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: '%s soň',
        past: '%s öň',
        s: 'birnäçe sekunt',
        m: 'bir minut',
        mm: '%d minut',
        h: 'bir sagat',
        hh: '%d sagat',
        d: 'bir gün',
        dd: '%d gün',
        M: 'bir aý',
        MM: '%d aý',
        y: 'bir ýyl',
        yy: '%d ýyl',
      },
      ordinal: function (number, period) {
        switch (period) {
          case 'd':
          case 'D':
          case 'Do':
          case 'DD':
            return number

          default:
            if (number === 0) {
              return number + "'unjy"
            }
            var a = number % 10,
              b = (number % 100) - a,
              c = number >= 100 ? 100 : null
            return number + (suffixes$4[a] || suffixes$4[b] || suffixes$4[c])
        }
      },
      week: {
        dow: 1,
        doy: 7,
      },
    })
    hooks.defineLocale('tl-ph', {
      months:
        'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
          '_'
        ),
      monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
      weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
        '_'
      ),
      weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
      weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'MM/D/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY HH:mm',
        LLLL: 'dddd, MMMM DD, YYYY HH:mm',
      },
      calendar: {
        sameDay: 'LT [ngayong araw]',
        nextDay: '[Bukas ng] LT',
        nextWeek: 'LT [sa susunod na] dddd',
        lastDay: 'LT [kahapon]',
        lastWeek: 'LT [noong nakaraang] dddd',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'sa loob ng %s',
        past: '%s ang nakalipas',
        s: 'ilang segundo',
        ss: '%d segundo',
        m: 'isang minuto',
        mm: '%d minuto',
        h: 'isang oras',
        hh: '%d oras',
        d: 'isang araw',
        dd: '%d araw',
        M: 'isang buwan',
        MM: '%d buwan',
        y: 'isang taon',
        yy: '%d taon',
      },
      dayOfMonthOrdinalParse: /\d{1,2}/,
      ordinal: function (number) {
        return number
      },
      week: {
        dow: 1,
        doy: 4,
      },
    })
    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split(
      '_'
    )
    function translateFuture(output) {
      var time = output
      time =
        output.indexOf('jaj') !== -1
          ? time.slice(0, -3) + 'leS'
          : output.indexOf('jar') !== -1
            ? time.slice(0, -3) + 'waQ'
            : output.indexOf('DIS') !== -1
              ? time.slice(0, -3) + 'nem'
              : time + ' pIq'
      return time
    }
    function translatePast(output) {
      var time = output
      time =
        output.indexOf('jaj') !== -1
          ? time.slice(0, -3) + 'Hu’'
          : output.indexOf('jar') !== -1
            ? time.slice(0, -3) + 'wen'
            : output.indexOf('DIS') !== -1
              ? time.slice(0, -3) + 'ben'
              : time + ' ret'
      return time
    }
    function translate$a(number, withoutSuffix, string, isFuture) {
      var numberNoun = numberAsNoun(number)
      switch (string) {
        case 'ss':
          return numberNoun + ' lup'

        case 'mm':
          return numberNoun + ' tup'

        case 'hh':
          return numberNoun + ' rep'

        case 'dd':
          return numberNoun + ' jaj'

        case 'MM':
          return numberNoun + ' jar'

        case 'yy':
          return numberNoun + ' DIS'
      }
    }
    function numberAsNoun(number) {
      var hundred = Math.floor((number % 1e3) / 100),
        ten = Math.floor((number % 100) / 10),
        one = number % 10,
        word = ''
      if (hundred > 0) {
        word += numbersNouns[hundred] + 'vatlh'
      }
      if (ten > 0) {
        word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH'
      }
      if (one > 0) {
        word += (word !== '' ? ' ' : '') + numbersNouns[one]
      }
      return word === '' ? 'pagh' : word
    }
    hooks.defineLocale('tlh', {
      months:
        'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
          '_'
        ),
      monthsShort:
        'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
          '_'
        ),
      monthsParseExact: true,
      weekdays:
        'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
      weekdaysShort:
        'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
      weekdaysMin:
        'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[DaHjaj] LT',
        nextDay: '[wa’leS] LT',
        nextWeek: 'LLL',
        lastDay: '[wa’Hu’] LT',
        lastWeek: 'LLL',
        sameElse: 'L',
      },
      relativeTime: {
        future: translateFuture,
        past: translatePast,
        s: 'puS lup',
        ss: translate$a,
        m: 'wa’ tup',
        mm: translate$a,
        h: 'wa’ rep',
        hh: translate$a,
        d: 'wa’ jaj',
        dd: translate$a,
        M: 'wa’ jar',
        MM: translate$a,
        y: 'wa’ DIS',
        yy: translate$a,
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: '%d.',
      week: {
        dow: 1,
        doy: 4,
      },
    })
    var suffixes$5 = {
      1: "'inci",
      5: "'inci",
      8: "'inci",
      70: "'inci",
      80: "'inci",
      2: "'nci",
      7: "'nci",
      20: "'nci",
      50: "'nci",
      3: "'üncü",
      4: "'üncü",
      100: "'üncü",
      6: "'ncı",
      9: "'uncu",
      10: "'uncu",
      30: "'uncu",
      60: "'ıncı",
      90: "'ıncı",
    }
    hooks.defineLocale('tr', {
      months:
        'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
          '_'
        ),
      monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
      weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
        '_'
      ),
      weekdaysShort: 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
      weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
      meridiem: function (hours, minutes, isLower) {
        if (hours < 12) {
          return isLower ? 'öö' : 'ÖÖ'
        } else {
          return isLower ? 'ös' : 'ÖS'
        }
      },
      meridiemParse: /öö|ÖÖ|ös|ÖS/,
      isPM: function (input) {
        return input === 'ös' || input === 'ÖS'
      },
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[bugün saat] LT',
        nextDay: '[yarın saat] LT',
        nextWeek: '[gelecek] dddd [saat] LT',
        lastDay: '[dün] LT',
        lastWeek: '[geçen] dddd [saat] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: '%s sonra',
        past: '%s önce',
        s: 'birkaç saniye',
        ss: '%d saniye',
        m: 'bir dakika',
        mm: '%d dakika',
        h: 'bir saat',
        hh: '%d saat',
        d: 'bir gün',
        dd: '%d gün',
        w: 'bir hafta',
        ww: '%d hafta',
        M: 'bir ay',
        MM: '%d ay',
        y: 'bir yıl',
        yy: '%d yıl',
      },
      ordinal: function (number, period) {
        switch (period) {
          case 'd':
          case 'D':
          case 'Do':
          case 'DD':
            return number

          default:
            if (number === 0) {
              return number + "'ıncı"
            }
            var a = number % 10,
              b = (number % 100) - a,
              c = number >= 100 ? 100 : null
            return number + (suffixes$5[a] || suffixes$5[b] || suffixes$5[c])
        }
      },
      week: {
        dow: 1,
        doy: 7,
      },
    })
    hooks.defineLocale('tzl', {
      months:
        'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
          '_'
        ),
      monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
      weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split(
        '_'
      ),
      weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
      weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
      longDateFormat: {
        LT: 'HH.mm',
        LTS: 'HH.mm.ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM [dallas] YYYY',
        LLL: 'D. MMMM [dallas] YYYY HH.mm',
        LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
      },
      meridiemParse: /d\'o|d\'a/i,
      isPM: function (input) {
        return "d'o" === input.toLowerCase()
      },
      meridiem: function (hours, minutes, isLower) {
        if (hours > 11) {
          return isLower ? "d'o" : "D'O"
        } else {
          return isLower ? "d'a" : "D'A"
        }
      },
      calendar: {
        sameDay: '[oxhi à] LT',
        nextDay: '[demà à] LT',
        nextWeek: 'dddd [à] LT',
        lastDay: '[ieiri à] LT',
        lastWeek: '[sür el] dddd [lasteu à] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'osprei %s',
        past: 'ja%s',
        s: processRelativeTime$8,
        ss: processRelativeTime$8,
        m: processRelativeTime$8,
        mm: processRelativeTime$8,
        h: processRelativeTime$8,
        hh: processRelativeTime$8,
        d: processRelativeTime$8,
        dd: processRelativeTime$8,
        M: processRelativeTime$8,
        MM: processRelativeTime$8,
        y: processRelativeTime$8,
        yy: processRelativeTime$8,
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: '%d.',
      week: {
        dow: 1,
        doy: 4,
      },
    })
    function processRelativeTime$8(number, withoutSuffix, key, isFuture) {
      var format = {
        s: ['viensas secunds', "'iensas secunds"],
        ss: [number + ' secunds', '' + number + ' secunds'],
        m: ["'n míut", "'iens míut"],
        mm: [number + ' míuts', '' + number + ' míuts'],
        h: ["'n þora", "'iensa þora"],
        hh: [number + ' þoras', '' + number + ' þoras'],
        d: ["'n ziua", "'iensa ziua"],
        dd: [number + ' ziuas', '' + number + ' ziuas'],
        M: ["'n mes", "'iens mes"],
        MM: [number + ' mesen', '' + number + ' mesen'],
        y: ["'n ar", "'iens ar"],
        yy: [number + ' ars', '' + number + ' ars'],
      }
      return isFuture
        ? format[key][0]
        : withoutSuffix
          ? format[key][0]
          : format[key][1]
    }
    hooks.defineLocale('tzm-latn', {
      months:
        'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
          '_'
        ),
      monthsShort:
        'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
          '_'
        ),
      weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
      weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split(
        '_'
      ),
      weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[asdkh g] LT',
        nextDay: '[aska g] LT',
        nextWeek: 'dddd [g] LT',
        lastDay: '[assant g] LT',
        lastWeek: 'dddd [g] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'dadkh s yan %s',
        past: 'yan %s',
        s: 'imik',
        ss: '%d imik',
        m: 'minuḍ',
        mm: '%d minuḍ',
        h: 'saɛa',
        hh: '%d tassaɛin',
        d: 'ass',
        dd: '%d ossan',
        M: 'ayowr',
        MM: '%d iyyirn',
        y: 'asgas',
        yy: '%d isgasn',
      },
      week: {
        dow: 6,
        doy: 12,
      },
    })
    hooks.defineLocale('tzm', {
      months:
        'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
          '_'
        ),
      monthsShort:
        'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
          '_'
        ),
      weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
      weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split(
        '_'
      ),
      weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
        nextWeek: 'dddd [ⴴ] LT',
        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
        lastWeek: 'dddd [ⴴ] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
        past: 'ⵢⴰⵏ %s',
        s: 'ⵉⵎⵉⴽ',
        ss: '%d ⵉⵎⵉⴽ',
        m: 'ⵎⵉⵏⵓⴺ',
        mm: '%d ⵎⵉⵏⵓⴺ',
        h: 'ⵙⴰⵄⴰ',
        hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
        d: 'ⴰⵙⵙ',
        dd: '%d oⵙⵙⴰⵏ',
        M: 'ⴰⵢoⵓⵔ',
        MM: '%d ⵉⵢⵢⵉⵔⵏ',
        y: 'ⴰⵙⴳⴰⵙ',
        yy: '%d ⵉⵙⴳⴰⵙⵏ',
      },
      week: {
        dow: 6,
        doy: 12,
      },
    })
    hooks.defineLocale('ug-cn', {
      months:
        'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
          '_'
        ),
      monthsShort:
        'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
          '_'
        ),
      weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
        '_'
      ),
      weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
      weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'YYYY-MM-DD',
        LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
        LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
        LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
      },
      meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
      meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
          hour = 0
        }
        if (
          meridiem === 'يېرىم كېچە' ||
          meridiem === 'سەھەر' ||
          meridiem === 'چۈشتىن بۇرۇن'
        ) {
          return hour
        } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
          return hour + 12
        } else {
          return hour >= 11 ? hour : hour + 12
        }
      },
      meridiem: function (hour, minute, isLower) {
        var hm = hour * 100 + minute
        if (hm < 600) {
          return 'يېرىم كېچە'
        } else if (hm < 900) {
          return 'سەھەر'
        } else if (hm < 1130) {
          return 'چۈشتىن بۇرۇن'
        } else if (hm < 1230) {
          return 'چۈش'
        } else if (hm < 1800) {
          return 'چۈشتىن كېيىن'
        } else {
          return 'كەچ'
        }
      },
      calendar: {
        sameDay: '[بۈگۈن سائەت] LT',
        nextDay: '[ئەتە سائەت] LT',
        nextWeek: '[كېلەركى] dddd [سائەت] LT',
        lastDay: '[تۆنۈگۈن] LT',
        lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: '%s كېيىن',
        past: '%s بۇرۇن',
        s: 'نەچچە سېكونت',
        ss: '%d سېكونت',
        m: 'بىر مىنۇت',
        mm: '%d مىنۇت',
        h: 'بىر سائەت',
        hh: '%d سائەت',
        d: 'بىر كۈن',
        dd: '%d كۈن',
        M: 'بىر ئاي',
        MM: '%d ئاي',
        y: 'بىر يىل',
        yy: '%d يىل',
      },
      dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
      ordinal: function (number, period) {
        switch (period) {
          case 'd':
          case 'D':
          case 'DDD':
            return number + '-كۈنى'

          case 'w':
          case 'W':
            return number + '-ھەپتە'

          default:
            return number
        }
      },
      preparse: function (string) {
        return string.replace(/،/g, ',')
      },
      postformat: function (string) {
        return string.replace(/,/g, '،')
      },
      week: {
        dow: 1,
        doy: 7,
      },
    })
    function plural$6(word, num) {
      var forms = word.split('_')
      return num % 10 === 1 && num % 100 !== 11
        ? forms[0]
        : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
          ? forms[1]
          : forms[2]
    }
    function relativeTimeWithPlural$4(number, withoutSuffix, key) {
      var format = {
        ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
        mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
        hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
        dd: 'день_дні_днів',
        MM: 'місяць_місяці_місяців',
        yy: 'рік_роки_років',
      }
      if (key === 'm') {
        return withoutSuffix ? 'хвилина' : 'хвилину'
      } else if (key === 'h') {
        return withoutSuffix ? 'година' : 'годину'
      } else {
        return number + ' ' + plural$6(format[key], +number)
      }
    }
    function weekdaysCaseReplace(m, format) {
      var weekdays = {
          nominative:
            'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
              '_'
            ),
          accusative:
            'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
              '_'
            ),
          genitive:
            'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
              '_'
            ),
        },
        nounCase
      if (m === true) {
        return weekdays['nominative']
          .slice(1, 7)
          .concat(weekdays['nominative'].slice(0, 1))
      }
      if (!m) {
        return weekdays['nominative']
      }
      nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
        ? 'accusative'
        : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
          ? 'genitive'
          : 'nominative'
      return weekdays[nounCase][m.day()]
    }
    function processHoursFunction(str) {
      return function () {
        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT'
      }
    }
    hooks.defineLocale('uk', {
      months: {
        format:
          'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
            '_'
          ),
        standalone:
          'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
            '_'
          ),
      },
      monthsShort:
        'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
      weekdays: weekdaysCaseReplace,
      weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
      weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D MMMM YYYY р.',
        LLL: 'D MMMM YYYY р., HH:mm',
        LLLL: 'dddd, D MMMM YYYY р., HH:mm',
      },
      calendar: {
        sameDay: processHoursFunction('[Сьогодні '),
        nextDay: processHoursFunction('[Завтра '),
        lastDay: processHoursFunction('[Вчора '),
        nextWeek: processHoursFunction('[У] dddd ['),
        lastWeek: function () {
          switch (this.day()) {
            case 0:
            case 3:
            case 5:
            case 6:
              return processHoursFunction('[Минулої] dddd [').call(this)

            case 1:
            case 2:
            case 4:
              return processHoursFunction('[Минулого] dddd [').call(this)
          }
        },
        sameElse: 'L',
      },
      relativeTime: {
        future: 'за %s',
        past: '%s тому',
        s: 'декілька секунд',
        ss: relativeTimeWithPlural$4,
        m: relativeTimeWithPlural$4,
        mm: relativeTimeWithPlural$4,
        h: 'годину',
        hh: relativeTimeWithPlural$4,
        d: 'день',
        dd: relativeTimeWithPlural$4,
        M: 'місяць',
        MM: relativeTimeWithPlural$4,
        y: 'рік',
        yy: relativeTimeWithPlural$4,
      },
      meridiemParse: /ночі|ранку|дня|вечора/,
      isPM: function (input) {
        return /^(дня|вечора)$/.test(input)
      },
      meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
          return 'ночі'
        } else if (hour < 12) {
          return 'ранку'
        } else if (hour < 17) {
          return 'дня'
        } else {
          return 'вечора'
        }
      },
      dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
      ordinal: function (number, period) {
        switch (period) {
          case 'M':
          case 'd':
          case 'DDD':
          case 'w':
          case 'W':
            return number + '-й'

          case 'D':
            return number + '-го'

          default:
            return number
        }
      },
      week: {
        dow: 1,
        doy: 7,
      },
    })
    var months$b = [
        'جنوری',
        'فروری',
        'مارچ',
        'اپریل',
        'مئی',
        'جون',
        'جولائی',
        'اگست',
        'ستمبر',
        'اکتوبر',
        'نومبر',
        'دسمبر',
      ],
      days$2 = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ']
    hooks.defineLocale('ur', {
      months: months$b,
      monthsShort: months$b,
      weekdays: days$2,
      weekdaysShort: days$2,
      weekdaysMin: days$2,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd، D MMMM YYYY HH:mm',
      },
      meridiemParse: /صبح|شام/,
      isPM: function (input) {
        return 'شام' === input
      },
      meridiem: function (hour, minute, isLower) {
        if (hour < 12) {
          return 'صبح'
        }
        return 'شام'
      },
      calendar: {
        sameDay: '[آج بوقت] LT',
        nextDay: '[کل بوقت] LT',
        nextWeek: 'dddd [بوقت] LT',
        lastDay: '[گذشتہ روز بوقت] LT',
        lastWeek: '[گذشتہ] dddd [بوقت] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: '%s بعد',
        past: '%s قبل',
        s: 'چند سیکنڈ',
        ss: '%d سیکنڈ',
        m: 'ایک منٹ',
        mm: '%d منٹ',
        h: 'ایک گھنٹہ',
        hh: '%d گھنٹے',
        d: 'ایک دن',
        dd: '%d دن',
        M: 'ایک ماہ',
        MM: '%d ماہ',
        y: 'ایک سال',
        yy: '%d سال',
      },
      preparse: function (string) {
        return string.replace(/،/g, ',')
      },
      postformat: function (string) {
        return string.replace(/,/g, '،')
      },
      week: {
        dow: 1,
        doy: 4,
      },
    })
    hooks.defineLocale('uz-latn', {
      months:
        'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
          '_'
        ),
      monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split(
        '_'
      ),
      weekdays:
        'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
          '_'
        ),
      weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
      weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'D MMMM YYYY, dddd HH:mm',
      },
      calendar: {
        sameDay: '[Bugun soat] LT [da]',
        nextDay: '[Ertaga] LT [da]',
        nextWeek: 'dddd [kuni soat] LT [da]',
        lastDay: '[Kecha soat] LT [da]',
        lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
        sameElse: 'L',
      },
      relativeTime: {
        future: 'Yaqin %s ichida',
        past: 'Bir necha %s oldin',
        s: 'soniya',
        ss: '%d soniya',
        m: 'bir daqiqa',
        mm: '%d daqiqa',
        h: 'bir soat',
        hh: '%d soat',
        d: 'bir kun',
        dd: '%d kun',
        M: 'bir oy',
        MM: '%d oy',
        y: 'bir yil',
        yy: '%d yil',
      },
      week: {
        dow: 1,
        doy: 7,
      },
    })
    hooks.defineLocale('uz', {
      months:
        'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
          '_'
        ),
      monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
      weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split(
        '_'
      ),
      weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
      weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'D MMMM YYYY, dddd HH:mm',
      },
      calendar: {
        sameDay: '[Бугун соат] LT [да]',
        nextDay: '[Эртага] LT [да]',
        nextWeek: 'dddd [куни соат] LT [да]',
        lastDay: '[Кеча соат] LT [да]',
        lastWeek: '[Утган] dddd [куни соат] LT [да]',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'Якин %s ичида',
        past: 'Бир неча %s олдин',
        s: 'фурсат',
        ss: '%d фурсат',
        m: 'бир дакика',
        mm: '%d дакика',
        h: 'бир соат',
        hh: '%d соат',
        d: 'бир кун',
        dd: '%d кун',
        M: 'бир ой',
        MM: '%d ой',
        y: 'бир йил',
        yy: '%d йил',
      },
      week: {
        dow: 1,
        doy: 7,
      },
    })
    hooks.defineLocale('vi', {
      months:
        'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
          '_'
        ),
      monthsShort:
        'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
          '_'
        ),
      monthsParseExact: true,
      weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
        '_'
      ),
      weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
      weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
      weekdaysParseExact: true,
      meridiemParse: /sa|ch/i,
      isPM: function (input) {
        return /^ch$/i.test(input)
      },
      meridiem: function (hours, minutes, isLower) {
        if (hours < 12) {
          return isLower ? 'sa' : 'SA'
        } else {
          return isLower ? 'ch' : 'CH'
        }
      },
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM [năm] YYYY',
        LLL: 'D MMMM [năm] YYYY HH:mm',
        LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
        l: 'DD/M/YYYY',
        ll: 'D MMM YYYY',
        lll: 'D MMM YYYY HH:mm',
        llll: 'ddd, D MMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[Hôm nay lúc] LT',
        nextDay: '[Ngày mai lúc] LT',
        nextWeek: 'dddd [tuần tới lúc] LT',
        lastDay: '[Hôm qua lúc] LT',
        lastWeek: 'dddd [tuần trước lúc] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: '%s tới',
        past: '%s trước',
        s: 'vài giây',
        ss: '%d giây',
        m: 'một phút',
        mm: '%d phút',
        h: 'một giờ',
        hh: '%d giờ',
        d: 'một ngày',
        dd: '%d ngày',
        w: 'một tuần',
        ww: '%d tuần',
        M: 'một tháng',
        MM: '%d tháng',
        y: 'một năm',
        yy: '%d năm',
      },
      dayOfMonthOrdinalParse: /\d{1,2}/,
      ordinal: function (number) {
        return number
      },
      week: {
        dow: 1,
        doy: 4,
      },
    })
    hooks.defineLocale('x-pseudo', {
      months:
        'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
          '_'
        ),
      monthsShort:
        'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
          '_'
        ),
      monthsParseExact: true,
      weekdays:
        'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
          '_'
        ),
      weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
      weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'HH:mm',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm',
      },
      calendar: {
        sameDay: '[T~ódá~ý át] LT',
        nextDay: '[T~ómó~rró~w át] LT',
        nextWeek: 'dddd [át] LT',
        lastDay: '[Ý~ést~érdá~ý át] LT',
        lastWeek: '[L~ást] dddd [át] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'í~ñ %s',
        past: '%s á~gó',
        s: 'á ~féw ~sécó~ñds',
        ss: '%d s~écóñ~ds',
        m: 'á ~míñ~úté',
        mm: '%d m~íñú~tés',
        h: 'á~ñ hó~úr',
        hh: '%d h~óúrs',
        d: 'á ~dáý',
        dd: '%d d~áýs',
        M: 'á ~móñ~th',
        MM: '%d m~óñt~hs',
        y: 'á ~ýéár',
        yy: '%d ý~éárs',
      },
      dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
      ordinal: function (number) {
        var b = number % 10,
          output =
            ~~((number % 100) / 10) === 1
              ? 'th'
              : b === 1
                ? 'st'
                : b === 2
                  ? 'nd'
                  : b === 3
                    ? 'rd'
                    : 'th'
        return number + output
      },
      week: {
        dow: 1,
        doy: 4,
      },
    })
    hooks.defineLocale('yo', {
      months:
        'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
          '_'
        ),
      monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
      weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
      weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
      weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
      longDateFormat: {
        LT: 'h:mm A',
        LTS: 'h:mm:ss A',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY h:mm A',
        LLLL: 'dddd, D MMMM YYYY h:mm A',
      },
      calendar: {
        sameDay: '[Ònì ni] LT',
        nextDay: '[Ọ̀la ni] LT',
        nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
        lastDay: '[Àna ni] LT',
        lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'ní %s',
        past: '%s kọjá',
        s: 'ìsẹjú aayá die',
        ss: 'aayá %d',
        m: 'ìsẹjú kan',
        mm: 'ìsẹjú %d',
        h: 'wákati kan',
        hh: 'wákati %d',
        d: 'ọjọ́ kan',
        dd: 'ọjọ́ %d',
        M: 'osù kan',
        MM: 'osù %d',
        y: 'ọdún kan',
        yy: 'ọdún %d',
      },
      dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
      ordinal: 'ọjọ́ %d',
      week: {
        dow: 1,
        doy: 4,
      },
    })
    hooks.defineLocale('zh-cn', {
      months:
        '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
          '_'
        ),
      monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
        '_'
      ),
      weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
      weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
      weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'YYYY/MM/DD',
        LL: 'YYYY年M月D日',
        LLL: 'YYYY年M月D日Ah点mm分',
        LLLL: 'YYYY年M月D日ddddAh点mm分',
        l: 'YYYY/M/D',
        ll: 'YYYY年M月D日',
        lll: 'YYYY年M月D日 HH:mm',
        llll: 'YYYY年M月D日dddd HH:mm',
      },
      meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
      meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
          hour = 0
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
          return hour
        } else if (meridiem === '下午' || meridiem === '晚上') {
          return hour + 12
        } else {
          return hour >= 11 ? hour : hour + 12
        }
      },
      meridiem: function (hour, minute, isLower) {
        var hm = hour * 100 + minute
        if (hm < 600) {
          return '凌晨'
        } else if (hm < 900) {
          return '早上'
        } else if (hm < 1130) {
          return '上午'
        } else if (hm < 1230) {
          return '中午'
        } else if (hm < 1800) {
          return '下午'
        } else {
          return '晚上'
        }
      },
      calendar: {
        sameDay: '[今天]LT',
        nextDay: '[明天]LT',
        nextWeek: function (now) {
          if (now.week() !== this.week()) {
            return '[下]dddLT'
          } else {
            return '[本]dddLT'
          }
        },
        lastDay: '[昨天]LT',
        lastWeek: function (now) {
          if (this.week() !== now.week()) {
            return '[上]dddLT'
          } else {
            return '[本]dddLT'
          }
        },
        sameElse: 'L',
      },
      dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
      ordinal: function (number, period) {
        switch (period) {
          case 'd':
          case 'D':
          case 'DDD':
            return number + '日'

          case 'M':
            return number + '月'

          case 'w':
          case 'W':
            return number + '周'

          default:
            return number
        }
      },
      relativeTime: {
        future: '%s后',
        past: '%s前',
        s: '几秒',
        ss: '%d 秒',
        m: '1 分钟',
        mm: '%d 分钟',
        h: '1 小时',
        hh: '%d 小时',
        d: '1 天',
        dd: '%d 天',
        w: '1 周',
        ww: '%d 周',
        M: '1 个月',
        MM: '%d 个月',
        y: '1 年',
        yy: '%d 年',
      },
      week: {
        dow: 1,
        doy: 4,
      },
    })
    hooks.defineLocale('zh-hk', {
      months:
        '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
          '_'
        ),
      monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
        '_'
      ),
      weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
      weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
      weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'YYYY/MM/DD',
        LL: 'YYYY年M月D日',
        LLL: 'YYYY年M月D日 HH:mm',
        LLLL: 'YYYY年M月D日dddd HH:mm',
        l: 'YYYY/M/D',
        ll: 'YYYY年M月D日',
        lll: 'YYYY年M月D日 HH:mm',
        llll: 'YYYY年M月D日dddd HH:mm',
      },
      meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
      meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
          hour = 0
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
          return hour
        } else if (meridiem === '中午') {
          return hour >= 11 ? hour : hour + 12
        } else if (meridiem === '下午' || meridiem === '晚上') {
          return hour + 12
        }
      },
      meridiem: function (hour, minute, isLower) {
        var hm = hour * 100 + minute
        if (hm < 600) {
          return '凌晨'
        } else if (hm < 900) {
          return '早上'
        } else if (hm < 1200) {
          return '上午'
        } else if (hm === 1200) {
          return '中午'
        } else if (hm < 1800) {
          return '下午'
        } else {
          return '晚上'
        }
      },
      calendar: {
        sameDay: '[今天]LT',
        nextDay: '[明天]LT',
        nextWeek: '[下]ddddLT',
        lastDay: '[昨天]LT',
        lastWeek: '[上]ddddLT',
        sameElse: 'L',
      },
      dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
      ordinal: function (number, period) {
        switch (period) {
          case 'd':
          case 'D':
          case 'DDD':
            return number + '日'

          case 'M':
            return number + '月'

          case 'w':
          case 'W':
            return number + '週'

          default:
            return number
        }
      },
      relativeTime: {
        future: '%s後',
        past: '%s前',
        s: '幾秒',
        ss: '%d 秒',
        m: '1 分鐘',
        mm: '%d 分鐘',
        h: '1 小時',
        hh: '%d 小時',
        d: '1 天',
        dd: '%d 天',
        M: '1 個月',
        MM: '%d 個月',
        y: '1 年',
        yy: '%d 年',
      },
    })
    hooks.defineLocale('zh-mo', {
      months:
        '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
          '_'
        ),
      monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
        '_'
      ),
      weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
      weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
      weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'YYYY年M月D日',
        LLL: 'YYYY年M月D日 HH:mm',
        LLLL: 'YYYY年M月D日dddd HH:mm',
        l: 'D/M/YYYY',
        ll: 'YYYY年M月D日',
        lll: 'YYYY年M月D日 HH:mm',
        llll: 'YYYY年M月D日dddd HH:mm',
      },
      meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
      meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
          hour = 0
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
          return hour
        } else if (meridiem === '中午') {
          return hour >= 11 ? hour : hour + 12
        } else if (meridiem === '下午' || meridiem === '晚上') {
          return hour + 12
        }
      },
      meridiem: function (hour, minute, isLower) {
        var hm = hour * 100 + minute
        if (hm < 600) {
          return '凌晨'
        } else if (hm < 900) {
          return '早上'
        } else if (hm < 1130) {
          return '上午'
        } else if (hm < 1230) {
          return '中午'
        } else if (hm < 1800) {
          return '下午'
        } else {
          return '晚上'
        }
      },
      calendar: {
        sameDay: '[今天] LT',
        nextDay: '[明天] LT',
        nextWeek: '[下]dddd LT',
        lastDay: '[昨天] LT',
        lastWeek: '[上]dddd LT',
        sameElse: 'L',
      },
      dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
      ordinal: function (number, period) {
        switch (period) {
          case 'd':
          case 'D':
          case 'DDD':
            return number + '日'

          case 'M':
            return number + '月'

          case 'w':
          case 'W':
            return number + '週'

          default:
            return number
        }
      },
      relativeTime: {
        future: '%s內',
        past: '%s前',
        s: '幾秒',
        ss: '%d 秒',
        m: '1 分鐘',
        mm: '%d 分鐘',
        h: '1 小時',
        hh: '%d 小時',
        d: '1 天',
        dd: '%d 天',
        M: '1 個月',
        MM: '%d 個月',
        y: '1 年',
        yy: '%d 年',
      },
    })
    hooks.defineLocale('zh-tw', {
      months:
        '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
          '_'
        ),
      monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
        '_'
      ),
      weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
      weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
      weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'YYYY/MM/DD',
        LL: 'YYYY年M月D日',
        LLL: 'YYYY年M月D日 HH:mm',
        LLLL: 'YYYY年M月D日dddd HH:mm',
        l: 'YYYY/M/D',
        ll: 'YYYY年M月D日',
        lll: 'YYYY年M月D日 HH:mm',
        llll: 'YYYY年M月D日dddd HH:mm',
      },
      meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
      meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
          hour = 0
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
          return hour
        } else if (meridiem === '中午') {
          return hour >= 11 ? hour : hour + 12
        } else if (meridiem === '下午' || meridiem === '晚上') {
          return hour + 12
        }
      },
      meridiem: function (hour, minute, isLower) {
        var hm = hour * 100 + minute
        if (hm < 600) {
          return '凌晨'
        } else if (hm < 900) {
          return '早上'
        } else if (hm < 1130) {
          return '上午'
        } else if (hm < 1230) {
          return '中午'
        } else if (hm < 1800) {
          return '下午'
        } else {
          return '晚上'
        }
      },
      calendar: {
        sameDay: '[今天] LT',
        nextDay: '[明天] LT',
        nextWeek: '[下]dddd LT',
        lastDay: '[昨天] LT',
        lastWeek: '[上]dddd LT',
        sameElse: 'L',
      },
      dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
      ordinal: function (number, period) {
        switch (period) {
          case 'd':
          case 'D':
          case 'DDD':
            return number + '日'

          case 'M':
            return number + '月'

          case 'w':
          case 'W':
            return number + '週'

          default:
            return number
        }
      },
      relativeTime: {
        future: '%s後',
        past: '%s前',
        s: '幾秒',
        ss: '%d 秒',
        m: '1 分鐘',
        mm: '%d 分鐘',
        h: '1 小時',
        hh: '%d 小時',
        d: '1 天',
        dd: '%d 天',
        M: '1 個月',
        MM: '%d 個月',
        y: '1 年',
        yy: '%d 年',
      },
    })
    hooks.locale('en')
    return hooks
  })
})(momentWithLocales)
var moment$1 = momentWithLocales.exports
var momentBusinessDays = {
  exports: {},
}
var moment = {
  exports: {},
}
;(function (module, exports) {
  ;(function (global, factory) {
    module.exports = factory()
  })(commonjsGlobal, function () {
    var hookCallback
    function hooks() {
      return hookCallback.apply(null, arguments)
    }
    function setHookCallback(callback) {
      hookCallback = callback
    }
    function isArray(input) {
      return (
        input instanceof Array ||
        Object.prototype.toString.call(input) === '[object Array]'
      )
    }
    function isObject(input) {
      return (
        input != null &&
        Object.prototype.toString.call(input) === '[object Object]'
      )
    }
    function hasOwnProp(a, b) {
      return Object.prototype.hasOwnProperty.call(a, b)
    }
    function isObjectEmpty(obj) {
      if (Object.getOwnPropertyNames) {
        return Object.getOwnPropertyNames(obj).length === 0
      } else {
        var k
        for (k in obj) {
          if (hasOwnProp(obj, k)) {
            return false
          }
        }
        return true
      }
    }
    function isUndefined(input) {
      return input === void 0
    }
    function isNumber(input) {
      return (
        typeof input === 'number' ||
        Object.prototype.toString.call(input) === '[object Number]'
      )
    }
    function isDate(input) {
      return (
        input instanceof Date ||
        Object.prototype.toString.call(input) === '[object Date]'
      )
    }
    function map(arr, fn) {
      var res = [],
        i
      for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i))
      }
      return res
    }
    function extend(a, b) {
      for (var i in b) {
        if (hasOwnProp(b, i)) {
          a[i] = b[i]
        }
      }
      if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString
      }
      if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf
      }
      return a
    }
    function createUTC(input, format, locale, strict) {
      return createLocalOrUTC(input, format, locale, strict, true).utc()
    }
    function defaultParsingFlags() {
      return {
        empty: false,
        unusedTokens: [],
        unusedInput: [],
        overflow: -2,
        charsLeftOver: 0,
        nullInput: false,
        invalidEra: null,
        invalidMonth: null,
        invalidFormat: false,
        userInvalidated: false,
        iso: false,
        parsedDateParts: [],
        era: null,
        meridiem: null,
        rfc2822: false,
        weekdayMismatch: false,
      }
    }
    function getParsingFlags(m) {
      if (m._pf == null) {
        m._pf = defaultParsingFlags()
      }
      return m._pf
    }
    var some
    if (Array.prototype.some) {
      some = Array.prototype.some
    } else {
      some = function (fun) {
        var t = Object(this),
          len = t.length >>> 0,
          i
        for (i = 0; i < len; i++) {
          if (i in t && fun.call(this, t[i], i, t)) {
            return true
          }
        }
        return false
      }
    }
    function isValid(m) {
      if (m._isValid == null) {
        var flags = getParsingFlags(m),
          parsedParts = some.call(flags.parsedDateParts, function (i) {
            return i != null
          }),
          isNowValid =
            !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidEra &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.weekdayMismatch &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts))
        if (m._strict) {
          isNowValid =
            isNowValid &&
            flags.charsLeftOver === 0 &&
            flags.unusedTokens.length === 0 &&
            flags.bigHour === undefined
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
          m._isValid = isNowValid
        } else {
          return isNowValid
        }
      }
      return m._isValid
    }
    function createInvalid(flags) {
      var m = createUTC(NaN)
      if (flags != null) {
        extend(getParsingFlags(m), flags)
      } else {
        getParsingFlags(m).userInvalidated = true
      }
      return m
    }
    var momentProperties = (hooks.momentProperties = []),
      updateInProgress = false
    function copyConfig(to, from) {
      var i, prop, val
      if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject
      }
      if (!isUndefined(from._i)) {
        to._i = from._i
      }
      if (!isUndefined(from._f)) {
        to._f = from._f
      }
      if (!isUndefined(from._l)) {
        to._l = from._l
      }
      if (!isUndefined(from._strict)) {
        to._strict = from._strict
      }
      if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm
      }
      if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC
      }
      if (!isUndefined(from._offset)) {
        to._offset = from._offset
      }
      if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from)
      }
      if (!isUndefined(from._locale)) {
        to._locale = from._locale
      }
      if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
          prop = momentProperties[i]
          val = from[prop]
          if (!isUndefined(val)) {
            to[prop] = val
          }
        }
      }
      return to
    }
    function Moment(config) {
      copyConfig(this, config)
      this._d = new Date(config._d != null ? config._d.getTime() : NaN)
      if (!this.isValid()) {
        this._d = new Date(NaN)
      }
      if (updateInProgress === false) {
        updateInProgress = true
        hooks.updateOffset(this)
        updateInProgress = false
      }
    }
    function isMoment(obj) {
      return (
        obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
      )
    }
    function warn(msg) {
      if (
        hooks.suppressDeprecationWarnings === false &&
        typeof console !== 'undefined' &&
        console.warn
      ) {
        console.warn('Deprecation warning: ' + msg)
      }
    }
    function deprecate(msg, fn) {
      var firstTime = true
      return extend(function () {
        if (hooks.deprecationHandler != null) {
          hooks.deprecationHandler(null, msg)
        }
        if (firstTime) {
          var args = [],
            arg,
            i,
            key
          for (i = 0; i < arguments.length; i++) {
            arg = ''
            if (typeof arguments[i] === 'object') {
              arg += '\n[' + i + '] '
              for (key in arguments[0]) {
                if (hasOwnProp(arguments[0], key)) {
                  arg += key + ': ' + arguments[0][key] + ', '
                }
              }
              arg = arg.slice(0, -2)
            } else {
              arg = arguments[i]
            }
            args.push(arg)
          }
          warn(
            msg +
              '\nArguments: ' +
              Array.prototype.slice.call(args).join('') +
              '\n' +
              new Error().stack
          )
          firstTime = false
        }
        return fn.apply(this, arguments)
      }, fn)
    }
    var deprecations = {}
    function deprecateSimple(name, msg) {
      if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg)
      }
      if (!deprecations[name]) {
        warn(msg)
        deprecations[name] = true
      }
    }
    hooks.suppressDeprecationWarnings = false
    hooks.deprecationHandler = null
    function isFunction(input) {
      return (
        (typeof Function !== 'undefined' && input instanceof Function) ||
        Object.prototype.toString.call(input) === '[object Function]'
      )
    }
    function set(config) {
      var prop, i
      for (i in config) {
        if (hasOwnProp(config, i)) {
          prop = config[i]
          if (isFunction(prop)) {
            this[i] = prop
          } else {
            this['_' + i] = prop
          }
        }
      }
      this._config = config
      this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
          '|' +
          /\d{1,2}/.source
      )
    }
    function mergeConfigs(parentConfig, childConfig) {
      var res = extend({}, parentConfig),
        prop
      for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
          if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
            res[prop] = {}
            extend(res[prop], parentConfig[prop])
            extend(res[prop], childConfig[prop])
          } else if (childConfig[prop] != null) {
            res[prop] = childConfig[prop]
          } else {
            delete res[prop]
          }
        }
      }
      for (prop in parentConfig) {
        if (
          hasOwnProp(parentConfig, prop) &&
          !hasOwnProp(childConfig, prop) &&
          isObject(parentConfig[prop])
        ) {
          res[prop] = extend({}, res[prop])
        }
      }
      return res
    }
    function Locale(config) {
      if (config != null) {
        this.set(config)
      }
    }
    var keys
    if (Object.keys) {
      keys = Object.keys
    } else {
      keys = function (obj) {
        var i,
          res = []
        for (i in obj) {
          if (hasOwnProp(obj, i)) {
            res.push(i)
          }
        }
        return res
      }
    }
    var defaultCalendar = {
      sameDay: '[Today at] LT',
      nextDay: '[Tomorrow at] LT',
      nextWeek: 'dddd [at] LT',
      lastDay: '[Yesterday at] LT',
      lastWeek: '[Last] dddd [at] LT',
      sameElse: 'L',
    }
    function calendar(key, mom, now) {
      var output = this._calendar[key] || this._calendar['sameElse']
      return isFunction(output) ? output.call(mom, now) : output
    }
    function zeroFill(number, targetLength, forceSign) {
      var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0
      return (
        (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
        absNumber
      )
    }
    var formattingTokens =
        /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
      localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
      formatFunctions = {},
      formatTokenFunctions = {}
    function addFormatToken(token, padded, ordinal, callback) {
      var func = callback
      if (typeof callback === 'string') {
        func = function () {
          return this[callback]()
        }
      }
      if (token) {
        formatTokenFunctions[token] = func
      }
      if (padded) {
        formatTokenFunctions[padded[0]] = function () {
          return zeroFill(func.apply(this, arguments), padded[1], padded[2])
        }
      }
      if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
          return this.localeData().ordinal(func.apply(this, arguments), token)
        }
      }
    }
    function removeFormattingTokens(input) {
      if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '')
      }
      return input.replace(/\\/g, '')
    }
    function makeFormatFunction(format) {
      var array = format.match(formattingTokens),
        i,
        length
      for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
          array[i] = formatTokenFunctions[array[i]]
        } else {
          array[i] = removeFormattingTokens(array[i])
        }
      }
      return function (mom) {
        var output = '',
          i
        for (i = 0; i < length; i++) {
          output += isFunction(array[i]) ? array[i].call(mom, format) : array[i]
        }
        return output
      }
    }
    function formatMoment(m, format) {
      if (!m.isValid()) {
        return m.localeData().invalidDate()
      }
      format = expandFormat(format, m.localeData())
      formatFunctions[format] =
        formatFunctions[format] || makeFormatFunction(format)
      return formatFunctions[format](m)
    }
    function expandFormat(format, locale) {
      var i = 5
      function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input
      }
      localFormattingTokens.lastIndex = 0
      while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(
          localFormattingTokens,
          replaceLongDateFormatTokens
        )
        localFormattingTokens.lastIndex = 0
        i -= 1
      }
      return format
    }
    var defaultLongDateFormat = {
      LTS: 'h:mm:ss A',
      LT: 'h:mm A',
      L: 'MM/DD/YYYY',
      LL: 'MMMM D, YYYY',
      LLL: 'MMMM D, YYYY h:mm A',
      LLLL: 'dddd, MMMM D, YYYY h:mm A',
    }
    function longDateFormat(key) {
      var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()]
      if (format || !formatUpper) {
        return format
      }
      this._longDateFormat[key] = formatUpper
        .match(formattingTokens)
        .map(function (tok) {
          if (
            tok === 'MMMM' ||
            tok === 'MM' ||
            tok === 'DD' ||
            tok === 'dddd'
          ) {
            return tok.slice(1)
          }
          return tok
        })
        .join('')
      return this._longDateFormat[key]
    }
    var defaultInvalidDate = 'Invalid date'
    function invalidDate() {
      return this._invalidDate
    }
    var defaultOrdinal = '%d',
      defaultDayOfMonthOrdinalParse = /\d{1,2}/
    function ordinal(number) {
      return this._ordinal.replace('%d', number)
    }
    var defaultRelativeTime = {
      future: 'in %s',
      past: '%s ago',
      s: 'a few seconds',
      ss: '%d seconds',
      m: 'a minute',
      mm: '%d minutes',
      h: 'an hour',
      hh: '%d hours',
      d: 'a day',
      dd: '%d days',
      w: 'a week',
      ww: '%d weeks',
      M: 'a month',
      MM: '%d months',
      y: 'a year',
      yy: '%d years',
    }
    function relativeTime(number, withoutSuffix, string, isFuture) {
      var output = this._relativeTime[string]
      return isFunction(output)
        ? output(number, withoutSuffix, string, isFuture)
        : output.replace(/%d/i, number)
    }
    function pastFuture(diff, output) {
      var format = this._relativeTime[diff > 0 ? 'future' : 'past']
      return isFunction(format) ? format(output) : format.replace(/%s/i, output)
    }
    var aliases = {}
    function addUnitAlias(unit, shorthand) {
      var lowerCase = unit.toLowerCase()
      aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit
    }
    function normalizeUnits(units) {
      return typeof units === 'string'
        ? aliases[units] || aliases[units.toLowerCase()]
        : undefined
    }
    function normalizeObjectUnits(inputObject) {
      var normalizedInput = {},
        normalizedProp,
        prop
      for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
          normalizedProp = normalizeUnits(prop)
          if (normalizedProp) {
            normalizedInput[normalizedProp] = inputObject[prop]
          }
        }
      }
      return normalizedInput
    }
    var priorities = {}
    function addUnitPriority(unit, priority) {
      priorities[unit] = priority
    }
    function getPrioritizedUnits(unitsObj) {
      var units = [],
        u
      for (u in unitsObj) {
        if (hasOwnProp(unitsObj, u)) {
          units.push({
            unit: u,
            priority: priorities[u],
          })
        }
      }
      units.sort(function (a, b) {
        return a.priority - b.priority
      })
      return units
    }
    function isLeapYear(year) {
      return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0
    }
    function absFloor(number) {
      if (number < 0) {
        return Math.ceil(number) || 0
      } else {
        return Math.floor(number)
      }
    }
    function toInt(argumentForCoercion) {
      var coercedNumber = +argumentForCoercion,
        value = 0
      if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber)
      }
      return value
    }
    function makeGetSet(unit, keepTime) {
      return function (value) {
        if (value != null) {
          set$1(this, unit, value)
          hooks.updateOffset(this, keepTime)
          return this
        } else {
          return get(this, unit)
        }
      }
    }
    function get(mom, unit) {
      return mom.isValid()
        ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
        : NaN
    }
    function set$1(mom, unit, value) {
      if (mom.isValid() && !isNaN(value)) {
        if (
          unit === 'FullYear' &&
          isLeapYear(mom.year()) &&
          mom.month() === 1 &&
          mom.date() === 29
        ) {
          value = toInt(value)
          mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
            value,
            mom.month(),
            daysInMonth(value, mom.month())
          )
        } else {
          mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value)
        }
      }
    }
    function stringGet(units) {
      units = normalizeUnits(units)
      if (isFunction(this[units])) {
        return this[units]()
      }
      return this
    }
    function stringSet(units, value) {
      if (typeof units === 'object') {
        units = normalizeObjectUnits(units)
        var prioritized = getPrioritizedUnits(units),
          i
        for (i = 0; i < prioritized.length; i++) {
          this[prioritized[i].unit](units[prioritized[i].unit])
        }
      } else {
        units = normalizeUnits(units)
        if (isFunction(this[units])) {
          return this[units](value)
        }
      }
      return this
    }
    var match1 = /\d/,
      match2 = /\d\d/,
      match3 = /\d{3}/,
      match4 = /\d{4}/,
      match6 = /[+-]?\d{6}/,
      match1to2 = /\d\d?/,
      match3to4 = /\d\d\d\d?/,
      match5to6 = /\d\d\d\d\d\d?/,
      match1to3 = /\d{1,3}/,
      match1to4 = /\d{1,4}/,
      match1to6 = /[+-]?\d{1,6}/,
      matchUnsigned = /\d+/,
      matchSigned = /[+-]?\d+/,
      matchOffset = /Z|[+-]\d\d:?\d\d/gi,
      matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi,
      matchTimestamp = /[+-]?\d+(\.\d{1,3})?/,
      matchWord =
        /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
      regexes
    regexes = {}
    function addRegexToken(token, regex, strictRegex) {
      regexes[token] = isFunction(regex)
        ? regex
        : function (isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex
          }
    }
    function getParseRegexForToken(token, config) {
      if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token))
      }
      return regexes[token](config._strict, config._locale)
    }
    function unescapeFormat(s) {
      return regexEscape(
        s
          .replace('\\', '')
          .replace(
            /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
            function (matched, p1, p2, p3, p4) {
              return p1 || p2 || p3 || p4
            }
          )
      )
    }
    function regexEscape(s) {
      return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
    }
    var tokens = {}
    function addParseToken(token, callback) {
      var i,
        func = callback
      if (typeof token === 'string') {
        token = [token]
      }
      if (isNumber(callback)) {
        func = function (input, array) {
          array[callback] = toInt(input)
        }
      }
      for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func
      }
    }
    function addWeekParseToken(token, callback) {
      addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {}
        callback(input, config._w, config, token)
      })
    }
    function addTimeToArrayFromToken(token, input, config) {
      if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token)
      }
    }
    var YEAR = 0,
      MONTH = 1,
      DATE = 2,
      HOUR = 3,
      MINUTE = 4,
      SECOND = 5,
      MILLISECOND = 6,
      WEEK = 7,
      WEEKDAY = 8
    function mod(n, x) {
      return ((n % x) + x) % x
    }
    var indexOf
    if (Array.prototype.indexOf) {
      indexOf = Array.prototype.indexOf
    } else {
      indexOf = function (o) {
        var i
        for (i = 0; i < this.length; ++i) {
          if (this[i] === o) {
            return i
          }
        }
        return -1
      }
    }
    function daysInMonth(year, month) {
      if (isNaN(year) || isNaN(month)) {
        return NaN
      }
      var modMonth = mod(month, 12)
      year += (month - modMonth) / 12
      return modMonth === 1
        ? isLeapYear(year)
          ? 29
          : 28
        : 31 - ((modMonth % 7) % 2)
    }
    addFormatToken('M', ['MM', 2], 'Mo', function () {
      return this.month() + 1
    })
    addFormatToken('MMM', 0, 0, function (format) {
      return this.localeData().monthsShort(this, format)
    })
    addFormatToken('MMMM', 0, 0, function (format) {
      return this.localeData().months(this, format)
    })
    addUnitAlias('month', 'M')
    addUnitPriority('month', 8)
    addRegexToken('M', match1to2)
    addRegexToken('MM', match1to2, match2)
    addRegexToken('MMM', function (isStrict, locale) {
      return locale.monthsShortRegex(isStrict)
    })
    addRegexToken('MMMM', function (isStrict, locale) {
      return locale.monthsRegex(isStrict)
    })
    addParseToken(['M', 'MM'], function (input, array) {
      array[MONTH] = toInt(input) - 1
    })
    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
      var month = config._locale.monthsParse(input, token, config._strict)
      if (month != null) {
        array[MONTH] = month
      } else {
        getParsingFlags(config).invalidMonth = input
      }
    })
    var defaultLocaleMonths =
        'January_February_March_April_May_June_July_August_September_October_November_December'.split(
          '_'
        ),
      defaultLocaleMonthsShort =
        'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
      MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
      defaultMonthsShortRegex = matchWord,
      defaultMonthsRegex = matchWord
    function localeMonths(m, format) {
      if (!m) {
        return isArray(this._months) ? this._months : this._months['standalone']
      }
      return isArray(this._months)
        ? this._months[m.month()]
        : this._months[
            (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
              ? 'format'
              : 'standalone'
          ][m.month()]
    }
    function localeMonthsShort(m, format) {
      if (!m) {
        return isArray(this._monthsShort)
          ? this._monthsShort
          : this._monthsShort['standalone']
      }
      return isArray(this._monthsShort)
        ? this._monthsShort[m.month()]
        : this._monthsShort[
            MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
          ][m.month()]
    }
    function handleStrictParse(monthName, format, strict) {
      var i,
        ii,
        mom,
        llc = monthName.toLocaleLowerCase()
      if (!this._monthsParse) {
        this._monthsParse = []
        this._longMonthsParse = []
        this._shortMonthsParse = []
        for (i = 0; i < 12; ++i) {
          mom = createUTC([2e3, i])
          this._shortMonthsParse[i] = this.monthsShort(
            mom,
            ''
          ).toLocaleLowerCase()
          this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase()
        }
      }
      if (strict) {
        if (format === 'MMM') {
          ii = indexOf.call(this._shortMonthsParse, llc)
          return ii !== -1 ? ii : null
        } else {
          ii = indexOf.call(this._longMonthsParse, llc)
          return ii !== -1 ? ii : null
        }
      } else {
        if (format === 'MMM') {
          ii = indexOf.call(this._shortMonthsParse, llc)
          if (ii !== -1) {
            return ii
          }
          ii = indexOf.call(this._longMonthsParse, llc)
          return ii !== -1 ? ii : null
        } else {
          ii = indexOf.call(this._longMonthsParse, llc)
          if (ii !== -1) {
            return ii
          }
          ii = indexOf.call(this._shortMonthsParse, llc)
          return ii !== -1 ? ii : null
        }
      }
    }
    function localeMonthsParse(monthName, format, strict) {
      var i, mom, regex
      if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict)
      }
      if (!this._monthsParse) {
        this._monthsParse = []
        this._longMonthsParse = []
        this._shortMonthsParse = []
      }
      for (i = 0; i < 12; i++) {
        mom = createUTC([2e3, i])
        if (strict && !this._longMonthsParse[i]) {
          this._longMonthsParse[i] = new RegExp(
            '^' + this.months(mom, '').replace('.', '') + '$',
            'i'
          )
          this._shortMonthsParse[i] = new RegExp(
            '^' + this.monthsShort(mom, '').replace('.', '') + '$',
            'i'
          )
        }
        if (!strict && !this._monthsParse[i]) {
          regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '')
          this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i')
        }
        if (
          strict &&
          format === 'MMMM' &&
          this._longMonthsParse[i].test(monthName)
        ) {
          return i
        } else if (
          strict &&
          format === 'MMM' &&
          this._shortMonthsParse[i].test(monthName)
        ) {
          return i
        } else if (!strict && this._monthsParse[i].test(monthName)) {
          return i
        }
      }
    }
    function setMonth(mom, value) {
      var dayOfMonth
      if (!mom.isValid()) {
        return mom
      }
      if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
          value = toInt(value)
        } else {
          value = mom.localeData().monthsParse(value)
          if (!isNumber(value)) {
            return mom
          }
        }
      }
      dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value))
      mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth)
      return mom
    }
    function getSetMonth(value) {
      if (value != null) {
        setMonth(this, value)
        hooks.updateOffset(this, true)
        return this
      } else {
        return get(this, 'Month')
      }
    }
    function getDaysInMonth() {
      return daysInMonth(this.year(), this.month())
    }
    function monthsShortRegex(isStrict) {
      if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
          computeMonthsParse.call(this)
        }
        if (isStrict) {
          return this._monthsShortStrictRegex
        } else {
          return this._monthsShortRegex
        }
      } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
          this._monthsShortRegex = defaultMonthsShortRegex
        }
        return this._monthsShortStrictRegex && isStrict
          ? this._monthsShortStrictRegex
          : this._monthsShortRegex
      }
    }
    function monthsRegex(isStrict) {
      if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
          computeMonthsParse.call(this)
        }
        if (isStrict) {
          return this._monthsStrictRegex
        } else {
          return this._monthsRegex
        }
      } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
          this._monthsRegex = defaultMonthsRegex
        }
        return this._monthsStrictRegex && isStrict
          ? this._monthsStrictRegex
          : this._monthsRegex
      }
    }
    function computeMonthsParse() {
      function cmpLenRev(a, b) {
        return b.length - a.length
      }
      var shortPieces = [],
        longPieces = [],
        mixedPieces = [],
        i,
        mom
      for (i = 0; i < 12; i++) {
        mom = createUTC([2e3, i])
        shortPieces.push(this.monthsShort(mom, ''))
        longPieces.push(this.months(mom, ''))
        mixedPieces.push(this.months(mom, ''))
        mixedPieces.push(this.monthsShort(mom, ''))
      }
      shortPieces.sort(cmpLenRev)
      longPieces.sort(cmpLenRev)
      mixedPieces.sort(cmpLenRev)
      for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i])
        longPieces[i] = regexEscape(longPieces[i])
      }
      for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i])
      }
      this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i')
      this._monthsShortRegex = this._monthsRegex
      this._monthsStrictRegex = new RegExp(
        '^(' + longPieces.join('|') + ')',
        'i'
      )
      this._monthsShortStrictRegex = new RegExp(
        '^(' + shortPieces.join('|') + ')',
        'i'
      )
    }
    addFormatToken('Y', 0, 0, function () {
      var y = this.year()
      return y <= 9999 ? zeroFill(y, 4) : '+' + y
    })
    addFormatToken(0, ['YY', 2], 0, function () {
      return this.year() % 100
    })
    addFormatToken(0, ['YYYY', 4], 0, 'year')
    addFormatToken(0, ['YYYYY', 5], 0, 'year')
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year')
    addUnitAlias('year', 'y')
    addUnitPriority('year', 1)
    addRegexToken('Y', matchSigned)
    addRegexToken('YY', match1to2, match2)
    addRegexToken('YYYY', match1to4, match4)
    addRegexToken('YYYYY', match1to6, match6)
    addRegexToken('YYYYYY', match1to6, match6)
    addParseToken(['YYYYY', 'YYYYYY'], YEAR)
    addParseToken('YYYY', function (input, array) {
      array[YEAR] =
        input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input)
    })
    addParseToken('YY', function (input, array) {
      array[YEAR] = hooks.parseTwoDigitYear(input)
    })
    addParseToken('Y', function (input, array) {
      array[YEAR] = parseInt(input, 10)
    })
    function daysInYear(year) {
      return isLeapYear(year) ? 366 : 365
    }
    hooks.parseTwoDigitYear = function (input) {
      return toInt(input) + (toInt(input) > 68 ? 1900 : 2e3)
    }
    var getSetYear = makeGetSet('FullYear', true)
    function getIsLeapYear() {
      return isLeapYear(this.year())
    }
    function createDate(y, m, d, h, M, s, ms) {
      var date
      if (y < 100 && y >= 0) {
        date = new Date(y + 400, m, d, h, M, s, ms)
        if (isFinite(date.getFullYear())) {
          date.setFullYear(y)
        }
      } else {
        date = new Date(y, m, d, h, M, s, ms)
      }
      return date
    }
    function createUTCDate(y) {
      var date, args
      if (y < 100 && y >= 0) {
        args = Array.prototype.slice.call(arguments)
        args[0] = y + 400
        date = new Date(Date.UTC.apply(null, args))
        if (isFinite(date.getUTCFullYear())) {
          date.setUTCFullYear(y)
        }
      } else {
        date = new Date(Date.UTC.apply(null, arguments))
      }
      return date
    }
    function firstWeekOffset(year, dow, doy) {
      var fwd = 7 + dow - doy,
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7
      return -fwdlw + fwd - 1
    }
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
      var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear,
        resDayOfYear
      if (dayOfYear <= 0) {
        resYear = year - 1
        resDayOfYear = daysInYear(resYear) + dayOfYear
      } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1
        resDayOfYear = dayOfYear - daysInYear(year)
      } else {
        resYear = year
        resDayOfYear = dayOfYear
      }
      return {
        year: resYear,
        dayOfYear: resDayOfYear,
      }
    }
    function weekOfYear(mom, dow, doy) {
      var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek,
        resYear
      if (week < 1) {
        resYear = mom.year() - 1
        resWeek = week + weeksInYear(resYear, dow, doy)
      } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy)
        resYear = mom.year() + 1
      } else {
        resYear = mom.year()
        resWeek = week
      }
      return {
        week: resWeek,
        year: resYear,
      }
    }
    function weeksInYear(year, dow, doy) {
      var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy)
      return (daysInYear(year) - weekOffset + weekOffsetNext) / 7
    }
    addFormatToken('w', ['ww', 2], 'wo', 'week')
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek')
    addUnitAlias('week', 'w')
    addUnitAlias('isoWeek', 'W')
    addUnitPriority('week', 5)
    addUnitPriority('isoWeek', 5)
    addRegexToken('w', match1to2)
    addRegexToken('ww', match1to2, match2)
    addRegexToken('W', match1to2)
    addRegexToken('WW', match1to2, match2)
    addWeekParseToken(
      ['w', 'ww', 'W', 'WW'],
      function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input)
      }
    )
    function localeWeek(mom) {
      return weekOfYear(mom, this._week.dow, this._week.doy).week
    }
    var defaultLocaleWeek = {
      dow: 0,
      doy: 6,
    }
    function localeFirstDayOfWeek() {
      return this._week.dow
    }
    function localeFirstDayOfYear() {
      return this._week.doy
    }
    function getSetWeek(input) {
      var week = this.localeData().week(this)
      return input == null ? week : this.add((input - week) * 7, 'd')
    }
    function getSetISOWeek(input) {
      var week = weekOfYear(this, 1, 4).week
      return input == null ? week : this.add((input - week) * 7, 'd')
    }
    addFormatToken('d', 0, 'do', 'day')
    addFormatToken('dd', 0, 0, function (format) {
      return this.localeData().weekdaysMin(this, format)
    })
    addFormatToken('ddd', 0, 0, function (format) {
      return this.localeData().weekdaysShort(this, format)
    })
    addFormatToken('dddd', 0, 0, function (format) {
      return this.localeData().weekdays(this, format)
    })
    addFormatToken('e', 0, 0, 'weekday')
    addFormatToken('E', 0, 0, 'isoWeekday')
    addUnitAlias('day', 'd')
    addUnitAlias('weekday', 'e')
    addUnitAlias('isoWeekday', 'E')
    addUnitPriority('day', 11)
    addUnitPriority('weekday', 11)
    addUnitPriority('isoWeekday', 11)
    addRegexToken('d', match1to2)
    addRegexToken('e', match1to2)
    addRegexToken('E', match1to2)
    addRegexToken('dd', function (isStrict, locale) {
      return locale.weekdaysMinRegex(isStrict)
    })
    addRegexToken('ddd', function (isStrict, locale) {
      return locale.weekdaysShortRegex(isStrict)
    })
    addRegexToken('dddd', function (isStrict, locale) {
      return locale.weekdaysRegex(isStrict)
    })
    addWeekParseToken(
      ['dd', 'ddd', 'dddd'],
      function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict)
        if (weekday != null) {
          week.d = weekday
        } else {
          getParsingFlags(config).invalidWeekday = input
        }
      }
    )
    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
      week[token] = toInt(input)
    })
    function parseWeekday(input, locale) {
      if (typeof input !== 'string') {
        return input
      }
      if (!isNaN(input)) {
        return parseInt(input, 10)
      }
      input = locale.weekdaysParse(input)
      if (typeof input === 'number') {
        return input
      }
      return null
    }
    function parseIsoWeekday(input, locale) {
      if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7
      }
      return isNaN(input) ? null : input
    }
    function shiftWeekdays(ws, n) {
      return ws.slice(n, 7).concat(ws.slice(0, n))
    }
    var defaultLocaleWeekdays =
        'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
      defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
      defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
      defaultWeekdaysRegex = matchWord,
      defaultWeekdaysShortRegex = matchWord,
      defaultWeekdaysMinRegex = matchWord
    function localeWeekdays(m, format) {
      var weekdays = isArray(this._weekdays)
        ? this._weekdays
        : this._weekdays[
            m && m !== true && this._weekdays.isFormat.test(format)
              ? 'format'
              : 'standalone'
          ]
      return m === true
        ? shiftWeekdays(weekdays, this._week.dow)
        : m
          ? weekdays[m.day()]
          : weekdays
    }
    function localeWeekdaysShort(m) {
      return m === true
        ? shiftWeekdays(this._weekdaysShort, this._week.dow)
        : m
          ? this._weekdaysShort[m.day()]
          : this._weekdaysShort
    }
    function localeWeekdaysMin(m) {
      return m === true
        ? shiftWeekdays(this._weekdaysMin, this._week.dow)
        : m
          ? this._weekdaysMin[m.day()]
          : this._weekdaysMin
    }
    function handleStrictParse$1(weekdayName, format, strict) {
      var i,
        ii,
        mom,
        llc = weekdayName.toLocaleLowerCase()
      if (!this._weekdaysParse) {
        this._weekdaysParse = []
        this._shortWeekdaysParse = []
        this._minWeekdaysParse = []
        for (i = 0; i < 7; ++i) {
          mom = createUTC([2e3, 1]).day(i)
          this._minWeekdaysParse[i] = this.weekdaysMin(
            mom,
            ''
          ).toLocaleLowerCase()
          this._shortWeekdaysParse[i] = this.weekdaysShort(
            mom,
            ''
          ).toLocaleLowerCase()
          this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase()
        }
      }
      if (strict) {
        if (format === 'dddd') {
          ii = indexOf.call(this._weekdaysParse, llc)
          return ii !== -1 ? ii : null
        } else if (format === 'ddd') {
          ii = indexOf.call(this._shortWeekdaysParse, llc)
          return ii !== -1 ? ii : null
        } else {
          ii = indexOf.call(this._minWeekdaysParse, llc)
          return ii !== -1 ? ii : null
        }
      } else {
        if (format === 'dddd') {
          ii = indexOf.call(this._weekdaysParse, llc)
          if (ii !== -1) {
            return ii
          }
          ii = indexOf.call(this._shortWeekdaysParse, llc)
          if (ii !== -1) {
            return ii
          }
          ii = indexOf.call(this._minWeekdaysParse, llc)
          return ii !== -1 ? ii : null
        } else if (format === 'ddd') {
          ii = indexOf.call(this._shortWeekdaysParse, llc)
          if (ii !== -1) {
            return ii
          }
          ii = indexOf.call(this._weekdaysParse, llc)
          if (ii !== -1) {
            return ii
          }
          ii = indexOf.call(this._minWeekdaysParse, llc)
          return ii !== -1 ? ii : null
        } else {
          ii = indexOf.call(this._minWeekdaysParse, llc)
          if (ii !== -1) {
            return ii
          }
          ii = indexOf.call(this._weekdaysParse, llc)
          if (ii !== -1) {
            return ii
          }
          ii = indexOf.call(this._shortWeekdaysParse, llc)
          return ii !== -1 ? ii : null
        }
      }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
      var i, mom, regex
      if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict)
      }
      if (!this._weekdaysParse) {
        this._weekdaysParse = []
        this._minWeekdaysParse = []
        this._shortWeekdaysParse = []
        this._fullWeekdaysParse = []
      }
      for (i = 0; i < 7; i++) {
        mom = createUTC([2e3, 1]).day(i)
        if (strict && !this._fullWeekdaysParse[i]) {
          this._fullWeekdaysParse[i] = new RegExp(
            '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
            'i'
          )
          this._shortWeekdaysParse[i] = new RegExp(
            '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
            'i'
          )
          this._minWeekdaysParse[i] = new RegExp(
            '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
            'i'
          )
        }
        if (!this._weekdaysParse[i]) {
          regex =
            '^' +
            this.weekdays(mom, '') +
            '|^' +
            this.weekdaysShort(mom, '') +
            '|^' +
            this.weekdaysMin(mom, '')
          this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i')
        }
        if (
          strict &&
          format === 'dddd' &&
          this._fullWeekdaysParse[i].test(weekdayName)
        ) {
          return i
        } else if (
          strict &&
          format === 'ddd' &&
          this._shortWeekdaysParse[i].test(weekdayName)
        ) {
          return i
        } else if (
          strict &&
          format === 'dd' &&
          this._minWeekdaysParse[i].test(weekdayName)
        ) {
          return i
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
          return i
        }
      }
    }
    function getSetDayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN
      }
      var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay()
      if (input != null) {
        input = parseWeekday(input, this.localeData())
        return this.add(input - day, 'd')
      } else {
        return day
      }
    }
    function getSetLocaleDayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN
      }
      var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7
      return input == null ? weekday : this.add(input - weekday, 'd')
    }
    function getSetISODayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN
      }
      if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData())
        return this.day(this.day() % 7 ? weekday : weekday - 7)
      } else {
        return this.day() || 7
      }
    }
    function weekdaysRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this)
        }
        if (isStrict) {
          return this._weekdaysStrictRegex
        } else {
          return this._weekdaysRegex
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          this._weekdaysRegex = defaultWeekdaysRegex
        }
        return this._weekdaysStrictRegex && isStrict
          ? this._weekdaysStrictRegex
          : this._weekdaysRegex
      }
    }
    function weekdaysShortRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this)
        }
        if (isStrict) {
          return this._weekdaysShortStrictRegex
        } else {
          return this._weekdaysShortRegex
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
          this._weekdaysShortRegex = defaultWeekdaysShortRegex
        }
        return this._weekdaysShortStrictRegex && isStrict
          ? this._weekdaysShortStrictRegex
          : this._weekdaysShortRegex
      }
    }
    function weekdaysMinRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this)
        }
        if (isStrict) {
          return this._weekdaysMinStrictRegex
        } else {
          return this._weekdaysMinRegex
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
          this._weekdaysMinRegex = defaultWeekdaysMinRegex
        }
        return this._weekdaysMinStrictRegex && isStrict
          ? this._weekdaysMinStrictRegex
          : this._weekdaysMinRegex
      }
    }
    function computeWeekdaysParse() {
      function cmpLenRev(a, b) {
        return b.length - a.length
      }
      var minPieces = [],
        shortPieces = [],
        longPieces = [],
        mixedPieces = [],
        i,
        mom,
        minp,
        shortp,
        longp
      for (i = 0; i < 7; i++) {
        mom = createUTC([2e3, 1]).day(i)
        minp = regexEscape(this.weekdaysMin(mom, ''))
        shortp = regexEscape(this.weekdaysShort(mom, ''))
        longp = regexEscape(this.weekdays(mom, ''))
        minPieces.push(minp)
        shortPieces.push(shortp)
        longPieces.push(longp)
        mixedPieces.push(minp)
        mixedPieces.push(shortp)
        mixedPieces.push(longp)
      }
      minPieces.sort(cmpLenRev)
      shortPieces.sort(cmpLenRev)
      longPieces.sort(cmpLenRev)
      mixedPieces.sort(cmpLenRev)
      this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i')
      this._weekdaysShortRegex = this._weekdaysRegex
      this._weekdaysMinRegex = this._weekdaysRegex
      this._weekdaysStrictRegex = new RegExp(
        '^(' + longPieces.join('|') + ')',
        'i'
      )
      this._weekdaysShortStrictRegex = new RegExp(
        '^(' + shortPieces.join('|') + ')',
        'i'
      )
      this._weekdaysMinStrictRegex = new RegExp(
        '^(' + minPieces.join('|') + ')',
        'i'
      )
    }
    function hFormat() {
      return this.hours() % 12 || 12
    }
    function kFormat() {
      return this.hours() || 24
    }
    addFormatToken('H', ['HH', 2], 0, 'hour')
    addFormatToken('h', ['hh', 2], 0, hFormat)
    addFormatToken('k', ['kk', 2], 0, kFormat)
    addFormatToken('hmm', 0, 0, function () {
      return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2)
    })
    addFormatToken('hmmss', 0, 0, function () {
      return (
        '' +
        hFormat.apply(this) +
        zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2)
      )
    })
    addFormatToken('Hmm', 0, 0, function () {
      return '' + this.hours() + zeroFill(this.minutes(), 2)
    })
    addFormatToken('Hmmss', 0, 0, function () {
      return (
        '' +
        this.hours() +
        zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2)
      )
    })
    function meridiem(token, lowercase) {
      addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(
          this.hours(),
          this.minutes(),
          lowercase
        )
      })
    }
    meridiem('a', true)
    meridiem('A', false)
    addUnitAlias('hour', 'h')
    addUnitPriority('hour', 13)
    function matchMeridiem(isStrict, locale) {
      return locale._meridiemParse
    }
    addRegexToken('a', matchMeridiem)
    addRegexToken('A', matchMeridiem)
    addRegexToken('H', match1to2)
    addRegexToken('h', match1to2)
    addRegexToken('k', match1to2)
    addRegexToken('HH', match1to2, match2)
    addRegexToken('hh', match1to2, match2)
    addRegexToken('kk', match1to2, match2)
    addRegexToken('hmm', match3to4)
    addRegexToken('hmmss', match5to6)
    addRegexToken('Hmm', match3to4)
    addRegexToken('Hmmss', match5to6)
    addParseToken(['H', 'HH'], HOUR)
    addParseToken(['k', 'kk'], function (input, array, config) {
      var kInput = toInt(input)
      array[HOUR] = kInput === 24 ? 0 : kInput
    })
    addParseToken(['a', 'A'], function (input, array, config) {
      config._isPm = config._locale.isPM(input)
      config._meridiem = input
    })
    addParseToken(['h', 'hh'], function (input, array, config) {
      array[HOUR] = toInt(input)
      getParsingFlags(config).bigHour = true
    })
    addParseToken('hmm', function (input, array, config) {
      var pos = input.length - 2
      array[HOUR] = toInt(input.substr(0, pos))
      array[MINUTE] = toInt(input.substr(pos))
      getParsingFlags(config).bigHour = true
    })
    addParseToken('hmmss', function (input, array, config) {
      var pos1 = input.length - 4,
        pos2 = input.length - 2
      array[HOUR] = toInt(input.substr(0, pos1))
      array[MINUTE] = toInt(input.substr(pos1, 2))
      array[SECOND] = toInt(input.substr(pos2))
      getParsingFlags(config).bigHour = true
    })
    addParseToken('Hmm', function (input, array, config) {
      var pos = input.length - 2
      array[HOUR] = toInt(input.substr(0, pos))
      array[MINUTE] = toInt(input.substr(pos))
    })
    addParseToken('Hmmss', function (input, array, config) {
      var pos1 = input.length - 4,
        pos2 = input.length - 2
      array[HOUR] = toInt(input.substr(0, pos1))
      array[MINUTE] = toInt(input.substr(pos1, 2))
      array[SECOND] = toInt(input.substr(pos2))
    })
    function localeIsPM(input) {
      return (input + '').toLowerCase().charAt(0) === 'p'
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
      getSetHour = makeGetSet('Hours', true)
    function localeMeridiem(hours, minutes, isLower) {
      if (hours > 11) {
        return isLower ? 'pm' : 'PM'
      } else {
        return isLower ? 'am' : 'AM'
      }
    }
    var baseConfig = {
      calendar: defaultCalendar,
      longDateFormat: defaultLongDateFormat,
      invalidDate: defaultInvalidDate,
      ordinal: defaultOrdinal,
      dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
      relativeTime: defaultRelativeTime,
      months: defaultLocaleMonths,
      monthsShort: defaultLocaleMonthsShort,
      week: defaultLocaleWeek,
      weekdays: defaultLocaleWeekdays,
      weekdaysMin: defaultLocaleWeekdaysMin,
      weekdaysShort: defaultLocaleWeekdaysShort,
      meridiemParse: defaultLocaleMeridiemParse,
    }
    var locales = {},
      localeFamilies = {},
      globalLocale
    function commonPrefix(arr1, arr2) {
      var i,
        minl = Math.min(arr1.length, arr2.length)
      for (i = 0; i < minl; i += 1) {
        if (arr1[i] !== arr2[i]) {
          return i
        }
      }
      return minl
    }
    function normalizeLocale(key) {
      return key ? key.toLowerCase().replace('_', '-') : key
    }
    function chooseLocale(names) {
      var i = 0,
        j,
        next,
        locale,
        split
      while (i < names.length) {
        split = normalizeLocale(names[i]).split('-')
        j = split.length
        next = normalizeLocale(names[i + 1])
        next = next ? next.split('-') : null
        while (j > 0) {
          locale = loadLocale(split.slice(0, j).join('-'))
          if (locale) {
            return locale
          }
          if (next && next.length >= j && commonPrefix(split, next) >= j - 1) {
            break
          }
          j--
        }
        i++
      }
      return globalLocale
    }
    function loadLocale(name) {
      var oldLocale = null,
        aliasedRequire
      if (
        locales[name] === undefined &&
        'object' !== 'undefined' &&
        module &&
        module.exports
      ) {
        try {
          oldLocale = globalLocale._abbr
          aliasedRequire = commonjsRequire
          aliasedRequire('./locale/' + name)
          getSetGlobalLocale(oldLocale)
        } catch (e) {
          locales[name] = null
        }
      }
      return locales[name]
    }
    function getSetGlobalLocale(key, values) {
      var data
      if (key) {
        if (isUndefined(values)) {
          data = getLocale(key)
        } else {
          data = defineLocale(key, values)
        }
        if (data) {
          globalLocale = data
        } else {
          if (typeof console !== 'undefined' && console.warn) {
            console.warn(
              'Locale ' + key + ' not found. Did you forget to load it?'
            )
          }
        }
      }
      return globalLocale._abbr
    }
    function defineLocale(name, config) {
      if (config !== null) {
        var locale,
          parentConfig = baseConfig
        config.abbr = name
        if (locales[name] != null) {
          deprecateSimple(
            'defineLocaleOverride',
            'use moment.updateLocale(localeName, config) to change ' +
              'an existing locale. moment.defineLocale(localeName, ' +
              'config) should only be used for creating a new locale ' +
              'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
          )
          parentConfig = locales[name]._config
        } else if (config.parentLocale != null) {
          if (locales[config.parentLocale] != null) {
            parentConfig = locales[config.parentLocale]._config
          } else {
            locale = loadLocale(config.parentLocale)
            if (locale != null) {
              parentConfig = locale._config
            } else {
              if (!localeFamilies[config.parentLocale]) {
                localeFamilies[config.parentLocale] = []
              }
              localeFamilies[config.parentLocale].push({
                name: name,
                config: config,
              })
              return null
            }
          }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config))
        if (localeFamilies[name]) {
          localeFamilies[name].forEach(function (x) {
            defineLocale(x.name, x.config)
          })
        }
        getSetGlobalLocale(name)
        return locales[name]
      } else {
        delete locales[name]
        return null
      }
    }
    function updateLocale(name, config) {
      if (config != null) {
        var locale,
          tmpLocale,
          parentConfig = baseConfig
        if (locales[name] != null && locales[name].parentLocale != null) {
          locales[name].set(mergeConfigs(locales[name]._config, config))
        } else {
          tmpLocale = loadLocale(name)
          if (tmpLocale != null) {
            parentConfig = tmpLocale._config
          }
          config = mergeConfigs(parentConfig, config)
          if (tmpLocale == null) {
            config.abbr = name
          }
          locale = new Locale(config)
          locale.parentLocale = locales[name]
          locales[name] = locale
        }
        getSetGlobalLocale(name)
      } else {
        if (locales[name] != null) {
          if (locales[name].parentLocale != null) {
            locales[name] = locales[name].parentLocale
            if (name === getSetGlobalLocale()) {
              getSetGlobalLocale(name)
            }
          } else if (locales[name] != null) {
            delete locales[name]
          }
        }
      }
      return locales[name]
    }
    function getLocale(key) {
      var locale
      if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr
      }
      if (!key) {
        return globalLocale
      }
      if (!isArray(key)) {
        locale = loadLocale(key)
        if (locale) {
          return locale
        }
        key = [key]
      }
      return chooseLocale(key)
    }
    function listLocales() {
      return keys(locales)
    }
    function checkOverflow(m) {
      var overflow,
        a = m._a
      if (a && getParsingFlags(m).overflow === -2) {
        overflow =
          a[MONTH] < 0 || a[MONTH] > 11
            ? MONTH
            : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
              ? DATE
              : a[HOUR] < 0 ||
                  a[HOUR] > 24 ||
                  (a[HOUR] === 24 &&
                    (a[MINUTE] !== 0 ||
                      a[SECOND] !== 0 ||
                      a[MILLISECOND] !== 0))
                ? HOUR
                : a[MINUTE] < 0 || a[MINUTE] > 59
                  ? MINUTE
                  : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                      ? MILLISECOND
                      : -1
        if (
          getParsingFlags(m)._overflowDayOfYear &&
          (overflow < YEAR || overflow > DATE)
        ) {
          overflow = DATE
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
          overflow = WEEK
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
          overflow = WEEKDAY
        }
        getParsingFlags(m).overflow = overflow
      }
      return m
    }
    var extendedIsoRegex =
        /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
      basicIsoRegex =
        /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
      tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
      isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/],
        ['YYYYMM', /\d{6}/, false],
        ['YYYY', /\d{4}/, false],
      ],
      isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/],
      ],
      aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
      rfc2822 =
        /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
      obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60,
      }
    function configFromISO(config) {
      var i,
        l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime,
        dateFormat,
        timeFormat,
        tzFormat
      if (match) {
        getParsingFlags(config).iso = true
        for (i = 0, l = isoDates.length; i < l; i++) {
          if (isoDates[i][1].exec(match[1])) {
            dateFormat = isoDates[i][0]
            allowTime = isoDates[i][2] !== false
            break
          }
        }
        if (dateFormat == null) {
          config._isValid = false
          return
        }
        if (match[3]) {
          for (i = 0, l = isoTimes.length; i < l; i++) {
            if (isoTimes[i][1].exec(match[3])) {
              timeFormat = (match[2] || ' ') + isoTimes[i][0]
              break
            }
          }
          if (timeFormat == null) {
            config._isValid = false
            return
          }
        }
        if (!allowTime && timeFormat != null) {
          config._isValid = false
          return
        }
        if (match[4]) {
          if (tzRegex.exec(match[4])) {
            tzFormat = 'Z'
          } else {
            config._isValid = false
            return
          }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '')
        configFromStringAndFormat(config)
      } else {
        config._isValid = false
      }
    }
    function extractFromRFC2822Strings(
      yearStr,
      monthStr,
      dayStr,
      hourStr,
      minuteStr,
      secondStr
    ) {
      var result = [
        untruncateYear(yearStr),
        defaultLocaleMonthsShort.indexOf(monthStr),
        parseInt(dayStr, 10),
        parseInt(hourStr, 10),
        parseInt(minuteStr, 10),
      ]
      if (secondStr) {
        result.push(parseInt(secondStr, 10))
      }
      return result
    }
    function untruncateYear(yearStr) {
      var year = parseInt(yearStr, 10)
      if (year <= 49) {
        return 2e3 + year
      } else if (year <= 999) {
        return 1900 + year
      }
      return year
    }
    function preprocessRFC2822(s) {
      return s
        .replace(/\([^)]*\)|[\n\t]/g, ' ')
        .replace(/(\s\s+)/g, ' ')
        .replace(/^\s\s*/, '')
        .replace(/\s\s*$/, '')
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
      if (weekdayStr) {
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
          weekdayActual = new Date(
            parsedInput[0],
            parsedInput[1],
            parsedInput[2]
          ).getDay()
        if (weekdayProvided !== weekdayActual) {
          getParsingFlags(config).weekdayMismatch = true
          config._isValid = false
          return false
        }
      }
      return true
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
      if (obsOffset) {
        return obsOffsets[obsOffset]
      } else if (militaryOffset) {
        return 0
      } else {
        var hm = parseInt(numOffset, 10),
          m = hm % 100,
          h = (hm - m) / 100
        return h * 60 + m
      }
    }
    function configFromRFC2822(config) {
      var match = rfc2822.exec(preprocessRFC2822(config._i)),
        parsedArray
      if (match) {
        parsedArray = extractFromRFC2822Strings(
          match[4],
          match[3],
          match[2],
          match[5],
          match[6],
          match[7]
        )
        if (!checkWeekday(match[1], parsedArray, config)) {
          return
        }
        config._a = parsedArray
        config._tzm = calculateOffset(match[8], match[9], match[10])
        config._d = createUTCDate.apply(null, config._a)
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm)
        getParsingFlags(config).rfc2822 = true
      } else {
        config._isValid = false
      }
    }
    function configFromString(config) {
      var matched = aspNetJsonRegex.exec(config._i)
      if (matched !== null) {
        config._d = new Date(+matched[1])
        return
      }
      configFromISO(config)
      if (config._isValid === false) {
        delete config._isValid
      } else {
        return
      }
      configFromRFC2822(config)
      if (config._isValid === false) {
        delete config._isValid
      } else {
        return
      }
      if (config._strict) {
        config._isValid = false
      } else {
        hooks.createFromInputFallback(config)
      }
    }
    hooks.createFromInputFallback = deprecate(
      'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
      function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''))
      }
    )
    function defaults(a, b, c) {
      if (a != null) {
        return a
      }
      if (b != null) {
        return b
      }
      return c
    }
    function currentDateArray(config) {
      var nowValue = new Date(hooks.now())
      if (config._useUTC) {
        return [
          nowValue.getUTCFullYear(),
          nowValue.getUTCMonth(),
          nowValue.getUTCDate(),
        ]
      }
      return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()]
    }
    function configFromArray(config) {
      var i,
        date,
        input = [],
        currentDate,
        expectedWeekday,
        yearToUse
      if (config._d) {
        return
      }
      currentDate = currentDateArray(config)
      if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config)
      }
      if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR])
        if (
          config._dayOfYear > daysInYear(yearToUse) ||
          config._dayOfYear === 0
        ) {
          getParsingFlags(config)._overflowDayOfYear = true
        }
        date = createUTCDate(yearToUse, 0, config._dayOfYear)
        config._a[MONTH] = date.getUTCMonth()
        config._a[DATE] = date.getUTCDate()
      }
      for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i]
      }
      for (; i < 7; i++) {
        config._a[i] = input[i] =
          config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i]
      }
      if (
        config._a[HOUR] === 24 &&
        config._a[MINUTE] === 0 &&
        config._a[SECOND] === 0 &&
        config._a[MILLISECOND] === 0
      ) {
        config._nextDay = true
        config._a[HOUR] = 0
      }
      config._d = (config._useUTC ? createUTCDate : createDate).apply(
        null,
        input
      )
      expectedWeekday = config._useUTC
        ? config._d.getUTCDay()
        : config._d.getDay()
      if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm)
      }
      if (config._nextDay) {
        config._a[HOUR] = 24
      }
      if (
        config._w &&
        typeof config._w.d !== 'undefined' &&
        config._w.d !== expectedWeekday
      ) {
        getParsingFlags(config).weekdayMismatch = true
      }
    }
    function dayOfYearFromWeekInfo(config) {
      var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek
      w = config._w
      if (w.GG != null || w.W != null || w.E != null) {
        dow = 1
        doy = 4
        weekYear = defaults(
          w.GG,
          config._a[YEAR],
          weekOfYear(createLocal(), 1, 4).year
        )
        week = defaults(w.W, 1)
        weekday = defaults(w.E, 1)
        if (weekday < 1 || weekday > 7) {
          weekdayOverflow = true
        }
      } else {
        dow = config._locale._week.dow
        doy = config._locale._week.doy
        curWeek = weekOfYear(createLocal(), dow, doy)
        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year)
        week = defaults(w.w, curWeek.week)
        if (w.d != null) {
          weekday = w.d
          if (weekday < 0 || weekday > 6) {
            weekdayOverflow = true
          }
        } else if (w.e != null) {
          weekday = w.e + dow
          if (w.e < 0 || w.e > 6) {
            weekdayOverflow = true
          }
        } else {
          weekday = dow
        }
      }
      if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true
      } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true
      } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy)
        config._a[YEAR] = temp.year
        config._dayOfYear = temp.dayOfYear
      }
    }
    hooks.ISO_8601 = function () {}
    hooks.RFC_2822 = function () {}
    function configFromStringAndFormat(config) {
      if (config._f === hooks.ISO_8601) {
        configFromISO(config)
        return
      }
      if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config)
        return
      }
      config._a = []
      getParsingFlags(config).empty = true
      var string = '' + config._i,
        i,
        parsedInput,
        tokens,
        token,
        skipped,
        stringLength = string.length,
        totalParsedInputLength = 0,
        era
      tokens =
        expandFormat(config._f, config._locale).match(formattingTokens) || []
      for (i = 0; i < tokens.length; i++) {
        token = tokens[i]
        parsedInput = (string.match(getParseRegexForToken(token, config)) ||
          [])[0]
        if (parsedInput) {
          skipped = string.substr(0, string.indexOf(parsedInput))
          if (skipped.length > 0) {
            getParsingFlags(config).unusedInput.push(skipped)
          }
          string = string.slice(
            string.indexOf(parsedInput) + parsedInput.length
          )
          totalParsedInputLength += parsedInput.length
        }
        if (formatTokenFunctions[token]) {
          if (parsedInput) {
            getParsingFlags(config).empty = false
          } else {
            getParsingFlags(config).unusedTokens.push(token)
          }
          addTimeToArrayFromToken(token, parsedInput, config)
        } else if (config._strict && !parsedInput) {
          getParsingFlags(config).unusedTokens.push(token)
        }
      }
      getParsingFlags(config).charsLeftOver =
        stringLength - totalParsedInputLength
      if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string)
      }
      if (
        config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0
      ) {
        getParsingFlags(config).bigHour = undefined
      }
      getParsingFlags(config).parsedDateParts = config._a.slice(0)
      getParsingFlags(config).meridiem = config._meridiem
      config._a[HOUR] = meridiemFixWrap(
        config._locale,
        config._a[HOUR],
        config._meridiem
      )
      era = getParsingFlags(config).era
      if (era !== null) {
        config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR])
      }
      configFromArray(config)
      checkOverflow(config)
    }
    function meridiemFixWrap(locale, hour, meridiem) {
      var isPm
      if (meridiem == null) {
        return hour
      }
      if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem)
      } else if (locale.isPM != null) {
        isPm = locale.isPM(meridiem)
        if (isPm && hour < 12) {
          hour += 12
        }
        if (!isPm && hour === 12) {
          hour = 0
        }
        return hour
      } else {
        return hour
      }
    }
    function configFromStringAndArray(config) {
      var tempConfig,
        bestMoment,
        scoreToBeat,
        i,
        currentScore,
        validFormatFound,
        bestFormatIsValid = false
      if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true
        config._d = new Date(NaN)
        return
      }
      for (i = 0; i < config._f.length; i++) {
        currentScore = 0
        validFormatFound = false
        tempConfig = copyConfig({}, config)
        if (config._useUTC != null) {
          tempConfig._useUTC = config._useUTC
        }
        tempConfig._f = config._f[i]
        configFromStringAndFormat(tempConfig)
        if (isValid(tempConfig)) {
          validFormatFound = true
        }
        currentScore += getParsingFlags(tempConfig).charsLeftOver
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10
        getParsingFlags(tempConfig).score = currentScore
        if (!bestFormatIsValid) {
          if (
            scoreToBeat == null ||
            currentScore < scoreToBeat ||
            validFormatFound
          ) {
            scoreToBeat = currentScore
            bestMoment = tempConfig
            if (validFormatFound) {
              bestFormatIsValid = true
            }
          }
        } else {
          if (currentScore < scoreToBeat) {
            scoreToBeat = currentScore
            bestMoment = tempConfig
          }
        }
      }
      extend(config, bestMoment || tempConfig)
    }
    function configFromObject(config) {
      if (config._d) {
        return
      }
      var i = normalizeObjectUnits(config._i),
        dayOrDate = i.day === undefined ? i.date : i.day
      config._a = map(
        [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
        function (obj) {
          return obj && parseInt(obj, 10)
        }
      )
      configFromArray(config)
    }
    function createFromConfig(config) {
      var res = new Moment(checkOverflow(prepareConfig(config)))
      if (res._nextDay) {
        res.add(1, 'd')
        res._nextDay = undefined
      }
      return res
    }
    function prepareConfig(config) {
      var input = config._i,
        format = config._f
      config._locale = config._locale || getLocale(config._l)
      if (input === null || (format === undefined && input === '')) {
        return createInvalid({
          nullInput: true,
        })
      }
      if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input)
      }
      if (isMoment(input)) {
        return new Moment(checkOverflow(input))
      } else if (isDate(input)) {
        config._d = input
      } else if (isArray(format)) {
        configFromStringAndArray(config)
      } else if (format) {
        configFromStringAndFormat(config)
      } else {
        configFromInput(config)
      }
      if (!isValid(config)) {
        config._d = null
      }
      return config
    }
    function configFromInput(config) {
      var input = config._i
      if (isUndefined(input)) {
        config._d = new Date(hooks.now())
      } else if (isDate(input)) {
        config._d = new Date(input.valueOf())
      } else if (typeof input === 'string') {
        configFromString(config)
      } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
          return parseInt(obj, 10)
        })
        configFromArray(config)
      } else if (isObject(input)) {
        configFromObject(config)
      } else if (isNumber(input)) {
        config._d = new Date(input)
      } else {
        hooks.createFromInputFallback(config)
      }
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
      var c = {}
      if (format === true || format === false) {
        strict = format
        format = undefined
      }
      if (locale === true || locale === false) {
        strict = locale
        locale = undefined
      }
      if (
        (isObject(input) && isObjectEmpty(input)) ||
        (isArray(input) && input.length === 0)
      ) {
        input = undefined
      }
      c._isAMomentObject = true
      c._useUTC = c._isUTC = isUTC
      c._l = locale
      c._i = input
      c._f = format
      c._strict = strict
      return createFromConfig(c)
    }
    function createLocal(input, format, locale, strict) {
      return createLocalOrUTC(input, format, locale, strict, false)
    }
    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
          var other = createLocal.apply(null, arguments)
          if (this.isValid() && other.isValid()) {
            return other < this ? this : other
          } else {
            return createInvalid()
          }
        }
      ),
      prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
          var other = createLocal.apply(null, arguments)
          if (this.isValid() && other.isValid()) {
            return other > this ? this : other
          } else {
            return createInvalid()
          }
        }
      )
    function pickBy(fn, moments) {
      var res, i
      if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0]
      }
      if (!moments.length) {
        return createLocal()
      }
      res = moments[0]
      for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
          res = moments[i]
        }
      }
      return res
    }
    function min() {
      var args = [].slice.call(arguments, 0)
      return pickBy('isBefore', args)
    }
    function max() {
      var args = [].slice.call(arguments, 0)
      return pickBy('isAfter', args)
    }
    var now = function () {
      return Date.now ? Date.now() : +new Date()
    }
    var ordering = [
      'year',
      'quarter',
      'month',
      'week',
      'day',
      'hour',
      'minute',
      'second',
      'millisecond',
    ]
    function isDurationValid(m) {
      var key,
        unitHasDecimal = false,
        i
      for (key in m) {
        if (
          hasOwnProp(m, key) &&
          !(
            indexOf.call(ordering, key) !== -1 &&
            (m[key] == null || !isNaN(m[key]))
          )
        ) {
          return false
        }
      }
      for (i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
          if (unitHasDecimal) {
            return false
          }
          if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
            unitHasDecimal = true
          }
        }
      }
      return true
    }
    function isValid$1() {
      return this._isValid
    }
    function createInvalid$1() {
      return createDuration(NaN)
    }
    function Duration(duration) {
      var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0
      this._isValid = isDurationValid(normalizedInput)
      this._milliseconds =
        +milliseconds + seconds * 1e3 + minutes * 6e4 + hours * 1e3 * 60 * 60
      this._days = +days + weeks * 7
      this._months = +months + quarters * 3 + years * 12
      this._data = {}
      this._locale = getLocale()
      this._bubble()
    }
    function isDuration(obj) {
      return obj instanceof Duration
    }
    function absRound(number) {
      if (number < 0) {
        return Math.round(-1 * number) * -1
      } else {
        return Math.round(number)
      }
    }
    function compareArrays(array1, array2, dontConvert) {
      var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i
      for (i = 0; i < len; i++) {
        if (
          (dontConvert && array1[i] !== array2[i]) ||
          (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
        ) {
          diffs++
        }
      }
      return diffs + lengthDiff
    }
    function offset(token, separator) {
      addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset(),
          sign = '+'
        if (offset < 0) {
          offset = -offset
          sign = '-'
        }
        return (
          sign +
          zeroFill(~~(offset / 60), 2) +
          separator +
          zeroFill(~~offset % 60, 2)
        )
      })
    }
    offset('Z', ':')
    offset('ZZ', '')
    addRegexToken('Z', matchShortOffset)
    addRegexToken('ZZ', matchShortOffset)
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
      config._useUTC = true
      config._tzm = offsetFromString(matchShortOffset, input)
    })
    var chunkOffset = /([\+\-]|\d\d)/gi
    function offsetFromString(matcher, string) {
      var matches = (string || '').match(matcher),
        chunk,
        parts,
        minutes
      if (matches === null) {
        return null
      }
      chunk = matches[matches.length - 1] || []
      parts = (chunk + '').match(chunkOffset) || ['-', 0, 0]
      minutes = +(parts[1] * 60) + toInt(parts[2])
      return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes
    }
    function cloneWithOffset(input, model) {
      var res, diff
      if (model._isUTC) {
        res = model.clone()
        diff =
          (isMoment(input) || isDate(input)
            ? input.valueOf()
            : createLocal(input).valueOf()) - res.valueOf()
        res._d.setTime(res._d.valueOf() + diff)
        hooks.updateOffset(res, false)
        return res
      } else {
        return createLocal(input).local()
      }
    }
    function getDateOffset(m) {
      return -Math.round(m._d.getTimezoneOffset())
    }
    hooks.updateOffset = function () {}
    function getSetOffset(input, keepLocalTime, keepMinutes) {
      var offset = this._offset || 0,
        localAdjust
      if (!this.isValid()) {
        return input != null ? this : NaN
      }
      if (input != null) {
        if (typeof input === 'string') {
          input = offsetFromString(matchShortOffset, input)
          if (input === null) {
            return this
          }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
          input = input * 60
        }
        if (!this._isUTC && keepLocalTime) {
          localAdjust = getDateOffset(this)
        }
        this._offset = input
        this._isUTC = true
        if (localAdjust != null) {
          this.add(localAdjust, 'm')
        }
        if (offset !== input) {
          if (!keepLocalTime || this._changeInProgress) {
            addSubtract(this, createDuration(input - offset, 'm'), 1, false)
          } else if (!this._changeInProgress) {
            this._changeInProgress = true
            hooks.updateOffset(this, true)
            this._changeInProgress = null
          }
        }
        return this
      } else {
        return this._isUTC ? offset : getDateOffset(this)
      }
    }
    function getSetZone(input, keepLocalTime) {
      if (input != null) {
        if (typeof input !== 'string') {
          input = -input
        }
        this.utcOffset(input, keepLocalTime)
        return this
      } else {
        return -this.utcOffset()
      }
    }
    function setOffsetToUTC(keepLocalTime) {
      return this.utcOffset(0, keepLocalTime)
    }
    function setOffsetToLocal(keepLocalTime) {
      if (this._isUTC) {
        this.utcOffset(0, keepLocalTime)
        this._isUTC = false
        if (keepLocalTime) {
          this.subtract(getDateOffset(this), 'm')
        }
      }
      return this
    }
    function setOffsetToParsedOffset() {
      if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true)
      } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i)
        if (tZone != null) {
          this.utcOffset(tZone)
        } else {
          this.utcOffset(0, true)
        }
      }
      return this
    }
    function hasAlignedHourOffset(input) {
      if (!this.isValid()) {
        return false
      }
      input = input ? createLocal(input).utcOffset() : 0
      return (this.utcOffset() - input) % 60 === 0
    }
    function isDaylightSavingTime() {
      return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
      )
    }
    function isDaylightSavingTimeShifted() {
      if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted
      }
      var c = {},
        other
      copyConfig(c, this)
      c = prepareConfig(c)
      if (c._a) {
        other = c._isUTC ? createUTC(c._a) : createLocal(c._a)
        this._isDSTShifted =
          this.isValid() && compareArrays(c._a, other.toArray()) > 0
      } else {
        this._isDSTShifted = false
      }
      return this._isDSTShifted
    }
    function isLocal() {
      return this.isValid() ? !this._isUTC : false
    }
    function isUtcOffset() {
      return this.isValid() ? this._isUTC : false
    }
    function isUtc() {
      return this.isValid() ? this._isUTC && this._offset === 0 : false
    }
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
      isoRegex =
        /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/
    function createDuration(input, key) {
      var duration = input,
        match = null,
        sign,
        ret,
        diffRes
      if (isDuration(input)) {
        duration = {
          ms: input._milliseconds,
          d: input._days,
          M: input._months,
        }
      } else if (isNumber(input) || !isNaN(+input)) {
        duration = {}
        if (key) {
          duration[key] = +input
        } else {
          duration.milliseconds = +input
        }
      } else if ((match = aspNetRegex.exec(input))) {
        sign = match[1] === '-' ? -1 : 1
        duration = {
          y: 0,
          d: toInt(match[DATE]) * sign,
          h: toInt(match[HOUR]) * sign,
          m: toInt(match[MINUTE]) * sign,
          s: toInt(match[SECOND]) * sign,
          ms: toInt(absRound(match[MILLISECOND] * 1e3)) * sign,
        }
      } else if ((match = isoRegex.exec(input))) {
        sign = match[1] === '-' ? -1 : 1
        duration = {
          y: parseIso(match[2], sign),
          M: parseIso(match[3], sign),
          w: parseIso(match[4], sign),
          d: parseIso(match[5], sign),
          h: parseIso(match[6], sign),
          m: parseIso(match[7], sign),
          s: parseIso(match[8], sign),
        }
      } else if (duration == null) {
        duration = {}
      } else if (
        typeof duration === 'object' &&
        ('from' in duration || 'to' in duration)
      ) {
        diffRes = momentsDifference(
          createLocal(duration.from),
          createLocal(duration.to)
        )
        duration = {}
        duration.ms = diffRes.milliseconds
        duration.M = diffRes.months
      }
      ret = new Duration(duration)
      if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale
      }
      if (isDuration(input) && hasOwnProp(input, '_isValid')) {
        ret._isValid = input._isValid
      }
      return ret
    }
    createDuration.fn = Duration.prototype
    createDuration.invalid = createInvalid$1
    function parseIso(inp, sign) {
      var res = inp && parseFloat(inp.replace(',', '.'))
      return (isNaN(res) ? 0 : res) * sign
    }
    function positiveMomentsDifference(base, other) {
      var res = {}
      res.months =
        other.month() - base.month() + (other.year() - base.year()) * 12
      if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months
      }
      res.milliseconds = +other - +base.clone().add(res.months, 'M')
      return res
    }
    function momentsDifference(base, other) {
      var res
      if (!(base.isValid() && other.isValid())) {
        return {
          milliseconds: 0,
          months: 0,
        }
      }
      other = cloneWithOffset(other, base)
      if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other)
      } else {
        res = positiveMomentsDifference(other, base)
        res.milliseconds = -res.milliseconds
        res.months = -res.months
      }
      return res
    }
    function createAdder(direction, name) {
      return function (val, period) {
        var dur, tmp
        if (period !== null && !isNaN(+period)) {
          deprecateSimple(
            name,
            'moment().' +
              name +
              '(period, number) is deprecated. Please use moment().' +
              name +
              '(number, period). ' +
              'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
          )
          tmp = val
          val = period
          period = tmp
        }
        dur = createDuration(val, period)
        addSubtract(this, dur, direction)
        return this
      }
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
      var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months)
      if (!mom.isValid()) {
        return
      }
      updateOffset = updateOffset == null ? true : updateOffset
      if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding)
      }
      if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding)
      }
      if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding)
      }
      if (updateOffset) {
        hooks.updateOffset(mom, days || months)
      }
    }
    var add = createAdder(1, 'add'),
      subtract = createAdder(-1, 'subtract')
    function isString(input) {
      return typeof input === 'string' || input instanceof String
    }
    function isMomentInput(input) {
      return (
        isMoment(input) ||
        isDate(input) ||
        isString(input) ||
        isNumber(input) ||
        isNumberOrStringArray(input) ||
        isMomentInputObject(input) ||
        input === null ||
        input === undefined
      )
    }
    function isMomentInputObject(input) {
      var objectTest = isObject(input) && !isObjectEmpty(input),
        propertyTest = false,
        properties = [
          'years',
          'year',
          'y',
          'months',
          'month',
          'M',
          'days',
          'day',
          'd',
          'dates',
          'date',
          'D',
          'hours',
          'hour',
          'h',
          'minutes',
          'minute',
          'm',
          'seconds',
          'second',
          's',
          'milliseconds',
          'millisecond',
          'ms',
        ],
        i,
        property
      for (i = 0; i < properties.length; i += 1) {
        property = properties[i]
        propertyTest = propertyTest || hasOwnProp(input, property)
      }
      return objectTest && propertyTest
    }
    function isNumberOrStringArray(input) {
      var arrayTest = isArray(input),
        dataTypeTest = false
      if (arrayTest) {
        dataTypeTest =
          input.filter(function (item) {
            return !isNumber(item) && isString(input)
          }).length === 0
      }
      return arrayTest && dataTypeTest
    }
    function isCalendarSpec(input) {
      var objectTest = isObject(input) && !isObjectEmpty(input),
        propertyTest = false,
        properties = [
          'sameDay',
          'nextDay',
          'lastDay',
          'nextWeek',
          'lastWeek',
          'sameElse',
        ],
        i,
        property
      for (i = 0; i < properties.length; i += 1) {
        property = properties[i]
        propertyTest = propertyTest || hasOwnProp(input, property)
      }
      return objectTest && propertyTest
    }
    function getCalendarFormat(myMoment, now) {
      var diff = myMoment.diff(now, 'days', true)
      return diff < -6
        ? 'sameElse'
        : diff < -1
          ? 'lastWeek'
          : diff < 0
            ? 'lastDay'
            : diff < 1
              ? 'sameDay'
              : diff < 2
                ? 'nextDay'
                : diff < 7
                  ? 'nextWeek'
                  : 'sameElse'
    }
    function calendar$1(time, formats) {
      if (arguments.length === 1) {
        if (!arguments[0]) {
          time = undefined
          formats = undefined
        } else if (isMomentInput(arguments[0])) {
          time = arguments[0]
          formats = undefined
        } else if (isCalendarSpec(arguments[0])) {
          formats = arguments[0]
          time = undefined
        }
      }
      var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse',
        output =
          formats &&
          (isFunction(formats[format])
            ? formats[format].call(this, now)
            : formats[format])
      return this.format(
        output || this.localeData().calendar(format, this, createLocal(now))
      )
    }
    function clone() {
      return new Moment(this)
    }
    function isAfter(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input)
      if (!(this.isValid() && localInput.isValid())) {
        return false
      }
      units = normalizeUnits(units) || 'millisecond'
      if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf()
      } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf()
      }
    }
    function isBefore(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input)
      if (!(this.isValid() && localInput.isValid())) {
        return false
      }
      units = normalizeUnits(units) || 'millisecond'
      if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf()
      } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf()
      }
    }
    function isBetween(from, to, units, inclusivity) {
      var localFrom = isMoment(from) ? from : createLocal(from),
        localTo = isMoment(to) ? to : createLocal(to)
      if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
        return false
      }
      inclusivity = inclusivity || '()'
      return (
        (inclusivity[0] === '('
          ? this.isAfter(localFrom, units)
          : !this.isBefore(localFrom, units)) &&
        (inclusivity[1] === ')'
          ? this.isBefore(localTo, units)
          : !this.isAfter(localTo, units))
      )
    }
    function isSame(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input),
        inputMs
      if (!(this.isValid() && localInput.isValid())) {
        return false
      }
      units = normalizeUnits(units) || 'millisecond'
      if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf()
      } else {
        inputMs = localInput.valueOf()
        return (
          this.clone().startOf(units).valueOf() <= inputMs &&
          inputMs <= this.clone().endOf(units).valueOf()
        )
      }
    }
    function isSameOrAfter(input, units) {
      return this.isSame(input, units) || this.isAfter(input, units)
    }
    function isSameOrBefore(input, units) {
      return this.isSame(input, units) || this.isBefore(input, units)
    }
    function diff(input, units, asFloat) {
      var that, zoneDelta, output
      if (!this.isValid()) {
        return NaN
      }
      that = cloneWithOffset(input, this)
      if (!that.isValid()) {
        return NaN
      }
      zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4
      units = normalizeUnits(units)
      switch (units) {
        case 'year':
          output = monthDiff(this, that) / 12
          break

        case 'month':
          output = monthDiff(this, that)
          break

        case 'quarter':
          output = monthDiff(this, that) / 3
          break

        case 'second':
          output = (this - that) / 1e3
          break

        case 'minute':
          output = (this - that) / 6e4
          break

        case 'hour':
          output = (this - that) / 36e5
          break

        case 'day':
          output = (this - that - zoneDelta) / 864e5
          break

        case 'week':
          output = (this - that - zoneDelta) / 6048e5
          break

        default:
          output = this - that
      }
      return asFloat ? output : absFloor(output)
    }
    function monthDiff(a, b) {
      if (a.date() < b.date()) {
        return -monthDiff(b, a)
      }
      var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2,
        adjust
      if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months')
        adjust = (b - anchor) / (anchor - anchor2)
      } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months')
        adjust = (b - anchor) / (anchor2 - anchor)
      }
      return -(wholeMonthDiff + adjust) || 0
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ'
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]'
    function toString() {
      return this.clone()
        .locale('en')
        .format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ')
    }
    function toISOString(keepOffset) {
      if (!this.isValid()) {
        return null
      }
      var utc = keepOffset !== true,
        m = utc ? this.clone().utc() : this
      if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(
          m,
          utc
            ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
            : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
        )
      }
      if (isFunction(Date.prototype.toISOString)) {
        if (utc) {
          return this.toDate().toISOString()
        } else {
          return new Date(this.valueOf() + this.utcOffset() * 60 * 1e3)
            .toISOString()
            .replace('Z', formatMoment(m, 'Z'))
        }
      }
      return formatMoment(
        m,
        utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
      )
    }
    function inspect() {
      if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)'
      }
      var func = 'moment',
        zone = '',
        prefix,
        year,
        datetime,
        suffix
      if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone'
        zone = 'Z'
      }
      prefix = '[' + func + '("]'
      year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY'
      datetime = '-MM-DD[T]HH:mm:ss.SSS'
      suffix = zone + '[")]'
      return this.format(prefix + year + datetime + suffix)
    }
    function format(inputString) {
      if (!inputString) {
        inputString = this.isUtc()
          ? hooks.defaultFormatUtc
          : hooks.defaultFormat
      }
      var output = formatMoment(this, inputString)
      return this.localeData().postformat(output)
    }
    function from(time, withoutSuffix) {
      if (
        this.isValid() &&
        ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
      ) {
        return createDuration({
          to: this,
          from: time,
        })
          .locale(this.locale())
          .humanize(!withoutSuffix)
      } else {
        return this.localeData().invalidDate()
      }
    }
    function fromNow(withoutSuffix) {
      return this.from(createLocal(), withoutSuffix)
    }
    function to(time, withoutSuffix) {
      if (
        this.isValid() &&
        ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
      ) {
        return createDuration({
          from: this,
          to: time,
        })
          .locale(this.locale())
          .humanize(!withoutSuffix)
      } else {
        return this.localeData().invalidDate()
      }
    }
    function toNow(withoutSuffix) {
      return this.to(createLocal(), withoutSuffix)
    }
    function locale(key) {
      var newLocaleData
      if (key === undefined) {
        return this._locale._abbr
      } else {
        newLocaleData = getLocale(key)
        if (newLocaleData != null) {
          this._locale = newLocaleData
        }
        return this
      }
    }
    var lang = deprecate(
      'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
      function (key) {
        if (key === undefined) {
          return this.localeData()
        } else {
          return this.locale(key)
        }
      }
    )
    function localeData() {
      return this._locale
    }
    var MS_PER_SECOND = 1e3,
      MS_PER_MINUTE = 60 * MS_PER_SECOND,
      MS_PER_HOUR = 60 * MS_PER_MINUTE,
      MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR
    function mod$1(dividend, divisor) {
      return ((dividend % divisor) + divisor) % divisor
    }
    function localStartOfDate(y, m, d) {
      if (y < 100 && y >= 0) {
        return new Date(y + 400, m, d) - MS_PER_400_YEARS
      } else {
        return new Date(y, m, d).valueOf()
      }
    }
    function utcStartOfDate(y, m, d) {
      if (y < 100 && y >= 0) {
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS
      } else {
        return Date.UTC(y, m, d)
      }
    }
    function startOf(units) {
      var time, startOfDate
      units = normalizeUnits(units)
      if (units === undefined || units === 'millisecond' || !this.isValid()) {
        return this
      }
      startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate
      switch (units) {
        case 'year':
          time = startOfDate(this.year(), 0, 1)
          break

        case 'quarter':
          time = startOfDate(this.year(), this.month() - (this.month() % 3), 1)
          break

        case 'month':
          time = startOfDate(this.year(), this.month(), 1)
          break

        case 'week':
          time = startOfDate(
            this.year(),
            this.month(),
            this.date() - this.weekday()
          )
          break

        case 'isoWeek':
          time = startOfDate(
            this.year(),
            this.month(),
            this.date() - (this.isoWeekday() - 1)
          )
          break

        case 'day':
        case 'date':
          time = startOfDate(this.year(), this.month(), this.date())
          break

        case 'hour':
          time = this._d.valueOf()
          time -= mod$1(
            time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
            MS_PER_HOUR
          )
          break

        case 'minute':
          time = this._d.valueOf()
          time -= mod$1(time, MS_PER_MINUTE)
          break

        case 'second':
          time = this._d.valueOf()
          time -= mod$1(time, MS_PER_SECOND)
          break
      }
      this._d.setTime(time)
      hooks.updateOffset(this, true)
      return this
    }
    function endOf(units) {
      var time, startOfDate
      units = normalizeUnits(units)
      if (units === undefined || units === 'millisecond' || !this.isValid()) {
        return this
      }
      startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate
      switch (units) {
        case 'year':
          time = startOfDate(this.year() + 1, 0, 1) - 1
          break

        case 'quarter':
          time =
            startOfDate(this.year(), this.month() - (this.month() % 3) + 3, 1) -
            1
          break

        case 'month':
          time = startOfDate(this.year(), this.month() + 1, 1) - 1
          break

        case 'week':
          time =
            startOfDate(
              this.year(),
              this.month(),
              this.date() - this.weekday() + 7
            ) - 1
          break

        case 'isoWeek':
          time =
            startOfDate(
              this.year(),
              this.month(),
              this.date() - (this.isoWeekday() - 1) + 7
            ) - 1
          break

        case 'day':
        case 'date':
          time = startOfDate(this.year(), this.month(), this.date() + 1) - 1
          break

        case 'hour':
          time = this._d.valueOf()
          time +=
            MS_PER_HOUR -
            mod$1(
              time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
              MS_PER_HOUR
            ) -
            1
          break

        case 'minute':
          time = this._d.valueOf()
          time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1
          break

        case 'second':
          time = this._d.valueOf()
          time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1
          break
      }
      this._d.setTime(time)
      hooks.updateOffset(this, true)
      return this
    }
    function valueOf() {
      return this._d.valueOf() - (this._offset || 0) * 6e4
    }
    function unix() {
      return Math.floor(this.valueOf() / 1e3)
    }
    function toDate() {
      return new Date(this.valueOf())
    }
    function toArray() {
      var m = this
      return [
        m.year(),
        m.month(),
        m.date(),
        m.hour(),
        m.minute(),
        m.second(),
        m.millisecond(),
      ]
    }
    function toObject() {
      var m = this
      return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds(),
      }
    }
    function toJSON() {
      return this.isValid() ? this.toISOString() : null
    }
    function isValid$2() {
      return isValid(this)
    }
    function parsingFlags() {
      return extend({}, getParsingFlags(this))
    }
    function invalidAt() {
      return getParsingFlags(this).overflow
    }
    function creationData() {
      return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict,
      }
    }
    addFormatToken('N', 0, 0, 'eraAbbr')
    addFormatToken('NN', 0, 0, 'eraAbbr')
    addFormatToken('NNN', 0, 0, 'eraAbbr')
    addFormatToken('NNNN', 0, 0, 'eraName')
    addFormatToken('NNNNN', 0, 0, 'eraNarrow')
    addFormatToken('y', ['y', 1], 'yo', 'eraYear')
    addFormatToken('y', ['yy', 2], 0, 'eraYear')
    addFormatToken('y', ['yyy', 3], 0, 'eraYear')
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear')
    addRegexToken('N', matchEraAbbr)
    addRegexToken('NN', matchEraAbbr)
    addRegexToken('NNN', matchEraAbbr)
    addRegexToken('NNNN', matchEraName)
    addRegexToken('NNNNN', matchEraNarrow)
    addParseToken(
      ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
      function (input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict)
        if (era) {
          getParsingFlags(config).era = era
        } else {
          getParsingFlags(config).invalidEra = input
        }
      }
    )
    addRegexToken('y', matchUnsigned)
    addRegexToken('yy', matchUnsigned)
    addRegexToken('yyy', matchUnsigned)
    addRegexToken('yyyy', matchUnsigned)
    addRegexToken('yo', matchEraYearOrdinal)
    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR)
    addParseToken(['yo'], function (input, array, config, token) {
      var match
      if (config._locale._eraYearOrdinalRegex) {
        match = input.match(config._locale._eraYearOrdinalRegex)
      }
      if (config._locale.eraYearOrdinalParse) {
        array[YEAR] = config._locale.eraYearOrdinalParse(input, match)
      } else {
        array[YEAR] = parseInt(input, 10)
      }
    })
    function localeEras(m, format) {
      var i,
        l,
        date,
        eras = this._eras || getLocale('en')._eras
      for (i = 0, l = eras.length; i < l; ++i) {
        switch (typeof eras[i].since) {
          case 'string':
            date = hooks(eras[i].since).startOf('day')
            eras[i].since = date.valueOf()
            break
        }
        switch (typeof eras[i].until) {
          case 'undefined':
            eras[i].until = +Infinity
            break

          case 'string':
            date = hooks(eras[i].until).startOf('day').valueOf()
            eras[i].until = date.valueOf()
            break
        }
      }
      return eras
    }
    function localeErasParse(eraName, format, strict) {
      var i,
        l,
        eras = this.eras(),
        name,
        abbr,
        narrow
      eraName = eraName.toUpperCase()
      for (i = 0, l = eras.length; i < l; ++i) {
        name = eras[i].name.toUpperCase()
        abbr = eras[i].abbr.toUpperCase()
        narrow = eras[i].narrow.toUpperCase()
        if (strict) {
          switch (format) {
            case 'N':
            case 'NN':
            case 'NNN':
              if (abbr === eraName) {
                return eras[i]
              }
              break

            case 'NNNN':
              if (name === eraName) {
                return eras[i]
              }
              break

            case 'NNNNN':
              if (narrow === eraName) {
                return eras[i]
              }
              break
          }
        } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
          return eras[i]
        }
      }
    }
    function localeErasConvertYear(era, year) {
      var dir = era.since <= era.until ? +1 : -1
      if (year === undefined) {
        return hooks(era.since).year()
      } else {
        return hooks(era.since).year() + (year - era.offset) * dir
      }
    }
    function getEraName() {
      var i,
        l,
        val,
        eras = this.localeData().eras()
      for (i = 0, l = eras.length; i < l; ++i) {
        val = this.clone().startOf('day').valueOf()
        if (eras[i].since <= val && val <= eras[i].until) {
          return eras[i].name
        }
        if (eras[i].until <= val && val <= eras[i].since) {
          return eras[i].name
        }
      }
      return ''
    }
    function getEraNarrow() {
      var i,
        l,
        val,
        eras = this.localeData().eras()
      for (i = 0, l = eras.length; i < l; ++i) {
        val = this.clone().startOf('day').valueOf()
        if (eras[i].since <= val && val <= eras[i].until) {
          return eras[i].narrow
        }
        if (eras[i].until <= val && val <= eras[i].since) {
          return eras[i].narrow
        }
      }
      return ''
    }
    function getEraAbbr() {
      var i,
        l,
        val,
        eras = this.localeData().eras()
      for (i = 0, l = eras.length; i < l; ++i) {
        val = this.clone().startOf('day').valueOf()
        if (eras[i].since <= val && val <= eras[i].until) {
          return eras[i].abbr
        }
        if (eras[i].until <= val && val <= eras[i].since) {
          return eras[i].abbr
        }
      }
      return ''
    }
    function getEraYear() {
      var i,
        l,
        dir,
        val,
        eras = this.localeData().eras()
      for (i = 0, l = eras.length; i < l; ++i) {
        dir = eras[i].since <= eras[i].until ? +1 : -1
        val = this.clone().startOf('day').valueOf()
        if (
          (eras[i].since <= val && val <= eras[i].until) ||
          (eras[i].until <= val && val <= eras[i].since)
        ) {
          return (
            (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset
          )
        }
      }
      return this.year()
    }
    function erasNameRegex(isStrict) {
      if (!hasOwnProp(this, '_erasNameRegex')) {
        computeErasParse.call(this)
      }
      return isStrict ? this._erasNameRegex : this._erasRegex
    }
    function erasAbbrRegex(isStrict) {
      if (!hasOwnProp(this, '_erasAbbrRegex')) {
        computeErasParse.call(this)
      }
      return isStrict ? this._erasAbbrRegex : this._erasRegex
    }
    function erasNarrowRegex(isStrict) {
      if (!hasOwnProp(this, '_erasNarrowRegex')) {
        computeErasParse.call(this)
      }
      return isStrict ? this._erasNarrowRegex : this._erasRegex
    }
    function matchEraAbbr(isStrict, locale) {
      return locale.erasAbbrRegex(isStrict)
    }
    function matchEraName(isStrict, locale) {
      return locale.erasNameRegex(isStrict)
    }
    function matchEraNarrow(isStrict, locale) {
      return locale.erasNarrowRegex(isStrict)
    }
    function matchEraYearOrdinal(isStrict, locale) {
      return locale._eraYearOrdinalRegex || matchUnsigned
    }
    function computeErasParse() {
      var abbrPieces = [],
        namePieces = [],
        narrowPieces = [],
        mixedPieces = [],
        i,
        l,
        eras = this.eras()
      for (i = 0, l = eras.length; i < l; ++i) {
        namePieces.push(regexEscape(eras[i].name))
        abbrPieces.push(regexEscape(eras[i].abbr))
        narrowPieces.push(regexEscape(eras[i].narrow))
        mixedPieces.push(regexEscape(eras[i].name))
        mixedPieces.push(regexEscape(eras[i].abbr))
        mixedPieces.push(regexEscape(eras[i].narrow))
      }
      this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i')
      this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i')
      this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i')
      this._erasNarrowRegex = new RegExp(
        '^(' + narrowPieces.join('|') + ')',
        'i'
      )
    }
    addFormatToken(0, ['gg', 2], 0, function () {
      return this.weekYear() % 100
    })
    addFormatToken(0, ['GG', 2], 0, function () {
      return this.isoWeekYear() % 100
    })
    function addWeekYearFormatToken(token, getter) {
      addFormatToken(0, [token, token.length], 0, getter)
    }
    addWeekYearFormatToken('gggg', 'weekYear')
    addWeekYearFormatToken('ggggg', 'weekYear')
    addWeekYearFormatToken('GGGG', 'isoWeekYear')
    addWeekYearFormatToken('GGGGG', 'isoWeekYear')
    addUnitAlias('weekYear', 'gg')
    addUnitAlias('isoWeekYear', 'GG')
    addUnitPriority('weekYear', 1)
    addUnitPriority('isoWeekYear', 1)
    addRegexToken('G', matchSigned)
    addRegexToken('g', matchSigned)
    addRegexToken('GG', match1to2, match2)
    addRegexToken('gg', match1to2, match2)
    addRegexToken('GGGG', match1to4, match4)
    addRegexToken('gggg', match1to4, match4)
    addRegexToken('GGGGG', match1to6, match6)
    addRegexToken('ggggg', match1to6, match6)
    addWeekParseToken(
      ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
      function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input)
      }
    )
    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
      week[token] = hooks.parseTwoDigitYear(input)
    })
    function getSetWeekYear(input) {
      return getSetWeekYearHelper.call(
        this,
        input,
        this.week(),
        this.weekday(),
        this.localeData()._week.dow,
        this.localeData()._week.doy
      )
    }
    function getSetISOWeekYear(input) {
      return getSetWeekYearHelper.call(
        this,
        input,
        this.isoWeek(),
        this.isoWeekday(),
        1,
        4
      )
    }
    function getISOWeeksInYear() {
      return weeksInYear(this.year(), 1, 4)
    }
    function getISOWeeksInISOWeekYear() {
      return weeksInYear(this.isoWeekYear(), 1, 4)
    }
    function getWeeksInYear() {
      var weekInfo = this.localeData()._week
      return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy)
    }
    function getWeeksInWeekYear() {
      var weekInfo = this.localeData()._week
      return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy)
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
      var weeksTarget
      if (input == null) {
        return weekOfYear(this, dow, doy).year
      } else {
        weeksTarget = weeksInYear(input, dow, doy)
        if (week > weeksTarget) {
          week = weeksTarget
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy)
      }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
      var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear)
      this.year(date.getUTCFullYear())
      this.month(date.getUTCMonth())
      this.date(date.getUTCDate())
      return this
    }
    addFormatToken('Q', 0, 'Qo', 'quarter')
    addUnitAlias('quarter', 'Q')
    addUnitPriority('quarter', 7)
    addRegexToken('Q', match1)
    addParseToken('Q', function (input, array) {
      array[MONTH] = (toInt(input) - 1) * 3
    })
    function getSetQuarter(input) {
      return input == null
        ? Math.ceil((this.month() + 1) / 3)
        : this.month((input - 1) * 3 + (this.month() % 3))
    }
    addFormatToken('D', ['DD', 2], 'Do', 'date')
    addUnitAlias('date', 'D')
    addUnitPriority('date', 9)
    addRegexToken('D', match1to2)
    addRegexToken('DD', match1to2, match2)
    addRegexToken('Do', function (isStrict, locale) {
      return isStrict
        ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
        : locale._dayOfMonthOrdinalParseLenient
    })
    addParseToken(['D', 'DD'], DATE)
    addParseToken('Do', function (input, array) {
      array[DATE] = toInt(input.match(match1to2)[0])
    })
    var getSetDayOfMonth = makeGetSet('Date', true)
    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear')
    addUnitAlias('dayOfYear', 'DDD')
    addUnitPriority('dayOfYear', 4)
    addRegexToken('DDD', match1to3)
    addRegexToken('DDDD', match3)
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
      config._dayOfYear = toInt(input)
    })
    function getSetDayOfYear(input) {
      var dayOfYear =
        Math.round(
          (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
        ) + 1
      return input == null ? dayOfYear : this.add(input - dayOfYear, 'd')
    }
    addFormatToken('m', ['mm', 2], 0, 'minute')
    addUnitAlias('minute', 'm')
    addUnitPriority('minute', 14)
    addRegexToken('m', match1to2)
    addRegexToken('mm', match1to2, match2)
    addParseToken(['m', 'mm'], MINUTE)
    var getSetMinute = makeGetSet('Minutes', false)
    addFormatToken('s', ['ss', 2], 0, 'second')
    addUnitAlias('second', 's')
    addUnitPriority('second', 15)
    addRegexToken('s', match1to2)
    addRegexToken('ss', match1to2, match2)
    addParseToken(['s', 'ss'], SECOND)
    var getSetSecond = makeGetSet('Seconds', false)
    addFormatToken('S', 0, 0, function () {
      return ~~(this.millisecond() / 100)
    })
    addFormatToken(0, ['SS', 2], 0, function () {
      return ~~(this.millisecond() / 10)
    })
    addFormatToken(0, ['SSS', 3], 0, 'millisecond')
    addFormatToken(0, ['SSSS', 4], 0, function () {
      return this.millisecond() * 10
    })
    addFormatToken(0, ['SSSSS', 5], 0, function () {
      return this.millisecond() * 100
    })
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
      return this.millisecond() * 1e3
    })
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
      return this.millisecond() * 1e4
    })
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
      return this.millisecond() * 1e5
    })
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
      return this.millisecond() * 1e6
    })
    addUnitAlias('millisecond', 'ms')
    addUnitPriority('millisecond', 16)
    addRegexToken('S', match1to3, match1)
    addRegexToken('SS', match1to3, match2)
    addRegexToken('SSS', match1to3, match3)
    var token, getSetMillisecond
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
      addRegexToken(token, matchUnsigned)
    }
    function parseMs(input, array) {
      array[MILLISECOND] = toInt(('0.' + input) * 1e3)
    }
    for (token = 'S'; token.length <= 9; token += 'S') {
      addParseToken(token, parseMs)
    }
    getSetMillisecond = makeGetSet('Milliseconds', false)
    addFormatToken('z', 0, 0, 'zoneAbbr')
    addFormatToken('zz', 0, 0, 'zoneName')
    function getZoneAbbr() {
      return this._isUTC ? 'UTC' : ''
    }
    function getZoneName() {
      return this._isUTC ? 'Coordinated Universal Time' : ''
    }
    var proto = Moment.prototype
    proto.add = add
    proto.calendar = calendar$1
    proto.clone = clone
    proto.diff = diff
    proto.endOf = endOf
    proto.format = format
    proto.from = from
    proto.fromNow = fromNow
    proto.to = to
    proto.toNow = toNow
    proto.get = stringGet
    proto.invalidAt = invalidAt
    proto.isAfter = isAfter
    proto.isBefore = isBefore
    proto.isBetween = isBetween
    proto.isSame = isSame
    proto.isSameOrAfter = isSameOrAfter
    proto.isSameOrBefore = isSameOrBefore
    proto.isValid = isValid$2
    proto.lang = lang
    proto.locale = locale
    proto.localeData = localeData
    proto.max = prototypeMax
    proto.min = prototypeMin
    proto.parsingFlags = parsingFlags
    proto.set = stringSet
    proto.startOf = startOf
    proto.subtract = subtract
    proto.toArray = toArray
    proto.toObject = toObject
    proto.toDate = toDate
    proto.toISOString = toISOString
    proto.inspect = inspect
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
      proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
        return 'Moment<' + this.format() + '>'
      }
    }
    proto.toJSON = toJSON
    proto.toString = toString
    proto.unix = unix
    proto.valueOf = valueOf
    proto.creationData = creationData
    proto.eraName = getEraName
    proto.eraNarrow = getEraNarrow
    proto.eraAbbr = getEraAbbr
    proto.eraYear = getEraYear
    proto.year = getSetYear
    proto.isLeapYear = getIsLeapYear
    proto.weekYear = getSetWeekYear
    proto.isoWeekYear = getSetISOWeekYear
    proto.quarter = proto.quarters = getSetQuarter
    proto.month = getSetMonth
    proto.daysInMonth = getDaysInMonth
    proto.week = proto.weeks = getSetWeek
    proto.isoWeek = proto.isoWeeks = getSetISOWeek
    proto.weeksInYear = getWeeksInYear
    proto.weeksInWeekYear = getWeeksInWeekYear
    proto.isoWeeksInYear = getISOWeeksInYear
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear
    proto.date = getSetDayOfMonth
    proto.day = proto.days = getSetDayOfWeek
    proto.weekday = getSetLocaleDayOfWeek
    proto.isoWeekday = getSetISODayOfWeek
    proto.dayOfYear = getSetDayOfYear
    proto.hour = proto.hours = getSetHour
    proto.minute = proto.minutes = getSetMinute
    proto.second = proto.seconds = getSetSecond
    proto.millisecond = proto.milliseconds = getSetMillisecond
    proto.utcOffset = getSetOffset
    proto.utc = setOffsetToUTC
    proto.local = setOffsetToLocal
    proto.parseZone = setOffsetToParsedOffset
    proto.hasAlignedHourOffset = hasAlignedHourOffset
    proto.isDST = isDaylightSavingTime
    proto.isLocal = isLocal
    proto.isUtcOffset = isUtcOffset
    proto.isUtc = isUtc
    proto.isUTC = isUtc
    proto.zoneAbbr = getZoneAbbr
    proto.zoneName = getZoneName
    proto.dates = deprecate(
      'dates accessor is deprecated. Use date instead.',
      getSetDayOfMonth
    )
    proto.months = deprecate(
      'months accessor is deprecated. Use month instead',
      getSetMonth
    )
    proto.years = deprecate(
      'years accessor is deprecated. Use year instead',
      getSetYear
    )
    proto.zone = deprecate(
      'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
      getSetZone
    )
    proto.isDSTShifted = deprecate(
      'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
      isDaylightSavingTimeShifted
    )
    function createUnix(input) {
      return createLocal(input * 1e3)
    }
    function createInZone() {
      return createLocal.apply(null, arguments).parseZone()
    }
    function preParsePostFormat(string) {
      return string
    }
    var proto$1 = Locale.prototype
    proto$1.calendar = calendar
    proto$1.longDateFormat = longDateFormat
    proto$1.invalidDate = invalidDate
    proto$1.ordinal = ordinal
    proto$1.preparse = preParsePostFormat
    proto$1.postformat = preParsePostFormat
    proto$1.relativeTime = relativeTime
    proto$1.pastFuture = pastFuture
    proto$1.set = set
    proto$1.eras = localeEras
    proto$1.erasParse = localeErasParse
    proto$1.erasConvertYear = localeErasConvertYear
    proto$1.erasAbbrRegex = erasAbbrRegex
    proto$1.erasNameRegex = erasNameRegex
    proto$1.erasNarrowRegex = erasNarrowRegex
    proto$1.months = localeMonths
    proto$1.monthsShort = localeMonthsShort
    proto$1.monthsParse = localeMonthsParse
    proto$1.monthsRegex = monthsRegex
    proto$1.monthsShortRegex = monthsShortRegex
    proto$1.week = localeWeek
    proto$1.firstDayOfYear = localeFirstDayOfYear
    proto$1.firstDayOfWeek = localeFirstDayOfWeek
    proto$1.weekdays = localeWeekdays
    proto$1.weekdaysMin = localeWeekdaysMin
    proto$1.weekdaysShort = localeWeekdaysShort
    proto$1.weekdaysParse = localeWeekdaysParse
    proto$1.weekdaysRegex = weekdaysRegex
    proto$1.weekdaysShortRegex = weekdaysShortRegex
    proto$1.weekdaysMinRegex = weekdaysMinRegex
    proto$1.isPM = localeIsPM
    proto$1.meridiem = localeMeridiem
    function get$1(format, index, field, setter) {
      var locale = getLocale(),
        utc = createUTC().set(setter, index)
      return locale[field](utc, format)
    }
    function listMonthsImpl(format, index, field) {
      if (isNumber(format)) {
        index = format
        format = undefined
      }
      format = format || ''
      if (index != null) {
        return get$1(format, index, field, 'month')
      }
      var i,
        out = []
      for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month')
      }
      return out
    }
    function listWeekdaysImpl(localeSorted, format, index, field) {
      if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
          index = format
          format = undefined
        }
        format = format || ''
      } else {
        format = localeSorted
        index = format
        localeSorted = false
        if (isNumber(format)) {
          index = format
          format = undefined
        }
        format = format || ''
      }
      var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0,
        i,
        out = []
      if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day')
      }
      for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day')
      }
      return out
    }
    function listMonths(format, index) {
      return listMonthsImpl(format, index, 'months')
    }
    function listMonthsShort(format, index) {
      return listMonthsImpl(format, index, 'monthsShort')
    }
    function listWeekdays(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdays')
    }
    function listWeekdaysShort(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort')
    }
    function listWeekdaysMin(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin')
    }
    getSetGlobalLocale('en', {
      eras: [
        {
          since: '0001-01-01',
          until: +Infinity,
          offset: 1,
          name: 'Anno Domini',
          narrow: 'AD',
          abbr: 'AD',
        },
        {
          since: '0000-12-31',
          until: -Infinity,
          offset: 1,
          name: 'Before Christ',
          narrow: 'BC',
          abbr: 'BC',
        },
      ],
      dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
      ordinal: function (number) {
        var b = number % 10,
          output =
            toInt((number % 100) / 10) === 1
              ? 'th'
              : b === 1
                ? 'st'
                : b === 2
                  ? 'nd'
                  : b === 3
                    ? 'rd'
                    : 'th'
        return number + output
      },
    })
    hooks.lang = deprecate(
      'moment.lang is deprecated. Use moment.locale instead.',
      getSetGlobalLocale
    )
    hooks.langData = deprecate(
      'moment.langData is deprecated. Use moment.localeData instead.',
      getLocale
    )
    var mathAbs = Math.abs
    function abs() {
      var data = this._data
      this._milliseconds = mathAbs(this._milliseconds)
      this._days = mathAbs(this._days)
      this._months = mathAbs(this._months)
      data.milliseconds = mathAbs(data.milliseconds)
      data.seconds = mathAbs(data.seconds)
      data.minutes = mathAbs(data.minutes)
      data.hours = mathAbs(data.hours)
      data.months = mathAbs(data.months)
      data.years = mathAbs(data.years)
      return this
    }
    function addSubtract$1(duration, input, value, direction) {
      var other = createDuration(input, value)
      duration._milliseconds += direction * other._milliseconds
      duration._days += direction * other._days
      duration._months += direction * other._months
      return duration._bubble()
    }
    function add$1(input, value) {
      return addSubtract$1(this, input, value, 1)
    }
    function subtract$1(input, value) {
      return addSubtract$1(this, input, value, -1)
    }
    function absCeil(number) {
      if (number < 0) {
        return Math.floor(number)
      } else {
        return Math.ceil(number)
      }
    }
    function bubble() {
      var milliseconds = this._milliseconds,
        days = this._days,
        months = this._months,
        data = this._data,
        seconds,
        minutes,
        hours,
        years,
        monthsFromDays
      if (
        !(
          (milliseconds >= 0 && days >= 0 && months >= 0) ||
          (milliseconds <= 0 && days <= 0 && months <= 0)
        )
      ) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5
        days = 0
        months = 0
      }
      data.milliseconds = milliseconds % 1e3
      seconds = absFloor(milliseconds / 1e3)
      data.seconds = seconds % 60
      minutes = absFloor(seconds / 60)
      data.minutes = minutes % 60
      hours = absFloor(minutes / 60)
      data.hours = hours % 24
      days += absFloor(hours / 24)
      monthsFromDays = absFloor(daysToMonths(days))
      months += monthsFromDays
      days -= absCeil(monthsToDays(monthsFromDays))
      years = absFloor(months / 12)
      months %= 12
      data.days = days
      data.months = months
      data.years = years
      return this
    }
    function daysToMonths(days) {
      return (days * 4800) / 146097
    }
    function monthsToDays(months) {
      return (months * 146097) / 4800
    }
    function as(units) {
      if (!this.isValid()) {
        return NaN
      }
      var days,
        months,
        milliseconds = this._milliseconds
      units = normalizeUnits(units)
      if (units === 'month' || units === 'quarter' || units === 'year') {
        days = this._days + milliseconds / 864e5
        months = this._months + daysToMonths(days)
        switch (units) {
          case 'month':
            return months

          case 'quarter':
            return months / 3

          case 'year':
            return months / 12
        }
      } else {
        days = this._days + Math.round(monthsToDays(this._months))
        switch (units) {
          case 'week':
            return days / 7 + milliseconds / 6048e5

          case 'day':
            return days + milliseconds / 864e5

          case 'hour':
            return days * 24 + milliseconds / 36e5

          case 'minute':
            return days * 1440 + milliseconds / 6e4

          case 'second':
            return days * 86400 + milliseconds / 1e3

          case 'millisecond':
            return Math.floor(days * 864e5) + milliseconds

          default:
            throw new Error('Unknown unit ' + units)
        }
      }
    }
    function valueOf$1() {
      if (!this.isValid()) {
        return NaN
      }
      return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
      )
    }
    function makeAs(alias) {
      return function () {
        return this.as(alias)
      }
    }
    var asMilliseconds = makeAs('ms'),
      asSeconds = makeAs('s'),
      asMinutes = makeAs('m'),
      asHours = makeAs('h'),
      asDays = makeAs('d'),
      asWeeks = makeAs('w'),
      asMonths = makeAs('M'),
      asQuarters = makeAs('Q'),
      asYears = makeAs('y')
    function clone$1() {
      return createDuration(this)
    }
    function get$2(units) {
      units = normalizeUnits(units)
      return this.isValid() ? this[units + 's']() : NaN
    }
    function makeGetter(name) {
      return function () {
        return this.isValid() ? this._data[name] : NaN
      }
    }
    var milliseconds = makeGetter('milliseconds'),
      seconds = makeGetter('seconds'),
      minutes = makeGetter('minutes'),
      hours = makeGetter('hours'),
      days = makeGetter('days'),
      months = makeGetter('months'),
      years = makeGetter('years')
    function weeks() {
      return absFloor(this.days() / 7)
    }
    var round = Math.round,
      thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11,
      }
    function substituteTimeAgo(
      string,
      number,
      withoutSuffix,
      isFuture,
      locale
    ) {
      return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture)
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
      var duration = createDuration(posNegDuration).abs(),
        seconds = round(duration.as('s')),
        minutes = round(duration.as('m')),
        hours = round(duration.as('h')),
        days = round(duration.as('d')),
        months = round(duration.as('M')),
        weeks = round(duration.as('w')),
        years = round(duration.as('y')),
        a =
          (seconds <= thresholds.ss && ['s', seconds]) ||
          (seconds < thresholds.s && ['ss', seconds]) ||
          (minutes <= 1 && ['m']) ||
          (minutes < thresholds.m && ['mm', minutes]) ||
          (hours <= 1 && ['h']) ||
          (hours < thresholds.h && ['hh', hours]) ||
          (days <= 1 && ['d']) ||
          (days < thresholds.d && ['dd', days])
      if (thresholds.w != null) {
        a =
          a || (weeks <= 1 && ['w']) || (weeks < thresholds.w && ['ww', weeks])
      }
      a = a ||
        (months <= 1 && ['M']) ||
        (months < thresholds.M && ['MM', months]) ||
        (years <= 1 && ['y']) || ['yy', years]
      a[2] = withoutSuffix
      a[3] = +posNegDuration > 0
      a[4] = locale
      return substituteTimeAgo.apply(null, a)
    }
    function getSetRelativeTimeRounding(roundingFunction) {
      if (roundingFunction === undefined) {
        return round
      }
      if (typeof roundingFunction === 'function') {
        round = roundingFunction
        return true
      }
      return false
    }
    function getSetRelativeTimeThreshold(threshold, limit) {
      if (thresholds[threshold] === undefined) {
        return false
      }
      if (limit === undefined) {
        return thresholds[threshold]
      }
      thresholds[threshold] = limit
      if (threshold === 's') {
        thresholds.ss = limit - 1
      }
      return true
    }
    function humanize(argWithSuffix, argThresholds) {
      if (!this.isValid()) {
        return this.localeData().invalidDate()
      }
      var withSuffix = false,
        th = thresholds,
        locale,
        output
      if (typeof argWithSuffix === 'object') {
        argThresholds = argWithSuffix
        argWithSuffix = false
      }
      if (typeof argWithSuffix === 'boolean') {
        withSuffix = argWithSuffix
      }
      if (typeof argThresholds === 'object') {
        th = Object.assign({}, thresholds, argThresholds)
        if (argThresholds.s != null && argThresholds.ss == null) {
          th.ss = argThresholds.s - 1
        }
      }
      locale = this.localeData()
      output = relativeTime$1(this, !withSuffix, th, locale)
      if (withSuffix) {
        output = locale.pastFuture(+this, output)
      }
      return locale.postformat(output)
    }
    var abs$1 = Math.abs
    function sign(x) {
      return (x > 0) - (x < 0) || +x
    }
    function toISOString$1() {
      if (!this.isValid()) {
        return this.localeData().invalidDate()
      }
      var seconds = abs$1(this._milliseconds) / 1e3,
        days = abs$1(this._days),
        months = abs$1(this._months),
        minutes,
        hours,
        years,
        s,
        total = this.asSeconds(),
        totalSign,
        ymSign,
        daysSign,
        hmsSign
      if (!total) {
        return 'P0D'
      }
      minutes = absFloor(seconds / 60)
      hours = absFloor(minutes / 60)
      seconds %= 60
      minutes %= 60
      years = absFloor(months / 12)
      months %= 12
      s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : ''
      totalSign = total < 0 ? '-' : ''
      ymSign = sign(this._months) !== sign(total) ? '-' : ''
      daysSign = sign(this._days) !== sign(total) ? '-' : ''
      hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : ''
      return (
        totalSign +
        'P' +
        (years ? ymSign + years + 'Y' : '') +
        (months ? ymSign + months + 'M' : '') +
        (days ? daysSign + days + 'D' : '') +
        (hours || minutes || seconds ? 'T' : '') +
        (hours ? hmsSign + hours + 'H' : '') +
        (minutes ? hmsSign + minutes + 'M' : '') +
        (seconds ? hmsSign + s + 'S' : '')
      )
    }
    var proto$2 = Duration.prototype
    proto$2.isValid = isValid$1
    proto$2.abs = abs
    proto$2.add = add$1
    proto$2.subtract = subtract$1
    proto$2.as = as
    proto$2.asMilliseconds = asMilliseconds
    proto$2.asSeconds = asSeconds
    proto$2.asMinutes = asMinutes
    proto$2.asHours = asHours
    proto$2.asDays = asDays
    proto$2.asWeeks = asWeeks
    proto$2.asMonths = asMonths
    proto$2.asQuarters = asQuarters
    proto$2.asYears = asYears
    proto$2.valueOf = valueOf$1
    proto$2._bubble = bubble
    proto$2.clone = clone$1
    proto$2.get = get$2
    proto$2.milliseconds = milliseconds
    proto$2.seconds = seconds
    proto$2.minutes = minutes
    proto$2.hours = hours
    proto$2.days = days
    proto$2.weeks = weeks
    proto$2.months = months
    proto$2.years = years
    proto$2.humanize = humanize
    proto$2.toISOString = toISOString$1
    proto$2.toString = toISOString$1
    proto$2.toJSON = toISOString$1
    proto$2.locale = locale
    proto$2.localeData = localeData
    proto$2.toIsoString = deprecate(
      'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
      toISOString$1
    )
    proto$2.lang = lang
    addFormatToken('X', 0, 0, 'unix')
    addFormatToken('x', 0, 0, 'valueOf')
    addRegexToken('x', matchSigned)
    addRegexToken('X', matchTimestamp)
    addParseToken('X', function (input, array, config) {
      config._d = new Date(parseFloat(input) * 1e3)
    })
    addParseToken('x', function (input, array, config) {
      config._d = new Date(toInt(input))
    })
    hooks.version = '2.29.1'
    setHookCallback(createLocal)
    hooks.fn = proto
    hooks.min = min
    hooks.max = max
    hooks.now = now
    hooks.utc = createUTC
    hooks.unix = createUnix
    hooks.months = listMonths
    hooks.isDate = isDate
    hooks.locale = getSetGlobalLocale
    hooks.invalid = createInvalid
    hooks.duration = createDuration
    hooks.isMoment = isMoment
    hooks.weekdays = listWeekdays
    hooks.parseZone = createInZone
    hooks.localeData = getLocale
    hooks.isDuration = isDuration
    hooks.monthsShort = listMonthsShort
    hooks.weekdaysMin = listWeekdaysMin
    hooks.defineLocale = defineLocale
    hooks.updateLocale = updateLocale
    hooks.locales = listLocales
    hooks.weekdaysShort = listWeekdaysShort
    hooks.normalizeUnits = normalizeUnits
    hooks.relativeTimeRounding = getSetRelativeTimeRounding
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold
    hooks.calendarFormat = getCalendarFormat
    hooks.prototype = proto
    hooks.HTML5_FMT = {
      DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
      DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
      DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
      DATE: 'YYYY-MM-DD',
      TIME: 'HH:mm',
      TIME_SECONDS: 'HH:mm:ss',
      TIME_MS: 'HH:mm:ss.SSS',
      WEEK: 'GGGG-[W]WW',
      MONTH: 'YYYY-MM',
    }
    return hooks
  })
})(moment)
;(function (module) {
  if (typeof commonjsRequire === 'function') {
    var moment$1 = moment.exports
  }
  moment$1.fn.isHoliday = function () {
    var locale = this.localeData()
    if (locale._holidays) {
      if (locale._holidays.indexOf(this.format(locale._holidayFormat)) >= 0)
        return true
    }
    if (locale.holiday) {
      if (locale.holiday(this)) {
        return true
      }
      return false
    }
    return false
  }
  moment$1.fn.isBusinessDay = function () {
    var locale = this.localeData()
    var defaultWorkingWeekdays = [1, 2, 3, 4, 5]
    var workingWeekdays = locale._workingWeekdays || defaultWorkingWeekdays
    if (this.isHoliday()) return false
    if (workingWeekdays.indexOf(this.day()) >= 0) return true
    return false
  }
  moment$1.fn.businessDaysIntoMonth = function () {
    if (!this.isValid()) {
      return NaN
    }
    var businessDay = this.isBusinessDay() ? this : this.prevBusinessDay()
    var monthBusinessDays = businessDay.monthBusinessDays()
    var businessDaysIntoMonth
    monthBusinessDays.map(function (day, index) {
      if (day.format('M/DD/YY') === businessDay.format('M/DD/YY')) {
        businessDaysIntoMonth = index + 1
      }
    })
    return businessDaysIntoMonth
  }
  moment$1.fn.businessDiff = function (param, relative) {
    var d1 = this.clone()
    var d2 = param.clone()
    var positive = d1 >= d2
    var start = d1 < d2 ? d1 : d2
    var end = d2 > d1 ? d2 : d1
    var daysBetween = 0
    if (start.format('DD/MM/YYYY') === end.format('DD/MM/YYYY')) {
      return daysBetween
    }
    while (start < end) {
      if (start.isBusinessDay()) {
        daysBetween++
      }
      start.add(1, 'd')
    }
    if (relative) {
      return positive ? daysBetween : -daysBetween
    }
    return daysBetween
  }
  moment$1.fn.businessAdd = function (number, period) {
    var day = this.clone()
    if (!day.isValid()) {
      return day
    }
    if (number < 0) {
      number = Math.round(-1 * number) * -1
    } else {
      number = Math.round(number)
    }
    var signal = number < 0 ? -1 : 1
    period = typeof period !== 'undefined' ? period : 'days'
    var remaining = Math.abs(number)
    while (remaining > 0) {
      day.add(signal, period)
      if (day.isBusinessDay()) {
        remaining--
      }
    }
    return day
  }
  moment$1.fn.businessSubtract = function (number, period) {
    return this.businessAdd(-number, period)
  }
  moment$1.fn.nextBusinessDay = function () {
    var locale = this.localeData()
    var loop = 1
    var defaultNextBusinessDayLimit = 7
    var limit = locale._nextBusinessDayLimit || defaultNextBusinessDayLimit
    while (loop < limit) {
      if (this.add(1, 'd').isBusinessDay()) {
        break
      }
      loop++
    }
    return this
  }
  moment$1.fn.prevBusinessDay = function () {
    var locale = this.localeData()
    var loop = 1
    var defaultPrevBusinessDayLimit = 7
    var limit = locale._prevBusinessDayLimit || defaultPrevBusinessDayLimit
    while (loop < limit) {
      if (this.subtract(1, 'd').isBusinessDay()) {
        break
      }
      loop++
    }
    return this
  }
  moment$1.fn.monthBusinessDays = function (partialEndDate) {
    if (!this.isValid()) {
      return []
    }
    var me = this.clone()
    var day = me.clone().startOf('month')
    var end = partialEndDate ? partialEndDate : me.clone().endOf('month')
    var daysArr = []
    var done = false
    while (!done) {
      if (day.isBusinessDay()) {
        daysArr.push(day.clone())
      }
      if (end.diff(day.add(1, 'd')) < 0) {
        done = true
      }
    }
    return daysArr
  }
  moment$1.fn.monthNaturalDays = function (fromToday) {
    if (!this.isValid()) {
      return []
    }
    var me = this.clone()
    var day = fromToday ? me.clone() : me.clone().startOf('month')
    var end = me.clone().endOf('month')
    var daysArr = []
    var done = false
    while (!done) {
      daysArr.push(day.clone())
      if (end.diff(day.add(1, 'd')) < 0) {
        done = true
      }
    }
    return daysArr
  }
  moment$1.fn.monthBusinessWeeks = function (fromToday) {
    fromToday = fromToday || false
    var me = this.clone()
    var startDate = fromToday ? me.clone() : me.clone().startOf('month')
    return getBusinessWeeks(this, fromToday, null, startDate)
  }
  moment$1.fn.businessWeeksBetween = function (endDate) {
    var me = this.clone()
    var startDate = me.clone()
    return getBusinessWeeks(this, false, endDate, startDate)
  }
  var getBusinessWeeks = function (self, fromToday, endDate, startDate) {
    if (!self.isValid()) {
      return []
    }
    var me = self.clone()
    var day = startDate
    var end = endDate ? moment$1(endDate).clone() : me.clone().endOf('month')
    var weeksArr = []
    var daysArr = []
    var done = false
    while (!done) {
      if (day.day() >= 1 && day.day() < 6) {
        daysArr.push(day.clone())
      }
      if (day.day() === 5) {
        weeksArr.push(daysArr)
        daysArr = []
      }
      if (end.diff(day.add(1, 'd')) < 0) {
        if (daysArr.length < 5) {
          weeksArr.push(daysArr)
        }
        done = true
      }
    }
    return weeksArr
  }
  moment$1.fn.monthNaturalWeeks = function (fromToday) {
    if (!this.isValid()) {
      return []
    }
    var me = this.clone()
    var day = fromToday ? me.clone() : me.clone().startOf('month')
    var end = me.clone().endOf('month')
    var weeksArr = []
    var daysArr = []
    var done = false
    while (!done) {
      daysArr.push(day.clone())
      if (day.day() === 6) {
        weeksArr.push(daysArr)
        daysArr = []
      }
      if (end.diff(day.add(1, 'd')) < 0) {
        if (daysArr.length < 7) {
          weeksArr.push(daysArr)
        }
        done = true
      }
    }
    return weeksArr
  }
  if (module.exports) {
    module.exports = moment$1
  }
})(momentBusinessDays)
var momentBusiness = momentBusinessDays.exports
const MOMENT_FORMAT_NP_ISO = 'YYYY-MM-DD'
const MOMENT_FORMAT_NP_DAY = 'YYYYMMDD'
const MOMENT_FORMAT_NP_MONTH = 'YYYY-MM'
const MOMENT_FORMAT_NP_QUARTER = 'YYYY-[Q]Q'
const RE_DATE = '\\d{4}-[01]\\d-[0123]\\d'
const RE_YYYYMMDD_DATE = '\\d{4}[01]\\d[0123]\\d'
const RE_FILE_EXTENSIONS_GROUP = '\\.(md|txt)$'
const RE_DAILY_NOTE_FILENAME = '(^|\\/)'
  .concat(RE_YYYYMMDD_DATE)
  .concat(RE_FILE_EXTENSIONS_GROUP)
const RE_NP_WEEK_SPEC = '\\d{4}\\-W[0-5]\\d'
const RE_WEEKLY_NOTE_FILENAME = '(^|\\/)'
  .concat(RE_NP_WEEK_SPEC)
  .concat(RE_FILE_EXTENSIONS_GROUP)
const RE_NP_MONTH_SPEC = '\\d{4}-[01]\\d(?![\\d-])'
const RE_MONTHLY_NOTE_FILENAME = '(^|\\/)'
  .concat(RE_NP_MONTH_SPEC)
  .concat(RE_FILE_EXTENSIONS_GROUP)
const RE_NP_QUARTER_SPEC = '\\d{4}\\-Q[1-4](?!\\d)'
const RE_QUARTERLY_NOTE_FILENAME = '(^|\\/)'
  .concat(RE_NP_QUARTER_SPEC)
  .concat(RE_FILE_EXTENSIONS_GROUP)
const RE_NP_YEAR_SPEC = '\\d{4}(?![\\d-])'
const RE_YEARLY_NOTE_FILENAME = '(^|\\/)'
  .concat(RE_NP_YEAR_SPEC)
  .concat(RE_FILE_EXTENSIONS_GROUP)
const RE_DATE_INTERVAL = '[+\\-]?\\d+[BbDdWwMmQqYy]'
moment$1().format('YYYY-MM-DD')
const getFormattedTime = function () {
  let format =
    arguments.length > 0 && arguments[0] !== undefined
      ? arguments[0]
      : '%Y-%m-%d %I:%M:%S %P'
  return strftime(format)
}
moment$1().toISOString().replace('T', ' ').slice(0, 16)
function hyphenatedDate(date) {
  if (date != null) {
    return toLocaleDateString(date, 'sv-SE')
  } else {
    return 'hyphenatedDate: error: not a valid JS Date'
  }
}
function toLocaleDateString(dateObj) {
  let locale =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : []
  let options =
    arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}
  return dateObj.toLocaleDateString(locale, options)
}
function getDateStringFromCalendarFilename(filename) {
  let returnISODate =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false
  try {
    if (filename.match(RE_DAILY_NOTE_FILENAME)) {
      if (returnISODate) {
        return getISODateStringFromYYYYMMDD(filename)
      } else {
        return filename.slice(0, 8)
      }
    } else if (filename.match(RE_WEEKLY_NOTE_FILENAME)) {
      return filename.slice(0, 8)
    } else if (filename.match(RE_MONTHLY_NOTE_FILENAME)) {
      return filename.slice(0, 7)
    } else if (filename.match(RE_QUARTERLY_NOTE_FILENAME)) {
      return filename.slice(0, 7)
    } else if (filename.match(RE_YEARLY_NOTE_FILENAME)) {
      return filename.slice(0, 4)
    } else {
      throw new Error('Invalid calendar filename: '.concat(filename))
    }
  } catch (err) {
    logError('dateTime / getDateStringFromCalendarFilename', err.message)
    return '(invalid date)'
  }
}
function getISODateStringFromYYYYMMDD(filename) {
  if (filename.match(/^\d{8}/)) {
    return ''
      .concat(filename.slice(0, 4), '-')
      .concat(filename.slice(4, 6), '-')
      .concat(filename.slice(6, 8))
  } else {
    return '(not a YYYYMMDD date)'
  }
}
async function parseJSON5$1(contents) {
  try {
    const value = json5.parse(contents)
    return value
  } catch (err) {
    logError('general/parseJSON5()', err.message)
    return {}
  }
}
function displayTitle(n) {
  var _getDateStringFromCal, _n$title
  return !n
    ? '(error)'
    : n.type === 'Calendar'
      ? (_getDateStringFromCal = getDateStringFromCalendarFilename(
          n.filename
        )) !== null && _getDateStringFromCal !== void 0
        ? _getDateStringFromCal
        : ''
      : (_n$title = n.title) !== null && _n$title !== void 0
        ? _n$title
        : '(error)'
}
function stringReplace() {
  let inputString =
    arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
  let replacementArray = arguments.length > 1 ? arguments[1] : undefined
  let outputString = inputString
  replacementArray.forEach((r) => {
    outputString = outputString.replace(r.key, r.value)
  })
  return outputString
}
function semverVersionToNumber(version) {
  const parts = version.split('.')
  if (parts.length < 3) {
    parts.push('0')
    if (parts.length < 3) {
      parts.push('0')
    }
  }
  for (const part of parts) {
    const foundPart = parseInt(part, 10)
    if (Number.isNaN(foundPart) || foundPart >= 1024) {
      throw new Error('Version string invalid, '.concat(part, ' is too large'))
    }
  }
  let numericVersion = 0
  for (let i = 0; i < 3; i++) {
    numericVersion |= parseInt(parts[i]) << (i * 10)
  }
  return numericVersion
}
var frontMatter = {
  exports: {},
}
var jsYaml$1 = {}
var loader$1 = {}
var common$6 = {}
function isNothing(subject) {
  return typeof subject === 'undefined' || subject === null
}
function isObject$3(subject) {
  return typeof subject === 'object' && subject !== null
}
function toArray(sequence) {
  if (Array.isArray(sequence)) return sequence
  else if (isNothing(sequence)) return []
  return [sequence]
}
function extend(target, source) {
  var index, length, key, sourceKeys
  if (source) {
    sourceKeys = Object.keys(source)
    for (index = 0, length = sourceKeys.length; index < length; index += 1) {
      key = sourceKeys[index]
      target[key] = source[key]
    }
  }
  return target
}
function repeat(string, count) {
  var result = '',
    cycle
  for (cycle = 0; cycle < count; cycle += 1) {
    result += string
  }
  return result
}
function isNegativeZero(number) {
  return number === 0 && Number.NEGATIVE_INFINITY === 1 / number
}
common$6.isNothing = isNothing
common$6.isObject = isObject$3
common$6.toArray = toArray
common$6.repeat = repeat
common$6.isNegativeZero = isNegativeZero
common$6.extend = extend
function YAMLException$4(reason, mark) {
  Error.call(this)
  this.name = 'YAMLException'
  this.reason = reason
  this.mark = mark
  this.message =
    (this.reason || '(unknown reason)') +
    (this.mark ? ' ' + this.mark.toString() : '')
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor)
  } else {
    this.stack = new Error().stack || ''
  }
}
YAMLException$4.prototype = Object.create(Error.prototype)
YAMLException$4.prototype.constructor = YAMLException$4
YAMLException$4.prototype.toString = function toString(compact) {
  var result = this.name + ': '
  result += this.reason || '(unknown reason)'
  if (!compact && this.mark) {
    result += ' ' + this.mark.toString()
  }
  return result
}
var exception = YAMLException$4
var common$5 = common$6
function Mark$1(name, buffer, position, line, column) {
  this.name = name
  this.buffer = buffer
  this.position = position
  this.line = line
  this.column = column
}
Mark$1.prototype.getSnippet = function getSnippet(indent, maxLength) {
  var head, start, tail, end, snippet
  if (!this.buffer) return null
  indent = indent || 4
  maxLength = maxLength || 75
  head = ''
  start = this.position
  while (
    start > 0 &&
    '\0\r\n\u2028\u2029'.indexOf(this.buffer.charAt(start - 1)) === -1
  ) {
    start -= 1
    if (this.position - start > maxLength / 2 - 1) {
      head = ' ... '
      start += 5
      break
    }
  }
  tail = ''
  end = this.position
  while (
    end < this.buffer.length &&
    '\0\r\n\u2028\u2029'.indexOf(this.buffer.charAt(end)) === -1
  ) {
    end += 1
    if (end - this.position > maxLength / 2 - 1) {
      tail = ' ... '
      end -= 5
      break
    }
  }
  snippet = this.buffer.slice(start, end)
  return (
    common$5.repeat(' ', indent) +
    head +
    snippet +
    tail +
    '\n' +
    common$5.repeat(' ', indent + this.position - start + head.length) +
    '^'
  )
}
Mark$1.prototype.toString = function toString(compact) {
  var snippet,
    where = ''
  if (this.name) {
    where += 'in "' + this.name + '" '
  }
  where += 'at line ' + (this.line + 1) + ', column ' + (this.column + 1)
  if (!compact) {
    snippet = this.getSnippet()
    if (snippet) {
      where += ':\n' + snippet
    }
  }
  return where
}
var mark = Mark$1
var YAMLException$3 = exception
var TYPE_CONSTRUCTOR_OPTIONS = [
  'kind',
  'resolve',
  'construct',
  'instanceOf',
  'predicate',
  'represent',
  'defaultStyle',
  'styleAliases',
]
var YAML_NODE_KINDS = ['scalar', 'sequence', 'mapping']
function compileStyleAliases(map) {
  var result = {}
  if (map !== null) {
    Object.keys(map).forEach(function (style) {
      map[style].forEach(function (alias) {
        result[String(alias)] = style
      })
    })
  }
  return result
}
function Type$h(tag, options) {
  options = options || {}
  Object.keys(options).forEach(function (name) {
    if (TYPE_CONSTRUCTOR_OPTIONS.indexOf(name) === -1) {
      throw new YAMLException$3(
        'Unknown option "' +
          name +
          '" is met in definition of "' +
          tag +
          '" YAML type.'
      )
    }
  })
  this.tag = tag
  this.kind = options['kind'] || null
  this.resolve =
    options['resolve'] ||
    function () {
      return true
    }
  this.construct =
    options['construct'] ||
    function (data) {
      return data
    }
  this.instanceOf = options['instanceOf'] || null
  this.predicate = options['predicate'] || null
  this.represent = options['represent'] || null
  this.defaultStyle = options['defaultStyle'] || null
  this.styleAliases = compileStyleAliases(options['styleAliases'] || null)
  if (YAML_NODE_KINDS.indexOf(this.kind) === -1) {
    throw new YAMLException$3(
      'Unknown kind "' +
        this.kind +
        '" is specified for "' +
        tag +
        '" YAML type.'
    )
  }
}
var type = Type$h
var common$4 = common$6
var YAMLException$2 = exception
var Type$g = type
function compileList(schema, name, result) {
  var exclude = []
  schema.include.forEach(function (includedSchema) {
    result = compileList(includedSchema, name, result)
  })
  schema[name].forEach(function (currentType) {
    result.forEach(function (previousType, previousIndex) {
      if (
        previousType.tag === currentType.tag &&
        previousType.kind === currentType.kind
      ) {
        exclude.push(previousIndex)
      }
    })
    result.push(currentType)
  })
  return result.filter(function (type, index) {
    return exclude.indexOf(index) === -1
  })
}
function compileMap() {
  var result = {
      scalar: {},
      sequence: {},
      mapping: {},
      fallback: {},
    },
    index,
    length
  function collectType(type) {
    result[type.kind][type.tag] = result['fallback'][type.tag] = type
  }
  for (index = 0, length = arguments.length; index < length; index += 1) {
    arguments[index].forEach(collectType)
  }
  return result
}
function Schema$5(definition) {
  this.include = definition.include || []
  this.implicit = definition.implicit || []
  this.explicit = definition.explicit || []
  this.implicit.forEach(function (type) {
    if (type.loadKind && type.loadKind !== 'scalar') {
      throw new YAMLException$2(
        'There is a non-scalar type in the implicit list of a schema. Implicit resolving of such types is not supported.'
      )
    }
  })
  this.compiledImplicit = compileList(this, 'implicit', [])
  this.compiledExplicit = compileList(this, 'explicit', [])
  this.compiledTypeMap = compileMap(
    this.compiledImplicit,
    this.compiledExplicit
  )
}
Schema$5.DEFAULT = null
Schema$5.create = function createSchema() {
  var schemas, types
  switch (arguments.length) {
    case 1:
      schemas = Schema$5.DEFAULT
      types = arguments[0]
      break

    case 2:
      schemas = arguments[0]
      types = arguments[1]
      break

    default:
      throw new YAMLException$2(
        'Wrong number of arguments for Schema.create function'
      )
  }
  schemas = common$4.toArray(schemas)
  types = common$4.toArray(types)
  if (
    !schemas.every(function (schema) {
      return schema instanceof Schema$5
    })
  ) {
    throw new YAMLException$2(
      'Specified list of super schemas (or a single Schema object) contains a non-Schema object.'
    )
  }
  if (
    !types.every(function (type) {
      return type instanceof Type$g
    })
  ) {
    throw new YAMLException$2(
      'Specified list of YAML types (or a single Type object) contains a non-Type object.'
    )
  }
  return new Schema$5({
    include: schemas,
    explicit: types,
  })
}
var schema = Schema$5
var Type$f = type
var str = new Type$f('tag:yaml.org,2002:str', {
  kind: 'scalar',
  construct: function (data) {
    return data !== null ? data : ''
  },
})
var Type$e = type
var seq = new Type$e('tag:yaml.org,2002:seq', {
  kind: 'sequence',
  construct: function (data) {
    return data !== null ? data : []
  },
})
var Type$d = type
var map = new Type$d('tag:yaml.org,2002:map', {
  kind: 'mapping',
  construct: function (data) {
    return data !== null ? data : {}
  },
})
var Schema$4 = schema
var failsafe = new Schema$4({
  explicit: [str, seq, map],
})
var Type$c = type
function resolveYamlNull(data) {
  if (data === null) return true
  var max = data.length
  return (
    (max === 1 && data === '~') ||
    (max === 4 && (data === 'null' || data === 'Null' || data === 'NULL'))
  )
}
function constructYamlNull() {
  return null
}
function isNull(object) {
  return object === null
}
var _null = new Type$c('tag:yaml.org,2002:null', {
  kind: 'scalar',
  resolve: resolveYamlNull,
  construct: constructYamlNull,
  predicate: isNull,
  represent: {
    canonical: function () {
      return '~'
    },
    lowercase: function () {
      return 'null'
    },
    uppercase: function () {
      return 'NULL'
    },
    camelcase: function () {
      return 'Null'
    },
  },
  defaultStyle: 'lowercase',
})
var Type$b = type
function resolveYamlBoolean(data) {
  if (data === null) return false
  var max = data.length
  return (
    (max === 4 && (data === 'true' || data === 'True' || data === 'TRUE')) ||
    (max === 5 && (data === 'false' || data === 'False' || data === 'FALSE'))
  )
}
function constructYamlBoolean(data) {
  return data === 'true' || data === 'True' || data === 'TRUE'
}
function isBoolean(object) {
  return Object.prototype.toString.call(object) === '[object Boolean]'
}
var bool = new Type$b('tag:yaml.org,2002:bool', {
  kind: 'scalar',
  resolve: resolveYamlBoolean,
  construct: constructYamlBoolean,
  predicate: isBoolean,
  represent: {
    lowercase: function (object) {
      return object ? 'true' : 'false'
    },
    uppercase: function (object) {
      return object ? 'TRUE' : 'FALSE'
    },
    camelcase: function (object) {
      return object ? 'True' : 'False'
    },
  },
  defaultStyle: 'lowercase',
})
var common$3 = common$6
var Type$a = type
function isHexCode(c) {
  return (48 <= c && c <= 57) || (65 <= c && c <= 70) || (97 <= c && c <= 102)
}
function isOctCode(c) {
  return 48 <= c && c <= 55
}
function isDecCode(c) {
  return 48 <= c && c <= 57
}
function resolveYamlInteger(data) {
  if (data === null) return false
  var max = data.length,
    index = 0,
    hasDigits = false,
    ch
  if (!max) return false
  ch = data[index]
  if (ch === '-' || ch === '+') {
    ch = data[++index]
  }
  if (ch === '0') {
    if (index + 1 === max) return true
    ch = data[++index]
    if (ch === 'b') {
      index++
      for (; index < max; index++) {
        ch = data[index]
        if (ch === '_') continue
        if (ch !== '0' && ch !== '1') return false
        hasDigits = true
      }
      return hasDigits && ch !== '_'
    }
    if (ch === 'x') {
      index++
      for (; index < max; index++) {
        ch = data[index]
        if (ch === '_') continue
        if (!isHexCode(data.charCodeAt(index))) return false
        hasDigits = true
      }
      return hasDigits && ch !== '_'
    }
    for (; index < max; index++) {
      ch = data[index]
      if (ch === '_') continue
      if (!isOctCode(data.charCodeAt(index))) return false
      hasDigits = true
    }
    return hasDigits && ch !== '_'
  }
  if (ch === '_') return false
  for (; index < max; index++) {
    ch = data[index]
    if (ch === '_') continue
    if (ch === ':') break
    if (!isDecCode(data.charCodeAt(index))) {
      return false
    }
    hasDigits = true
  }
  if (!hasDigits || ch === '_') return false
  if (ch !== ':') return true
  return /^(:[0-5]?[0-9])+$/.test(data.slice(index))
}
function constructYamlInteger(data) {
  var value = data,
    sign = 1,
    ch,
    base,
    digits = []
  if (value.indexOf('_') !== -1) {
    value = value.replace(/_/g, '')
  }
  ch = value[0]
  if (ch === '-' || ch === '+') {
    if (ch === '-') sign = -1
    value = value.slice(1)
    ch = value[0]
  }
  if (value === '0') return 0
  if (ch === '0') {
    if (value[1] === 'b') return sign * parseInt(value.slice(2), 2)
    if (value[1] === 'x') return sign * parseInt(value, 16)
    return sign * parseInt(value, 8)
  }
  if (value.indexOf(':') !== -1) {
    value.split(':').forEach(function (v) {
      digits.unshift(parseInt(v, 10))
    })
    value = 0
    base = 1
    digits.forEach(function (d) {
      value += d * base
      base *= 60
    })
    return sign * value
  }
  return sign * parseInt(value, 10)
}
function isInteger(object) {
  return (
    Object.prototype.toString.call(object) === '[object Number]' &&
    object % 1 === 0 &&
    !common$3.isNegativeZero(object)
  )
}
var int = new Type$a('tag:yaml.org,2002:int', {
  kind: 'scalar',
  resolve: resolveYamlInteger,
  construct: constructYamlInteger,
  predicate: isInteger,
  represent: {
    binary: function (obj) {
      return obj >= 0
        ? '0b' + obj.toString(2)
        : '-0b' + obj.toString(2).slice(1)
    },
    octal: function (obj) {
      return obj >= 0 ? '0' + obj.toString(8) : '-0' + obj.toString(8).slice(1)
    },
    decimal: function (obj) {
      return obj.toString(10)
    },
    hexadecimal: function (obj) {
      return obj >= 0
        ? '0x' + obj.toString(16).toUpperCase()
        : '-0x' + obj.toString(16).toUpperCase().slice(1)
    },
  },
  defaultStyle: 'decimal',
  styleAliases: {
    binary: [2, 'bin'],
    octal: [8, 'oct'],
    decimal: [10, 'dec'],
    hexadecimal: [16, 'hex'],
  },
})
var common$2 = common$6
var Type$9 = type
var YAML_FLOAT_PATTERN = new RegExp(
  '^(?:[-+]?(?:0|[1-9][0-9_]*)(?:\\.[0-9_]*)?(?:[eE][-+]?[0-9]+)?' +
    '|\\.[0-9_]+(?:[eE][-+]?[0-9]+)?' +
    '|[-+]?[0-9][0-9_]*(?::[0-5]?[0-9])+\\.[0-9_]*' +
    '|[-+]?\\.(?:inf|Inf|INF)' +
    '|\\.(?:nan|NaN|NAN))$'
)
function resolveYamlFloat(data) {
  if (data === null) return false
  if (!YAML_FLOAT_PATTERN.test(data) || data[data.length - 1] === '_') {
    return false
  }
  return true
}
function constructYamlFloat(data) {
  var value, sign, base, digits
  value = data.replace(/_/g, '').toLowerCase()
  sign = value[0] === '-' ? -1 : 1
  digits = []
  if ('+-'.indexOf(value[0]) >= 0) {
    value = value.slice(1)
  }
  if (value === '.inf') {
    return sign === 1 ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY
  } else if (value === '.nan') {
    return NaN
  } else if (value.indexOf(':') >= 0) {
    value.split(':').forEach(function (v) {
      digits.unshift(parseFloat(v, 10))
    })
    value = 0
    base = 1
    digits.forEach(function (d) {
      value += d * base
      base *= 60
    })
    return sign * value
  }
  return sign * parseFloat(value, 10)
}
var SCIENTIFIC_WITHOUT_DOT = /^[-+]?[0-9]+e/
function representYamlFloat(object, style) {
  var res
  if (isNaN(object)) {
    switch (style) {
      case 'lowercase':
        return '.nan'

      case 'uppercase':
        return '.NAN'

      case 'camelcase':
        return '.NaN'
    }
  } else if (Number.POSITIVE_INFINITY === object) {
    switch (style) {
      case 'lowercase':
        return '.inf'

      case 'uppercase':
        return '.INF'

      case 'camelcase':
        return '.Inf'
    }
  } else if (Number.NEGATIVE_INFINITY === object) {
    switch (style) {
      case 'lowercase':
        return '-.inf'

      case 'uppercase':
        return '-.INF'

      case 'camelcase':
        return '-.Inf'
    }
  } else if (common$2.isNegativeZero(object)) {
    return '-0.0'
  }
  res = object.toString(10)
  return SCIENTIFIC_WITHOUT_DOT.test(res) ? res.replace('e', '.e') : res
}
function isFloat(object) {
  return (
    Object.prototype.toString.call(object) === '[object Number]' &&
    (object % 1 !== 0 || common$2.isNegativeZero(object))
  )
}
var float = new Type$9('tag:yaml.org,2002:float', {
  kind: 'scalar',
  resolve: resolveYamlFloat,
  construct: constructYamlFloat,
  predicate: isFloat,
  represent: representYamlFloat,
  defaultStyle: 'lowercase',
})
var Schema$3 = schema
var json = new Schema$3({
  include: [failsafe],
  implicit: [_null, bool, int, float],
})
var Schema$2 = schema
var core = new Schema$2({
  include: [json],
})
var Type$8 = type
var YAML_DATE_REGEXP = new RegExp(
  '^([0-9][0-9][0-9][0-9])' + '-([0-9][0-9])' + '-([0-9][0-9])$'
)
var YAML_TIMESTAMP_REGEXP = new RegExp(
  '^([0-9][0-9][0-9][0-9])' +
    '-([0-9][0-9]?)' +
    '-([0-9][0-9]?)' +
    '(?:[Tt]|[ \\t]+)' +
    '([0-9][0-9]?)' +
    ':([0-9][0-9])' +
    ':([0-9][0-9])' +
    '(?:\\.([0-9]*))?' +
    '(?:[ \\t]*(Z|([-+])([0-9][0-9]?)' +
    '(?::([0-9][0-9]))?))?$'
)
function resolveYamlTimestamp(data) {
  if (data === null) return false
  if (YAML_DATE_REGEXP.exec(data) !== null) return true
  if (YAML_TIMESTAMP_REGEXP.exec(data) !== null) return true
  return false
}
function constructYamlTimestamp(data) {
  var match,
    year,
    month,
    day,
    hour,
    minute,
    second,
    fraction = 0,
    delta = null,
    tz_hour,
    tz_minute,
    date
  match = YAML_DATE_REGEXP.exec(data)
  if (match === null) match = YAML_TIMESTAMP_REGEXP.exec(data)
  if (match === null) throw new Error('Date resolve error')
  year = +match[1]
  month = +match[2] - 1
  day = +match[3]
  if (!match[4]) {
    return new Date(Date.UTC(year, month, day))
  }
  hour = +match[4]
  minute = +match[5]
  second = +match[6]
  if (match[7]) {
    fraction = match[7].slice(0, 3)
    while (fraction.length < 3) {
      fraction += '0'
    }
    fraction = +fraction
  }
  if (match[9]) {
    tz_hour = +match[10]
    tz_minute = +(match[11] || 0)
    delta = (tz_hour * 60 + tz_minute) * 6e4
    if (match[9] === '-') delta = -delta
  }
  date = new Date(Date.UTC(year, month, day, hour, minute, second, fraction))
  if (delta) date.setTime(date.getTime() - delta)
  return date
}
function representYamlTimestamp(object) {
  return object.toISOString()
}
var timestamp$1 = new Type$8('tag:yaml.org,2002:timestamp', {
  kind: 'scalar',
  resolve: resolveYamlTimestamp,
  construct: constructYamlTimestamp,
  instanceOf: Date,
  represent: representYamlTimestamp,
})
var Type$7 = type
function resolveYamlMerge(data) {
  return data === '<<' || data === null
}
var merge = new Type$7('tag:yaml.org,2002:merge', {
  kind: 'scalar',
  resolve: resolveYamlMerge,
})
var NodeBuffer
try {
  var _require$1 = commonjsRequire
  NodeBuffer = _require$1('buffer').Buffer
} catch (__) {}
var Type$6 = type
var BASE64_MAP =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=\n\r'
function resolveYamlBinary(data) {
  if (data === null) return false
  var code,
    idx,
    bitlen = 0,
    max = data.length,
    map = BASE64_MAP
  for (idx = 0; idx < max; idx++) {
    code = map.indexOf(data.charAt(idx))
    if (code > 64) continue
    if (code < 0) return false
    bitlen += 6
  }
  return bitlen % 8 === 0
}
function constructYamlBinary(data) {
  var idx,
    tailbits,
    input = data.replace(/[\r\n=]/g, ''),
    max = input.length,
    map = BASE64_MAP,
    bits = 0,
    result = []
  for (idx = 0; idx < max; idx++) {
    if (idx % 4 === 0 && idx) {
      result.push((bits >> 16) & 255)
      result.push((bits >> 8) & 255)
      result.push(bits & 255)
    }
    bits = (bits << 6) | map.indexOf(input.charAt(idx))
  }
  tailbits = (max % 4) * 6
  if (tailbits === 0) {
    result.push((bits >> 16) & 255)
    result.push((bits >> 8) & 255)
    result.push(bits & 255)
  } else if (tailbits === 18) {
    result.push((bits >> 10) & 255)
    result.push((bits >> 2) & 255)
  } else if (tailbits === 12) {
    result.push((bits >> 4) & 255)
  }
  if (NodeBuffer) {
    return NodeBuffer.from ? NodeBuffer.from(result) : new NodeBuffer(result)
  }
  return result
}
function representYamlBinary(object) {
  var result = '',
    bits = 0,
    idx,
    tail,
    max = object.length,
    map = BASE64_MAP
  for (idx = 0; idx < max; idx++) {
    if (idx % 3 === 0 && idx) {
      result += map[(bits >> 18) & 63]
      result += map[(bits >> 12) & 63]
      result += map[(bits >> 6) & 63]
      result += map[bits & 63]
    }
    bits = (bits << 8) + object[idx]
  }
  tail = max % 3
  if (tail === 0) {
    result += map[(bits >> 18) & 63]
    result += map[(bits >> 12) & 63]
    result += map[(bits >> 6) & 63]
    result += map[bits & 63]
  } else if (tail === 2) {
    result += map[(bits >> 10) & 63]
    result += map[(bits >> 4) & 63]
    result += map[(bits << 2) & 63]
    result += map[64]
  } else if (tail === 1) {
    result += map[(bits >> 2) & 63]
    result += map[(bits << 4) & 63]
    result += map[64]
    result += map[64]
  }
  return result
}
function isBinary(object) {
  return NodeBuffer && NodeBuffer.isBuffer(object)
}
var binary = new Type$6('tag:yaml.org,2002:binary', {
  kind: 'scalar',
  resolve: resolveYamlBinary,
  construct: constructYamlBinary,
  predicate: isBinary,
  represent: representYamlBinary,
})
var Type$5 = type
var _hasOwnProperty$3 = Object.prototype.hasOwnProperty
var _toString$2 = Object.prototype.toString
function resolveYamlOmap(data) {
  if (data === null) return true
  var objectKeys = [],
    index,
    length,
    pair,
    pairKey,
    pairHasKey,
    object = data
  for (index = 0, length = object.length; index < length; index += 1) {
    pair = object[index]
    pairHasKey = false
    if (_toString$2.call(pair) !== '[object Object]') return false
    for (pairKey in pair) {
      if (_hasOwnProperty$3.call(pair, pairKey)) {
        if (!pairHasKey) pairHasKey = true
        else return false
      }
    }
    if (!pairHasKey) return false
    if (objectKeys.indexOf(pairKey) === -1) objectKeys.push(pairKey)
    else return false
  }
  return true
}
function constructYamlOmap(data) {
  return data !== null ? data : []
}
var omap = new Type$5('tag:yaml.org,2002:omap', {
  kind: 'sequence',
  resolve: resolveYamlOmap,
  construct: constructYamlOmap,
})
var Type$4 = type
var _toString$1 = Object.prototype.toString
function resolveYamlPairs(data) {
  if (data === null) return true
  var index,
    length,
    pair,
    keys,
    result,
    object = data
  result = new Array(object.length)
  for (index = 0, length = object.length; index < length; index += 1) {
    pair = object[index]
    if (_toString$1.call(pair) !== '[object Object]') return false
    keys = Object.keys(pair)
    if (keys.length !== 1) return false
    result[index] = [keys[0], pair[keys[0]]]
  }
  return true
}
function constructYamlPairs(data) {
  if (data === null) return []
  var index,
    length,
    pair,
    keys,
    result,
    object = data
  result = new Array(object.length)
  for (index = 0, length = object.length; index < length; index += 1) {
    pair = object[index]
    keys = Object.keys(pair)
    result[index] = [keys[0], pair[keys[0]]]
  }
  return result
}
var pairs = new Type$4('tag:yaml.org,2002:pairs', {
  kind: 'sequence',
  resolve: resolveYamlPairs,
  construct: constructYamlPairs,
})
var Type$3 = type
var _hasOwnProperty$2 = Object.prototype.hasOwnProperty
function resolveYamlSet(data) {
  if (data === null) return true
  var key,
    object = data
  for (key in object) {
    if (_hasOwnProperty$2.call(object, key)) {
      if (object[key] !== null) return false
    }
  }
  return true
}
function constructYamlSet(data) {
  return data !== null ? data : {}
}
var set = new Type$3('tag:yaml.org,2002:set', {
  kind: 'mapping',
  resolve: resolveYamlSet,
  construct: constructYamlSet,
})
var Schema$1 = schema
var default_safe = new Schema$1({
  include: [core],
  implicit: [timestamp$1, merge],
  explicit: [binary, omap, pairs, set],
})
var Type$2 = type
function resolveJavascriptUndefined() {
  return true
}
function constructJavascriptUndefined() {
  return undefined
}
function representJavascriptUndefined() {
  return ''
}
function isUndefined(object) {
  return typeof object === 'undefined'
}
var _undefined = new Type$2('tag:yaml.org,2002:js/undefined', {
  kind: 'scalar',
  resolve: resolveJavascriptUndefined,
  construct: constructJavascriptUndefined,
  predicate: isUndefined,
  represent: representJavascriptUndefined,
})
var Type$1 = type
function resolveJavascriptRegExp(data) {
  if (data === null) return false
  if (data.length === 0) return false
  var regexp = data,
    tail = /\/([gim]*)$/.exec(data),
    modifiers = ''
  if (regexp[0] === '/') {
    if (tail) modifiers = tail[1]
    if (modifiers.length > 3) return false
    if (regexp[regexp.length - modifiers.length - 1] !== '/') return false
  }
  return true
}
function constructJavascriptRegExp(data) {
  var regexp = data,
    tail = /\/([gim]*)$/.exec(data),
    modifiers = ''
  if (regexp[0] === '/') {
    if (tail) modifiers = tail[1]
    regexp = regexp.slice(1, regexp.length - modifiers.length - 1)
  }
  return new RegExp(regexp, modifiers)
}
function representJavascriptRegExp(object) {
  var result = '/' + object.source + '/'
  if (object.global) result += 'g'
  if (object.multiline) result += 'm'
  if (object.ignoreCase) result += 'i'
  return result
}
function isRegExp(object) {
  return Object.prototype.toString.call(object) === '[object RegExp]'
}
var regexp = new Type$1('tag:yaml.org,2002:js/regexp', {
  kind: 'scalar',
  resolve: resolveJavascriptRegExp,
  construct: constructJavascriptRegExp,
  predicate: isRegExp,
  represent: representJavascriptRegExp,
})
var esprima
try {
  var _require = commonjsRequire
  esprima = _require('esprima')
} catch (_) {
  if (typeof window !== 'undefined') esprima = window.esprima
}
var Type = type
function resolveJavascriptFunction(data) {
  if (data === null) return false
  try {
    var source = '(' + data + ')',
      ast = esprima.parse(source, {
        range: true,
      })
    if (
      ast.type !== 'Program' ||
      ast.body.length !== 1 ||
      ast.body[0].type !== 'ExpressionStatement' ||
      (ast.body[0].expression.type !== 'ArrowFunctionExpression' &&
        ast.body[0].expression.type !== 'FunctionExpression')
    ) {
      return false
    }
    return true
  } catch (err) {
    return false
  }
}
function constructJavascriptFunction(data) {
  var source = '(' + data + ')',
    ast = esprima.parse(source, {
      range: true,
    }),
    params = [],
    body
  if (
    ast.type !== 'Program' ||
    ast.body.length !== 1 ||
    ast.body[0].type !== 'ExpressionStatement' ||
    (ast.body[0].expression.type !== 'ArrowFunctionExpression' &&
      ast.body[0].expression.type !== 'FunctionExpression')
  ) {
    throw new Error('Failed to resolve function')
  }
  ast.body[0].expression.params.forEach(function (param) {
    params.push(param.name)
  })
  body = ast.body[0].expression.body.range
  if (ast.body[0].expression.body.type === 'BlockStatement') {
    return new Function(params, source.slice(body[0] + 1, body[1] - 1))
  }
  return new Function(params, 'return ' + source.slice(body[0], body[1]))
}
function representJavascriptFunction(object) {
  return object.toString()
}
function isFunction$2(object) {
  return Object.prototype.toString.call(object) === '[object Function]'
}
var _function = new Type('tag:yaml.org,2002:js/function', {
  kind: 'scalar',
  resolve: resolveJavascriptFunction,
  construct: constructJavascriptFunction,
  predicate: isFunction$2,
  represent: representJavascriptFunction,
})
var Schema = schema
var default_full = (Schema.DEFAULT = new Schema({
  include: [default_safe],
  explicit: [_undefined, regexp, _function],
}))
var common$1 = common$6
var YAMLException$1 = exception
var Mark = mark
var DEFAULT_SAFE_SCHEMA$1 = default_safe
var DEFAULT_FULL_SCHEMA$1 = default_full
var _hasOwnProperty$1 = Object.prototype.hasOwnProperty
var CONTEXT_FLOW_IN = 1
var CONTEXT_FLOW_OUT = 2
var CONTEXT_BLOCK_IN = 3
var CONTEXT_BLOCK_OUT = 4
var CHOMPING_CLIP = 1
var CHOMPING_STRIP = 2
var CHOMPING_KEEP = 3
var PATTERN_NON_PRINTABLE =
  /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F-\x84\x86-\x9F\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/
var PATTERN_NON_ASCII_LINE_BREAKS = /[\x85\u2028\u2029]/
var PATTERN_FLOW_INDICATORS = /[,\[\]\{\}]/
var PATTERN_TAG_HANDLE = /^(?:!|!!|![a-z\-]+!)$/i
var PATTERN_TAG_URI =
  /^(?:!|[^,\[\]\{\}])(?:%[0-9a-f]{2}|[0-9a-z\-#;\/\?:@&=\+\$,_\.!~\*'\(\)\[\]])*$/i
function _class(obj) {
  return Object.prototype.toString.call(obj)
}
function is_EOL(c) {
  return c === 10 || c === 13
}
function is_WHITE_SPACE(c) {
  return c === 9 || c === 32
}
function is_WS_OR_EOL(c) {
  return c === 9 || c === 32 || c === 10 || c === 13
}
function is_FLOW_INDICATOR(c) {
  return c === 44 || c === 91 || c === 93 || c === 123 || c === 125
}
function fromHexCode(c) {
  var lc
  if (48 <= c && c <= 57) {
    return c - 48
  }
  lc = c | 32
  if (97 <= lc && lc <= 102) {
    return lc - 97 + 10
  }
  return -1
}
function escapedHexLen(c) {
  if (c === 120) {
    return 2
  }
  if (c === 117) {
    return 4
  }
  if (c === 85) {
    return 8
  }
  return 0
}
function fromDecimalCode(c) {
  if (48 <= c && c <= 57) {
    return c - 48
  }
  return -1
}
function simpleEscapeSequence(c) {
  return c === 48
    ? '\0'
    : c === 97
      ? ''
      : c === 98
        ? '\b'
        : c === 116
          ? '\t'
          : c === 9
            ? '\t'
            : c === 110
              ? '\n'
              : c === 118
                ? '\v'
                : c === 102
                  ? '\f'
                  : c === 114
                    ? '\r'
                    : c === 101
                      ? ''
                      : c === 32
                        ? ' '
                        : c === 34
                          ? '"'
                          : c === 47
                            ? '/'
                            : c === 92
                              ? '\\'
                              : c === 78
                                ? ''
                                : c === 95
                                  ? ' '
                                  : c === 76
                                    ? '\u2028'
                                    : c === 80
                                      ? '\u2029'
                                      : ''
}
function charFromCodepoint(c) {
  if (c <= 65535) {
    return String.fromCharCode(c)
  }
  return String.fromCharCode(
    ((c - 65536) >> 10) + 55296,
    ((c - 65536) & 1023) + 56320
  )
}
var simpleEscapeCheck = new Array(256)
var simpleEscapeMap = new Array(256)
for (var i = 0; i < 256; i++) {
  simpleEscapeCheck[i] = simpleEscapeSequence(i) ? 1 : 0
  simpleEscapeMap[i] = simpleEscapeSequence(i)
}
function State$1(input, options) {
  this.input = input
  this.filename = options['filename'] || null
  this.schema = options['schema'] || DEFAULT_FULL_SCHEMA$1
  this.onWarning = options['onWarning'] || null
  this.legacy = options['legacy'] || false
  this.json = options['json'] || false
  this.listener = options['listener'] || null
  this.implicitTypes = this.schema.compiledImplicit
  this.typeMap = this.schema.compiledTypeMap
  this.length = input.length
  this.position = 0
  this.line = 0
  this.lineStart = 0
  this.lineIndent = 0
  this.documents = []
}
function generateError(state, message) {
  return new YAMLException$1(
    message,
    new Mark(
      state.filename,
      state.input,
      state.position,
      state.line,
      state.position - state.lineStart
    )
  )
}
function throwError(state, message) {
  throw generateError(state, message)
}
function throwWarning(state, message) {
  if (state.onWarning) {
    state.onWarning.call(null, generateError(state, message))
  }
}
var directiveHandlers = {
  YAML: function handleYamlDirective(state, name, args) {
    var match, major, minor
    if (state.version !== null) {
      throwError(state, 'duplication of %YAML directive')
    }
    if (args.length !== 1) {
      throwError(state, 'YAML directive accepts exactly one argument')
    }
    match = /^([0-9]+)\.([0-9]+)$/.exec(args[0])
    if (match === null) {
      throwError(state, 'ill-formed argument of the YAML directive')
    }
    major = parseInt(match[1], 10)
    minor = parseInt(match[2], 10)
    if (major !== 1) {
      throwError(state, 'unacceptable YAML version of the document')
    }
    state.version = args[0]
    state.checkLineBreaks = minor < 2
    if (minor !== 1 && minor !== 2) {
      throwWarning(state, 'unsupported YAML version of the document')
    }
  },
  TAG: function handleTagDirective(state, name, args) {
    var handle, prefix
    if (args.length !== 2) {
      throwError(state, 'TAG directive accepts exactly two arguments')
    }
    handle = args[0]
    prefix = args[1]
    if (!PATTERN_TAG_HANDLE.test(handle)) {
      throwError(
        state,
        'ill-formed tag handle (first argument) of the TAG directive'
      )
    }
    if (_hasOwnProperty$1.call(state.tagMap, handle)) {
      throwError(
        state,
        'there is a previously declared suffix for "' + handle + '" tag handle'
      )
    }
    if (!PATTERN_TAG_URI.test(prefix)) {
      throwError(
        state,
        'ill-formed tag prefix (second argument) of the TAG directive'
      )
    }
    state.tagMap[handle] = prefix
  },
}
function captureSegment(state, start, end, checkJson) {
  var _position, _length, _character, _result
  if (start < end) {
    _result = state.input.slice(start, end)
    if (checkJson) {
      for (
        _position = 0, _length = _result.length;
        _position < _length;
        _position += 1
      ) {
        _character = _result.charCodeAt(_position)
        if (
          !(_character === 9 || (32 <= _character && _character <= 1114111))
        ) {
          throwError(state, 'expected valid JSON character')
        }
      }
    } else if (PATTERN_NON_PRINTABLE.test(_result)) {
      throwError(state, 'the stream contains non-printable characters')
    }
    state.result += _result
  }
}
function mergeMappings(state, destination, source, overridableKeys) {
  var sourceKeys, key, index, quantity
  if (!common$1.isObject(source)) {
    throwError(
      state,
      'cannot merge mappings; the provided source object is unacceptable'
    )
  }
  sourceKeys = Object.keys(source)
  for (index = 0, quantity = sourceKeys.length; index < quantity; index += 1) {
    key = sourceKeys[index]
    if (!_hasOwnProperty$1.call(destination, key)) {
      destination[key] = source[key]
      overridableKeys[key] = true
    }
  }
}
function storeMappingPair(
  state,
  _result,
  overridableKeys,
  keyTag,
  keyNode,
  valueNode,
  startLine,
  startPos
) {
  var index, quantity
  if (Array.isArray(keyNode)) {
    keyNode = Array.prototype.slice.call(keyNode)
    for (index = 0, quantity = keyNode.length; index < quantity; index += 1) {
      if (Array.isArray(keyNode[index])) {
        throwError(state, 'nested arrays are not supported inside keys')
      }
      if (
        typeof keyNode === 'object' &&
        _class(keyNode[index]) === '[object Object]'
      ) {
        keyNode[index] = '[object Object]'
      }
    }
  }
  if (typeof keyNode === 'object' && _class(keyNode) === '[object Object]') {
    keyNode = '[object Object]'
  }
  keyNode = String(keyNode)
  if (_result === null) {
    _result = {}
  }
  if (keyTag === 'tag:yaml.org,2002:merge') {
    if (Array.isArray(valueNode)) {
      for (
        index = 0, quantity = valueNode.length;
        index < quantity;
        index += 1
      ) {
        mergeMappings(state, _result, valueNode[index], overridableKeys)
      }
    } else {
      mergeMappings(state, _result, valueNode, overridableKeys)
    }
  } else {
    if (
      !state.json &&
      !_hasOwnProperty$1.call(overridableKeys, keyNode) &&
      _hasOwnProperty$1.call(_result, keyNode)
    ) {
      state.line = startLine || state.line
      state.position = startPos || state.position
      throwError(state, 'duplicated mapping key')
    }
    _result[keyNode] = valueNode
    delete overridableKeys[keyNode]
  }
  return _result
}
function readLineBreak(state) {
  var ch
  ch = state.input.charCodeAt(state.position)
  if (ch === 10) {
    state.position++
  } else if (ch === 13) {
    state.position++
    if (state.input.charCodeAt(state.position) === 10) {
      state.position++
    }
  } else {
    throwError(state, 'a line break is expected')
  }
  state.line += 1
  state.lineStart = state.position
}
function skipSeparationSpace(state, allowComments, checkIndent) {
  var lineBreaks = 0,
    ch = state.input.charCodeAt(state.position)
  while (ch !== 0) {
    while (is_WHITE_SPACE(ch)) {
      ch = state.input.charCodeAt(++state.position)
    }
    if (allowComments && ch === 35) {
      do {
        ch = state.input.charCodeAt(++state.position)
      } while (ch !== 10 && ch !== 13 && ch !== 0)
    }
    if (is_EOL(ch)) {
      readLineBreak(state)
      ch = state.input.charCodeAt(state.position)
      lineBreaks++
      state.lineIndent = 0
      while (ch === 32) {
        state.lineIndent++
        ch = state.input.charCodeAt(++state.position)
      }
    } else {
      break
    }
  }
  if (
    checkIndent !== -1 &&
    lineBreaks !== 0 &&
    state.lineIndent < checkIndent
  ) {
    throwWarning(state, 'deficient indentation')
  }
  return lineBreaks
}
function testDocumentSeparator(state) {
  var _position = state.position,
    ch
  ch = state.input.charCodeAt(_position)
  if (
    (ch === 45 || ch === 46) &&
    ch === state.input.charCodeAt(_position + 1) &&
    ch === state.input.charCodeAt(_position + 2)
  ) {
    _position += 3
    ch = state.input.charCodeAt(_position)
    if (ch === 0 || is_WS_OR_EOL(ch)) {
      return true
    }
  }
  return false
}
function writeFoldedLines(state, count) {
  if (count === 1) {
    state.result += ' '
  } else if (count > 1) {
    state.result += common$1.repeat('\n', count - 1)
  }
}
function readPlainScalar(state, nodeIndent, withinFlowCollection) {
  var preceding,
    following,
    captureStart,
    captureEnd,
    hasPendingContent,
    _line,
    _lineStart,
    _lineIndent,
    _kind = state.kind,
    _result = state.result,
    ch
  ch = state.input.charCodeAt(state.position)
  if (
    is_WS_OR_EOL(ch) ||
    is_FLOW_INDICATOR(ch) ||
    ch === 35 ||
    ch === 38 ||
    ch === 42 ||
    ch === 33 ||
    ch === 124 ||
    ch === 62 ||
    ch === 39 ||
    ch === 34 ||
    ch === 37 ||
    ch === 64 ||
    ch === 96
  ) {
    return false
  }
  if (ch === 63 || ch === 45) {
    following = state.input.charCodeAt(state.position + 1)
    if (
      is_WS_OR_EOL(following) ||
      (withinFlowCollection && is_FLOW_INDICATOR(following))
    ) {
      return false
    }
  }
  state.kind = 'scalar'
  state.result = ''
  captureStart = captureEnd = state.position
  hasPendingContent = false
  while (ch !== 0) {
    if (ch === 58) {
      following = state.input.charCodeAt(state.position + 1)
      if (
        is_WS_OR_EOL(following) ||
        (withinFlowCollection && is_FLOW_INDICATOR(following))
      ) {
        break
      }
    } else if (ch === 35) {
      preceding = state.input.charCodeAt(state.position - 1)
      if (is_WS_OR_EOL(preceding)) {
        break
      }
    } else if (
      (state.position === state.lineStart && testDocumentSeparator(state)) ||
      (withinFlowCollection && is_FLOW_INDICATOR(ch))
    ) {
      break
    } else if (is_EOL(ch)) {
      _line = state.line
      _lineStart = state.lineStart
      _lineIndent = state.lineIndent
      skipSeparationSpace(state, false, -1)
      if (state.lineIndent >= nodeIndent) {
        hasPendingContent = true
        ch = state.input.charCodeAt(state.position)
        continue
      } else {
        state.position = captureEnd
        state.line = _line
        state.lineStart = _lineStart
        state.lineIndent = _lineIndent
        break
      }
    }
    if (hasPendingContent) {
      captureSegment(state, captureStart, captureEnd, false)
      writeFoldedLines(state, state.line - _line)
      captureStart = captureEnd = state.position
      hasPendingContent = false
    }
    if (!is_WHITE_SPACE(ch)) {
      captureEnd = state.position + 1
    }
    ch = state.input.charCodeAt(++state.position)
  }
  captureSegment(state, captureStart, captureEnd, false)
  if (state.result) {
    return true
  }
  state.kind = _kind
  state.result = _result
  return false
}
function readSingleQuotedScalar(state, nodeIndent) {
  var ch, captureStart, captureEnd
  ch = state.input.charCodeAt(state.position)
  if (ch !== 39) {
    return false
  }
  state.kind = 'scalar'
  state.result = ''
  state.position++
  captureStart = captureEnd = state.position
  while ((ch = state.input.charCodeAt(state.position)) !== 0) {
    if (ch === 39) {
      captureSegment(state, captureStart, state.position, true)
      ch = state.input.charCodeAt(++state.position)
      if (ch === 39) {
        captureStart = state.position
        state.position++
        captureEnd = state.position
      } else {
        return true
      }
    } else if (is_EOL(ch)) {
      captureSegment(state, captureStart, captureEnd, true)
      writeFoldedLines(state, skipSeparationSpace(state, false, nodeIndent))
      captureStart = captureEnd = state.position
    } else if (
      state.position === state.lineStart &&
      testDocumentSeparator(state)
    ) {
      throwError(
        state,
        'unexpected end of the document within a single quoted scalar'
      )
    } else {
      state.position++
      captureEnd = state.position
    }
  }
  throwError(
    state,
    'unexpected end of the stream within a single quoted scalar'
  )
}
function readDoubleQuotedScalar(state, nodeIndent) {
  var captureStart, captureEnd, hexLength, hexResult, tmp, ch
  ch = state.input.charCodeAt(state.position)
  if (ch !== 34) {
    return false
  }
  state.kind = 'scalar'
  state.result = ''
  state.position++
  captureStart = captureEnd = state.position
  while ((ch = state.input.charCodeAt(state.position)) !== 0) {
    if (ch === 34) {
      captureSegment(state, captureStart, state.position, true)
      state.position++
      return true
    } else if (ch === 92) {
      captureSegment(state, captureStart, state.position, true)
      ch = state.input.charCodeAt(++state.position)
      if (is_EOL(ch)) {
        skipSeparationSpace(state, false, nodeIndent)
      } else if (ch < 256 && simpleEscapeCheck[ch]) {
        state.result += simpleEscapeMap[ch]
        state.position++
      } else if ((tmp = escapedHexLen(ch)) > 0) {
        hexLength = tmp
        hexResult = 0
        for (; hexLength > 0; hexLength--) {
          ch = state.input.charCodeAt(++state.position)
          if ((tmp = fromHexCode(ch)) >= 0) {
            hexResult = (hexResult << 4) + tmp
          } else {
            throwError(state, 'expected hexadecimal character')
          }
        }
        state.result += charFromCodepoint(hexResult)
        state.position++
      } else {
        throwError(state, 'unknown escape sequence')
      }
      captureStart = captureEnd = state.position
    } else if (is_EOL(ch)) {
      captureSegment(state, captureStart, captureEnd, true)
      writeFoldedLines(state, skipSeparationSpace(state, false, nodeIndent))
      captureStart = captureEnd = state.position
    } else if (
      state.position === state.lineStart &&
      testDocumentSeparator(state)
    ) {
      throwError(
        state,
        'unexpected end of the document within a double quoted scalar'
      )
    } else {
      state.position++
      captureEnd = state.position
    }
  }
  throwError(
    state,
    'unexpected end of the stream within a double quoted scalar'
  )
}
function readFlowCollection(state, nodeIndent) {
  var readNext = true,
    _line,
    _tag = state.tag,
    _result,
    _anchor = state.anchor,
    following,
    terminator,
    isPair,
    isExplicitPair,
    isMapping,
    overridableKeys = {},
    keyNode,
    keyTag,
    valueNode,
    ch
  ch = state.input.charCodeAt(state.position)
  if (ch === 91) {
    terminator = 93
    isMapping = false
    _result = []
  } else if (ch === 123) {
    terminator = 125
    isMapping = true
    _result = {}
  } else {
    return false
  }
  if (state.anchor !== null) {
    state.anchorMap[state.anchor] = _result
  }
  ch = state.input.charCodeAt(++state.position)
  while (ch !== 0) {
    skipSeparationSpace(state, true, nodeIndent)
    ch = state.input.charCodeAt(state.position)
    if (ch === terminator) {
      state.position++
      state.tag = _tag
      state.anchor = _anchor
      state.kind = isMapping ? 'mapping' : 'sequence'
      state.result = _result
      return true
    } else if (!readNext) {
      throwError(state, 'missed comma between flow collection entries')
    }
    keyTag = keyNode = valueNode = null
    isPair = isExplicitPair = false
    if (ch === 63) {
      following = state.input.charCodeAt(state.position + 1)
      if (is_WS_OR_EOL(following)) {
        isPair = isExplicitPair = true
        state.position++
        skipSeparationSpace(state, true, nodeIndent)
      }
    }
    _line = state.line
    composeNode(state, nodeIndent, CONTEXT_FLOW_IN, false, true)
    keyTag = state.tag
    keyNode = state.result
    skipSeparationSpace(state, true, nodeIndent)
    ch = state.input.charCodeAt(state.position)
    if ((isExplicitPair || state.line === _line) && ch === 58) {
      isPair = true
      ch = state.input.charCodeAt(++state.position)
      skipSeparationSpace(state, true, nodeIndent)
      composeNode(state, nodeIndent, CONTEXT_FLOW_IN, false, true)
      valueNode = state.result
    }
    if (isMapping) {
      storeMappingPair(
        state,
        _result,
        overridableKeys,
        keyTag,
        keyNode,
        valueNode
      )
    } else if (isPair) {
      _result.push(
        storeMappingPair(
          state,
          null,
          overridableKeys,
          keyTag,
          keyNode,
          valueNode
        )
      )
    } else {
      _result.push(keyNode)
    }
    skipSeparationSpace(state, true, nodeIndent)
    ch = state.input.charCodeAt(state.position)
    if (ch === 44) {
      readNext = true
      ch = state.input.charCodeAt(++state.position)
    } else {
      readNext = false
    }
  }
  throwError(state, 'unexpected end of the stream within a flow collection')
}
function readBlockScalar(state, nodeIndent) {
  var captureStart,
    folding,
    chomping = CHOMPING_CLIP,
    didReadContent = false,
    detectedIndent = false,
    textIndent = nodeIndent,
    emptyLines = 0,
    atMoreIndented = false,
    tmp,
    ch
  ch = state.input.charCodeAt(state.position)
  if (ch === 124) {
    folding = false
  } else if (ch === 62) {
    folding = true
  } else {
    return false
  }
  state.kind = 'scalar'
  state.result = ''
  while (ch !== 0) {
    ch = state.input.charCodeAt(++state.position)
    if (ch === 43 || ch === 45) {
      if (CHOMPING_CLIP === chomping) {
        chomping = ch === 43 ? CHOMPING_KEEP : CHOMPING_STRIP
      } else {
        throwError(state, 'repeat of a chomping mode identifier')
      }
    } else if ((tmp = fromDecimalCode(ch)) >= 0) {
      if (tmp === 0) {
        throwError(
          state,
          'bad explicit indentation width of a block scalar; it cannot be less than one'
        )
      } else if (!detectedIndent) {
        textIndent = nodeIndent + tmp - 1
        detectedIndent = true
      } else {
        throwError(state, 'repeat of an indentation width identifier')
      }
    } else {
      break
    }
  }
  if (is_WHITE_SPACE(ch)) {
    do {
      ch = state.input.charCodeAt(++state.position)
    } while (is_WHITE_SPACE(ch))
    if (ch === 35) {
      do {
        ch = state.input.charCodeAt(++state.position)
      } while (!is_EOL(ch) && ch !== 0)
    }
  }
  while (ch !== 0) {
    readLineBreak(state)
    state.lineIndent = 0
    ch = state.input.charCodeAt(state.position)
    while ((!detectedIndent || state.lineIndent < textIndent) && ch === 32) {
      state.lineIndent++
      ch = state.input.charCodeAt(++state.position)
    }
    if (!detectedIndent && state.lineIndent > textIndent) {
      textIndent = state.lineIndent
    }
    if (is_EOL(ch)) {
      emptyLines++
      continue
    }
    if (state.lineIndent < textIndent) {
      if (chomping === CHOMPING_KEEP) {
        state.result += common$1.repeat(
          '\n',
          didReadContent ? 1 + emptyLines : emptyLines
        )
      } else if (chomping === CHOMPING_CLIP) {
        if (didReadContent) {
          state.result += '\n'
        }
      }
      break
    }
    if (folding) {
      if (is_WHITE_SPACE(ch)) {
        atMoreIndented = true
        state.result += common$1.repeat(
          '\n',
          didReadContent ? 1 + emptyLines : emptyLines
        )
      } else if (atMoreIndented) {
        atMoreIndented = false
        state.result += common$1.repeat('\n', emptyLines + 1)
      } else if (emptyLines === 0) {
        if (didReadContent) {
          state.result += ' '
        }
      } else {
        state.result += common$1.repeat('\n', emptyLines)
      }
    } else {
      state.result += common$1.repeat(
        '\n',
        didReadContent ? 1 + emptyLines : emptyLines
      )
    }
    didReadContent = true
    detectedIndent = true
    emptyLines = 0
    captureStart = state.position
    while (!is_EOL(ch) && ch !== 0) {
      ch = state.input.charCodeAt(++state.position)
    }
    captureSegment(state, captureStart, state.position, false)
  }
  return true
}
function readBlockSequence(state, nodeIndent) {
  var _line,
    _tag = state.tag,
    _anchor = state.anchor,
    _result = [],
    following,
    detected = false,
    ch
  if (state.anchor !== null) {
    state.anchorMap[state.anchor] = _result
  }
  ch = state.input.charCodeAt(state.position)
  while (ch !== 0) {
    if (ch !== 45) {
      break
    }
    following = state.input.charCodeAt(state.position + 1)
    if (!is_WS_OR_EOL(following)) {
      break
    }
    detected = true
    state.position++
    if (skipSeparationSpace(state, true, -1)) {
      if (state.lineIndent <= nodeIndent) {
        _result.push(null)
        ch = state.input.charCodeAt(state.position)
        continue
      }
    }
    _line = state.line
    composeNode(state, nodeIndent, CONTEXT_BLOCK_IN, false, true)
    _result.push(state.result)
    skipSeparationSpace(state, true, -1)
    ch = state.input.charCodeAt(state.position)
    if ((state.line === _line || state.lineIndent > nodeIndent) && ch !== 0) {
      throwError(state, 'bad indentation of a sequence entry')
    } else if (state.lineIndent < nodeIndent) {
      break
    }
  }
  if (detected) {
    state.tag = _tag
    state.anchor = _anchor
    state.kind = 'sequence'
    state.result = _result
    return true
  }
  return false
}
function readBlockMapping(state, nodeIndent, flowIndent) {
  var following,
    allowCompact,
    _line,
    _pos,
    _tag = state.tag,
    _anchor = state.anchor,
    _result = {},
    overridableKeys = {},
    keyTag = null,
    keyNode = null,
    valueNode = null,
    atExplicitKey = false,
    detected = false,
    ch
  if (state.anchor !== null) {
    state.anchorMap[state.anchor] = _result
  }
  ch = state.input.charCodeAt(state.position)
  while (ch !== 0) {
    following = state.input.charCodeAt(state.position + 1)
    _line = state.line
    _pos = state.position
    if ((ch === 63 || ch === 58) && is_WS_OR_EOL(following)) {
      if (ch === 63) {
        if (atExplicitKey) {
          storeMappingPair(
            state,
            _result,
            overridableKeys,
            keyTag,
            keyNode,
            null
          )
          keyTag = keyNode = valueNode = null
        }
        detected = true
        atExplicitKey = true
        allowCompact = true
      } else if (atExplicitKey) {
        atExplicitKey = false
        allowCompact = true
      } else {
        throwError(
          state,
          'incomplete explicit mapping pair; a key node is missed; or followed by a non-tabulated empty line'
        )
      }
      state.position += 1
      ch = following
    } else if (composeNode(state, flowIndent, CONTEXT_FLOW_OUT, false, true)) {
      if (state.line === _line) {
        ch = state.input.charCodeAt(state.position)
        while (is_WHITE_SPACE(ch)) {
          ch = state.input.charCodeAt(++state.position)
        }
        if (ch === 58) {
          ch = state.input.charCodeAt(++state.position)
          if (!is_WS_OR_EOL(ch)) {
            throwError(
              state,
              'a whitespace character is expected after the key-value separator within a block mapping'
            )
          }
          if (atExplicitKey) {
            storeMappingPair(
              state,
              _result,
              overridableKeys,
              keyTag,
              keyNode,
              null
            )
            keyTag = keyNode = valueNode = null
          }
          detected = true
          atExplicitKey = false
          allowCompact = false
          keyTag = state.tag
          keyNode = state.result
        } else if (detected) {
          throwError(
            state,
            'can not read an implicit mapping pair; a colon is missed'
          )
        } else {
          state.tag = _tag
          state.anchor = _anchor
          return true
        }
      } else if (detected) {
        throwError(
          state,
          'can not read a block mapping entry; a multiline key may not be an implicit key'
        )
      } else {
        state.tag = _tag
        state.anchor = _anchor
        return true
      }
    } else {
      break
    }
    if (state.line === _line || state.lineIndent > nodeIndent) {
      if (
        composeNode(state, nodeIndent, CONTEXT_BLOCK_OUT, true, allowCompact)
      ) {
        if (atExplicitKey) {
          keyNode = state.result
        } else {
          valueNode = state.result
        }
      }
      if (!atExplicitKey) {
        storeMappingPair(
          state,
          _result,
          overridableKeys,
          keyTag,
          keyNode,
          valueNode,
          _line,
          _pos
        )
        keyTag = keyNode = valueNode = null
      }
      skipSeparationSpace(state, true, -1)
      ch = state.input.charCodeAt(state.position)
    }
    if (state.lineIndent > nodeIndent && ch !== 0) {
      throwError(state, 'bad indentation of a mapping entry')
    } else if (state.lineIndent < nodeIndent) {
      break
    }
  }
  if (atExplicitKey) {
    storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, null)
  }
  if (detected) {
    state.tag = _tag
    state.anchor = _anchor
    state.kind = 'mapping'
    state.result = _result
  }
  return detected
}
function readTagProperty(state) {
  var _position,
    isVerbatim = false,
    isNamed = false,
    tagHandle,
    tagName,
    ch
  ch = state.input.charCodeAt(state.position)
  if (ch !== 33) return false
  if (state.tag !== null) {
    throwError(state, 'duplication of a tag property')
  }
  ch = state.input.charCodeAt(++state.position)
  if (ch === 60) {
    isVerbatim = true
    ch = state.input.charCodeAt(++state.position)
  } else if (ch === 33) {
    isNamed = true
    tagHandle = '!!'
    ch = state.input.charCodeAt(++state.position)
  } else {
    tagHandle = '!'
  }
  _position = state.position
  if (isVerbatim) {
    do {
      ch = state.input.charCodeAt(++state.position)
    } while (ch !== 0 && ch !== 62)
    if (state.position < state.length) {
      tagName = state.input.slice(_position, state.position)
      ch = state.input.charCodeAt(++state.position)
    } else {
      throwError(state, 'unexpected end of the stream within a verbatim tag')
    }
  } else {
    while (ch !== 0 && !is_WS_OR_EOL(ch)) {
      if (ch === 33) {
        if (!isNamed) {
          tagHandle = state.input.slice(_position - 1, state.position + 1)
          if (!PATTERN_TAG_HANDLE.test(tagHandle)) {
            throwError(state, 'named tag handle cannot contain such characters')
          }
          isNamed = true
          _position = state.position + 1
        } else {
          throwError(state, 'tag suffix cannot contain exclamation marks')
        }
      }
      ch = state.input.charCodeAt(++state.position)
    }
    tagName = state.input.slice(_position, state.position)
    if (PATTERN_FLOW_INDICATORS.test(tagName)) {
      throwError(state, 'tag suffix cannot contain flow indicator characters')
    }
  }
  if (tagName && !PATTERN_TAG_URI.test(tagName)) {
    throwError(state, 'tag name cannot contain such characters: ' + tagName)
  }
  if (isVerbatim) {
    state.tag = tagName
  } else if (_hasOwnProperty$1.call(state.tagMap, tagHandle)) {
    state.tag = state.tagMap[tagHandle] + tagName
  } else if (tagHandle === '!') {
    state.tag = '!' + tagName
  } else if (tagHandle === '!!') {
    state.tag = 'tag:yaml.org,2002:' + tagName
  } else {
    throwError(state, 'undeclared tag handle "' + tagHandle + '"')
  }
  return true
}
function readAnchorProperty(state) {
  var _position, ch
  ch = state.input.charCodeAt(state.position)
  if (ch !== 38) return false
  if (state.anchor !== null) {
    throwError(state, 'duplication of an anchor property')
  }
  ch = state.input.charCodeAt(++state.position)
  _position = state.position
  while (ch !== 0 && !is_WS_OR_EOL(ch) && !is_FLOW_INDICATOR(ch)) {
    ch = state.input.charCodeAt(++state.position)
  }
  if (state.position === _position) {
    throwError(
      state,
      'name of an anchor node must contain at least one character'
    )
  }
  state.anchor = state.input.slice(_position, state.position)
  return true
}
function readAlias(state) {
  var _position, alias, ch
  ch = state.input.charCodeAt(state.position)
  if (ch !== 42) return false
  ch = state.input.charCodeAt(++state.position)
  _position = state.position
  while (ch !== 0 && !is_WS_OR_EOL(ch) && !is_FLOW_INDICATOR(ch)) {
    ch = state.input.charCodeAt(++state.position)
  }
  if (state.position === _position) {
    throwError(
      state,
      'name of an alias node must contain at least one character'
    )
  }
  alias = state.input.slice(_position, state.position)
  if (!_hasOwnProperty$1.call(state.anchorMap, alias)) {
    throwError(state, 'unidentified alias "' + alias + '"')
  }
  state.result = state.anchorMap[alias]
  skipSeparationSpace(state, true, -1)
  return true
}
function composeNode(
  state,
  parentIndent,
  nodeContext,
  allowToSeek,
  allowCompact
) {
  var allowBlockStyles,
    allowBlockScalars,
    allowBlockCollections,
    indentStatus = 1,
    atNewLine = false,
    hasContent = false,
    typeIndex,
    typeQuantity,
    type,
    flowIndent,
    blockIndent
  if (state.listener !== null) {
    state.listener('open', state)
  }
  state.tag = null
  state.anchor = null
  state.kind = null
  state.result = null
  allowBlockStyles =
    allowBlockScalars =
    allowBlockCollections =
      CONTEXT_BLOCK_OUT === nodeContext || CONTEXT_BLOCK_IN === nodeContext
  if (allowToSeek) {
    if (skipSeparationSpace(state, true, -1)) {
      atNewLine = true
      if (state.lineIndent > parentIndent) {
        indentStatus = 1
      } else if (state.lineIndent === parentIndent) {
        indentStatus = 0
      } else if (state.lineIndent < parentIndent) {
        indentStatus = -1
      }
    }
  }
  if (indentStatus === 1) {
    while (readTagProperty(state) || readAnchorProperty(state)) {
      if (skipSeparationSpace(state, true, -1)) {
        atNewLine = true
        allowBlockCollections = allowBlockStyles
        if (state.lineIndent > parentIndent) {
          indentStatus = 1
        } else if (state.lineIndent === parentIndent) {
          indentStatus = 0
        } else if (state.lineIndent < parentIndent) {
          indentStatus = -1
        }
      } else {
        allowBlockCollections = false
      }
    }
  }
  if (allowBlockCollections) {
    allowBlockCollections = atNewLine || allowCompact
  }
  if (indentStatus === 1 || CONTEXT_BLOCK_OUT === nodeContext) {
    if (CONTEXT_FLOW_IN === nodeContext || CONTEXT_FLOW_OUT === nodeContext) {
      flowIndent = parentIndent
    } else {
      flowIndent = parentIndent + 1
    }
    blockIndent = state.position - state.lineStart
    if (indentStatus === 1) {
      if (
        (allowBlockCollections &&
          (readBlockSequence(state, blockIndent) ||
            readBlockMapping(state, blockIndent, flowIndent))) ||
        readFlowCollection(state, flowIndent)
      ) {
        hasContent = true
      } else {
        if (
          (allowBlockScalars && readBlockScalar(state, flowIndent)) ||
          readSingleQuotedScalar(state, flowIndent) ||
          readDoubleQuotedScalar(state, flowIndent)
        ) {
          hasContent = true
        } else if (readAlias(state)) {
          hasContent = true
          if (state.tag !== null || state.anchor !== null) {
            throwError(state, 'alias node should not have any properties')
          }
        } else if (
          readPlainScalar(state, flowIndent, CONTEXT_FLOW_IN === nodeContext)
        ) {
          hasContent = true
          if (state.tag === null) {
            state.tag = '?'
          }
        }
        if (state.anchor !== null) {
          state.anchorMap[state.anchor] = state.result
        }
      }
    } else if (indentStatus === 0) {
      hasContent =
        allowBlockCollections && readBlockSequence(state, blockIndent)
    }
  }
  if (state.tag !== null && state.tag !== '!') {
    if (state.tag === '?') {
      if (state.result !== null && state.kind !== 'scalar') {
        throwError(
          state,
          'unacceptable node kind for !<?> tag; it should be "scalar", not "' +
            state.kind +
            '"'
        )
      }
      for (
        typeIndex = 0, typeQuantity = state.implicitTypes.length;
        typeIndex < typeQuantity;
        typeIndex += 1
      ) {
        type = state.implicitTypes[typeIndex]
        if (type.resolve(state.result)) {
          state.result = type.construct(state.result)
          state.tag = type.tag
          if (state.anchor !== null) {
            state.anchorMap[state.anchor] = state.result
          }
          break
        }
      }
    } else if (
      _hasOwnProperty$1.call(state.typeMap[state.kind || 'fallback'], state.tag)
    ) {
      type = state.typeMap[state.kind || 'fallback'][state.tag]
      if (state.result !== null && type.kind !== state.kind) {
        throwError(
          state,
          'unacceptable node kind for !<' +
            state.tag +
            '> tag; it should be "' +
            type.kind +
            '", not "' +
            state.kind +
            '"'
        )
      }
      if (!type.resolve(state.result)) {
        throwError(
          state,
          'cannot resolve a node with !<' + state.tag + '> explicit tag'
        )
      } else {
        state.result = type.construct(state.result)
        if (state.anchor !== null) {
          state.anchorMap[state.anchor] = state.result
        }
      }
    } else {
      throwError(state, 'unknown tag !<' + state.tag + '>')
    }
  }
  if (state.listener !== null) {
    state.listener('close', state)
  }
  return state.tag !== null || state.anchor !== null || hasContent
}
function readDocument(state) {
  var documentStart = state.position,
    _position,
    directiveName,
    directiveArgs,
    hasDirectives = false,
    ch
  state.version = null
  state.checkLineBreaks = state.legacy
  state.tagMap = {}
  state.anchorMap = {}
  while ((ch = state.input.charCodeAt(state.position)) !== 0) {
    skipSeparationSpace(state, true, -1)
    ch = state.input.charCodeAt(state.position)
    if (state.lineIndent > 0 || ch !== 37) {
      break
    }
    hasDirectives = true
    ch = state.input.charCodeAt(++state.position)
    _position = state.position
    while (ch !== 0 && !is_WS_OR_EOL(ch)) {
      ch = state.input.charCodeAt(++state.position)
    }
    directiveName = state.input.slice(_position, state.position)
    directiveArgs = []
    if (directiveName.length < 1) {
      throwError(
        state,
        'directive name must not be less than one character in length'
      )
    }
    while (ch !== 0) {
      while (is_WHITE_SPACE(ch)) {
        ch = state.input.charCodeAt(++state.position)
      }
      if (ch === 35) {
        do {
          ch = state.input.charCodeAt(++state.position)
        } while (ch !== 0 && !is_EOL(ch))
        break
      }
      if (is_EOL(ch)) break
      _position = state.position
      while (ch !== 0 && !is_WS_OR_EOL(ch)) {
        ch = state.input.charCodeAt(++state.position)
      }
      directiveArgs.push(state.input.slice(_position, state.position))
    }
    if (ch !== 0) readLineBreak(state)
    if (_hasOwnProperty$1.call(directiveHandlers, directiveName)) {
      directiveHandlers[directiveName](state, directiveName, directiveArgs)
    } else {
      throwWarning(state, 'unknown document directive "' + directiveName + '"')
    }
  }
  skipSeparationSpace(state, true, -1)
  if (
    state.lineIndent === 0 &&
    state.input.charCodeAt(state.position) === 45 &&
    state.input.charCodeAt(state.position + 1) === 45 &&
    state.input.charCodeAt(state.position + 2) === 45
  ) {
    state.position += 3
    skipSeparationSpace(state, true, -1)
  } else if (hasDirectives) {
    throwError(state, 'directives end mark is expected')
  }
  composeNode(state, state.lineIndent - 1, CONTEXT_BLOCK_OUT, false, true)
  skipSeparationSpace(state, true, -1)
  if (
    state.checkLineBreaks &&
    PATTERN_NON_ASCII_LINE_BREAKS.test(
      state.input.slice(documentStart, state.position)
    )
  ) {
    throwWarning(state, 'non-ASCII line breaks are interpreted as content')
  }
  state.documents.push(state.result)
  if (state.position === state.lineStart && testDocumentSeparator(state)) {
    if (state.input.charCodeAt(state.position) === 46) {
      state.position += 3
      skipSeparationSpace(state, true, -1)
    }
    return
  }
  if (state.position < state.length - 1) {
    throwError(state, 'end of the stream or a document separator is expected')
  } else {
    return
  }
}
function loadDocuments(input, options) {
  input = String(input)
  options = options || {}
  if (input.length !== 0) {
    if (
      input.charCodeAt(input.length - 1) !== 10 &&
      input.charCodeAt(input.length - 1) !== 13
    ) {
      input += '\n'
    }
    if (input.charCodeAt(0) === 65279) {
      input = input.slice(1)
    }
  }
  var state = new State$1(input, options)
  var nullpos = input.indexOf('\0')
  if (nullpos !== -1) {
    state.position = nullpos
    throwError(state, 'null byte is not allowed in input')
  }
  state.input += '\0'
  while (state.input.charCodeAt(state.position) === 32) {
    state.lineIndent += 1
    state.position += 1
  }
  while (state.position < state.length - 1) {
    readDocument(state)
  }
  return state.documents
}
function loadAll(input, iterator, options) {
  if (
    iterator !== null &&
    typeof iterator === 'object' &&
    typeof options === 'undefined'
  ) {
    options = iterator
    iterator = null
  }
  var documents = loadDocuments(input, options)
  if (typeof iterator !== 'function') {
    return documents
  }
  for (var index = 0, length = documents.length; index < length; index += 1) {
    iterator(documents[index])
  }
}
function load(input, options) {
  var documents = loadDocuments(input, options)
  if (documents.length === 0) {
    return undefined
  } else if (documents.length === 1) {
    return documents[0]
  }
  throw new YAMLException$1(
    'expected a single document in the stream, but found more'
  )
}
function safeLoadAll(input, iterator, options) {
  if (
    typeof iterator === 'object' &&
    iterator !== null &&
    typeof options === 'undefined'
  ) {
    options = iterator
    iterator = null
  }
  return loadAll(
    input,
    iterator,
    common$1.extend(
      {
        schema: DEFAULT_SAFE_SCHEMA$1,
      },
      options
    )
  )
}
function safeLoad(input, options) {
  return load(
    input,
    common$1.extend(
      {
        schema: DEFAULT_SAFE_SCHEMA$1,
      },
      options
    )
  )
}
loader$1.loadAll = loadAll
loader$1.load = load
loader$1.safeLoadAll = safeLoadAll
loader$1.safeLoad = safeLoad
var dumper$1 = {}
var common = common$6
var YAMLException = exception
var DEFAULT_FULL_SCHEMA = default_full
var DEFAULT_SAFE_SCHEMA = default_safe
var _toString = Object.prototype.toString
var _hasOwnProperty = Object.prototype.hasOwnProperty
var CHAR_TAB = 9
var CHAR_LINE_FEED = 10
var CHAR_CARRIAGE_RETURN = 13
var CHAR_SPACE = 32
var CHAR_EXCLAMATION = 33
var CHAR_DOUBLE_QUOTE = 34
var CHAR_SHARP = 35
var CHAR_PERCENT = 37
var CHAR_AMPERSAND = 38
var CHAR_SINGLE_QUOTE = 39
var CHAR_ASTERISK = 42
var CHAR_COMMA = 44
var CHAR_MINUS = 45
var CHAR_COLON = 58
var CHAR_EQUALS = 61
var CHAR_GREATER_THAN = 62
var CHAR_QUESTION = 63
var CHAR_COMMERCIAL_AT = 64
var CHAR_LEFT_SQUARE_BRACKET = 91
var CHAR_RIGHT_SQUARE_BRACKET = 93
var CHAR_GRAVE_ACCENT = 96
var CHAR_LEFT_CURLY_BRACKET = 123
var CHAR_VERTICAL_LINE = 124
var CHAR_RIGHT_CURLY_BRACKET = 125
var ESCAPE_SEQUENCES = {}
ESCAPE_SEQUENCES[0] = '\\0'
ESCAPE_SEQUENCES[7] = '\\a'
ESCAPE_SEQUENCES[8] = '\\b'
ESCAPE_SEQUENCES[9] = '\\t'
ESCAPE_SEQUENCES[10] = '\\n'
ESCAPE_SEQUENCES[11] = '\\v'
ESCAPE_SEQUENCES[12] = '\\f'
ESCAPE_SEQUENCES[13] = '\\r'
ESCAPE_SEQUENCES[27] = '\\e'
ESCAPE_SEQUENCES[34] = '\\"'
ESCAPE_SEQUENCES[92] = '\\\\'
ESCAPE_SEQUENCES[133] = '\\N'
ESCAPE_SEQUENCES[160] = '\\_'
ESCAPE_SEQUENCES[8232] = '\\L'
ESCAPE_SEQUENCES[8233] = '\\P'
var DEPRECATED_BOOLEANS_SYNTAX = [
  'y',
  'Y',
  'yes',
  'Yes',
  'YES',
  'on',
  'On',
  'ON',
  'n',
  'N',
  'no',
  'No',
  'NO',
  'off',
  'Off',
  'OFF',
]
function compileStyleMap(schema, map) {
  var result, keys, index, length, tag, style, type
  if (map === null) return {}
  result = {}
  keys = Object.keys(map)
  for (index = 0, length = keys.length; index < length; index += 1) {
    tag = keys[index]
    style = String(map[tag])
    if (tag.slice(0, 2) === '!!') {
      tag = 'tag:yaml.org,2002:' + tag.slice(2)
    }
    type = schema.compiledTypeMap['fallback'][tag]
    if (type && _hasOwnProperty.call(type.styleAliases, style)) {
      style = type.styleAliases[style]
    }
    result[tag] = style
  }
  return result
}
function encodeHex(character) {
  var string, handle, length
  string = character.toString(16).toUpperCase()
  if (character <= 255) {
    handle = 'x'
    length = 2
  } else if (character <= 65535) {
    handle = 'u'
    length = 4
  } else if (character <= 4294967295) {
    handle = 'U'
    length = 8
  } else {
    throw new YAMLException(
      'code point within a string may not be greater than 0xFFFFFFFF'
    )
  }
  return '\\' + handle + common.repeat('0', length - string.length) + string
}
function State(options) {
  this.schema = options['schema'] || DEFAULT_FULL_SCHEMA
  this.indent = Math.max(1, options['indent'] || 2)
  this.noArrayIndent = options['noArrayIndent'] || false
  this.skipInvalid = options['skipInvalid'] || false
  this.flowLevel = common.isNothing(options['flowLevel'])
    ? -1
    : options['flowLevel']
  this.styleMap = compileStyleMap(this.schema, options['styles'] || null)
  this.sortKeys = options['sortKeys'] || false
  this.lineWidth = options['lineWidth'] || 80
  this.noRefs = options['noRefs'] || false
  this.noCompatMode = options['noCompatMode'] || false
  this.condenseFlow = options['condenseFlow'] || false
  this.implicitTypes = this.schema.compiledImplicit
  this.explicitTypes = this.schema.compiledExplicit
  this.tag = null
  this.result = ''
  this.duplicates = []
  this.usedDuplicates = null
}
function indentString(string, spaces) {
  var ind = common.repeat(' ', spaces),
    position = 0,
    next = -1,
    result = '',
    line,
    length = string.length
  while (position < length) {
    next = string.indexOf('\n', position)
    if (next === -1) {
      line = string.slice(position)
      position = length
    } else {
      line = string.slice(position, next + 1)
      position = next + 1
    }
    if (line.length && line !== '\n') result += ind
    result += line
  }
  return result
}
function generateNextLine(state, level) {
  return '\n' + common.repeat(' ', state.indent * level)
}
function testImplicitResolving(state, str) {
  var index, length, type
  for (
    index = 0, length = state.implicitTypes.length;
    index < length;
    index += 1
  ) {
    type = state.implicitTypes[index]
    if (type.resolve(str)) {
      return true
    }
  }
  return false
}
function isWhitespace(c) {
  return c === CHAR_SPACE || c === CHAR_TAB
}
function isPrintable(c) {
  return (
    (32 <= c && c <= 126) ||
    (161 <= c && c <= 55295 && c !== 8232 && c !== 8233) ||
    (57344 <= c && c <= 65533 && c !== 65279) ||
    (65536 <= c && c <= 1114111)
  )
}
function isNsChar(c) {
  return (
    isPrintable(c) &&
    !isWhitespace(c) &&
    c !== 65279 &&
    c !== CHAR_CARRIAGE_RETURN &&
    c !== CHAR_LINE_FEED
  )
}
function isPlainSafe(c, prev) {
  return (
    isPrintable(c) &&
    c !== 65279 &&
    c !== CHAR_COMMA &&
    c !== CHAR_LEFT_SQUARE_BRACKET &&
    c !== CHAR_RIGHT_SQUARE_BRACKET &&
    c !== CHAR_LEFT_CURLY_BRACKET &&
    c !== CHAR_RIGHT_CURLY_BRACKET &&
    c !== CHAR_COLON &&
    (c !== CHAR_SHARP || (prev && isNsChar(prev)))
  )
}
function isPlainSafeFirst(c) {
  return (
    isPrintable(c) &&
    c !== 65279 &&
    !isWhitespace(c) &&
    c !== CHAR_MINUS &&
    c !== CHAR_QUESTION &&
    c !== CHAR_COLON &&
    c !== CHAR_COMMA &&
    c !== CHAR_LEFT_SQUARE_BRACKET &&
    c !== CHAR_RIGHT_SQUARE_BRACKET &&
    c !== CHAR_LEFT_CURLY_BRACKET &&
    c !== CHAR_RIGHT_CURLY_BRACKET &&
    c !== CHAR_SHARP &&
    c !== CHAR_AMPERSAND &&
    c !== CHAR_ASTERISK &&
    c !== CHAR_EXCLAMATION &&
    c !== CHAR_VERTICAL_LINE &&
    c !== CHAR_EQUALS &&
    c !== CHAR_GREATER_THAN &&
    c !== CHAR_SINGLE_QUOTE &&
    c !== CHAR_DOUBLE_QUOTE &&
    c !== CHAR_PERCENT &&
    c !== CHAR_COMMERCIAL_AT &&
    c !== CHAR_GRAVE_ACCENT
  )
}
function needIndentIndicator(string) {
  var leadingSpaceRe = /^\n* /
  return leadingSpaceRe.test(string)
}
var STYLE_PLAIN = 1,
  STYLE_SINGLE = 2,
  STYLE_LITERAL = 3,
  STYLE_FOLDED = 4,
  STYLE_DOUBLE = 5
function chooseScalarStyle(
  string,
  singleLineOnly,
  indentPerLevel,
  lineWidth,
  testAmbiguousType
) {
  var i
  var char, prev_char
  var hasLineBreak = false
  var hasFoldableLine = false
  var shouldTrackWidth = lineWidth !== -1
  var previousLineBreak = -1
  var plain =
    isPlainSafeFirst(string.charCodeAt(0)) &&
    !isWhitespace(string.charCodeAt(string.length - 1))
  if (singleLineOnly) {
    for (i = 0; i < string.length; i++) {
      char = string.charCodeAt(i)
      if (!isPrintable(char)) {
        return STYLE_DOUBLE
      }
      prev_char = i > 0 ? string.charCodeAt(i - 1) : null
      plain = plain && isPlainSafe(char, prev_char)
    }
  } else {
    for (i = 0; i < string.length; i++) {
      char = string.charCodeAt(i)
      if (char === CHAR_LINE_FEED) {
        hasLineBreak = true
        if (shouldTrackWidth) {
          hasFoldableLine =
            hasFoldableLine ||
            (i - previousLineBreak - 1 > lineWidth &&
              string[previousLineBreak + 1] !== ' ')
          previousLineBreak = i
        }
      } else if (!isPrintable(char)) {
        return STYLE_DOUBLE
      }
      prev_char = i > 0 ? string.charCodeAt(i - 1) : null
      plain = plain && isPlainSafe(char, prev_char)
    }
    hasFoldableLine =
      hasFoldableLine ||
      (shouldTrackWidth &&
        i - previousLineBreak - 1 > lineWidth &&
        string[previousLineBreak + 1] !== ' ')
  }
  if (!hasLineBreak && !hasFoldableLine) {
    return plain && !testAmbiguousType(string) ? STYLE_PLAIN : STYLE_SINGLE
  }
  if (indentPerLevel > 9 && needIndentIndicator(string)) {
    return STYLE_DOUBLE
  }
  return hasFoldableLine ? STYLE_FOLDED : STYLE_LITERAL
}
function writeScalar(state, string, level, iskey) {
  state.dump = (function () {
    if (string.length === 0) {
      return "''"
    }
    if (
      !state.noCompatMode &&
      DEPRECATED_BOOLEANS_SYNTAX.indexOf(string) !== -1
    ) {
      return "'" + string + "'"
    }
    var indent = state.indent * Math.max(1, level)
    var lineWidth =
      state.lineWidth === -1
        ? -1
        : Math.max(Math.min(state.lineWidth, 40), state.lineWidth - indent)
    var singleLineOnly =
      iskey || (state.flowLevel > -1 && level >= state.flowLevel)
    function testAmbiguity(string) {
      return testImplicitResolving(state, string)
    }
    switch (
      chooseScalarStyle(
        string,
        singleLineOnly,
        state.indent,
        lineWidth,
        testAmbiguity
      )
    ) {
      case STYLE_PLAIN:
        return string

      case STYLE_SINGLE:
        return "'" + string.replace(/'/g, "''") + "'"

      case STYLE_LITERAL:
        return (
          '|' +
          blockHeader(string, state.indent) +
          dropEndingNewline(indentString(string, indent))
        )

      case STYLE_FOLDED:
        return (
          '>' +
          blockHeader(string, state.indent) +
          dropEndingNewline(indentString(foldString(string, lineWidth), indent))
        )

      case STYLE_DOUBLE:
        return '"' + escapeString(string) + '"'

      default:
        throw new YAMLException('impossible error: invalid scalar style')
    }
  })()
}
function blockHeader(string, indentPerLevel) {
  var indentIndicator = needIndentIndicator(string)
    ? String(indentPerLevel)
    : ''
  var clip = string[string.length - 1] === '\n'
  var keep = clip && (string[string.length - 2] === '\n' || string === '\n')
  var chomp = keep ? '+' : clip ? '' : '-'
  return indentIndicator + chomp + '\n'
}
function dropEndingNewline(string) {
  return string[string.length - 1] === '\n' ? string.slice(0, -1) : string
}
function foldString(string, width) {
  var lineRe = /(\n+)([^\n]*)/g
  var result = (function () {
    var nextLF = string.indexOf('\n')
    nextLF = nextLF !== -1 ? nextLF : string.length
    lineRe.lastIndex = nextLF
    return foldLine(string.slice(0, nextLF), width)
  })()
  var prevMoreIndented = string[0] === '\n' || string[0] === ' '
  var moreIndented
  var match
  while ((match = lineRe.exec(string))) {
    var prefix = match[1],
      line = match[2]
    moreIndented = line[0] === ' '
    result +=
      prefix +
      (!prevMoreIndented && !moreIndented && line !== '' ? '\n' : '') +
      foldLine(line, width)
    prevMoreIndented = moreIndented
  }
  return result
}
function foldLine(line, width) {
  if (line === '' || line[0] === ' ') return line
  var breakRe = / [^ ]/g
  var match
  var start = 0,
    end,
    curr = 0,
    next = 0
  var result = ''
  while ((match = breakRe.exec(line))) {
    next = match.index
    if (next - start > width) {
      end = curr > start ? curr : next
      result += '\n' + line.slice(start, end)
      start = end + 1
    }
    curr = next
  }
  result += '\n'
  if (line.length - start > width && curr > start) {
    result += line.slice(start, curr) + '\n' + line.slice(curr + 1)
  } else {
    result += line.slice(start)
  }
  return result.slice(1)
}
function escapeString(string) {
  var result = ''
  var char, nextChar
  var escapeSeq
  for (var i = 0; i < string.length; i++) {
    char = string.charCodeAt(i)
    if (char >= 55296 && char <= 56319) {
      nextChar = string.charCodeAt(i + 1)
      if (nextChar >= 56320 && nextChar <= 57343) {
        result += encodeHex((char - 55296) * 1024 + nextChar - 56320 + 65536)
        i++
        continue
      }
    }
    escapeSeq = ESCAPE_SEQUENCES[char]
    result +=
      !escapeSeq && isPrintable(char) ? string[i] : escapeSeq || encodeHex(char)
  }
  return result
}
function writeFlowSequence(state, level, object) {
  var _result = '',
    _tag = state.tag,
    index,
    length
  for (index = 0, length = object.length; index < length; index += 1) {
    if (writeNode(state, level, object[index], false, false)) {
      if (index !== 0) _result += ',' + (!state.condenseFlow ? ' ' : '')
      _result += state.dump
    }
  }
  state.tag = _tag
  state.dump = '[' + _result + ']'
}
function writeBlockSequence(state, level, object, compact) {
  var _result = '',
    _tag = state.tag,
    index,
    length
  for (index = 0, length = object.length; index < length; index += 1) {
    if (writeNode(state, level + 1, object[index], true, true)) {
      if (!compact || index !== 0) {
        _result += generateNextLine(state, level)
      }
      if (state.dump && CHAR_LINE_FEED === state.dump.charCodeAt(0)) {
        _result += '-'
      } else {
        _result += '- '
      }
      _result += state.dump
    }
  }
  state.tag = _tag
  state.dump = _result || '[]'
}
function writeFlowMapping(state, level, object) {
  var _result = '',
    _tag = state.tag,
    objectKeyList = Object.keys(object),
    index,
    length,
    objectKey,
    objectValue,
    pairBuffer
  for (index = 0, length = objectKeyList.length; index < length; index += 1) {
    pairBuffer = ''
    if (index !== 0) pairBuffer += ', '
    if (state.condenseFlow) pairBuffer += '"'
    objectKey = objectKeyList[index]
    objectValue = object[objectKey]
    if (!writeNode(state, level, objectKey, false, false)) {
      continue
    }
    if (state.dump.length > 1024) pairBuffer += '? '
    pairBuffer +=
      state.dump +
      (state.condenseFlow ? '"' : '') +
      ':' +
      (state.condenseFlow ? '' : ' ')
    if (!writeNode(state, level, objectValue, false, false)) {
      continue
    }
    pairBuffer += state.dump
    _result += pairBuffer
  }
  state.tag = _tag
  state.dump = '{' + _result + '}'
}
function writeBlockMapping(state, level, object, compact) {
  var _result = '',
    _tag = state.tag,
    objectKeyList = Object.keys(object),
    index,
    length,
    objectKey,
    objectValue,
    explicitPair,
    pairBuffer
  if (state.sortKeys === true) {
    objectKeyList.sort()
  } else if (typeof state.sortKeys === 'function') {
    objectKeyList.sort(state.sortKeys)
  } else if (state.sortKeys) {
    throw new YAMLException('sortKeys must be a boolean or a function')
  }
  for (index = 0, length = objectKeyList.length; index < length; index += 1) {
    pairBuffer = ''
    if (!compact || index !== 0) {
      pairBuffer += generateNextLine(state, level)
    }
    objectKey = objectKeyList[index]
    objectValue = object[objectKey]
    if (!writeNode(state, level + 1, objectKey, true, true, true)) {
      continue
    }
    explicitPair =
      (state.tag !== null && state.tag !== '?') ||
      (state.dump && state.dump.length > 1024)
    if (explicitPair) {
      if (state.dump && CHAR_LINE_FEED === state.dump.charCodeAt(0)) {
        pairBuffer += '?'
      } else {
        pairBuffer += '? '
      }
    }
    pairBuffer += state.dump
    if (explicitPair) {
      pairBuffer += generateNextLine(state, level)
    }
    if (!writeNode(state, level + 1, objectValue, true, explicitPair)) {
      continue
    }
    if (state.dump && CHAR_LINE_FEED === state.dump.charCodeAt(0)) {
      pairBuffer += ':'
    } else {
      pairBuffer += ': '
    }
    pairBuffer += state.dump
    _result += pairBuffer
  }
  state.tag = _tag
  state.dump = _result || '{}'
}
function detectType(state, object, explicit) {
  var _result, typeList, index, length, type, style
  typeList = explicit ? state.explicitTypes : state.implicitTypes
  for (index = 0, length = typeList.length; index < length; index += 1) {
    type = typeList[index]
    if (
      (type.instanceOf || type.predicate) &&
      (!type.instanceOf ||
        (typeof object === 'object' && object instanceof type.instanceOf)) &&
      (!type.predicate || type.predicate(object))
    ) {
      state.tag = explicit ? type.tag : '?'
      if (type.represent) {
        style = state.styleMap[type.tag] || type.defaultStyle
        if (_toString.call(type.represent) === '[object Function]') {
          _result = type.represent(object, style)
        } else if (_hasOwnProperty.call(type.represent, style)) {
          _result = type.represent[style](object, style)
        } else {
          throw new YAMLException(
            '!<' + type.tag + '> tag resolver accepts not "' + style + '" style'
          )
        }
        state.dump = _result
      }
      return true
    }
  }
  return false
}
function writeNode(state, level, object, block, compact, iskey) {
  state.tag = null
  state.dump = object
  if (!detectType(state, object, false)) {
    detectType(state, object, true)
  }
  var type = _toString.call(state.dump)
  if (block) {
    block = state.flowLevel < 0 || state.flowLevel > level
  }
  var objectOrArray = type === '[object Object]' || type === '[object Array]',
    duplicateIndex,
    duplicate
  if (objectOrArray) {
    duplicateIndex = state.duplicates.indexOf(object)
    duplicate = duplicateIndex !== -1
  }
  if (
    (state.tag !== null && state.tag !== '?') ||
    duplicate ||
    (state.indent !== 2 && level > 0)
  ) {
    compact = false
  }
  if (duplicate && state.usedDuplicates[duplicateIndex]) {
    state.dump = '*ref_' + duplicateIndex
  } else {
    if (objectOrArray && duplicate && !state.usedDuplicates[duplicateIndex]) {
      state.usedDuplicates[duplicateIndex] = true
    }
    if (type === '[object Object]') {
      if (block && Object.keys(state.dump).length !== 0) {
        writeBlockMapping(state, level, state.dump, compact)
        if (duplicate) {
          state.dump = '&ref_' + duplicateIndex + state.dump
        }
      } else {
        writeFlowMapping(state, level, state.dump)
        if (duplicate) {
          state.dump = '&ref_' + duplicateIndex + ' ' + state.dump
        }
      }
    } else if (type === '[object Array]') {
      var arrayLevel = state.noArrayIndent && level > 0 ? level - 1 : level
      if (block && state.dump.length !== 0) {
        writeBlockSequence(state, arrayLevel, state.dump, compact)
        if (duplicate) {
          state.dump = '&ref_' + duplicateIndex + state.dump
        }
      } else {
        writeFlowSequence(state, arrayLevel, state.dump)
        if (duplicate) {
          state.dump = '&ref_' + duplicateIndex + ' ' + state.dump
        }
      }
    } else if (type === '[object String]') {
      if (state.tag !== '?') {
        writeScalar(state, state.dump, level, iskey)
      }
    } else {
      if (state.skipInvalid) return false
      throw new YAMLException('unacceptable kind of an object to dump ' + type)
    }
    if (state.tag !== null && state.tag !== '?') {
      state.dump = '!<' + state.tag + '> ' + state.dump
    }
  }
  return true
}
function getDuplicateReferences(object, state) {
  var objects = [],
    duplicatesIndexes = [],
    index,
    length
  inspectNode(object, objects, duplicatesIndexes)
  for (
    index = 0, length = duplicatesIndexes.length;
    index < length;
    index += 1
  ) {
    state.duplicates.push(objects[duplicatesIndexes[index]])
  }
  state.usedDuplicates = new Array(length)
}
function inspectNode(object, objects, duplicatesIndexes) {
  var objectKeyList, index, length
  if (object !== null && typeof object === 'object') {
    index = objects.indexOf(object)
    if (index !== -1) {
      if (duplicatesIndexes.indexOf(index) === -1) {
        duplicatesIndexes.push(index)
      }
    } else {
      objects.push(object)
      if (Array.isArray(object)) {
        for (index = 0, length = object.length; index < length; index += 1) {
          inspectNode(object[index], objects, duplicatesIndexes)
        }
      } else {
        objectKeyList = Object.keys(object)
        for (
          index = 0, length = objectKeyList.length;
          index < length;
          index += 1
        ) {
          inspectNode(object[objectKeyList[index]], objects, duplicatesIndexes)
        }
      }
    }
  }
}
function dump(input, options) {
  options = options || {}
  var state = new State(options)
  if (!state.noRefs) getDuplicateReferences(input, state)
  if (writeNode(state, 0, input, true, true)) return state.dump + '\n'
  return ''
}
function safeDump(input, options) {
  return dump(
    input,
    common.extend(
      {
        schema: DEFAULT_SAFE_SCHEMA,
      },
      options
    )
  )
}
dumper$1.dump = dump
dumper$1.safeDump = safeDump
var loader = loader$1
var dumper = dumper$1
function deprecated(name) {
  return function () {
    throw new Error('Function ' + name + ' is deprecated and cannot be used.')
  }
}
jsYaml$1.Type = type
jsYaml$1.Schema = schema
jsYaml$1.FAILSAFE_SCHEMA = failsafe
jsYaml$1.JSON_SCHEMA = json
jsYaml$1.CORE_SCHEMA = core
jsYaml$1.DEFAULT_SAFE_SCHEMA = default_safe
jsYaml$1.DEFAULT_FULL_SCHEMA = default_full
jsYaml$1.load = loader.load
jsYaml$1.loadAll = loader.loadAll
jsYaml$1.safeLoad = loader.safeLoad
jsYaml$1.safeLoadAll = loader.safeLoadAll
jsYaml$1.dump = dumper.dump
jsYaml$1.safeDump = dumper.safeDump
jsYaml$1.YAMLException = exception
jsYaml$1.MINIMAL_SCHEMA = failsafe
jsYaml$1.SAFE_SCHEMA = default_safe
jsYaml$1.DEFAULT_SCHEMA = default_full
jsYaml$1.scan = deprecated('scan')
jsYaml$1.parse = deprecated('parse')
jsYaml$1.compose = deprecated('compose')
jsYaml$1.addConstructor = deprecated('addConstructor')
var yaml = jsYaml$1
var jsYaml = yaml
var parser = jsYaml
var optionalByteOrderMark = '\\ufeff?'
var platform = typeof process !== 'undefined' ? process.platform : ''
var pattern =
  '^(' +
  optionalByteOrderMark +
  '(= yaml =|---)' +
  '$([\\s\\S]*?)' +
  '^(?:\\2|\\.\\.\\.)\\s*' +
  '$' +
  (platform === 'win32' ? '\\r?' : '') +
  '(?:\\n)?)'
var regex = new RegExp(pattern, 'm')
frontMatter.exports = extractor
frontMatter.exports.test = test
function extractor(string, options) {
  string = string || ''
  var defaultOptions = {
    allowUnsafe: false,
  }
  options =
    options instanceof Object
      ? {
          ...defaultOptions,
          ...options,
        }
      : defaultOptions
  options.allowUnsafe = Boolean(options.allowUnsafe)
  var lines = string.split(/(\r?\n)/)
  if (lines[0] && /= yaml =|---/.test(lines[0])) {
    return parse(string, options.allowUnsafe)
  } else {
    return {
      attributes: {},
      body: string,
      bodyBegin: 1,
    }
  }
}
function computeLocation(match, body) {
  var line = 1
  var pos = body.indexOf('\n')
  var offset = match.index + match[0].length
  while (pos !== -1) {
    if (pos >= offset) {
      return line
    }
    line++
    pos = body.indexOf('\n', pos + 1)
  }
  return line
}
function parse(string, allowUnsafe) {
  var match = regex.exec(string)
  if (!match) {
    return {
      attributes: {},
      body: string,
      bodyBegin: 1,
    }
  }
  var loader = allowUnsafe ? parser.load : parser.safeLoad
  var yaml = match[match.length - 1].replace(/^\s+|\s+$/g, '')
  var attributes = loader(yaml) || {}
  var body = string.replace(match[0], '')
  var line = computeLocation(match, string)
  return {
    attributes: attributes,
    body: body,
    bodyBegin: line,
    frontmatter: yaml,
  }
}
function test(string) {
  string = string || ''
  return regex.test(string)
}
var fm = frontMatter.exports
const pluginJson = 'helpers/NPFrontMatter.js'
function quoteText(text) {
  const needsQuoting =
    text.includes(': ') ||
    /:$/.test(text) ||
    /^#\S/.test(text) ||
    /^@/.test(text) ||
    text === ''
  const isWrappedInQuotes = /^".*"$/.test(text)
  return needsQuoting && !isWrappedInQuotes ? '"'.concat(text, '"') : text
}
const hasFrontMatter = (text) =>
  text.split('\n', 1)[0] === '---' &&
  fm.test(_sanitizeFrontmatterText(text, true))
const noteHasFrontMatter = (note) => {
  var _note$paragraphs
  return (
    note &&
    hasFrontMatter(note.content || '') &&
    ((_note$paragraphs = note.paragraphs) === null ||
    _note$paragraphs === void 0
      ? void 0
      : _note$paragraphs.length) >= 2 &&
    (note.paragraphs[0].type === 'separator' ||
      note.paragraphs[0].content === '---')
  )
}
const getFrontMatterAttributes = (note) =>
  hasFrontMatter(
    (note === null || note === void 0 ? void 0 : note.content) || ''
  )
    ? getAttributes(note.content)
    : false
const getFrontMatterParagraphs = function (note) {
  let includeSeparators =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false
  try {
    const paras =
      (note === null || note === void 0 ? void 0 : note.paragraphs) || []
    if (!paras.length || paras[0].content !== '---') return false
    const startAt = includeSeparators ? 0 : 1
    for (let i = 1; i < paras.length; i++) {
      const para = paras[i]
      if (para.content === '---')
        return paras.slice(startAt, includeSeparators ? i + 1 : i)
    }
    return false
  } catch (err) {
    logError('NPFrontMatter/getFrontMatterParagraphs()', JSP(err))
    return false
  }
}
function removeFrontMatter(note) {
  let removeSeparators =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false
  try {
    const fmParas = getFrontMatterParagraphs(note, removeSeparators)
    if (!fmParas) return false
    const fm = getFrontMatterAttributes(note || '')
    note.removeParagraphs(fmParas)
    if (removeSeparators && fm && fm.title)
      note.prependParagraph('# '.concat(fm.title), 'text')
    return true
  } catch (err) {
    logError('NPFrontMatter/removeFrontMatter()', JSP(err))
    return false
  }
}
function _objectToYaml(obj) {
  let indent =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' '
  let output = ''
  for (const prop in obj) {
    output += '\n'.concat(indent).concat(prop, ':')
    if (Array.isArray(obj[prop])) {
      obj[prop].forEach((el) => {
        output += '\n'.concat(indent, ' - ').concat(el)
      })
    } else if (
      typeof obj[prop] === 'object' &&
      obj[prop] !== null &&
      Object.keys(obj[prop]).length
    ) {
      output += _objectToYaml(obj[prop], ''.concat(indent, ' '))
    } else {
      output += ' '.concat(obj[prop])
    }
  }
  return output
}
function writeFrontMatter(note, attributes) {
  let alsoEnsureTitle =
    arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true
  let quoteNonStandardYaml =
    arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false
  if (!noteHasFrontMatter(note)) {
    logError(
      pluginJson,
      'writeFrontMatter: no frontmatter already found in note, so stopping.'
    )
    return false
  }
  if (ensureFrontmatter(note, alsoEnsureTitle)) {
    const outputArr = []
    Object.keys(attributes).forEach((key) => {
      const value = attributes[key]
      if (value !== null) {
        if (typeof value === 'string') {
          outputArr.push(
            quoteNonStandardYaml
              ? ''.concat(key, ': ').concat(quoteText(value))
              : ''.concat(key, ': ').concat(value)
          )
        } else {
          if (typeof value === 'object') {
            logDebug(
              pluginJson,
              "writeFrontMatter: value for key '".concat(
                key,
                "' is an object (e.g. multi-level list). Converting to multi-line string."
              )
            )
            const yamlString = _objectToYaml(value)
            outputArr.push(''.concat(key, ':').concat(yamlString))
          }
        }
      }
    })
    const output = outputArr.join('\n')
    note.insertParagraph(output, 1, 'text')
    return true
  } else {
    logError(
      pluginJson,
      'writeFrontMatter: Could not write frontmatter for note "'.concat(
        note.filename || '',
        '" for some reason.'
      )
    )
  }
  return false
}
const hasTemplateTagsInFM = (fmText) => fmText.includes('<%')
function setFrontMatterVars(note, varObj) {
  try {
    const title = varObj.title || null
    logDebug(
      'setFrontMatterVars',
      'Note "'
        .concat(title || '', '" BEFORE: hasFrontmatter:')
        .concat(String(noteHasFrontMatter(note) || ''), ' note has ')
        .concat(note.paragraphs.length, ' lines')
    )
    const hasFM = ensureFrontmatter(note, true, title)
    if (!hasFM) {
      throw new Error(
        'setFrontMatterVars: Could not add front matter to note which has no title. Note should have a title, or you should pass in a title in the varObj.'
      )
    }
    if (hasFrontMatter(note.content || '')) {
      const existingAttributes = getAttributes(note.content)
      const changedAttributes = _objectSpread2({}, existingAttributes)
      Object.keys(varObj).forEach((key) => {
        if (varObj[key] === null && existingAttributes.hasOwnProperty(key)) {
          delete changedAttributes[key]
        } else {
          changedAttributes[key] = String(varObj[key])
        }
      })
      removeFrontMatter(note)
      writeFrontMatter(note, changedAttributes)
      logDebug(
        'setFrontMatterVars',
        '- ending with '.concat(note.paragraphs.length, ' lines')
      )
    } else {
      logError(
        'setFrontMatterVars',
        '- could not change frontmatter for note "'.concat(
          note.filename || '',
          '" because it has no frontmatter.'
        )
      )
    }
    return true
  } catch (error) {
    logError('NPFrontMatter/setFrontMatterVars()', JSP(error))
    return false
  }
}
function ensureFrontmatter(note) {
  let alsoEnsureTitle =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true
  let title = arguments.length > 2 ? arguments[2] : undefined
  try {
    let retVal = false
    if (note == null) {
      logError('ensureFrontmatter', 'No note found. Stopping conversion.')
    } else if (hasFrontMatter(note.content || '')) {
      const attr = getAttributes(note.content)
      clo(
        attr,
        "ensureFrontmatter: Note '".concat(
          displayTitle(note),
          "' has frontmatter already: attr ="
        )
      )
      if (!attr.title && title) {
        logDebug(
          'ensureFrontmatter',
          "Note '".concat(
            displayTitle(note),
            "' already has frontmatter but no title. Adding title."
          )
        )
        if (note.content)
          note.content = note.content.replace(
            '---',
            '---\ntitle: '.concat(title, '\n')
          )
      } else if (title && attr.title !== title) {
        logDebug(
          'ensureFrontmatter',
          "Note '".concat(
            displayTitle(note),
            "' already has frontmatter but title is wrong. Updating title."
          )
        )
        if (note.content)
          note.content = note.content.replace(
            'title: '.concat(attr.title),
            'title: '.concat(title)
          )
      }
      retVal = true
    } else {
      let newTitle
      let front = ''
      if (note.type === 'Notes' && alsoEnsureTitle) {
        var _newTitle
        logDebug(
          'ensureFrontmatter',
          "'".concat(
            note.filename,
            "' had no frontmatter or title line, so will now make one:"
          )
        )
        const firstLine = note.paragraphs.length ? note.paragraphs[0] : {}
        const titleFromFirstLine =
          firstLine.type === 'title' && firstLine.headingLevel === 1
            ? firstLine.content
            : ''
        newTitle = (title || titleFromFirstLine || note.title || '').replace(
          /`/g,
          ''
        )
        logDebug(
          'ensureFrontmatter',
          "- newTitle='".concat(
            (_newTitle = newTitle) !== null && _newTitle !== void 0
              ? _newTitle
              : '',
            "'"
          )
        )
        if (newTitle === '') {
          logError(
            'ensureFrontmatter',
            "Cannot find title for '".concat(
              note.filename,
              "'. Stopping conversion."
            )
          )
        }
        if (titleFromFirstLine) note.removeParagraph(note.paragraphs[0])
        front = '---\ntitle: '.concat(quoteText(newTitle), '\n---\n')
      } else {
        front = '---\n---\n'
      }
      const newContent = ''
        .concat(front)
        .concat(
          (note === null || note === void 0 ? void 0 : note.content) || ''
        )
      note.content = ''
      note.insertParagraph(newContent, 0, 'text')
      retVal = true
      logDebug(
        'ensureFrontmatter',
        "-> Note '".concat(
          displayTitle(note),
          "' converted to use frontmatter."
        )
      )
    }
    return retVal
  } catch (error) {
    logError('NPFrontMatter/ensureFrontmattter()', JSP(error))
    return false
  }
}
function _getFMText(text) {
  const lines = text.split('\n')
  if (lines.length >= 2 && lines[0] === '---') {
    let fmText = ''
    let i = 0
    while (i < lines.length) {
      fmText += ''.concat(lines[i], '\n')
      i++
      if (lines[i] === '---') {
        return ''.concat(fmText, '---\n')
      }
    }
  }
  return ''
}
function _fixFrontmatter(fmText) {
  const varLines = fmText.trim().split('\n').slice(1, -1)
  let output = '',
    isMultiline = false
  varLines.forEach((line) => {
    if (line.trim() === '') {
      output += '\n'
      return
    }
    if (isMultiline && !line.trim().startsWith('-')) {
      isMultiline = false
    }
    if (
      !isMultiline &&
      line.trim().endsWith(':') &&
      line.split(':').length === 2
    ) {
      isMultiline = true
      output += ''.concat(line, '\n')
      return
    }
    if (isMultiline) {
      output += ''.concat(line.trimEnd(), '\n')
      return
    }
    const [varName, ...varValue] = line.split(':')
    const value = varValue.join(':').trim()
    const fixedValue = quoteText(value)
    output += ''.concat(varName, ': ').concat(fixedValue, '\n')
  })
  return '---\n'.concat(output, '---\n')
}
function _sanitizeFrontmatterText(originalText) {
  let removeTemplateTagsInFM =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false
  const unfilteredFmText = _getFMText(originalText)
  const hasTags = hasTemplateTagsInFM(unfilteredFmText)
  const fmTextWithoutTags =
    removeTemplateTagsInFM && hasTags
      ? unfilteredFmText
          .split('\n')
          .filter((line) => !line.includes('<%'))
          .join('\n')
      : unfilteredFmText
  if (fmTextWithoutTags === '') return originalText
  const fixedText = _fixFrontmatter(fmTextWithoutTags)
  return originalText.replace(unfilteredFmText, fixedText)
}
function getSanitizedFmParts(noteText) {
  let removeTemplateTagsInFM =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false
  let fmData = {
    attributes: {},
    body: noteText,
    frontmatter: '',
  }
  const sanitizedText = _sanitizeFrontmatterText(
    noteText || '',
    removeTemplateTagsInFM
  )
  try {
    fmData = fm(sanitizedText, {
      allowUnsafe: true,
    })
  } catch (error) {
    logError(
      'Frontmatter getAttributes error. COULD NOT SANITIZE CONTENT: "'
        .concat(error.message, '". Returning empty values for this note: "')
        .concat(JSON.stringify(noteText), '"')
    )
  }
  return fmData
}
function getAttributes() {
  let templateData =
    arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
  let removeTemplateTagsInFM =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false
  const fmData = getSanitizedFmParts(templateData, removeTemplateTagsInFM)
  Object.keys(
    fmData === null || fmData === void 0 ? void 0 : fmData.attributes
  ).forEach((key) => {
    fmData.attributes[key] || typeof fmData.attributes[key] === 'boolean'
      ? fmData.attributes[key]
      : (fmData.attributes[key] = '')
  })
  return fmData && fmData !== null && fmData !== void 0 && fmData.attributes
    ? fmData.attributes
    : {}
}
class FrontmatterModule {
  constructor() {
    let NPTemplating =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null
    if (NPTemplating) {
      this.templatingInstance = NPTemplating
    }
  }
  isFrontmatterTemplate(templateData) {
    const parts = getSanitizedFmParts(templateData)
    return parts !== null &&
      parts !== void 0 &&
      parts.attributes &&
      Object.keys(parts.attributes).length
      ? true
      : false
  }
  getFrontmatterBlock(templateData) {
    const templateLines = templateData.split('\n')
    if (templateLines[0] === '---') {
      templateLines.shift()
      if (templateLines.indexOf('---') > 0) {
        return templateData
      }
    }
    return ''
  }
  getFrontmatterText(templateData) {
    return templateData.replace(this.body(templateData), '')
  }
  parse() {
    let template =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    if (this.isFrontmatterTemplate(template)) {
      const fmData = getSanitizedFmParts(template)
      Object.keys(
        fmData === null || fmData === void 0 ? void 0 : fmData.attributes
      ).forEach((key) => {
        fmData.attributes[key]
          ? fmData.attributes[key]
          : (fmData.attributes[key] = '')
      })
      return fmData
    } else {
      return {}
    }
  }
  attributes() {
    let templateData =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    try {
      const fmData = getSanitizedFmParts(templateData)
      Object.keys(
        fmData === null || fmData === void 0 ? void 0 : fmData.attributes
      ).forEach((key) => {
        fmData.attributes[key]
          ? fmData.attributes[key]
          : (fmData.attributes[key] = '')
      })
      return fmData && fmData !== null && fmData !== void 0 && fmData.attributes
        ? fmData.attributes
        : {}
    } catch (error) {
      return {}
    }
  }
  body() {
    let templateData =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    const fmData = getSanitizedFmParts(templateData)
    return fmData && fmData !== null && fmData !== void 0 && fmData.body
      ? fmData.body
      : ''
  }
  convertProjectNoteToFrontmatter() {
    let projectNote =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    if (this.isFrontmatterTemplate(projectNote)) {
      return -3
    }
    let note = projectNote
    if (note.length === 0) {
      return -1
    }
    const lines = note.split('\n')
    if (lines.length === 0) {
      return -1
    }
    let title = lines.shift()
    if (!title.startsWith('#')) {
      return -2
    }
    title = title.substr(2)
    note = lines.join('\n')
    let frontmatter = '---\n'
    frontmatter += 'title: '.concat(title, '\n')
    frontmatter += 'type: empty-note\n'
    frontmatter += '---\n'
    note = ''.concat(frontmatter).concat(note)
    return note
  }
}
const DAY_NUMBER_SUNDAY = 0
const DAY_NUMBER_MONDAY = 1
const DAY_NUMBER_TUESDAY = 2
const DAY_NUMBER_WEDNESDAY = 3
const DAY_NUMBER_THURSDAY = 4
const DAY_NUMBER_FRIDAY = 5
const DAY_NUMBER_SATURDAY = 6
function now() {
  let format =
    arguments.length > 0 && arguments[0] !== undefined
      ? arguments[0]
      : 'YYYY-MM-DD'
  return moment$1(new Date()).format(
    format && format.length > 0 ? format : 'YYYY-MM-DD'
  )
}
function timestamp() {
  let format =
    arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
  const nowFormat = format.length > 0 ? format : 'YYYY-MM-DD h:mm A'
  return now(nowFormat)
}
class DateModule {
  constructor() {
    var _this$config, _this$config$template, _this$config2
    let config =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}
    this.config = config
    const osLocale =
      ((_this$config = this.config) === null || _this$config === void 0
        ? void 0
        : (_this$config$template = _this$config.templateLocale) === null ||
            _this$config$template === void 0
          ? void 0
          : _this$config$template.length) > 0
        ? (_this$config2 = this.config) === null || _this$config2 === void 0
          ? void 0
          : _this$config2.templateLocale
        : 'en-US'
    moment$1.locale(osLocale)
    this.DAY_NUMBER_SUNDAY = DAY_NUMBER_SUNDAY
    this.DAY_NUMBER_MONDAY = DAY_NUMBER_MONDAY
    this.DAY_NUMBER_TUESDAY = DAY_NUMBER_TUESDAY
    this.DAY_NUMBER_WEDNESDAY = DAY_NUMBER_WEDNESDAY
    this.DAY_NUMBER_THURSDAY = DAY_NUMBER_THURSDAY
    this.DAY_NUMBER_FRIDAY = DAY_NUMBER_FRIDAY
    this.DAY_NUMBER_SATURDAY = DAY_NUMBER_SATURDAY
  }
  setLocale() {
    var _this$config3, _this$config3$templat, _this$config4
    const osLocale =
      ((_this$config3 = this.config) === null || _this$config3 === void 0
        ? void 0
        : (_this$config3$templat = _this$config3.templateLocale) === null ||
            _this$config3$templat === void 0
          ? void 0
          : _this$config3$templat.length) > 0
        ? (_this$config4 = this.config) === null || _this$config4 === void 0
          ? void 0
          : _this$config4.templateLocale
        : 'en-US'
    moment$1.locale(osLocale)
  }
  ref() {
    let value =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    return moment$1(value)
  }
  createDateTime() {
    let userDateString =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    return userDateString.length === 10
      ? new Date(''.concat(userDateString, 'T00:01:00'))
      : new Date()
  }
  timestamp() {
    var _this$config5
    this.setLocale()
    const nowFormat =
      ((_this$config5 = this.config) === null || _this$config5 === void 0
        ? void 0
        : _this$config5.timestampFormat) || 'YYYY-MM-DD h:mm A'
    return this.now(nowFormat)
  }
  format() {
    var _format, _this$config6, _this$config7
    let format =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let date =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ''
    format = (_format = format) !== null && _format !== void 0 ? _format : ''
    this.setLocale()
    let dateValue = date.length > 0 ? new Date(date) : new Date()
    if (date.length === 10) {
      dateValue = moment$1(date).format('YYYY-MM-DD')
    }
    if (date instanceof moment$1) {
      dateValue = new Date(date)
    }
    const configFormat =
      ((_this$config6 = this.config) === null || _this$config6 === void 0
        ? void 0
        : _this$config6.dateFormat) || 'YYYY-MM-DD'
    const locale =
      ((_this$config7 = this.config) === null || _this$config7 === void 0
        ? void 0
        : _this$config7.templateLocale) || 'en-US'
    format = format.length > 0 ? format : configFormat
    let formattedDate = moment$1(date).format(format)
    if (
      format === 'short' ||
      format === 'medium' ||
      format === 'long' ||
      format === 'full'
    ) {
      formattedDate = new Intl.DateTimeFormat(locale, {
        dateStyle: format,
      }).format(dateValue)
    }
    return formattedDate
  }
  now() {
    var _this$config8, _this$config9
    let format =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let offset =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ''
    const locale =
      ((_this$config8 = this.config) === null || _this$config8 === void 0
        ? void 0
        : _this$config8.templateLocale) || 'en-US'
    const configFormat =
      ((_this$config9 = this.config) === null || _this$config9 === void 0
        ? void 0
        : _this$config9.dateFormat) || 'YYYY-MM-DD'
    format = format.length > 0 ? format : configFormat
    const dateValue = new Date()
    this.setLocale()
    let formattedDate = moment$1(dateValue).format(format)
    if (offset) {
      offset = ''.concat(offset)
      let newDate = ''
      if (
        offset.match(
          /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/
        )
      ) {
        newDate = offset.includes('-')
          ? moment$1(dateValue).subtract(Math.abs(offset), 'days')
          : moment$1(dateValue).add(offset, 'days')
      } else {
        const shorthand = offset[offset.length - 1]
        const value = offset.replace(shorthand, '')
        newDate = offset.includes('-')
          ? moment$1(dateValue).subtract(Math.abs(value), shorthand)
          : moment$1(dateValue).add(value, shorthand)
      }
      formattedDate = moment$1(newDate).format(format)
    }
    if (
      format === 'short' ||
      format === 'medium' ||
      format === 'long' ||
      format === 'full'
    ) {
      formattedDate = new Intl.DateTimeFormat(locale, {
        dateStyle: format,
      }).format(new Date())
    }
    return this.isValid(formattedDate)
  }
  date8601() {
    return this.now()
  }
  today() {
    let format =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    this.setLocale()
    return this.format(format, new Date())
  }
  tomorrow() {
    var _this$config10
    let format =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    this.setLocale()
    const configFormat =
      ((_this$config10 = this.config) === null || _this$config10 === void 0
        ? void 0
        : _this$config10.dateFormat) || 'YYYY-MM-DD'
    format = format.length > 0 ? format : configFormat
    const dateValue = moment$1(new Date()).add(1, 'days')
    return this.format(format, dateValue)
  }
  yesterday() {
    var _this$config11
    let format =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    const configFormat =
      ((_this$config11 = this.config) === null || _this$config11 === void 0
        ? void 0
        : _this$config11.dateFormat) || 'YYYY-MM-DD'
    format = format.length > 0 ? format : configFormat
    const dateValue = moment$1(new Date()).subtract(1, 'days')
    return this.format(format, dateValue)
  }
  weekday() {
    var _this$config12
    let format =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let offset =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1
    let pivotDate =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ''
    const configFormat =
      ((_this$config12 = this.config) === null || _this$config12 === void 0
        ? void 0
        : _this$config12.dateFormat) || 'YYYY-MM-DD'
    format = format.length > 0 ? format : configFormat
    const offsetValue = typeof offset === 'number' ? offset : parseInt(offset)
    const dateValue =
      pivotDate.length === 0
        ? new Date()
        : new Date(this.createDateTime(pivotDate))
    return moment$1(dateValue).weekday(offsetValue).format(format)
  }
  weekNumber() {
    let pivotDate =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    this.setLocale()
    const dateValue = pivotDate.length === 10 ? pivotDate : new Date()
    const dateStr = moment$1(dateValue).format('YYYY-MM-DD')
    let weekNumber = parseInt(this.format('W', dateStr))
    if (this.dayNumber(pivotDate) === 0) {
      weekNumber++
    }
    return weekNumber
  }
  dayNumber() {
    let pivotDate =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    this.setLocale()
    let localeDate = new moment$1().toLocaleString()
    if (pivotDate.length > 0 && pivotDate.length === 10) {
      localeDate = this.createDateTime(pivotDate)
    }
    let dayNumber = new moment$1(localeDate).day()
    if (isNaN(dayNumber)) {
      dayNumber = new moment$1().day()
    }
    return dayNumber
  }
  isWeekend() {
    let pivotDate =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let localeDate = new moment$1().toLocaleString()
    if (pivotDate.length > 0 && pivotDate.length === 10) {
      const formattedDate = moment$1(pivotDate).format('YYYY-MM-DD')
      localeDate = this.createDateTime(formattedDate)
    }
    const day = new moment$1(localeDate).day()
    return day === 6 || day === 0
  }
  isWeekday() {
    let pivotDate =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    return !this.isWeekend(pivotDate)
  }
  weekOf() {
    let startDay =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0
    let endDay =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6
    let userPivotDate =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ''
    let startDayNumber = 0
    let endDayNumber = 6
    let pivotDate = ''
    if (typeof startDay === 'string') {
      pivotDate = startDay
    } else {
      startDayNumber = startDay ? startDay : 0
      endDayNumber = endDay ? endDay : 6
      pivotDate =
        userPivotDate.length > 0
          ? userPivotDate
          : moment$1(new Date()).format('YYYY-MM-DD')
    }
    const startDate = this.weekday('YYYY-MM-DD', startDayNumber, pivotDate)
    const endDate = this.weekday('YYYY-MM-DD', endDayNumber, pivotDate)
    const weekNumber = this.weekNumber(pivotDate)
    return 'W'
      .concat(weekNumber, ' (')
      .concat(startDate, '..')
      .concat(endDate, ')')
  }
  startOfWeek() {
    let format =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let userPivotDate =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ''
    let firstDayOfWeek =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0
    let pivotDate =
      userPivotDate && userPivotDate.length > 0
        ? userPivotDate
        : moment$1(new Date()).format('YYYY-MM-DD')
    pivotDate = this.createDateTime(pivotDate)
    let result = moment$1(pivotDate).startOf('week')
    if (firstDayOfWeek > 0) {
      result = moment$1(pivotDate).startOf('week').add(firstDayOfWeek, 'days')
    }
    return this.format(format, result)
  }
  endOfWeek() {
    let format =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let userPivotDate =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ''
    let firstDayOfWeek =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0
    format = format ? format : ''
    let pivotDate =
      userPivotDate && userPivotDate.length > 0
        ? userPivotDate
        : moment$1(new Date()).format('YYYY-MM-DD')
    let endOfWeek = moment$1(pivotDate).endOf('week')
    if (firstDayOfWeek > 0) {
      endOfWeek = moment$1(pivotDate).endOf('week').add(firstDayOfWeek, 'days')
    }
    return this.format(format, endOfWeek)
  }
  startOfMonth() {
    var _this$config13
    let format =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let userPivotDate =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ''
    let pivotDate =
      userPivotDate && userPivotDate.length > 0
        ? userPivotDate
        : moment$1(new Date()).format('YYYY-MM-DD')
    const configFormat =
      ((_this$config13 = this.config) === null || _this$config13 === void 0
        ? void 0
        : _this$config13.dateFormat) || 'YYYY-MM-DD'
    format = format && format.length > 0 ? format : configFormat
    let firstOfMonth = moment$1(pivotDate).startOf('month')
    return this.format(format, firstOfMonth)
  }
  endOfMonth() {
    var _this$config14
    let format =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let userPivotDate =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ''
    let pivotDate =
      userPivotDate && userPivotDate.length > 0
        ? userPivotDate
        : moment$1(new Date()).format('YYYY-MM-DD')
    const configFormat =
      ((_this$config14 = this.config) === null || _this$config14 === void 0
        ? void 0
        : _this$config14.dateFormat) || 'YYYY-MM-DD'
    format = format && format.length > 0 ? format : configFormat
    let firstOfMonth = moment$1(pivotDate).endOf('month')
    return this.format(format, firstOfMonth)
  }
  daysInMonth() {
    let userPivotDate =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let pivotDate =
      userPivotDate && userPivotDate.length > 0
        ? userPivotDate
        : moment$1(new Date()).format('YYYY-MM-DD')
    return moment$1(pivotDate).daysInMonth()
  }
  daysBetween() {
    let startDate =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let endDate =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ''
    if (startDate.length !== 10) {
      return 'Invalid Start Date'
    }
    if (endDate.length !== 10) {
      return 'Invalid End Date'
    }
    return moment$1(new Date(endDate)).diff(
      moment$1(new Date(startDate)),
      'days'
    )
  }
  add() {
    var _this$config15, _this$config16
    let userPivotDate =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let value =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ''
    let shorthand =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'days'
    let format =
      arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ''
    ;((_this$config15 = this.config) === null || _this$config15 === void 0
      ? void 0
      : _this$config15.templateLocale) || 'en-US'
    const pivotDate =
      userPivotDate && userPivotDate.length > 0
        ? userPivotDate
        : moment$1(new Date()).format('YYYY-MM-DD')
    const configFormat =
      ((_this$config16 = this.config) === null || _this$config16 === void 0
        ? void 0
        : _this$config16.dateFormat) || 'YYYY-MM-DD'
    format = format.length > 0 ? format : configFormat
    const dt = this.createDateTime(pivotDate)
    const shorthandKeys = ['y', 'Q', 'M', 'w', 'd', 'h', 'm', 's', 'ms']
    if (typeof value === 'string') {
      const match = shorthandKeys.filter((item) => value.indexOf(item) !== -1)
      if (match.length > 0) {
        shorthand = match[0]
        value = value.replace(/\D/g, '')
      }
    }
    let result = moment$1(new Date(dt)).add(value, shorthand)
    return this.format(format, result)
  }
  subtract() {
    var _this$config17
    let userPivotDate =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let value =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ''
    let shorthand =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'days'
    let format =
      arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ''
    userPivotDate && userPivotDate.length > 0
      ? userPivotDate
      : moment$1(new Date()).format('YYYY-MM-DD')
    const configFormat =
      ((_this$config17 = this.config) === null || _this$config17 === void 0
        ? void 0
        : _this$config17.dateFormat) || 'YYYY-MM-DD'
    format = format.length > 0 ? format : configFormat
    const dt = this.createDateTime(userPivotDate)
    const shorthandKeys = ['y', 'Q', 'M', 'w', 'd', 'h', 'm', 's', 'ms']
    if (typeof value === 'string') {
      const match = shorthandKeys.filter((item) => value.indexOf(item) !== -1)
      if (match.length > 0) {
        shorthand = match[0]
        value = value.replace(/\D/g, '')
      }
    }
    value = Math.abs(value)
    let result = moment$1(new Date(dt)).subtract(value, shorthand)
    return this.format(format, result)
  }
  businessAdd() {
    var _this$config18, _this$config19
    let numDays =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1
    let pivotDate =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ''
    let format =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ''
    const locale =
      ((_this$config18 = this.config) === null || _this$config18 === void 0
        ? void 0
        : _this$config18.templateLocale) || 'en-US'
    const configFormat =
      ((_this$config19 = this.config) === null || _this$config19 === void 0
        ? void 0
        : _this$config19.dateFormat) || 'YYYY-MM-DD'
    const dtFormat = format.length > 0 ? format : configFormat
    const dt =
      pivotDate.length === 10
        ? new Date(''.concat(pivotDate, 'T00:01:00'))
        : new Date()
    let result = momentBusiness(dt).businessAdd(numDays)
    let formattedDate = result.format(dtFormat)
    if (
      dtFormat === 'short' ||
      dtFormat === 'medium' ||
      dtFormat === 'long' ||
      dtFormat === 'full'
    ) {
      formattedDate = new Intl.DateTimeFormat(locale, {
        dateStyle: dtFormat,
      }).format(result)
    }
    return formattedDate
  }
  businessSubtract() {
    var _this$config20, _this$config21
    let numDays =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1
    let pivotDate =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ''
    let format =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ''
    const locale =
      ((_this$config20 = this.config) === null || _this$config20 === void 0
        ? void 0
        : _this$config20.templateLocale) || 'en-US'
    const configFormat =
      ((_this$config21 = this.config) === null || _this$config21 === void 0
        ? void 0
        : _this$config21.dateFormat) || 'YYYY-MM-DD'
    const dtFormat = format.length > 0 ? format : configFormat
    const dt =
      pivotDate.length === 10
        ? new Date(''.concat(pivotDate, 'T00:01:00'))
        : new Date()
    let result = momentBusiness(dt).businessSubtract(numDays)
    let formattedDate = result.format(dtFormat)
    if (
      dtFormat === 'short' ||
      dtFormat === 'medium' ||
      dtFormat === 'long' ||
      dtFormat === 'full'
    ) {
      formattedDate = new Intl.DateTimeFormat(locale, {
        dateStyle: dtFormat,
      }).format(result)
    }
    return formattedDate
  }
  nextBusinessDay() {
    let pivotDate =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let format =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ''
    return this.businessAdd(1, pivotDate, format)
  }
  previousBusinessDay() {
    let pivotDate =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let format =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ''
    return this.businessSubtract(1, pivotDate, format)
  }
  fromNow() {
    return 'INCOMPLETE'
  }
  isValid() {
    let dateObj =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null
    return dateObj
  }
}
function helpInfo(section, userDocPage) {
  let docPage = userDocPage || ''
  if (docPage.length === 0) {
    switch (section) {
      case 'Templating Prompts':
        docPage = 'templating-examples-prompt'
        break

      case 'Meeting Notes':
        docPage = 'templating-commands'
        break

      case 'Quick Notes':
        docPage = 'templating-quicknotes'
        break

      case 'Template Anatomty':
        docPage = 'templating-anatomy'
        break

      case 'Template Anatomty: Frontmatter':
        docPage = 'templating-anatomy'
        break

      case 'Plugin Error':
        docPage = 'templating-modules-overview'
        break
    }
  }
  let msg = ''
  msg += 'For more information please refer to "'
    .concat(section, '"\n\nhttps://noteplan.co/plugins/templating/')
    .concat(docPage)
  return msg
}
function debug(debugInfo) {
  let preamble =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ''
  let logInfo =
    arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ''
  const SPACER_LENGTH = 80
  const LINE_CHAR = '- '
  {
    const spaces =
      logInfo.length === 0
        ? SPACER_LENGTH
        : Math.round((SPACER_LENGTH - (logInfo.length - 2)) / 2)
    const premambe =
      logInfo.length === 0
        ? ''.concat(LINE_CHAR).repeat(spaces - 4)
        : ''.concat(LINE_CHAR).repeat(spaces) +
          ' '.concat(logInfo, ' ') +
          ''.concat(LINE_CHAR).repeat(spaces)
    log(pluginJson$1, premambe, 'DEBUG')
    if (Array.isArray(debugInfo)) {
      clo(
        '  numItems: '.concat(debugInfo.length, '  \n            ') +
          '[\n ' +
          debugInfo.join(',\n     ') +
          ' \n]',
        '',
        4
      )
    } else {
      clo(debugInfo, preamble, 4)
    }
    log(pluginJson$1, premambe, 'DEBUG')
    console.log('')
  }
}
function trimString(inStr, maxLen) {
  return inStr.length > maxLen ? inStr.slice(0, maxLen) + ' ...' : inStr
}
moment$1().toDate().toLocaleString()
function pad(n) {
  return n < 10 ? '0'.concat(n) : String(n)
}
function getNPWeekData() {
  let dateIn =
    arguments.length > 0 && arguments[0] !== undefined
      ? arguments[0]
      : new Date()
  let offsetIncrement =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0
  let offsetType =
    arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'week'
  try {
    var _ref2, _NotePlan, _NotePlan$environment
    if (
      (_ref2 =
        ((_NotePlan = NotePlan) === null || _NotePlan === void 0
          ? void 0
          : (_NotePlan$environment = _NotePlan.environment) === null ||
              _NotePlan$environment === void 0
            ? void 0
            : _NotePlan$environment.buildVersion) < 876) !== null &&
      _ref2 !== void 0
        ? _ref2
        : true
    ) {
      throw new Error('Sorry; week API calls requires NotePlan v3.7 or newer.')
    }
    let dateStrFormat = 'YYYY-MM-DD',
      newMom
    if (typeof dateIn === 'string') {
      if (new RegExp(RE_YYYYMMDD_DATE).test(dateIn)) dateStrFormat = 'YYYYMMDD'
      if (new RegExp(RE_NP_WEEK_SPEC).test(dateIn)) dateStrFormat = 'YYYY-[W]WW'
      newMom = moment$1(dateIn, dateStrFormat).add(offsetIncrement, offsetType)
    } else {
      newMom = moment$1(dateIn).add(offsetIncrement, offsetType)
    }
    if (newMom) {
      const date = newMom.toDate()
      if (date) {
        const weekNumber = Calendar.weekNumber(date)
        const startDate = Calendar.startOfWeek(date)
        const endDate = Calendar.endOfWeek(date)
        const weekStartYear = startDate.getFullYear()
        const weekEndYear = endDate.getFullYear()
        const weekYear =
          weekStartYear === weekEndYear
            ? weekStartYear
            : weekNumber === 1
              ? weekEndYear
              : weekStartYear
        const weekString = ''.concat(weekYear, '-W').concat(pad(weekNumber))
        return {
          weekNumber: weekNumber,
          startDate: startDate,
          endDate: endDate,
          weekYear: weekYear,
          date: date,
          weekString: weekString,
        }
      }
    }
    return null
  } catch (err) {
    logError('NPdateTime::getNPWeekData', err.message)
    return null
  }
}
function getRelativeDates() {
  try {
    const relativeDates = []
    const todayMom = moment$1()
    const thisDateStrDisplay = moment$1(todayMom).format(MOMENT_FORMAT_NP_ISO)
    let thisDateStr = moment$1(todayMom).format(MOMENT_FORMAT_NP_DAY)
    relativeDates.push({
      relName: 'today',
      dateStr: thisDateStrDisplay,
      note: DataStore.calendarNoteByDateString(thisDateStr),
    })
    thisDateStr = moment$1(todayMom)
      .subtract(1, 'days')
      .startOf('day')
      .format(MOMENT_FORMAT_NP_DAY)
    relativeDates.push({
      relName: 'yesterday',
      dateStr: thisDateStrDisplay,
      note: DataStore.calendarNoteByDateString(thisDateStr),
    })
    thisDateStr = moment$1(todayMom)
      .add(1, 'days')
      .startOf('day')
      .format(MOMENT_FORMAT_NP_DAY)
    relativeDates.push({
      relName: 'tomorrow',
      dateStr: thisDateStrDisplay,
      note: DataStore.calendarNoteByDateString(thisDateStr),
    })
    let thisNPWeekInfo = getNPWeekData(new Date())
    thisDateStr = thisNPWeekInfo.weekString
    relativeDates.push({
      relName: 'this week',
      dateStr: thisDateStr,
      note: DataStore.calendarNoteByDateString(thisDateStr),
    })
    thisNPWeekInfo = getNPWeekData(new Date(), -1)
    thisDateStr = thisNPWeekInfo.weekString
    relativeDates.push({
      relName: 'last week',
      dateStr: thisDateStr,
      note: DataStore.calendarNoteByDateString(thisDateStr),
    })
    thisNPWeekInfo = getNPWeekData(new Date(), 1)
    thisDateStr = thisNPWeekInfo.weekString
    relativeDates.push({
      relName: 'next week',
      dateStr: thisDateStr,
      note: DataStore.calendarNoteByDateString(thisDateStr),
    })
    thisDateStr = moment$1(todayMom)
      .startOf('month')
      .format(MOMENT_FORMAT_NP_MONTH)
    relativeDates.push({
      relName: 'this month',
      dateStr: thisDateStr,
      note: DataStore.calendarNoteByDateString(thisDateStr),
    })
    thisDateStr = moment$1(todayMom)
      .subtract(1, 'month')
      .startOf('month')
      .format(MOMENT_FORMAT_NP_MONTH)
    relativeDates.push({
      relName: 'last month',
      dateStr: thisDateStr,
      note: DataStore.calendarNoteByDateString(thisDateStr),
    })
    thisDateStr = moment$1(todayMom)
      .add(1, 'month')
      .startOf('month')
      .format(MOMENT_FORMAT_NP_MONTH)
    relativeDates.push({
      relName: 'next month',
      dateStr: thisDateStr,
      note: DataStore.calendarNoteByDateString(thisDateStr),
    })
    thisDateStr = moment$1(todayMom)
      .startOf('quarter')
      .format(MOMENT_FORMAT_NP_QUARTER)
    relativeDates.push({
      relName: 'this quarter',
      dateStr: thisDateStr,
      note: DataStore.calendarNoteByDateString(thisDateStr),
    })
    thisDateStr = moment$1(todayMom)
      .subtract(1, 'quarter')
      .startOf('quarter')
      .format(MOMENT_FORMAT_NP_QUARTER)
    relativeDates.push({
      relName: 'last quarter',
      dateStr: thisDateStr,
      note: DataStore.calendarNoteByDateString(thisDateStr),
    })
    thisDateStr = moment$1(todayMom)
      .add(1, 'quarter')
      .startOf('quarter')
      .format(MOMENT_FORMAT_NP_QUARTER)
    relativeDates.push({
      relName: 'next quarter',
      dateStr: thisDateStr,
      note: DataStore.calendarNoteByDateString(thisDateStr),
    })
    return relativeDates
  } catch (err) {
    logError('getRelativeDates', ''.concat(err.name, ': ').concat(err.message))
    return [{}]
  }
}
function smartAppendPara(note, paraText, paragraphType) {
  note.insertParagraph(
    paraText,
    findEndOfActivePartOfNote(note) + 1,
    paragraphType
  )
}
function smartPrependPara(note, paraText, paragraphType) {
  note.insertParagraph(
    paraText,
    findStartOfActivePartOfNote(note),
    paragraphType
  )
}
function findStartOfActivePartOfNote(note) {
  let allowPreamble =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false
  try {
    let startOfActive = NaN
    let paras = note.paragraphs
    if (paras.length === 0) {
      note.appendParagraph('', 'empty')
      return 0
    }
    const endOfFMIndex = endOfFrontmatterLineIndex(note)
    if (endOfFMIndex === 0) {
      if (paras[0].type === 'title' && paras[0].headingLevel === 1) {
        startOfActive = 1
      } else {
        startOfActive = 0
      }
    } else {
      startOfActive = endOfFMIndex + 1
    }
    if (paras.length === startOfActive) {
      note.appendParagraph('', 'empty')
      paras = note.paragraphs
      startOfActive = paras.length
    }
    logDebug(
      'paragraph/findStartOfActivePartOfNote',
      '- startOfActive so far = '
        .concat(String(startOfActive), '. allowPreamble: ')
        .concat(allowPreamble ? 'true' : 'false')
    )
    if (
      allowPreamble ||
      (paras[startOfActive].type === 'text' &&
        paras[startOfActive].content.match(/^#\w/))
    ) {
      logDebug(
        'paragraph/findStartOfActivePartOfNote',
        '- We want to allow preamble, or found a metadata line.'
      )
      for (let i = startOfActive; i < paras.length; i++) {
        const p = paras[i]
        if (
          [
            'open',
            'done',
            'scheduled',
            'cancelled',
            'checklist',
            'checklistDone',
            'checklistScheduled',
            'checklistCancelled',
            'title',
            'code',
          ].includes(p.type)
        ) {
          logDebug(
            'paragraph/findStartOfActivePartOfNote',
            '  - Found task/checklist/title/code line -> this line.'
          )
          startOfActive = i
          break
        } else if (p.type === 'separator' || p.type === 'empty') {
          logDebug(
            'paragraph/findStartOfActivePartOfNote',
            '  - Found separator/blank -> next line.'
          )
          startOfActive = i + 1
          break
        }
      }
      logDebug(
        'paragraph/findStartOfActivePartOfNote',
        '-> '.concat(
          String(startOfActive),
          '  (after finding preamble or metadata line)'
        )
      )
    }
    return startOfActive
  } catch (err) {
    logError('paragraph/findStartOfActivePartOfNote', err.message)
    return NaN
  }
}
function findEndOfActivePartOfNote(note) {
  try {
    const paras = note.paragraphs
    let lineCount = paras.length
    if (lineCount === 0) {
      return 0
    } else {
      var _paras$filter, _paras$filter2
      if (paras[paras.length - 1].type === 'empty') {
        lineCount--
      }
      const doneHeaderLines =
        (_paras$filter = paras.filter(
          (p) => p.headingLevel === 2 && p.content.startsWith('Done')
        )) !== null && _paras$filter !== void 0
          ? _paras$filter
          : []
      let doneHeaderLine =
        doneHeaderLines.length > 0 ? doneHeaderLines[0].lineIndex : 0
      if (
        doneHeaderLine > 2 &&
        paras[doneHeaderLine - 1].type === 'separator'
      ) {
        doneHeaderLine -= 1
      }
      const cancelledHeaderLines =
        (_paras$filter2 = paras.filter(
          (p) => p.headingLevel === 2 && p.content.startsWith('Cancelled')
        )) !== null && _paras$filter2 !== void 0
          ? _paras$filter2
          : []
      let cancelledHeaderLine =
        cancelledHeaderLines.length > 0 ? cancelledHeaderLines[0].lineIndex : 0
      if (
        cancelledHeaderLine > 2 &&
        paras[cancelledHeaderLine - 1].type === 'separator'
      ) {
        cancelledHeaderLine -= 1
      }
      const endOfActive =
        doneHeaderLine > 1
          ? doneHeaderLine - 1
          : cancelledHeaderLine > 1
            ? cancelledHeaderLine - 1
            : lineCount > 1
              ? lineCount - 1
              : 0
      return endOfActive
    }
  } catch (err) {
    logError('paragraph/findEndOfActivePartOfNote', err.message)
    return NaN
  }
}
function endOfFrontmatterLineIndex(note) {
  try {
    const paras = note.paragraphs
    const lineCount = paras.length
    if (paras.filter((p) => p.type === 'separator').length < 2) {
      return 0
    }
    if (note.paragraphs[0].type !== 'separator') {
      return 0
    }
    if (note.paragraphs.length <= 3) {
      return 0
    }
    let lineIndex = 1
    while (lineIndex < lineCount) {
      const p = paras[lineIndex]
      if (p.type === 'separator') {
        return lineIndex
      }
      lineIndex++
    }
    return 0
  } catch (err) {
    logError('paragraph/findEndOfActivePartOfNote', err.message)
    return NaN
  }
}
function parseJSON5(contents) {
  try {
    const value = json5.parse(contents)
    return value
  } catch (error) {
    logError('userInput / parseJSON5', error.message)
    return {}
  }
}
async function chooseOption(message, options) {
  var _ref, _options$index$value, _options$index
  let defaultValue =
    arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null
  const { index: index } = await CommandBar.showOptions(
    options.map((option) => option.label),
    message
  )
  return (_ref =
    (_options$index$value =
      (_options$index = options[index]) === null || _options$index === void 0
        ? void 0
        : _options$index.value) !== null && _options$index$value !== void 0
      ? _options$index$value
      : defaultValue) !== null && _ref !== void 0
    ? _ref
    : options[0].value
}
async function chooseOptionWithModifiers(message, options) {
  logDebug(
    'userInput / chooseOptionWithModifiers()',
    'About to showOptions with '
      .concat(options.length, ' options & prompt:"')
      .concat(message, '"')
  )
  const { index: index, keyModifiers: keyModifiers } =
    await CommandBar.showOptions(
      options.map((option) => option.label),
      message
    )
  return _objectSpread2(
    _objectSpread2({}, options[index]),
    {},
    {
      index: index,
      keyModifiers: keyModifiers,
    }
  )
}
async function getInput(message) {
  let okLabel =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'OK'
  let dialogTitle =
    arguments.length > 2 && arguments[2] !== undefined
      ? arguments[2]
      : 'Enter value'
  let defaultValue =
    arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ''
  if (typeof CommandBar.textPrompt === 'function') {
    return await CommandBar.textPrompt(dialogTitle, message, defaultValue)
  } else {
    return await CommandBar.showInput(message, okLabel)
  }
}
async function showMessage(message) {
  let confirmButton =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'OK'
  let dialogTitle =
    arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ''
  let useCommandBar =
    arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false
  if (typeof CommandBar.prompt === 'function' && !useCommandBar) {
    await CommandBar.prompt(dialogTitle, message, [confirmButton])
  } else {
    await CommandBar.showOptions([confirmButton], message)
  }
}
async function chooseFolder(msg) {
  let includeArchive =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false
  let includeNewFolderOption =
    arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false
  let startFolder = arguments.length > 3 ? arguments[3] : undefined
  const IS_DESKTOP = NotePlan.environment.platform === 'macOS'
  const NEW_FOLDER = '➕ (Add New Folder'.concat(
    IS_DESKTOP
      ? ' - or opt-click on a parent folder to create new subfolder'
      : '',
    ')'
  )
  let folder
  let folders = []
  if (includeNewFolderOption) {
    folders.push(NEW_FOLDER)
  }
  folders = [...folders, ...DataStore.folders.slice()]
  if (
    startFolder !== null &&
    startFolder !== void 0 &&
    startFolder.length &&
    startFolder !== '/'
  ) {
    folders = folders.filter(
      (f) => f === NEW_FOLDER || f.startsWith(startFolder)
    )
  } else {
    if (!includeArchive) {
      folders = folders.filter((f) => !f.startsWith('@Archive'))
    }
  }
  let value, keyModifiers
  if (folders.length > 0) {
    var _keyModifiers
    const folderOptionList = []
    for (const f of folders) {
      if (f !== '/' && f !== NEW_FOLDER) {
        const folderParts = f.split('/')
        for (let i = 0; i < folderParts.length - 1; i++) {
          folderParts[i] = '     '
        }
        folderParts[folderParts.length - 1] = '📁 '.concat(
          folderParts[folderParts.length - 1]
        )
        const folderLabel = folderParts.join('')
        folderOptionList.push({
          label: folderLabel,
          value: f,
        })
      } else {
        folderOptionList.push(
          f !== NEW_FOLDER
            ? {
                label: '📁 /',
                value: '/',
              }
            : {
                label: NEW_FOLDER,
                value: NEW_FOLDER,
              }
        )
      }
    }
    ;({ value: value, keyModifiers: keyModifiers } =
      await chooseOptionWithModifiers(msg, folderOptionList))
    if (
      (_keyModifiers = keyModifiers) !== null &&
      _keyModifiers !== void 0 &&
      _keyModifiers.length &&
      keyModifiers.indexOf('opt') > -1
    ) {
      folder = NEW_FOLDER
    } else {
      folder = value
    }
    logDebug(
      'helpers/userInput',
      'chooseFolder folder:'
        .concat(folder, ' value:')
        .concat(value, ' keyModifiers:')
        .concat(keyModifiers, " keyModifiers.indexOf('opt')=")
        .concat(keyModifiers.indexOf('opt'))
    )
  } else {
    folder = '/'
  }
  if (folder === NEW_FOLDER) {
    var _value
    const optClicked =
      ((_value = value) === null || _value === void 0
        ? void 0
        : _value.length) &&
      keyModifiers &&
      keyModifiers.indexOf('opt') > -1
    const newFolderName = await CommandBar.textPrompt(
      'Create new folder'.concat(
        optClicked
          ? ' inside folder:\n"'.concat(value || '', '".')
          : '...\nYou will choose where to create the folder in the next step.'
      ),
      'Folder name:',
      ''
    )
    if (newFolderName && newFolderName.length) {
      const inWhichFolder =
        optClicked && value
          ? value
          : await chooseFolder(
              "Create '"
                .concat(newFolderName, "' inside which folder? (")
                .concat(
                  startFolder !== null && startFolder !== void 0
                    ? startFolder
                    : '/',
                  ' for root)'
                ),
              includeArchive,
              false,
              startFolder
            )
      if (inWhichFolder) {
        folder =
          inWhichFolder === '/'
            ? newFolderName
            : ''.concat(inWhichFolder, '/').concat(newFolderName)
      }
    }
  }
  logDebug(
    'helpers/userInput',
    'chooseFolder folder chosen: "'.concat(folder, '"')
  )
  return folder
}
async function chooseHeading(note) {
  let optionAddATopAndtBottom =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true
  let optionCreateNewHeading =
    arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false
  let includeArchive =
    arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false
  let headingLevel =
    arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 2
  try {
    var _note$title
    let headingStrings = []
    const spacer = '#'
    let headingParas = []
    const indexEndOfActive = findEndOfActivePartOfNote(note)
    if (includeArchive) {
      headingParas = note.paragraphs.filter(
        (p) => p.type === 'title' && p.lineIndex < indexEndOfActive
      )
    } else {
      headingParas = note.paragraphs.filter((p) => p.type === 'title')
    }
    if (headingParas.length > 0) {
      if (headingParas[0].content === note.title) {
        headingParas = headingParas.slice(1)
      }
    }
    if (headingParas.length > 0) {
      headingStrings = headingParas.map((p) => {
        let prefix = ''
        for (let i = 0; i < p.headingLevel; i++) {
          prefix += spacer
        }
        return ''.concat(prefix, ' ').concat(p.content)
      })
    }
    if (optionCreateNewHeading) {
      if (note.type === 'Calendar') {
        headingStrings.unshift(
          '➕#️⃣ (first insert new heading at the start of the note)'
        )
      } else {
        headingStrings.unshift(
          '➕#️⃣ (first insert new heading under the title)'
        )
      }
      headingStrings.push(
        '➕#️⃣ (first insert new heading at the end of the note)'
      )
    }
    if (optionAddATopAndtBottom) {
      headingStrings.unshift('⏫ (top of note)')
      headingStrings.push('⏬ (bottom of note)')
    }
    if (headingStrings.length === 0) {
      return ''
    }
    const result = await CommandBar.showOptions(
      headingStrings,
      "Select a heading from note '".concat(
        (_note$title = note.title) !== null && _note$title !== void 0
          ? _note$title
          : 'Untitled',
        "'"
      )
    )
    let headingToReturn = headingStrings[result.index].replace(/^#{1,5}\s*/, '')
    let newHeading
    switch (headingToReturn) {
      case '➕#️⃣ (first insert new heading at the start of the note)':
        newHeading = await getInput(
          'Enter heading to add at the start of the note'
        )
        if (newHeading && typeof newHeading === 'string') {
          const startPos = 0
          note.insertHeading(newHeading, startPos, headingLevel)
          logDebug(
            'userInput / chooseHeading',
            "prepended new heading '"
              .concat(newHeading, "' at line ")
              .concat(startPos, ' (calendar note)')
          )
          headingToReturn = newHeading
        } else {
          throw new Error('user cancelled operation')
        }
        break

      case '➕#️⃣ (first insert new heading under the title)':
        newHeading = await getInput(
          'Enter heading to add at the start of the note'
        )
        if (newHeading && typeof newHeading === 'string') {
          const startPos = findStartOfActivePartOfNote(note)
          note.insertHeading(newHeading, startPos, headingLevel)
          logDebug(
            'userInput / chooseHeading',
            "prepended new heading '"
              .concat(newHeading, "' at line ")
              .concat(startPos, ' (project note)')
          )
          headingToReturn = newHeading
        } else {
          throw new Error('user cancelled operation')
        }
        break

      case '➕#️⃣ (first insert new heading at the end of the note)':
        newHeading = await getInput(
          'Enter heading to add at the end of the note'
        )
        if (newHeading && typeof newHeading === 'string') {
          const newLindeIndex = indexEndOfActive + 1
          note.insertHeading(newHeading, newLindeIndex, headingLevel)
          logDebug(
            'userInput / chooseHeading',
            "appended new heading '"
              .concat(newHeading, "' at line ")
              .concat(newLindeIndex)
          )
          headingToReturn = newHeading
        } else {
          throw new Error('user cancelled operation')
        }
        break

      case '⏫ (top of note)':
        logDebug(
          'userInput / chooseHeading',
          'selected top of note, rather than a heading'
        )
        headingToReturn = '<<top of note>>'
        break

      case '⏬ (bottom of note)':
        logDebug(
          'userInput / chooseHeading',
          'selected end of note, rather than a heading'
        )
        headingToReturn = ''
        break

      default:
        logDebug(
          'userInput / chooseHeading',
          'User picked existing heading number '
            .concat(result.index + 1, " ('")
            .concat(headingToReturn, "') from ")
            .concat(headingStrings.length, ' ..')
        )
        break
    }
    return headingToReturn
  } catch (error) {
    logError('userInput / chooseHeading', error.message)
    return '<error>'
  }
}
async function askDateInterval(dateParams) {
  var _await$CommandBar$sho
  const dateParamsTrimmed =
    (dateParams === null || dateParams === void 0
      ? void 0
      : dateParams.trim()) || ''
  const paramConfig =
    dateParamsTrimmed.startsWith('{') && dateParamsTrimmed.endsWith('}')
      ? parseJSON5(dateParams)
      : dateParamsTrimmed !== ''
        ? parseJSON5('{'.concat(dateParams, '}'))
        : {}
  const allSettings = _objectSpread2({}, paramConfig)
  let { question: question } = allSettings
  question = question ? question : 'Please enter a date interval'
  const reply =
    (_await$CommandBar$sho = await CommandBar.showInput(
      question,
      'Date interval (in form nn[bdwmqy]): %@'
    )) !== null && _await$CommandBar$sho !== void 0
      ? _await$CommandBar$sho
      : ''
  const trimmedReply = reply.trim()
  if (trimmedReply.match(RE_DATE_INTERVAL) == null) {
    await showMessage(
      'Sorry: '.concat(trimmedReply, " wasn't a valid date interval"),
      'OK',
      'Error'
    )
    return ''
  }
  return trimmedReply
}
async function datePicker(dateParams) {
  let config =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}
  try {
    var _config$date
    const dateConfig =
      (_config$date = config.date) !== null && _config$date !== void 0
        ? _config$date
        : {}
    clo(dateConfig, 'userInput / datePicker dateConfig object:')
    const dateParamsTrimmed = dateParams.trim()
    const paramConfig =
      dateParamsTrimmed.startsWith('{') && dateParamsTrimmed.endsWith('}')
        ? parseJSON5(dateParams)
        : dateParamsTrimmed !== ''
          ? parseJSON5('{'.concat(dateParams, '}'))
          : {}
    logDebug(
      'userInput / datePicker',
      'params: '.concat(dateParams, ' -> ').concat(JSON.stringify(paramConfig))
    )
    const allSettings = _objectSpread2(
      _objectSpread2({}, dateConfig),
      paramConfig
    )
    let { question: question, defaultValue: defaultValue } = allSettings
    question = question ? question : 'Please enter a date'
    defaultValue = defaultValue ? defaultValue : 'YYYY-MM-DD'
    const reply = await CommandBar.textPrompt(
      'Date Picker',
      question,
      defaultValue
    )
    if (typeof reply === 'string') {
      const reply2 = reply.replace('>', '').trim()
      if (!reply2.match(RE_DATE)) {
        await showMessage(
          'Sorry: '.concat(reply2, " wasn't a date of form YYYY-MM-DD"),
          'OK',
          'Error'
        )
        return ''
      }
      return reply2
    } else {
      logWarn('userInput / datePicker', 'User cancelled date input')
      return ''
    }
  } catch (e) {
    logError('userInput / datePicker', e.message)
    return ''
  }
}
const relativeDates = getRelativeDates()
async function createNewNote() {
  let _title =
    arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
  let _content =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ''
  let _folder =
    arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ''
  const title =
    _title || (await getInput('Title of new note', 'OK', 'New Note', ''))
  const content = _content
  if (title) {
    const folder =
      _folder ||
      (await chooseFolder('Select folder to add note in:', false, true))
    const noteContent = '# '.concat(title, '\n').concat(content)
    const filename = await DataStore.newNoteWithContent(noteContent, folder)
    return DataStore.noteByFilename(filename, 'Notes') || null
  } else {
    return null
  }
}
function displayTitleWithRelDate(noteIn) {
  let showRelativeDates =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true
  if (noteIn.type === 'Calendar') {
    var _getDateStringFromCal
    let calNoteTitle =
      (_getDateStringFromCal = getDateStringFromCalendarFilename(
        noteIn.filename,
        true
      )) !== null && _getDateStringFromCal !== void 0
        ? _getDateStringFromCal
        : '(error)'
    if (showRelativeDates) {
      for (const rd of relativeDates) {
        if (calNoteTitle === rd.dateStr) {
          calNoteTitle = ''.concat(rd.dateStr, '\t(📆 ').concat(rd.relName, ')')
        }
      }
    }
    return calNoteTitle
  } else {
    var _noteIn$title
    return (_noteIn$title = noteIn.title) !== null && _noteIn$title !== void 0
      ? _noteIn$title
      : '(error)'
  }
}
async function chooseNote() {
  var _noteToReturn
  let includeProjectNotes =
    arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true
  let includeCalendarNotes =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false
  let foldersToIgnore =
    arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : []
  let promptText =
    arguments.length > 3 && arguments[3] !== undefined
      ? arguments[3]
      : 'Choose a note'
  let currentNoteFirst =
    arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false
  let allowNewNoteCreation =
    arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false
  let noteList = []
  const projectNotes = DataStore.projectNotes
  const calendarNotes = DataStore.calendarNotes
  if (includeProjectNotes) {
    noteList = noteList.concat(projectNotes)
  }
  if (includeCalendarNotes) {
    noteList = noteList.concat(calendarNotes)
  }
  const noteListFiltered = noteList.filter((note) => {
    let isInIgnoredFolder = false
    foldersToIgnore.forEach((folder) => {
      if (note.filename.includes(''.concat(folder, '/'))) {
        isInIgnoredFolder = true
      }
    })
    isInIgnoredFolder =
      isInIgnoredFolder || !/(\.md|\.txt)$/i.test(note.filename)
    return !isInIgnoredFolder
  })
  const sortedNoteListFiltered = noteListFiltered.sort(
    (first, second) => second.changedDate - first.changedDate
  )
  const opts = sortedNoteListFiltered.map((note) =>
    displayTitleWithRelDate(note)
  )
  const { note: note } = Editor
  if (allowNewNoteCreation) {
    opts.unshift('[New note]')
    sortedNoteListFiltered.unshift('[New note]')
  }
  if (currentNoteFirst && note) {
    sortedNoteListFiltered.unshift(note)
    opts.unshift(
      '[Current note: "'.concat(displayTitleWithRelDate(Editor), '"]')
    )
  }
  const { index: index } = await CommandBar.showOptions(opts, promptText)
  let noteToReturn = sortedNoteListFiltered[index]
  if (noteToReturn === '[New note]') {
    noteToReturn = await createNewNote()
  }
  return (_noteToReturn = noteToReturn) !== null && _noteToReturn !== void 0
    ? _noteToReturn
    : null
}
function time() {
  let format =
    arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'h:mm A'
  return moment$1(new Date()).format(
    format && format.length > 0 ? format : 'h:mm A'
  )
}
class TimeModule {
  constructor(config) {
    var _this$config, _this$config$locale
    this.config = config
    let osLocale = 'en-US'
    if (
      ((_this$config = this.config) === null || _this$config === void 0
        ? void 0
        : (_this$config$locale = _this$config.locale) === null ||
            _this$config$locale === void 0
          ? void 0
          : _this$config$locale.length) > 0
    ) {
      var _this$config2
      osLocale =
        (_this$config2 = this.config) === null || _this$config2 === void 0
          ? void 0
          : _this$config2.locale
    }
    moment$1.locale(osLocale)
  }
  convertTime12to24() {
    let userTime =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    if (userTime.length === 0) {
      return ''
    }
    const time12h = userTime.replace('_AM', ' AM').replace('_PM', ' PM')
    const [time, modifier] = time12h.split(' ')
    let [hours, minutes] = time.split(':')
    if (hours === '12') {
      hours = '00'
    }
    if (modifier === 'PM') {
      hours = parseInt(hours, 10) + 12
    }
    return ''.concat(hours, ':').concat(minutes)
  }
  format() {
    var _this$config3
    let format =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let date =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ''
    let dateValue = date.length > 0 ? date : new Date()
    const configFormat =
      ((_this$config3 = this.config) === null || _this$config3 === void 0
        ? void 0
        : _this$config3.timeFormat) || 'HH:mm A'
    format = format.length > 0 ? format : configFormat
    if (date instanceof Date) {
      return moment$1(date).format(format)
    } else {
      dateValue = new Date(date).toLocaleString()
      return moment$1(new Date(dateValue)).format(format)
    }
  }
  now() {
    var _this$config4, _this$config5
    let format =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    const locale =
      ((_this$config4 = this.config) === null || _this$config4 === void 0
        ? void 0
        : _this$config4.locale) || 'en-US'
    const configFormat =
      ((_this$config5 = this.config) === null || _this$config5 === void 0
        ? void 0
        : _this$config5.timeFormat) || 'short'
    format = format.length > 0 ? format : configFormat
    let formattedTime = moment$1(new Date()).format(format)
    if (
      format === 'short' ||
      format === 'medium' ||
      format === 'long' ||
      format === 'full'
    ) {
      formattedTime = new Intl.DateTimeFormat(locale, {
        timeStyle: format,
      }).format(new Date())
    }
    return this.isValid(formattedTime)
  }
  currentTime() {
    let format =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    return this.now(format)
  }
  isValid() {
    let timeObj =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null
    return timeObj
  }
}
const affirmations = [
  'You got this',
  "You'll figure it out",
  "You're a smart cookie",
  'I believe in you',
  'Sucking at something is the first step towards being good at something',
  'Struggling is part of learning',
  "Everything has cracks - that's how the light gets in",
  "Mistakes don't make you less capable",
  'We are all works in progress',
  'You are a capable human',
  'You know more than you think',
  '10x engineers are a myth',
  "If everything was easy you'd be bored",
  'I admire you for taking this on',
  "You're resourceful and clever",
  "You'll find a way",
  "I know you'll sort it out",
  "Struggling means you're learning",
  "You're doing a great job",
  "It'll feel magical when it's working",
  "I'm rooting for you",
  'Your mind is full of brilliant ideas',
  'You make a difference in the world by simply existing in it',
  'You are learning valuable lessons from yourself every day',
  'You are worthy and deserving of respect',
  'You know more than you knew yesterday',
  "You're an inspiration",
  'Your life is already a miracle of chance waiting for you to shape its destiny',
  'Your life is about to be incredible',
  "Nothing is impossible. The word itself says 'I’m possible!'",
  'Failure is just another way to learn how to do something right',
  'I give myself permission to do what is right for me',
  'You can do it',
  'It is not a sprint, it is a marathon. One step at a time',
  'Success is the progressive realization of a worthy goal',
  'People with goals succeed because they know where they’re going',
  'All you need is the plan, the roadmap, and the courage to press on to your destination',
  'The opposite of courage in our society is not cowardice... it is conformity',
  'Whenever we’re afraid, it’s because we don’t know enough. If we understood enough, we would never be afraid',
  'The past does not equal the future',
  'The path to success is to take massive, determined action',
  'It’s what you practice in private that you will be rewarded for in public',
  'Small progress is still progress',
  "Don't worry if you find flaws in your past creations, it's because you've evolved",
  'Starting is the most difficult step - but you can do it',
  "Don't forget to enjoy the journey",
  "It's not a mistake, it's a learning opportunity",
  'You got this',
  "You'll figure it out",
  "You're a smart cookie",
  'I believe in you',
  'Sucking at something is the first step towards being good at something',
  'Struggling is part of learning',
  "Everything has cracks - that's how the light gets in",
  "Mistakes don't make you less capable",
  'We are all works in progress',
  'You are a capable human',
  'You know more than you think',
  '10x engineers are a myth',
  "If everything was easy you'd be bored",
  'I admire you for taking this on',
  "You're resourceful and clever",
  "You'll find a way",
  "I know you'll sort it out",
  "Struggling means you're learning",
  "You're doing a great job",
  "It'll feel magical when it's working",
  "I'm rooting for you",
  'Your mind is full of brilliant ideas',
  'You make a difference in the world by simply existing in it',
  'You are learning valuable lessons from yourself every day',
  'You are worthy and deserving of respect',
  'You know more than you knew yesterday',
  "You're an inspiration",
  'Your life is already a miracle of chance waiting for you to shape its destiny',
  'Your life is about to be incredible',
  "Nothing is impossible. The word itself says 'I’m possible!'",
  'Failure is just another way to learn how to do something right',
  'I give myself permission to do what is right for me',
  'You can do it',
  'It is not a sprint, it is a marathon. One step at a time',
  'Success is the progressive realization of a worthy goal',
  'People with goals succeed because they know where they’re going',
  'All you need is the plan, the roadmap, and the courage to press on to your destination',
  'The opposite of courage in our society is not cowardice... it is conformity',
  'Whenever we’re afraid, it’s because we don’t know enough. If we understood enough, we would never be afraid',
  'The past does not equal the future',
  'The path to success is to take massive, determined action',
  'It’s what you practice in private that you will be rewarded for in public',
  'Small progress is still progress',
  "Don't worry if you find flaws in your past creations, it's because you've evolved",
  'Starting is the most difficult step - but you can do it',
  "Don't forget to enjoy the journey",
  "It's not a mistake, it's a learning opportunity",
  'Nothing can dim the light that shines from within.',
  'You are loved just for being who you are, just for existing.',
  'The chance to love and be loved exists no matter where you are.',
  'Courage starts with showing up and letting ourselves be seen.',
  'Make way for the unprecedented and watch your reality rearrange yourself.',
  'Open your heart and drink in the glorious day.',
  'The perfect moment is this one.',
  'Am I good enough? Yes I am.',
  'I am deliberate and afraid of nothing.',
  'Your life is about to be incredible.',
  'Who you are inside is what helps you make and do everything in life.',
  'Your perspective is unique. It’s important and it counts.',
  'Every day above earth is a good day.',
  'Nothing can dim the light that shines from within.',
  'You must do the things you think you cannot do.',
  'The secret of attraction is to love yourself.',
  "Good riddance to decisions that don't support self-care, self-value, and self-worth.",
  'I say looking on the bright side of life never killed anybody.',
  'I’m better than I used to be. Better than I was yesterday. But hopefully not as good as I’ll be tomorrow.',
  'I have never ever focused on the negative of things. I always look at the positive.',
  "I'm giving you permission to root for yourself and while you're at it root for those around you, too.",
  'We must accept finite disappointment, but never lose infinite hope.',
  'Your life is already a miracle of chance waiting for you to shape its destiny.',
  'If you really think small, your world will be small. If you think big, your world will be big.',
  'Embrace the glorious mess that you are.',
  'The ultimate truth of who you are is not I am this or I am that, but I Am.',
  'Gratitude is a celebration we are all invited to.',
  'We must be willing to let go of the life we planned so as to have the life that is waiting for us.',
  "Nothing is impossible. The word itself says 'I’m possible!'",
  'The only courage you ever need is the courage to fulfill the dreams of your own life.',
  'Failure is just another way to learn how to do something right.',
  'The emotion that can break your heart is sometimes the very one that heals it.',
  'Your crown has been bought and paid for. Put it on your head and wear it.',
  'Everything passes if you learn to hold things lightly.',
  'Write it on your heart that every day is the best day in the year.',
  'Hold up your head! You were not made for failure, you were made for victory.',
  'If you have good thoughts they will shine out of your face like sunbeams and you will always look lovely.',
  'There is nothing either good or bad, but thinking makes it so.',
  'Doubt kills more dreams than failure ever will',
]
var affirmations_1 = affirmations
function getAffirmation() {
  return affirmations_1[Math.floor(Math.random() * affirmations_1.length)]
}
async function getAdvice() {
  try {
    var _data$slip, _data$slip$advice
    const response = await fetch('https://api.adviceslip.com/advice', {
      timeout: 3e3,
    })
    const data = JSON.parse(response)
    return data &&
      (data === null || data === void 0
        ? void 0
        : (_data$slip = data.slip) === null || _data$slip === void 0
          ? void 0
          : (_data$slip$advice = _data$slip.advice) === null ||
              _data$slip$advice === void 0
            ? void 0
            : _data$slip$advice.length) > 0
      ? data.slip.advice
      : '**Advice returned empty response**'
  } catch (err) {
    return '**An error occurred accessing quoting service**'
  }
}
async function getDailyQuote() {
  const response = await fetch('https://zenquotes.io/api/random', {
    timeout: 3e3,
  })
  if (response) {
    const quoteLines = JSON.parse(response)
    if (quoteLines.length > 0) {
      const data = quoteLines[0]
      return ''.concat(data.q, ' - *').concat(data.a, '*')
    }
  } else {
    return '**An error occurred accessing quoting service**'
  }
}
async function getWOTD(params) {
  try {
    const url = 'https://wordsapiv1.p.rapidapi.com/words/?random=true'
    const options = {
      method: 'GET',
      headers: {
        'X-RapidAPI-Key': 'Xwiq2Q2FCrmshVLkpU1ApDOasM3rp1OIm7vjsnlVvRfpkFBmeX',
        'X-RapidAPI-Host': 'wordsapiv1.p.rapidapi.com',
      },
    }
    const result = await fetch(url, options)
    const data = JSON.parse(result)
    let word = data === null || data === void 0 ? void 0 : data.word
    if (params !== null && params !== void 0 && params.attribution) {
      word = ''
        .concat(data === null || data === void 0 ? void 0 : data.word, ' ')
        .concat(data === null || data === void 0 ? void 0 : data.word)
    }
    return word
  } catch (error) {
    return '**An error occurred accessing wotd service**'
  }
}
async function getWeather() {
  try {
    const response = await await fetch('https://wttr.in?format=3', {
      timeout: 3e3,
    })
    return response
      ? response
      : '**An error occurred accessing weather service**'
  } catch (error) {
    return '**An error occurred accessing weather service**'
  }
}
const weatherDescTexts = [
  'showers',
  'rain',
  'sunny intervals',
  'partly',
  'sunny',
  'clear',
  'clear sky',
  'cloud',
  'fog',
  'snow',
  'thunderstorm',
  'tornado',
]
const weatherDescIcons = [
  '🌦️',
  '🌧️',
  '🌤',
  '⛅',
  '☀️',
  '☀️',
  '☀️',
  '☁️',
  '🌫',
  '🌨️',
  '⛈',
  '🌪',
]
const areaNameOverride = function () {
  let areaName =
    arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
  switch (areaName.toLowerCase()) {
    case 'talbert':
      return 'Fountain Valley'
  }
  return areaName
}
async function getWeatherSummary(format) {
  const getWeatherURL = 'https://wttr.in/?format=j1'
  let jsonIn, allWeatherData
  try {
    jsonIn = await fetch(getWeatherURL)
    if (jsonIn != null) {
      var _allWeatherData$neare,
        _allWeatherData$neare2,
        _allWeatherData$neare3,
        _allWeatherData$neare4,
        _allWeatherData$neare5,
        _allWeatherData$curre,
        _allWeatherData$curre2,
        _allWeatherData$curre3
      try {
        allWeatherData = JSON.parse(jsonIn)
      } catch (error) {
        logError("'".concat(error.message, "' parsing Weather data lookup"))
        return "**Error '".concat(
          error.message,
          "' parsing Weather data lookup.**"
        )
      }
      const areaName = areaNameOverride(
        (_allWeatherData$neare =
          (_allWeatherData$neare2 = allWeatherData.nearest_area[0]) === null ||
          _allWeatherData$neare2 === void 0
            ? void 0
            : (_allWeatherData$neare3 = _allWeatherData$neare2.areaName[0]) ===
                  null || _allWeatherData$neare3 === void 0
              ? void 0
              : _allWeatherData$neare3.value) !== null &&
          _allWeatherData$neare !== void 0
          ? _allWeatherData$neare
          : '(no nearest_area returned)'
      )
      const region =
        (_allWeatherData$neare4 =
          allWeatherData.nearest_area[0].region[0].value) !== null &&
        _allWeatherData$neare4 !== void 0
          ? _allWeatherData$neare4
          : '(no region returned)'
      const country =
        (_allWeatherData$neare5 =
          allWeatherData.nearest_area[0].country[0].value) !== null &&
        _allWeatherData$neare5 !== void 0
          ? _allWeatherData$neare5
          : '(no country returned)'
      const minTempF = allWeatherData.weather[0].mintempF
      const maxTempF = allWeatherData.weather[0].maxtempF
      const minTempC = allWeatherData.weather[0].mintempC
      const maxTempC = allWeatherData.weather[0].maxtempC
      const weatherDesc =
        (_allWeatherData$curre =
          (_allWeatherData$curre2 = allWeatherData.current_condition[0]) ===
            null || _allWeatherData$curre2 === void 0
            ? void 0
            : (_allWeatherData$curre3 =
                  _allWeatherData$curre2.weatherDesc[0]) === null ||
                _allWeatherData$curre3 === void 0
              ? void 0
              : _allWeatherData$curre3.value) !== null &&
        _allWeatherData$curre !== void 0
          ? _allWeatherData$curre
          : '(no weatherDesc found)'
      let weatherIcon = ''
      for (let i = 0; i < weatherDescTexts.length; i++) {
        if (weatherDesc.toLowerCase().match(weatherDescTexts[i])) {
          weatherIcon = weatherDescIcons[i]
          break
        }
      }
      const replacements = [
        {
          key: ':areaName:',
          value: areaName,
        },
        {
          key: ':region:',
          value: region,
        },
        {
          key: ':country:',
          value: country,
        },
        {
          key: ':mintempC:',
          value: minTempC,
        },
        {
          key: ':maxtempC:',
          value: maxTempC,
        },
        {
          key: ':mintempF:',
          value: minTempF,
        },
        {
          key: ':maxtempF:',
          value: maxTempF,
        },
        {
          key: ':description:',
          value: weatherDesc,
        },
        {
          key: ':icon:',
          value: weatherIcon,
        },
      ]
      let output = stringReplace(format, replacements)
      let matchesObj = output.matchAll(/:([\w]*?):/g)
      for (let matchedItem of matchesObj) {
        var _allWeatherData$curre4
        const key = matchedItem[1]
        const value =
          (_allWeatherData$curre4 =
            allWeatherData.current_condition[0][key]) !== null &&
          _allWeatherData$curre4 !== void 0
            ? _allWeatherData$curre4
            : '(missing)'
        output = output.replace(':'.concat(key, ':'), value)
      }
      return output
    } else {
      logError(pluginJson$1, 'Null JSON returned from Weather data lookup.')
      return '_Error: got no data back from Weather data lookup._'
    }
  } catch (error) {
    logError(
      pluginJson$1,
      "'"
        .concat(error.message, "' in weather data lookup from ")
        .concat(getWeatherURL)
    )
    return "**Error '"
      .concat(error.message, "' occurred in weather data lookup from ")
      .concat(getWeatherURL, '.**')
  }
}
var freeGlobal$1 =
  typeof commonjsGlobal == 'object' &&
  commonjsGlobal &&
  commonjsGlobal.Object === Object &&
  commonjsGlobal
var _freeGlobal = freeGlobal$1
var freeGlobal = _freeGlobal
var freeSelf = typeof self == 'object' && self && self.Object === Object && self
var root$3 = freeGlobal || freeSelf || Function('return this')()
var _root = root$3
var root$2 = _root
var Symbol$4 = root$2.Symbol
var _Symbol = Symbol$4
var Symbol$3 = _Symbol
var objectProto$4 = Object.prototype
var hasOwnProperty$3 = objectProto$4.hasOwnProperty
var nativeObjectToString$1 = objectProto$4.toString
var symToStringTag$1 = Symbol$3 ? Symbol$3.toStringTag : undefined
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$3.call(value, symToStringTag$1),
    tag = value[symToStringTag$1]
  try {
    value[symToStringTag$1] = undefined
    var unmasked = true
  } catch (e) {}
  var result = nativeObjectToString$1.call(value)
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag
    } else {
      delete value[symToStringTag$1]
    }
  }
  return result
}
var _getRawTag = getRawTag$1
var objectProto$3 = Object.prototype
var nativeObjectToString = objectProto$3.toString
function objectToString$1(value) {
  return nativeObjectToString.call(value)
}
var _objectToString = objectToString$1
var Symbol$2 = _Symbol,
  getRawTag = _getRawTag,
  objectToString = _objectToString
var nullTag = '[object Null]',
  undefinedTag = '[object Undefined]'
var symToStringTag = Symbol$2 ? Symbol$2.toStringTag : undefined
function baseGetTag$1(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag
  }
  return symToStringTag && symToStringTag in Object(value)
    ? getRawTag(value)
    : objectToString(value)
}
var _baseGetTag = baseGetTag$1
function isObject$2(value) {
  var type = typeof value
  return value != null && (type == 'object' || type == 'function')
}
var isObject_1 = isObject$2
var baseGetTag = _baseGetTag,
  isObject$1 = isObject_1
var asyncTag = '[object AsyncFunction]',
  funcTag = '[object Function]',
  genTag = '[object GeneratorFunction]',
  proxyTag = '[object Proxy]'
function isFunction$1(value) {
  if (!isObject$1(value)) {
    return false
  }
  var tag = baseGetTag(value)
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag
}
var isFunction_1 = isFunction$1
var root$1 = _root
var coreJsData$1 = root$1['__core-js_shared__']
var _coreJsData = coreJsData$1
var coreJsData = _coreJsData
var maskSrcKey = (function () {
  var uid = /[^.]+$/.exec(
    (coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO) || ''
  )
  return uid ? 'Symbol(src)_1.' + uid : ''
})()
function isMasked$1(func) {
  return !!maskSrcKey && maskSrcKey in func
}
var _isMasked = isMasked$1
var funcProto$1 = Function.prototype
var funcToString$1 = funcProto$1.toString
function toSource$1(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func)
    } catch (e) {}
    try {
      return func + ''
    } catch (e) {}
  }
  return ''
}
var _toSource = toSource$1
var isFunction = isFunction_1,
  isMasked = _isMasked,
  isObject = isObject_1,
  toSource = _toSource
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g
var reIsHostCtor = /^\[object .+?Constructor\]$/
var funcProto = Function.prototype,
  objectProto$2 = Object.prototype
var funcToString = funcProto.toString
var hasOwnProperty$2 = objectProto$2.hasOwnProperty
var reIsNative = RegExp(
  '^' +
    funcToString
      .call(hasOwnProperty$2)
      .replace(reRegExpChar, '\\$&')
      .replace(
        /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
        '$1.*?'
      ) +
    '$'
)
function baseIsNative$1(value) {
  if (!isObject(value) || isMasked(value)) {
    return false
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor
  return pattern.test(toSource(value))
}
var _baseIsNative = baseIsNative$1
function getValue$1(object, key) {
  return object == null ? undefined : object[key]
}
var _getValue = getValue$1
var baseIsNative = _baseIsNative,
  getValue = _getValue
function getNative$2(object, key) {
  var value = getValue(object, key)
  return baseIsNative(value) ? value : undefined
}
var _getNative = getNative$2
var getNative$1 = _getNative
var nativeCreate$4 = getNative$1(Object, 'create')
var _nativeCreate = nativeCreate$4
var nativeCreate$3 = _nativeCreate
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {}
  this.size = 0
}
var _hashClear = hashClear$1
function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key]
  this.size -= result ? 1 : 0
  return result
}
var _hashDelete = hashDelete$1
var nativeCreate$2 = _nativeCreate
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__'
var objectProto$1 = Object.prototype
var hasOwnProperty$1 = objectProto$1.hasOwnProperty
function hashGet$1(key) {
  var data = this.__data__
  if (nativeCreate$2) {
    var result = data[key]
    return result === HASH_UNDEFINED$1 ? undefined : result
  }
  return hasOwnProperty$1.call(data, key) ? data[key] : undefined
}
var _hashGet = hashGet$1
var nativeCreate$1 = _nativeCreate
var objectProto = Object.prototype
var hasOwnProperty = objectProto.hasOwnProperty
function hashHas$1(key) {
  var data = this.__data__
  return nativeCreate$1
    ? data[key] !== undefined
    : hasOwnProperty.call(data, key)
}
var _hashHas = hashHas$1
var nativeCreate = _nativeCreate
var HASH_UNDEFINED = '__lodash_hash_undefined__'
function hashSet$1(key, value) {
  var data = this.__data__
  this.size += this.has(key) ? 0 : 1
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value
  return this
}
var _hashSet = hashSet$1
var hashClear = _hashClear,
  hashDelete = _hashDelete,
  hashGet = _hashGet,
  hashHas = _hashHas,
  hashSet = _hashSet
function Hash$1(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length
  this.clear()
  while (++index < length) {
    var entry = entries[index]
    this.set(entry[0], entry[1])
  }
}
Hash$1.prototype.clear = hashClear
Hash$1.prototype['delete'] = hashDelete
Hash$1.prototype.get = hashGet
Hash$1.prototype.has = hashHas
Hash$1.prototype.set = hashSet
var _Hash = Hash$1
function listCacheClear$1() {
  this.__data__ = []
  this.size = 0
}
var _listCacheClear = listCacheClear$1
function eq$1(value, other) {
  return value === other || (value !== value && other !== other)
}
var eq_1 = eq$1
var eq = eq_1
function assocIndexOf$4(array, key) {
  var length = array.length
  while (length--) {
    if (eq(array[length][0], key)) {
      return length
    }
  }
  return -1
}
var _assocIndexOf = assocIndexOf$4
var assocIndexOf$3 = _assocIndexOf
var arrayProto = Array.prototype
var splice = arrayProto.splice
function listCacheDelete$1(key) {
  var data = this.__data__,
    index = assocIndexOf$3(data, key)
  if (index < 0) {
    return false
  }
  var lastIndex = data.length - 1
  if (index == lastIndex) {
    data.pop()
  } else {
    splice.call(data, index, 1)
  }
  --this.size
  return true
}
var _listCacheDelete = listCacheDelete$1
var assocIndexOf$2 = _assocIndexOf
function listCacheGet$1(key) {
  var data = this.__data__,
    index = assocIndexOf$2(data, key)
  return index < 0 ? undefined : data[index][1]
}
var _listCacheGet = listCacheGet$1
var assocIndexOf$1 = _assocIndexOf
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1
}
var _listCacheHas = listCacheHas$1
var assocIndexOf = _assocIndexOf
function listCacheSet$1(key, value) {
  var data = this.__data__,
    index = assocIndexOf(data, key)
  if (index < 0) {
    ++this.size
    data.push([key, value])
  } else {
    data[index][1] = value
  }
  return this
}
var _listCacheSet = listCacheSet$1
var listCacheClear = _listCacheClear,
  listCacheDelete = _listCacheDelete,
  listCacheGet = _listCacheGet,
  listCacheHas = _listCacheHas,
  listCacheSet = _listCacheSet
function ListCache$1(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length
  this.clear()
  while (++index < length) {
    var entry = entries[index]
    this.set(entry[0], entry[1])
  }
}
ListCache$1.prototype.clear = listCacheClear
ListCache$1.prototype['delete'] = listCacheDelete
ListCache$1.prototype.get = listCacheGet
ListCache$1.prototype.has = listCacheHas
ListCache$1.prototype.set = listCacheSet
var _ListCache = ListCache$1
var getNative = _getNative,
  root = _root
var Map$1 = getNative(root, 'Map')
var _Map = Map$1
var Hash = _Hash,
  ListCache = _ListCache,
  Map = _Map
function mapCacheClear$1() {
  this.size = 0
  this.__data__ = {
    hash: new Hash(),
    map: new (Map || ListCache)(),
    string: new Hash(),
  }
}
var _mapCacheClear = mapCacheClear$1
function isKeyable$1(value) {
  var type = typeof value
  return type == 'string' ||
    type == 'number' ||
    type == 'symbol' ||
    type == 'boolean'
    ? value !== '__proto__'
    : value === null
}
var _isKeyable = isKeyable$1
var isKeyable = _isKeyable
function getMapData$4(map, key) {
  var data = map.__data__
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map
}
var _getMapData = getMapData$4
var getMapData$3 = _getMapData
function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)['delete'](key)
  this.size -= result ? 1 : 0
  return result
}
var _mapCacheDelete = mapCacheDelete$1
var getMapData$2 = _getMapData
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key)
}
var _mapCacheGet = mapCacheGet$1
var getMapData$1 = _getMapData
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key)
}
var _mapCacheHas = mapCacheHas$1
var getMapData = _getMapData
function mapCacheSet$1(key, value) {
  var data = getMapData(this, key),
    size = data.size
  data.set(key, value)
  this.size += data.size == size ? 0 : 1
  return this
}
var _mapCacheSet = mapCacheSet$1
var mapCacheClear = _mapCacheClear,
  mapCacheDelete = _mapCacheDelete,
  mapCacheGet = _mapCacheGet,
  mapCacheHas = _mapCacheHas,
  mapCacheSet = _mapCacheSet
function MapCache$1(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length
  this.clear()
  while (++index < length) {
    var entry = entries[index]
    this.set(entry[0], entry[1])
  }
}
MapCache$1.prototype.clear = mapCacheClear
MapCache$1.prototype['delete'] = mapCacheDelete
MapCache$1.prototype.get = mapCacheGet
MapCache$1.prototype.has = mapCacheHas
MapCache$1.prototype.set = mapCacheSet
var _MapCache = MapCache$1
var MapCache = _MapCache
var FUNC_ERROR_TEXT = 'Expected a function'
function memoize$1(func, resolver) {
  if (
    typeof func != 'function' ||
    (resolver != null && typeof resolver != 'function')
  ) {
    throw new TypeError(FUNC_ERROR_TEXT)
  }
  var memoized = function () {
    var args = arguments,
      key = resolver ? resolver.apply(this, args) : args[0],
      cache = memoized.cache
    if (cache.has(key)) {
      return cache.get(key)
    }
    var result = func.apply(this, args)
    memoized.cache = cache.set(key, result) || cache
    return result
  }
  memoized.cache = new (memoize$1.Cache || MapCache)()
  return memoized
}
memoize$1.Cache = MapCache
var memoize_1 = memoize$1
var memoize = memoize_1
var MAX_MEMOIZE_SIZE = 500
function memoizeCapped$1(func) {
  var result = memoize(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear()
    }
    return key
  })
  var cache = result.cache
  return result
}
var _memoizeCapped = memoizeCapped$1
var memoizeCapped = _memoizeCapped
var rePropName =
  /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g
var reEscapeChar = /\\(\\)?/g
memoizeCapped(function (string) {
  var result = []
  if (string.charCodeAt(0) === 46) {
    result.push('')
  }
  string.replace(rePropName, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match)
  })
  return result
})
var Symbol$1 = _Symbol
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined
symbolProto ? symbolProto.toString : undefined
async function initConfiguration(pluginJsonData) {
  const migrateData = {}
  if (typeof pluginJsonData !== 'object') {
    await CommandBar.prompt('NotePlan Error', 'Invalid Plugin Settings')
    return migrateData
  }
  try {
    const pluginSettings = pluginJsonData.hasOwnProperty('plugin.settings')
      ? pluginJsonData['plugin.settings']
      : []
    pluginSettings.forEach((setting) => {
      migrateData[setting.key] = setting.default
    })
  } catch (error) {
    CommandBar.prompt('NotePlan Error', 'An error occurred '.concat(error))
  }
  return migrateData
}
function updateSettingData(pluginJsonData) {
  let updateResult = 0
  const newSettings = {}
  const currentSettingData = DataStore.settings
  const pluginSettings = pluginJsonData.hasOwnProperty('plugin.settings')
    ? pluginJsonData['plugin.settings']
    : []
  pluginSettings.forEach((setting) => {
    const key =
      (setting === null || setting === void 0 ? void 0 : setting.key) || null
    if (key) {
      if (!currentSettingData.hasOwnProperty(key)) {
        newSettings[key] =
          (setting === null || setting === void 0 ? void 0 : setting.default) ||
          ''
        updateResult = 1
      } else {
        newSettings[key] = currentSettingData[key]
      }
    }
  })
  try {
    DataStore.settings = newSettings
  } catch (error) {
    console.log(
      'NPConfiguration/updateSettingData/Plugin Settings Migration Failed. Was not able to automatically migrate your plugin settings to the new version. Please open the plugin settings and save in order to update your settings.'
    )
    updateResult = -1
  }
  return updateResult
}
function getSetting() {
  let pluginId =
    arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
  let key =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ''
  let defaultValue =
    arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ''
  const settings = DataStore.loadJSON(
    '../../data/'.concat(pluginId, '/settings.json')
  )
  return typeof settings === 'object' && settings.hasOwnProperty(key)
    ? settings[key]
    : defaultValue
}
const _excluded = ['locale']
async function processDate(dateParams, config) {
  var _config$date
  const defaultConfig =
    (_config$date =
      config === null || config === void 0 ? void 0 : config.date) !== null &&
    _config$date !== void 0
      ? _config$date
      : {}
  const dateParamsTrimmed =
    (dateParams === null || dateParams === void 0
      ? void 0
      : dateParams.trim()) || ''
  const paramConfig =
    dateParamsTrimmed.startsWith('{') && dateParamsTrimmed.endsWith('}')
      ? await parseJSON5$1(dateParams)
      : dateParamsTrimmed !== ''
        ? await parseJSON5$1('{'.concat(dateParams, '}'))
        : {}
  const finalArguments = _objectSpread2(
    _objectSpread2({}, defaultConfig),
    paramConfig
  )
  const _ref = finalArguments,
    { locale: locale } = _ref,
    otherParams = _objectWithoutProperties(_ref, _excluded)
  const localeParam = locale != null ? String(locale) : []
  const secondParam = _objectSpread2(
    {
      dateStyle: 'short',
    },
    otherParams
  )
  return new Intl.DateTimeFormat(localeParam, secondParam).format(new Date())
}
async function isCommandAvailable(pluginId, pluginCommand) {
  try {
    let result = DataStore.installedPlugins().filter(
      (plugin) => plugin.id === pluginId
    )
    let commands =
      typeof result !== 'undefined' &&
      Array.isArray(result) &&
      result.length > 0 &&
      result[0].commands
    if (commands) {
      let command = commands.filter((command) => command.name === pluginCommand)
      return Array.isArray(command) && command.length > 0
    } else {
      return false
    }
  } catch (error) {
    logError(pluginJson$1, error)
    return false
  }
}
async function invokePluginCommandByName() {
  let pluginId =
    arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
  let pluginCommand =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ''
  let args =
    arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : []
  if (await isCommandAvailable(pluginId, pluginCommand)) {
    return (
      (await DataStore.invokePluginCommandByName(
        pluginCommand,
        pluginId,
        args
      )) || ''
    )
  } else {
    const info = ''
    return '**Unable to locate "'
      .concat(pluginId, ' :: ')
      .concat(pluginCommand, '".  Make sure "')
      .concat(pluginId, '" plugin has been installed.**\n\n')
      .concat(info)
  }
}
const globals = {
  affirmation: async () => getAffirmation(),
  advice: async () => getAdvice(),
  quote: async () => getDailyQuote(),
  wotd: async () => getWOTD(),
  legacyDate: async function () {
    let params =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    return await processDate(JSON.stringify(params))
  },
  progressUpdate: async (params) =>
    await invokePluginCommandByName('jgclark.Summaries', 'progressUpdate', [
      params,
    ]),
  todayProgressFromTemplate: async (params) =>
    await invokePluginCommandByName(
      'jgclark.Summaries',
      'todayProgressFromTemplate',
      [JSON.stringify(params)]
    ),
  weather: async function () {
    let formatParam =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let weatherFormat =
      getSetting(pluginJson$1['plugin.id'], 'weatherFormat', '') || ''
    if (formatParam.length > 0) {
      weatherFormat = formatParam
    }
    return weatherFormat === 0
      ? await getWeather()
      : await getWeatherSummary(weatherFormat)
  },
  date8601: async () =>
    await invokePluginCommandByName(
      'dwertheimer.DateAutomations',
      'date8601',
      null
    ),
  currentDate: async (params) => await processDate(JSON.stringify(params)),
  pickDate: async function () {
    return "**The 'pickDate' helper has been deprecated, you should modify template to use 'promptDate(...) method.**'"
  },
  pickDateInterval: async (dateParams) =>
    "**'pickDateInterval' has been deprecated, you should modify template to use 'promptDateInterval(...) method.**'",
  events: async (dateParams) =>
    invokePluginCommandByName('jgclark.EventHelpers', 'listDaysEvents', [
      JSON.stringify(dateParams),
    ]),
  listTodaysEvents: async function () {
    let params =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    return invokePluginCommandByName('jgclark.EventHelpers', 'listDaysEvents', [
      JSON.stringify(params),
    ])
  },
  matchingEvents: async function () {
    let params =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    return invokePluginCommandByName(
      'jgclark.EventHelpers',
      'listMatchingDaysEvents',
      [JSON.stringify(params)]
    )
  },
  listMatchingEvents: async function () {
    let params =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    return invokePluginCommandByName(
      'jgclark.EventHelpers',
      'listMatchingDaysEvents',
      [JSON.stringify(params)]
    )
  },
  sweepTasks: async function () {
    let params =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    return invokePluginCommandByName('nmn.sweep', 'sweepTemplate', [
      JSON.stringify(params),
    ])
  },
  formattedDateTime: (params) => {
    const dateFormat =
      typeof params === 'object' && params.hasOwnProperty('format')
        ? params.format
        : params
    return getFormattedTime(dateFormat)
  },
  weekDates: async (params) =>
    invokePluginCommandByName('dwertheimer.DateAutomations', 'getWeekDates', [
      JSON.stringify(params),
    ]),
  now: async () => now(),
  timestamp: async () => timestamp(),
  currentTime: async () => time(),
  currentDate: async () => now(),
  selection: async () =>
    Editor.selectedParagraphs.map((para) => para.rawContent).join('\n'),
  clo: function (obj) {
    let preamble =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ''
    let space =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2
    clo(obj, preamble, space)
  },
}
async function getVerse() {
  try {
    const URL = 'https://labs.bible.org/api/?passage=random&type=json'
    const response = await await fetch(URL, {
      timeout: 3e3,
    })
    const data = JSON.parse(response)[0]
    return data
      ? '> 🙏🏻  '
          .concat(
            data === null || data === void 0 ? void 0 : data.bookname,
            ' '
          )
          .concat(data === null || data === void 0 ? void 0 : data.chapter, ':')
          .concat(
            data === null || data === void 0 ? void 0 : data.verse,
            ' \n> 🗣  '
          )
          .concat(data === null || data === void 0 ? void 0 : data.text)
      : '**An error occurred accessing quoting service**'
  } catch (err) {
    return '**An error occurred accessing quoting service**'
  }
}
Object.arrayReference = function (o, s) {
  s = s.replace(/\[(\w+)\]/g, '.$1')
  s = s.replace(/^\./, '')
  const a = s.split('.')
  for (let i = 0, n = a.length; i < n; ++i) {
    const k = a[i]
    if (k in o) {
      o = o[k]
    } else {
      return
    }
  }
  return o
}
const formatData = (obj) =>
  JSON.stringify(obj, null, 2)
    .replace(/\\/g, ' ')
    .replace(/, /g, ',\n   ')
    .replace(/"{/g, '{\n  ')
    .replace(/}"/g, '\n}')
    .replace(/ ",/g, '",')
    .replace(/ ":/g, '":')
const isJson = (str) => {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}
const isURL = (str) => str.indexOf('http') >= 0
async function getService(templateConfig) {
  let section =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ''
  let key =
    arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ''
  const serviceConfig =
    templateConfig === null || templateConfig === void 0
      ? void 0
      : templateConfig.services
  if (serviceConfig) {
    if (!isURL(section) && !serviceConfig.hasOwnProperty(section)) {
      return '**invalid section "'.concat(section, '"**')
    }
    let URL = isURL(section) ? section : serviceConfig[section]
    let dataKey = key
    try {
      if (typeof URL === 'object') {
        dataKey = URL.keys
        URL = URL.url
      }
      const response = await fetch(URL)
      if (!isJson(response)) {
        if (response.indexOf('error') >= 0) {
          const endpoint = isURL(section) ? ' API' : ' service'
          throw new Error('Accessing '.concat(section).concat(endpoint))
        }
        return response.replace('\n', '')
      }
      const data = JSON.parse(response)
      if (dataKey === '*') {
        return formatData(data)
      }
      let result = ''
      if (Array.isArray(dataKey)) {
        dataKey.forEach((item) => {
          const value = Object.arrayReference(data, item)
          result += value ? value : item
        })
        return result
      } else {
        if (data.hasOwnProperty('error')) {
          return JSON.stringify(data.error, null, 1)
        }
        return Object.arrayReference(data, ''.concat(dataKey))
      }
    } catch (error) {
      return error
    }
  }
  return ''
}
class WebModule {
  async advice() {
    return await getAdvice()
  }
  async affirmation() {
    return await getAffirmation()
  }
  async quote() {
    return await getDailyQuote()
  }
  async weather(templateConfig) {
    var _templateConfig$weath
    let params =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ''
    let weatherFormat = params.length > 0 ? params : ''
    weatherFormat =
      weatherFormat.length === 0 &&
      (templateConfig === null || templateConfig === void 0
        ? void 0
        : (_templateConfig$weath = templateConfig.weatherFormat) === null ||
            _templateConfig$weath === void 0
          ? void 0
          : _templateConfig$weath.length) > 0
        ? templateConfig === null || templateConfig === void 0
          ? void 0
          : templateConfig.weatherFormat
        : weatherFormat
    return weatherFormat.length === 0
      ? await (await getWeather()).trim()
      : await (await getWeatherSummary(weatherFormat)).trim()
  }
  async verse() {
    return await getVerse()
  }
  async service(templateConfig) {
    let serviceUrl =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ''
    let key =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ''
    return await getService(templateConfig, serviceUrl, key)
  }
  async wotd(templateConfig) {
    let params =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ''
    const confg = _objectSpread2(_objectSpread2({}, templateConfig), params)
    return await getWOTD(confg)
  }
}
class NoteModule {
  constructor(config) {
    this.config = config
  }
  getCurrentNote() {
    var _Editor$filename, _Editor$type
    const filename =
      Editor.type === 'Calendar'
        ? (_Editor$filename = Editor.filename) === null ||
          _Editor$filename === void 0
          ? void 0
          : _Editor$filename.replace('.md', '')
        : Editor.filename
    if (filename == null) {
      return null
    }
    const note = DataStore.noteByFilename(
      filename,
      (_Editor$type = Editor.type) !== null && _Editor$type !== void 0
        ? _Editor$type
        : 'Notes'
    )
    return note
  }
  setCursor() {
    return '$NP_CURSOR'
  }
  filename() {
    var _this$getCurrentNote
    return (_this$getCurrentNote = this.getCurrentNote()) === null ||
      _this$getCurrentNote === void 0
      ? void 0
      : _this$getCurrentNote.filename
  }
  title() {
    var _this$getCurrentNote2
    return (_this$getCurrentNote2 = this.getCurrentNote()) === null ||
      _this$getCurrentNote2 === void 0
      ? void 0
      : _this$getCurrentNote2.title
  }
  type() {
    var _this$getCurrentNote3
    return (_this$getCurrentNote3 = this.getCurrentNote()) === null ||
      _this$getCurrentNote3 === void 0
      ? void 0
      : _this$getCurrentNote3.type
  }
  content() {
    var _this$getCurrentNote4
    let stripFrontmatter =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false
    let content =
      (_this$getCurrentNote4 = this.getCurrentNote()) === null ||
      _this$getCurrentNote4 === void 0
        ? void 0
        : _this$getCurrentNote4.content
    if (content == null) {
      return null
    }
    if (stripFrontmatter) {
      const frontmatterText = new FrontmatterModule().getFrontmatterText(
        content
      )
      content = content.replace(frontmatterText, '')
    }
    return content
  }
  hashtags() {
    var _this$getCurrentNote5
    return (_this$getCurrentNote5 = this.getCurrentNote()) === null ||
      _this$getCurrentNote5 === void 0
      ? void 0
      : _this$getCurrentNote5.hashtags.join(', ')
  }
  mentions() {
    var _this$getCurrentNote6
    return (_this$getCurrentNote6 = this.getCurrentNote()) === null ||
      _this$getCurrentNote6 === void 0
      ? void 0
      : _this$getCurrentNote6.mentions.join(', ')
  }
  date() {
    var _this$getCurrentNote7
    let format =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let dt =
      (_this$getCurrentNote7 = this.getCurrentNote()) === null ||
      _this$getCurrentNote7 === void 0
        ? void 0
        : _this$getCurrentNote7.date
    if (format.length > 0) {
      dt = moment$1(dt).format('YYYY-MM-DD')
    }
    return dt
  }
  createdDate() {
    var _this$getCurrentNote8
    let format =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let dt =
      (_this$getCurrentNote8 = this.getCurrentNote()) === null ||
      _this$getCurrentNote8 === void 0
        ? void 0
        : _this$getCurrentNote8.createdDate
    if (format.length > 0) {
      dt = moment$1(dt).format('YYYY-MM-DD')
    }
    return dt
  }
  changedDate() {
    var _this$getCurrentNote9
    let format =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let dt =
      (_this$getCurrentNote9 = this.getCurrentNote()) === null ||
      _this$getCurrentNote9 === void 0
        ? void 0
        : _this$getCurrentNote9.changedDate
    if (format.length > 0) {
      dt = moment$1(dt).format('YYYY-MM-DD')
    }
    return dt
  }
  paragraphs() {
    var _this$getCurrentNote10
    let paragraphs =
      (_this$getCurrentNote10 = this.getCurrentNote()) === null ||
      _this$getCurrentNote10 === void 0
        ? void 0
        : _this$getCurrentNote10.paragraphs
    let result = []
    if (paragraphs == null) {
      return result
    }
    paragraphs.forEach((item) => {
      let keys = getAllPropertyNames(item)
      keys.forEach((key) => {
        if (
          typeof item[key] === 'string' ||
          typeof item[key] === 'boolean' ||
          Array.isArray(item[key])
        ) {
          result.push({
            key: key,
            value: item[key],
          })
        }
      })
    })
    return result
  }
  backlinks() {
    var _this$getCurrentNote11
    let backlinks =
      (_this$getCurrentNote11 = this.getCurrentNote()) === null ||
      _this$getCurrentNote11 === void 0
        ? void 0
        : _this$getCurrentNote11.backlinks
    let result = []
    if (backlinks == null) {
      return result
    }
    backlinks.forEach((item) => {
      let keys = getAllPropertyNames(item)
      keys.forEach((key) => {
        if (
          typeof item[key] === 'string' ||
          typeof item[key] === 'boolean' ||
          Array.isArray(item[key])
        ) {
          result.push({
            key: key,
            value: item[key],
          })
        }
      })
    })
    return result
  }
  linkedItems() {
    var _this$getCurrentNote12
    let linkedItems =
      (_this$getCurrentNote12 = this.getCurrentNote()) === null ||
      _this$getCurrentNote12 === void 0
        ? void 0
        : _this$getCurrentNote12.linkedItems
    let result = []
    if (linkedItems == null) {
      return result
    }
    linkedItems.forEach((item) => {
      let keys = getAllPropertyNames(item)
      keys.forEach((key) => {
        if (
          typeof item[key] === 'string' ||
          typeof item[key] === 'boolean' ||
          Array.isArray(item[key])
        ) {
          result.push({
            key: key,
            value: item[key],
          })
        }
      })
    })
    return result
  }
  datedTodos() {
    var _this$getCurrentNote13
    let datedTodos =
      (_this$getCurrentNote13 = this.getCurrentNote()) === null ||
      _this$getCurrentNote13 === void 0
        ? void 0
        : _this$getCurrentNote13.datedTodos
    let result = []
    if (datedTodos == null) {
      return result
    }
    datedTodos.forEach((item) => {
      let keys = getAllPropertyNames(item)
      keys.forEach((key) => {
        if (
          typeof item[key] === 'string' ||
          typeof item[key] === 'boolean' ||
          Array.isArray(item[key])
        ) {
          result.push({
            key: key,
            value: item[key],
          })
        }
      })
    })
    return result
  }
  async attributes() {
    var _this$getCurrentNote$, _this$getCurrentNote14
    const iFM = new FrontmatterModule()
    const note =
      (_this$getCurrentNote$ =
        (_this$getCurrentNote14 = this.getCurrentNote()) === null ||
        _this$getCurrentNote14 === void 0
          ? void 0
          : _this$getCurrentNote14.content) !== null &&
      _this$getCurrentNote$ !== void 0
        ? _this$getCurrentNote$
        : ''
    let result = []
    if (iFM.isFrontmatterTemplate(note)) {
      for (const [key, value] of Object.entries(iFM.attributes(note))) {
        result.push({
          key: key,
          value: value,
        })
      }
    }
    return result
  }
}
var sprintf = {}
;(function (exports) {
  ;(function (window) {
    var re = {
      not_string: /[^s]/,
      number: /[diefg]/,
      json: /[j]/,
      not_json: /[^j]/,
      text: /^[^\x25]+/,
      modulo: /^\x25{2}/,
      placeholder:
        /^\x25(?:([1-9]\d*)\$|\(([^\)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijosuxX])/,
      key: /^([a-z_][a-z_\d]*)/i,
      key_access: /^\.([a-z_][a-z_\d]*)/i,
      index_access: /^\[(\d+)\]/,
      sign: /^[\+\-]/,
    }
    function sprintf() {
      var key = arguments[0],
        cache = sprintf.cache
      if (!(cache[key] && cache.hasOwnProperty(key))) {
        cache[key] = sprintf.parse(key)
      }
      return sprintf.format.call(null, cache[key], arguments)
    }
    sprintf.format = function (parse_tree, argv) {
      var cursor = 1,
        tree_length = parse_tree.length,
        node_type = '',
        arg,
        output = [],
        i,
        k,
        match,
        pad,
        pad_character,
        pad_length,
        is_positive = true,
        sign = ''
      for (i = 0; i < tree_length; i++) {
        node_type = get_type(parse_tree[i])
        if (node_type === 'string') {
          output[output.length] = parse_tree[i]
        } else if (node_type === 'array') {
          match = parse_tree[i]
          if (match[2]) {
            arg = argv[cursor]
            for (k = 0; k < match[2].length; k++) {
              if (!arg.hasOwnProperty(match[2][k])) {
                throw new Error(
                  sprintf("[sprintf] property '%s' does not exist", match[2][k])
                )
              }
              arg = arg[match[2][k]]
            }
          } else if (match[1]) {
            arg = argv[match[1]]
          } else {
            arg = argv[cursor++]
          }
          if (get_type(arg) == 'function') {
            arg = arg()
          }
          if (
            re.not_string.test(match[8]) &&
            re.not_json.test(match[8]) &&
            get_type(arg) != 'number' &&
            isNaN(arg)
          ) {
            throw new TypeError(
              sprintf('[sprintf] expecting number but found %s', get_type(arg))
            )
          }
          if (re.number.test(match[8])) {
            is_positive = arg >= 0
          }
          switch (match[8]) {
            case 'b':
              arg = arg.toString(2)
              break

            case 'c':
              arg = String.fromCharCode(arg)
              break

            case 'd':
            case 'i':
              arg = parseInt(arg, 10)
              break

            case 'j':
              arg = JSON.stringify(arg, null, match[6] ? parseInt(match[6]) : 0)
              break

            case 'e':
              arg = match[7] ? arg.toExponential(match[7]) : arg.toExponential()
              break

            case 'f':
              arg = match[7]
                ? parseFloat(arg).toFixed(match[7])
                : parseFloat(arg)
              break

            case 'g':
              arg = match[7]
                ? parseFloat(arg).toPrecision(match[7])
                : parseFloat(arg)
              break

            case 'o':
              arg = arg.toString(8)
              break

            case 's':
              arg =
                (arg = String(arg)) && match[7]
                  ? arg.substring(0, match[7])
                  : arg
              break

            case 'u':
              arg = arg >>> 0
              break

            case 'x':
              arg = arg.toString(16)
              break

            case 'X':
              arg = arg.toString(16).toUpperCase()
              break
          }
          if (re.json.test(match[8])) {
            output[output.length] = arg
          } else {
            if (re.number.test(match[8]) && (!is_positive || match[3])) {
              sign = is_positive ? '+' : '-'
              arg = arg.toString().replace(re.sign, '')
            } else {
              sign = ''
            }
            pad_character = match[4]
              ? match[4] === '0'
                ? '0'
                : match[4].charAt(1)
              : ' '
            pad_length = match[6] - (sign + arg).length
            pad = match[6]
              ? pad_length > 0
                ? str_repeat(pad_character, pad_length)
                : ''
              : ''
            output[output.length] = match[5]
              ? sign + arg + pad
              : pad_character === '0'
                ? sign + pad + arg
                : pad + sign + arg
          }
        }
      }
      return output.join('')
    }
    sprintf.cache = {}
    sprintf.parse = function (fmt) {
      var _fmt = fmt,
        match = [],
        parse_tree = [],
        arg_names = 0
      while (_fmt) {
        if ((match = re.text.exec(_fmt)) !== null) {
          parse_tree[parse_tree.length] = match[0]
        } else if ((match = re.modulo.exec(_fmt)) !== null) {
          parse_tree[parse_tree.length] = '%'
        } else if ((match = re.placeholder.exec(_fmt)) !== null) {
          if (match[2]) {
            arg_names |= 1
            var field_list = [],
              replacement_field = match[2],
              field_match = []
            if ((field_match = re.key.exec(replacement_field)) !== null) {
              field_list[field_list.length] = field_match[1]
              while (
                (replacement_field = replacement_field.substring(
                  field_match[0].length
                )) !== ''
              ) {
                if (
                  (field_match = re.key_access.exec(replacement_field)) !== null
                ) {
                  field_list[field_list.length] = field_match[1]
                } else if (
                  (field_match = re.index_access.exec(replacement_field)) !==
                  null
                ) {
                  field_list[field_list.length] = field_match[1]
                } else {
                  throw new SyntaxError(
                    '[sprintf] failed to parse named argument key'
                  )
                }
              }
            } else {
              throw new SyntaxError(
                '[sprintf] failed to parse named argument key'
              )
            }
            match[2] = field_list
          } else {
            arg_names |= 2
          }
          if (arg_names === 3) {
            throw new Error(
              '[sprintf] mixing positional and named placeholders is not (yet) supported'
            )
          }
          parse_tree[parse_tree.length] = match
        } else {
          throw new SyntaxError('[sprintf] unexpected placeholder')
        }
        _fmt = _fmt.substring(match[0].length)
      }
      return parse_tree
    }
    var vsprintf = function (fmt, argv, _argv) {
      _argv = (argv || []).slice(0)
      _argv.splice(0, 0, fmt)
      return sprintf.apply(null, _argv)
    }
    function get_type(variable) {
      return Object.prototype.toString.call(variable).slice(8, -1).toLowerCase()
    }
    function str_repeat(input, multiplier) {
      return Array(multiplier + 1).join(input)
    }
    {
      exports.sprintf = sprintf
      exports.vsprintf = vsprintf
    }
  })()
})(sprintf)
class UtilityModule {
  constructor() {
    let config =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}
    _defineProperty(this, 'config', void 0)
    this.config = config
  }
  format() {
    let formatter =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    for (
      var _len = arguments.length,
        input = new Array(_len > 1 ? _len - 1 : 0),
        _key = 1;
      _key < _len;
      _key++
    ) {
      input[_key - 1] = arguments[_key]
    }
    if (formatter.length > 0) {
      return sprintf.sprintf(formatter, ...input)
    }
    return input
  }
  concat() {
    for (
      var _len2 = arguments.length, params = new Array(_len2), _key2 = 0;
      _key2 < _len2;
      _key2++
    ) {
      params[_key2] = arguments[_key2]
    }
    return params.join(' ').replace(/\s\s+/g, ' ')
  }
  lowercase() {
    let str =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    return str.toLowerCase()
  }
  uppercase() {
    let str =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    return str.toUpperCase()
  }
  titleCase() {
    let str =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    return str.replace(/(^|\s)\S/g, function (t) {
      return t.toUpperCase()
    })
  }
  camelize() {
    let str =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
      if (+match === 0) return ''
      return index === 0 ? match.toLowerCase() : match.toUpperCase()
    })
  }
  slug() {
    let inStr =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let str = inStr
    str = str.replace(/^\s+|\s+$/g, '')
    str = str.toLowerCase()
    const from = 'àáãäâèéëêìíïîòóöôùúüûñç·/_,:;'
    const to = 'aaaaaeeeeiiiioooouuuunc------'
    for (let i = 0, l = from.length; i < l; i++) {
      str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
    }
    str = str
      .replace(/[^a-z0-9 -]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
    return str
  }
  slugify() {
    let inStr =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    return this.slug(inStr)
  }
}
class SystemModule {
  constructor() {
    let config =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}
    _defineProperty(this, 'config', void 0)
    this.config = config
  }
  selection() {
    return Editor.selectedParagraphs.map((para) => para.rawContent).join('\n')
  }
  clipboard() {
    return this.config.clipboard
  }
}
var ejs$1 = {
  exports: {},
}
;(function (module, exports) {
  ;(function (f) {
    {
      module.exports = f()
    }
  })(function () {
    return (function () {
      function r(e, n, t) {
        function o(i, f) {
          if (!n[i]) {
            if (!e[i]) {
              var c = 'function' == typeof commonjsRequire && commonjsRequire
              if (!f && c) return c(i, !0)
              if (u) return u(i, !0)
              var a = new Error("Cannot find module '" + i + "'")
              throw ((a.code = 'MODULE_NOT_FOUND'), a)
            }
            var p = (n[i] = {
              exports: {},
            })
            e[i][0].call(
              p.exports,
              function (r) {
                var n = e[i][1][r]
                return o(n || r)
              },
              p,
              p.exports,
              r,
              e,
              n,
              t
            )
          }
          return n[i].exports
        }
        for (
          var u = 'function' == typeof commonjsRequire && commonjsRequire,
            i = 0;
          i < t.length;
          i++
        )
          o(t[i])
        return o
      }
      return r
    })()(
      {
        1: [
          function (require, module, exports) {
            var fs = require('fs')
            var path = require('path')
            var utils = require('./utils')
            var scopeOptionWarned = false
            var _VERSION_STRING = require('../package.json').version
            var _DEFAULT_OPEN_DELIMITER = '<'
            var _DEFAULT_CLOSE_DELIMITER = '>'
            var _DEFAULT_DELIMITER = '%'
            var _DEFAULT_LOCALS_NAME = 'locals'
            var _NAME = 'ejs'
            var _REGEX_STRING = '(<%%|%%>|<%=|<%-|<%_|<%#|<%|%>|-%>|_%>)'
            var _OPTS_PASSABLE_WITH_DATA = [
              'delimiter',
              'scope',
              'context',
              'debug',
              'compileDebug',
              'client',
              '_with',
              'rmWhitespace',
              'strict',
              'filename',
              'async',
            ]
            var _OPTS_PASSABLE_WITH_DATA_EXPRESS =
              _OPTS_PASSABLE_WITH_DATA.concat('cache')
            var _BOM = /^\uFEFF/
            exports.cache = utils.cache
            exports.fileLoader = fs.readFileSync
            exports.localsName = _DEFAULT_LOCALS_NAME
            exports.promiseImpl = new Function('return this;')().Promise
            exports.resolveInclude = function (name, filename, isDir) {
              var dirname = path.dirname
              var extname = path.extname
              var resolve = path.resolve
              var includePath = resolve(
                isDir ? filename : dirname(filename),
                name
              )
              var ext = extname(name)
              if (!ext) {
                includePath += '.ejs'
              }
              return includePath
            }
            function resolvePaths(name, paths) {
              var filePath
              if (
                paths.some(function (v) {
                  filePath = exports.resolveInclude(name, v, true)
                  return fs.existsSync(filePath)
                })
              ) {
                return filePath
              }
            }
            function getIncludePath(path, options) {
              var includePath
              var filePath
              var views = options.views
              var match = /^[A-Za-z]+:\\|^\//.exec(path)
              if (match && match.length) {
                path = path.replace(/^\/*/, '')
                if (Array.isArray(options.root)) {
                  includePath = resolvePaths(path, options.root)
                } else {
                  includePath = exports.resolveInclude(
                    path,
                    options.root || '/',
                    true
                  )
                }
              } else {
                if (options.filename) {
                  filePath = exports.resolveInclude(path, options.filename)
                  if (fs.existsSync(filePath)) {
                    includePath = filePath
                  }
                }
                if (!includePath && Array.isArray(views)) {
                  includePath = resolvePaths(path, views)
                }
                if (!includePath && typeof options.includer !== 'function') {
                  throw new Error(
                    'Could not find the include file "' +
                      options.escapeFunction(path) +
                      '"'
                  )
                }
              }
              return includePath
            }
            function handleCache(options, template) {
              var func
              var filename = options.filename
              var hasTemplate = arguments.length > 1
              if (options.cache) {
                if (!filename) {
                  throw new Error('cache option requires a filename')
                }
                func = exports.cache.get(filename)
                if (func) {
                  return func
                }
                if (!hasTemplate) {
                  template = fileLoader(filename).toString().replace(_BOM, '')
                }
              } else if (!hasTemplate) {
                if (!filename) {
                  throw new Error(
                    'Internal EJS error: no file name or template ' + 'provided'
                  )
                }
                template = fileLoader(filename).toString().replace(_BOM, '')
              }
              func = exports.compile(template, options)
              if (options.cache) {
                exports.cache.set(filename, func)
              }
              return func
            }
            function tryHandleCache(options, data, cb) {
              var result
              if (!cb) {
                if (typeof exports.promiseImpl == 'function') {
                  return new exports.promiseImpl(function (resolve, reject) {
                    try {
                      result = handleCache(options)(data)
                      resolve(result)
                    } catch (err) {
                      reject(err)
                    }
                  })
                } else {
                  throw new Error('Please provide a callback function')
                }
              } else {
                try {
                  result = handleCache(options)(data)
                } catch (err) {
                  return cb(err)
                }
                cb(null, result)
              }
            }
            function fileLoader(filePath) {
              return exports.fileLoader(filePath)
            }
            function includeFile(path, options) {
              var opts = utils.shallowCopy({}, options)
              opts.filename = getIncludePath(path, opts)
              if (typeof options.includer === 'function') {
                var includerResult = options.includer(path, opts.filename)
                if (includerResult) {
                  if (includerResult.filename) {
                    opts.filename = includerResult.filename
                  }
                  if (includerResult.template) {
                    return handleCache(opts, includerResult.template)
                  }
                }
              }
              return handleCache(opts)
            }
            function rethrow(err, str, flnm, lineno, esc) {
              var lines = str.split('\n')
              var start = Math.max(lineno - 3, 0)
              var end = Math.min(lines.length, lineno + 3)
              var filename = esc(flnm)
              var context = lines
                .slice(start, end)
                .map(function (line, i) {
                  var curr = i + start + 1
                  return (curr == lineno ? ' >> ' : '    ') + curr + '| ' + line
                })
                .join('\n')
              err.path = filename
              err.message =
                (filename || 'ejs') +
                ':' +
                lineno +
                '\n' +
                context +
                '\n\n' +
                err.message
              throw err
            }
            function stripSemi(str) {
              return str.replace(/;(\s*$)/, '$1')
            }
            exports.compile = function compile(template, opts) {
              var templ
              if (opts && opts.scope) {
                if (!scopeOptionWarned) {
                  console.warn(
                    '`scope` option is deprecated and will be removed in EJS 3'
                  )
                  scopeOptionWarned = true
                }
                if (!opts.context) {
                  opts.context = opts.scope
                }
                delete opts.scope
              }
              templ = new Template(template, opts)
              return templ.compile()
            }
            exports.render = function (template, d, o) {
              var data = d || {}
              var opts = o || {}
              if (arguments.length == 2) {
                utils.shallowCopyFromList(opts, data, _OPTS_PASSABLE_WITH_DATA)
              }
              return handleCache(opts, template)(data)
            }
            exports.renderFile = function () {
              var args = Array.prototype.slice.call(arguments)
              var filename = args.shift()
              var cb
              var opts = {
                filename: filename,
              }
              var data
              var viewOpts
              if (typeof arguments[arguments.length - 1] == 'function') {
                cb = args.pop()
              }
              if (args.length) {
                data = args.shift()
                if (args.length) {
                  utils.shallowCopy(opts, args.pop())
                } else {
                  if (data.settings) {
                    if (data.settings.views) {
                      opts.views = data.settings.views
                    }
                    if (data.settings['view cache']) {
                      opts.cache = true
                    }
                    viewOpts = data.settings['view options']
                    if (viewOpts) {
                      utils.shallowCopy(opts, viewOpts)
                    }
                  }
                  utils.shallowCopyFromList(
                    opts,
                    data,
                    _OPTS_PASSABLE_WITH_DATA_EXPRESS
                  )
                }
                opts.filename = filename
              } else {
                data = {}
              }
              return tryHandleCache(opts, data, cb)
            }
            exports.Template = Template
            exports.clearCache = function () {
              exports.cache.reset()
            }
            function Template(text, opts) {
              opts = opts || {}
              var options = {}
              this.templateText = text
              this.mode = null
              this.truncate = false
              this.currentLine = 1
              this.source = ''
              options.client = opts.client || false
              options.escapeFunction =
                opts.escape || opts.escapeFunction || utils.escapeXML
              options.compileDebug = opts.compileDebug !== false
              options.debug = !!opts.debug
              options.filename = opts.filename
              options.openDelimiter =
                opts.openDelimiter ||
                exports.openDelimiter ||
                _DEFAULT_OPEN_DELIMITER
              options.closeDelimiter =
                opts.closeDelimiter ||
                exports.closeDelimiter ||
                _DEFAULT_CLOSE_DELIMITER
              options.delimiter =
                opts.delimiter || exports.delimiter || _DEFAULT_DELIMITER
              options.strict = opts.strict || false
              options.context = opts.context
              options.cache = opts.cache || false
              options.rmWhitespace = opts.rmWhitespace
              options.root = opts.root
              options.includer = opts.includer
              options.outputFunctionName = opts.outputFunctionName
              options.localsName =
                opts.localsName || exports.localsName || _DEFAULT_LOCALS_NAME
              options.views = opts.views
              options.async = opts.async
              options.destructuredLocals = opts.destructuredLocals
              options.legacyInclude =
                typeof opts.legacyInclude != 'undefined'
                  ? !!opts.legacyInclude
                  : true
              if (options.strict) {
                options._with = false
              } else {
                options._with =
                  typeof opts._with != 'undefined' ? opts._with : true
              }
              this.opts = options
              this.regex = this.createRegex()
            }
            Template.modes = {
              EVAL: 'eval',
              ESCAPED: 'escaped',
              RAW: 'raw',
              COMMENT: 'comment',
              LITERAL: 'literal',
            }
            Template.prototype = {
              createRegex: function () {
                var str = _REGEX_STRING
                var delim = utils.escapeRegExpChars(this.opts.delimiter)
                var open = utils.escapeRegExpChars(this.opts.openDelimiter)
                var close = utils.escapeRegExpChars(this.opts.closeDelimiter)
                str = str
                  .replace(/%/g, delim)
                  .replace(/</g, open)
                  .replace(/>/g, close)
                return new RegExp(str)
              },
              compile: function () {
                var src
                var fn
                var opts = this.opts
                var prepended = ''
                var appended = ''
                var escapeFn = opts.escapeFunction
                var ctor
                var sanitizedFilename = opts.filename
                  ? JSON.stringify(opts.filename)
                  : 'undefined'
                if (!this.source) {
                  this.generateSource()
                  prepended +=
                    '  var __output = "";\n' +
                    '  function __append(s) { if (s !== undefined && s !== null) __output += s }\n'
                  if (opts.outputFunctionName) {
                    prepended +=
                      '  var ' + opts.outputFunctionName + ' = __append;' + '\n'
                  }
                  if (
                    opts.destructuredLocals &&
                    opts.destructuredLocals.length
                  ) {
                    var destructuring =
                      '  var __locals = (' + opts.localsName + ' || {}),\n'
                    for (var i = 0; i < opts.destructuredLocals.length; i++) {
                      var name = opts.destructuredLocals[i]
                      if (i > 0) {
                        destructuring += ',\n  '
                      }
                      destructuring += name + ' = __locals.' + name
                    }
                    prepended += destructuring + ';\n'
                  }
                  if (opts._with !== false) {
                    prepended +=
                      '  with (' + opts.localsName + ' || {}) {' + '\n'
                    appended += '  }' + '\n'
                  }
                  appended += '  return __output;' + '\n'
                  this.source = prepended + this.source + appended
                }
                if (opts.compileDebug) {
                  src =
                    'var __line = 1' +
                    '\n' +
                    '  , __lines = ' +
                    JSON.stringify(this.templateText) +
                    '\n' +
                    '  , __filename = ' +
                    sanitizedFilename +
                    ';' +
                    '\n' +
                    'try {' +
                    '\n' +
                    this.source +
                    '} catch (e) {' +
                    '\n' +
                    '  rethrow(e, __lines, __filename, __line, escapeFn);' +
                    '\n' +
                    '}' +
                    '\n'
                } else {
                  src = this.source
                }
                if (opts.client) {
                  src =
                    'escapeFn = escapeFn || ' +
                    escapeFn.toString() +
                    ';' +
                    '\n' +
                    src
                  if (opts.compileDebug) {
                    src =
                      'rethrow = rethrow || ' +
                      rethrow.toString() +
                      ';' +
                      '\n' +
                      src
                  }
                }
                if (opts.strict) {
                  src = '"use strict";\n' + src
                }
                if (opts.debug) {
                  console.log(src)
                }
                if (opts.compileDebug && opts.filename) {
                  src = src + '\n' + '//# sourceURL=' + sanitizedFilename + '\n'
                }
                try {
                  if (opts.async) {
                    try {
                      ctor = new Function(
                        'return (async function(){}).constructor;'
                      )()
                    } catch (e) {
                      if (e instanceof SyntaxError) {
                        throw new Error(
                          'This environment does not support async/await'
                        )
                      } else {
                        throw e
                      }
                    }
                  } else {
                    ctor = Function
                  }
                  fn = new ctor(
                    opts.localsName + ', escapeFn, include, rethrow',
                    src
                  )
                } catch (e) {
                  if (e instanceof SyntaxError) {
                    if (opts.filename) {
                      e.message += ' in ' + opts.filename
                    }
                    e.message += ' while compiling ejs\n\n'
                    e.message +=
                      'If the above error is not helpful, you may want to try EJS-Lint:\n'
                    e.message += 'https://github.com/RyanZim/EJS-Lint'
                    if (!opts.async) {
                      e.message += '\n'
                      e.message +=
                        'Or, if you meant to create an async function, pass `async: true` as an option.'
                    }
                  }
                  throw e
                }
                var returnedFn = opts.client
                  ? fn
                  : function anonymous(data) {
                      var include = function (path, includeData) {
                        var d = utils.shallowCopy({}, data)
                        if (includeData) {
                          d = utils.shallowCopy(d, includeData)
                        }
                        return includeFile(path, opts)(d)
                      }
                      return fn.apply(opts.context, [
                        data || {},
                        escapeFn,
                        include,
                        rethrow,
                      ])
                    }
                if (
                  opts.filename &&
                  typeof Object.defineProperty === 'function'
                ) {
                  var filename = opts.filename
                  var basename = path.basename(filename, path.extname(filename))
                  try {
                    Object.defineProperty(returnedFn, 'name', {
                      value: basename,
                      writable: false,
                      enumerable: false,
                      configurable: true,
                    })
                  } catch (e) {}
                }
                return returnedFn
              },
              generateSource: function () {
                var opts = this.opts
                if (opts.rmWhitespace) {
                  this.templateText = this.templateText
                    .replace(/[\r\n]+/g, '\n')
                    .replace(/^\s+|\s+$/gm, '')
                }
                this.templateText = this.templateText
                  .replace(/[ \t]*<%_/gm, '<%_')
                  .replace(/_%>[ \t]*/gm, '_%>')
                var self = this
                var matches = this.parseTemplateText()
                var d = this.opts.delimiter
                var o = this.opts.openDelimiter
                var c = this.opts.closeDelimiter
                if (matches && matches.length) {
                  matches.forEach(function (line, index) {
                    var closing
                    if (
                      line.indexOf(o + d) === 0 &&
                      line.indexOf(o + d + d) !== 0
                    ) {
                      closing = matches[index + 2]
                      if (
                        !(
                          closing == d + c ||
                          closing == '-' + d + c ||
                          closing == '_' + d + c
                        )
                      ) {
                        throw new Error(
                          'Could not find matching close tag for "' +
                            line +
                            '".'
                        )
                      }
                    }
                    self.scanLine(line)
                  })
                }
              },
              parseTemplateText: function () {
                var str = this.templateText
                var pat = this.regex
                var result = pat.exec(str)
                var arr = []
                var firstPos
                while (result) {
                  firstPos = result.index
                  if (firstPos !== 0) {
                    arr.push(str.substring(0, firstPos))
                    str = str.slice(firstPos)
                  }
                  arr.push(result[0])
                  str = str.slice(result[0].length)
                  result = pat.exec(str)
                }
                if (str) {
                  arr.push(str)
                }
                return arr
              },
              _addOutput: function (line) {
                if (this.truncate) {
                  line = line.replace(/^(?:\r\n|\r|\n)/, '')
                  this.truncate = false
                }
                if (!line) {
                  return line
                }
                line = line.replace(/\\/g, '\\\\')
                line = line.replace(/\n/g, '\\n')
                line = line.replace(/\r/g, '\\r')
                line = line.replace(/"/g, '\\"')
                this.source += '    ; __append("' + line + '")' + '\n'
              },
              scanLine: function (line) {
                var self = this
                var d = this.opts.delimiter
                var o = this.opts.openDelimiter
                var c = this.opts.closeDelimiter
                var newLineCount = 0
                newLineCount = line.split('\n').length - 1
                switch (line) {
                  case o + d:
                  case o + d + '_':
                    this.mode = Template.modes.EVAL
                    break

                  case o + d + '=':
                    this.mode = Template.modes.ESCAPED
                    break

                  case o + d + '-':
                    this.mode = Template.modes.RAW
                    break

                  case o + d + '#':
                    this.mode = Template.modes.COMMENT
                    break

                  case o + d + d:
                    this.mode = Template.modes.LITERAL
                    this.source +=
                      '    ; __append("' +
                      line.replace(o + d + d, o + d) +
                      '")' +
                      '\n'
                    break

                  case d + d + c:
                    this.mode = Template.modes.LITERAL
                    this.source +=
                      '    ; __append("' +
                      line.replace(d + d + c, d + c) +
                      '")' +
                      '\n'
                    break

                  case d + c:
                  case '-' + d + c:
                  case '_' + d + c:
                    if (this.mode == Template.modes.LITERAL) {
                      this._addOutput(line)
                    }
                    this.mode = null
                    this.truncate =
                      line.indexOf('-') === 0 || line.indexOf('_') === 0
                    break

                  default:
                    if (this.mode) {
                      switch (this.mode) {
                        case Template.modes.EVAL:
                        case Template.modes.ESCAPED:
                        case Template.modes.RAW:
                          if (line.lastIndexOf('//') > line.lastIndexOf('\n')) {
                            line += '\n'
                          }
                      }
                      switch (this.mode) {
                        case Template.modes.EVAL:
                          this.source += '    ; ' + line + '\n'
                          break

                        case Template.modes.ESCAPED:
                          this.source +=
                            '    ; __append(escapeFn(' +
                            stripSemi(line) +
                            '))' +
                            '\n'
                          break

                        case Template.modes.RAW:
                          this.source +=
                            '    ; __append(' + stripSemi(line) + ')' + '\n'
                          break

                        case Template.modes.COMMENT:
                          break

                        case Template.modes.LITERAL:
                          this._addOutput(line)
                          break
                      }
                    } else {
                      this._addOutput(line)
                    }
                }
                if (self.opts.compileDebug && newLineCount) {
                  this.currentLine += newLineCount
                  this.source += '    ; __line = ' + this.currentLine + '\n'
                }
              },
            }
            exports.escapeXML = utils.escapeXML
            exports.__express = exports.renderFile
            exports.VERSION = _VERSION_STRING
            exports.name = _NAME
            if (typeof window != 'undefined') {
              window.ejs = exports
            }
          },
          {
            '../package.json': 6,
            './utils': 2,
            fs: 3,
            path: 4,
          },
        ],
        2: [
          function (require, module, exports) {
            var regExpChars = /[|\\{}()[\]^$+*?.]/g
            exports.escapeRegExpChars = function (string) {
              if (!string) {
                return ''
              }
              return String(string).replace(regExpChars, '\\$&')
            }
            var _ENCODE_HTML_RULES = {
              '&': '&amp;',
              '<': '&lt;',
              '>': '&gt;',
              '"': '&#34;',
              "'": '&#39;',
            }
            var _MATCH_HTML = /[&<>'"]/g
            function encode_char(c) {
              return _ENCODE_HTML_RULES[c] || c
            }
            var escapeFuncStr =
              'var _ENCODE_HTML_RULES = {\n' +
              '      "&": "&amp;"\n' +
              '    , "<": "&lt;"\n' +
              '    , ">": "&gt;"\n' +
              '    , \'"\': "&#34;"\n' +
              '    , "\'": "&#39;"\n' +
              '    }\n' +
              '  , _MATCH_HTML = /[&<>\'"]/g;\n' +
              'function encode_char(c) {\n' +
              '  return _ENCODE_HTML_RULES[c] || c;\n' +
              '};\n'
            exports.escapeXML = function (markup) {
              return markup == undefined
                ? ''
                : String(markup).replace(_MATCH_HTML, encode_char)
            }
            exports.escapeXML.toString = function () {
              return (
                Function.prototype.toString.call(this) + ';\n' + escapeFuncStr
              )
            }
            exports.shallowCopy = function (to, from) {
              from = from || {}
              for (var p in from) {
                to[p] = from[p]
              }
              return to
            }
            exports.shallowCopyFromList = function (to, from, list) {
              for (var i = 0; i < list.length; i++) {
                var p = list[i]
                if (typeof from[p] != 'undefined') {
                  to[p] = from[p]
                }
              }
              return to
            }
            exports.cache = {
              _data: {},
              set: function (key, val) {
                this._data[key] = val
              },
              get: function (key) {
                return this._data[key]
              },
              remove: function (key) {
                delete this._data[key]
              },
              reset: function () {
                this._data = {}
              },
            }
            exports.hyphenToCamel = function (str) {
              return str.replace(/-[a-z]/g, function (match) {
                return match[1].toUpperCase()
              })
            }
          },
          {},
        ],
        3: [function (require, module, exports) {}, {}],
        4: [
          function (require, module, exports) {
            ;(function (process) {
              function normalizeArray(parts, allowAboveRoot) {
                var up = 0
                for (var i = parts.length - 1; i >= 0; i--) {
                  var last = parts[i]
                  if (last === '.') {
                    parts.splice(i, 1)
                  } else if (last === '..') {
                    parts.splice(i, 1)
                    up++
                  } else if (up) {
                    parts.splice(i, 1)
                    up--
                  }
                }
                if (allowAboveRoot) {
                  for (; up--; up) {
                    parts.unshift('..')
                  }
                }
                return parts
              }
              exports.resolve = function () {
                var resolvedPath = '',
                  resolvedAbsolute = false
                for (
                  var i = arguments.length - 1;
                  i >= -1 && !resolvedAbsolute;
                  i--
                ) {
                  var path = i >= 0 ? arguments[i] : process.cwd()
                  if (typeof path !== 'string') {
                    throw new TypeError(
                      'Arguments to path.resolve must be strings'
                    )
                  } else if (!path) {
                    continue
                  }
                  resolvedPath = path + '/' + resolvedPath
                  resolvedAbsolute = path.charAt(0) === '/'
                }
                resolvedPath = normalizeArray(
                  filter(resolvedPath.split('/'), function (p) {
                    return !!p
                  }),
                  !resolvedAbsolute
                ).join('/')
                return (resolvedAbsolute ? '/' : '') + resolvedPath || '.'
              }
              exports.normalize = function (path) {
                var isAbsolute = exports.isAbsolute(path),
                  trailingSlash = substr(path, -1) === '/'
                path = normalizeArray(
                  filter(path.split('/'), function (p) {
                    return !!p
                  }),
                  !isAbsolute
                ).join('/')
                if (!path && !isAbsolute) {
                  path = '.'
                }
                if (path && trailingSlash) {
                  path += '/'
                }
                return (isAbsolute ? '/' : '') + path
              }
              exports.isAbsolute = function (path) {
                return path.charAt(0) === '/'
              }
              exports.join = function () {
                var paths = Array.prototype.slice.call(arguments, 0)
                return exports.normalize(
                  filter(paths, function (p, index) {
                    if (typeof p !== 'string') {
                      throw new TypeError(
                        'Arguments to path.join must be strings'
                      )
                    }
                    return p
                  }).join('/')
                )
              }
              exports.relative = function (from, to) {
                from = exports.resolve(from).substr(1)
                to = exports.resolve(to).substr(1)
                function trim(arr) {
                  var start = 0
                  for (; start < arr.length; start++) {
                    if (arr[start] !== '') break
                  }
                  var end = arr.length - 1
                  for (; end >= 0; end--) {
                    if (arr[end] !== '') break
                  }
                  if (start > end) return []
                  return arr.slice(start, end - start + 1)
                }
                var fromParts = trim(from.split('/'))
                var toParts = trim(to.split('/'))
                var length = Math.min(fromParts.length, toParts.length)
                var samePartsLength = length
                for (var i = 0; i < length; i++) {
                  if (fromParts[i] !== toParts[i]) {
                    samePartsLength = i
                    break
                  }
                }
                var outputParts = []
                for (var i = samePartsLength; i < fromParts.length; i++) {
                  outputParts.push('..')
                }
                outputParts = outputParts.concat(toParts.slice(samePartsLength))
                return outputParts.join('/')
              }
              exports.sep = '/'
              exports.delimiter = ':'
              exports.dirname = function (path) {
                if (typeof path !== 'string') path = path + ''
                if (path.length === 0) return '.'
                var code = path.charCodeAt(0)
                var hasRoot = code === 47
                var end = -1
                var matchedSlash = true
                for (var i = path.length - 1; i >= 1; --i) {
                  code = path.charCodeAt(i)
                  if (code === 47) {
                    if (!matchedSlash) {
                      end = i
                      break
                    }
                  } else {
                    matchedSlash = false
                  }
                }
                if (end === -1) return hasRoot ? '/' : '.'
                if (hasRoot && end === 1) {
                  return '/'
                }
                return path.slice(0, end)
              }
              function basename(path) {
                if (typeof path !== 'string') path = path + ''
                var start = 0
                var end = -1
                var matchedSlash = true
                var i
                for (i = path.length - 1; i >= 0; --i) {
                  if (path.charCodeAt(i) === 47) {
                    if (!matchedSlash) {
                      start = i + 1
                      break
                    }
                  } else if (end === -1) {
                    matchedSlash = false
                    end = i + 1
                  }
                }
                if (end === -1) return ''
                return path.slice(start, end)
              }
              exports.basename = function (path, ext) {
                var f = basename(path)
                if (ext && f.substr(-1 * ext.length) === ext) {
                  f = f.substr(0, f.length - ext.length)
                }
                return f
              }
              exports.extname = function (path) {
                if (typeof path !== 'string') path = path + ''
                var startDot = -1
                var startPart = 0
                var end = -1
                var matchedSlash = true
                var preDotState = 0
                for (var i = path.length - 1; i >= 0; --i) {
                  var code = path.charCodeAt(i)
                  if (code === 47) {
                    if (!matchedSlash) {
                      startPart = i + 1
                      break
                    }
                    continue
                  }
                  if (end === -1) {
                    matchedSlash = false
                    end = i + 1
                  }
                  if (code === 46) {
                    if (startDot === -1) startDot = i
                    else if (preDotState !== 1) preDotState = 1
                  } else if (startDot !== -1) {
                    preDotState = -1
                  }
                }
                if (
                  startDot === -1 ||
                  end === -1 ||
                  preDotState === 0 ||
                  (preDotState === 1 &&
                    startDot === end - 1 &&
                    startDot === startPart + 1)
                ) {
                  return ''
                }
                return path.slice(startDot, end)
              }
              function filter(xs, f) {
                if (xs.filter) return xs.filter(f)
                var res = []
                for (var i = 0; i < xs.length; i++) {
                  if (f(xs[i], i, xs)) res.push(xs[i])
                }
                return res
              }
              var substr =
                'ab'.substr(-1) === 'b'
                  ? function (str, start, len) {
                      return str.substr(start, len)
                    }
                  : function (str, start, len) {
                      if (start < 0) start = str.length + start
                      return str.substr(start, len)
                    }
            }).call(this, require('_process'))
          },
          {
            _process: 5,
          },
        ],
        5: [
          function (require, module, exports) {
            var process = (module.exports = {})
            var cachedSetTimeout
            var cachedClearTimeout
            function defaultSetTimout() {
              throw new Error('setTimeout has not been defined')
            }
            function defaultClearTimeout() {
              throw new Error('clearTimeout has not been defined')
            }
            ;(function () {
              try {
                if (typeof setTimeout === 'function') {
                  cachedSetTimeout = setTimeout
                } else {
                  cachedSetTimeout = defaultSetTimout
                }
              } catch (e) {
                cachedSetTimeout = defaultSetTimout
              }
              try {
                if (typeof clearTimeout === 'function') {
                  cachedClearTimeout = clearTimeout
                } else {
                  cachedClearTimeout = defaultClearTimeout
                }
              } catch (e) {
                cachedClearTimeout = defaultClearTimeout
              }
            })()
            function runTimeout(fun) {
              if (cachedSetTimeout === setTimeout) {
                return setTimeout(fun, 0)
              }
              if (
                (cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) &&
                setTimeout
              ) {
                cachedSetTimeout = setTimeout
                return setTimeout(fun, 0)
              }
              try {
                return cachedSetTimeout(fun, 0)
              } catch (e) {
                try {
                  return cachedSetTimeout.call(null, fun, 0)
                } catch (e) {
                  return cachedSetTimeout.call(this, fun, 0)
                }
              }
            }
            function runClearTimeout(marker) {
              if (cachedClearTimeout === clearTimeout) {
                return clearTimeout(marker)
              }
              if (
                (cachedClearTimeout === defaultClearTimeout ||
                  !cachedClearTimeout) &&
                clearTimeout
              ) {
                cachedClearTimeout = clearTimeout
                return clearTimeout(marker)
              }
              try {
                return cachedClearTimeout(marker)
              } catch (e) {
                try {
                  return cachedClearTimeout.call(null, marker)
                } catch (e) {
                  return cachedClearTimeout.call(this, marker)
                }
              }
            }
            var queue = []
            var draining = false
            var currentQueue
            var queueIndex = -1
            function cleanUpNextTick() {
              if (!draining || !currentQueue) {
                return
              }
              draining = false
              if (currentQueue.length) {
                queue = currentQueue.concat(queue)
              } else {
                queueIndex = -1
              }
              if (queue.length) {
                drainQueue()
              }
            }
            function drainQueue() {
              if (draining) {
                return
              }
              var timeout = runTimeout(cleanUpNextTick)
              draining = true
              var len = queue.length
              while (len) {
                currentQueue = queue
                queue = []
                while (++queueIndex < len) {
                  if (currentQueue) {
                    currentQueue[queueIndex].run()
                  }
                }
                queueIndex = -1
                len = queue.length
              }
              currentQueue = null
              draining = false
              runClearTimeout(timeout)
            }
            process.nextTick = function (fun) {
              var args = new Array(arguments.length - 1)
              if (arguments.length > 1) {
                for (var i = 1; i < arguments.length; i++) {
                  args[i - 1] = arguments[i]
                }
              }
              queue.push(new Item(fun, args))
              if (queue.length === 1 && !draining) {
                runTimeout(drainQueue)
              }
            }
            function Item(fun, array) {
              this.fun = fun
              this.array = array
            }
            Item.prototype.run = function () {
              this.fun.apply(null, this.array)
            }
            process.title = 'browser'
            process.browser = true
            process.env = {}
            process.argv = []
            process.version = ''
            process.versions = {}
            function noop() {}
            process.on = noop
            process.addListener = noop
            process.once = noop
            process.off = noop
            process.removeListener = noop
            process.removeAllListeners = noop
            process.emit = noop
            process.prependListener = noop
            process.prependOnceListener = noop
            process.listeners = function (name) {
              return []
            }
            process.binding = function (name) {
              throw new Error('process.binding is not supported')
            }
            process.cwd = function () {
              return '/'
            }
            process.chdir = function (dir) {
              throw new Error('process.chdir is not supported')
            }
            process.umask = function () {
              return 0
            }
          },
          {},
        ],
        6: [
          function (require, module, exports) {
            module.exports = {
              name: 'ejs',
              description: 'Embedded JavaScript templates',
              keywords: ['template', 'engine', 'ejs'],
              version: '3.1.6',
              author: 'Matthew Eernisse <mde@fleegix.org> (http://fleegix.org)',
              license: 'Apache-2.0',
              bin: {
                ejs: './bin/cli.js',
              },
              main: './lib/ejs.js',
              jsdelivr: 'ejs.min.js',
              unpkg: 'ejs.min.js',
              repository: {
                type: 'git',
                url: 'git://github.com/mde/ejs.git',
              },
              bugs: 'https://github.com/mde/ejs/issues',
              homepage: 'https://github.com/mde/ejs',
              dependencies: {
                jake: '^10.6.1',
              },
              devDependencies: {
                browserify: '^16.5.1',
                eslint: '^6.8.0',
                'git-directory-deploy': '^1.5.1',
                jsdoc: '^3.6.4',
                'lru-cache': '^4.0.1',
                mocha: '^7.1.1',
                'uglify-js': '^3.3.16',
              },
              engines: {
                node: '>=0.10.0',
              },
              scripts: {
                test: 'mocha',
              },
            }
          },
          {},
        ],
      },
      {},
      [1]
    )(1)
  })
})(ejs$1)
var ejs = ejs$1.exports
class TemplatingEngine {
  constructor(config) {
    _defineProperty(this, 'templateConfig', void 0)
    _defineProperty(this, 'templatePlugins', void 0)
    _defineProperty(this, 'templateModules', void 0)
    this.templateConfig = config || {}
    this.templatePlugins = []
    this.templateModules = []
    if (this.templateConfig.templateLocale === '<system>') {
      this.templateConfig.templateLocale = NotePlan.environment.languageCode
    }
  }
  _replaceDoubleDashes(templateData) {
    let returnedData = templateData
    const lines = templateData.split('\n')
    const startBlock = lines.indexOf('--')
    const endBlock = startBlock === 0 ? lines.indexOf('--', startBlock + 1) : -1
    if (startBlock >= 0 && endBlock > 0) {
      lines[startBlock] = '---'
      lines[endBlock] = '---'
      returnedData = lines.join('\n')
    }
    return returnedData
  }
  async heartbeat() {
    return '```\n' + JSON.stringify(this.templateConfig, null, 2) + '\n```\n'
  }
  async templateErrorMessage() {
    let method =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let message =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ''
    const line = '*'.repeat(message.length + 30)
    console.log(line)
    console.log('   ERROR')
    console.log('   Method: '.concat(method, ':'))
    console.log('   Message: '.concat(message))
    console.log(line)
    console.log('\n')
    return '**Error: '.concat(method, '**\n- **').concat(message, '**')
  }
  async isFrontmatter(templateData) {
    return templateData.length > 0
      ? new FrontmatterModule().isFrontmatterTemplate(templateData.substring(1))
      : false
  }
  async render() {
    var _this$templateConfig,
      _this$templateConfig2,
      _this$templateConfig3,
      _this$templateConfig4,
      _this = this
    let templateData =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let userData =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}
    let userOptions =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}
    const options = _objectSpread2(
      _objectSpread2(
        {},
        {
          async: true,
          rmWhitespace: false,
        }
      ),
      userOptions
    )
    templateData.includes('system.clipboard')
    if (templateData.indexOf('system.clipboard') > 0) {
      this.templateConfig.clipboard = Clipboard.string
    }
    const helpers = {
      date: new DateModule(this.templateConfig),
      time: new TimeModule(this.templateConfig),
      utility: new UtilityModule(this.templateConfig),
      system: new SystemModule(this.templateConfig),
      note: new NoteModule(this.templateConfig),
      frontmatter: {},
      user: {
        first:
          ((_this$templateConfig = this.templateConfig) === null ||
          _this$templateConfig === void 0
            ? void 0
            : _this$templateConfig.userFirstName) || '',
        last:
          ((_this$templateConfig2 = this.templateConfig) === null ||
          _this$templateConfig2 === void 0
            ? void 0
            : _this$templateConfig2.userLastName) || '',
        email:
          ((_this$templateConfig3 = this.templateConfig) === null ||
          _this$templateConfig3 === void 0
            ? void 0
            : _this$templateConfig3.userEmail) || '',
        phone:
          ((_this$templateConfig4 = this.templateConfig) === null ||
          _this$templateConfig4 === void 0
            ? void 0
            : _this$templateConfig4.userPhone) || '',
      },
      web: {
        advice: async () => await new WebModule().advice(),
        affirmation: async () => await new WebModule().affirmation(),
        quote: async () => await new WebModule().quote(),
        verse: async () => await new WebModule().verse(),
        weather: async function () {
          let params =
            arguments.length > 0 && arguments[0] !== undefined
              ? arguments[0]
              : ''
          return await new WebModule().weather(_this.templateConfig, params)
        },
        wotd: async function () {
          let params =
            arguments.length > 0 && arguments[0] !== undefined
              ? arguments[0]
              : ''
          return await new WebModule().wotd(_this.templateConfig, params)
        },
        services: async function () {
          let url =
            arguments.length > 0 && arguments[0] !== undefined
              ? arguments[0]
              : ''
          let key =
            arguments.length > 1 && arguments[1] !== undefined
              ? arguments[1]
              : ''
          return await new WebModule().service(_this.templateConfig, url, key)
        },
      },
    }
    let renderData = _objectSpread2(_objectSpread2({}, helpers), userData)
    renderData = userData.data
      ? _objectSpread2(_objectSpread2({}, userData.data), renderData)
      : _objectSpread2({}, renderData)
    renderData = userData.methods
      ? _objectSpread2(_objectSpread2({}, userData.methods), renderData)
      : renderData
    if (userData !== null && userData !== void 0 && userData.data) {
      renderData.data = _objectSpread2({}, userData.data)
    }
    if (userData !== null && userData !== void 0 && userData.methods) {
      renderData.methods = _objectSpread2(
        _objectSpread2({}, renderData.methods),
        userData.methods
      )
    }
    this.templateModules.forEach((moduleItem) => {
      clo(moduleItem, 'moduleItem')
      if (this.isClass(moduleItem.module)) {
        clo(moduleItem.module, 'is class')
        Object.getOwnPropertyNames(moduleItem.module.prototype)
        log(
          pluginJson$1,
          'np.Templating Error: ES6 Classes are not supported ['.concat(
            moduleItem.moduleNamespace,
            ']'
          )
        )
      } else {
        for (const [key, method] of Object.entries(moduleItem.module)) {
          logDebug('key: '.concat(key, ' method:').concat(typeof method))
          renderData[moduleItem.moduleNamespace] = {}
          for (const [moduleKey, moduleMethod] of Object.entries(
            moduleItem.module
          )) {
            logDebug(
              'moduleKey: '
                .concat(moduleKey, ' moduleMethod:')
                .concat(typeof moduleMethod)
            )
            renderData[moduleItem.moduleNamespace][moduleKey] = moduleMethod
          }
        }
      }
    })
    renderData.np = _objectSpread2({}, renderData)
    let processedTemplateData = templateData
    let frontmatterBlock = new FrontmatterModule().getFrontmatterBlock(
      processedTemplateData
    )
    if (frontmatterBlock.length > 0) {
      processedTemplateData = await ejs.render(
        processedTemplateData,
        renderData,
        {
          async: true,
          openDelimiter: '{',
          closeDelimiter: '}',
        }
      )
      frontmatterBlock = new FrontmatterModule().getFrontmatterBlock(
        processedTemplateData
      )
      const frontmatterData = new FrontmatterModule().parse(frontmatterBlock)
      if (
        frontmatterData.hasOwnProperty('attributes') &&
        frontmatterData.hasOwnProperty('body')
      ) {
        if (Object.keys(frontmatterData.attributes).length > 0) {
          renderData.frontmatter = _objectSpread2(
            {},
            frontmatterData.attributes
          )
        }
        if (frontmatterData.body.length > 0) {
          processedTemplateData = frontmatterData.body
        }
      }
    }
    this.templatePlugins.forEach((item) => {
      renderData[item.name] = item.method
    })
    try {
      var _result
      let result = await ejs.render(processedTemplateData, renderData, options)
      result =
        (result &&
          ((_result = result) === null || _result === void 0
            ? void 0
            : _result.replace(/undefined/g, ''))) ||
        ''
      return this._replaceDoubleDashes(result)
    } catch (error) {
      logDebug('199 np.Templating error: '.concat(error))
      const message = error.message.replace('\n', '')
      let block = ''
      if (error !== null && error !== void 0 && error.line) {
        block = '\nline: '.concat(error.line - 7, '\n')
        if (error !== null && error !== void 0 && error.column) {
          block += 'column: '.concat(error.column, '\n')
        }
        block += '\n'
      }
      let result =
        '**An error occurred rendering template:**\n\n' +
        message
          .replace(/ejs:/gi, 'template line: ')
          .replace('list.', 'list')
          .replace('while compiling ejs', '') +
        block
      return result
    }
  }
  async getDefaultFormat() {
    let formatType =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'date'
    log(pluginJson$1, 'FIXME: TemplatingEngine.getDefaultFormat')
    log(
      pluginJson$1,
      'This method should never be called, all references have been removed but leaving for backwards compatability'
    )
    try {
      var _templateConfig$templ, _templateConfig$templ2
      const templateConfig = await this.getTemplateConfig()
      let format = formatType === 'date' ? 'YYYY-MM-DD' : 'HH:mm:ss A'
      if (
        templateConfig !== null &&
        templateConfig !== void 0 &&
        (_templateConfig$templ = templateConfig.templates) !== null &&
        _templateConfig$templ !== void 0 &&
        (_templateConfig$templ2 = _templateConfig$templ.defaultFormats) !==
          null &&
        _templateConfig$templ2 !== void 0 &&
        _templateConfig$templ2[formatType]
      ) {
        var _templateConfig$templ3, _templateConfig$templ4
        format =
          templateConfig === null || templateConfig === void 0
            ? void 0
            : (_templateConfig$templ3 = templateConfig.templates) === null ||
                _templateConfig$templ3 === void 0
              ? void 0
              : (_templateConfig$templ4 =
                    _templateConfig$templ3.defaultFormats) === null ||
                  _templateConfig$templ4 === void 0
                ? void 0
                : _templateConfig$templ4[formatType]
      }
      format = formatType === 'date' ? 'YYYY-MM-DD' : 'HH:mm:ss A'
      logDebug(pluginJson$1, '230 np.Templating format: '.concat(format))
      return format
    } catch (error) {
      logError('231 np.Templating Error: '.concat(error))
      return this.templateErrorMessage(
        'TemplatingEngine.getDefaultFormat',
        error
      )
    }
  }
  async register() {
    let name =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let methodOrModule = arguments.length > 1 ? arguments[1] : undefined
    let methodOrModuleType = typeof methodOrModule
    if (this.isClass(methodOrModule)) {
      methodOrModuleType = 'class'
    }
    switch (methodOrModuleType) {
      case 'function':
        const result = this.templatePlugins.find((item) => item.name === name)
        if (!result) {
          this.templatePlugins.push({
            name: name,
            method: methodOrModule,
          })
        }
        break

      case 'class':
        log(
          pluginJson$1,
          'np.Templating Error: ES6 Classes are not supported ['.concat(
            name,
            ']'
          )
        )
        log(
          pluginJson$1,
          'Please refer to np.Templating Documentation [Templating Plugins]'
        )
        break

      case 'object':
        const moduleNmae = this.templateModules.find(
          (item) => item.moduleNamespace === name
        )
        if (!moduleNmae) {
          this.templateModules.push({
            moduleNamespace: name,
            module: methodOrModule,
          })
        }
        break
    }
  }
  isClass(obj) {
    const isCtorClass =
      obj.constructor && obj.constructor.toString().substring(0, 5) === 'class'
    if (obj.prototype === undefined) {
      return isCtorClass
    }
    const isPrototypeCtorClass =
      obj.prototype.constructor &&
      obj.prototype.constructor.toString &&
      obj.prototype.constructor.toString().substring(0, 5) === 'class'
    return isCtorClass || isPrototypeCtorClass
  }
}
const TEMPLATE_MODULES = [
  'calendar',
  'date',
  'frontmatter',
  'note',
  'system',
  'time',
  'user',
  'utility',
]
const isCommentTag = function () {
  let tag =
    arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
  return tag.includes('<%#')
}
const codeBlockHasComment = function () {
  let codeBlock =
    arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
  const CODE_BLOCK_COMMENT_TAGS = ['template: ignore', 'template:ignore']
  return CODE_BLOCK_COMMENT_TAGS.some((tag) => codeBlock.includes(tag))
}
const blockIsJavaScript = function () {
  let codeBlock =
    arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
  return codeBlock.includes('```templatejs')
}
const getCodeBlocks = function () {
  let templateData =
    arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
  const CODE_BLOCK_TAG = '```'
  let codeBlocks = []
  let blockStart = templateData.indexOf(CODE_BLOCK_TAG)
  while (blockStart >= 0) {
    let blockEnd = templateData.indexOf(
      CODE_BLOCK_TAG,
      blockStart + CODE_BLOCK_TAG.length
    )
    if (blockEnd === -1) {
      blockEnd = templateData.length
    }
    const fencedCodeBlock = templateData.substring(
      blockStart,
      blockEnd + CODE_BLOCK_TAG.length
    )
    if (fencedCodeBlock.length > 0) {
      codeBlocks.push(fencedCodeBlock)
    }
    blockStart = templateData.indexOf(CODE_BLOCK_TAG, blockEnd + 1)
  }
  return codeBlocks
}
const getIgnoredCodeBlocks = function () {
  let templateData =
    arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
  let ignoredCodeBlocks = []
  const codeBlocks = getCodeBlocks(templateData)
  codeBlocks.forEach((codeBlock) => {
    if (codeBlockHasComment(codeBlock)) {
      ignoredCodeBlocks.push(codeBlock)
    }
  })
  return ignoredCodeBlocks
}
const convertJavaScriptBlocksToTags = function () {
  let templateData =
    arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
  let result = templateData
  const codeBlocks = getCodeBlocks(templateData)
  codeBlocks.forEach((codeBlock) => {
    if (!codeBlockHasComment(codeBlock) && blockIsJavaScript(codeBlock)) {
      if (!codeBlock.includes('<%')) {
        let newBlock = codeBlock
          .replace('```templatejs\n', '')
          .replace('```', '')
        newBlock = '<% '.concat(newBlock, ' -%>')
        result = result.replace(codeBlock, newBlock)
      }
    }
  })
  return result
}
const getProperyValue = (object, key) => {
  key.split('.').forEach((token) => {
    if (object) object = object[token]
  })
  return object
}
const DEFAULT_TEMPLATE_CONFIG = {
  templateFolderName:
    typeof NotePlan !== 'undefined'
      ? NotePlan.environment.templateFolder
      : '@Templates',
  templateLocale: 'en-US',
  templateGroupTemplatesByFolder: false,
  dateFormat: 'YYYY-MM-DD',
  timeFormat: 'h:mm A',
  nowFormat: 'YYYY-MM-DD h:mm:ss A',
  userFirstName: 'John',
  userLastName: 'Doe',
  userEmail: 'john.doe@gmail.com',
  userPhone: '(714) 555-1212',
  weatherFormat: '',
  services: {
    affirmation: 'https://affirmations.dev',
    quote: {
      url: 'https://zenquotes.io/api/random',
      keys: ['"', '[0].q', '"', ' - ', '*', '[0].a', '*'],
    },
  },
}
async function getTemplateFolder() {
  return NotePlan.environment.templateFolder
}
class NPTemplating {
  constructor() {
    _defineProperty(this, 'templateConfig', void 0)
    _defineProperty(this, 'templateGlobals', void 0)
  }
  static _frontmatterError(error) {
    if (error.reason === 'missed comma between flow collection entries') {
      return '**Frontmatter Template Parsing Error**\n\nWhen using template tags in frontmatter attributes, the entire block must be wrapped in quotes\n'.concat(
        error.mark
      )
    }
    return error
  }
  static _removeWhitespaceFromCodeBlocks() {
    let str =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let result = str
    getCodeBlocks(str).forEach((codeBlock) => {
      let newCodeBlock = codeBlock
      logDebug(
        pluginJson$1,
        '_removeWhitespaceFromCodeBlocks codeBlock before: "'.concat(
          newCodeBlock,
          '"'
        )
      )
      newCodeBlock = newCodeBlock
        .replace('```javascript\n', '')
        .replace(/```/gi, '')
        .replace(/\n\n/gi, '')
        .replace(/\n/gi, '')
      logDebug(
        pluginJson$1,
        '_removeWhitespaceFromCodeBlocks codeBlock after: "'.concat(
          newCodeBlock,
          '"'
        )
      )
      result = result.replace(codeBlock, newCodeBlock)
    })
    return result.replace(/\n\n\n/gi, '\n')
  }
  static _filterTemplateResult() {
    let templateResult =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let result = templateResult
    result = result.replace('ejs', 'template')
    result = result.replace(
      'If the above error is not helpful, you may want to try EJS-Lint:',
      ''
    )
    result = result.replace(
      'https://github.com/RyanZim/EJS-Lint',
      'HTTP_REMOVED'
    )
    if (result.includes('HTTP_REMOVED')) {
      result += 'For more information on proper template syntax, refer to:\n'
      result += 'https://nptemplating-docs.netlify.app/'
      result = result.replace('HTTP_REMOVED', '')
    }
    return result
  }
  static async updateOrInstall(currentSettings, currentVersion) {
    const settingsData = _objectSpread2({}, currentSettings)
    let updatesApplied = 0
    const settingsVersion = semverVersionToNumber(
      (settingsData === null || settingsData === void 0
        ? void 0
        : settingsData.version) || ''
    )
    if (settingsVersion < semverVersionToNumber('2.0.0')) {
      log(pluginJson$1, '==> np.Templating 2.0.0 Updates Applied')
      updatesApplied++
    }
    if (settingsVersion < semverVersionToNumber('1.1.3')) {
      log(pluginJson$1, '==> np.Templating 1.1.3 Updates Applied')
      updatesApplied++
    }
    settingsData.version = currentVersion
    if (updatesApplied > 0) {
      var _DataStore$settings
      log(
        pluginJson$1,
        '==> np.Templating Settings Updated to v'.concat(currentVersion)
      )
      const templateGroupTemplatesByFolder =
        ((_DataStore$settings = DataStore.settings) === null ||
        _DataStore$settings === void 0
          ? void 0
          : _DataStore$settings.templateGroupTemplatesByFolder) || false
      DataStore.setPreference(
        'templateGroupTemplatesByFolder',
        templateGroupTemplatesByFolder
      )
    }
    return settingsData
  }
  static async setup() {
    try {
      const data = await this.getSettings()
      this.constructor.templateConfig = _objectSpread2(
        _objectSpread2({}, data),
        {
          clipboard: '',
        }
      )
      let globalData = []
      Object.getOwnPropertyNames(globals).forEach((key) => {
        globalData.push(key)
      })
      this.constructor.templateGlobals = globalData
    } catch (error) {
      await CommandBar.prompt('Template Error', error)
    }
  }
  static async getSettings() {
    let data = DataStore.loadJSON('../np.Templating/settings.json')
    if (!data) {
      DataStore.saveJSON(
        DEFAULT_TEMPLATE_CONFIG,
        '../np.Templating/settings.json'
      )
      data = DataStore.loadJSON('../np.Templating/settings.json')
    }
    return data
  }
  static async getSetting() {
    let key =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let defaultValue =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ''
    const data = this.getSettings()
    if (data) {
      return data.hasOwnProperty(key) ? data[key] : defaultValue
    }
    return defaultValue
  }
  static async putSetting(key, value) {
    return true
  }
  static async heartbeat() {
    await this.setup()
    await this.getSetting('userFirstName')
    return (
      '```\n' +
      JSON.stringify(this.constructor.templateConfig, null, 2) +
      '\n```\n'
    )
  }
  static async normalizeToNotePlanFilename() {
    let filename =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    return filename.replace(/[#()?%*|"<>:]/gi, '')
  }
  static templateErrorMessage() {
    var _message$name
    let method =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let message =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ''
    if (
      (message === null || message === void 0
        ? void 0
        : (_message$name = message.name) === null || _message$name === void 0
          ? void 0
          : _message$name.indexOf('YAMLException')) >= 0
    ) {
      const frontMatterErrorMessage = this._frontmatterError(message)
      return frontMatterErrorMessage
    }
    const line = '*'.repeat(message.length + 30)
    console.log(line)
    console.log('   ERROR')
    console.log('   Method: '.concat(method, ':'))
    console.log('   Message: '.concat(message))
    console.log(line)
    console.log('\n')
    return '**Error: '.concat(method, '**\n- **').concat(message, '**')
  }
  static async chooseTemplate() {
    let tags =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*'
    let promptMessage =
      arguments.length > 1 && arguments[1] !== undefined
        ? arguments[1]
        : 'Choose Template'
    let userOptions =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null
    try {
      var _this$constructor$tem
      await this.setup()
      let templateGroupTemplatesByFolder =
        ((_this$constructor$tem = this.constructor.templateConfig) === null ||
        _this$constructor$tem === void 0
          ? void 0
          : _this$constructor$tem.templateGroupTemplatesByFolder) || false
      if (
        userOptions &&
        userOptions.hasOwnProperty('templateGroupTemplatesByFolder')
      ) {
        templateGroupTemplatesByFolder =
          userOptions.templateGroupTemplatesByFolder
      }
      const templateList = await this.getTemplateList(tags)
      let options = []
      for (const template of templateList) {
        const parts = template.value.split('/')
        const filename = parts.pop()
        let label = template.value
          .replace(''.concat(NotePlan.environment.templateFolder, '/'), '')
          .replace(filename, template.label.replace('/', '-'))
        if (!templateGroupTemplatesByFolder) {
          const parts = label.split('/')
          label = parts[parts.length - 1]
        }
        options.push({
          label: label,
          value: template.value,
        })
      }
      return await chooseOption(promptMessage, options)
    } catch (error) {}
  }
  static async getFilenameFromTemplate() {
    let note =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    const parts = note.split('/')
    if (parts.length === 0);
    const notes = await DataStore.projectNoteByTitle(note, true, false)
    if (notes == null) {
      return 'INCOMPLETE'
    }
    const finalNotes = notes.filter((note) =>
      note.filename.startsWith(NotePlan.environment.templateFolder)
    )
    if (finalNotes.length > 1) {
      return 'MULTIPLE NOTES FOUND'
    } else {
      return notes[0].filename
    }
  }
  static async getTemplateList() {
    let types =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*'
    try {
      await this.setup()
      let settings = await this.getSettings()
      const templateFolder = await getTemplateFolder()
      if (templateFolder == null) {
        await CommandBar.prompt(
          'Templating Error',
          'An error occurred locating '.concat(templateFolder, ' folder')
        )
        return
      }
      const filterTypes = Array.isArray(types)
        ? types
        : types.split(',').map((type) => type.trim())
      const allTemplates = DataStore.projectNotes
        .filter((n) => {
          var _n$filename
          return (_n$filename = n.filename) === null || _n$filename === void 0
            ? void 0
            : _n$filename.startsWith(templateFolder)
        })
        .filter((n) => !n.frontmatterTypes.includes('ignore'))
        .filter((n) => !n.frontmatterTypes.includes('template-helper'))
        .filter((n) => {
          var _n$title
          return !(
            (_n$title = n.title) !== null &&
            _n$title !== void 0 &&
            _n$title.startsWith('_configuration')
          )
        })
        .filter((n) => {
          var _n$filename2
          return !(
            (_n$filename2 = n.filename) !== null &&
            _n$filename2 !== void 0 &&
            _n$filename2.startsWith('Delete After Release')
          )
        })
        .sort((a, b) => a.filename.localeCompare(b.filename))
        .map((note) =>
          note.title == null
            ? null
            : {
                label: note.title,
                value: note.filename,
              }
        )
        .filter(Boolean)
      let resultTemplates = []
      let matches = []
      let exclude = []
      let allTypes = []
      for (const template of allTemplates) {
        if (template.value.length > 0) {
          const templateData = await this.getTemplate(template.value)
          if (templateData.length > 0) {
            const attrs = await new FrontmatterModule().attributes(templateData)
            const type =
              (attrs === null || attrs === void 0 ? void 0 : attrs.type) || ''
            if (type.length > 0) {
              allTypes = allTypes
                .concat(type.split(','))
                .map((type) =>
                  type === null || type === void 0 ? void 0 : type.trim()
                )
            }
          }
        }
      }
      allTypes = allTypes.filter((v, i, a) => a.indexOf(v) === i)
      filterTypes.forEach((type) => {
        matches = type === '*' ? matches.concat(allTypes) : matches
        if (type[0] !== '!' && allTypes.indexOf(type) > -1) {
          matches.push(allTypes[allTypes.indexOf(type)])
        }
        if (type[0] === '!' && allTypes.indexOf(type.substring(1)) > -1) {
          exclude.push(allTypes[allTypes.indexOf(type.substring(1))])
        }
      })
      exclude.push('ignore')
      let finalMatches = matches.filter((x) => !exclude.includes(x))
      let templateList = []
      for (const template of allTemplates) {
        if (template.value.length > 0) {
          const templateData = await this.getTemplate(template.value)
          if (templateData.length > 0) {
            const attrs = await new FrontmatterModule().attributes(templateData)
            const type =
              (attrs === null || attrs === void 0 ? void 0 : attrs.type) || ''
            let types = (type.length > 0 &&
              (type === null || type === void 0
                ? void 0
                : type.split(','))) || ['*']
            types.forEach((element, index) => {
              types[index] = element.trim()
            })
            finalMatches.every((match) => {
              if (
                types.includes(match) ||
                (types.includes('*') && filterTypes.includes('*'))
              ) {
                if (types.filter((x) => exclude.includes(x)).length === 0) {
                  templateList.push(template)
                  return false
                }
              }
              return true
            })
          }
        }
      }
      return templateList
    } catch (error) {
      logError(pluginJson$1, error)
    }
  }
  static async getTemplateListByTags() {
    let tags =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*'
    try {
      await this.setup()
      const templateFolder = await getTemplateFolder()
      if (templateFolder == null) {
        await CommandBar.prompt(
          'Templating Error',
          'An error occurred locating '.concat(templateFolder, ' folder')
        )
        return
      }
      const filterTags = Array.isArray(tags)
        ? tags
        : tags.split(',').map((tag) => tag.trim())
      const allTemplates = DataStore.projectNotes
        .filter((n) => {
          var _n$filename3
          return (_n$filename3 = n.filename) === null || _n$filename3 === void 0
            ? void 0
            : _n$filename3.startsWith(templateFolder)
        })
        .filter((n) => {
          var _n$title2
          return !(
            (_n$title2 = n.title) !== null &&
            _n$title2 !== void 0 &&
            _n$title2.startsWith('_configuration')
          )
        })
        .filter((n) => {
          var _n$filename4
          return !(
            (_n$filename4 = n.filename) !== null &&
            _n$filename4 !== void 0 &&
            _n$filename4.startsWith('Delete After Release')
          )
        })
        .sort((a, b) => a.filename.localeCompare(b.filename))
        .map((note) =>
          note.title == null
            ? null
            : {
                label: note.title,
                value: note.filename,
              }
        )
        .filter(Boolean)
      let resultTemplates = []
      let matches = []
      let exclude = []
      let allTags = []
      for (const template of allTemplates) {
        if (template.value.length > 0) {
          const templateData = await this.getTemplate(template.value)
          if (templateData.length > 0) {
            const attrs = await new FrontmatterModule().attributes(templateData)
            const tag =
              (attrs === null || attrs === void 0 ? void 0 : attrs.tags) || ''
            if (tag.length > 0) {
              allTags = allTags
                .concat(tag.split(','))
                .map((tag) =>
                  tag === null || tag === void 0 ? void 0 : tag.trim()
                )
            }
          }
        }
      }
      allTags = allTags.filter((v, i, a) => a.indexOf(v) === i)
      filterTags.forEach((tag) => {
        matches = tag === '*' ? matches.concat(allTags) : matches
        if (tag[0] !== '!' && allTags.indexOf(tag) > -1) {
          matches.push(allTags[allTags.indexOf(tag)])
        }
        if (tag[0] === '!' && allTags.indexOf(tag.substring(1)) > -1) {
          exclude.push(allTags[allTags.indexOf(tag.substring(1))])
        }
      })
      exclude.push('ignore')
      let finalMatches = matches.filter((x) => !exclude.includes(x))
      let templateList = []
      for (const template of allTemplates) {
        if (template.value.length > 0) {
          const templateData = await this.getTemplate(template.value)
          if (templateData.length > 0) {
            const attrs = await new FrontmatterModule().attributes(templateData)
            const tag =
              (attrs === null || attrs === void 0 ? void 0 : attrs.tags) || ''
            let tags = (tag.length > 0 &&
              (tag === null || tag === void 0 ? void 0 : tag.split(','))) || [
              '*',
            ]
            tags.forEach((element, index) => {
              tags[index] = element.trim()
            })
            finalMatches.every((match) => {
              if (
                tags.includes(match) ||
                (tags.includes('*') && filterTags.includes('*'))
              ) {
                if (tags.filter((x) => exclude.includes(x)).length === 0) {
                  templateList.push(template)
                  return false
                }
              }
              return true
            })
          }
        }
      }
      return templateList
    } catch (error) {
      logError(pluginJson$1, error)
    }
  }
  static async getTemplate() {
    let templateName =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let options =
      arguments.length > 1 && arguments[1] !== undefined
        ? arguments[1]
        : {
            showChoices: true,
            silent: false,
          }
    await this.setup()
    const parts = templateName.split('/')
    const filename = parts.pop()
    let templateFolderName = await getTemplateFolder()
    let originalFilename = templateName
    let templateFilename = templateName
    if (!templateName.includes(templateFolderName)) {
      templateFilename = ''.concat(templateFolderName, '/').concat(templateName)
    }
    let selectedTemplate = ''
    const normalizedFilename = await this.normalizeToNotePlanFilename(filename)
    templateFilename = templateFilename.replace(filename, normalizedFilename)
    try {
      var _selectedTemplate
      templateFilename = templateFilename.replace(/.md|.txt/gi, '')
      selectedTemplate = await DataStore.projectNoteByFilename(
        ''.concat(templateFilename, '.md')
      )
      if (!selectedTemplate) {
        selectedTemplate = await DataStore.projectNoteByFilename(
          ''.concat(templateFilename, '.txt')
        )
      }
      if (!selectedTemplate) {
        const parts = templateName.split('/')
        if (parts.length > 0) {
          templateFilename = parts.pop()
          let templates = await DataStore.projectNoteByTitle(
            templateFilename,
            true,
            false
          )
          if (templates.length > 1) {
            let templatesSecondary = []
            for (const template of templates) {
              if (
                template &&
                template.filename.startsWith(templateFolderName)
              ) {
                const parts = template.filename.split('/')
                parts.pop()
                templatesSecondary.push({
                  value: template.filename,
                  label: ''.concat(parts.join('/'), '/').concat(template.title),
                  title: template.title,
                })
              }
            }
            if (templatesSecondary.length > 1) {
              let selectedItem =
                (await chooseOption('Choose Template', templatesSecondary)) ||
                null
              if (selectedItem) {
                selectedTemplate =
                  await DataStore.projectNoteByFilename(selectedItem)
              }
            } else {
              selectedTemplate = await DataStore.projectNoteByFilename(
                templatesSecondary[0].value
              )
            }
          } else {
            selectedTemplate =
              Array.isArray(templates) && templates.length > 0
                ? templates[0]
                : null
          }
        }
      }
      if (!selectedTemplate && !options.silent) {
        await CommandBar.prompt(
          'Template Error',
          'Unable to locate '.concat(originalFilename)
        )
      }
      let templateContent =
        ((_selectedTemplate = selectedTemplate) === null ||
        _selectedTemplate === void 0
          ? void 0
          : _selectedTemplate.content) || ''
      let isFrontmatterTemplate =
        templateContent.length > 0
          ? new FrontmatterModule().isFrontmatterTemplate(templateContent)
          : false
      if (isFrontmatterTemplate) {
        return templateContent || ''
      }
      if (
        templateContent == null ||
        (templateContent.length === 0 && !options.silent)
      ) {
        const message = 'Template "'.concat(
          templateName,
          '" Not Found or Empty'
        )
        return this.templateErrorMessage('NPTemplating.getTemplate', message)
      }
      const lines = templateContent.split('\n')
      const dividerIndex = lines.findIndex(
        (element) => element === '---' || element === '*****'
      )
      if (dividerIndex > 0) {
        templateContent = lines.splice(dividerIndex + 1).join('\n')
      } else {
        templateContent = lines.splice(1).join('\n')
      }
      return templateContent
    } catch (error) {
      return this.templateErrorMessage('NPTemplating.getTemplate', error)
    }
  }
  static async getTemplateAttributes() {
    let templateData =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    return await new FrontmatterModule().attributes(templateData)
  }
  static async getTemplateConfig() {
    await this.setup()
    return this.constructor.templateConfig
  }
  static async getNote() {
    let notePath =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let content = ''
    const noteParts = notePath.split('/')
    const noteName = noteParts.pop()
    const noteFolder = noteParts.join('/')
    if (noteName.length > 0) {
      const foundNotes = DataStore.projectNoteByTitle(
        noteName,
        true,
        noteFolder.length === 0
      )
      if (typeof foundNotes !== 'undefined' && Array.isArray(foundNotes)) {
        if (foundNotes.length === 1) {
          content = foundNotes[0].content
        } else {
          for (const note of foundNotes) {
            const parts = note.filename.split('/')
            parts.pop()
            const folder = parts.join('/')
            if (folder === noteFolder) {
              content = note.content
            }
          }
        }
      }
    }
    return content
  }
  static async preProcessNote() {
    let tag =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    if (!isCommentTag(tag)) {
      const includeInfo = tag
        .replace('<%-', '')
        .replace('%>', '')
        .replace('note', '')
        .replace('(', '')
        .replace(')', '')
      const parts = includeInfo.split(',')
      if (parts.length > 0) {
        const noteNamePath = parts[0].replace(/'/gi, '').trim()
        const content = await this.getNote(noteNamePath)
        if (content.length > 0) {
          return content
        } else {
          return '**An error occurred loading note "'.concat(
            noteNamePath,
            '"**'
          )
        }
      } else {
        return '**An error occurred process note**'
      }
    }
    return ''
  }
  static async preProcessCalendar() {
    let tag =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    if (!isCommentTag(tag)) {
      const includeInfo = tag
        .replace('<%-', '')
        .replace('%>', '')
        .replace('calendar', '')
        .replace('(', '')
        .replace(')', '')
      const parts = includeInfo.split(',')
      if (parts.length > 0) {
        const noteName = parts[0].replace(/'/gi, '').trim()
        let calendarNote = await DataStore.calendarNoteByDateString(noteName)
        if (typeof calendarNote !== 'undefined') {
          return calendarNote.content
        } else {
          return '**An error occurred loading note "'.concat(noteName, '"**')
        }
      } else {
        return '**An error occurred process note**'
      }
    }
    return ''
  }
  static async preProcess(templateData, sessionData) {
    let newTemplateData = templateData
    let newSettingData = _objectSpread2({}, sessionData)
    let override = {}
    const tags = (await this.getTags(templateData)) || []
    for (let tag of tags) {
      if (isCommentTag(tag)) {
        const regex = new RegExp(''.concat(tag, '[\\s\\r\\n]*'), 'g')
        newTemplateData = newTemplateData.replace(regex, '')
        tag = ''
      }
      if (tag.includes('note(')) {
        newTemplateData = newTemplateData.replace(
          tag,
          await this.preProcessNote(tag)
        )
      }
      if (tag.includes('calendar(')) {
        newTemplateData = newTemplateData.replace(
          tag,
          await this.preProcessCalendar(tag)
        )
      }
      if (tag.includes('include(') || tag.includes('template(')) {
        if (!isCommentTag(tag)) {
          let includeInfo = tag
          const keywords = [
            '<%=',
            '<%-',
            '<%',
            '_%>',
            '-%>',
            '%>',
            'include',
            'template',
          ]
          keywords.forEach(
            (x, i) =>
              (includeInfo = includeInfo
                .replace(/[{()}]/g, '')
                .replace(new RegExp(x, 'g'), ''))
          )
          const parts = includeInfo.split(',')
          if (parts.length > 0) {
            const templateName = parts[0]
              .replace(/'\s/gi, '')
              .replace(/'/gi, '')
              .trim()
            parts.length >= 1 ? parts[1] : {}
            const templateContent = await this.getTemplate(templateName, {
              silent: true,
            })
            const isTemplate = new FrontmatterModule().isFrontmatterTemplate(
              templateContent
            )
            if (isTemplate) {
              const {
                frontmatterAttributes: frontmatterAttributes,
                frontmatterBody: frontmatterBody,
              } = await this.preRender(templateContent, newSettingData)
              newSettingData = _objectSpread2({}, frontmatterAttributes)
              const renderedTemplate = await this.render(
                frontmatterBody,
                newSettingData
              )
              if (tag.includes('const') || tag.includes('let')) {
                const pos = tag.indexOf('=')
                if (pos > 0) {
                  let temp = tag
                    .substring(0, pos - 1)
                    .replace('<%', '')
                    .trim()
                  let varParts = temp.split(' ')
                  override[varParts[1]] = renderedTemplate
                  newTemplateData = newTemplateData.replace(tag, '')
                }
              } else {
                newTemplateData = newTemplateData.replace(tag, renderedTemplate)
              }
            } else {
              if (templateName.length === 8 && /^\d+$/.test(templateName)) {
                const calendarData = await this.preProcessCalendar(templateName)
                newTemplateData = newTemplateData.replace(tag, calendarData)
              } else {
                newTemplateData = newTemplateData.replace(
                  tag,
                  await this.preProcessNote(templateName)
                )
              }
            }
          } else {
            newTemplateData = newTemplateData.replace(
              tag,
              '**Unable to parse include**'
            )
          }
        }
      }
    }
    for (const tag of tags) {
      if (
        !tag.includes('await') &&
        !this.isControlBlock(tag) &&
        tag.includes('(') &&
        !tag.includes('prompt(')
      ) {
        let tempTag = tag.replace('<%-', '<%- await')
        newTemplateData = newTemplateData.replace(tag, tempTag)
      }
      if (
        tag.toLowerCase().includes(':return:') ||
        tag.toLowerCase().includes(':cr:')
      ) {
        newTemplateData = newTemplateData.replace(tag, '')
      }
      const getType = (value) => {
        if (value.includes('[')) {
          return 'array'
        }
        if (value.includes('{')) {
          return 'object'
        }
        return 'string'
      }
      if (tag.includes('const') || tag.includes('let') || tag.includes('var')) {
        if (sessionData) {
          const tempTag = tag
            .replace('const', '')
            .replace('let', '')
            .trimLeft()
            .replace('<%', '')
            .replace('-%>', '')
            .replace('%>', '')
          let pos = tempTag.indexOf('=')
          if (pos > 0) {
            let varName = tempTag.substring(0, pos - 1).trim()
            let value = tempTag.substring(pos + 1)
            if (getType(value) === 'string') {
              value = value.replace(/['"]+/g, '').trim()
            }
            if (getType(value) === 'array' || getType(value) === 'object') {
              value = value.replace('" ', '').replace(' "', '').trim()
            }
            newSettingData[varName] = value
          }
        }
      }
      if (tag === '<%- aim %>' || tag === '<%- aim() %>') {
        newTemplateData = newTemplateData.replace(tag, "<%- prompt('aim') %>")
      }
      if (tag === '<%- context %>' || tag === '<%- context() %>') {
        newTemplateData = newTemplateData.replace(
          tag,
          "<%- prompt('context') %>"
        )
      }
      if (tag === '<%- meetingName %>' || tag === '<%- meetingName() %>') {
        newTemplateData = newTemplateData.replace(
          tag,
          "<%- prompt('meetingName','Enter Meeting Name:') %>"
        )
      }
    }
    newSettingData = _objectSpread2(
      _objectSpread2({}, newSettingData),
      override
    )
    return {
      newTemplateData: newTemplateData,
      newSettingData: newSettingData,
    }
  }
  static async renderTemplate() {
    let templateName =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let userData =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}
    let userOptions =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}
    try {
      await this.setup()
      const templateData = await this.getTemplate(templateName)
      const {
        frontmatterBody: frontmatterBody,
        frontmatterAttributes: frontmatterAttributes,
      } = await this.preRender(templateData)
      const data = _objectSpread2(
        _objectSpread2({}, frontmatterAttributes),
        {},
        {
          frontmatter: _objectSpread2({}, frontmatterAttributes),
        },
        userData
      )
      const renderedData = await this.render(templateData, data, userOptions)
      return this._filterTemplateResult(renderedData)
    } catch (error) {
      clo(error, 'NPTemplating.renderTemplate found error dbw1')
      return this.templateErrorMessage('NPTemplating.renderTemplate', error)
    }
  }
  static async render() {
    let inTemplateData =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let userData =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}
    let userOptions =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}
    const usePrompts = false
    try {
      await this.setup()
      let sessionData = _objectSpread2({}, userData),
        templateData = ''
      if (
        inTemplateData !== null &&
        inTemplateData !== void 0 &&
        inTemplateData.replace
      ) {
        templateData = inTemplateData
          .replace(/‘/gi, "'")
          .replace(/’/gi, "'")
          .replace(/“/gi, "'")
          .replace(/”/gi, "'")
      }
      if (typeof templateData !== 'string') {
        templateData = templateData.toString()
      }
      let globalData = {}
      Object.getOwnPropertyNames(globals).forEach((key) => {
        globalData[key] = getProperyValue(globals, key)
      })
      sessionData.methods = _objectSpread2(
        _objectSpread2({}, sessionData.methods),
        globalData
      )
      templateData = templateData.replace(/<%@/gi, '<%- prompt')
      const isFrontmatterTemplate =
        new FrontmatterModule().isFrontmatterTemplate(templateData)
      if (isFrontmatterTemplate) {
        const {
          frontmatterAttributes: frontmatterAttributes,
          frontmatterBody: frontmatterBody,
        } = await this.preRender(templateData, sessionData)
        sessionData.data = _objectSpread2(
          _objectSpread2({}, sessionData.data),
          frontmatterAttributes
        )
      }
      templateData = await this.importCodeBlocks(templateData)
      if (isFrontmatterTemplate && usePrompts) {
        var _FrontmatterModule$pa
        const frontmatterAttributes =
          ((_FrontmatterModule$pa = new FrontmatterModule().parse(
            templateData
          )) === null || _FrontmatterModule$pa === void 0
            ? void 0
            : _FrontmatterModule$pa.attributes) || {}
        for (const [key, value] of Object.entries(frontmatterAttributes)) {
          let frontMatterValue = value
          const promptData = await this.processPrompts(
            value,
            sessionData,
            '<%',
            '%>'
          )
          frontMatterValue = promptData.sessionTemplateData
          const {
            newTemplateData: newTemplateData,
            newSettingData: newSettingData,
          } = await this.preProcess(frontMatterValue, sessionData)
          sessionData = _objectSpread2(
            _objectSpread2({}, sessionData),
            newSettingData
          )
          const renderedData = await new TemplatingEngine(
            this.constructor.templateConfig
          ).render(newTemplateData, promptData.sessionData, userOptions)
          templateData = templateData.replace(
            ''.concat(key, ': ').concat(value),
            ''.concat(key, ': ').concat(renderedData)
          )
        }
        if (userOptions !== null && userOptions !== void 0 && userOptions.qtn) {
          return templateData
        }
      }
      templateData = convertJavaScriptBlocksToTags(templateData)
      const {
        newTemplateData: newTemplateData,
        newSettingData: newSettingData,
      } = await this.preProcess(templateData, sessionData)
      sessionData = _objectSpread2({}, newSettingData)
      const promptData = await this.processPrompts(
        newTemplateData,
        sessionData,
        '<%',
        '%>'
      )
      templateData = promptData.sessionTemplateData
      sessionData = promptData.sessionData
      sessionData.data = _objectSpread2(
        _objectSpread2({}, sessionData.data),
        userData === null || userData === void 0 ? void 0 : userData.data
      )
      sessionData.methods = _objectSpread2(
        _objectSpread2({}, sessionData.methods),
        userData === null || userData === void 0 ? void 0 : userData.methods
      )
      const ignoredCodeBlocks = getIgnoredCodeBlocks(templateData)
      for (let index = 0; index < ignoredCodeBlocks.length; index++) {
        templateData = templateData.replace(
          ignoredCodeBlocks[index],
          '__codeblock:'.concat(index, '__')
        )
      }
      const renderedData = await new TemplatingEngine(
        this.constructor.templateConfig
      ).render(templateData, sessionData, userOptions)
      let final = this._filterTemplateResult(renderedData)
      for (let index = 0; index < ignoredCodeBlocks.length; index++) {
        final = final.replace(
          '__codeblock:'.concat(index, '__'),
          ignoredCodeBlocks[index]
        )
      }
      return final
    } catch (error) {
      clo(error, 'NPTemplating.renderTemplate found error dbw2')
      return this.templateErrorMessage('NPTemplating.renderTemplate', error)
    }
  }
  static extractTitleFromMarkdown(markdown) {
    let title = 'foo'
    let updatedMarkdown = markdown
    const lines = markdown.split('\n')
    if (lines[0].startsWith('# ')) {
      title = lines[0].substring(2)
      lines.shift()
      updatedMarkdown = lines.join('\n')
    }
    return {
      updatedMarkdown: updatedMarkdown,
      title: title,
    }
  }
  static async preRender() {
    let _templateData =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let userData =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}
    await this.setup()
    let templateData = _templateData
    let sectionData = _objectSpread2({}, userData)
    if (!new FrontmatterModule().isFrontmatterTemplate(templateData)) {
      const extractedData = this.extractTitleFromMarkdown(templateData)
      if (!extractedData.title)
        extractedData.title = 'Untitled (no title found in template)'
      templateData = '---\ntitle: '
        .concat(extractedData.title, '\n---\n')
        .concat(extractedData.updatedMarkdown)
      logDebug(
        pluginJson$1,
        'Template is not frontmatter, adding extracted title:"'
          .concat(extractedData.title, '" to content:')
          .concat(extractedData.updatedMarkdown)
      )
    }
    const frontmatterData = new FrontmatterModule().parse(templateData)
    const frontmatterAttributes =
      (frontmatterData === null || frontmatterData === void 0
        ? void 0
        : frontmatterData.attributes) || {}
    let frontmatterBody = frontmatterData.body
    const attributeKeys = Object.keys(frontmatterAttributes)
    for (const item of attributeKeys) {
      let value = frontmatterAttributes[item]
      let attributeValue =
        typeof value === 'string'
          ? await this.render(value, sectionData)
          : value
      sectionData[item] = attributeValue
      frontmatterAttributes[item] = attributeValue
    }
    return {
      frontmatterBody: frontmatterBody,
      frontmatterAttributes: _objectSpread2(
        _objectSpread2({}, userData),
        frontmatterAttributes
      ),
    }
  }
  static async postProcess(templateData) {
    let newTemplateData = templateData
    let pos = 0
    let startPos = 0
    let cursors = []
    do {
      let findStr = '$NP_CURSOR'
      pos = newTemplateData.indexOf(findStr, startPos)
      if (pos >= 0) {
        cursors.push({
          start: pos,
        })
        startPos = pos + 1
      }
    } while (pos >= 0)
    return {
      cursors: cursors,
    }
  }
  static async getTags() {
    let templateData =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    const TAGS_PATTERN = /\<%.*?\%>/gi
    const items = templateData.match(TAGS_PATTERN)
    return items || []
  }
  static async getPromptParameters() {
    let promptTag =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let tagValue = ''
    tagValue = promptTag
      .replace(
        /\bask\b|promptDateInterval|promptDate|prompt|[()]|<%-|<%=|<%|-%>|%>/gi,
        ''
      )
      .trim()
    let varName = ''
    let promptMessage = ''
    let options = ''
    let pos = tagValue.indexOf(',')
    if (pos >= 0) {
      varName = tagValue
        .substr(0, pos - 1)
        .replace(/'/g, '')
        .trim()
      tagValue = tagValue.substr(pos + 1)
      pos = tagValue.indexOf(',')
      if (pos >= 0) {
        if (tagValue[0] !== '[') {
          promptMessage = tagValue.substr(0, pos).replace(/'/g, '').trim()
          tagValue = tagValue.substr(pos + 1).trim()
        }
        if (tagValue.length > 0) {
          if (tagValue.includes('[')) {
            const optionItems = tagValue
              .replace('[', '')
              .replace(']', '')
              .split(',')
            options = optionItems.map((item) => item.replace(/'/g, ''))
          } else {
            options = tagValue.replace(/(^"|"$)/g, '').replace(/(^'|'$)/g, '')
            switch (options) {
              case '=now':
              case '%today%':
                options = new DateModule().now('YYYY-MM-DD')
                break

              case '%yesterday%':
                options = new DateModule().yesterday('YYYY-MM-DD')
                break

              case '%tomorrow%':
                options = new DateModule().tomorrow('YYYY-MM-DD')
                break

              case '%timestamp%':
                options = new DateModule().timestamp('YYYY-MM-DD')
                break
            }
          }
        }
      } else {
        promptMessage = tagValue.replace(/'/g, '')
      }
    } else {
      varName = tagValue.replace(/'/g, '')
    }
    if (promptMessage.length === 0) {
      promptMessage =
        options.length > 0
          ? 'Select '.concat(varName)
          : 'Enter '.concat(varName)
    }
    varName = varName.replace(/ /gi, '_')
    varName = varName.replace(/\?/gi, '')
    return {
      varName: varName,
      promptMessage: promptMessage,
      options: options,
    }
  }
  static async prompt(message) {
    let options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null
    if (Array.isArray(options)) {
      const { index: index } = await CommandBar.showOptions(options, message)
      return options[index]
    } else {
      let value = ''
      if (typeof options === 'string' && options.length > 0) {
        value = await CommandBar.textPrompt(
          '',
          message.replace('_', ' '),
          options
        )
      } else {
        value = await CommandBar.textPrompt('', message.replace('_', ' '), '')
      }
      return value
    }
  }
  static async promptDate(message, defaultValue) {
    return await datePicker(message)
  }
  static async promptDateInterval(message, defaultValue) {
    return await askDateInterval(message)
  }
  static async processPrompts(templateData, userData) {
    let startTag =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '<%'
    let endTag =
      arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '%>'
    const sessionData = _objectSpread2({}, userData)
    const methods = userData.hasOwnProperty('methods')
      ? Object.keys(
          userData === null || userData === void 0 ? void 0 : userData.methods
        )
      : []
    let sessionTemplateData = templateData
    sessionTemplateData = sessionTemplateData.replace(/<%@/gi, '<%- prompt')
    sessionTemplateData = sessionTemplateData.replace(
      /system.promptDateInterval/gi,
      'promptDateInterval'
    )
    sessionTemplateData = sessionTemplateData.replace(
      /system.promptDate/gi,
      'promptDate'
    )
    sessionTemplateData = sessionTemplateData.replace(/<%=/gi, '<%-')
    let tags = await this.getTags(sessionTemplateData)
    for (let tag of tags) {
      for (const method of methods) {
        if (tag.includes(method));
      }
      this.constructor.templateGlobals.some((element) => tag.includes(element))
      const doPrompt = (tag) => {
        let check = /prompt(Date|Interval)*\(/.test(tag)
        return check
      }
      if (doPrompt(tag)) {
        let {
          varName: varName,
          promptMessage: promptMessage,
          options: options,
        } = await this.getPromptParameters(tag)
        const varExists = (varName) => {
          let result = true
          if (!sessionData.hasOwnProperty(varName)) {
            result = false
            if (
              sessionData.hasOwnProperty('data') &&
              sessionData.data.hasOwnProperty(varName)
            ) {
              result = true
            }
          }
          return result
        }
        if (!varExists(varName)) {
          promptMessage = promptMessage.replace('await', '').replace(/  /g, ' ')
          let response = ''
          if (tag.includes('promptDate(')) {
            response = await datePicker(
              JSON.stringify({
                question: promptMessage,
              }),
              {}
            )
          } else if (tag.includes('promptDateInterval(')) {
            response = await askDateInterval(
              JSON.stringify({
                question: promptMessage,
              })
            )
          } else {
            response = await await this.prompt(promptMessage, options)
          }
          if (response) {
            if (typeof response === 'string') {
              response = response.trim()
            }
            sessionData[varName] = response
          } else {
            sessionData[varName] = ''
          }
        }
        if (
          tag.indexOf('<%=') >= 0 ||
          tag.indexOf('<%-') >= 0 ||
          tag.indexOf('<%') >= 0
        ) {
          const outputTag = tag.startsWith('<%=') ? '=' : '-'
          if (this.isVariableTag(tag)) {
            const parts = tag.split(' ')
            if (parts.length >= 2) {
              varName = parts[2]
              sessionTemplateData = sessionTemplateData.replace(
                ''.concat(tag, '\n'),
                ''
              )
              const keys = Object.keys(sessionData)
              for (let index = 0; index < keys.length; index++) {
                if (keys[index].indexOf('=_'.concat(varName)) >= 0) {
                  sessionData[varName] = sessionData[keys[index]]
                }
              }
            }
          }
          if (!tag.startsWith('<%-')) {
            sessionTemplateData = sessionTemplateData.replace(
              ''.concat(tag, '\n'),
              ''
            )
          } else {
            sessionTemplateData = sessionTemplateData.replace(
              tag,
              ''
                .concat(startTag)
                .concat(outputTag, ' ')
                .concat(varName, ' ')
                .concat(endTag)
            )
          }
        } else {
          sessionTemplateData = sessionTemplateData.replace(
            tag,
            "<% 'prompt' -%>"
          )
        }
      } else {
        await this.getPromptParameters(tag)
      }
    }
    sessionTemplateData = sessionTemplateData.replace(/<%~/gi, '<%=')
    return {
      sessionTemplateData: sessionTemplateData,
      sessionData: sessionData,
    }
  }
  static async createTemplate() {
    let title =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let metaData = arguments.length > 1 ? arguments[1] : undefined
    let content =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ''
    try {
      await this.setup()
      const parts = title.split('/')
      const noteName = parts.pop()
      const folder = (await getTemplateFolder()) + '/' + parts.join('/')
      const templateFilename = (await getTemplateFolder()) + '/' + title
      if (!(await this.templateExists(templateFilename))) {
        const filename = await DataStore.newNote(noteName, folder)
        const note = DataStore.projectNoteByFilename(filename)
        let metaTagData = []
        for (const [key, value] of Object.entries(metaData)) {
          metaTagData.push(''.concat(key, ': ').concat(value))
        }
        let templateContent = '---\ntitle: '
          .concat(noteName, '\n')
          .concat(metaTagData.join('\n'), '\n---\n')
        templateContent += content
        note.content = templateContent
        return true
      } else {
        return false
      }
    } catch (error) {
      logError(pluginJson$1, 'createTemplate :: '.concat(error))
    }
  }
  static async templateExists() {
    let title =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    await this.setup()
    await getTemplateFolder()
    let templateFilename =
      (await getTemplateFolder()) +
      title.replace(/@Templates/gi, '').replace(/\/\//, '/')
    templateFilename =
      await NPTemplating.normalizeToNotePlanFilename(templateFilename)
    try {
      let note = undefined
      note = await DataStore.projectNoteByFilename(
        ''.concat(templateFilename, '.md')
      )
      if (typeof note === 'undefined') {
        note = await DataStore.projectNoteByFilename(
          ''.concat(templateFilename, '.txt')
        )
      }
      return typeof note !== 'undefined'
    } catch (error) {
      logError(pluginJson$1, 'templateExists :: '.concat(error))
    }
  }
  static async getFolder() {
    var _Editor
    let folder =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let promptMessage =
      arguments.length > 1 && arguments[1] !== undefined
        ? arguments[1]
        : 'Select folder'
    await this.setup()
    let selectedFolder = folder
    DataStore.folders
    if (
      folder == '<select>' ||
      (((_Editor = Editor) === null || _Editor === void 0
        ? void 0
        : _Editor.type) === 'Calendar' &&
        selectedFolder.length === 0)
    ) {
      selectedFolder = await chooseFolder(promptMessage, false, true)
    } else if (folder == '<current>') {
      var _Editor$note
      const currentFilename =
        (_Editor$note = Editor.note) === null || _Editor$note === void 0
          ? void 0
          : _Editor$note.filename
      if (typeof currentFilename === 'undefined') {
        selectedFolder = await chooseFolder(promptMessage, false, true)
      } else {
        const parts = currentFilename.split('/')
        if (parts.length > 1) {
          parts.pop()
          selectedFolder = parts.join('/')
        }
      }
    } else {
      if (selectedFolder.length === 0) {
        selectedFolder = await chooseFolder(promptMessage, false, true)
      }
    }
    return selectedFolder
  }
  static isVariableTag() {
    let tag =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    return (
      tag.indexOf('<% const') > 0 ||
      tag.indexOf('<% let') > 0 ||
      tag.indexOf('<% var') > 0 ||
      tag.indexOf('{') > 0 ||
      tag.indexOf('}') > 0
    )
  }
  static isMethod() {
    let tag =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let userData =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null
    userData !== null &&
    userData !== void 0 &&
    userData.hasOwnProperty('methods')
      ? Object.keys(
          userData === null || userData === void 0 ? void 0 : userData.methods
        )
      : []
    return (
      tag.indexOf('(') > 0 || tag.indexOf('@') > 0 || tag.indexOf('prompt(') > 0
    )
  }
  static isTemplateModule() {
    let tag =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    const tagValue = tag
      .replace('<%=', '')
      .replace('<%-', '')
      .replace('%>', '')
      .trim()
    const pos = tagValue.indexOf('.')
    if (pos >= 0) {
      const moduleName = tagValue.substring(0, pos)
      return TEMPLATE_MODULES.indexOf(moduleName) >= 0
    }
    return false
  }
  static isControlBlock(tag) {
    let result = false
    if (tag.length >= 3) {
      if (tag[2] === ' ') {
        result = true
      }
    }
    if (tag.includes('prompt(')) {
      result = false
    }
    if (tag.includes('let') || tag.includes('const') || tag.includes('var')) {
      result = true
    }
    if (tag.includes('~')) {
      result = true
    }
    return result
  }
  static async isCommandAvailable(pluginId, pluginCommand) {
    try {
      let result = DataStore.installedPlugins().filter(
        (plugin) => plugin.id === pluginId
      )
      let commands =
        typeof result !== 'undefined' &&
        Array.isArray(result) &&
        result.length > 0 &&
        result[0].commands
      if (commands) {
        let command = commands.filter(
          (command) => command.name === pluginCommand
        )
        return Array.isArray(command) && command.length > 0
      } else {
        return false
      }
    } catch (error) {
      logError(pluginJson$1, error)
      return false
    }
  }
  static async invokePluginCommandByName(pluginId, pluginCommand) {
    let args =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : []
    if (await this.isCommandAvailable(pluginId, pluginCommand)) {
      return (
        (await DataStore.invokePluginCommandByName(
          pluginCommand,
          pluginId,
          args
        )) || ''
      )
    } else {
      const info = helpInfo('Plugin Error')
      return '**Unable to locate "'
        .concat(pluginId, ' :: ')
        .concat(pluginCommand, '".  Make sure "')
        .concat(pluginId, '" plugin has been installed.**\n\n')
        .concat(info)
    }
  }
  static async convertNoteToFrontmatter(projectNote) {
    return new FrontmatterModule().convertProjectNoteToFrontmatter(projectNote)
  }
  static async importCodeBlocks() {
    let templateData =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let newTemplateData = templateData
    const tags = (await this.getTags(templateData)) || []
    for (let tag of tags) {
      if (!isCommentTag(tag) && tag.includes('import(')) {
        const importInfo = tag
          .replace('<%-', '')
          .replace('<%', '')
          .replace('-%>', '')
          .replace('%>', '')
          .replace('import', '')
          .replace('(', '')
          .replace(')', '')
        const parts = importInfo.split(',')
        if (parts.length > 0) {
          const noteNamePath = parts[0].replace(/['"`]/gi, '').trim()
          const content = await this.getTemplate(noteNamePath)
          const body = new FrontmatterModule().body(content)
          if (body.length > 0) {
            newTemplateData = newTemplateData.replace('`' + tag + '`', body)
            newTemplateData = newTemplateData.replace(tag, body)
          } else {
            newTemplateData = newTemplateData.replace(
              tag,
              '**An error occurred importing "'.concat(noteNamePath, '"**')
            )
          }
        }
      }
    }
    return newTemplateData
  }
  static async execute() {
    let templateData =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
    let sessionData = arguments.length > 1 ? arguments[1] : undefined
    let processedTemplateData = templateData
    let processedSessionData = sessionData
    getCodeBlocks(templateData).forEach(async (codeBlock) => {
      if (!codeBlockHasComment(codeBlock) && blockIsJavaScript(codeBlock)) {
        const executeCodeBlock = codeBlock
          .replace('```templatejs\n', '')
          .replace('```\n', '')
        try {
          let result = ''
          if (executeCodeBlock.includes('<%')) {
            result = await new TemplatingEngine(
              this.constructor.templateConfig
            ).render(executeCodeBlock, processedSessionData)
            processedTemplateData = processedTemplateData.replace(
              codeBlock,
              result
            )
          } else {
            const fn = Function.apply(null, ['params', executeCodeBlock])
            result = fn(processedSessionData)
            if (typeof result === 'object') {
              processedTemplateData = processedTemplateData
                .replace(codeBlock, 'OBJECT')
                .replace('OBJECT\n', '')
              processedSessionData = _objectSpread2(
                _objectSpread2({}, processedSessionData),
                result
              )
            } else {
              processedTemplateData = processedTemplateData.replace(
                codeBlock,
                typeof result === 'string' ? result : ''
              )
            }
          }
        } catch (error) {
          logError(pluginJson$1, error)
        }
      }
    })
    debug(processedTemplateData, 'execute final')
    return {
      processedTemplateData: processedTemplateData,
      processedSessionData: processedSessionData,
    }
  }
}
function deleteEntireBlock(note, para) {
  let includeFromStartOfSection =
    arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false
  let keepHeading =
    arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true
  const paraBlock = getParagraphBlock(
    note,
    para.lineIndex,
    includeFromStartOfSection
  )
  logDebug(
    'NPParagraph/deleteEntireBlock',
    'Removing '.concat(paraBlock.length, ' items under ').concat(para.content)
  )
  keepHeading ? paraBlock.shift() : null
  if (paraBlock.length > 0) {
    note.removeParagraphs(paraBlock)
    logDebug(
      'NPParagraph/deleteEntireBlock',
      'Removed '
        .concat(paraBlock.length, ' items under ')
        .concat(para.content, ' (from line ')
        .concat(para.lineIndex, ')')
    )
  } else {
    logDebug(
      'NPParagraph/deleteEntireBlock',
      'No paragraphs to remove under '
        .concat(para.content, ' (line # ')
        .concat(para.lineIndex, ')')
    )
  }
}
function removeContentUnderHeading(note, heading) {
  let includeFromStartOfSection =
    arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false
  let keepHeading =
    arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true
  const paras = note.paragraphs.find(
    (p) => p.type === 'title' && p.content.includes(heading)
  )
  if (paras && paras.lineIndex != null) {
    deleteEntireBlock(note, paras, includeFromStartOfSection, keepHeading)
    logDebug(
      'NPParagraph/removeContentUnderHeading',
      'Note now has '.concat(note.paragraphs.length, ' lines')
    )
  } else {
    logWarn(
      'NPParagraph/removeContentUnderHeading',
      'Did not find heading: "'.concat(heading, '", so nothing removed.')
    )
  }
}
function insertContentUnderHeading(destNote, headingToFind, parasAsText) {
  let headingLevel =
    arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2
  logDebug(
    'NPParagraph/insertContentUnderHeading',
    "Called for '"
      .concat(headingToFind, "' with ")
      .concat(parasAsText.split('\n').length, ' paras)')
  )
  const headingMarker = '#'.repeat(headingLevel)
  const startOfNote = findStartOfActivePartOfNote(destNote)
  let insertionIndex = startOfNote
  for (let i = 0; i < destNote.paragraphs.length; i++) {
    const p = destNote.paragraphs[i]
    if (p.content.trim().startsWith(headingToFind) && p.type === 'title') {
      insertionIndex = i + 1
      break
    }
  }
  logDebug(
    'NPParagraph/insertContentUnderHeading',
    'insertionIndex = '
      .concat(insertionIndex, ' (startOfNote = ')
      .concat(startOfNote, ')')
  )
  const paraText =
    insertionIndex === startOfNote && headingToFind !== ''
      ? ''
          .concat(headingMarker, ' ')
          .concat(headingToFind, '\n')
          .concat(parasAsText, '\n')
      : parasAsText
  destNote.insertParagraph(paraText, insertionIndex, 'text')
}
async function replaceContentUnderHeading(note, heading, newContentText) {
  var _note$title
  let includeFromStartOfSection =
    arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false
  let headingLevel =
    arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 2
  logDebug(
    'NPParagraph / replaceContentUnderHeading',
    "In '"
      .concat(
        (_note$title = note.title) !== null && _note$title !== void 0
          ? _note$title
          : 'Untitled Note',
        '\' replace items under heading: "'
      )
      .concat(heading, '"')
  )
  removeContentUnderHeading(note, heading, includeFromStartOfSection)
  await insertContentUnderHeading(note, heading, newContentText, headingLevel)
}
function getParagraphBlock(note, selectedParaIndex) {
  let includeFromStartOfSection =
    arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false
  let useTightBlockDefinition =
    arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false
  const parasInBlock = []
  const startActiveLineIndex = findStartOfActivePartOfNote(note)
  const allParas = note.paragraphs
  const lastLineIndex = allParas.length - 1
  let startLine = selectedParaIndex
  let selectedPara = allParas[startLine]
  logDebug(
    'NPParagraph / getParagraphBlock',
    'Starting at lineIndex '
      .concat(selectedParaIndex, ' with start active/last line = ')
      .concat(startActiveLineIndex, '/')
      .concat(lastLineIndex, ' with ')
      .concat(String(includeFromStartOfSection), '/')
      .concat(String(useTightBlockDefinition), ": '")
      .concat(trimString(selectedPara.content, 50), "'")
  )
  if (includeFromStartOfSection) {
    for (let i = selectedParaIndex; i >= startActiveLineIndex; i--) {
      const p = allParas[i]
      if (p.type === 'separator') {
        startLine = i + 1
        break
      } else if (p.content === '') {
        startLine = i + 1
        break
      } else if (p.type === 'title' && p.headingLevel === 1) {
        startLine = i + 1
        break
      } else if (p.type === 'title' && p.headingLevel > 1) {
        startLine = i
        break
      }
      if (i === startActiveLineIndex) {
        startLine = i
      }
    }
  }
  selectedPara = allParas[startLine]
  if (selectedPara.type === 'title') {
    const thisHeadingLevel = selectedPara.headingLevel
    parasInBlock.push(selectedPara)
    for (let i = startLine + 1; i <= lastLineIndex; i++) {
      const p = allParas[i]
      if (p.type === 'title' && p.headingLevel <= thisHeadingLevel) {
        break
      } else if (useTightBlockDefinition && p.type === 'separator') {
        break
      } else if (useTightBlockDefinition && p.content === '') {
        break
      }
      parasInBlock.push(p)
    }
  } else {
    const startingIndentLevel = selectedPara.indents
    parasInBlock.push(selectedPara)
    for (let i = startLine + 1; i <= lastLineIndex; i++) {
      const p = allParas[i]
      if (useTightBlockDefinition && p.type === 'separator') {
        break
      } else if (useTightBlockDefinition && p.content === '') {
        break
      } else if (p.type === 'title') {
        break
      } else if (
        p.indents < startingIndentLevel &&
        !includeFromStartOfSection
      ) {
        break
      }
      parasInBlock.push(p)
    }
  }
  logDebug(
    'NPParagraph / getParagraphBlock',
    '  - Found '
      .concat(parasInBlock.length, ' paras in block starting with: "')
      .concat(parasInBlock[0].content, '"')
  )
  return parasInBlock
}
function selectFirstNonTitleLineInEditor() {
  if (Editor && Editor.content) {
    for (
      let i = findStartOfActivePartOfNote(Editor);
      i < Editor.paragraphs.length;
      i++
    ) {
      const line = Editor.paragraphs[i]
      if (
        line.type !== 'title' &&
        line !== null &&
        line !== void 0 &&
        line.contentRange &&
        line.contentRange.start >= 0
      ) {
        Editor.select(line.contentRange.start, 0)
        return
      }
    }
  }
}
async function writeNoteContents(
  note,
  renderedTemplate,
  headingName,
  location
) {
  let options =
    arguments.length > 4 && arguments[4] !== undefined
      ? arguments[4]
      : {
          shouldOpenInEditor: false,
          createMissingHeading: false,
          replaceNoteContents: false,
        }
  let writeUnderHeading = headingName
  if (note) {
    logDebug(
      pluginJson$1,
      'writeNoteContents title:"'
        .concat(note.title || '', '" writeUnderHeading:')
        .concat(writeUnderHeading, ' location:')
        .concat(location, ' options:')
        .concat(JSP(options), ' renderedTemplate:\n---\n')
        .concat(renderedTemplate, '\n---')
    )
    if (options.replaceNoteContents) {
      logDebug(
        pluginJson$1,
        'NPEditor::writeNoteContents replacing note contents (options.replaceNoteContents === true)'
      )
      const startIndex = findStartOfActivePartOfNote(note)
      logDebug(
        pluginJson$1,
        'NPEditor::writeNoteContents deleting everything after line #'.concat(
          startIndex
        )
      )
      const parasToKeep = note.paragraphs.filter(
        (p) => p.lineIndex < startIndex
      )
      note.paragraphs.filter((p) => p.lineIndex >= startIndex)
      const strToKeep = parasToKeep.map((p) => p.rawContent).join('\n')
      logDebug(
        pluginJson$1,
        'NPEditor::adding in renderedTemplate ('.concat(
          renderedTemplate.split('\n').length,
          ' lines)'
        )
      )
      note.content = ''.concat(strToKeep, '\n').concat(renderedTemplate)
      return
    } else {
      if (
        /<choose>/i.test(writeUnderHeading) ||
        /<select>/i.test(writeUnderHeading)
      ) {
        writeUnderHeading = await chooseHeading(note, true)
      }
      if (writeUnderHeading) {
        var _note$content
        if (
          (note === null || note === void 0
            ? void 0
            : (_note$content = note.content) === null ||
                _note$content === void 0
              ? void 0
              : _note$content.indexOf(''.concat(writeUnderHeading, '\n'))) !==
            -1 ||
          options.createMissingHeading
        ) {
          if (location === 'replace') {
            await replaceContentUnderHeading(
              note,
              writeUnderHeading,
              renderedTemplate
            )
          } else {
            note.addParagraphBelowHeadingTitle(
              renderedTemplate,
              'text',
              writeUnderHeading,
              location === 'append',
              true
            )
          }
          if (options.shouldOpenInEditor) {
            await Editor.openNoteByFilename(note.filename)
            selectFirstNonTitleLineInEditor()
          }
        } else {
          await CommandBar.prompt(
            '"'.concat(writeUnderHeading, '" heading does not exist in note.'),
            ''
          )
        }
      } else {
        const startIndex = findStartOfActivePartOfNote(note)
        if (location === 'append') {
          logDebug(
            pluginJson$1,
            'writeNoteContents appending "'.concat(renderedTemplate, '"')
          )
          note.appendParagraph(renderedTemplate, 'text')
        } else {
          logDebug(
            pluginJson$1,
            'writeNoteContents prepending "'
              .concat(renderedTemplate, '" at index ')
              .concat(startIndex)
          )
          note.insertParagraph(renderedTemplate, startIndex, 'text')
        }
      }
    }
  } else {
    logDebug(
      pluginJson$1,
      'NPEditor::writeNoteContents -- there was no note to write to'
    )
  }
}
async function templateFileByTitleEx() {
  let selectedTemplate =
    arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
  let openInEditor =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false
  let args =
    arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null
  try {
    logDebug(
      pluginJson$1,
      'templateFileByTitleEx Starting Self-Running Template Execution: selectedTemplate:"'
        .concat(selectedTemplate, '" openInEditor:')
        .concat(String(openInEditor), ' args:"')
        .concat(
          (args === null || args === void 0 ? void 0 : args.toString()) || '',
          '"'
        )
    )
    if (selectedTemplate.length !== 0) {
      const argObj = overrideSettingsWithStringArgs({}, args || '')
      clo(
        argObj,
        'templateFileByTitleEx after overrideSettingsWithStringArgs argObj'
      )
      if (!selectedTemplate || selectedTemplate.length === 0) {
        await CommandBar.prompt(
          'You must supply a template title as the first argument',
          helpInfo('Presets')
        )
      }
      let failed = false
      const templateData = await NPTemplating.getTemplate(selectedTemplate)
      if (!templateData) {
        failed = true
      }
      const isFrontmatter = new FrontmatterModule().isFrontmatterTemplate(
        templateData
      )
      if (!failed && isFrontmatter) {
        const {
          frontmatterBody: frontmatterBody,
          frontmatterAttributes: frontmatterAttributes,
        } = await NPTemplating.preRender(templateData)
        let data = _objectSpread2(
          _objectSpread2(_objectSpread2({}, frontmatterAttributes), argObj),
          {},
          {
            frontmatter: _objectSpread2(
              _objectSpread2({}, frontmatterAttributes),
              argObj
            ),
          }
        )
        let renderedTemplate = await NPTemplating.render(frontmatterBody, data)
        const {
          openNoteTitle: openNoteTitle,
          writeNoteTitle: writeNoteTitle,
          location: location,
          writeUnderHeading: writeUnderHeading,
          replaceNoteContents: replaceNoteContents,
          getNoteTitled: getNoteTitled,
        } = frontmatterAttributes
        clo(
          frontmatterAttributes,
          'templateFileByTitleEx after destructure - replaceNoteContents:'.concat(
            replaceNoteContents,
            ' the rest:'
          )
        )
        let noteTitle =
          (openNoteTitle && openNoteTitle.trim()) ||
          (writeNoteTitle &&
            (writeNoteTitle === null || writeNoteTitle === void 0
              ? void 0
              : writeNoteTitle.trim())) ||
          '' ||
          (getNoteTitled && getNoteTitled.trim())
        let shouldOpenInEditor =
          (openNoteTitle && openNoteTitle.length > 0) || openInEditor
        const createMissingHeading = true
        if (/<choose>/i.test(noteTitle) || /<select>/i.test(noteTitle)) {
          var _noteTitle
          logDebug(pluginJson$1, 'templateFileByTitleEx Inside choose code')
          const chosenNote = await chooseNote()
          noteTitle =
            (chosenNote === null || chosenNote === void 0
              ? void 0
              : chosenNote.title) || ''
          if (
            !(
              (_noteTitle = noteTitle) !== null &&
              _noteTitle !== void 0 &&
              _noteTitle.length
            )
          ) {
            await showMessage("Selected note has no title and can't be used")
            return
          }
          logDebug(
            pluginJson$1,
            'templateFileByTitleEx: noteTitle: '.concat(noteTitle)
          )
        }
        const isTodayNote = /<today>/i.test(noteTitle)
        const isThisWeek = /<thisweek>/i.test(noteTitle)
        const isNextWeek = /<nextweek>/i.test(noteTitle)
        logDebug(
          pluginJson$1,
          'templateFileByTitleEx isTodayNote:'
            .concat(String(isTodayNote), ' isThisWeek:')
            .concat(String(isThisWeek), ' isNextWeek:')
            .concat(String(isNextWeek))
        )
        let note
        let options = {
          shouldOpenInEditor: false,
          createMissingHeading: Boolean(createMissingHeading),
          replaceNoteContents: Boolean(replaceNoteContents),
        }
        clo(options, 'templateFileByTitleEx options')
        if (isTodayNote) {
          if (shouldOpenInEditor) {
            var _Editor, _Editor$note
            if (
              ((_Editor = Editor) === null || _Editor === void 0
                ? void 0
                : (_Editor$note = _Editor.note) === null ||
                    _Editor$note === void 0
                  ? void 0
                  : _Editor$note.title) !== hyphenatedDate(new Date())
            ) {
              var _Editor2, _Editor2$note, _Editor$note2
              logDebug(
                pluginJson$1,
                'templateFileByTitleEx About to openNoteByDate; Editor was opened to: '
                  .concat(
                    ((_Editor2 = Editor) === null || _Editor2 === void 0
                      ? void 0
                      : (_Editor2$note = _Editor2.note) === null ||
                          _Editor2$note === void 0
                        ? void 0
                        : _Editor2$note.title) || '',
                    ', and we want '
                  )
                  .concat(hyphenatedDate(new Date()))
              )
              await Editor.openNoteByDate(new Date())
              logDebug(
                pluginJson$1,
                'templateFileByTitleEx Editor.note.filename is:'.concat(
                  String(
                    ((_Editor$note2 = Editor.note) === null ||
                    _Editor$note2 === void 0
                      ? void 0
                      : _Editor$note2.filename) || ''
                  )
                )
              )
            }
            if (Editor.note) {
              await writeNoteContents(
                Editor.note,
                renderedTemplate,
                writeUnderHeading,
                location,
                options
              )
            }
          } else {
            var _note
            logDebug(
              pluginJson$1,
              'templateFileByTitleEx About to open calendarNoteByDate'
            )
            note = DataStore.calendarNoteByDate(new Date())
            logDebug(
              pluginJson$1,
              'templateFileByTitleEx got note:'.concat(
                ((_note = note) === null || _note === void 0
                  ? void 0
                  : _note.title) || ''
              )
            )
            if (note) {
              logDebug(
                pluginJson$1,
                'templateFileByTitleEx note found. filename='.concat(
                  note.filename,
                  ' calling writeNoteContents'
                )
              )
              await writeNoteContents(
                note,
                renderedTemplate,
                writeUnderHeading,
                location,
                options
              )
            } else {
              logError(pluginJson$1, 'templateFileByTitleEx note NOT found.')
              clo(note, 'templateFileByTitleEx note variable is')
            }
          }
        } else if (isThisWeek || isNextWeek) {
          logDebug(
            pluginJson$1,
            'templateFileByTitleEx isThisWeek || isNextWeek'
          )
          const dateInfo = getNPWeekData(
            moment$1().toDate(),
            isThisWeek ? 0 : 1,
            'week'
          )
          if (dateInfo) {
            if (shouldOpenInEditor) {
              var _Editor3
              await Editor.openWeeklyNote(
                dateInfo.weekYear,
                dateInfo.weekNumber
              )
              if (
                (_Editor3 = Editor) !== null &&
                _Editor3 !== void 0 &&
                _Editor3.note
              ) {
                await writeNoteContents(
                  Editor.note,
                  renderedTemplate,
                  writeUnderHeading,
                  location,
                  options
                )
              }
            } else {
              note = DataStore.calendarNoteByDateString(dateInfo.weekString)
              if (note) {
                await writeNoteContents(
                  note,
                  renderedTemplate,
                  writeUnderHeading,
                  location,
                  options
                )
              }
            }
          } else {
            logError(
              pluginJson$1,
              'templateFileByTitleEx: Could not get proper week info for '.concat(
                noteTitle
              )
            )
          }
        } else {
          var _noteTitle2
          logDebug(
            pluginJson$1,
            'templateFileByTitleEx is other type noteTitle:'.concat(noteTitle)
          )
          if (noteTitle === '<current>') {
            if (Editor.type === 'Notes' || Editor.type === 'Calendar') {
              if (Editor.note) {
                await writeNoteContents(
                  Editor.note,
                  renderedTemplate,
                  writeUnderHeading,
                  location,
                  options
                )
              }
            } else {
              await CommandBar.prompt(
                'You must have either Project Note or Calendar Note open when using "<current>".',
                ''
              )
            }
            return
          }
          if (
            (_noteTitle2 = noteTitle) !== null &&
            _noteTitle2 !== void 0 &&
            _noteTitle2.length
          ) {
            const notes = await DataStore.projectNoteByTitle(noteTitle)
            const length = notes ? notes.length : 0
            if (!notes || length == 0 || (notes && notes.length > 1)) {
              let msg = 'Unable to locate any notes matching "'.concat(
                noteTitle,
                '"'
              )
              if (length > 1) {
                msg = ''
                  .concat(length, ' notes found matching "')
                  .concat(noteTitle, '"')
              }
              await CommandBar.prompt(
                ''.concat(
                  msg,
                  '.\n\nThe title must be unique to ensure correct note is updated.'
                ),
                helpInfo('Presets')
              )
            } else {
              note = notes[0] || null
              if (!note) {
                await CommandBar.prompt(
                  'Unable to locate note matching "'.concat(noteTitle, '"'),
                  helpInfo('Presets')
                )
              } else {
                var _note2
                logDebug(
                  pluginJson$1,
                  'templateFileByTitleEx: About to call writeNoteContents in note: "'.concat(
                    ((_note2 = note) === null || _note2 === void 0
                      ? void 0
                      : _note2.title) || '',
                    '"'
                  )
                )
                await writeNoteContents(
                  note,
                  renderedTemplate,
                  writeUnderHeading,
                  location,
                  _objectSpread2(_objectSpread2({}, options), {
                    shouldOpenInEditor: shouldOpenInEditor,
                    createMissingHeading: createMissingHeading,
                  })
                )
              }
            }
          } else {
            await CommandBar.prompt(
              'Frontmatter field: "getNoteTitled" must be set in order to open the desired note.',
              helpInfo('Presets')
            )
          }
        }
      } else {
        await CommandBar.prompt(
          'Unable to locate template "'.concat(selectedTemplate, '"'),
          helpInfo('Presets')
        )
      }
    }
  } catch (error) {
    logError(pluginJson$1, JSP(error))
  }
}
export async function onSettingsUpdated() {
  try {
    var _DataStore$settings
    const templateGroupTemplatesByFolder =
      ((_DataStore$settings = DataStore.settings) === null ||
      _DataStore$settings === void 0
        ? void 0
        : _DataStore$settings.templateGroupTemplatesByFolder) || false
    DataStore.setPreference(
      'templateGroupTemplatesByFolder',
      templateGroupTemplatesByFolder
    )
  } catch (error) {
    logError(pluginJson$1, error)
  }
}
export async function onUpdateOrInstall() {
  try {
    let result = 0
    const pluginSettingsData = await DataStore.loadJSON(
      '../'.concat(pluginJson$1['plugin.id'], '/settings.json')
    )
    if (typeof pluginSettingsData == 'undefined') {
      result = updateSettingData(pluginJson$1)
    }
    const templateSettings = await NPTemplating.updateOrInstall(
      DataStore.settings,
      pluginJson$1['plugin.version']
    )
    DataStore.settings = _objectSpread2({}, templateSettings)
    const pluginList = DataStore.installedPlugins()
    const version = await DataStore.invokePluginCommandByName(
      'np:about',
      'np.Templating',
      [{}]
    )
    console.log(version)
  } catch (error) {
    logError(pluginJson$1, error)
  }
}
export async function templateInit() {
  try {
    const pluginSettingsData = await DataStore.loadJSON(
      '../'.concat(pluginJson$1['plugin.id'], '/settings.json')
    )
    if (typeof pluginSettingsData === 'object') {
      const result = await CommandBar.prompt(
        'Templating Settings',
        'np.Templating settings have already been created. \n\nWould you like to reset to default settings?',
        ['Yes', 'No']
      )
      if (result === 0) {
        DataStore.settings = _objectSpread2(
          {},
          await initConfiguration(pluginJson$1)
        )
      }
    } else {
      onUpdateOrInstall({
        silent: true,
      })
    }
  } catch (error) {
    logError(pluginJson$1, error)
  }
}
export async function templateInsert() {
  let templateName =
    arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
  try {
    if (Editor.type === 'Notes' || Editor.type === 'Calendar') {
      const selectedTemplate =
        templateName.length > 0
          ? templateName
          : await NPTemplating.chooseTemplate()
      // We need this in the web app to close the command bar without continuing here
      if (!selectedTemplate) {
        return
      }
      const templateData = await NPTemplating.getTemplate(selectedTemplate)
      const {
        frontmatterBody: frontmatterBody,
        frontmatterAttributes: frontmatterAttributes,
      } = await NPTemplating.preRender(templateData)
      const renderedTemplate = await NPTemplating.render(
        frontmatterBody,
        frontmatterAttributes
      )
      Editor.insertTextAtCursor(renderedTemplate)
    } else {
      await CommandBar.prompt(
        'Template',
        'You must have a Project Note or Calendar Note opened where you wish to insert template.'
      )
    }
  } catch (error) {
    logError(pluginJson$1, error)
  }
}
export async function templateAppend() {
  let templateName =
    arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
  try {
    if (Editor.type === 'Notes' || Editor.type === 'Calendar') {
      const content = Editor.content || ''
      const selectedTemplate =
        templateName.length > 0
          ? templateName
          : await NPTemplating.chooseTemplate()
      const templateData = await NPTemplating.getTemplate(selectedTemplate)
      let {
        frontmatterBody: frontmatterBody,
        frontmatterAttributes: frontmatterAttributes,
      } = await NPTemplating.preRender(templateData)
      let data = _objectSpread2(
        _objectSpread2({}, frontmatterAttributes),
        {},
        {
          frontmatter: _objectSpread2({}, frontmatterAttributes),
        }
      )
      let renderedTemplate = await NPTemplating.render(frontmatterBody, data)
      const location =
        (frontmatterAttributes === null || frontmatterAttributes === void 0
          ? void 0
          : frontmatterAttributes.location) || 'append'
      if (location === 'cursor') {
        Editor.insertTextAtCursor(renderedTemplate)
      } else {
        Editor.insertTextAtCharacterIndex(renderedTemplate, content.length)
      }
    } else {
      await CommandBar.prompt(
        'Template',
        'You must have a Project Note or Calendar Note opened where you wish to append template.'
      )
    }
  } catch (error) {
    logError(pluginJson$1, error)
  }
}
export async function templateInvoke(templateName) {
  try {
    if (Editor.type === 'Notes' || Editor.type === 'Calendar') {
      var _selectedTemplateFile
      const content = Editor.content || ''
      let selectedTemplateFilename
      if (templateName) {
        const notes = await DataStore.projectNoteByTitle(templateName, true)
        if (notes !== null && notes !== void 0 && notes.length) {
          selectedTemplateFilename = notes[0].filename
        } else {
          logError(
            pluginJson$1,
            'Unable to locate template: '.concat(
              templateName,
              ' which was passed to templateExecute'
            )
          )
        }
      }
      const selectedTemplate =
        (_selectedTemplateFile = selectedTemplateFilename) !== null &&
        _selectedTemplateFile !== void 0
          ? _selectedTemplateFile
          : await NPTemplating.chooseTemplate()
      const templateData = await NPTemplating.getTemplate(selectedTemplate)
      let {
        frontmatterBody: frontmatterBody,
        frontmatterAttributes: frontmatterAttributes,
      } = await NPTemplating.preRender(templateData)
      let data = _objectSpread2(
        _objectSpread2({}, frontmatterAttributes),
        {},
        {
          frontmatter: _objectSpread2({}, frontmatterAttributes),
        }
      )
      const location =
        (frontmatterAttributes === null || frontmatterAttributes === void 0
          ? void 0
          : frontmatterAttributes.location) || 'append'
      let renderedTemplate = await NPTemplating.render(frontmatterBody, data)
      switch (location) {
        case 'append':
          smartAppendPara(Editor, renderedTemplate, 'text')
          break

        case 'prepend':
          smartPrependPara(Editor, renderedTemplate, 'text')
          break

        case 'insert':
        case 'cursor':
          Editor.insertTextAtCursor(renderedTemplate)
          break

        default:
          Editor.insertTextAtCursor(renderedTemplate)
          break
      }
    } else {
      await CommandBar.prompt(
        'Template',
        'You must have a Project Note or Calendar Note opened where you wish to append template.'
      )
    }
  } catch (error) {
    logError(pluginJson$1, error)
  }
}
export async function templateNew() {
  let templateTitle =
    arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
  let _folder = arguments.length > 1 ? arguments[1] : undefined
  try {
    let selectedTemplate
    if (
      templateTitle !== null &&
      templateTitle !== void 0 &&
      templateTitle.trim().length
    ) {
      const options = await NPTemplating.getTemplateList()
      const chosenOpt = options.find((option) => option.label === templateTitle)
      if (chosenOpt) {
        selectedTemplate = chosenOpt.value
      }
    } else {
      selectedTemplate = await NPTemplating.chooseTemplate()
    }
    const templateData = await NPTemplating.getTemplate(selectedTemplate)
    const templateAttributes =
      await NPTemplating.getTemplateAttributes(templateData)
    let folder = _folder !== null && _folder !== void 0 ? _folder : ''
    let noteTitle = ''
    const {
      frontmatterBody: frontmatterBody,
      frontmatterAttributes: frontmatterAttributes,
    } = await NPTemplating.preRender(templateData)
    if (
      !folder &&
      frontmatterAttributes !== null &&
      frontmatterAttributes !== void 0 &&
      frontmatterAttributes.folder &&
      frontmatterAttributes.folder.length > 0
    ) {
      folder = await NPTemplating.getFolder(
        frontmatterAttributes.folder,
        'Select Destination Folder'
      )
    }
    if (frontmatterAttributes.hasOwnProperty('newNoteTitle')) {
      noteTitle = frontmatterAttributes.newNoteTitle
    } else {
      const title = await CommandBar.textPrompt(
        'Template',
        'Enter New Note Title',
        ''
      )
      if (typeof title === 'boolean' || title.length === 0) {
        return
      }
      noteTitle = title
    }
    if (noteTitle.length === 0) {
      return
    }
    const filename = DataStore.newNote(noteTitle, folder) || ''
    if (filename) {
      const data = {
        data: _objectSpread2(_objectSpread2({}, frontmatterAttributes), {
          noteTitle: noteTitle,
        }),
      }
      const templateResult = await NPTemplating.render(frontmatterBody, data)
      await Editor.openNoteByFilename(filename)
      const hasFM = hasFrontMatter(templateResult)
      if (hasFM) {
        Editor.content = templateResult
        setFrontMatterVars(Editor, {
          title: noteTitle,
        })
      } else {
        Editor.content = '# '.concat(noteTitle, '\n').concat(templateResult)
      }
      selectFirstNonTitleLineInEditor()
    } else {
      await CommandBar.prompt(
        'New Template',
        'An error occured creating '.concat(noteTitle, ' note')
      )
    }
  } catch (error) {
    logError(pluginJson$1, error)
  }
}
export async function templateQuickNote() {
  let templateTitle =
    arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
  try {
    const content = Editor.content || ''
    const templateFolder = await getTemplateFolder()
    const options = await NPTemplating.getTemplateList('quick-note')
    if (options.length === 0) {
      await CommandBar.prompt(
        'Unable to locate any Quick Notes templates in "'.concat(
          templateFolder,
          '" folder'
        ),
        helpInfo('Quick Notes')
      )
      return
    }
    let selectedTemplate
    if (
      templateTitle !== null &&
      templateTitle !== void 0 &&
      templateTitle.length &&
      options.find((option) => option.label === templateTitle)
    ) {
      var _options$find
      selectedTemplate =
        (_options$find = options.find(
          (option) => option.label === templateTitle
        )) === null || _options$find === void 0
          ? void 0
          : _options$find.value
    } else {
      selectedTemplate =
        options.length > 1
          ? await NPTemplating.chooseTemplate('quick-note', 'Choose Quick Note')
          : options[0].value
    }
    if (selectedTemplate) {
      const templateData = await NPTemplating.getTemplate(selectedTemplate)
      const isFrontmatter = new FrontmatterModule().isFrontmatterTemplate(
        templateData
      )
      const templateAttributes =
        await NPTemplating.getTemplateAttributes(templateData)
      let folder = ''
      if (isFrontmatter) {
        var _frontmatterAttribute, _frontmatterAttribute2
        const {
          frontmatterBody: frontmatterBody,
          frontmatterAttributes: frontmatterAttributes,
        } = await NPTemplating.preRender(templateData)
        let folder =
          (_frontmatterAttribute =
            frontmatterAttributes === null || frontmatterAttributes === void 0
              ? void 0
              : (_frontmatterAttribute2 = frontmatterAttributes.folder) ===
                    null || _frontmatterAttribute2 === void 0
                ? void 0
                : _frontmatterAttribute2.trim()) !== null &&
          _frontmatterAttribute !== void 0
            ? _frontmatterAttribute
            : ''
        if (
          frontmatterAttributes !== null &&
          frontmatterAttributes !== void 0 &&
          frontmatterAttributes.folder &&
          frontmatterAttributes.folder.length > 0
        ) {
          folder = await NPTemplating.getFolder(
            frontmatterAttributes.folder,
            'Select Destination Folder'
          )
        }
        let newNoteTitle = ''
        if (
          frontmatterAttributes !== null &&
          frontmatterAttributes !== void 0 &&
          frontmatterAttributes.newNoteTitle
        ) {
          newNoteTitle = frontmatterAttributes.newNoteTitle
        } else {
          newNoteTitle =
            (await CommandBar.textPrompt(
              'Quick Note',
              'Enter Note Title',
              ''
            )) || ''
          if (typeof newNoteTitle === 'boolean' || newNoteTitle.length === 0) {
            return
          }
        }
        const filename = DataStore.newNote(newNoteTitle, folder) || ''
        if (filename) {
          const data = {
            data: _objectSpread2(_objectSpread2({}, frontmatterAttributes), {
              noteTitle: newNoteTitle,
            }),
          }
          let finalRenderedData = await NPTemplating.render(
            frontmatterBody,
            data
          )
          await Editor.openNoteByFilename(filename)
          const lines = finalRenderedData.split('\n')
          const startBlock = lines.indexOf('--')
          const endBlock =
            startBlock === 0 ? lines.indexOf('--', startBlock + 1) : -1
          if (startBlock >= 0 && endBlock >= 0) {
            lines[startBlock] = '---'
            lines[endBlock] = '---'
            Editor.content = lines.join('\n')
          } else {
            Editor.content = '# '
              .concat(newNoteTitle, '\n')
              .concat(finalRenderedData)
          }
          selectFirstNonTitleLineInEditor()
        } else {
          await CommandBar.prompt(
            'New Note Could Note Be Created',
            'Note: "'
              .concat(newNoteTitle, '" (newNoteTitle) in folder: "')
              .concat(
                folder,
                '" could not be created. Check to ensure folder path is valid. For more information please refer to '
              )
              .concat(helpInfo('Template Anatomty: Frontmatter'))
          )
        }
      } else {
        await CommandBar.prompt(
          'New Note Could Note Be Created',
          helpInfo('Template Anatomty: Frontmatter')
        )
      }
    }
  } catch (error) {
    logError(pluginJson$1, error.message)
  }
}
export async function templateMeetingNote() {
  let templateName =
    arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
  try {
    const content = Editor.content || ''
    const templateFolder = await getTemplateFolder()
    const options = await NPTemplating.getTemplateList('meeting-note')
    if (options.length === 0) {
      await CommandBar.prompt('Templating', helpInfo('Meeting Notes'))
      return
    }
    let selectedTemplate = ''
    if (
      templateName !== null &&
      templateName !== void 0 &&
      templateName.length &&
      options.find((option) => option.label === templateName)
    ) {
      var _options$find2
      selectedTemplate =
        (_options$find2 = options.find(
          (option) => option.label === templateName
        )) === null || _options$find2 === void 0
          ? void 0
          : _options$find2.value
    } else {
      selectedTemplate =
        options.length > 1
          ? await NPTemplating.chooseTemplate(
              'meeting-note',
              'Choose Meeting Note'
            )
          : options[0].value
    }
    if (selectedTemplate) {
      const templateData = await NPTemplating.getTemplate(selectedTemplate)
      const isFrontmatter = new FrontmatterModule().isFrontmatterTemplate(
        templateData
      )
      const templateAttributes =
        await NPTemplating.getTemplateAttributes(templateData)
      let folder = ''
      if (isFrontmatter) {
        var _frontmatterAttribute3
        const {
          frontmatterBody: frontmatterBody,
          frontmatterAttributes: frontmatterAttributes,
        } = await NPTemplating.preRender(templateData)
        let folder =
          (_frontmatterAttribute3 =
            frontmatterAttributes === null || frontmatterAttributes === void 0
              ? void 0
              : frontmatterAttributes.folder.trim()) !== null &&
          _frontmatterAttribute3 !== void 0
            ? _frontmatterAttribute3
            : ''
        if (
          frontmatterAttributes !== null &&
          frontmatterAttributes !== void 0 &&
          frontmatterAttributes.folder &&
          frontmatterAttributes.folder.length > 0
        ) {
          folder = await NPTemplating.getFolder(
            frontmatterAttributes.folder,
            'Select Destination Folder'
          )
        }
        let newNoteTitle = ''
        if (
          frontmatterAttributes !== null &&
          frontmatterAttributes !== void 0 &&
          frontmatterAttributes.newNoteTitle
        ) {
          newNoteTitle = frontmatterAttributes.newNoteTitle
        } else {
          const format = getSetting('np.Templating', 'timestampFormat')
          const info = await CommandBar.textPrompt(
            'Meeting Note',
            'What is date/time of meeeting?',
            timestamp(format)
          )
          newNoteTitle = info ? info : ''
          if (typeof newNoteTitle === 'boolean' || newNoteTitle.length === 0) {
            return
          }
        }
        if (!newNoteTitle || newNoteTitle.length === 0) {
          const helpText = helpInfo('Templating Prompts')
          await CommandBar.prompt(
            'Invalid Note Title (newNoteTitle)',
            "QuickNotes are required to have a newNoteTitle field which specifies what the generated note's title will be. FYI, note title may only contain alphanumeric characters (a..z, A..Z, 0..9)\n\nIf you have used a templating prompt to obtain note title, make sure the prompt variable is valid.\n\n".concat(
              helpText
            )
          )
          return
        }
        const filename = DataStore.newNote(newNoteTitle, folder) || ''
        if (filename) {
          const data = {
            data: _objectSpread2(_objectSpread2({}, frontmatterAttributes), {
              noteTitle: newNoteTitle,
            }),
          }
          let finalRenderedData = await NPTemplating.render(
            frontmatterBody,
            data
          )
          await Editor.openNoteByFilename(filename)
          const lines = finalRenderedData.split('\n')
          const startBlock = lines.indexOf('--')
          const endBlock =
            startBlock === 0 ? lines.indexOf('--', startBlock + 1) : -1
          if (startBlock >= 0 && endBlock >= 0) {
            lines[startBlock] = '---'
            lines[endBlock] = '---'
            Editor.content = lines.join('\n')
          } else {
            Editor.content = '# '
              .concat(newNoteTitle, '\n')
              .concat(finalRenderedData)
          }
          selectFirstNonTitleLineInEditor()
        }
      }
    }
  } catch (error) {
    logError(pluginJson$1, error.message)
  }
}
export async function templateRunner() {
  try {
    if (arguments.length > 0) {
      templateFileByTitle(
        arguments.length <= 0 ? undefined : arguments[0],
        (arguments.length <= 1 ? undefined : arguments[1]) === 'true',
        arguments.length > 2
          ? arguments.length <= 2
            ? undefined
            : arguments[2]
          : ''
      )
    } else {
      await CommandBar.prompt(
        'No arguments (with template name) were given to the templateRunner."',
        helpInfo('Presets')
      )
    }
  } catch (error) {
    logError(pluginJson$1, error)
  }
}
export async function templateAbout() {
  try {
    const version = pluginJson$1['plugin.version']
    let aboutInfo = 'Templating Plugin for NotePlan\nv'.concat(
      version,
      '\n\n\nCopyright © 2022 Mike Erickson.\nAll Rights Reserved.'
    )
    await CommandBar.prompt('About np.Templating', aboutInfo)
    log(pluginJson$1, ''.concat(version))
    return version
  } catch (error) {
    return logError(pluginJson$1, error)
  }
}
export async function templateSamples() {
  const numSamples = 10
  const result = await CommandBar.prompt(
    'This will create '.concat(
      numSamples,
      ' template samples in your Templates folder'
    ),
    'Are you sure you wish to continue?',
    ['Continue', 'Cancel']
  )
  if (result === 0) {
    console.log('Create Samples')
  }
}
export async function templateTest() {
  try {
    let plugins = DataStore.installedPlugins()
    plugins.forEach((plugin) => {
      clo(plugin)
    })
  } catch (error) {
    logError(pluginJson$1, error)
  }
}
export async function templateWOTD() {
  try {
    const url = 'https://wordsapiv1.p.rapidapi.com/words/?random=true'
    const options = {
      method: 'GET',
      headers: {
        'X-RapidAPI-Key': 'Xwiq2Q2FCrmshVLkpU1ApDOasM3rp1OIm7vjsnlVvRfpkFBmeX',
        'X-RapidAPI-Host': 'wordsapiv1.p.rapidapi.com',
      },
    }
    const result = await fetch(url, options)
    let data = JSON.parse(result)
    Editor.insertTextAtCursor(data.word)
  } catch (error) {
    logError(pluginJson$1, error)
  }
}
export async function templateConvertNote() {
  if (typeof Editor.type === 'undefined') {
    await CommandBar.prompt(
      'Conversion Error',
      'Please select the Project Note you would like to convert and try again.'
    )
    return
  }
  if (Editor.type !== 'Notes') {
    await CommandBar.prompt(
      'Conversion Error',
      'You can only convert Project Notes'
    )
    return
  }
  const note = Editor.content || ''
  const result = new FrontmatterModule().convertProjectNoteToFrontmatter(note)
  switch (result) {
    case -1:
      await CommandBar.prompt(
        'Conversion Falied',
        'Unable to convert Project Note.'
      )
      break

    case -2:
      await CommandBar.prompt(
        'Conversion Falied',
        'Project Note must have Title (starts with # character)'
      )
      break

    case -3:
      await CommandBar.prompt(
        'Conversion Falied',
        'Project Note already in Frontmatter Format'
      )
      break
  }
  if (typeof result === 'string') {
    Editor.selectAll()
    Editor.insertTextAtCursor(result.toString())
    Editor.highlightByIndex(0, 0)
  }
}
export async function templateExecute(templateName) {
  try {
    var _selectedTemplateFile2
    let selectedTemplateFilename
    if (templateName) {
      const notes = await DataStore.projectNoteByTitle(templateName, true)
      if (notes !== null && notes !== void 0 && notes.length) {
        selectedTemplateFilename = notes[0].filename
      } else {
        logError(
          pluginJson$1,
          'Unable to locate template: '.concat(
            templateName,
            ' which was passed to templateExecute'
          )
        )
      }
    }
    selectedTemplateFilename =
      (_selectedTemplateFile2 = selectedTemplateFilename) !== null &&
      _selectedTemplateFile2 !== void 0
        ? _selectedTemplateFile2
        : await NPTemplating.chooseTemplate(
            'template-fragment',
            'Choose Template Fragment',
            {
              templateGroupTemplatesByFolder: false,
            }
          )
    await NPTemplating.renderTemplate(selectedTemplateFilename)
  } catch (error) {
    logError(pluginJson$1, error.message)
  }
}
export async function getTemplate() {
  let templateName =
    arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
  let options =
    arguments.length > 1 && arguments[1] !== undefined
      ? arguments[1]
      : {
          showChoices: true,
        }
  return await NPTemplating.getTemplate(templateName, options)
}
export async function preRender() {
  let templateData =
    arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
  let userData =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}
  const {
    frontmatterBody: frontmatterBody,
    frontmatterAttributes: frontmatterAttributes,
  } = await NPTemplating.preRender(templateData, userData)
  return {
    frontmatterBody: frontmatterBody,
    frontmatterAttributes: frontmatterAttributes,
  }
}
export async function render() {
  let inTemplateData =
    arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
  let userData =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}
  let userOptions =
    arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}
  return await NPTemplating.render(inTemplateData, userData, userOptions)
}
export async function renderTemplate() {
  let templateName =
    arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
  let userData =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}
  let userOptions =
    arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}
  return await NPTemplating.renderTemplate(templateName, userData, userOptions)
}
export async function templateFileByTitle() {
  let selectedTemplate =
    arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
  let openInEditor =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false
  let args =
    arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ''
  await templateFileByTitleEx(selectedTemplate, openInEditor, args)
}
